// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cds--layout--size-xs {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xs, 1.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xs {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xs, 1.5rem));
}

.cds--layout-constraint--size__min-xs {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout-constraint--size__max-xs {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xs, 1.5rem);
}

.cds--layout--size-sm {
  --cds-layout-size-height-context: var(--cds-layout-size-height-sm, 2rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-sm {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-sm, 2rem));
}

.cds--layout-constraint--size__min-sm {
  --cds-layout-size-height-min: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout-constraint--size__max-sm {
  --cds-layout-size-height-max: var(--cds-layout-size-height-sm, 2rem);
}

.cds--layout--size-md {
  --cds-layout-size-height-context: var(--cds-layout-size-height-md, 2.5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-md {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-md, 2.5rem));
}

.cds--layout-constraint--size__min-md {
  --cds-layout-size-height-min: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout-constraint--size__max-md {
  --cds-layout-size-height-max: var(--cds-layout-size-height-md, 2.5rem);
}

.cds--layout--size-lg {
  --cds-layout-size-height-context: var(--cds-layout-size-height-lg, 3rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-lg {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-lg, 3rem));
}

.cds--layout-constraint--size__min-lg {
  --cds-layout-size-height-min: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout-constraint--size__max-lg {
  --cds-layout-size-height-max: var(--cds-layout-size-height-lg, 3rem);
}

.cds--layout--size-xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-xl, 4rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-xl, 4rem));
}

.cds--layout-constraint--size__min-xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout-constraint--size__max-xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-xl, 4rem);
}

.cds--layout--size-2xl {
  --cds-layout-size-height-context: var(--cds-layout-size-height-2xl, 5rem);
  --cds-layout-size-height: var(--cds-layout-size-height-context);
}

.cds--layout-constraint--size__default-2xl {
  --cds-layout-size-height: var(--cds-layout-size-height-context, var(--cds-layout-size-height-2xl, 5rem));
}

.cds--layout-constraint--size__min-2xl {
  --cds-layout-size-height-min: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout-constraint--size__max-2xl {
  --cds-layout-size-height-max: var(--cds-layout-size-height-2xl, 5rem);
}

.cds--layout--density-condensed {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-condensed {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-condensed, 0.5rem));
}

.cds--layout-constraint--density__min-condensed {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout-constraint--density__max-condensed {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-condensed, 0.5rem);
}

.cds--layout--density-normal {
  --cds-layout-density-padding-inline-context: var(--cds-layout-density-padding-inline-normal, 1rem);
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context);
}

.cds--layout-constraint--density__default-normal {
  --cds-layout-density-padding-inline: var(--cds-layout-density-padding-inline-context, var(--cds-layout-density-padding-inline-normal, 1rem));
}

.cds--layout-constraint--density__min-normal {
  --cds-layout-density-padding-inline-min: var(--cds-layout-density-padding-inline-normal, 1rem);
}

.cds--layout-constraint--density__max-normal {
  --cds-layout-density-padding-inline-max: var(--cds-layout-density-padding-inline-normal, 1rem);
}

:root {
  --cds-layout-size-height-xs: 1.5rem;
  --cds-layout-size-height-sm: 2rem;
  --cds-layout-size-height-md: 2.5rem;
  --cds-layout-size-height-lg: 3rem;
  --cds-layout-size-height-xl: 4rem;
  --cds-layout-size-height-2xl: 5rem;
  --cds-layout-size-height-min: 0px;
  --cds-layout-size-height-max: 999999999px;
  --cds-layout-density-padding-inline-condensed: 0.5rem;
  --cds-layout-density-padding-inline-normal: 1rem;
  --cds-layout-density-padding-inline-min: 0px;
  --cds-layout-density-padding-inline-max: 999999999px;
}

:root {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-one {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
}

.cds--layer-two {
  --cds-layer: var(--cds-layer-02, #ffffff);
  --cds-layer-active: var(--cds-layer-active-02, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-02, #f4f4f4);
  --cds-layer-hover: var(--cds-layer-hover-02, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-02, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-02, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-02, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-02, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-02, #a8a8a8);
  --cds-field: var(--cds-field-02, #ffffff);
  --cds-field-hover: var(--cds-field-hover-02, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-01, #c6c6c6);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-02, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-02, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-02, #a8a8a8);
}

.cds--layer-three {
  --cds-layer: var(--cds-layer-03, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-03, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-03, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-03, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-03, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-03, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-03, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-03, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-03, #a8a8a8);
  --cds-field: var(--cds-field-03, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-03, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-02, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-03, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-03, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-03, #c6c6c6);
}

.cds--layer-one.cds--layer__with-background {
  background-color: #ffffff;
  background-color: var(--cds-layer-background);
}

.cds--layer-two.cds--layer__with-background {
  background-color: #ffffff;
  background-color: var(--cds-layer-background);
}

.cds--layer-three.cds--layer__with-background {
  background-color: #ffffff;
  background-color: var(--cds-layer-background);
}

@keyframes cds--hide-feedback {
  0% {
    opacity: 1;
    visibility: inherit;
  }
  100% {
    opacity: 0;
    visibility: hidden;
  }
}
@keyframes cds--show-feedback {
  0% {
    opacity: 0;
    visibility: hidden;
  }
  100% {
    opacity: 1;
    visibility: inherit;
  }
}
@keyframes cds--skeleton {
  0% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
  20% {
    opacity: 1;
    transform: scaleX(1);
    transform-origin: left;
  }
  28% {
    transform: scaleX(1);
    transform-origin: right;
  }
  51% {
    transform: scaleX(0);
    transform-origin: right;
  }
  58% {
    transform: scaleX(0);
    transform-origin: right;
  }
  82% {
    transform: scaleX(1);
    transform-origin: right;
  }
  83% {
    transform: scaleX(1);
    transform-origin: left;
  }
  96% {
    transform: scaleX(0);
    transform-origin: left;
  }
  100% {
    opacity: 0.3;
    transform: scaleX(0);
    transform-origin: left;
  }
}
.cds--assistive-text,
.cds--visually-hidden {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--popover-container {
  display: inline-block;
}

.cds--popover-container:not(.cds--popover--auto-align) {
  position: relative;
}

.cds--popover--high-contrast .cds--popover {
  --cds-popover-background-color: var(--cds-background-inverse, #393939);
  --cds-popover-text-color: var(--cds-text-inverse, #ffffff);
}

.cds--popover--drop-shadow .cds--popover {
  filter: drop-shadow(0 0.125rem 0.125rem rgba(0, 0, 0, 0.2));
  filter: var(--cds-popover-drop-shadow, drop-shadow(0 0.125rem 0.125rem rgba(0, 0, 0, 0.2)));
}

.cds--popover--border > .cds--popover > .cds--popover-content {
  outline: 1px solid #e0e0e0;
  outline: 1px solid var(--cds-popover-border-color, var(--cds-border-subtle));
  outline-offset: -1px;
}

.cds--popover--caret {
  --cds-popover-offset: 0.625rem;
}

.cds--popover {
  position: absolute;
  z-index: 6000;
  inset: 0;
  pointer-events: none;
}

.cds--popover-content {
  --cds-layout-size-height-sm: 2rem;
}
.cds--popover-content.cds--layout--size-sm, .cds--layout--size-sm :where(.cds--popover-content) {
  --cds-layout-size-height: var(--cds-layout-size-height-sm);
}
.cds--popover-content {
  --cds-layout-size-height-md: 2.5rem;
}
.cds--popover-content.cds--layout--size-md, .cds--layout--size-md :where(.cds--popover-content) {
  --cds-layout-size-height: var(--cds-layout-size-height-md);
}
.cds--popover-content {
  --cds-layout-size-height-lg: 3rem;
}
.cds--popover-content.cds--layout--size-lg, .cds--layout--size-lg :where(.cds--popover-content) {
  --cds-layout-size-height: var(--cds-layout-size-height-lg);
}
.cds--popover-content {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover-content *,
.cds--popover-content *::before,
.cds--popover-content *::after {
  box-sizing: inherit;
}
.cds--popover-content {
  position: absolute;
  z-index: 6000;
  display: none;
  border-radius: 2px;
  border-radius: var(--cds-popover-border-radius, 2px);
  background-color: #f4f4f4;
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  color: #161616;
  color: var(--cds-popover-text-color, var(--cds-text-primary, #161616));
  inline-size: -webkit-max-content;
  inline-size: max-content;
  max-inline-size: 23rem;
  pointer-events: auto;
}

.cds--popover--open > .cds--popover > .cds--popover-content {
  display: block;
}

.cds--popover--background-token__background > .cds--popover > .cds--popover-content {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}

.cds--popover-content::before {
  position: absolute;
  display: none;
  content: "";
}

.cds--popover--open > .cds--popover > .cds--popover-content::before {
  display: block;
}

.cds--popover-caret,
.cds--popover--auto-align.cds--popover-caret {
  position: absolute;
  z-index: 6000;
  display: none;
  will-change: transform;
}
.cds--popover-caret::after,
.cds--popover--auto-align.cds--popover-caret::after {
  position: absolute;
  display: block;
  background-color: #f4f4f4;
  background-color: var(--cds-popover-background-color, var(--cds-layer));
  content: "";
}
.cds--popover-caret::before,
.cds--popover--auto-align.cds--popover-caret::before {
  position: absolute;
  display: none;
  background-color: #e0e0e0;
  background-color: var(--cds-popover-border-color, var(--cds-border-subtle));
  content: "";
}

.cds--popover--background-token__background > .cds--popover > .cds--popover-caret::after {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}

.cds--popover--border .cds--popover-caret::before,
.cds--popover--border .cds--popover--auto-align.cds--popover-caret::before {
  display: block;
}

.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-caret {
  display: block;
}

.cds--popover--auto-align.cds--popover--caret.cds--popover--open > .cds--popover > .cds--popover-content > .cds--popover-caret {
  display: block;
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-caret {
  display: none;
}

.cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(100% + 0rem));
  transform: translate(-50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

.cds--popover--bottom:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-block-end: -0.25rem;
}

.cds--popover--top:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--top-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--top-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-block-start: -0.25rem;
}

.cds--popover--top-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-inline-start: calc(50% - 0rem - 1rem);
  inset-inline-start: calc(50% - var(--cds-popover-offset, 0rem) - 1rem);
}

.cds--popover--top-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-inline-end: calc(50% - 0rem - 1rem);
  inset-inline-end: calc(50% - var(--cds-popover-offset, 0rem) - 1rem);
}

.cds--popover--right:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--right-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--right-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-inline-start: calc(100% + 0.25rem);
}

.cds--popover--left:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--left-start:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content,
.cds--popover--left-end:not(.cds--popover--caret):not(.cds--popover--auto-align):not(.cds--popover--tab-tip) > .cds--popover > .cds--popover-content {
  inset-inline-end: calc(100% + 0.25rem);
}

[dir=rtl] .cds--popover--bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(100% + 0rem));
  transform: translate(50%, calc(100% + var(--cds-popover-offset, 0rem)));
}

.cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-start: calc(50% - 0rem);
  inset-inline-start: calc(50% - var(--cds-popover-offset, 0rem));
  transform: translate(calc(-1 * 0rem), calc(100% + 0rem));
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: calc(50% - 0rem);
  inset-inline-end: calc(50% - var(--cds-popover-offset, 0rem));
  inset-inline-start: initial;
}

.cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 0;
  inset-inline-end: calc(50% - 0rem);
  inset-inline-end: calc(50% - var(--cds-popover-offset, 0rem));
  transform: translate(0rem, calc(100% + 0rem));
  transform: translate(var(--cds-popover-offset, 0rem), calc(100% + var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--bottom-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: calc(50% - 0rem);
  inset-inline-start: calc(50% - var(--cds-popover-offset, 0rem));
}

.cds--popover--bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-left > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-start > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-right > .cds--popover > .cds--popover-content::before,
.cds--popover--bottom-end > .cds--popover > .cds--popover-content::before {
  block-size: 0rem;
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-start: 0;
  inset-inline: 0;
  transform: translateY(-100%);
}

.cds--popover--bottom > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
.cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-end: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, 0rem);
  transform: translate(-50%, var(--cds-popover-offset, 0rem));
}
.cds--popover--bottom > .cds--popover > .cds--popover-caret::after,
.cds--popover--bottom-left > .cds--popover > .cds--popover-caret::after,
.cds--popover--bottom-start > .cds--popover > .cds--popover-caret::after,
.cds--popover--bottom-right > .cds--popover > .cds--popover-caret::after,
.cds--popover--bottom-end > .cds--popover > .cds--popover-caret::after {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
          clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--border.cds--popover--bottom > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-left > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-start > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-right > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-end > .cds--popover > .cds--popover-caret::before {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
          clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--border.cds--popover--bottom > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-left > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-start > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-right > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-end > .cds--popover > .cds--popover-caret::after {
  inline-size: calc(0.75rem - 1px);
  inline-size: calc(var(--cds-popover-caret-width, 0.75rem) - 1px);
  inset-block-start: 1px;
  inset-inline-start: 0.5px;
}

[dir=rtl] .cds--popover--bottom > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-left > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-start > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-right > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--bottom-end > .cds--popover > .cds--popover-caret {
  transform: translate(50%, 0rem);
  transform: translate(50%, var(--cds-popover-offset, 0rem));
}

.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
          clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--border.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
          clip-path: polygon(0% 100%, 50% 0%, 100% 100%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--border.cds--popover--bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--bottom-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inline-size: calc(0.75rem - 1px);
  inline-size: calc(var(--cds-popover-caret-width, 0.75rem) - 1px);
  inset-block-start: 1px;
  inset-inline-start: 0.5px;
}

.cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-100% - 0rem));
  transform: translate(-50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(-100% - 0rem));
  transform: translate(50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}

.cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-start: calc(50% - 0rem);
  inset-inline-start: calc(50% - var(--cds-popover-offset, 0rem));
  transform: translate(calc(-1 * 0rem), calc(-100% - 0rem));
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: calc(50% - 0rem);
  inset-inline-end: calc(50% - var(--cds-popover-offset, 0rem));
  inset-inline-start: initial;
}

.cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 0;
  inset-inline-end: calc(50% - 0rem);
  inset-inline-end: calc(50% - var(--cds-popover-offset, 0rem));
  transform: translate(0rem, calc(-100% - 0rem));
  transform: translate(var(--cds-popover-offset, 0rem), calc(-100% - var(--cds-popover-offset, 0rem)));
}

[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: calc(50% - 0rem);
  inset-inline-start: calc(50% - var(--cds-popover-offset, 0rem));
}

.cds--popover--top > .cds--popover > .cds--popover-content::before,
.cds--popover--top-left > .cds--popover > .cds--popover-content::before,
.cds--popover--top-start > .cds--popover > .cds--popover-content::before,
.cds--popover--top-right > .cds--popover > .cds--popover-content::before,
.cds--popover--top-end > .cds--popover > .cds--popover-content::before {
  block-size: 0rem;
  block-size: var(--cds-popover-offset, 0rem);
  inset-block-end: 0;
  inset-inline: 0;
  transform: translateY(100%);
}

.cds--popover--top > .cds--popover > .cds--popover-caret,
.cds--popover--top-left > .cds--popover > .cds--popover-caret,
.cds--popover--top-start > .cds--popover > .cds--popover-caret,
.cds--popover--top-right > .cds--popover > .cds--popover-caret,
.cds--popover--top-end > .cds--popover > .cds--popover-caret {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
  inset-block-start: 0;
  inset-inline-start: 50%;
  transform: translate(-50%, calc(-1 * 0rem));
  transform: translate(-50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}
.cds--popover--top > .cds--popover > .cds--popover-caret::after,
.cds--popover--top-left > .cds--popover > .cds--popover-caret::after,
.cds--popover--top-start > .cds--popover > .cds--popover-caret::after,
.cds--popover--top-right > .cds--popover > .cds--popover-caret::after,
.cds--popover--top-end > .cds--popover > .cds--popover-caret::after {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
          clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--border.cds--popover--top > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-left > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-start > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-right > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-end > .cds--popover > .cds--popover-caret::before {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
          clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--border.cds--popover--top > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-left > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-start > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-right > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-end > .cds--popover > .cds--popover-caret::after {
  inline-size: calc(0.75rem - 1px);
  inline-size: calc(var(--cds-popover-caret-width, 0.75rem) - 1px);
  inset-block-start: -1px;
  inset-inline-start: 0.5px;
}

[dir=rtl] .cds--popover--top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  transform: translate(50%, calc(-1 * 0rem));
  transform: translate(50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
          clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}

.cds--popover--border.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  block-size: 0.375rem;
  block-size: var(--cds-popover-caret-height, 0.375rem);
  -webkit-clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
          clip-path: polygon(0% 0%, 50% 100%, 100% 0%);
  inline-size: 0.75rem;
  inline-size: var(--cds-popover-caret-width, 0.75rem);
}
.cds--popover--border.cds--popover--top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--top-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inline-size: calc(0.75rem - 1px);
  inline-size: calc(var(--cds-popover-caret-width, 0.75rem) - 1px);
  inset-block-start: -1px;
  inset-inline-start: 0.5px;
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(0rem, -50%);
  transform: translate(var(--cds-popover-offset, 0rem), -50%);
}

.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(0rem, calc(0.5 * 0rem * -1 - 16px));
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) * -1 - 16px));
}

.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-start: 100%;
  transform: translate(0rem, calc(0.5 * 0rem + 16px));
  transform: translate(var(--cds-popover-offset, 0rem), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--right > .cds--popover > .cds--popover-content::before,
.cds--popover--right-top > .cds--popover > .cds--popover-content::before,
.cds--popover--right-start > .cds--popover > .cds--popover-content::before,
.cds--popover--right-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--right-end > .cds--popover > .cds--popover-content::before {
  inline-size: 0rem;
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block: 0;
  inset-inline-start: 0;
  transform: translateX(-100%);
}

.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-start: 100%;
  transform: translate(calc(0rem - 100%), -50%);
  transform: translate(calc(var(--cds-popover-offset, 0rem) - 100%), -50%);
}
.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
          clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

[dir=rtl] .cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: 100%;
  inset-inline-start: initial;
}

.cds--popover--border.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
          clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--border.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  inset-inline-start: 1px;
}

[dir=rtl] .cds--popover--border.cds--popover--right:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  inset-inline-start: -1px;
}

.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
          clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--border.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
          clip-path: polygon(0% 50%, 100% 0%, 100% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--border.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inset-inline-start: 1px;
}

[dir=rtl] .cds--popover--border.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  -webkit-margin-start: 1px;
          margin-inline-start: 1px;
}
[dir=rtl] .cds--popover--border.cds--popover--right.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--right-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inset-inline-start: 0;
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * 0rem + 0.1px), -50%);
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 0.1px), -50%);
}

.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * 0rem), calc(-0.5 * 0rem - 16px));
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(-0.5 * var(--cds-popover-offset, 0rem) - 16px));
}

.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-block-end: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * 0rem), calc(0.5 * 0rem + 16px));
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem)), calc(0.5 * var(--cds-popover-offset, 0rem) + 16px));
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--left > .cds--popover > .cds--popover-content::before,
.cds--popover--left-top > .cds--popover > .cds--popover-content::before,
.cds--popover--left-start > .cds--popover > .cds--popover-content::before,
.cds--popover--left-bottom > .cds--popover > .cds--popover-content::before,
.cds--popover--left-end > .cds--popover > .cds--popover-content::before {
  inline-size: 0rem;
  inline-size: var(--cds-popover-offset, 0rem);
  inset-block: 0;
  inset-inline-end: 0;
  transform: translateX(100%);
}

.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
  inset-block-start: 50%;
  inset-inline-end: 100%;
  transform: translate(calc(-1 * 0rem + 100%), -50%);
  transform: translate(calc(-1 * var(--cds-popover-offset, 0rem) + 100%), -50%);
}
.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

[dir=rtl] .cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret,
[dir=rtl] .cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret {
  inset-inline-end: initial;
  inset-inline-start: 100%;
}

.cds--popover--border.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::before {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--border.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  inset-inline-start: -1px;
}

[dir=rtl] .cds--popover--border.cds--popover--left:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-top:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-bottom:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-caret::after {
  inset-inline-start: 1px;
}

.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret,
.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}

.cds--popover--border.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
.cds--popover--border.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  block-size: 0.75rem;
  block-size: var(--cds-popover-caret-width, 0.75rem);
  -webkit-clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
          clip-path: polygon(0% 0%, 100% 50%, 0% 100%);
  inline-size: 0.375rem;
  inline-size: var(--cds-popover-caret-height, 0.375rem);
}
.cds--popover--border.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
.cds--popover--border.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inset-inline-start: -1px;
}

[dir=rtl] .cds--popover--border.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before,
[dir=rtl] .cds--popover--border.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::before {
  -webkit-margin-start: -1px;
          margin-inline-start: -1px;
}
[dir=rtl] .cds--popover--border.cds--popover--left.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-top.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-start.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-bottom.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after,
[dir=rtl] .cds--popover--border.cds--popover--left-end.cds--popover--auto-align > .cds--popover > .cds--popover-content > .cds--popover-caret::after {
  inset-inline-start: 0;
}

.cds--popover--tab-tip > .cds--popover > .cds--popover-content {
  border-radius: 0;
}

.cds--popover--tab-tip.cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--tab-tip.cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--tab-tip.cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--tab-tip.cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-start: 0;
}

.cds--popover--tab-tip.cds--popover--top-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
.cds--popover--tab-tip.cds--popover--bottom-end:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--tab-tip.cds--popover--top-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content,
[dir=rtl] .cds--popover--tab-tip.cds--popover--bottom-start:not(.cds--popover--auto-align) > .cds--popover > .cds--popover-content {
  inset-inline-end: 0;
  inset-inline-start: initial;
}

.cds--popover--tab-tip .cds--popover {
  will-change: filter;
}

.cds--popover--tab-tip__button {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--popover--tab-tip__button *,
.cds--popover--tab-tip__button *::before,
.cds--popover--tab-tip__button *::after {
  box-sizing: inherit;
}
.cds--popover--tab-tip__button::-moz-focus-inner {
  border: 0;
}
.cds--popover--tab-tip__button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--popover--tab-tip__button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--popover--tab-tip__button:focus {
    outline-style: dotted;
  }
}
.cds--popover--tab-tip__button:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--popover--tab-tip__button svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button {
  background: #f4f4f4;
  background: var(--cds-layer);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
}

.cds--popover--tab-tip.cds--popover--open .cds--popover--tab-tip__button:not(:focus)::after {
  position: absolute;
  z-index: 6001;
  background: #f4f4f4;
  background: var(--cds-layer);
  block-size: 2px;
  content: "";
  inline-size: 100%;
  inset-block-end: 0;
}

.cds--popover--tab-tip__button svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--tooltip {
  --cds-popover-offset: 12px;
}

.cds--tooltip-content {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: 1rem 1rem;
  padding: var(--cds-tooltip-padding-block, 1rem) var(--cds-tooltip-padding-inline, 1rem);
  max-inline-size: 18rem;
  overflow-wrap: break-word;
}

.cds--icon-tooltip {
  --cds-tooltip-padding-block: 0.125rem;
  --cds-popover-caret-width: 0.5rem;
  --cds-popover-caret-height: 0.25rem;
  --cds-popover-offset: 0.5rem;
}

.cds--icon-tooltip .cds--tooltip-content {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--definition-term {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--definition-term *,
.cds--definition-term *::before,
.cds--definition-term *::after {
  box-sizing: inherit;
}
.cds--definition-term::-moz-focus-inner {
  border: 0;
}
.cds--definition-term {
  border-radius: 0;
  -webkit-border-after: 1px dotted #8d8d8d;
          border-block-end: 1px dotted #8d8d8d;
  -webkit-border-after: 1px dotted var(--cds-border-strong);
          border-block-end: 1px dotted var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--definition-term:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--definition-term:focus {
    outline-style: dotted;
  }
}
.cds--definition-term:focus {
  border-block-end-color: var(--color-primary);
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-term:hover {
  border-block-end-color: var(--color-primary);
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
}

.cds--definition-tooltip {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: 0.5rem 1rem;
  max-inline-size: 11rem;
  text-wrap: auto;
  word-break: break-word;
}

.cds--btn {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-xs)), var(--cds-layout-size-height, var(--cds-layout-size-height-lg)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-2xl)));
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  --temp-1lh: (
    var(--cds-body-compact-01-line-height, 1.28572) * 1em
  );
  --temp-expressive-1lh: (
    var(--cds-body-compact-02-line-height, 1.375) * 1em
  );
  --temp-padding-block-max: calc(
    (var(--cds-layout-size-height-lg) - var(--temp-1lh)) / 2 -
      0.0625rem
  );
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--btn *,
.cds--btn *::before,
.cds--btn *::after {
  box-sizing: inherit;
}
.cds--btn {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: space-between;
  border-radius: 0;
  margin: 0;
  cursor: pointer;
  inline-size: -webkit-max-content;
  inline-size: max-content;
  max-inline-size: 20rem;
  min-block-size: var(--cds-layout-size-height-local);
  outline: none;
  padding-block: min((var(--cds-layout-size-height-local) - var(--temp-1lh)) / 2 - 0.0625rem, var(--temp-padding-block-max));
  padding-inline: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem) calc(var(--cds-layout-density-padding-inline-local) * 3 + 1rem - 0.0625rem);
  text-align: start;
  text-decoration: none;
  transition: background 70ms cubic-bezier(0, 0, 0.38, 0.9), box-shadow 70ms cubic-bezier(0, 0, 0.38, 0.9), border-color 70ms cubic-bezier(0, 0, 0.38, 0.9), outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
  vertical-align: top;
}
.cds--btn:disabled, .cds--btn:hover:disabled, .cds--btn:focus:disabled, .cds--btn.cds--btn--disabled, .cds--btn.cds--btn--disabled:hover, .cds--btn.cds--btn--disabled:focus {
  border-color: #c6c6c6;
  border-color: var(--cds-button-disabled, #c6c6c6);
  background: #c6c6c6;
  background: var(--cds-button-disabled, #c6c6c6);
  box-shadow: none;
  color: #8d8d8d;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
  cursor: not-allowed;
}
.cds--btn .cds--btn__icon {
  position: absolute;
  flex-shrink: 0;
  block-size: 1rem;
  inline-size: 1rem;
  inset-block-start: min((var(--cds-layout-size-height-local) - 1rem) / 2 - 0.0625rem, var(--temp-padding-block-max));
  inset-inline-end: var(--cds-layout-density-padding-inline-local);
  -webkit-margin-before: 0.0625rem;
          margin-block-start: 0.0625rem;
}

.cds--btn::-moz-focus-inner {
  padding: 0;
  border: 0;
}

.cds--btn--primary {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: var(--color-primary);
  background-color: var(--cds-button-primary, #0f62fe);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--primary:hover {
  background-color: color-mix(in oklab, var(--color-primary) 85%, black);
  background-color: var(--cds-button-primary-hover, #0050e6);
}
.cds--btn--primary:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--primary:active {
  background-color: color-mix(in oklab, var(--color-primary) 70%, black);
  background-color: var(--cds-button-primary-active, #002d9c);
}
.cds--btn--primary .cds--btn__icon,
.cds--btn--primary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--primary:hover {
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}

.cds--btn--secondary {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: #393939;
  background-color: var(--cds-button-secondary, #393939);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--secondary:hover {
  background-color: #474747;
  background-color: var(--cds-button-secondary-hover, #474747);
}
.cds--btn--secondary:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--secondary:active {
  background-color: #6f6f6f;
  background-color: var(--cds-button-secondary-active, #6f6f6f);
}
.cds--btn--secondary .cds--btn__icon,
.cds--btn--secondary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--secondary:hover, .cds--btn--secondary:focus {
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}

.cds--btn--tertiary {
  border-width: 1px;
  border-style: solid;
  border-color: var(--color-primary);
  border-color: var(--cds-button-tertiary, #0f62fe);
  background-color: transparent;
  color: var(--color-primary);
  color: var(--cds-button-tertiary, #0f62fe);
}
.cds--btn--tertiary:hover {
  background-color: var(--color-primary);
  background-color: var(--cds-button-tertiary-hover, #0050e6);
}
.cds--btn--tertiary:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--tertiary:active {
  background-color: color-mix(in oklab, var(--color-primary) 70%, black);
  background-color: var(--cds-button-tertiary-active, #002d9c);
}
.cds--btn--tertiary .cds--btn__icon,
.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--tertiary:hover {
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:focus {
  background-color: var(--color-primary);
  background-color: var(--cds-button-tertiary, #0f62fe);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:active {
  border-color: transparent;
  background-color: color-mix(in oklab, var(--color-primary) 70%, black);
  background-color: var(--cds-button-tertiary-active, #002d9c);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--btn--tertiary:disabled, .cds--btn--tertiary:hover:disabled, .cds--btn--tertiary:focus:disabled, .cds--btn--tertiary.cds--btn--disabled, .cds--btn--tertiary.cds--btn--disabled:hover, .cds--btn--tertiary.cds--btn--disabled:focus {
  background: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}

.cds--btn--ghost {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
  color: var(--color-primary);
  color: var(--cds-link-primary, #0f62fe);
}
.cds--btn--ghost:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}
.cds--btn--ghost:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--ghost:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}
.cds--btn--ghost .cds--btn__icon,
.cds--btn--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--ghost {
  -webkit-padding-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
          padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
}
.cds--btn--ghost .cds--btn__icon {
  position: static;
  align-self: center;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}
.cds--btn--ghost:hover, .cds--btn--ghost:active {
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-primary-hover, #0043ce);
}
.cds--btn--ghost:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}
.cds--btn--ghost:disabled, .cds--btn--ghost:hover:disabled, .cds--btn--ghost:focus:disabled, .cds--btn--ghost.cds--btn--disabled, .cds--btn--ghost.cds--btn--disabled:hover, .cds--btn--ghost.cds--btn--disabled:focus {
  border-color: transparent;
  background: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}
.cds--btn--ghost:not([disabled]) svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--btn--icon-only {
  align-items: center;
  justify-content: center;
  padding: 0;
  block-size: var(--cds-layout-size-height-local);
  inline-size: var(--cds-layout-size-height-local);
  -webkit-padding-before: 0;
          padding-block-start: 0;
}
.cds--btn--icon-only > :first-child {
  min-inline-size: 1rem;
}
.cds--btn--icon-only .cds--btn__icon {
  position: static;
}
.cds--btn--icon-only.cds--btn--ghost:focus {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
  box-shadow: inset 0 0 0 1px var(--color-primary);
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
}
.cds--btn--icon-only.cds--btn--ghost .cds--btn__icon, .cds--btn--icon-only.cds--btn--danger--ghost .cds--btn__icon {
  margin: 0;
}
.cds--btn--icon-only.cds--btn--danger--ghost {
  -webkit-padding-end: calc(var(--cds-layout-density-padding-inline-local) - 1rem);
          padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) - 1rem);
}

.cds--btn--xs:not(.cds--btn--icon-only) {
  -webkit-padding-before: 1.5px;
          padding-block-start: 1.5px;
}

.cds--btn--xs:not(.cds--btn--icon-only) .cds--btn__icon,
.cds--btn--sm:not(.cds--btn--icon-only) .cds--btn__icon,
.cds--btn--md:not(.cds--btn--icon-only) .cds--btn__icon {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--btn--icon-only.cds--btn--selected {
  background: rgba(141, 141, 141, 0.2);
  background: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}

.cds--btn path[data-icon-path=inner-path] {
  fill: none;
}

.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon path:not([data-icon-path]):not([fill=none]),
.cds--btn--ghost.cds--btn--icon-only .cds--btn__icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon path:not([data-icon-path]):not([fill=none]),
.cds--btn--ghost.cds--btn--icon-only[disabled] .cds--btn__icon,
.cds--btn.cds--btn--icon-only.cds--btn--ghost[disabled]:hover .cds--btn__icon {
  fill: #8d8d8d;
  fill: var(--cds-icon-on-color-disabled, #8d8d8d);
}

.cds--btn--ghost.cds--btn--icon-only[disabled] {
  cursor: not-allowed;
}

.cds--icon-tooltip--disabled .cds--tooltip-trigger__wrapper {
  cursor: not-allowed;
}

.cds--icon-tooltip--disabled .cds--btn--icon-only[disabled] {
  pointer-events: none;
}

.cds--btn--danger {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: #da1e28;
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger:hover {
  background-color: #b81921;
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger:active {
  background-color: #750e13;
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger .cds--btn__icon,
.cds--btn--danger .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger:hover {
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary {
  border-width: 1px;
  border-style: solid;
  border-color: #da1e28;
  border-color: var(--cds-button-danger-secondary, #da1e28);
  background-color: transparent;
  color: #da1e28;
  color: var(--cds-button-danger-secondary, #da1e28);
}
.cds--btn--danger--tertiary:hover {
  background-color: #b81921;
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger--tertiary:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger--tertiary:active {
  background-color: #750e13;
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger--tertiary .cds--btn__icon,
.cds--btn--danger--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger--tertiary:hover {
  border-color: #b81921;
  border-color: var(--cds-button-danger-hover, #b81921);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:focus {
  background-color: #da1e28;
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:active {
  border-color: #750e13;
  border-color: var(--cds-button-danger-active, #750e13);
  background-color: #750e13;
  background-color: var(--cds-button-danger-active, #750e13);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--tertiary:disabled, .cds--btn--danger--tertiary:hover:disabled, .cds--btn--danger--tertiary:focus:disabled, .cds--btn--danger--tertiary.cds--btn--disabled, .cds--btn--danger--tertiary.cds--btn--disabled:hover, .cds--btn--danger--tertiary.cds--btn--disabled:focus {
  background: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}
.cds--btn--danger--ghost {
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
  background-color: transparent;
  color: #da1e28;
  color: var(--cds-button-danger-secondary, #da1e28);
}
.cds--btn--danger--ghost:hover {
  background-color: #b81921;
  background-color: var(--cds-button-danger-hover, #b81921);
}
.cds--btn--danger--ghost:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--btn--danger--ghost:active {
  background-color: #750e13;
  background-color: var(--cds-button-danger-active, #750e13);
}
.cds--btn--danger--ghost .cds--btn__icon,
.cds--btn--danger--ghost .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}
.cds--btn--danger--ghost {
  -webkit-padding-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
          padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) - 0.0625rem);
}
.cds--btn--danger--ghost .cds--btn__icon {
  position: static;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}
.cds--btn--danger--ghost:hover, .cds--btn--danger--ghost:active {
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--btn--danger--ghost:disabled, .cds--btn--danger--ghost:hover:disabled, .cds--btn--danger--ghost:focus:disabled, .cds--btn--danger--ghost.cds--btn--disabled, .cds--btn--danger--ghost.cds--btn--disabled:hover, .cds--btn--danger--ghost.cds--btn--disabled:focus {
  border-color: transparent;
  background: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}

.cds--btn--expressive {
  font-size: 1rem;
  font-size: var(--cds-body-compact-02-font-size, 1rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-02-font-weight, 400);
  line-height: 1.375;
  line-height: var(--cds-body-compact-02-line-height, 1.375);
  letter-spacing: 0;
  letter-spacing: var(--cds-body-compact-02-letter-spacing, 0);
  padding-block: min((var(--cds-layout-size-height-local) - var(--temp-expressive-1lh)) / 2 - 0.0625rem, var(--temp-padding-block-max));
}

.cds--btn--icon-only.cds--btn--expressive {
  padding: 12px 13px;
}

.cds--btn.cds--btn--expressive .cds--btn__icon {
  block-size: 1.25rem;
  inline-size: 1.25rem;
}

.cds--btn-set .cds--btn.cds--btn--expressive {
  max-inline-size: 20rem;
}

.cds--btn.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--btn.cds--skeleton:hover, .cds--btn.cds--skeleton:focus, .cds--btn.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--btn.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--btn.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--btn.cds--skeleton {
    background: CanvasText;
  }
  .cds--btn.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--btn.cds--skeleton {
  inline-size: 9.375rem;
}

.cds--btn-set {
  display: flex;
}

.cds--btn-set--stacked {
  flex-direction: column;
}

.cds--btn-set .cds--btn {
  inline-size: 100%;
  max-inline-size: 12.25rem;
}
.cds--btn-set .cds--btn:not(:focus) {
  box-shadow: -0.0625rem 0 0 0 #e0e0e0;
  box-shadow: -0.0625rem 0 0 0 var(--cds-button-separator, #e0e0e0);
}
.cds--btn-set .cds--btn:first-of-type:not(:focus) {
  box-shadow: inherit;
}

.cds--btn-set .cds--btn:focus + .cds--btn {
  box-shadow: inherit;
}

.cds--btn-set--stacked .cds--btn:not(:focus) {
  box-shadow: 0 -0.0625rem 0 0 #e0e0e0;
  box-shadow: 0 -0.0625rem 0 0 var(--cds-button-separator, #e0e0e0);
}

.cds--btn-set--stacked .cds--btn:first-of-type:not(:focus) {
  box-shadow: inherit;
}

.cds--btn-set .cds--btn.cds--btn--disabled {
  box-shadow: -0.0625rem 0 0 0 #8d8d8d;
  box-shadow: -0.0625rem 0 0 0 var(--cds-icon-on-color-disabled, #8d8d8d);
}
.cds--btn-set .cds--btn.cds--btn--disabled:first-of-type {
  box-shadow: none;
}

.cds--btn-set--stacked .cds--btn.cds--btn--disabled {
  box-shadow: 0 -0.0625rem 0 0 #8d8d8d;
  box-shadow: 0 -0.0625rem 0 0 var(--cds-layer-selected-disabled, #8d8d8d);
}
.cds--btn-set--stacked .cds--btn.cds--btn--disabled:first-of-type {
  box-shadow: none;
}

.cds--btn-set .cds--btn.cds--btn--loading {
  border-color: transparent;
  background-color: transparent;
  box-shadow: none;
}

.cds--btn--sm .cds--badge-indicator {
  -webkit-margin-before: 0.25rem;
          margin-block-start: 0.25rem;
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

[dir=rtl] .cds--btn-set .cds--btn:not(:focus) {
  box-shadow: 0.0625rem 0 0 0 #e0e0e0;
  box-shadow: 0.0625rem 0 0 0 var(--cds-button-separator, #e0e0e0);
}

.cds--btn-set--fluid {
  container-type: inline-size;
}
.cds--btn-set--fluid .cds--btn-set__fluid-inner {
  --flex-direction: row;
  display: flex;
  flex-direction: var(--flex-direction);
  align-items: stretch;
  justify-content: flex-end;
  inline-size: 100%;
}
.cds--btn-set--fluid .cds--btn-set__fluid-inner .cds--btn {
  flex: 0 1 25%;
  max-inline-size: 14.5rem;
}
.cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack .cds--btn {
  min-inline-size: 11rem;
}
.cds--btn-set--fluid .cds--btn-set__fluid-inner .cds--btn--ghost,
.cds--btn-set--fluid .cds--btn-set__fluid-inner .cds--btn--danger--ghost {
  flex: 1 1 25%;
  max-inline-size: none;
  -webkit-padding-start: 2rem;
          padding-inline-start: 2rem; /* increased padding when inline */
}
@container (width <= 11rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(1):last-child) {
    --flex-direction: column;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(1):last-child) .cds--btn {
    flex: initial;
    inline-size: 100%;
    max-inline-size: none;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(1):last-child) .cds--btn--ghost {
    -webkit-padding-start: 1rem;
            padding-inline-start: 1rem;
  }
}
@container (width <= 22rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(2):last-child) {
    --flex-direction: column;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(2):last-child) .cds--btn {
    flex: initial;
    inline-size: 100%;
    max-inline-size: none;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(2):last-child) .cds--btn--ghost {
    -webkit-padding-start: 1rem;
            padding-inline-start: 1rem;
  }
}
@container (width <= 33rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(3):last-child) {
    --flex-direction: column;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(3):last-child) .cds--btn {
    flex: initial;
    inline-size: 100%;
    max-inline-size: none;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(3):last-child) .cds--btn--ghost {
    -webkit-padding-start: 1rem;
            padding-inline-start: 1rem;
  }
}
@container (width <= 44rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(4):last-child) {
    --flex-direction: column;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(4):last-child) .cds--btn {
    flex: initial;
    inline-size: 100%;
    max-inline-size: none;
  }
  .cds--btn-set--fluid .cds--btn-set__fluid-inner--auto-stack:has(:nth-child(4):last-child) .cds--btn--ghost {
    -webkit-padding-start: 1rem;
            padding-inline-start: 1rem;
  }
}
@container (width <= 44rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner:has(:nth-child(2):last-child) .cds--btn {
    flex-basis: 50%;
    max-inline-size: none;
  }
}
@container (width <= 33rem) {
  .cds--btn-set--fluid .cds--btn-set__fluid-inner:has(:nth-child(1):last-child) .cds--btn {
    flex: 1 1 100%;
    max-inline-size: none;
  }
}

.cds--toggletip-label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

:host([slot=label-text]) .cds--toggletip-label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--toggletip-button {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--toggletip-button *,
.cds--toggletip-button *::before,
.cds--toggletip-button *::after {
  box-sizing: inherit;
}
.cds--toggletip-button::-moz-focus-inner {
  border: 0;
}
.cds--toggletip-button {
  display: flex;
  align-items: center;
}

.cds--toggletip-button svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--toggletip-button:hover svg,
.cds--toggletip--open .cds--toggletip-button svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--toggletip-button:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--toggletip-button:focus {
    outline-style: dotted;
  }
}

.cds--toggletip {
  --cds-popover-offset: 0.8125rem;
}

.cds--toggletip-content {
  --cds-button-focus-color: var(--cds-focus-inverse, #ffffff);
  --cds-link-text-color: var(--cds-link-inverse, #78a9ff);
  --cds-link-hover-text-color: var(--cds-link-inverse-hover, #a6c8ff);
  --cds-link-visited-text-color: var(--cds-link-inverse-visited, #be95ff);
  --cds-link-focus-text-color: var(--cds-focus-inverse, #ffffff);
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  display: grid;
  padding: 1rem;
  max-inline-size: 18rem;
  grid-row-gap: 1rem;
  row-gap: 1rem;
}

.cds--toggletip-content p {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
}

.cds--toggletip-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 1rem;
}

.cds--toggle {
  display: inline-block;
  -webkit-user-select: none;
          user-select: none;
}

.cds--toggle__label-text {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  display: block;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  -webkit-margin-after: 1rem;
          margin-block-end: 1rem;
}

.cds--toggle__button {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}
.cds--toggle__button:focus {
  outline: none;
}

.cds--toggle__appearance {
  display: inline-grid;
  align-items: center;
  column-gap: 0.5rem;
  cursor: pointer;
  grid-template-columns: -webkit-max-content -webkit-max-content;
  grid-template-columns: max-content max-content;
}

.cds--toggle__switch {
  position: relative;
  border-radius: 0.75rem;
  background-color: #8d8d8d;
  background-color: var(--cds-toggle-off, #8d8d8d);
  block-size: 1.5rem;
  inline-size: 3rem;
  transition: background-color 70ms cubic-bezier(0.2, 0, 1, 0.9);
}
.cds--toggle__switch::before {
  position: absolute;
  border-radius: 50%;
  background-color: #ffffff;
  background-color: var(--cds-icon-on-color, #ffffff);
  block-size: 1.125rem;
  content: "";
  inline-size: 1.125rem;
  inset-block-start: 0.1875rem;
  inset-inline-start: 0.1875rem;
  transition: transform 70ms cubic-bezier(0.2, 0, 1, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--toggle__switch::before {
    transition: none;
  }
}

.cds--toggle__button:focus + .cds--toggle__label .cds--toggle__switch::after,
.cds--toggle:not(.cds--toggle--disabled):active .cds--toggle__switch::after {
  display: block;
  border-radius: 1rem;
  block-size: 100%;
  content: "";
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--toggle__switch--checked {
  background-color: #24a148;
  background-color: var(--cds-support-success, #24a148);
}
.cds--toggle__switch--checked::before {
  transform: translateX(1.5rem);
}

.cds--toggle__text {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--toggle__appearance--sm .cds--toggle__switch {
  block-size: 1rem;
  inline-size: 2rem;
}
.cds--toggle__appearance--sm .cds--toggle__switch::before {
  block-size: 0.625rem;
  inline-size: 0.625rem;
}

.cds--toggle__appearance--sm .cds--toggle__switch--checked::before {
  transform: translateX(1rem);
}

.cds--toggle__check {
  position: absolute;
  block-size: 0.3125rem;
  fill: #24a148;
  fill: var(--cds-support-success, #24a148);
  inline-size: 0.375rem;
  inset-block-start: 0.375rem;
  inset-inline-end: 0.3125rem;
  visibility: hidden;
}

.cds--toggle__switch--checked .cds--toggle__check {
  visibility: visible;
}

.cds--toggle--disabled .cds--toggle__appearance {
  cursor: not-allowed;
}

.cds--toggle--disabled .cds--toggle__label-text,
.cds--toggle--disabled .cds--toggle__text {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--toggle--disabled .cds--toggle__switch {
  background-color: #c6c6c6;
  background-color: var(--cds-button-disabled, #c6c6c6);
}
.cds--toggle--disabled .cds--toggle__switch::before {
  background-color: #8d8d8d;
  background-color: var(--cds-icon-on-color-disabled, #8d8d8d);
}

.cds--toggle--disabled .cds--toggle__check {
  fill: #c6c6c6;
  fill: var(--cds-button-disabled, #c6c6c6);
}

.cds--toggle--readonly .cds--toggle__appearance {
  cursor: default;
}

.cds--toggle--readonly .cds--toggle__switch {
  border: 1px solid rgba(22, 22, 22, 0.25);
  border: 1px solid var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
  background-color: transparent;
}
.cds--toggle--readonly .cds--toggle__switch::before {
  background-color: #161616;
  background-color: var(--cds-icon-primary, #161616);
  inset-block-start: 0.125rem;
  inset-inline-start: 0.125rem;
}

.cds--toggle--readonly .cds--toggle__check {
  fill: #ffffff;
  fill: var(--cds-background, #ffffff);
  inset-block-start: 0.3125rem;
  inset-inline-end: 0.25rem;
}

.cds--toggle--readonly .cds--toggle__text {
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toggle__switch,
  .cds--toggle__switch::before {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toggle__button:focus + .cds--toggle__label .cds--toggle__switch,
  .cds--toggle:not(.cds--toggle--disabled):active .cds--toggle__switch {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--toggle--skeleton {
  display: flex;
  align-items: center;
}

.cds--toggle--skeleton .cds--toggle__skeleton-circle {
  position: relative;
  overflow: hidden;
  border-radius: 50%;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
}
.cds--toggle--skeleton .cds--toggle__skeleton-circle::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 200%;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--toggle--skeleton .cds--toggle__skeleton-circle::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toggle--skeleton .cds--toggle__skeleton-circle {
    background: CanvasText;
  }
  .cds--toggle--skeleton .cds--toggle__skeleton-circle::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--toggle--skeleton .cds--toggle__skeleton-circle {
  border-radius: 50%;
  block-size: 1.125rem;
  inline-size: 1.125rem;
}

.cds--toggle--skeleton .cds--toggle__skeleton-rectangle {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--toggle--skeleton .cds--toggle__skeleton-rectangle:hover, .cds--toggle--skeleton .cds--toggle__skeleton-rectangle:focus, .cds--toggle--skeleton .cds--toggle__skeleton-rectangle:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--toggle--skeleton .cds--toggle__skeleton-rectangle::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--toggle--skeleton .cds--toggle__skeleton-rectangle::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toggle--skeleton .cds--toggle__skeleton-rectangle {
    background: CanvasText;
  }
  .cds--toggle--skeleton .cds--toggle__skeleton-rectangle::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--toggle--skeleton .cds--toggle__skeleton-rectangle {
  block-size: 0.5rem;
  inline-size: 1.5rem;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

[dir=rtl] .cds--toggle__switch--checked::before {
  transform: translateX(-1.5rem);
}

[dir=rtl] .cds--toggle__appearance--sm .cds--toggle__switch--checked::before {
  transform: translateX(-1rem);
}

.cds--overflow-menu,
.cds--overflow-menu__trigger {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu *,
.cds--overflow-menu *::before,
.cds--overflow-menu *::after,
.cds--overflow-menu__trigger *,
.cds--overflow-menu__trigger *::before,
.cds--overflow-menu__trigger *::after {
  box-sizing: inherit;
}
.cds--overflow-menu::-moz-focus-inner,
.cds--overflow-menu__trigger::-moz-focus-inner {
  border: 0;
}
.cds--overflow-menu,
.cds--overflow-menu__trigger {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu *,
.cds--overflow-menu *::before,
.cds--overflow-menu *::after,
.cds--overflow-menu__trigger *,
.cds--overflow-menu__trigger *::before,
.cds--overflow-menu__trigger *::after {
  box-sizing: inherit;
}
.cds--overflow-menu,
.cds--overflow-menu__trigger {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 2.5rem;
  cursor: pointer;
  inline-size: 2.5rem;
  min-block-size: 2.5rem;
  transition: outline 110ms cubic-bezier(0, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--overflow-menu:focus,
.cds--overflow-menu__trigger:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu:focus,
  .cds--overflow-menu__trigger:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu:hover,
.cds--overflow-menu__trigger:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.cds--overflow-menu > :first-child {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--overflow-menu--xs {
  block-size: 1.5rem;
  inline-size: 1.5rem;
  min-block-size: 1.5rem;
}

.cds--overflow-menu--sm {
  block-size: 2rem;
  inline-size: 2rem;
  min-block-size: 2rem;
}

.cds--overflow-menu--lg {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu__trigger.cds--tooltip--a11y.cds--tooltip__trigger:focus svg {
  outline: none;
}

.cds--overflow-menu.cds--overflow-menu--open,
.cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__trigger {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  transition: none;
}

.cds--overflow-menu--light.cds--overflow-menu--open,
.cds--overflow-menu--light.cds--overflow-menu--open .cds--overflow-menu__trigger {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--overflow-menu__icon {
  block-size: 1rem;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1rem;
}

.cds--overflow-menu__wrapper {
  line-height: 0;
}

.cds--overflow-menu-options {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu-options *,
.cds--overflow-menu-options *::before,
.cds--overflow-menu-options *::after {
  box-sizing: inherit;
}
.cds--overflow-menu-options {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  position: absolute;
  z-index: 6000;
  display: none;
  flex-direction: column;
  align-items: flex-start;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 10rem;
  inset-block-start: 2rem;
  inset-inline-start: 0;
  list-style: none;
}
.cds--overflow-menu-options::after {
  position: absolute;
  display: block;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  content: "";
  transition: background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--overflow-menu-options::after {
    transition: none;
  }
}

.cds--overflow-menu.cds--overflow-menu--open:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--overflow-menu-options--light {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--overflow-menu-options--light::after {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--overflow-menu.cds--overflow-menu--light.cds--overflow-menu--open:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--overflow-menu-options[data-floating-menu-direction=bottom]:not(.cds--breadcrumb-menu-options)::after {
  block-size: 0.1875rem;
  inline-size: 2.5rem;
  inset-block-start: -0.1875rem;
  inset-inline-start: 0;
}

.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  block-size: 0.5rem;
  inline-size: 2.5rem;
  inset-block-end: -0.5rem;
  inset-inline-start: 0;
}

.cds--overflow-menu-options[data-floating-menu-direction=left]::after {
  block-size: 2.5rem;
  inline-size: 0.375rem;
  inset-block-start: 0;
  inset-inline-end: -0.375rem;
}

.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 2.5rem;
  inline-size: 0.375rem;
  inset-block-start: 0;
  inset-inline-start: -0.375rem;
}

.cds--overflow-menu-options--xs.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after, .cds--overflow-menu-options--xs.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  inline-size: 1.5rem;
}
.cds--overflow-menu-options--xs.cds--overflow-menu-options[data-floating-menu-direction=left]::after, .cds--overflow-menu-options--xs.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 1.5rem;
}

.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after, .cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  inline-size: 2rem;
}
.cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=left]::after, .cds--overflow-menu-options--sm.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 2rem;
}

.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after, .cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=top]::after {
  inline-size: 3rem;
}
.cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=left]::after, .cds--overflow-menu-options--lg.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  block-size: 3rem;
}

.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=top]::after,
.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=bottom]::after {
  inset-inline: auto 0;
}

.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=left]::after,
.cds--overflow-menu--flip.cds--overflow-menu-options[data-floating-menu-direction=right]::after {
  inset-block: auto 0;
}

.cds--overflow-menu-options--open {
  display: flex;
}

.cds--overflow-menu-options__content {
  inline-size: 100%;
}

.cds--overflow-menu-options__option {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu-options__option *,
.cds--overflow-menu-options__option *::before,
.cds--overflow-menu-options__option *::after {
  box-sizing: inherit;
}
.cds--overflow-menu-options__option {
  display: flex;
  align-items: center;
  padding: 0;
  background-color: transparent;
  block-size: 2.5rem;
  inline-size: 100%;
  transition: background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--overflow-menu-options--xs .cds--overflow-menu-options__option {
  block-size: 1.5rem;
}

.cds--overflow-menu-options--sm .cds--overflow-menu-options__option {
  block-size: 2rem;
}

.cds--overflow-menu-options--lg .cds--overflow-menu-options__option {
  block-size: 3rem;
}

.cds--overflow-menu--divider {
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-border-subtle);
          border-block-start: 1px solid var(--cds-border-subtle);
}

.cds--overflow-menu--light .cds--overflow-menu--divider {
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-border-subtle);
          border-block-start: 1px solid var(--cds-border-subtle);
}

a.cds--overflow-menu-options__btn::before {
  display: inline-block;
  block-size: 100%;
  content: "";
  vertical-align: middle;
}

.cds--overflow-menu-options__btn {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: inline-flex;
  align-items: center;
  padding: 0 1rem;
  border: none;
  background-color: transparent;
  block-size: 100%;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  cursor: pointer;
  font-family: inherit;
  font-weight: 400;
  inline-size: 100%;
  max-inline-size: 11.25rem;
  text-align: start;
  transition: outline 110ms cubic-bezier(0, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9), color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--overflow-menu-options__btn:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--overflow-menu-options__btn:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--overflow-menu-options__btn:focus {
    outline-style: dotted;
  }
}
.cds--overflow-menu-options__btn::-moz-focus-inner {
  border: none;
}

.cds--overflow-menu-options__btn svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--overflow-menu-options__btn:hover svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--overflow-menu-options__option-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--overflow-menu-options__option:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover,
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus {
  background-color: #da1e28;
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:hover svg,
.cds--overflow-menu-options__option--danger .cds--overflow-menu-options__btn:focus svg {
  fill: currentColor;
}

.cds--overflow-menu-options__option--disabled:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: not-allowed;
}

.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:hover, .cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:active, .cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn:focus {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--overflow-menu-options__option--disabled .cds--overflow-menu-options__btn svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--overflow-menu--flip {
  inset-inline-start: -140px;
}
.cds--overflow-menu--flip::before {
  inset-inline-start: 145px;
}

/* stylelint-disable */
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--overflow-menu:focus,
  .cds--overflow-menu-options__btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

/*stylelint-enable */
.cds--overflow-menu__top-start {
  transform: translate(0, calc(-100% - 2.5rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 2.5rem)));
}

.cds--overflow-menu__top-end {
  transform: translate(0, calc(-100% - 2.5rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 2.5rem)));
}

.cds--modal {
  position: fixed;
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  background-color: var(--cds-overlay, rgba(0, 0, 0, 0.6));
  block-size: 100vh;
  content: "";
  inline-size: 100vw;
  inset-block-start: 0;
  inset-inline-start: 0;
}
.cds--modal.cds--modal--enable-presence {
  animation: cds--presence-modal__enter 240ms cubic-bezier(0, 0, 0.3, 1) forwards;
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--modal.cds--modal--enable-presence {
    animation: none;
  }
}
.cds--modal.cds--modal--enable-presence[data-exiting] {
  animation: cds--presence-modal__exit 240ms cubic-bezier(0.4, 0.14, 1, 1) forwards;
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--modal.cds--modal--enable-presence[data-exiting] {
    animation: none;
  }
}
@keyframes cds--presence-modal__enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes cds--presence-modal__exit {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.cds--modal:not(.cds--modal--enable-presence) {
  opacity: 0;
  transition: opacity 240ms cubic-bezier(0.4, 0.14, 1, 1), visibility 0ms linear 240ms;
  visibility: hidden;
}
.cds--modal:not(.cds--modal--enable-presence).is-visible {
  opacity: 1;
  transition: opacity 240ms cubic-bezier(0, 0, 0.3, 1), visibility 0ms linear;
  visibility: inherit;
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--modal:not(.cds--modal--enable-presence).is-visible {
    transition: none;
  }
}
.cds--modal .cds--text-input--fluid .cds--text-input,
.cds--modal .cds--text-area--fluid .cds--text-area__wrapper,
.cds--modal .cds--text-area--fluid .cds--text-area,
.cds--modal .cds--search--fluid .cds--search-input,
.cds--modal .cds--select--fluid .cds--select-input,
.cds--modal .cds--text-area--fluid .cds--text-area__wrapper[data-invalid] .cds--text-area__divider + .cds--form-requirement,
.cds--modal .cds--list-box__wrapper--fluid .cds--list-box,
.cds--modal .cds--list-box__wrapper--fluid.cds--list-box__wrapper,
.cds--modal .cds--number-input--fluid input[type=number],
.cds--modal .cds--number-input--fluid input[type=text],
.cds--modal .cds--number-input--fluid .cds--number__control-btn::before,
.cds--modal .cds--number-input--fluid .cds--number__control-btn::after,
.cds--modal .cds--date-picker--fluid .ccdsds--date-picker-input__wrapper .cds--date-picker__input {
  background-color: #f4f4f4;
  background-color: var(--cds-field-01, #f4f4f4);
}
.cds--modal .cds--list-box__wrapper--fluid .cds--list-box__menu {
  background-color: #f4f4f4;
  background-color: var(--cds-layer-01, #f4f4f4);
}
.cds--modal .cds--list-box__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover-02, #e8e8e8);
}
.cds--modal .cds--list-box__menu-item--active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected-02, #e0e0e0);
}
.cds--modal .cds--list-box__menu-item--active:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover-02, #d1d1d1);
}
.cds--modal .cds--number-input--fluid .cds--number__control-btn:hover::before,
.cds--modal .cds--number-input--fluid .cds--number__control-btn:hover::after {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--modal .cds--number-input--fluid .cds--number__control-btn:focus::before,
.cds--modal .cds--number-input--fluid .cds--number__control-btn:focus::after {
  -webkit-border-start: 2px solid var(--color-primary);
          border-inline-start: 2px solid var(--color-primary);
  -webkit-border-start: 2px solid var(--cds-focus, #0f62fe);
          border-inline-start: 2px solid var(--cds-focus, #0f62fe);
}

.cds--modal--enable-presence[data-exiting] .cds--modal-container {
  animation: cds--presence-modal-container__exit 240ms cubic-bezier(0.4, 0.14, 1, 1) forwards;
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--modal--enable-presence[data-exiting] .cds--modal-container {
    animation: none;
  }
}
.cds--modal--enable-presence .cds--modal-container {
  animation: cds--presence-modal-container__enter 240ms cubic-bezier(0, 0, 0.3, 1) forwards;
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--modal--enable-presence .cds--modal-container {
    animation: none;
  }
}
@keyframes cds--presence-modal-container__enter {
  from {
    transform: translate3d(0, -24px, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes cds--presence-modal-container__exit {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(0, -24px, 0);
  }
}

:not(.cds--modal--enable-presence).is-visible .cds--modal-container {
  transform: translate3d(0, 0, 0);
  transition: transform 240ms cubic-bezier(0, 0, 0.3, 1);
}
:not(.cds--modal--enable-presence) .cds--modal-container {
  transform: translate3d(0, -24px, 0);
  transition: transform 240ms cubic-bezier(0.4, 0.14, 1, 1);
}

.cds--modal-container {
  position: fixed;
  display: grid;
  border: 1px solid #c6c6c6;
  border: 1px solid var(--cds-border-subtle-01, #c6c6c6);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  grid-template-columns: 100%;
  grid-template-rows: auto 1fr auto;
  inline-size: 100%;
  inset-block-start: 0;
  max-block-size: 100%;
  outline: 3px solid transparent;
  outline-offset: -3px;
  transform-origin: top center;
}
@media (min-width: 42rem) {
  .cds--modal-container {
    position: relative;
    inline-size: 84%;
    max-block-size: 90%;
  }
}
@media (min-width: 66rem) {
  .cds--modal-container {
    inline-size: 60%;
    max-block-size: 84%;
  }
}
@media (min-width: 82rem) {
  .cds--modal-container {
    inline-size: 48%;
  }
}
.cds--modal-container .cds--modal-container-body {
  display: contents;
}

.cds--modal-content {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  position: relative;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 400;
  grid-column: 1/-1;
  grid-row: 2/-2;
  overflow-y: auto;
  padding-block: 0.5rem 3rem;
  padding-inline: 1rem 1rem;
}
.cds--modal-content:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--modal-content:focus {
    outline-style: dotted;
  }
}

.cds--modal-content .cds--form--fluid {
  margin-inline: -2rem;
}

.cds--modal-content > p,
.cds--modal-content__regular-content {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  -webkit-padding-end: calc(20% - 2rem);
          padding-inline-end: calc(20% - 2rem);
}

.cds--modal-content--with-form {
  -webkit-padding-end: 1rem;
          padding-inline-end: 1rem;
}

.cds--modal-header {
  grid-column: 1/-1;
  grid-row: 1/1;
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
  max-block-size: 50vh;
  overflow-y: auto;
  -webkit-padding-before: 1rem;
          padding-block-start: 1rem;
  padding-inline: 1rem 3rem;
}

.cds--modal-header__label {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--modal-header__label *,
.cds--modal-header__label *::before,
.cds--modal-header__label *::after {
  box-sizing: inherit;
}
.cds--modal-header__label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  -webkit-margin-after: 0.25rem;
          margin-block-end: 0.25rem;
}

.cds--modal-header__heading {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--modal-header__heading *,
.cds--modal-header__heading *::before,
.cds--modal-header__heading *::after {
  box-sizing: inherit;
}
.cds--modal-header__heading {
  font-size: 1.25rem;
  font-size: var(--cds-heading-03-font-size, 1.25rem);
  font-weight: 400;
  font-weight: var(--cds-heading-03-font-weight, 400);
  line-height: 1.4;
  line-height: var(--cds-heading-03-line-height, 1.4);
  letter-spacing: 0;
  letter-spacing: var(--cds-heading-03-letter-spacing, 0);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  -webkit-padding-end: calc(20% - 3rem);
          padding-inline-end: calc(20% - 3rem);
}

.cds--modal-container--xs .cds--modal-content__regular-content {
  -webkit-padding-end: 1rem;
          padding-inline-end: 1rem;
}
.cds--modal-container--xs .cds--modal-content > p {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}
@media (min-width: 42rem) {
  .cds--modal-container--xs {
    inline-size: 48%;
  }
}
@media (min-width: 66rem) {
  .cds--modal-container--xs {
    inline-size: 32%;
    max-block-size: 48%;
  }
}
@media (min-width: 82rem) {
  .cds--modal-container--xs {
    inline-size: 24%;
  }
}

.cds--modal-container--sm .cds--modal-content__regular-content {
  -webkit-padding-end: 1rem;
          padding-inline-end: 1rem;
}
.cds--modal-container--sm .cds--modal-content > p {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}
@media (min-width: 42rem) {
  .cds--modal-container--sm {
    inline-size: 60%;
  }
}
@media (min-width: 66rem) {
  .cds--modal-container--sm {
    inline-size: 42%;
    max-block-size: 72%;
  }
  .cds--modal-container--sm .cds--modal-content > p,
  .cds--modal-container--sm .cds--modal-content__regular-content {
    -webkit-padding-end: 20%;
            padding-inline-end: 20%;
  }
}
@media (min-width: 82rem) {
  .cds--modal-container--sm {
    inline-size: 36%;
  }
}

@media (min-width: 42rem) {
  .cds--modal-container--lg {
    inline-size: 96%;
  }
}
@media (min-width: 66rem) {
  .cds--modal-container--lg {
    inline-size: 84%;
    max-block-size: 96%;
  }
}
@media (min-width: 82rem) {
  .cds--modal-container--lg {
    inline-size: 72%;
  }
}

.cds--modal-scroll-content {
  -webkit-border-after: 2px solid transparent;
          border-block-end: 2px solid transparent;
  -webkit-mask-image: linear-gradient(to bottom, #f4f4f4 calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, #f4f4f4 0, 16px, transparent 16px), linear-gradient(to right, #f4f4f4 0, 2px, transparent 2px), linear-gradient(to top, #f4f4f4 0, 2px, transparent 2px);
          mask-image: linear-gradient(to bottom, #f4f4f4 calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, #f4f4f4 0, 16px, transparent 16px), linear-gradient(to right, #f4f4f4 0, 2px, transparent 2px), linear-gradient(to top, #f4f4f4 0, 2px, transparent 2px);
  -webkit-mask-image: linear-gradient(to bottom, var(--cds-layer) calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, var(--cds-layer) 0, 16px, transparent 16px), linear-gradient(to right, var(--cds-layer) 0, 2px, transparent 2px), linear-gradient(to top, var(--cds-layer) 0, 2px, transparent 2px);
          mask-image: linear-gradient(to bottom, var(--cds-layer) calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, var(--cds-layer) 0, 16px, transparent 16px), linear-gradient(to right, var(--cds-layer) 0, 2px, transparent 2px), linear-gradient(to top, var(--cds-layer) 0, 2px, transparent 2px);
}

.cds--modal--slug .cds--modal-content.cds--modal-scroll-content.cds--modal-scroll-content--no-fade,
.cds--modal--decorator .cds--modal-content.cds--modal-scroll-content.cds--modal-scroll-content--no-fade,
.cds--modal-scroll-content.cds--modal-scroll-content--no-fade,
.cds--modal-scroll-content--no-fade {
  -webkit-mask-image: none;
          mask-image: none;
}

.cds--modal-scroll-content:has(.cds--autoalign) {
  -webkit-mask-image: none;
          mask-image: none;
}

.cds--modal-scroll-content > *:last-child {
  -webkit-margin-after: 1.5rem;
          margin-block-end: 1.5rem;
}

.cds--modal-footer {
  display: flex;
  justify-content: flex-end;
  block-size: 4rem;
  grid-column: 1/-1;
  grid-row: -1/-1;
  -webkit-margin-before: auto;
          margin-block-start: auto;
}

.cds--modal-footer .cds--btn {
  flex: 0 1 50%;
  align-items: baseline;
  margin: 0;
  block-size: 4rem;
  max-inline-size: none;
}

.cds--modal-footer .cds--btn:not(.cds--skeleton) {
  padding-block: 0.875rem 2rem;
}

.cds--modal-footer--three-button .cds--btn {
  flex: 0 1 25%;
  align-items: flex-start;
}

.cds--modal-close-button {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
}

.cds--modal-close {
  padding: 0.75rem;
  border: 2px solid transparent;
  background-color: transparent;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--modal-close:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--modal-close:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}

.cds--modal-close::-moz-focus-inner {
  border: 0;
}

.cds--modal-close__icon {
  block-size: 1.25rem;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1.25rem;
}

.cds--body--with-modal-open {
  overflow: hidden;
}

.cds--body--with-modal-open .cds--modal .cds--tooltip,
.cds--body--with-modal-open .cds--modal .cds--overflow-menu-options,
.cds--body--with-modal-open .cds--overflow-menu-options {
  z-index: 9000;
}

.cds--modal-container--full-width .cds--modal-content {
  padding: 0;
  margin: 0;
}

.cds--modal--slug.cds--modal,
.cds--modal--decorator:has(.cds--ai-label).cds--modal {
  background-color: rgba(0, 17, 65, 0.5);
  background-color: var(--cds-ai-overlay, rgba(0, 17, 65, 0.5));
}

.cds--modal--slug .cds--modal-container,
.cds--modal--decorator:has(.cds--ai-label) .cds--modal-container {
  background: linear-gradient(to top, #f4f4f4 0%, rgba(69, 137, 255, 0.1) 0%, 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #f4f4f4, #f4f4f4) padding-box, linear-gradient(to bottom, rgba(166, 200, 255, 0.64), #78a9ff) border-box, linear-gradient(to top, #f4f4f4, #f4f4f4) border-box;
  background: linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)) 0%, var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) padding-box, linear-gradient(to bottom, var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)), var(--cds-ai-border-end, #78a9ff)) border-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) border-box;
  border: 1px solid transparent;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  box-shadow: inset 0 -80px 70px -65px rgba(69, 137, 255, 0.1), 0 24px 40px -24px rgba(15, 98, 254, 0.1);
  box-shadow: inset 0 -80px 70px -65px var(--cds-ai-inner-shadow, rgba(69, 137, 255, 0.1)), 0 24px 40px -24px var(--cds-ai-drop-shadow, rgba(15, 98, 254, 0.1));
}

.cds--modal--slug .cds--modal-container:has(.cds--modal-footer),
.cds--modal--decorator:has(.cds--ai-label) .cds--modal-container:has(.cds--modal-footer) {
  background: linear-gradient(to top, #f4f4f4 calc(0% + 64px), rgba(69, 137, 255, 0.1) calc(0% + 64px), 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #f4f4f4, #f4f4f4) padding-box, linear-gradient(to bottom, rgba(166, 200, 255, 0.64), #78a9ff) border-box, linear-gradient(to top, #f4f4f4, #f4f4f4) border-box;
  background: linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)) calc(0% + 64px), var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) calc(0% + 64px), 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) padding-box, linear-gradient(to bottom, var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)), var(--cds-ai-border-end, #78a9ff)) border-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) border-box;
  box-shadow: inset 0 -80px 0 -16px #f4f4f4, inset 0 -160px 70px -65px rgba(69, 137, 255, 0.1), 0 24px 40px -24px rgba(15, 98, 254, 0.1);
  box-shadow: inset 0 -80px 0 -16px var(--cds-layer), inset 0 -160px 70px -65px var(--cds-ai-inner-shadow, rgba(69, 137, 255, 0.1)), 0 24px 40px -24px var(--cds-ai-drop-shadow, rgba(15, 98, 254, 0.1));
}

.cds--modal--slug .cds--modal-content.cds--modal-scroll-content,
.cds--modal--decorator .cds--modal-content.cds--modal-scroll-content {
  -webkit-mask-image: linear-gradient(to bottom, #f4f4f4 calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, #f4f4f4 0, 16px, transparent 16px), linear-gradient(to right, #f4f4f4 0, 2px, transparent 2px), linear-gradient(to top, #f4f4f4 0, 2px, transparent 2px);
          mask-image: linear-gradient(to bottom, #f4f4f4 calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, #f4f4f4 0, 16px, transparent 16px), linear-gradient(to right, #f4f4f4 0, 2px, transparent 2px), linear-gradient(to top, #f4f4f4 0, 2px, transparent 2px);
  -webkit-mask-image: linear-gradient(to bottom, var(--cds-layer) calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, var(--cds-layer) 0, 16px, transparent 16px), linear-gradient(to right, var(--cds-layer) 0, 2px, transparent 2px), linear-gradient(to top, var(--cds-layer) 0, 2px, transparent 2px);
          mask-image: linear-gradient(to bottom, var(--cds-layer) calc(100% - 80px), transparent calc(100% - 48px), transparent 100%), linear-gradient(to left, var(--cds-layer) 0, 16px, transparent 16px), linear-gradient(to right, var(--cds-layer) 0, 2px, transparent 2px), linear-gradient(to top, var(--cds-layer) 0, 2px, transparent 2px);
}

.cds--modal-header > .cds--modal--inner__decorator:has(+ .cds--modal-close-button) > *,
.cds--modal-header > .cds--modal-close-button ~ .cds--modal--inner__decorator > *,
.cds--modal--decorator .cds--modal-container-body > .cds--modal--inner__decorator > *,
.cds--modal-header > .cds--ai-label:has(+ .cds--modal-close-button),
.cds--modal-header > .cds--modal-close-button ~ .cds--ai-label,
.cds--modal--slug .cds--modal-container-body > .cds--ai-label,
.cds--modal-header > .cds--slug:has(+ .cds--modal-close-button),
.cds--modal-header > .cds--modal-close-button ~ .cds--slug,
.cds--modal--slug .cds--modal-container-body > .cds--slug {
  position: absolute;
  inset-block-start: 0.625rem;
  inset-inline-end: 3rem;
}

.cds--modal-header > .cds--modal--inner__decorator:not(:has(.cds--ai-label)) > * {
  inset-block-start: 1rem;
}

.cds--modal-header > .cds--modal--inner__decorator:has(.cds--ai-label--revert) > * {
  inset-block-start: 1.475rem;
}

.cds--modal--decorator .cds--modal-content--overflow-indicator::before,
.cds--modal--decorator .cds--modal-content--overflow-indicator {
  display: none;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--modal-close:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #f4f4f4 inset;
  box-shadow: 0 0 0 1000px var(--cds-field) inset;
  -webkit-text-fill-color: #161616;
  -webkit-text-fill-color: var(--cds-text-primary, #161616);
}

.cds--fieldset {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--fieldset *,
.cds--fieldset *::before,
.cds--fieldset *::after {
  box-sizing: inherit;
}

.cds--form-item {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
}

.cds--label html {
  font-size: 100%;
}
.cds--label body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--label code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--label strong {
  font-weight: 600;
}
.cds--label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  display: inline-block;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-weight: 400;
  line-height: 1rem;
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
  vertical-align: baseline;
}

.cds--label .cds--toggletip-label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--label--no-margin {
  -webkit-margin-after: 0;
          margin-block-end: 0;
}

.cds--label + .cds--tooltip {
  position: relative;
  inset-block-start: 0.2rem;
  inset-inline-start: 0.5rem;
}

.cds--label + .cds--tooltip .cds--tooltip__trigger {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger *,
.cds--label + .cds--tooltip .cds--tooltip__trigger *::before,
.cds--label + .cds--tooltip .cds--tooltip__trigger *::after {
  box-sizing: inherit;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger::-moz-focus-inner {
  border: 0;
}
.cds--label + .cds--tooltip .cds--tooltip__trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--label + .cds--tooltip .cds--tooltip__trigger svg :hover {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--label + .cds--toggletip {
  inset-block-start: 0.2rem;
  inset-inline-start: 0.5rem;
}

.cds--label.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--label.cds--skeleton:hover, .cds--label.cds--skeleton:focus, .cds--label.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--label.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--label.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--label.cds--skeleton {
    background: CanvasText;
  }
  .cds--label.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--label.cds--skeleton {
  block-size: 0.875rem;
  inline-size: 4.6875rem;
}

input[type=number],
input[type=text].cds--number {
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
}

input[data-invalid]:not(:focus),
.cds--number[data-invalid] input[type=number]:not(:focus),
.cds--number[data-invalid] input[type=text]:not(:focus),
.cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:not(:focus),
.cds--text-area__wrapper[data-invalid] > .cds--text-area--invalid:not(:focus),
.cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),
.cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,
.cds--combo-box--invalid--focused),
.cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus) {
  outline: 2px solid #da1e28;
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  input[data-invalid]:not(:focus),
  .cds--number[data-invalid] input[type=number]:not(:focus),
  .cds--number[data-invalid] input[type=text]:not(:focus),
  .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:not(:focus),
  .cds--text-area__wrapper[data-invalid] > .cds--text-area--invalid:not(:focus),
  .cds--select-input__wrapper[data-invalid] .cds--select-input:not(:focus),
  .cds--list-box[data-invalid]:not(.cds--multi-select--invalid--focused,
  .cds--combo-box--invalid--focused),
  .cds--combo-box[data-invalid]:not(.cds--multi-select--selected) .cds--text-input:not(:focus) {
    outline-style: dotted;
  }
}

input[data-invalid] ~ .cds--form-requirement,
.cds--number[data-invalid] .cds--number__input-wrapper ~ .cds--form-requirement,
.cds--number__input-wrapper--warning ~ .cds--form-requirement,
.cds--date-picker-input__wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--warn ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--invalid ~ .cds--form-requirement,
.cds--time-picker--invalid ~ .cds--form-requirement,
.cds--time-picker--warning ~ .cds--form-requirement,
.cds--text-input__field-wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-input__field-wrapper--warning ~ .cds--form-requirement,
.cds--text-input__field-wrapper--warning > .cds--text-input ~ .cds--form-requirement,
.cds--text-area__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-area__wrapper--warn ~ .cds--form-requirement,
.cds--select-input__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--select--warning .cds--select-input__wrapper ~ .cds--form-requirement,
.cds--time-picker[data-invalid] ~ .cds--form-requirement,
.cds--list-box[data-invalid] ~ .cds--form-requirement,
.cds--list-box--warning ~ .cds--form-requirement {
  display: block;
  overflow: visible;
  font-weight: 400;
  max-block-size: 12.5rem;
}

.cds--select--inline.cds--select--warning .cds--select-input--inline__wrapper ~ .cds--form-requirement,
.cds--select-input--inline__wrapper[data-invalid] ~ .cds--form-requirement {
  display: inline-flex;
  overflow: visible;
  margin: 0;
  inline-size: 100%;
  -webkit-margin-after: 0;
          margin-block-end: 0;
  max-block-size: 100%;
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}

input[data-invalid] ~ .cds--form-requirement,
.cds--number[data-invalid] .cds--number__input-wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper ~ .cds--form-requirement,
.cds--date-picker-input__wrapper--invalid ~ .cds--form-requirement,
.cds--time-picker--invalid ~ .cds--form-requirement,
.cds--text-input__field-wrapper[data-invalid] ~ .cds--form-requirement,
.cds--text-area__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--select-input__wrapper[data-invalid] ~ .cds--form-requirement,
.cds--time-picker[data-invalid] ~ .cds--form-requirement,
.cds--list-box[data-invalid] ~ .cds--form-requirement,
.cds--select-input--inline__wrapper[data-invalid] ~ .cds--form-requirement {
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid],
.cds--form--fluid .cds--text-input__field-wrapper--warning {
  display: block;
}

.cds--form--fluid input[data-invalid] {
  outline: none;
}

.cds--form--fluid .cds--form-requirement {
  padding: 0.5rem 2.5rem 0.5rem 1rem;
  margin: 0;
}

input:not(output, [data-invalid]):-moz-ui-invalid {
  box-shadow: none;
}

.cds--form-requirement html {
  font-size: 100%;
}
.cds--form-requirement body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--form-requirement code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--form-requirement strong {
  font-weight: 600;
}
.cds--form-requirement {
  font-size: 0.75rem;
  font-size: var(--cds-helper-text-01-font-size, 0.75rem);
  line-height: 1.33333;
  line-height: var(--cds-helper-text-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-helper-text-01-letter-spacing, 0.32px);
  display: none;
  overflow: hidden;
  margin: 0.25rem 0 0;
  max-block-size: 0;
}

.cds--select--inline .cds--form__helper-text {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--form__helper-text {
  font-size: 0.75rem;
  font-size: var(--cds-helper-text-01-font-size, 0.75rem);
  line-height: 1.33333;
  line-height: var(--cds-helper-text-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-helper-text-01-letter-spacing, 0.32px);
  z-index: 0;
  color: #6f6f6f;
  color: var(--cds-text-helper, #6f6f6f);
  inline-size: 100%;
  -webkit-margin-before: 0.25rem;
          margin-block-start: 0.25rem;
  opacity: 1;
}

.cds--label--disabled,
.cds--form__helper-text--disabled {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

fieldset[disabled] .cds--label,
fieldset[disabled] .cds--form__helper-text {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--stack-horizontal {
  display: inline-grid;
  column-gap: 0;
  column-gap: var(--cds-stack-gap, 0);
  grid-auto-flow: column;
}

.cds--stack-vertical {
  display: grid;
  grid-auto-flow: row;
  row-gap: 0;
  grid-row-gap: 0;
  grid-row-gap: var(--cds-stack-gap, 0);
  row-gap: var(--cds-stack-gap, 0);
}

.cds--stack-scale-1 {
  --cds-stack-gap: 0.125rem;
}

.cds--stack-scale-2 {
  --cds-stack-gap: 0.25rem;
}

.cds--stack-scale-3 {
  --cds-stack-gap: 0.5rem;
}

.cds--stack-scale-4 {
  --cds-stack-gap: 0.75rem;
}

.cds--stack-scale-5 {
  --cds-stack-gap: 1rem;
}

.cds--stack-scale-6 {
  --cds-stack-gap: 1.5rem;
}

.cds--stack-scale-7 {
  --cds-stack-gap: 2rem;
}

.cds--stack-scale-8 {
  --cds-stack-gap: 2.5rem;
}

.cds--stack-scale-9 {
  --cds-stack-gap: 3rem;
}

.cds--stack-scale-10 {
  --cds-stack-gap: 4rem;
}

.cds--stack-scale-11 {
  --cds-stack-gap: 5rem;
}

.cds--stack-scale-12 {
  --cds-stack-gap: 6rem;
}

.cds--stack-scale-13 {
  --cds-stack-gap: 10rem;
}

.cds--checkbox-group {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--checkbox-group *,
.cds--checkbox-group *::before,
.cds--checkbox-group *::after {
  box-sizing: inherit;
}

.cds--form-item.cds--checkbox-wrapper {
  position: relative;
  -webkit-margin-after: 0.375rem;
          margin-block-end: 0.375rem;
}

.cds--form-item.cds--checkbox-wrapper:first-of-type {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--label + .cds--form-item.cds--checkbox-wrapper {
  -webkit-margin-before: -0.125rem;
          margin-block-start: -0.125rem;
}

.cds--form-item.cds--checkbox-wrapper:last-of-type {
  -webkit-margin-after: 0.1875rem;
          margin-block-end: 0.1875rem;
}

.cds--checkbox {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  inset-block-start: 1.25rem;
  inset-inline-start: 0.7rem;
}

.cds--checkbox-label html {
  font-size: 100%;
}
.cds--checkbox-label body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--checkbox-label code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--checkbox-label strong {
  font-weight: 600;
}
.cds--checkbox-label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: flex;
  cursor: pointer;
  min-block-size: 1.25rem;
  -webkit-padding-before: 0.0625rem;
          padding-block-start: 0.0625rem;
  -webkit-padding-start: 1.25rem;
          padding-inline-start: 1.25rem;
  -webkit-user-select: none;
          user-select: none;
}

.cds--checkbox-label-text {
  -webkit-padding-start: 0.625rem;
          padding-inline-start: 0.625rem;
}

.cds--checkbox-label::before,
.cds--checkbox-label::after {
  box-sizing: border-box;
}
@media print {
  .cds--checkbox-label::before,
  .cds--checkbox-label::after {
    -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
  }
}

.cds--checkbox-label::before {
  position: absolute;
  border: 1px solid #161616;
  border: 1px solid var(--cds-icon-primary, #161616);
  border-radius: 2px;
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--checkbox-label::before {
    border: 1px solid ButtonBorder;
  }
}
.cds--checkbox-label::before {
  background-color: transparent;
  block-size: 1rem;
  content: "";
  inline-size: 1rem;
  inset-block-start: 0.125rem;
  inset-inline-start: 0;
  margin-block: 0.0625rem 0.125rem;
  margin-inline: 0.1875rem 0;
}

.cds--checkbox-label::after {
  position: absolute;
  background: none;
  block-size: 0.3125rem;
  -webkit-border-after: 1.5px solid #ffffff;
          border-block-end: 1.5px solid #ffffff;
  -webkit-border-after: 1.5px solid var(--cds-icon-inverse, #ffffff);
          border-block-end: 1.5px solid var(--cds-icon-inverse, #ffffff);
  -webkit-border-start: 1.5px solid #ffffff;
          border-inline-start: 1.5px solid #ffffff;
  -webkit-border-start: 1.5px solid var(--cds-icon-inverse, #ffffff);
          border-inline-start: 1.5px solid var(--cds-icon-inverse, #ffffff);
  content: "";
  inline-size: 0.5625rem;
  inset-block-start: 0.40625rem;
  inset-inline-start: 0.4375rem;
  -webkit-margin-before: -0.1875rem;
          margin-block-start: -0.1875rem;
  transform: scale(0) rotate(-45deg);
  transform-origin: bottom right;
}

.cds--checkbox:checked + .cds--checkbox-label::before,
.cds--checkbox:indeterminate + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true]::before {
  border: none;
  border-width: 1px;
  background-color: #161616;
  background-color: var(--cds-icon-primary, #161616);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--checkbox:checked + .cds--checkbox-label::before,
  .cds--checkbox:indeterminate + .cds--checkbox-label::before,
  .cds--checkbox-label[data-contained-checkbox-state=true]::before {
    border: 1px solid ButtonBorder;
    background-color: SelectedItem;
  }
}

.cds--checkbox:checked + .cds--checkbox-label::after,
.cds--checkbox-label[data-contained-checkbox-state=true]::after {
  transform: scale(1) rotate(-45deg);
}

.cds--checkbox:indeterminate + .cds--checkbox-label::after {
  -webkit-border-after: 2px solid #ffffff;
          border-block-end: 2px solid #ffffff;
  -webkit-border-after: 2px solid var(--cds-icon-inverse, #ffffff);
          border-block-end: 2px solid var(--cds-icon-inverse, #ffffff);
  -webkit-border-start: 0 solid #ffffff;
          border-inline-start: 0 solid #ffffff;
  -webkit-border-start: 0 solid var(--cds-icon-inverse, #ffffff);
          border-inline-start: 0 solid var(--cds-icon-inverse, #ffffff);
  inline-size: 0.5rem;
  inset-block-start: 0.6875rem;
  transform: scale(1) rotate(0deg);
}

.cds--checkbox:focus + .cds--checkbox-label::before,
.cds--checkbox-label__focus::before,
.cds--checkbox:checked:focus + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true].cds--checkbox-label__focus::before,
.cds--checkbox:indeterminate:focus + .cds--checkbox-label::before {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--checkbox:disabled + .cds--checkbox-label,
.cds--checkbox-label[data-contained-checkbox-disabled=true] {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--checkbox:disabled + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-disabled=true]::before {
  border-color: rgba(22, 22, 22, 0.25);
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox:checked:disabled + .cds--checkbox-label::before,
.cds--checkbox:indeterminate:disabled + .cds--checkbox-label::before,
.cds--checkbox-label[data-contained-checkbox-state=true][data-contained-checkbox-disabled=true]::before {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox-group[data-invalid] .cds--checkbox-label::before,
.cds--checkbox-wrapper--invalid .cds--checkbox-label::before,
.cds--checkbox-wrapper--invalid .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid #da1e28;
  border: 1px solid var(--cds-support-error, #da1e28);
}

.cds--checkbox-group .cds--checkbox-wrapper--invalid > .cds--checkbox__validation-msg,
.cds--checkbox-group .cds--checkbox-wrapper--warning > .cds--checkbox__validation-msg,
.cds--checkbox-group .cds--checkbox-wrapper > .cds--form__helper-text {
  display: none;
}

.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox-label::before,
.cds--checkbox-group:not(.cds--checkbox-group[data-invalid]) .cds--checkbox-wrapper--invalid .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid #161616;
  border: 1px solid var(--cds-icon-primary, #161616);
}

.cds--checkbox-group__validation-msg,
.cds--checkbox__validation-msg {
  display: none;
  align-items: flex-start;
  inline-size: 100%;
  -webkit-margin-before: 0.25rem;
          margin-block-start: 0.25rem;
}

.cds--checkbox__invalid-icon {
  margin: 0.0625rem 0.0625rem 0 0.1875rem;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  min-inline-size: 1rem;
}

.cds--checkbox__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--checkbox__invalid-icon--warning path:first-of-type {
  fill: #000000;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg,
.cds--checkbox-group--warning .cds--checkbox-group__validation-msg,
.cds--checkbox-wrapper--invalid > .cds--checkbox__validation-msg,
.cds--checkbox-wrapper--warning > .cds--checkbox__validation-msg {
  display: flex;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-group--warning .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--warning .cds--checkbox__validation-msg .cds--form-requirement {
  display: block;
  overflow: visible;
  -webkit-margin-before: 0;
          margin-block-start: 0;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  max-block-size: 100%;
}

.cds--checkbox-group--invalid .cds--checkbox-group__validation-msg .cds--form-requirement,
.cds--checkbox-wrapper--invalid .cds--checkbox__validation-msg .cds--form-requirement {
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
}

.cds--checkbox-group--readonly .cds--checkbox-label,
.cds--checkbox-wrapper--readonly .cds--checkbox-label {
  cursor: default;
}

.cds--checkbox-group--readonly .cds--checkbox-label-text,
.cds--checkbox-wrapper--readonly .cds--checkbox-label-text {
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

.cds--checkbox-group--readonly .cds--checkbox + .cds--checkbox-label::before,
.cds--checkbox-wrapper--readonly .cds--checkbox + .cds--checkbox-label::before {
  border-color: rgba(22, 22, 22, 0.25);
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--checkbox-group--readonly .cds--checkbox:checked + .cds--checkbox-label::before,
.cds--checkbox-wrapper--readonly .cds--checkbox:checked + .cds--checkbox-label::before {
  border: 1px solid rgba(22, 22, 22, 0.25);
  border: 1px solid var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
  background: transparent;
}

.cds--checkbox-group--readonly .cds--checkbox:checked + .cds--checkbox-label::after,
.cds--checkbox-wrapper--readonly .cds--checkbox:checked + .cds--checkbox-label::after {
  border-color: #161616;
  border-color: var(--cds-text-primary, #161616);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--checkbox-group--readonly .cds--checkbox:checked + .cds--checkbox-label::after,
  .cds--checkbox-wrapper--readonly .cds--checkbox:checked + .cds--checkbox-label::after {
    fill: SelectedItemText;
  }
}

.cds--checkbox-skeleton .cds--checkbox-label {
  cursor: default;
}

.cds--checkbox-label-text.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--checkbox-label-text.cds--skeleton:hover, .cds--checkbox-label-text.cds--skeleton:focus, .cds--checkbox-label-text.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--checkbox-label-text.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--checkbox-label-text.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--checkbox-label-text.cds--skeleton {
    background: CanvasText;
  }
  .cds--checkbox-label-text.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--checkbox-label-text.cds--skeleton {
  block-size: 1rem;
  inline-size: 6.25rem;
  margin-block: 0.0625rem 0;
  margin-inline: 0.375rem 0;
}

.cds--checkbox--inline {
  position: relative;
}

[dir=rtl] .cds--checkbox-label::after {
  -webkit-margin-before: 0;
          margin-block-start: 0;
  -webkit-margin-start: -0.0625rem;
          margin-inline-start: -0.0625rem;
  transform-origin: center;
}

[dir=rtl] .cds--checkbox:checked + .cds--checkbox-label::after,
[dir=rtl] .cds--checkbox-label[data-contained-checkbox-state=true]::after {
  transform: scale(1.2) rotate3d(0.5, 1, 0, 158deg);
}

.cds--checkbox-group--decorator legend.cds--label,
.cds--checkbox-wrapper--decorator .cds--checkbox-label-text {
  display: flex;
}

.cds--checkbox-group--slug legend.cds--label,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text {
  display: flex;
}

.cds--checkbox-group--decorator legend.cds--label .cds--checkbox-group-inner--decorator > *,
.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--checkbox-wrapper-inner--decorator > * {
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--checkbox-group--slug legend.cds--label .cds--ai-label,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label,
.cds--checkbox-group--slug legend.cds--label .cds--slug,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug {
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--checkbox-wrapper--decorator .cds--checkbox-label-text .cds--ai-label__button--inline {
  line-height: inherit;
  -webkit-margin-before: -0.0625rem;
          margin-block-start: -0.0625rem;
}

.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--ai-label__button--inline,
.cds--checkbox-wrapper--slug .cds--checkbox-label-text .cds--slug__button--inline {
  line-height: inherit;
  -webkit-margin-before: -0.0625rem;
          margin-block-start: -0.0625rem;
}

.cds--checkbox-group--horizontal {
  position: relative;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
}
.cds--checkbox-group--horizontal .cds--form-item {
  flex: none;
  -webkit-margin-after: 0;
          margin-block-end: 0;
}
.cds--checkbox-group--horizontal .cds--form-item:not(:last-of-type) {
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}
.cds--checkbox-group--horizontal .cds--checkbox-label-text {
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}
.cds--checkbox-group--horizontal .cds--label + .cds--form-item.cds--checkbox-wrapper {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--text-input {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--text-input *,
.cds--text-input *::before,
.cds--text-input *::after {
  box-sizing: inherit;
}
.cds--text-input {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  padding: 0 var(--cds-layout-density-padding-inline-local);
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: var(--cds-layout-size-height-local);
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-family: inherit;
  inline-size: 100%;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--text-input:focus, .cds--text-input:active {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--text-input:focus, .cds--text-input:active {
    outline-style: dotted;
  }
}
.cds--text-input-wrapper svg[hidden] {
  display: none;
}

.cds--password-input {
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}

.cds--text-input--sm.cds--password-input {
  -webkit-padding-end: 2rem;
          padding-inline-end: 2rem;
}

.cds--text-input--lg.cds--password-input {
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--text-input::placeholder {
  color: rgba(22, 22, 22, 0.4);
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
}

.cds--text-input--light {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--text-input__field-wrapper {
  position: relative;
  display: flex;
  inline-size: 100%;
}

.cds--text-input__invalid-icon {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--text-input__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--text-input__invalid-icon--warning path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--text-input--password__visibility {
  position: relative;
  display: inline-flex;
  overflow: visible;
  align-items: center;
}
.cds--text-input--password__visibility:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--text-input--password__visibility:focus {
    outline-style: dotted;
  }
}
.cds--text-input--password__visibility {
  cursor: pointer;
}
.cds--text-input--password__visibility:focus {
  outline: 1px solid transparent;
}
.cds--text-input--password__visibility:focus svg {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--text-input--password__visibility:focus svg {
    outline-style: dotted;
  }
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  position: absolute;
  z-index: 6000;
  display: flex;
  align-items: center;
  opacity: 0;
  pointer-events: none;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    display: inline-block;
  }
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after {
  transition: opacity 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after {
    transition: none;
  }
}
.cds--text-input--password__visibility.cds--tooltip--a11y::before, .cds--text-input--password__visibility.cds--tooltip--a11y::after {
  transition: none;
}
.cds--text-input--password__visibility::before {
  border-style: solid;
  block-size: 0;
  content: "";
  inline-size: 0;
}
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  box-sizing: content-box;
  color: inherit;
  opacity: 1;
  white-space: normal;
  word-break: break-word;
}
.cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  z-index: 6000;
  padding: 0.1875rem 1rem;
  border-radius: 0.125rem;
  background-color: #393939;
  background-color: var(--cds-background-inverse, #393939);
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  font-weight: 400;
  inline-size: -webkit-max-content;
  inline-size: max-content;
  max-inline-size: 13rem;
  min-inline-size: 1.5rem;
  text-align: start;
  transform: translateX(-50%);
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@supports (-ms-accelerator: true) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@supports (-ms-ime-align: auto) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    inline-size: auto;
  }
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--text-input--password__visibility::after,
  .cds--text-input--password__visibility .cds--assistive-text,
  .cds--text-input--password__visibility + .cds--assistive-text {
    border: 1px solid transparent;
  }
}
.cds--text-input--password__visibility::after {
  content: attr(aria-label);
}
.cds--text-input--password__visibility.cds--tooltip--a11y::after {
  content: none;
}
.cds--text-input--password__visibility.cds--tooltip--visible::before, .cds--text-input--password__visibility.cds--tooltip--visible::after, .cds--text-input--password__visibility:hover::before, .cds--text-input--password__visibility:hover::after, .cds--text-input--password__visibility:focus::before, .cds--text-input--password__visibility:focus::after {
  opacity: 1;
}
@keyframes cds--tooltip-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,
.cds--text-input--password__visibility.cds--tooltip--visible + .cds--assistive-text, .cds--text-input--password__visibility:hover .cds--assistive-text,
.cds--text-input--password__visibility:hover + .cds--assistive-text, .cds--text-input--password__visibility:focus .cds--assistive-text,
.cds--text-input--password__visibility:focus + .cds--assistive-text {
  overflow: visible;
  margin: auto;
  clip: auto;
}
.cds--text-input--password__visibility.cds--tooltip--visible .cds--assistive-text,
.cds--text-input--password__visibility.cds--tooltip--visible + .cds--assistive-text, .cds--text-input--password__visibility.cds--tooltip--visible.cds--tooltip--a11y::before, .cds--text-input--password__visibility:hover .cds--assistive-text,
.cds--text-input--password__visibility:hover + .cds--assistive-text, .cds--text-input--password__visibility:hover.cds--tooltip--a11y::before, .cds--text-input--password__visibility:focus .cds--assistive-text,
.cds--text-input--password__visibility:focus + .cds--assistive-text, .cds--text-input--password__visibility:focus.cds--tooltip--a11y::before {
  animation: cds--tooltip-fade 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--text-input--password__visibility.cds--tooltip--hidden .cds--assistive-text, .cds--text-input--password__visibility.cds--tooltip--hidden + .cds--assistive-text {
  overflow: hidden;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
}
.cds--text-input--password__visibility.cds--tooltip--hidden.cds--tooltip--a11y::before {
  animation: none;
  opacity: 0;
}
.cds--text-input--password__visibility .cds--assistive-text::after {
  position: absolute;
  display: block;
  content: "";
  block-size: 0.75rem;
  inline-size: 100%;
  inset-inline-start: 0;
  inset-block-start: -0.75rem;
}
.cds--text-input--password__visibility::before, .cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  inset-block-end: 0;
  inset-inline-start: 50%;
}
.cds--text-input--password__visibility::before {
  border-width: 0 0.25rem 0.3125rem;
  border-color: transparent transparent #393939;
  border-color: transparent transparent var(--cds-background-inverse, #393939);
  inset-block-end: -0.5rem;
  transform: translate(-50%, 100%);
}
.cds--text-input--password__visibility::after,
.cds--text-input--password__visibility .cds--assistive-text,
.cds--text-input--password__visibility + .cds--assistive-text {
  inset-block-end: -0.8125rem;
  transform: translate(-50%, 100%);
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: none;
  block-size: 100%;
  cursor: pointer;
  inline-size: 2.5rem;
  inset-inline-end: 0;
  min-block-size: auto;
  transition: outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--toggle-password-tooltip .cds--popover {
  inset-inline-start: -2.5rem;
}

.cds--toggle-password-tooltip .cds--popover-content {
  min-inline-size: 2.5rem;
}

.cds--text-input--sm + .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  inline-size: 2rem;
}

.cds--text-input--lg + .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  inline-size: 3rem;
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--btn.cds--text-input--password__visibility__toggle.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}

.cds--text-input--invalid,
.cds--text-input--warning {
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}

.cds--text-input--invalid.cds--password-input {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--text-input--invalid + .cds--text-input--password__visibility__toggle {
  inset-inline-end: 1rem;
}

.cds--password-input-wrapper .cds--text-input__invalid-icon {
  inset-inline-end: 2.5rem;
}

.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger {
  cursor: not-allowed;
}

.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--text-input:disabled ~ .cds--text-input--password__visibility__toggle.cds--tooltip__trigger svg:hover {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger {
  cursor: default;
}

.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--text-input--password__visibility__toggle:disabled.cds--tooltip__trigger:hover {
  cursor: default;
}

.cds--text-input__counter-alert {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
}

.cds--text-input:disabled {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  -webkit-text-fill-color: rgba(22, 22, 22, 0.25);
  -webkit-text-fill-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--text-input--light:disabled {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--text-input:disabled::placeholder {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  opacity: 1;
}

.cds--text-input--invalid {
  outline: 2px solid #da1e28;
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--text-input--invalid {
    outline-style: dotted;
  }
}
.cds--text-input--invalid {
  box-shadow: none;
}
.cds--text-input--invalid .cds--text-input--password__visibility__toggle {
  inset-inline-end: 2.5rem;
}

.cds--skeleton.cds--text-input {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--skeleton.cds--text-input:hover, .cds--skeleton.cds--text-input:focus, .cds--skeleton.cds--text-input:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--skeleton.cds--text-input::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--skeleton.cds--text-input::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--skeleton.cds--text-input {
    background: CanvasText;
  }
  .cds--skeleton.cds--text-input::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}

.cds--form--fluid .cds--text-input-wrapper {
  position: relative;
  background: #f4f4f4;
  background: var(--cds-field);
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--form--fluid .cds--label {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  margin: 0;
  block-size: 1rem;
  inset-block-start: 0.8125rem;
  inset-inline-start: 1rem;
}

.cds--form--fluid .cds--form__helper-text {
  display: none;
}

.cds--form--fluid .cds--text-input {
  padding: 2rem 1rem 0.8125rem;
  min-block-size: 4rem;
}

.cds--text-input__divider,
.cds--form--fluid .cds--text-input__divider {
  display: none;
}

.cds--form--fluid .cds--text-input--invalid,
.cds--form--fluid .cds--text-input--warning {
  -webkit-border-after: none;
          border-block-end: none;
}

.cds--form--fluid .cds--text-input--invalid + .cds--text-input__divider,
.cds--form--fluid .cds--text-input--warning + .cds--text-input__divider {
  display: block;
  border-style: solid;
  border-color: #e0e0e0;
  border-color: var(--cds-border-subtle);
  margin: 0 1rem;
  -webkit-border-after: none;
          border-block-end: none;
}

.cds--form--fluid .cds--text-input__invalid-icon {
  inset-block-start: 5rem;
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid,
.cds--form--fluid .cds--text-input__field-wrapper--warning > .cds--text-input--warning {
  outline: none;
}

.cds--form--fluid .cds--text-input__field-wrapper--warning {
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus) {
  outline: 2px solid #da1e28;
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:not(:focus) {
    outline-style: dotted;
  }
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within,
.cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--form--fluid .cds--text-input__field-wrapper[data-invalid]:focus-within,
  .cds--form--fluid .cds--text-input__field-wrapper--warning:focus-within {
    outline-style: dotted;
  }
}

.cds--form--fluid .cds--text-input__field-wrapper[data-invalid] > .cds--text-input--invalid:focus,
.cds--form--fluid .cds--text-input__field-wrapper--warning > .cds--text-input--warning:focus {
  outline: none;
}

.cds--text-input-wrapper.cds--text-input-wrapper--inline {
  flex-flow: row wrap;
}

.cds--text-input-wrapper .cds--label--inline {
  flex: 1 1;
  margin: 0.8125rem 0 0 0;
  overflow-wrap: break-word;
  word-break: break-word;
}

.cds--text-input-wrapper .cds--label--inline--sm {
  -webkit-margin-before: 0.5625rem;
          margin-block-start: 0.5625rem;
}

.cds--text-input-wrapper .cds--label--inline--lg {
  -webkit-margin-before: 1.0625rem;
          margin-block-start: 1.0625rem;
}

.cds--text-input__label-helper-wrapper {
  flex: 2 1;
  flex-direction: column;
  -webkit-margin-end: 1.5rem;
          margin-inline-end: 1.5rem;
  max-inline-size: 8rem;
  overflow-wrap: break-word;
}

.cds--text-input-wrapper .cds--form__helper-text--inline {
  -webkit-margin-before: 0.125rem;
          margin-block-start: 0.125rem;
}

.cds--text-input__field-outer-wrapper {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: flex-start;
  inline-size: 100%;
}

.cds--text-input__field-outer-wrapper--inline {
  flex: 8 1;
  flex-direction: column;
}

.cds--text-input-wrapper--inline .cds--form-requirement {
  display: block;
  overflow: visible;
  font-weight: 400;
  max-block-size: 12.5rem;
}

.cds--text-input-wrapper--inline--invalid .cds--form-requirement {
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
}

.cds--form--fluid .cds--text-input-wrapper--readonly,
.cds--text-input-wrapper--readonly .cds--text-input {
  background: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator > *,
.cds--text-input__field-wrapper .cds--ai-label,
.cds--text-input__field-wrapper .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--text-input__field-wrapper--decorator .cds--text-input:has(~ .cds--text-input__field-inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--text-input__field-inner-wrapper--decorator .cds--ai-label--revert)),
.cds--text-input__field-wrapper--slug .cds--text-input:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--text-input__field-wrapper--slug .cds--text-input:has(~ .cds--slug):not(:has(~ .cds--slug--revert)) {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
}

.cds--text-input__field-wrapper--decorator .cds--text-input:has(~ .cds--text-input__field-inner-wrapper--decorator > *),
.cds--text-input__field-wrapper--slug .cds--text-input:has(~ .cds--ai-label),
.cds--text-input__field-wrapper--slug .cds--text-input:has(~ .cds--slug) {
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}

.cds--text-input--invalid:has(~ .cds--text-input__field-inner-wrapper--decorator > *),
.cds--text-input--warning:has(~ .cds--text-input__field-inner-wrapper--decorator > *),
.cds--text-input--invalid:has(~ .cds--ai-label),
.cds--text-input--warning:has(~ .cds--ai-label),
.cds--text-input--invalid:has(~ .cds--slug),
.cds--text-input--warning:has(~ .cds--slug) {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--text-input--invalid ~ .cds--text-input__field-inner-wrapper--decorator > *,
.cds--text-input--warning ~ .cds--text-input__field-inner-wrapper--decorator > *,
.cds--text-input--invalid ~ .cds--ai-label,
.cds--text-input--warning ~ .cds--ai-label,
.cds--text-input--invalid ~ .cds--slug,
.cds--text-input--warning ~ .cds--slug {
  inset-inline-end: 2.5rem;
}

.cds--text-input__field-wrapper--decorator .cds--text-input__field-inner-wrapper--decorator:not(:has(.cds--ai-label)) > * {
  block-size: 1rem;
}

.cds--text-input__label-wrapper {
  display: flex;
  justify-content: space-between;
  inline-size: 100%;
}

.cds--text-area {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--text-area *,
.cds--text-area *::before,
.cds--text-area *::after {
  box-sizing: inherit;
}
.cds--text-area {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  padding: 0.6875rem var(--cds-layout-density-padding-inline-local);
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 100%;
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-family: inherit;
  min-block-size: 2.5rem;
  min-inline-size: 10rem;
  resize: vertical;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--text-area:focus,
.cds--text-area:active {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--text-area:focus,
  .cds--text-area:active {
    outline-style: dotted;
  }
}

.cds--text-area::placeholder {
  color: rgba(22, 22, 22, 0.4);
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
}

.cds--text-area--light {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--text-area__wrapper {
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  position: relative;
  display: flex;
  inline-size: 100%;
  max-inline-size: 100%;
}

.cds--text-area__wrapper--cols {
  inline-size: auto;
}

.cds--text-area__invalid-icon {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 0.75rem;
  inset-inline-end: var(--cds-layout-density-padding-inline-local);
}

.cds--text-area__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--text-area__invalid-icon--warning path[fill] {
  fill: #000000;
  opacity: 1;
}

.cds--text-area__counter-alert {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
}

.cds--form-item:has(.cds--text-area__wrapper--cols) {
  inline-size: -webkit-fit-content;
  inline-size: fit-content;
}

.cds--text-area:disabled {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  outline: none;
  resize: none;
}

.cds--text-area:disabled::placeholder {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--text-area__wrapper--readonly .cds--text-area {
  background: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--text-area__wrapper--decorator .cds--text-area__inner-wrapper--decorator > *,
.cds--text-area__wrapper--slug .cds--ai-label,
.cds--text-area__wrapper--slug .cds--slug {
  position: absolute;
  inset-block-start: 0.75rem;
  inset-inline-end: 1rem;
}

.cds--text-area__wrapper--decorator .cds--ai-label.cds--ai-label--revert,
.cds--text-area__wrapper--slug .cds--ai-label.cds--ai-label--revert,
.cds--text-area__wrapper--slug .cds--slug.cds--slug--revert {
  inset-block-start: 0.25rem;
  inset-inline-end: 0.5rem;
  transform: translate(0);
}

.cds--text-area__wrapper--decorator .cds--text-area:has(~ .cds--text-area__inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--text-area__inner-wrapper--decorator .cds--ai-label--revert)),
.cds--text-area__wrapper--slug .cds--text-area:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--text-area__wrapper--slug .cds--text-area:has(~ .cds--slug):not(:has(~ .cds--slug--revert)) {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
}

.cds--text-area__wrapper--decorator .cds--text-area:has(~ .cds--text-area__inner-wrapper--decorator > *),
.cds--text-area__wrapper--slug .cds--text-area:has(~ .cds--ai-label),
.cds--text-area__wrapper--slug .cds--text-area:has(~ .cds--slug) {
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}

.cds--text-area--invalid:has(~ .cds--text-area__inner-wrapper--decorator > *),
.cds--text-area--warn:has(~ .cds--text-area__inner-wrapper--decorator > *),
.cds--text-area--invalid:has(~ .cds--ai-label),
.cds--text-area--warn:has(~ .cds--ai-label),
.cds--text-area--invalid:has(~ .cds--slug),
.cds--text-area--warn:has(~ .cds--slug) {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--text-area--invalid ~ .cds--text-area__inner-wrapper--decorator > *,
.cds--text-area--warn ~ .cds--text-area__inner-wrapper--decorator > *,
.cds--text-area--invalid ~ .cds--ai-label,
.cds--text-area--warn ~ .cds--ai-label,
.cds--text-area--invalid ~ .cds--slug,
.cds--text-area--warn ~ .cds--slug {
  inset-inline-end: 2.5rem;
}

.cds--text-area--invalid ~ .cds--text-area__inner-wrapper--decorator > .cds--ai-label.cds--ai-label--revert,
.cds--text-area--warn ~ .cds--text-area__inner-wrapper--decorator > .cds--ai-label.cds--ai-label--revert,
.cds--text-area--invalid ~ .cds--ai-label.cds--ai-label--revert,
.cds--text-area--warn ~ .cds--ai-label.cds--ai-label--revert,
.cds--text-area--invalid ~ .cds--slug.cds--slug--revert,
.cds--text-area--warn ~ .cds--slug.cds--slug--revert {
  inset-inline-end: 2rem;
}

.cds--text-area.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--text-area.cds--skeleton:hover, .cds--text-area.cds--skeleton:focus, .cds--text-area.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--text-area.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--text-area.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--text-area.cds--skeleton {
    background: CanvasText;
  }
  .cds--text-area.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--text-area.cds--skeleton {
  block-size: 6.25rem;
  inline-size: 100%;
}
.cds--text-area.cds--skeleton::placeholder {
  color: transparent;
}

.cds--text-area__label-wrapper {
  position: relative;
  display: flex;
  justify-content: space-between;
  inline-size: 100%;
}

.cds--tag {
  --cds-layout-size-height-xs: 1.125rem;
}
.cds--tag.cds--layout--size-xs, .cds--layout--size-xs :where(.cds--tag) {
  --cds-layout-size-height: var(--cds-layout-size-height-xs);
}
.cds--tag {
  --cds-layout-size-height-sm: 1.125rem;
}
.cds--tag.cds--layout--size-sm, .cds--layout--size-sm :where(.cds--tag) {
  --cds-layout-size-height: var(--cds-layout-size-height-sm);
}
.cds--tag {
  --cds-layout-size-height-md: 1.5rem;
}
.cds--tag.cds--layout--size-md, .cds--layout--size-md :where(.cds--tag) {
  --cds-layout-size-height: var(--cds-layout-size-height-md);
}
.cds--tag {
  --cds-layout-size-height-lg: 2rem;
}
.cds--tag.cds--layout--size-lg, .cds--layout--size-lg :where(.cds--tag) {
  --cds-layout-size-height: var(--cds-layout-size-height-lg);
}
.cds--tag {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  background-color: #e0e0e0;
  background-color: var(--cds-tag-background-gray, #e0e0e0);
  color: #161616;
  color: var(--cds-tag-color-gray, #161616);
}
.cds--tag.cds--tag--operational {
  border: 1px solid #e0e0e0;
  border: 1px solid var(--cds-tag-background-gray, #e0e0e0);
}
.cds--tag.cds--tag--operational:hover {
  background-color: #cacaca;
  background-color: var(--cds-tag-hover-gray, #d1d1d1);
}
.cds--tag .cds--tag__close-icon:hover {
  background-color: #cacaca;
  background-color: var(--cds-tag-hover-gray, #d1d1d1);
}
.cds--tag .cds--definition-term .cds--tag__label {
  color: #161616;
  color: var(--cds-tag-color-gray, #161616);
}
.cds--tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  cursor: default;
  max-inline-size: 13rem;
  min-block-size: var(--cds-layout-size-height-local);
  min-inline-size: 2rem;
  padding-inline: 0.5rem;
  vertical-align: middle;
  word-break: break-word;
}
.cds--tag.cds--tag--lg {
  -webkit-padding-start: 0.75rem;
          padding-inline-start: 0.75rem;
}
.cds--tag:has(.cds--tag__custom-icon) {
  -webkit-padding-start: 0.25rem;
          padding-inline-start: 0.25rem;
}
.cds--tag.cds--tag--lg:not(.cds--tag--filter) {
  padding-inline: 0.75rem;
}
.cds--tag.cds--tag--lg:has(.cds--tag__custom-icon) {
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}
.cds--tag:not(.cds--tag--selectable) {
  border: 0;
}
.cds--tag:not(:first-child) {
  -webkit-margin-start: 0;
          margin-inline-start: 0;
}

.cds--tag--operational > span,
.cds--tag--selectable > span,
.cds--tag__label {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--tag--interactive:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--tag--filter {
  padding-block: 0;
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}
.cds--tag--filter:hover {
  outline: none;
}

.cds--tag--selectable {
  border: 1px solid #161616;
  border: 1px solid var(--cds-border-inverse, #161616);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
}
.cds--tag--selectable:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  outline: none;
}
.cds--tag--selectable:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--tag--selectable-selected {
  background-color: #161616;
  background-color: var(--cds-layer-selected-inverse, #161616);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--tag--selectable-selected:hover {
  background-color: #161616;
  background-color: var(--cds-layer-selected-inverse, #161616);
}

.cds--tag--operational {
  border: 1px solid #a8a8a8;
  border: 1px solid var(--cds-tag-border-gray, #a8a8a8);
  background-color: #e0e0e0;
  background-color: var(--cds-tag-background-gray, #e0e0e0);
  color: #161616;
  color: var(--cds-tag-color-gray, #161616);
  cursor: pointer;
}
.cds--tag--operational:hover {
  background-color: #cacaca;
  background-color: var(--cds-tag-hover-gray, #d1d1d1);
  outline: none;
}
.cds--tag--operational:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1px;
}

.cds--tag--red {
  background-color: #ffd7d9;
  background-color: var(--cds-tag-background-red, #ffd7d9);
  color: #a2191f;
  color: var(--cds-tag-color-red, #a2191f);
}
.cds--tag--red.cds--tag--operational {
  border: 1px solid #ff8389;
  border: 1px solid var(--cds-tag-border-red, #ff8389);
}
.cds--tag--red.cds--tag--operational:hover {
  background-color: #ffc2c5;
  background-color: var(--cds-tag-hover-red, #ffc2c5);
}
.cds--tag--red .cds--tag__close-icon:hover {
  background-color: #ffc2c5;
  background-color: var(--cds-tag-hover-red, #ffc2c5);
}
.cds--tag--red .cds--definition-term .cds--tag__label {
  color: #a2191f;
  color: var(--cds-tag-color-red, #a2191f);
}

.cds--tag--magenta {
  background-color: #ffd6e8;
  background-color: var(--cds-tag-background-magenta, #ffd6e8);
  color: #9f1853;
  color: var(--cds-tag-color-magenta, #9f1853);
}
.cds--tag--magenta.cds--tag--operational {
  border: 1px solid #ff7eb6;
  border: 1px solid var(--cds-tag-border-magenta, #ff7eb6);
}
.cds--tag--magenta.cds--tag--operational:hover {
  background-color: #ffbdda;
  background-color: var(--cds-tag-hover-magenta, #ffbdda);
}
.cds--tag--magenta .cds--tag__close-icon:hover {
  background-color: #ffbdda;
  background-color: var(--cds-tag-hover-magenta, #ffbdda);
}
.cds--tag--magenta .cds--definition-term .cds--tag__label {
  color: #9f1853;
  color: var(--cds-tag-color-magenta, #9f1853);
}

.cds--tag--purple {
  background-color: #e8daff;
  background-color: var(--cds-tag-background-purple, #e8daff);
  color: #6929c4;
  color: var(--cds-tag-color-purple, #6929c4);
}
.cds--tag--purple.cds--tag--operational {
  border: 1px solid #be95ff;
  border: 1px solid var(--cds-tag-border-purple, #be95ff);
}
.cds--tag--purple.cds--tag--operational:hover {
  background-color: #dcc7ff;
  background-color: var(--cds-tag-hover-purple, #dcc7ff);
}
.cds--tag--purple .cds--tag__close-icon:hover {
  background-color: #dcc7ff;
  background-color: var(--cds-tag-hover-purple, #dcc7ff);
}
.cds--tag--purple .cds--definition-term .cds--tag__label {
  color: #6929c4;
  color: var(--cds-tag-color-purple, #6929c4);
}

.cds--tag--blue {
  background-color: #d0e2ff;
  background-color: var(--cds-tag-background-blue, #d0e2ff);
  color: #0043ce;
  color: var(--cds-tag-color-blue, #0043ce);
}
.cds--tag--blue.cds--tag--operational {
  border: 1px solid #78a9ff;
  border: 1px solid var(--cds-tag-border-blue, #78a9ff);
}
.cds--tag--blue.cds--tag--operational:hover {
  background-color: #b8d3ff;
  background-color: var(--cds-tag-hover-blue, #b8d3ff);
}
.cds--tag--blue .cds--tag__close-icon:hover {
  background-color: #b8d3ff;
  background-color: var(--cds-tag-hover-blue, #b8d3ff);
}
.cds--tag--blue .cds--definition-term .cds--tag__label {
  color: #0043ce;
  color: var(--cds-tag-color-blue, #0043ce);
}

.cds--tag--cyan {
  background-color: #bae6ff;
  background-color: var(--cds-tag-background-cyan, #bae6ff);
  color: #00539a;
  color: var(--cds-tag-color-cyan, #00539a);
}
.cds--tag--cyan.cds--tag--operational {
  border: 1px solid #33b1ff;
  border: 1px solid var(--cds-tag-border-cyan, #33b1ff);
}
.cds--tag--cyan.cds--tag--operational:hover {
  background-color: #99daff;
  background-color: var(--cds-tag-hover-cyan, #99daff);
}
.cds--tag--cyan .cds--tag__close-icon:hover {
  background-color: #99daff;
  background-color: var(--cds-tag-hover-cyan, #99daff);
}
.cds--tag--cyan .cds--definition-term .cds--tag__label {
  color: #00539a;
  color: var(--cds-tag-color-cyan, #00539a);
}

.cds--tag--teal {
  background-color: #9ef0f0;
  background-color: var(--cds-tag-background-teal, #9ef0f0);
  color: #005d5d;
  color: var(--cds-tag-color-teal, #005d5d);
}
.cds--tag--teal.cds--tag--operational {
  border: 1px solid #08bdba;
  border: 1px solid var(--cds-tag-border-teal, #08bdba);
}
.cds--tag--teal.cds--tag--operational:hover {
  background-color: #57e5e5;
  background-color: var(--cds-tag-hover-teal, #57e5e5);
}
.cds--tag--teal .cds--tag__close-icon:hover {
  background-color: #57e5e5;
  background-color: var(--cds-tag-hover-teal, #57e5e5);
}
.cds--tag--teal .cds--definition-term .cds--tag__label {
  color: #005d5d;
  color: var(--cds-tag-color-teal, #005d5d);
}

.cds--tag--green {
  background-color: #a7f0ba;
  background-color: var(--cds-tag-background-green, #a7f0ba);
  color: #0e6027;
  color: var(--cds-tag-color-green, #0e6027);
}
.cds--tag--green.cds--tag--operational {
  border: 1px solid #42be65;
  border: 1px solid var(--cds-tag-border-green, #42be65);
}
.cds--tag--green.cds--tag--operational:hover {
  background-color: #74e792;
  background-color: var(--cds-tag-hover-green, #74e792);
}
.cds--tag--green .cds--tag__close-icon:hover {
  background-color: #74e792;
  background-color: var(--cds-tag-hover-green, #74e792);
}
.cds--tag--green .cds--definition-term .cds--tag__label {
  color: #0e6027;
  color: var(--cds-tag-color-green, #0e6027);
}

.cds--tag--gray {
  background-color: #e0e0e0;
  background-color: var(--cds-tag-background-gray, #e0e0e0);
  color: #161616;
  color: var(--cds-tag-color-gray, #161616);
}
.cds--tag--gray.cds--tag--operational {
  border: 1px solid #a8a8a8;
  border: 1px solid var(--cds-tag-border-gray, #a8a8a8);
}
.cds--tag--gray.cds--tag--operational:hover {
  background-color: #cacaca;
  background-color: var(--cds-tag-hover-gray, #d1d1d1);
}
.cds--tag--gray .cds--tag__close-icon:hover {
  background-color: #cacaca;
  background-color: var(--cds-tag-hover-gray, #d1d1d1);
}
.cds--tag--gray .cds--definition-term .cds--tag__label {
  color: #161616;
  color: var(--cds-tag-color-gray, #161616);
}

.cds--tag--cool-gray {
  background-color: #dde1e6;
  background-color: var(--cds-tag-background-cool-gray, #dde1e6);
  color: #121619;
  color: var(--cds-tag-color-cool-gray, #121619);
}
.cds--tag--cool-gray.cds--tag--operational {
  border: 1px solid #a2a9b0;
  border: 1px solid var(--cds-tag-border-cool-gray, #a2a9b0);
}
.cds--tag--cool-gray.cds--tag--operational:hover {
  background-color: #cdd3da;
  background-color: var(--cds-tag-hover-cool-gray, #cdd3da);
}
.cds--tag--cool-gray .cds--tag__close-icon:hover {
  background-color: #cdd3da;
  background-color: var(--cds-tag-hover-cool-gray, #cdd3da);
}
.cds--tag--cool-gray .cds--definition-term .cds--tag__label {
  color: #121619;
  color: var(--cds-tag-color-cool-gray, #121619);
}

.cds--tag--warm-gray {
  background-color: #e5e0df;
  background-color: var(--cds-tag-background-warm-gray, #e5e0df);
  color: #171414;
  color: var(--cds-tag-color-warm-gray, #171414);
}
.cds--tag--warm-gray.cds--tag--operational {
  border: 1px solid #ada8a8;
  border: 1px solid var(--cds-tag-border-warm-gray, #ada8a8);
}
.cds--tag--warm-gray.cds--tag--operational:hover {
  background-color: #d8d0cf;
  background-color: var(--cds-tag-hover-warm-gray, #d8d0cf);
}
.cds--tag--warm-gray .cds--tag__close-icon:hover {
  background-color: #d8d0cf;
  background-color: var(--cds-tag-hover-warm-gray, #d8d0cf);
}
.cds--tag--warm-gray .cds--definition-term .cds--tag__label {
  color: #171414;
  color: var(--cds-tag-color-warm-gray, #171414);
}

.cds--tag--high-contrast:not(.cds--tag--operational) {
  background-color: #393939;
  background-color: var(--cds-background-inverse, #393939);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational {
  border: 1px solid #393939;
  border: 1px solid var(--cds-background-inverse, #393939);
}
.cds--tag--high-contrast:not(.cds--tag--operational).cds--tag--operational:hover {
  background-color: #474747;
  background-color: var(--cds-background-inverse-hover, #474747);
}
.cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover {
  background-color: #474747;
  background-color: var(--cds-background-inverse-hover, #474747);
}
.cds--tag--high-contrast:not(.cds--tag--operational) .cds--definition-term .cds--tag__label {
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}

.cds--multi-select--readonly .cds--tag--high-contrast:not(.cds--tag--operational) .cds--tag__close-icon:hover {
  background-color: transparent;
}

.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational {
  border: 1px solid #ffffff;
  border: 1px solid var(--cds-background, #ffffff);
}
.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]).cds--tag--operational:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--tag__close-icon:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) .cds--definition-term .cds--tag__label {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tag--outline:not(.cds--tag--operational):not(span):not([disabled]) {
  outline: 1px solid #393939;
  outline: 1px solid var(--cds-background-inverse, #393939);
  outline-offset: -1px;
}

.cds--tag--disabled:not(.cds--tag--operational),
.cds--tag--filter.cds--tag--disabled,
.cds--tag--interactive.cds--tag--disabled {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational,
.cds--tag--filter.cds--tag--disabled.cds--tag--operational,
.cds--tag--interactive.cds--tag--disabled.cds--tag--operational {
  border: 1px solid #f4f4f4;
  border: 1px solid var(--cds-layer);
}
.cds--tag--disabled:not(.cds--tag--operational).cds--tag--operational:hover,
.cds--tag--filter.cds--tag--disabled.cds--tag--operational:hover,
.cds--tag--interactive.cds--tag--disabled.cds--tag--operational:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}
.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__close-icon:hover,
.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover,
.cds--tag--interactive.cds--tag--disabled .cds--tag__close-icon:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}
.cds--tag--disabled:not(.cds--tag--operational) .cds--definition-term .cds--tag__label,
.cds--tag--filter.cds--tag--disabled .cds--definition-term .cds--tag__label,
.cds--tag--interactive.cds--tag--disabled .cds--definition-term .cds--tag__label {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--tag--disabled:not(.cds--tag--operational),
.cds--tag--filter.cds--tag--disabled,
.cds--tag--interactive.cds--tag--disabled {
  box-shadow: none;
  outline: none;
}
.cds--tag--disabled:not(.cds--tag--operational):hover,
.cds--tag--filter.cds--tag--disabled:hover,
.cds--tag--interactive.cds--tag--disabled:hover {
  cursor: not-allowed;
}
.cds--tag--disabled:not(.cds--tag--operational) .cds--tag__label,
.cds--tag--filter.cds--tag--disabled .cds--tag__label,
.cds--tag--interactive.cds--tag--disabled .cds--tag__label {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--tag--selectable.cds--tag--disabled,
.cds--tag--operational.cds--tag--disabled {
  border: 1px solid #c6c6c6;
  border: 1px solid var(--cds-border-disabled, #c6c6c6);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--tag--selectable.cds--tag--disabled:hover,
.cds--tag--operational.cds--tag--disabled:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: not-allowed;
}

.cds--tag--interactive {
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--tag__close-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 50%;
  margin: 0 0 0 0.125rem;
  background-color: transparent;
  block-size: var(--cds-layout-size-height-local);
  color: currentColor;
  cursor: pointer;
  inline-size: var(--cds-layout-size-height-local);
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), box-shadow 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tag__close-icon svg {
  fill: currentColor;
}

.cds--tag__custom-icon {
  flex-shrink: 0;
  padding: 0;
  border: 0;
  background-color: transparent;
  block-size: 1rem;
  color: currentColor;
  inline-size: 1rem;
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
  outline: none;
}
.cds--tag__custom-icon svg {
  fill: currentColor;
}

.cds--tag--disabled .cds--tag__close-icon {
  cursor: not-allowed;
}

.cds--tag__close-icon:focus {
  z-index: 99999;
  border-radius: 50%;
  box-shadow: inset 0 0 0 1px var(--color-primary);
  box-shadow: inset 0 0 0 1px var(--cds-focus, #0f62fe);
  outline: none;
}

.cds--tag--high-contrast .cds--tag__close-icon:focus {
  box-shadow: inset 0 0 0 1px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-focus-inverse, #ffffff);
}

.cds--tag--filter.cds--tag--disabled .cds--tag__close-icon:hover {
  background-color: transparent;
}

.cds--tag--filter.cds--tag--disabled svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--tag--sm.cds--tag--filter {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}

.cds--tag--sm .cds--tag__close-icon {
  -webkit-margin-start: 0.3125rem;
          margin-inline-start: 0.3125rem;
}

.cds--tag.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--tag.cds--skeleton:hover, .cds--tag.cds--skeleton:focus, .cds--tag.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--tag.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--tag.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tag.cds--skeleton {
    background: CanvasText;
  }
  .cds--tag.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--tag.cds--skeleton {
  background-color: #e8e8e8;
  background-color: var(--cds-skeleton-background, #e8e8e8);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tag.cds--skeleton.cds--tag--operational {
  border: 1px solid #e8e8e8;
  border: 1px solid var(--cds-skeleton-background, #e8e8e8);
}
.cds--tag.cds--skeleton.cds--tag--operational:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-skeleton-background, #e8e8e8);
}
.cds--tag.cds--skeleton .cds--tag__close-icon:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-skeleton-background, #e8e8e8);
}
.cds--tag.cds--skeleton .cds--definition-term .cds--tag__label {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tag.cds--skeleton {
  overflow: hidden;
  inline-size: 3.75rem;
}
@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
  .cds--tag.cds--skeleton {
    transform: translateZ(0);
  }
}

.cds--tag .cds--ai-label .cds--ai-label__button--inline,
.cds--tag .cds--slug .cds--slug__button--inline {
  color: currentColor;
  -webkit-margin-start: 0.0625rem;
          margin-inline-start: 0.0625rem;
}

.cds--tag .cds--ai-label .cds--ai-label__button--inline .cds--ai-label__text::before,
.cds--tag .cds--slug .cds--slug__button--inline .cds--slug__text::before {
  background-color: currentColor;
}

.cds--tag .cds--ai-label .cds--ai-label__button--inline:hover,
.cds--tag .cds--slug .cds--slug__button--inline:hover {
  border-color: currentColor;
}

.cds--tag--filter .cds--tag__decorator > *,
.cds--tag--filter .cds--ai-label,
.cds--tag--filter .cds--slug {
  min-inline-size: 2.00875rem;
}

.cds--tag .cds--tag__decorator:not(:has(.cds--ai-label)) {
  block-size: 1rem;
  text-align: center;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tag {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tag__close-icon:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--tag-label-tooltip {
  max-inline-size: -webkit-fill-available;
}

.cds--tag__custom-icon + .cds--tag-label-tooltip {
  max-inline-size: 11rem;
}

.cds--tag--filter .cds--tag__custom-icon + .cds--tag-label-tooltip {
  max-inline-size: 9.875rem;
}

.cds--interactive--tag-children {
  display: inline-flex;
  max-inline-size: 12.5rem;
  place-items: center;
}

.cds--tag--filter .cds--tag__custom-icon + span > .cds--interactive--tag-children {
  max-inline-size: 11.5rem;
}

.cds--tag .cds--definition-term {
  -webkit-border-after: none;
  border-block-end: none;
  cursor: default;
  max-inline-size: 12rem;
}

.cds--tag .cds--tag__custom-icon + span > .cds--definition-term {
  max-inline-size: 11rem;
}

.cds--tag > .cds--popover-container {
  display: flex;
}

.cds--toggletip-button:has(.cds--tag--operational.cds--tag--disabled) {
  pointer-events: none;
}

.cds--list-box__wrapper {
  display: block;
}

.cds--list-box__wrapper--inline {
  display: inline-grid;
  align-items: center;
  grid-gap: 0.25rem;
  grid-template: auto auto/auto auto;
}
.cds--list-box__wrapper--inline .cds--label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
.cds--list-box__wrapper--inline .cds--label,
.cds--list-box__wrapper--inline .cds--form__helper-text,
.cds--list-box__wrapper--inline .cds--form-requirement {
  margin: 0;
}
.cds--list-box__wrapper--inline .cds--form__helper-text {
  max-inline-size: none;
}
.cds--list-box__wrapper--inline .cds--form-requirement {
  grid-column: 2;
}

.cds--list-box html {
  font-size: 100%;
}
.cds--list-box body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--list-box code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--list-box strong {
  font-weight: 600;
}
.cds--list-box {
  position: relative;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
  inline-size: 100%;
  max-block-size: 2.5rem;
  transition: all 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--list-box:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--multi-select.cds--multi-select--readonly.cds--list-box {
  cursor: default;
}

.cds--list-box--lg {
  block-size: 3rem;
  max-block-size: 3rem;
}

.cds--list-box--sm {
  block-size: 2rem;
  max-block-size: 2rem;
}

.cds--list-box--expanded {
  border-block-end-color: #c6c6c6;
  border-block-end-color: var(--cds-border-subtle-01, #c6c6c6);
}

.cds--layer-two .cds--list-box--expanded {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--list-box--expanded {
  border-block-end-color: #c6c6c6;
  border-block-end-color: var(--cds-border-subtle-03, #c6c6c6);
}

.cds--list-box--expanded:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}

.cds--list-box--expanded:hover.cds--list-box--light:hover {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--list-box .cds--text-input {
  block-size: 100%;
  min-inline-size: 0;
}

.cds--list-box__invalid-icon {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 50%;
  inset-inline-end: 2.5rem;
  transform: translateY(-50%);
}

.cds--list-box__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--list-box__invalid-icon--warning path[fill] {
  fill: #000000;
  opacity: 1;
}

.cds--list-box[data-invalid] .cds--list-box__field,
.cds--list-box.cds--list-box--warning .cds--list-box__field {
  -webkit-border-after: 0;
          border-block-end: 0;
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field,
.cds--list-box.cds--list-box--warning.cds--list-box--inline .cds--list-box__field {
  -webkit-padding-end: 3.5rem;
          padding-inline-end: 3.5rem;
}

.cds--list-box--light {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}
.cds--list-box--light:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--list-box--light .cds--list-box__menu {
  background: #f4f4f4;
  background: var(--cds-layer);
}

.cds--list-box--light .cds--list-box__menu-item__option {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle);
}

.cds--list-box--light.cds--list-box--expanded {
  border-block-end-color: transparent;
}

.cds--list-box--disabled:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}

.cds--list-box--light.cds--list-box--disabled {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--list-box--disabled,
.cds--list-box--disabled .cds--list-box__field,
.cds--list-box--disabled .cds--list-box__field:focus {
  border-block-end-color: transparent;
  outline: none;
}

.cds--list-box--disabled .cds--list-box__label,
.cds--list-box--disabled.cds--list-box--inline .cds--list-box__label {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--list-box--disabled .cds--list-box__menu-icon > svg,
.cds--list-box--disabled .cds--list-box__selection > svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--list-box--disabled,
.cds--list-box--disabled .cds--list-box__field,
.cds--list-box--disabled .cds--list-box__menu-icon {
  cursor: not-allowed;
}

.cds--list-box--disabled .cds--list-box__menu-item,
.cds--list-box--disabled .cds--list-box__menu-item:hover,
.cds--list-box--disabled .cds--list-box__menu-item--highlighted {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  text-decoration: none;
}

.cds--list-box--disabled .cds--list-box__selection:hover {
  cursor: not-allowed;
}

.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field {
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--list-box--disabled.cds--list-box[data-invalid].cds--list-box--inline .cds--list-box__field {
  -webkit-padding-end: 2rem;
          padding-inline-end: 2rem;
}

.cds--list-box.cds--list-box--inline {
  border-width: 0;
  background-color: transparent;
}
.cds--list-box.cds--list-box--inline:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--list-box.cds--list-box--inline.cds--list-box--expanded {
  border-block-end-width: 0;
}

.cds--list-box.cds--list-box--inline.cds--list-box--expanded .cds--list-box__field[aria-expanded=true] {
  border-width: 0;
}

.cds--list-box.cds--list-box--inline.cds--list-box--expanded:hover,
.cds--list-box.cds--list-box--inline.cds--list-box--disabled:hover {
  background-color: transparent;
}

.cds--list-box.cds--list-box--inline .cds--list-box__field {
  padding: 0 2rem 0 0.5rem;
}

.cds--list-box.cds--list-box--inline .cds--list-box__menu-icon {
  inset-inline-end: 0.5rem;
}

.cds--list-box.cds--list-box--inline .cds--list-box__invalid-icon {
  inset-inline-end: 2rem;
}

.cds--list-box--inline .cds--list-box__label {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box--inline .cds--list-box__field {
  block-size: 100%;
}

.cds--dropdown--inline .cds--list-box__field {
  max-inline-size: 30rem;
}

.cds--dropdown--inline .cds--list-box__menu {
  max-inline-size: 30rem;
  min-inline-size: 18rem;
}

.cds--list-box__field {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--list-box__field *,
.cds--list-box__field *::before,
.cds--list-box__field *::after {
  box-sizing: inherit;
}
.cds--list-box__field::-moz-focus-inner {
  border: 0;
}
.cds--list-box__field {
  position: relative;
  display: inline-flex;
  overflow: hidden;
  align-items: center;
  block-size: calc(100% + 1px);
  cursor: pointer;
  outline: none;
  padding-block: 0;
  padding-inline: 1rem 3rem;
  text-overflow: ellipsis;
  vertical-align: top;
  white-space: nowrap;
}

.cds--list-box__field:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--list-box__field:focus {
    outline-style: dotted;
  }
}

.cds--list-box__field[disabled] {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}

.cds--list-box__field .cds--text-input {
  -webkit-padding-end: 4.375rem;
          padding-inline-end: 4.375rem;
}

.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input,
.cds--list-box--warning .cds--list-box__field .cds--text-input {
  -webkit-padding-end: 6.5625rem;
          padding-inline-end: 6.5625rem;
}

.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input + .cds--list-box__invalid-icon,
.cds--list-box--warning .cds--list-box__field .cds--text-input + .cds--list-box__invalid-icon {
  inset-inline-end: 5.125rem;
}

.cds--list-box__field .cds--text-input--empty {
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty,
.cds--list-box--warning .cds--list-box__field .cds--text-input--empty {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--list-box[data-invalid] .cds--list-box__field .cds--text-input--empty + .cds--list-box__invalid-icon,
.cds--list-box--warning .cds--list-box__field .cds--text-input--empty + .cds--list-box__invalid-icon {
  inset-inline-end: 2.5rem;
}

.cds--list-box__label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  overflow: hidden;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  text-overflow: ellipsis;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

.cds--list-box__menu-icon {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--list-box__menu-icon *,
.cds--list-box__menu-icon *::before,
.cds--list-box__menu-icon *::after {
  box-sizing: inherit;
}
.cds--list-box__menu-icon::-moz-focus-inner {
  border: 0;
}
.cds--list-box__menu-icon {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 1.5rem;
  cursor: pointer;
  inline-size: 1.5rem;
  inset-inline-end: 0.75rem;
  outline: none;
  transition: transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--list-box__menu-icon > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--list-box__menu-icon--open {
  justify-content: center;
  inline-size: 1.5rem;
  transform: rotate(180deg);
}

.cds--list-box__selection {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--list-box__selection *,
.cds--list-box__selection *::before,
.cds--list-box__selection *::after {
  box-sizing: inherit;
}
.cds--list-box__selection::-moz-focus-inner {
  border: 0;
}
.cds--list-box__selection {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 1.5rem;
  cursor: pointer;
  inline-size: 1.5rem;
  inset-block-start: 50%;
  /* to preserve .5rem space between icons according to spec top/transform used to center the combobox clear selection icon in IE11 */
  inset-inline-end: 2.8125rem;
  transform: translateY(-50%);
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  -webkit-user-select: none;
          user-select: none;
}
.cds--list-box__selection:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--list-box__selection:focus {
    outline-style: dotted;
  }
}
.cds--list-box__selection:focus:hover {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--list-box__selection:focus:hover {
    outline-style: dotted;
  }
}

.cds--list-box__selection > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--list-box--disabled .cds--list-box__selection:focus {
  outline: none;
}

.cds--list-box__selection--multi {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  position: static;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 0.75rem;
  background-color: #393939;
  background-color: var(--cds-background-inverse, #393939);
  block-size: 1.5rem;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: auto;
  inset-block-start: auto;
  line-height: 0;
  -webkit-margin-end: 0.625rem;
          margin-inline-end: 0.625rem;
  -webkit-padding-end: 0.125rem;
          padding-inline-end: 0.125rem;
  transform: none;
}

.cds--list-box__selection--multi > svg {
  padding: 0.125rem;
  block-size: 1.25rem;
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
  inline-size: 1.25rem;
  -webkit-margin-start: 0.25rem;
          margin-inline-start: 0.25rem;
}
.cds--list-box__selection--multi > svg:hover {
  border-radius: 50%;
  background-color: #474747;
  background-color: var(--cds-button-secondary-hover, #474747);
}

.cds--list-box--disabled .cds--list-box__selection--multi {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  color: #f4f4f4;
  color: var(--cds-layer);
}
.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational {
  border: 1px solid rgba(22, 22, 22, 0.25);
  border: 1px solid var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--list-box--disabled .cds--list-box__selection--multi.cds--tag--operational:hover {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--list-box--disabled .cds--list-box__selection--multi .cds--tag__close-icon:hover {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--list-box--disabled .cds--list-box__selection--multi .cds--definition-term .cds--tag__label {
  color: #f4f4f4;
  color: var(--cds-layer);
}
.cds--list-box--disabled .cds--list-box__selection--multi > svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--list-box--disabled .cds--list-box__selection--multi > svg:hover {
  background-color: transparent;
  background-color: initial;
}

.cds--list-box__selection--multi:hover {
  outline: none;
}

.cds--list-box__menu {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  position: absolute;
  z-index: 9100;
  display: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
  inset-inline: 0;
  overflow-y: auto;
  transition: max-height 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--list-box__menu:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--list-box__menu:focus {
    outline-style: dotted;
  }
}

.cds--autoalign .cds--list-box__menu {
  inset-inline: auto;
}

.cds--list-box .cds--list-box__field[aria-expanded=false] .cds--list-box__menu {
  display: none;
  max-block-size: 0;
  visibility: hidden;
}

.cds--list-box--expanded .cds--list-box__menu {
  display: block;
  max-block-size: 13.75rem;
}

.cds--list-box--expanded.cds--list-box--lg .cds--list-box__menu {
  max-block-size: 16.5rem;
}

.cds--list-box--expanded.cds--list-box--sm .cds--list-box__menu {
  max-block-size: 11rem;
}

.cds--list-box__menu-item {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  block-size: 2.5rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  cursor: pointer;
  transition: background 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  -webkit-user-select: none;
          user-select: none;
}
.cds--list-box__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--list-box__menu-item:active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}

.cds--list-box--light .cds--list-box__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--list-box--sm .cds--list-box__menu-item {
  block-size: 2rem;
}

.cds--list-box--lg .cds--list-box__menu-item {
  block-size: 3rem;
}

.cds--list-box--disabled .cds--list-box__menu-item:hover {
  background-color: transparent;
}

.cds--list-box--light .cds--list-box__menu-item:active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}

.cds--list-box--disabled .cds--list-box__menu-item__option:hover {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-01, #c6c6c6);
}

.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item__option:hover {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item__option:hover {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-03, #c6c6c6);
}

.cds--list-box__menu-item:first-of-type .cds--list-box__menu-item__option {
  border-block-start-color: transparent;
}

.cds--list-box__menu-item:hover .cds--list-box__menu-item__option {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box--disabled .cds--list-box__menu-item:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-01, #c6c6c6);
}

.cds--layer-two .cds--list-box--disabled .cds--list-box__menu-item:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--list-box--disabled .cds--list-box__menu-item:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-03, #c6c6c6);
}

.cds--layer-two .cds--list-box__menu-item__option {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--list-box__menu-item__option {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-03, #c6c6c6);
}

.cds--list-box__menu-item__option {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--list-box__menu-item__option *,
.cds--list-box__menu-item__option *::before,
.cds--list-box__menu-item__option *::after {
  box-sizing: inherit;
}
.cds--list-box__menu-item__option {
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: block;
  overflow: hidden;
  padding: 0.6875rem 0;
  margin: 0 1rem;
  block-size: 2.5rem;
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  -webkit-border-before: 1px solid transparent;
          border-block-start: 1px solid transparent;
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-01, #c6c6c6);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-weight: normal;
  line-height: 1rem;
  -webkit-padding-end: 1.5rem;
          padding-inline-end: 1.5rem;
  text-decoration: none;
  text-overflow: ellipsis;
  transition: border-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  white-space: nowrap;
}
.cds--list-box__menu-item__option:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--list-box__menu-item__option:focus {
    outline-style: dotted;
  }
}
.cds--list-box__menu-item__option:focus {
  padding: 0.6875rem 1rem;
  border-color: transparent;
  margin: 0;
}
.cds--list-box__menu-item__option:hover {
  border-color: transparent;
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box--sm .cds--list-box__menu-item__option {
  block-size: 2rem;
  padding-block: 0.4375rem 0.4375rem;
}

.cds--list-box--lg .cds--list-box__menu-item__option {
  block-size: 3rem;
  padding-block: 0.9375rem 0.9375rem;
}

.cds--list-box--disabled .cds--list-box__menu-item:hover .cds--list-box__menu-item__option,
.cds--list-box--disabled .cds--list-box__menu-item__option {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--list-box__menu-item[disabled],
.cds--list-box__menu-item[disabled] *,
.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,
.cds--list-box__menu-item[disabled]:hover {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  outline: none;
}

.cds--list-box__menu-item[disabled]:hover {
  background-color: revert;
}

.cds--list-box__menu-item[disabled] .cds--checkbox-label::before {
  border-color: rgba(22, 22, 22, 0.25);
  border-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,
.cds--list-box__menu-item[disabled]:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-01, #c6c6c6);
}

.cds--layer-two .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,
.cds--layer-two .cds--list-box__menu-item[disabled]:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,
.cds--layer-three .cds--list-box__menu-item[disabled]:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: #c6c6c6;
  border-block-start-color: var(--cds-border-subtle-03, #c6c6c6);
}

.cds--list-box__menu-item--active + .cds--list-box__menu-item[disabled] .cds--list-box__menu-item__option,
.cds--list-box__menu-item:hover + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: transparent;
}

.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option {
  margin: 0 0.5rem;
}
.cds--list-box.cds--list-box--inline .cds--list-box__menu-item__option:focus {
  margin: 0;
  padding-inline: 0.5rem 0.5rem;
}

.cds--list-box__menu-item--highlighted {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--list-box__menu-item--highlighted {
    outline-style: dotted;
  }
}
.cds--list-box__menu-item--highlighted {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option,
.cds--list-box__menu-item--highlighted + .cds--list-box__menu-item .cds--list-box__menu-item__option {
  border-block-start-color: transparent;
}

.cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box__menu-item--active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-layer-selected);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box--light .cds--list-box__menu-item--active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-layer-selected);
}

.cds--list-box__menu-item--active:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
  border-block-end-color: #d1d1d1;
  border-block-end-color: var(--cds-layer-selected-hover);
}

.cds--list-box__menu-item--active .cds--list-box__menu-item__option {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--list-box__menu-item--active + .cds--list-box__menu-item > .cds--list-box__menu-item__option {
  border-block-start-color: transparent;
}

.cds--list-box__menu-item__selected-icon {
  position: absolute;
  display: none;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--list-box--inline .cds--list-box__menu-item__selected-icon {
  inset-inline-end: 0.5rem;
}

.cds--list-box__menu-item--active .cds--list-box__menu-item__selected-icon {
  display: block;
}

.cds--list-box__menu-item .cds--checkbox-label {
  inline-size: 100%;
}

.cds--list-box__menu-item .cds--checkbox-label-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--list-box--up .cds--list-box__menu {
  inset-block-end: 2.5rem;
}

.cds--list-box--up.cds--dropdown--sm .cds--list-box__menu,
.cds--list-box--up.cds--list-box--sm .cds--list-box__menu,
.cds--list-box--up .cds--list-box--sm .cds--list-box__menu {
  inset-block-end: 2rem;
}

.cds--list-box--up.cds--dropdown--lg .cds--list-box__menu,
.cds--list-box--up.cds--list-box--lg .cds--list-box__menu,
.cds--list-box--up .cds--list-box--lg .cds--list-box__menu {
  inset-block-end: 3rem;
}

.cds--list-box .cds--text-input {
  background-color: inherit;
  min-inline-size: 0;
  text-overflow: ellipsis;
}

.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator > *,
.cds--list-box__wrapper--slug .cds--ai-label,
.cds--list-box__wrapper--slug .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: calc(2.5rem + 9px);
  -webkit-margin-before: 0.03125rem;
          margin-block-start: 0.03125rem;
  transform: translateY(-50%);
}

.cds--list-box__wrapper--decorator:has(.cds--list-box__invalid-icon) .cds--list-box__inner-wrapper--decorator > *::before,
.cds--list-box__wrapper--slug:has(.cds--list-box__invalid-icon) .cds--ai-label::before,
.cds--list-box__wrapper--slug:has(.cds--list-box__invalid-icon) .cds--slug::before,
.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator > *::after,
.cds--list-box__wrapper--slug .cds--ai-label::after,
.cds--list-box__wrapper--slug .cds--slug::after {
  position: absolute;
  background-color: #c6c6c6;
  background-color: var(--cds-border-subtle-01, #c6c6c6);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator > *::before,
.cds--list-box__wrapper--slug .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--slug::before {
  display: none;
  inset-inline-start: -0.5625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator > *::before,
.cds--list-box__wrapper--slug .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--slug::before,
.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert::before,
.cds--list-box__wrapper--slug .cds--ai-label--revert::before,
.cds--list-box__wrapper--slug .cds--slug--revert::before,
.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator > *::after,
.cds--list-box__wrapper--slug .cds--ai-label::after,
.cds--list-box__wrapper--slug .cds--slug::after {
  display: block;
  inset-block-start: 0.0625rem;
  inset-inline-end: -0.5625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert::before,
.cds--list-box__wrapper--slug .cds--ai-label--revert::before,
.cds--list-box__wrapper--slug .cds--slug--revert::before,
.cds--list-box__wrapper--decorator .cds--list-box__inner-wrapper--decorator .cds--ai-label--revert::after,
.cds--list-box__wrapper--slug .cds--ai-label--revert::after,
.cds--list-box__wrapper--slug .cds--slug--revert::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -0.0625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label):not(:has(.cds--list-box__inner-wrapper--decorator .cds--ai-label--revert)),
.cds--list-box__wrapper--slug .cds--list-box:has(.cds--ai-label):not(:has(.cds--ai-label--revert)),
.cds--list-box__wrapper--slug .cds--list-box:has(.cds--slug):not(:has(.cds--slug--revert)) {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
}

.cds--list-box__wrapper--decorator .cds--list-box input[role=combobox],
.cds--list-box__wrapper--slug .cds--list-box input[role=combobox] {
  border-block-end-color: transparent;
}

.cds--list-box__wrapper--decorator .cds--list-box__field,
.cds--list-box__wrapper--decorator .cds--text-input--empty,
.cds--list-box__wrapper--slug .cds--list-box__field,
.cds--list-box__wrapper--slug .cds--text-input--empty {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--list-box__wrapper--decorator .cds--text-input:not(.cds--text-input--empty),
.cds--list-box__wrapper--slug .cds--text-input:not(.cds--text-input--empty) {
  -webkit-padding-end: 6.5625rem;
          padding-inline-end: 6.5625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty,
.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__field,
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input--empty,
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__field,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input--empty,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field {
  -webkit-padding-end: 6rem;
          padding-inline-end: 6rem;
}

.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty),
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input:not(.cds--text-input--empty),
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--text-input:not(.cds--text-input--empty) {
  -webkit-padding-end: 8.5625rem;
          padding-inline-end: 8.5625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--text-input--empty + .cds--list-box__invalid-icon,
.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--text-input--empty + .cds--list-box__invalid-icon,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--list-box__invalid-icon,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__invalid-icon.cds--list-box__invalid-icon--warning {
  inset-inline-end: 5.0625rem;
}

.cds--list-box__wrapper--decorator .cds--list-box--invalid[data-invalid] > *::before,
.cds--list-box__wrapper--decorator .cds--list-box--warning > *::before,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--ai-label::before,
.cds--list-box__wrapper--slug .cds--list-box--invalid[data-invalid] .cds--slug::before,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--slug::before {
  display: block;
}

.cds--list-box__wrapper--decorator .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--list-box__inner-wrapper--decorator .cds--ai-label,
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--list-box__inner-wrapper--decorator .cds--ai-label,
.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--ai-label,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--ai-label,
.cds--list-box__wrapper--slug .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--slug,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--slug {
  inset-inline-end: calc(4rem + 18px);
}

.cds--list-box__wrapper--decorator .cds--list-box__field:has(.cds--list-box__selection) ~ .cds--list-box__inner-wrapper--decorator > * {
  inset-inline-end: calc(4rem + 18px);
}

.cds--list-box__wrapper--decorator .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,
.cds--list-box__wrapper--decorator .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,
.cds--list-box__wrapper--slug .cds--list-box--invalid .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon,
.cds--list-box__wrapper--slug .cds--list-box--warning .cds--list-box__field:has(.cds--list-box__selection) .cds--list-box__invalid-icon {
  inset-inline-end: 7.125rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--list-box__field,
  .cds--list-box__menu,
  .cds--multi-select .cds--tag--filter {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--list-box__field:focus,
  .cds--multi-select .cds--tag__close-icon:focus,
  .cds--list-box__menu-item--highlighted .cds--list-box__menu-item__option {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection::after {
  position: absolute;
  background-color: #c6c6c6;
  background-color: var(--cds-border-subtle-01, #c6c6c6);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
  -webkit-margin-start: 2.0625rem;
          margin-inline-start: 2.0625rem;
}

.cds--list-box--warning .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection::before,
.cds--list-box--invalid[data-invalid] .cds--list-box__field:has(.cds--list-box__menu-icon) .cds--list-box__selection::before {
  position: absolute;
  background-color: #c6c6c6;
  background-color: var(--cds-border-subtle-01, #c6c6c6);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
  -webkit-margin-end: 2.0625rem;
          margin-inline-end: 2.0625rem;
}

.cds--list-box__wrapper--decorator:has(.cds--multi-select) .cds--list-box__menu-icon,
.cds--list-box__wrapper--slug:has(.cds--multi-select) .cds--list-box__menu-icon {
  inset-inline-end: 0.75rem;
}

.cds--list-box__wrapper--decorator:has(.cds--dropdown) .cds--list-box__menu-icon,
.cds--list-box__wrapper--slug:has(.cds--dropdown) .cds--list-box__menu-icon {
  inset-inline-end: 0.75rem;
}

.cds--dropdown__wrapper--inline {
  display: inline-grid;
  align-items: center;
  grid-gap: 0 1.5rem;
  grid-template: auto/auto -webkit-min-content;
  grid-template: auto/auto min-content;
}
.cds--dropdown__wrapper--inline:has(.cds--label.cds--visually-hidden) {
  grid-template: auto/auto;
}
.cds--dropdown__wrapper--inline .cds--label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
.cds--dropdown__wrapper--inline .cds--label,
.cds--dropdown__wrapper--inline .cds--form__helper-text,
.cds--dropdown__wrapper--inline .cds--form-requirement {
  margin: 0;
}
.cds--dropdown__wrapper--inline .cds--form-requirement {
  grid-column: 2;
}

.cds--dropdown html {
  font-size: 100%;
}
.cds--dropdown body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--dropdown code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--dropdown strong {
  font-weight: 600;
}
.cds--dropdown {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: relative;
  display: block;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
  inline-size: 100%;
  list-style: none;
  outline: 2px solid transparent;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--dropdown:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--dropdown .cds--list-box__field {
  text-align: start;
}

.cds--dropdown--lg {
  block-size: 3rem;
  max-block-size: 3rem;
}

.cds--dropdown--lg .cds--dropdown__arrow {
  inset-block-start: 1rem;
}

.cds--dropdown--sm {
  block-size: 2rem;
  max-block-size: 2rem;
}

.cds--dropdown--sm .cds--dropdown__arrow {
  inset-block-start: 0.5rem;
}

.cds--dropdown--open {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--dropdown--open .cds--list-box__field {
  outline: none;
}

.cds--dropdown--focus .cds--list-box__field {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--dropdown--focus .cds--list-box__field {
    outline-style: dotted;
  }
}

.cds--dropdown--invalid {
  outline: 2px solid #da1e28;
  outline: 2px solid var(--cds-support-error, #da1e28);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--dropdown--invalid {
    outline-style: dotted;
  }
}
.cds--dropdown--invalid .cds--dropdown-text {
  -webkit-padding-end: 3.5rem;
          padding-inline-end: 3.5rem;
}
.cds--dropdown--invalid + .cds--form-requirement {
  display: inline-block;
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
  max-block-size: 12.5rem;
}

.cds--dropdown__invalid-icon {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 50%;
  inset-inline-end: 2.5rem;
  transform: translateY(-50%);
}

.cds--dropdown--open:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}

.cds--dropdown--open:focus {
  outline: 1px solid transparent;
}

.cds--dropdown--open .cds--dropdown-list {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  max-block-size: 13.75rem;
  transition: max-height 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--dropdown--light {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}
.cds--dropdown--light:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--dropdown--up .cds--dropdown-list {
  inset-block-end: 2rem;
}

.cds--dropdown__arrow {
  position: absolute;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inset-block-start: 0.8125rem;
  inset-inline-end: 1rem;
  pointer-events: none;
  transform-origin: 50% 45%;
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

button.cds--dropdown-text {
  border: none;
  background: none;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  text-align: start;
}
button.cds--dropdown-text:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  button.cds--dropdown-text:focus {
    outline-style: dotted;
  }
}

.cds--dropdown-text {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: block;
  overflow: hidden;
  block-size: calc(100% + 1px);
  padding-inline: 1rem 2.625rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--dropdown-list html {
  font-size: 100%;
}
.cds--dropdown-list body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--dropdown-list code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--dropdown-list strong {
  font-weight: 600;
}
.cds--dropdown-list {
  outline: 2px solid transparent;
  outline-offset: -2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: absolute;
  z-index: 9100;
  display: flex;
  overflow: hidden auto;
  flex-direction: column;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
  list-style: none;
  max-block-size: 0;
  transition: max-height 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--dropdown--light .cds--dropdown-list {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--dropdown:not(.cds--dropdown--open) .cds--dropdown-item {
  visibility: hidden;
}

.cds--dropdown-item {
  position: relative;
  opacity: 0;
  transition: visibility 70ms cubic-bezier(0.2, 0, 0.38, 0.9), opacity 70ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  visibility: inherit;
}
.cds--dropdown-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--dropdown-item:hover + .cds--dropdown-item .cds--dropdown-link {
  border-color: transparent;
}
.cds--dropdown-item:active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}
.cds--dropdown-item:first-of-type .cds--dropdown-link {
  border-block-start-color: transparent;
}

.cds--dropdown-item:last-of-type .cds--dropdown-link {
  -webkit-border-after: none;
          border-block-end: none;
}

.cds--dropdown-link {
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: block;
  overflow: hidden;
  padding: 0.6875rem 0;
  border: 1px solid transparent;
  margin: 0 1rem;
  block-size: 2.5rem;
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-weight: normal;
  line-height: 1rem;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cds--dropdown-link:hover {
  border-color: transparent;
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--dropdown--light .cds--dropdown-link {
  border-block-start-color: #e0e0e0;
  border-block-start-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--dropdown--sm .cds--dropdown-link {
  block-size: 2rem;
  padding-block: 0.4375rem 0.4375rem;
}

.cds--dropdown--focused,
.cds--dropdown-link:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--dropdown--focused,
  .cds--dropdown-link:focus {
    outline-style: dotted;
  }
}
.cds--dropdown--focused,
.cds--dropdown-link:focus {
  padding: 0.6875rem 1rem;
  margin: 0;
}

.cds--dropdown-list[aria-activedescendant] .cds--dropdown-link:focus {
  padding: 0.6875rem 0;
  margin: 0 1rem;
  outline: none;
}

.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus {
    outline-style: dotted;
  }
}
.cds--dropdown-list[aria-activedescendant] .cds--dropdown--focused:focus {
  padding: 0.6875rem 1rem;
  margin: 0;
}

.cds--dropdown-list[aria-activedescendant] .cds--dropdown-item:active {
  background-color: inherit;
}

.cds--dropdown-item:hover .cds--dropdown-link {
  border-block-end-color: #e8e8e8;
  border-block-end-color: var(--cds-layer-hover);
}

.cds--dropdown--open .cds--dropdown__arrow {
  transform: rotate(-180deg);
}

.cds--dropdown--open.cds--dropdown--sm .cds--dropdown-list {
  max-block-size: 11rem;
}

.cds--dropdown--open .cds--dropdown-item {
  opacity: 1;
}

.cds--dropdown--disabled {
  border-block-end-color: transparent;
}
.cds--dropdown--disabled:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}
.cds--dropdown--disabled:focus {
  outline: none;
}
.cds--dropdown--disabled .cds--dropdown-text,
.cds--dropdown--disabled .cds--list-box__label {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--dropdown--disabled .cds--dropdown__arrow,
.cds--dropdown--disabled .cds--list-box__menu-icon svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--dropdown--disabled.cds--dropdown--light:hover {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--dropdown--disabled .cds--list-box__field,
.cds--dropdown--disabled .cds--list-box__menu-icon {
  cursor: not-allowed;
}

.cds--dropdown--auto-width {
  inline-size: auto;
  max-inline-size: 25rem;
}

.cds--dropdown--inline {
  display: inline-block;
  background-color: transparent;
  border-block-end-color: transparent;
  inline-size: auto;
  justify-self: start;
  transition: background 70ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--dropdown--inline:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--dropdown--inline.cds--dropdown--disabled {
  background-color: transparent;
}
.cds--dropdown--inline .cds--dropdown__arrow {
  inset-block-start: 0.5rem;
  inset-inline-end: 0.5rem;
}

.cds--dropdown--inline.cds--dropdown--open {
  background-color: transparent;
}

.cds--dropdown--inline .cds--dropdown-text {
  display: inline-block;
  overflow: visible;
  padding: 0.4375rem 2rem 0.4375rem 0.75rem;
  block-size: 2rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--dropdown--inline.cds--dropdown--disabled .cds--dropdown-text {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--dropdown--inline.cds--dropdown--disabled:focus .cds--dropdown-text {
  outline: 0;
}

.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown__invalid-icon {
  inset-inline-end: 2rem;
}

.cds--dropdown--inline.cds--dropdown--invalid .cds--dropdown-text {
  -webkit-padding-end: 3.5rem;
          padding-inline-end: 3.5rem;
}

.cds--dropdown--inline.cds--dropdown--open:focus .cds--dropdown-list {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
}

.cds--dropdown--inline .cds--dropdown-link {
  font-weight: normal;
}

.cds--dropdown--show-selected .cds--dropdown--selected {
  display: block;
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--dropdown--show-selected .cds--dropdown--selected:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}
.cds--dropdown--show-selected .cds--dropdown--selected .cds--dropdown-link {
  border-block-start-color: transparent;
}
.cds--dropdown--show-selected .cds--dropdown--selected + .cds--dropdown-item .cds--dropdown-link {
  border-block-start-color: transparent;
}
.cds--dropdown--show-selected .cds--dropdown--selected .cds--list-box__menu-item__selected-icon {
  display: block;
}

.cds--dropdown-v2.cds--skeleton,
.cds--dropdown.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--dropdown-v2.cds--skeleton:hover, .cds--dropdown-v2.cds--skeleton:focus, .cds--dropdown-v2.cds--skeleton:active,
.cds--dropdown.cds--skeleton:hover,
.cds--dropdown.cds--skeleton:focus,
.cds--dropdown.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--dropdown-v2.cds--skeleton::before,
.cds--dropdown.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--dropdown-v2.cds--skeleton::before,
  .cds--dropdown.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--dropdown-v2.cds--skeleton,
  .cds--dropdown.cds--skeleton {
    background: CanvasText;
  }
  .cds--dropdown-v2.cds--skeleton::before,
  .cds--dropdown.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--dropdown .cds--list-box__field {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--list-box__menu-item__option {
    outline: none;
  }
}

.cds--dropdown--readonly,
.cds--dropdown--readonly:hover {
  background-color: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--dropdown--inline.cds--dropdown--readonly {
  border-block-end-color: transparent;
}

.cds--dropdown--readonly .cds--list-box__field,
.cds--dropdown--readonly .cds--list-box__menu-icon {
  cursor: default;
}

.cds--dropdown--readonly .cds--list-box__menu-icon svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--multi-select {
  box-sizing: border-box;
}

.cds--multi-select .cds--list-box__field--wrapper {
  display: inline-flex;
  align-items: center;
  block-size: calc(100% + 1px);
  inline-size: 100%;
}

.cds--multi-select .cds--list-box__field:focus {
  outline: 2px solid transparent;
  outline-offset: -2px;
}

.cds--multi-select--filterable .cds--list-box__field {
  padding: 0;
}

.cds--multi-select .cds--tag {
  margin: 0 0.5rem 0 1rem;
  min-inline-size: auto;
}

.cds--multi-select .cds--list-box__menu {
  min-inline-size: auto;
}

.cds--multi-select.cds--multi-select--selectall .cds--list-box__menu-item:first-child .cds--list-box__menu-item__option {
  padding: 0.6875rem 1rem;
  margin: 0;
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-border-subtle-01, #c6c6c6);
          border-block-end: 1px solid var(--cds-border-subtle-01, #c6c6c6);
}

.cds--multi-select.cds--multi-select--selectall .cds--list-box__menu-item:nth-child(2) .cds--list-box__menu-item__option {
  -webkit-border-before: none;
          border-block-start: none;
}

.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-wrapper {
  display: flex;
  align-items: center;
  block-size: 100%;
  inline-size: 100%;
}

.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label {
  display: inline-block;
  overflow: hidden;
  inline-size: 100%;
  -webkit-padding-start: 1.75rem;
          padding-inline-start: 1.75rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label::before {
  margin-block: 0;
}

.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox:indeterminate + .cds--checkbox-label::after {
  inset-block-start: 0.5625rem;
}

.cds--multi-select .cds--list-box__menu-item__option .cds--checkbox-label::after {
  inset-block-start: 0.3125rem;
}

.cds--multi-select .cds--list-box__menu-item__option > .cds--form-item {
  flex-direction: row;
  margin: 0;
}

.cds--multi-select .cds--list-box__menu-item .cds--checkbox:checked ~ .cds--checkbox-label-text {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--multi-select--filterable {
  transition: outline-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--multi-select--filterable.cds--combo-box .cds--text-input {
  border: 0.125rem solid transparent;
  background-clip: padding-box;
  outline: none;
}

.cds--multi-select--filterable--input-focused,
.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=false]),
.cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=true]) {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--multi-select--filterable--input-focused,
  .cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=false]),
  .cds--multi-select .cds--list-box__field--wrapper--input-focused:has(button[aria-expanded=true]) {
    outline-style: dotted;
  }
}

.cds--multi-select.cds--list-box--expanded .cds--list-box__field--wrapper:has(button[aria-activedescendant]:not([aria-activedescendant=""])),
.cds--multi-select--filterable.cds--list-box--expanded:has(input[aria-activedescendant]:not([aria-activedescendant=""])) {
  outline-offset: -0.0625rem;
  outline-width: 0.0625rem;
}

.cds--multi-select--filterable.cds--multi-select--selected .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted::before,
.cds--multi-select.cds--multi-select--selected .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted::before {
  position: absolute;
  border: 2px solid var(--color-primary);
  border: 2px solid var(--cds-focus, #0f62fe);
  block-size: 100%;
  -webkit-border-before: 1px solid var(--color-primary);
          border-block-start: 1px solid var(--color-primary);
  -webkit-border-before: 1px solid var(--cds-focus, #0f62fe);
          border-block-start: 1px solid var(--cds-focus, #0f62fe);
  content: "";
  inline-size: 100%;
}

.cds--multi-select--filterable.cds--multi-select--selected .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted,
.cds--multi-select.cds--multi-select--selected .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted {
  outline: 2px solid transparent;
  outline-offset: -2px;
}

.cds--multi-select--filterable.cds--multi-select--selected .cds--text-input,
.cds--multi-select.cds--multi-select--selected .cds--list-box__field {
  -webkit-padding-start: 0;
          padding-inline-start: 0;
}

.cds--multi-select--filterable.cds--list-box--disabled:hover:not(.cds--multi-select--filterable) .cds--text-input {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}

.cds--multi-select--filterable .cds--list-box__selection--multi {
  margin: 0 0 0 1rem;
}

.cds--multi-select--filterable.cds--multi-select--inline,
.cds--multi-select--filterable.cds--multi-select--inline .cds--text-input {
  background-color: transparent;
  -webkit-border-after: 0;
          border-block-end: 0;
}

.cds--multi-select:not(.cds--list-box--expanded) .cds--list-box__menu {
  visibility: hidden;
}

.cds--multi-select.cds--multi-select--readonly,
.cds--multi-select.cds--multi-select--readonly:hover {
  background-color: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--multi-select.cds--multi-select--readonly .cds--list-box__menu-icon svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--multi-select.cds--multi-select--readonly .cds--tag--filter,
.cds--multi-select.cds--multi-select--readonly .cds--tag__close-icon:hover {
  background-color: transparent;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: default;
}

.cds--multi-select.cds--multi-select--readonly .cds--tag--filter {
  box-shadow: 0 0 0 1px #e0e0e0;
  box-shadow: 0 0 0 1px var(--cds-border-subtle);
}

.cds--multi-select.cds--multi-select--readonly .cds--tag--filter svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--multi-select.cds--multi-select--readonly .cds--list-box__field,
.cds--multi-select.cds--multi-select--readonly .cds--list-box__menu-icon {
  cursor: default;
}

.cds--search {
  position: relative;
  display: flex;
  align-items: center;
  inline-size: 100%;
}

.cds--search .cds--label {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--search-input {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-input *,
.cds--search-input *::before,
.cds--search-input *::after {
  box-sizing: inherit;
}
.cds--search-input {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  order: 1;
  padding: 0 2.5rem;
  border: none;
  -webkit-appearance: none;
          appearance: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  text-overflow: ellipsis;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--search-input:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-input:focus {
    outline-style: dotted;
  }
}
.cds--search-input::placeholder {
  color: rgba(22, 22, 22, 0.4);
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
}
.cds--search-input::-ms-clear {
  display: none;
}
.cds--search-input::-webkit-search-decoration, .cds--search-input::-webkit-search-cancel-button, .cds--search-input::-webkit-search-results-button, .cds--search-input::-webkit-search-results-decoration {
  display: none;
  -webkit-appearance: none;
  appearance: none;
}

.cds--search-input[disabled] {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--search-input[disabled]::placeholder {
  color: #f4f4f4;
  color: var(--cds-field);
}

.cds--search--light .cds--search-input {
  background: #ffffff;
  background: var(--cds-field-02, #ffffff);
}

.cds--search--light .cds--search-close::before {
  background: #ffffff;
  background: var(--cds-field-02, #ffffff);
}

.cds--search--sm .cds--search-input,
.cds--search--sm.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 2rem;
  block-size: 2rem;
}

.cds--search--sm .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--search--md .cds--search-input,
.cds--search--md.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 2.5rem;
  block-size: 2.5rem;
}

.cds--search--md .cds--search-magnifier-icon {
  inset-inline-start: 0.75rem;
}

.cds--search--lg .cds--search-input,
.cds--search--lg.cds--search--expandable.cds--search--expanded .cds--search-input {
  padding: 0 3rem;
  block-size: 3rem;
}

.cds--search-magnifier-icon {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-magnifier-icon *,
.cds--search-magnifier-icon *::before,
.cds--search-magnifier-icon *::after {
  box-sizing: inherit;
}
.cds--search-magnifier-icon {
  position: absolute;
  z-index: 2;
  block-size: 1rem;
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
  inline-size: 1rem;
  inset-block-start: 50%;
  inset-inline-start: 1rem;
  pointer-events: none;
  transform: translateY(-50%);
}

.cds--search-close {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--search-close *,
.cds--search-close *::before,
.cds--search-close *::after {
  box-sizing: inherit;
}
.cds--search-close::-moz-focus-inner {
  border: 0;
}
.cds--search-close {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
}
.cds--search-close::before {
  position: absolute;
  display: block;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: calc(100% - 2px);
  content: "";
  inline-size: 2px;
  inset-block-start: 0.0625rem;
  inset-inline-start: 0;
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--search-close::before {
    transition: none;
  }
}
.cds--search-close:hover {
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
}
.cds--search-close:hover::before {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--search-button {
  flex-shrink: 0;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-margin-start: 0.125rem;
          margin-inline-start: 0.125rem;
}
.cds--search-button svg {
  fill: currentColor;
  vertical-align: middle;
}

.cds--search-close svg {
  fill: inherit;
}

.cds--search-close,
.cds--search-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1px 0;
  border-style: solid;
  border-color: transparent;
  block-size: 2.5rem;
  cursor: pointer;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  opacity: 1;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), border 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  visibility: inherit;
}
.cds--search-close:hover,
.cds--search-button:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--search-close:focus,
.cds--search-button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-close:focus,
  .cds--search-button:focus {
    outline-style: dotted;
  }
}
.cds--search-close:active,
.cds--search-button:active {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-close:active,
  .cds--search-button:active {
    outline-style: dotted;
  }
}
.cds--search-close:active,
.cds--search-button:active {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}

.cds--search--disabled .cds--search-close,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier {
  cursor: not-allowed;
  outline: none;
}
.cds--search--disabled .cds--search-close:hover,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover {
  background-color: transparent;
  border-block-end-color: transparent;
}
.cds--search--disabled .cds--search-close:hover::before,
.cds--search--disabled.cds--search--expandable .cds--search-magnifier:hover::before {
  background-color: transparent;
}

.cds--search--disabled svg {
  fill: #8d8d8d;
  fill: var(--cds-icon-on-color-disabled, #8d8d8d);
}

.cds--search-close:focus::before,
.cds--search-close:active::before {
  background-color: var(--color-primary);
  background-color: var(--cds-focus, #0f62fe);
}

.cds--search-input:focus ~ .cds--search-close:hover {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--search-input:focus ~ .cds--search-close:hover {
    outline-style: dotted;
  }
}

.cds--search--sm .cds--search-close,
.cds--search--sm ~ .cds--search-button, .cds--search--sm.cds--search--expandable, .cds--search--sm.cds--search--expandable .cds--search-magnifier {
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--search--sm.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 2rem;
}

.cds--search--md .cds--search-close,
.cds--search--md ~ .cds--search-button, .cds--search--md.cds--search--expandable, .cds--search--md.cds--search--expandable .cds--search-magnifier {
  block-size: 2.5rem;
  inline-size: 2.5rem;
}
.cds--search--md.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 2.5rem;
}

.cds--search--lg .cds--search-close,
.cds--search--lg ~ .cds--search-button, .cds--search--lg.cds--search--expandable, .cds--search--lg.cds--search--expandable .cds--search-magnifier {
  block-size: 3rem;
  inline-size: 3rem;
}
.cds--search--lg.cds--search--expandable .cds--search-input::placeholder {
  padding: 0 3rem;
}

.cds--search-close--hidden {
  opacity: 0;
  visibility: hidden;
}

.cds--search--lg.cds--skeleton .cds--search-input,
.cds--search--md.cds--skeleton .cds--search-input,
.cds--search--sm.cds--skeleton .cds--search-input {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--search--lg.cds--skeleton .cds--search-input:hover, .cds--search--lg.cds--skeleton .cds--search-input:focus, .cds--search--lg.cds--skeleton .cds--search-input:active,
.cds--search--md.cds--skeleton .cds--search-input:hover,
.cds--search--md.cds--skeleton .cds--search-input:focus,
.cds--search--md.cds--skeleton .cds--search-input:active,
.cds--search--sm.cds--skeleton .cds--search-input:hover,
.cds--search--sm.cds--skeleton .cds--search-input:focus,
.cds--search--sm.cds--skeleton .cds--search-input:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--search--lg.cds--skeleton .cds--search-input::before,
.cds--search--md.cds--skeleton .cds--search-input::before,
.cds--search--sm.cds--skeleton .cds--search-input::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--search--lg.cds--skeleton .cds--search-input::before,
  .cds--search--md.cds--skeleton .cds--search-input::before,
  .cds--search--sm.cds--skeleton .cds--search-input::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--search--lg.cds--skeleton .cds--search-input,
  .cds--search--md.cds--skeleton .cds--search-input,
  .cds--search--sm.cds--skeleton .cds--search-input {
    background: CanvasText;
  }
  .cds--search--lg.cds--skeleton .cds--search-input::before,
  .cds--search--md.cds--skeleton .cds--search-input::before,
  .cds--search--sm.cds--skeleton .cds--search-input::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--search--lg.cds--skeleton .cds--search-input,
.cds--search--md.cds--skeleton .cds--search-input,
.cds--search--sm.cds--skeleton .cds--search-input {
  inline-size: 100%;
}
.cds--search--lg.cds--skeleton .cds--search-input::placeholder,
.cds--search--md.cds--skeleton .cds--search-input::placeholder,
.cds--search--sm.cds--skeleton .cds--search-input::placeholder {
  color: transparent;
}

.cds--search--expandable {
  transition: width 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--search--expandable.cds--search--expanded {
  inline-size: 100%;
}

.cds--search--expandable .cds--search-input {
  padding: 0;
  inline-size: 0;
  transition: transform 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--search--expandable .cds--search-input::placeholder {
  position: relative;
  opacity: 0;
  transition-duration: 70ms;
  transition-property: padding, opacity;
  transition-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--search--expandable.cds--search--expanded .cds--search-input {
  inline-size: 100%;
  transition: padding 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--search--expandable.cds--search--expanded .cds--search-input::placeholder {
  position: relative;
  padding: 0;
  opacity: 1;
}

.cds--search--expandable .cds--search-magnifier {
  position: absolute;
  cursor: pointer;
}
.cds--search--expandable .cds--search-magnifier:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
}

.cds--search--expandable .cds--search-magnifier:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.cds--search--expandable.cds--search--expanded .cds--search-magnifier {
  pointer-events: none;
}

.cds--search--expandable .cds--search-magnifier-icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--search--expandable.cds--search--expanded .cds--search-magnifier-icon {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--search--expandable.cds--search--disabled svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--search-magnifier-tooltip {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cds--search-magnifier-tooltip .cds--search-magnifier {
  position: relative;
}

.cds--combo-box:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
}

.cds--combo-box .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted::before {
  position: absolute;
  border: 2px solid var(--color-primary);
  border: 2px solid var(--cds-focus, #0f62fe);
  block-size: 100%;
  -webkit-border-before: 1px solid var(--color-primary);
          border-block-start: 1px solid var(--color-primary);
  -webkit-border-before: 1px solid var(--cds-focus, #0f62fe);
          border-block-start: 1px solid var(--cds-focus, #0f62fe);
  content: "";
  inline-size: 100%;
}

.cds--combo-box .cds--list-box__menu-item:first-child.cds--list-box__menu-item--highlighted {
  outline: 2px solid transparent;
  outline-offset: -2px;
}

.cds--combo-box.cds--list-box--light:hover {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--combo-box .cds--text-input::-ms-clear {
  display: none;
}

.cds--combo-box.cds--list-box--expanded .cds--text-input {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--combo-box--input--focus.cds--text-input {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--combo-box--input--focus.cds--text-input {
    outline-style: dotted;
  }
}

.cds--combo-box.cds--list-box--expanded:has(input[aria-activedescendant]:not([aria-activedescendant=""])) .cds--combo-box--input--focus.cds--text-input {
  outline-offset: -0.0625rem;
  outline-width: 0.0625rem;
}

.cds--combo-box .cds--list-box__field,
.cds--combo-box.cds--list-box[data-invalid] .cds--list-box__field,
.cds--combo-box.cds--list-box--warning .cds--list-box__field,
.cds--combo-box.cds--list-box--disabled.cds--list-box[data-invalid] .cds--list-box__field,
.cds--combo-box.cds--list-box--disabled.cds--list-box--warning .cds--list-box__field {
  padding: 0;
}

.cds--combo-box--readonly,
.cds--combo-box--readonly:hover {
  background-color: transparent;
}

.cds--combo-box--readonly .cds--text-input {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--combo-box--readonly .cds--list-box__menu-icon,
.cds--combo-box--readonly .cds--list-box__selection {
  cursor: default;
}

.cds--combo-box--readonly .cds--list-box__menu-icon svg,
.cds--combo-box--readonly .cds--list-box__selection svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--select *,
.cds--select *::before,
.cds--select *::after {
  box-sizing: inherit;
}
.cds--select {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  inline-size: 100%;
}

.cds--select-input__wrapper {
  position: relative;
  display: flex;
  align-items: center;
  inline-size: 100%;
}

.cds--select-input {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: block;
  border: none;
  border-radius: 0;
  -webkit-appearance: none;
          appearance: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
  font-family: inherit;
  inline-size: 100%;
  opacity: 1;
  padding-block: 0;
  padding-inline: 1rem 3rem;
  text-overflow: ellipsis;
  transition: outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--select-input:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--select-input::-ms-expand {
  display: none;
}
.cds--select-input {
  /* This is for targeting styles specific to firefox */
  /* Removes dotted inner focus */
  /* https://sass-lang.com/documentation/breaking-changes/moz-document/ */
  /* stylelint-disable-next-line at-rule-no-vendor-prefix */
}
@-moz-document url-prefix() {
  .cds--select-input:-moz-focusring, .cds--select-input::-moz-focus-inner {
    background-image: none;
    color: transparent;
    text-shadow: 0 0 0 #000000;
  }
}
.cds--select-input:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--select-input:focus {
    outline-style: dotted;
  }
}
.cds--select-input:focus {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--select-input:disabled, .cds--select-input:hover:disabled {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  border-block-end-color: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--select-input--sm {
  block-size: 2rem;
  max-block-size: 2rem;
}

.cds--select-input--lg {
  block-size: 3rem;
  max-block-size: 3rem;
}

.cds--select--disabled .cds--label,
.cds--select--disabled .cds--form__helper-text {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select-input__wrapper[data-invalid] .cds--select-input,
.cds--select--warning .cds--select-input {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--select-input:disabled ~ .cds--select__arrow {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select--light .cds--select-input {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}
.cds--select--light .cds--select-input:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--select--light .cds--select-input:disabled, .cds--select--light .cds--select-input:hover:disabled {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--select__arrow {
  position: absolute;
  block-size: 100%;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inset-block-start: 0;
  inset-inline-end: 1rem;
  pointer-events: none;
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--select__arrow path {
    fill: ButtonText;
  }
}

.cds--select__invalid-icon {
  position: absolute;
  inset-inline-end: 2.5rem;
}

.cds--select-input__wrapper[data-invalid] .cds--select-input ~ .cds--select__invalid-icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}

.cds--select-input--inline__wrapper[data-invalid] .cds--select__invalid-icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}

.cds--select__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--select__invalid-icon--warning path[fill] {
  fill: #000000;
  opacity: 1;
}

optgroup.cds--select-optgroup,
.cds--select-option {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
optgroup.cds--select-optgroup:disabled,
.cds--select-option:disabled {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select--inline {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.cds--select--inline .cds--form__helper-text {
  -webkit-margin-after: 0;
          margin-block-end: 0;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--select--inline .cds--label {
  margin: 0 0.5rem 0 0;
  white-space: nowrap;
}

.cds--select--inline .cds--select-input {
  background-color: transparent;
  -webkit-border-after: none;
          border-block-end: none;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  padding-inline: 0.5rem 3rem;
}
.cds--select--inline .cds--select-input:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--select--inline .cds--select-input:focus,
.cds--select--inline .cds--select-input:focus option,
.cds--select--inline .cds--select-input:focus optgroup {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}
.cds--select--inline .cds--select-input:focus:hover,
.cds--select--inline .cds--select-input:focus option:hover,
.cds--select--inline .cds--select-input:focus optgroup:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--select--inline .cds--select-input[disabled],
.cds--select--inline .cds--select-input[disabled]:hover {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}

.cds--select--inline .cds--select__arrow {
  inset-inline-end: 0.5rem;
}

.cds--select--inline.cds--select--invalid .cds--select-input {
  -webkit-padding-end: 3.5rem;
          padding-inline-end: 3.5rem;
}

.cds--select--inline.cds--select--invalid .cds--select-input ~ .cds--select__invalid-icon,
.cds--select--inline.cds--select--warning .cds--select-input ~ .cds--select__invalid-icon--warning {
  inset-inline-end: 2rem;
}

.cds--select--inline .cds--select-input:disabled {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--select--inline .cds--select-input:disabled ~ * {
  cursor: not-allowed;
}

.cds--select--readonly .cds--select-input {
  background-color: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
  cursor: default;
}

.cds--select--readonly .cds--select__arrow {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--select--readonly.cds--select--inline .cds--select-input:hover {
  background-color: transparent;
}

.cds--select.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--select.cds--skeleton:hover, .cds--select.cds--skeleton:focus, .cds--select.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--select.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--select.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--select.cds--skeleton {
    background: CanvasText;
  }
  .cds--select.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--select.cds--skeleton {
  block-size: 2.5rem;
  inline-size: 100%;
}

.cds--select.cds--skeleton .cds--select-input {
  display: none;
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > *,
.cds--select--slug .cds--ai-label,
.cds--select--slug .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: calc(2.5rem + 8px + 1px);
  -webkit-margin-before: 0.03125rem;
          margin-block-start: 0.03125rem;
  transform: translateY(-50%);
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > *::after,
.cds--select--decorator .cds--select__inner-wrapper--decorator > *::before,
.cds--select--slug .cds--ai-label::after,
.cds--select--slug .cds--ai-label::before,
.cds--select--slug .cds--slug::after,
.cds--select--slug .cds--slug::before {
  position: absolute;
  background-color: #c6c6c6;
  background-color: var(--cds-border-subtle-01, #c6c6c6);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > *::before,
.cds--select--slug .cds--ai-label::before,
.cds--select--slug .cds--slug::before {
  display: none;
  inset-inline-start: calc(-0.5rem - 1px);
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > *::after,
.cds--select--slug .cds--ai-label::after,
.cds--select--slug .cds--slug::after {
  display: block;
  inset-block-start: 0;
  inset-inline-end: calc(-0.5rem - 1px);
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > .cds--ai-label--revert::before,
.cds--select--slug .cds--ai-label--revert::before,
.cds--select--slug .cds--slug--revert::before {
  inset-block-start: 0.5rem;
  inset-inline-start: 0;
}

.cds--select--decorator .cds--select__inner-wrapper--decorator > .cds--ai-label--revert,
.cds--select--slug .cds--ai-label--revert {
  inset-inline-end: 2.5625rem;
}

.cds--select--decorator .cds--ai-label--revert::after,
.cds--select--slug .cds--ai-label--revert::after,
.cds--select--slug .cds--slug--revert::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -1px;
}

.cds--select--decorator .cds--select-input:has(~ .cds--select__inner-wrapper--decorator),
.cds--select--slug .cds--select-input:has(~ .cds--ai-label),
.cds--select--slug .cds--select-input:has(~ .cds--slug) {
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--select--decorator:has(.cds--select__invalid-icon) .cds--select-input:has(~ .cds--select__inner-wrapper--decorator),
.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~ .cds--ai-label),
.cds--select--slug:has(.cds--select__invalid-icon) .cds--select-input:has(~ .cds--slug) {
  -webkit-padding-end: 6rem;
          padding-inline-end: 6rem;
}

.cds--select--decorator .cds--select-input:has(~ .cds--select__inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--select__inner-wrapper--decorator .cds--ai-label--revert)),
.cds--select--slug .cds--select-input:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--select--slug .cds--select-input:has(~ .cds--slug):not(:has(~ .cds--slug--revert)),
.cds--select-input-has--ai-label {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
}

.cds--select--decorator:has(.cds--select__invalid-icon) .cds--select__inner-wrapper--decorator > *::before,
.cds--select--slug:has(.cds--select__invalid-icon) .cds--ai-label::before,
.cds--select--slug:has(.cds--select__invalid-icon) .cds--slug::before {
  display: block;
}

.cds--select--decorator .cds--select-input__wrapper .cds--select-input ~ .cds--select__invalid-icon,
.cds--select--slug .cds--select-input__wrapper[data-invalid] .cds--select-input ~ .cds--select__invalid-icon,
.cds--select--slug .cds--select-input__wrapper .cds--select-input ~ .cds--select__invalid-icon {
  inset-inline-end: 5rem;
}

.cds--data-table-container + .cds--pagination {
  -webkit-border-before: 0;
          border-block-start: 0;
}

.cds--pagination {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--pagination *,
.cds--pagination *::before,
.cds--pagination *::after {
  box-sizing: inherit;
}
.cds--pagination {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  overflow: visible;
  overflow: initial;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-border-subtle);
          border-block-start: 1px solid var(--cds-border-subtle);
  container-name: pagination;
  container-type: inline-size;
  inline-size: calc(100% - 1px);
  min-block-size: 2.5rem;
}
@container pagination (min-width: 42rem) {
  .cds--pagination .cds--pagination__control-buttons {
    display: flex;
  }
}
@container pagination (max-width: 42rem) {
  .cds--pagination .cds--pagination__left > *,
  .cds--pagination .cds--pagination__right > * {
    display: none;
  }
  .cds--pagination .cds--pagination__items-count {
    display: inline;
    display: initial;
  }
  .cds--pagination .cds--pagination__control-buttons {
    display: flex;
  }
}

.cds--pagination--sm {
  min-block-size: 2rem;
}

.cds--pagination--lg {
  min-block-size: 3rem;
}

.cds--pagination .cds--select {
  align-items: center;
  block-size: 100%;
}

.cds--pagination .cds--select-input--inline__wrapper {
  display: flex;
  block-size: 100%;
}

.cds--pagination .cds--select-input {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  block-size: 100%;
  inline-size: auto;
  line-height: 2.5rem;
  min-inline-size: auto;
}
@-moz-document url-prefix() {
  .cds--pagination .cds--select-input {
    padding-inline-end: 1rem;
    text-overflow: clip;
  }
}

.cds--pagination .cds--select--inline .cds--select-input {
  padding-inline: 1rem 2.25rem;
}

.cds--pagination--sm .cds--select-input {
  line-height: 2rem;
}

.cds--pagination--lg .cds--select-input {
  line-height: 3rem;
}

.cds--pagination .cds--select-input:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}

.cds--pagination .cds--select--inline .cds--select-input:focus,
.cds--pagination .cds--select--inline .cds--select-input:focus option,
.cds--pagination .cds--select--inline .cds--select-input:focus optgroup {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--pagination .cds--select__arrow {
  inset-block-start: 50%;
  transform: translate(-0.5rem, -50%);
}

.cds--pagination .cds--select__item-count .cds--select-input {
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
}

.cds--pagination__right {
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--pagination__left,
.cds--pagination__right {
  display: flex;
  align-items: center;
  block-size: 100%;
}

.cds--pagination__left > .cds--form-item,
.cds--pagination__right > .cds--form-item {
  block-size: 100%;
}

.cds--pagination__left .cds--pagination__text,
.cds--pagination__right .cds--pagination__text {
  white-space: nowrap;
}

.cds--pagination__left .cds--pagination__text {
  -webkit-margin-end: 0.0625rem;
          margin-inline-end: 0.0625rem;
}

.cds--pagination__right .cds--pagination__text {
  margin-inline: 0.0625rem 1rem;
}

.cds--pagination__right .cds--pagination__text.cds--pagination__page-text {
  margin-inline: 1rem 0.0625rem;
}

.cds--pagination__right .cds--pagination__text.cds--pagination__page-text.cds--pagination__unknown-pages-text {
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--pagination__right .cds--pagination__text:empty {
  margin: 0;
}

.cds--pagination__left {
  padding: 0 1rem 0 0;
}
@container pagination (min-width: 42rem) {
  .cds--pagination__left {
    padding: 0 1rem;
  }
}

@container pagination (min-width: 42rem) {
  .cds--pagination__text {
    display: inline-block;
  }
}

span.cds--pagination__text {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  -webkit-margin-start: 1rem;
          margin-inline-start: 1rem;
}

span.cds--pagination__text.cds--pagination__items-count {
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--pagination__button,
.cds--btn--ghost.cds--pagination__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--pagination__button *,
.cds--pagination__button *::before,
.cds--pagination__button *::after,
.cds--btn--ghost.cds--pagination__button *,
.cds--btn--ghost.cds--pagination__button *::before,
.cds--btn--ghost.cds--pagination__button *::after {
  box-sizing: inherit;
}
.cds--pagination__button,
.cds--btn--ghost.cds--pagination__button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  background: none;
  block-size: 2.5rem;
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
  cursor: pointer;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  min-block-size: 2rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--pagination__button > svg,
.cds--btn--ghost.cds--pagination__button > svg {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

[dir=rtl] .cds--pagination__button > svg,
[dir=rtl] .cds--btn--ghost.cds--pagination__button > svg {
  transform: rotate(0.5turn);
}

.cds--pagination--sm .cds--pagination__button,
.cds--pagination--sm .cds--btn--ghost.cds--pagination__button {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--pagination--lg .cds--pagination__button,
.cds--pagination--lg .cds--btn--ghost.cds--pagination__button {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--pagination__button:focus,
.cds--btn--ghost:focus.cds--pagination__button {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--pagination__button:focus,
  .cds--btn--ghost:focus.cds--pagination__button {
    outline-style: dotted;
  }
}
.cds--pagination__button:focus,
.cds--btn--ghost:focus.cds--pagination__button {
  -webkit-border-start: 0;
          border-inline-start: 0;
}

.cds--pagination__button:hover,
.cds--btn--ghost:hover.cds--pagination__button {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}

.cds--pagination__button--no-index,
.cds--btn--ghost.cds--pagination__button--no-index {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--pagination__button:disabled:hover,
.cds--pagination__button--no-index:hover,
.cds--btn--ghost:disabled:hover.cds--pagination__button,
.cds--btn--ghost:hover.cds--pagination__button--no-index {
  border-color: #e0e0e0;
  border-color: var(--cds-border-subtle);
  background: #f4f4f4;
  background: var(--cds-layer);
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--pagination.cds--skeleton .cds--skeleton__text {
  -webkit-margin-after: 0;
          margin-block-end: 0;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--pagination__button,
  .cds--btn--ghost.cds--pagination__button {
    outline: 1px solid transparent;
  }
}

[dir=rtl] .cds--pagination .cds--select__arrow {
  transform: translate(0.5rem, -50%);
}

.cds--pagination .cds--select--inline .cds--select-input[disabled],
.cds--pagination .cds--select--inline .cds--select-input[disabled]:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--unstable-pagination {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--unstable-pagination *,
.cds--unstable-pagination *::before,
.cds--unstable-pagination *::after {
  box-sizing: inherit;
}
.cds--unstable-pagination {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-border-subtle);
          border-block-start: 1px solid var(--cds-border-subtle);
  container-name: pagination;
  container-type: inline-size;
  inline-size: 100%;
  min-block-size: 2.5rem;
}

@container pagination (min-width: 42rem) {
  .cds--unstable-pagination__text {
    display: inline-block;
  }
}
.cds--unstable-pagination__text {
  margin: 0 1rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--unstable-pagination__left,
.cds--unstable-pagination__right {
  display: flex;
  align-items: center;
  block-size: 100%;
}

.cds--unstable-pagination__left {
  padding: 0 1rem 0 0;
}

.cds--unstable-pagination__left > .cds--form-item,
.cds--unstable-pagination__right > .cds--form-item {
  block-size: 100%;
}

.cds--unstable-pagination__left .cds--unstable-pagination__text {
  -webkit-margin-end: 0.0625rem;
          margin-inline-end: 0.0625rem;
}

.cds--unstable-pagination__right .cds--unstable-pagination__text {
  margin-inline: 0.0625rem 1rem;
}

.cds--unstable-pagination__button {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--unstable-pagination__button *,
.cds--unstable-pagination__button *::before,
.cds--unstable-pagination__button *::after {
  box-sizing: inherit;
}
.cds--unstable-pagination__button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  margin: 0;
  background: none;
  block-size: 2.5rem;
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
  color: #161616;
  color: var(--cds-icon-primary, #161616);
  cursor: pointer;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  min-block-size: 2rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--unstable-pagination__button .cds--btn__icon {
  block-size: initial;
  inline-size: initial;
}

.cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--unstable-pagination__button.cds--btn--icon-only.cds--tooltip__trigger:focus {
    outline-style: dotted;
  }
}

.cds--unstable-pagination__button:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-icon-primary, #161616);
}

.cds--unstable-pagination__button--no-index {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--unstable-pagination__button.cds--btn:disabled {
  border-color: #e0e0e0;
  border-color: var(--cds-border-subtle);
  background: transparent;
}

.cds--unstable-pagination__button:disabled:hover,
.cds--unstable-pagination__button--no-index:hover {
  background: transparent;
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--unstable-pagination__page-selector,
.cds--unstable-pagination__page-sizer {
  align-items: center;
  block-size: 100%;
}

.cds--unstable-pagination__page-selector .cds--select-input--inline__wrapper,
.cds--unstable-pagination__page-sizer .cds--select-input--inline__wrapper {
  display: flex;
  block-size: 100%;
}

.cds--unstable-pagination__page-selector .cds--select-input,
.cds--unstable-pagination__page-sizer .cds--select-input {
  font-size: 0.875rem;
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  padding: 0 2.25rem 0 1rem;
  block-size: 100%;
  inline-size: auto;
  line-height: 2.5rem;
  min-inline-size: auto;
}

.cds--unstable-pagination__page-selector .cds--select-input:hover,
.cds--unstable-pagination__page-sizer .cds--select-input:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}

.cds--unstable-pagination__page-selector .cds--select__arrow,
.cds--unstable-pagination__page-sizer .cds--select__arrow {
  inset-block-start: 50%;
  transform: translateY(-50%);
}
@container pagination (min-width: 42rem) {
  .cds--unstable-pagination__page-selector .cds--select__arrow,
  .cds--unstable-pagination__page-sizer .cds--select__arrow {
    inset-inline-end: 1rem;
  }
}

.cds--unstable-pagination__page-selector {
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--unstable-pagination__page-sizer {
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
}

.cds--radio-button-group {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--radio-button-group *,
.cds--radio-button-group *::before,
.cds--radio-button-group *::after {
  box-sizing: inherit;
}
.cds--radio-button-group {
  position: relative;
  display: flex;
  align-items: center;
}

.cds--label + .cds--form-item .cds--radio-button-group {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--radio-button-group--vertical {
  flex-direction: column;
  align-items: flex-start;
}
.cds--radio-button-group--vertical.cds--radio-button-group--label-left {
  align-items: flex-end;
}
.cds--radio-button-group--vertical .cds--radio-button__label {
  -webkit-margin-end: 0;
          margin-inline-end: 0;
}
.cds--radio-button-group--vertical .cds--radio-button__label:not(:last-of-type) {
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
}

.cds--radio-button {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  -webkit-margin-before: 0.9rem;
          margin-block-start: 0.9rem;
  -webkit-margin-start: 0.63rem;
          margin-inline-start: 0.63rem;
  visibility: inherit;
}

.cds--radio-button__label {
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--radio-button__label-text {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  flex: 1 1;
}

.cds--radio-button__appearance {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--radio-button__appearance *,
.cds--radio-button__appearance *::before,
.cds--radio-button__appearance *::after {
  box-sizing: inherit;
}
.cds--radio-button__appearance {
  flex-shrink: 0;
  border: 1px solid #161616;
  border: 1px solid var(--cds-icon-primary, #161616);
  border-radius: 50%;
  background-color: transparent;
  block-size: 1.125rem;
  inline-size: 1.125rem;
  margin-block: 0.0625rem 0.125rem;
  margin-inline: 0.125rem 0.625rem;
}

.cds--radio-button-group--vertical .cds--radio-button__appearance {
  margin-block: 0;
}

.cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance {
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: #161616;
  border-color: var(--cds-icon-primary, #161616);
}
.cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  background-color: #161616;
  background-color: var(--cds-icon-primary, #161616);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  transform: scale(0.5);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
    background-color: ButtonText;
  }
}
@media print {
  .cds--radio-button:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
    -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
  }
}

.cds--radio-button:disabled + .cds--radio-button__label {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--radio-button:disabled + .cds--radio-button__label .cds--radio-button__appearance,
.cds--radio-button:disabled:checked + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: rgba(22, 22, 22, 0.25);
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--radio-button:disabled + .cds--radio-button__label .cds--radio-button__appearance::before,
.cds--radio-button:disabled:checked + .cds--radio-button__label .cds--radio-button__appearance::before {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--radio-button-group--readonly .cds--radio-button + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: rgba(22, 22, 22, 0.25);
  border-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--radio-button-group--readonly .cds--radio-button__label {
  cursor: default;
}

.cds--radio-button-group--readonly .cds--radio-button__label-text {
  cursor: text;
  -webkit-user-select: text;
          user-select: text;
}

.cds--radio-button-group--invalid .cds--radio-button + .cds--radio-button__label .cds--radio-button__appearance {
  border-color: #da1e28;
  border-color: var(--cds-support-error, #da1e28);
}

.cds--radio-button__validation-msg {
  display: none;
  align-items: flex-end;
  -webkit-margin-before: 0.375rem;
          margin-block-start: 0.375rem;
}

.cds--radio-button__invalid-icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  margin-inline: 0.1875rem 0.0625rem;
}

.cds--radio-button__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--radio-button__invalid-icon--warning path:first-of-type {
  fill: #000000;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg,
.cds--radio-button-group--warning + .cds--radio-button__validation-msg {
  display: flex;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg .cds--form-requirement,
.cds--radio-button-group--warning + .cds--radio-button__validation-msg .cds--form-requirement {
  display: block;
  overflow: visible;
  -webkit-margin-before: 0;
          margin-block-start: 0;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  max-block-size: 100%;
}

.cds--radio-button-group--invalid + .cds--radio-button__validation-msg .cds--form-requirement {
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
}

.cds--radio-button-group ~ .cds--form__helper-text {
  -webkit-margin-before: 0.375rem;
          margin-block-start: 0.375rem;
}

.cds--radio-button:focus + .cds--radio-button__label .cds--radio-button__appearance {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: 1.5px;
}

.cds--radio-button__label.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--radio-button__label.cds--skeleton:hover, .cds--radio-button__label.cds--skeleton:focus, .cds--radio-button__label.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--radio-button__label.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--radio-button__label.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--radio-button__label.cds--skeleton {
    background: CanvasText;
  }
  .cds--radio-button__label.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--radio-button__label.cds--skeleton {
  block-size: 1.125rem;
  inline-size: 6.25rem;
}

.cds--radio-button__label.cds--skeleton .cds--radio-button__appearance {
  display: none;
}

.cds--radio-button-wrapper .cds--radio-button__label {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
}

.cds--radio-button-wrapper:not(:last-of-type) {
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--radio-button-group--vertical .cds--radio-button-wrapper {
  -webkit-margin-after: 0.375rem;
          margin-block-end: 0.375rem;
  -webkit-margin-end: 0;
          margin-inline-end: 0;
}

.cds--radio-button-group--vertical .cds--radio-button-wrapper .cds--radio-button__label {
  -webkit-padding-before: 0.125rem;
          padding-block-start: 0.125rem;
}

.cds--radio-button-group--label-right .cds--radio-button__label,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-right .cds--radio-button__label {
  flex-direction: row;
}

.cds--radio-button-group--label-left .cds--radio-button__label,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__label {
  flex-direction: row-reverse;
}

.cds--radio-button-group--label-left .cds--radio-button__appearance,
.cds--radio-button-wrapper.cds--radio-button-wrapper--label-left .cds--radio-button__appearance {
  margin-inline: 0.5rem 0;
}

.cds--radio-button-group--decorator legend.cds--label,
.cds--radio-button-wrapper--decorator .cds--radio-button__label-text,
.cds--radio-button-group--slug legend.cds--label,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text {
  display: flex;
}

.cds--radio-button-group--decorator legend.cds--label .cds--radio-button-group-inner--decorator > *,
.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--radio-button-wrapper-inner--decorator > *,
.cds--radio-button-group--slug legend.cds--label .cds--ai-label,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label,
.cds--radio-button-group--slug legend.cds--label .cds--slug,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug {
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--radio-button-wrapper--decorator .cds--radio-button__label-text .cds--ai-label__button--inline,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--ai-label__button--inline,
.cds--radio-button-wrapper--slug .cds--radio-button__label-text .cds--slug__button--inline {
  line-height: inherit;
  -webkit-margin-before: -0.0625rem;
          margin-block-start: -0.0625rem;
}

.cds--number__controls:hover .cds--number__control-btn::after {
  display: none;
}

.cds--number__input-wrapper--decorator .cds--number__rule-divider,
.cds--number__input-wrapper--slug .cds--number__rule-divider {
  display: none;
}

.cds--number__input-wrapper--decorator .cds--number__control-btn:hover,
.cds--number__input-wrapper--slug .cds--number__control-btn:hover {
  box-shadow: 0 -1px 0 #4589ff inset;
  box-shadow: 0 -1px 0 var(--cds-ai-border-strong, #4589ff) inset;
}

.cds--number__controls:focus-within .cds--number__control-btn::after {
  display: none;
}

.cds--number html {
  font-size: 100%;
}
.cds--number body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--number code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--number strong {
  font-weight: 600;
}
.cds--number {
  position: relative;
  display: flex;
  flex-direction: column;
  inline-size: 100%;
}

.cds--number .cds--number__input-wrapper--warning input[type=number],
.cds--number .cds--number__input-wrapper--warning input[type=text] {
  -webkit-padding-end: 8rem;
          padding-inline-end: 8rem;
}

.cds--number input[type=number],
.cds--number input[type=text] {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: inline-flex;
  box-sizing: border-box;
  border: 0;
  border-radius: 0;
  -webkit-appearance: textfield;
          appearance: textfield;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  -webkit-border-after: 0.0625rem solid #8d8d8d;
          border-block-end: 0.0625rem solid #8d8d8d;
  -webkit-border-after: 0.0625rem solid var(--cds-border-strong);
          border-block-end: 0.0625rem solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  font-weight: 400;
  inline-size: 100%;
  min-inline-size: 9.375rem;
  padding-inline: 1rem 6rem;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--number input[type=number]:focus,
.cds--number input[type=text]:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--number input[type=number]:focus,
  .cds--number input[type=text]:focus {
    outline-style: dotted;
  }
}
.cds--number input[type=number]:disabled ~ .cds--number__controls,
.cds--number input[type=text]:disabled ~ .cds--number__controls {
  cursor: not-allowed;
  pointer-events: none;
}
.cds--number input[type=number]:disabled ~ .cds--number__controls svg,
.cds--number input[type=text]:disabled ~ .cds--number__controls svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--number input[type=number]::-ms-clear,
.cds--number input[type=text]::-ms-clear {
  display: none;
}
.cds--number input[type=number]::-webkit-inner-spin-button,
.cds--number input[type=text]::-webkit-inner-spin-button {
  -webkit-appearance: none;
          appearance: none;
}
.cds--number input[type=number][data-invalid],
.cds--number input[type=text][data-invalid] {
  -webkit-padding-end: 8rem;
          padding-inline-end: 8rem;
}

.cds--number--lg.cds--number input[type=number],
.cds--number--lg.cds--number input[type=text] {
  -webkit-padding-end: 7rem;
          padding-inline-end: 7rem;
}
.cds--number--lg.cds--number input[type=number][data-invalid],
.cds--number--lg.cds--number input[type=text][data-invalid] {
  -webkit-padding-end: 9rem;
          padding-inline-end: 9rem;
}
.cds--number--lg.cds--number .cds--number__input-wrapper--warning input[type=number],
.cds--number--lg.cds--number .cds--number__input-wrapper--warning input[type=text] {
  -webkit-padding-end: 9rem;
          padding-inline-end: 9rem;
}

.cds--number--sm.cds--number input[type=number],
.cds--number--sm.cds--number input[type=text] {
  -webkit-padding-end: 5rem;
          padding-inline-end: 5rem;
}
.cds--number--sm.cds--number input[type=number][data-invalid],
.cds--number--sm.cds--number input[type=text][data-invalid] {
  -webkit-padding-end: 7rem;
          padding-inline-end: 7rem;
}
.cds--number--sm.cds--number .cds--number__input-wrapper--warning input[type=number],
.cds--number--sm.cds--number .cds--number__input-wrapper--warning input[type=text] {
  -webkit-padding-end: 7rem;
          padding-inline-end: 7rem;
}

.cds--number input[type=number]:disabled,
.cds--number input[type=text]:disabled {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--number__input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.cds--number__controls html {
  font-size: 100%;
}
.cds--number__controls body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--number__controls code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--number__controls strong {
  font-weight: 600;
}
.cds--number__controls {
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  block-size: 100%;
  inline-size: 5rem;
  inset-block-start: 50%;
  inset-inline-end: 0;
  transform: translateY(-50%);
}

.cds--number__control-btn {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--number__control-btn *,
.cds--number__control-btn *::before,
.cds--number__control-btn *::after {
  box-sizing: inherit;
}
.cds--number__control-btn::-moz-focus-inner {
  border: 0;
}
.cds--number__control-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  block-size: 100%;
  color: #161616;
  color: var(--cds-icon-primary, #161616);
}
.cds--number__control-btn svg {
  fill: currentColor;
}
.cds--number__control-btn:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--number__control-btn:focus {
    outline-style: dotted;
  }
}
.cds--number__control-btn:focus {
  color: #161616;
  color: var(--cds-icon-primary, #161616);
  outline-offset: -2px;
  outline-width: 2px;
}
.cds--number__control-btn:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
  box-shadow: 0 -1px 0 #8d8d8d inset;
  box-shadow: 0 -1px 0 var(--cds-border-strong) inset;
  color: #161616;
  color: var(--cds-icon-primary, #161616);
  cursor: pointer;
}
.cds--number__control-btn:disabled {
  border-block-end-color: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--number__control-btn.down-icon {
  order: 1;
}

.cds--number__control-btn.up-icon {
  order: 2;
}

.cds--number input[type=number][data-invalid] ~ .cds--number__controls .cds--number__control-btn,
.cds--number input[type=text][data-invalid] ~ .cds--number__controls .cds--number__control-btn {
  border-block-end-color: #da1e28;
  border-block-end-color: var(--cds-support-error, #da1e28);
}

.cds--number input[type=number]:focus ~ .cds--number__controls .cds--number__control-btn,
.cds--number input[type=text]:focus ~ .cds--number__controls .cds--number__control-btn {
  border-width: 2px 0;
  border-style: solid;
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  box-shadow: none;
  outline-offset: -2px;
}

.cds--number input[type=number]:focus ~ .cds--number__controls .cds--number__control-btn:last-of-type:hover,
.cds--number input[type=text]:focus ~ .cds--number__controls .cds--number__control-btn:last-of-type:hover {
  box-shadow: -4px 0 0 -2px var(--color-primary) inset;
  box-shadow: -4px 0 0 -2px var(--cds-focus, #0f62fe) inset;
}

.cds--number input[type=number][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:last-of-type:hover,
.cds--number input[type=text][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:last-of-type:hover {
  box-shadow: -4px 0 0 -2px #da1e28 inset;
  box-shadow: -4px 0 0 -2px var(--cds-support-error, #da1e28) inset;
}

.cds--number input[type=number][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:hover,
.cds--number input[type=text][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:hover {
  border-width: 2px 0;
  border-style: solid;
  border-color: #da1e28;
  border-color: var(--cds-support-error, #da1e28);
  box-shadow: none;
  outline-offset: -2px;
}

.cds--number input[type=number][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:focus:hover,
.cds--number input[type=text][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:focus:hover {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--number input[type=number][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:focus:hover,
  .cds--number input[type=text][data-invalid]:not(:focus) ~ .cds--number__controls .cds--number__control-btn:focus:hover {
    outline-style: dotted;
  }
}

.cds--number__rule-divider {
  position: absolute;
  z-index: 6000;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1rem;
  inline-size: 0.0625rem;
}
.cds--number__rule-divider:first-of-type {
  order: 0;
}

.cds--number__controls .cds--number__rule-divider:first-of-type {
  background-color: transparent;
  inset-inline-start: 0;
}

.cds--number__invalid + .cds--number__controls .cds--number__rule-divider:first-of-type {
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
}

.cds--number--light .cds--number__rule-divider,
.cds--number--light .cds--number__invalid + .cds--number__controls .cds--number__rule-divider:first-of-type {
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle-02, #e0e0e0);
}

.cds--number input[type=number]:disabled + .cds--number__controls .cds--number__rule-divider:first-of-type,
.cds--number input[type=text]:disabled + .cds--number__controls .cds--number__rule-divider:first-of-type {
  background-color: transparent;
}

.cds--number input[type=number]:disabled + .cds--number__controls .cds--number__rule-divider,
.cds--number input[type=text]:disabled + .cds--number__controls .cds--number__rule-divider {
  background-color: rgba(22, 22, 22, 0.25);
  background-color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--number__control-btn:focus ~ .cds--number__rule-divider {
  background-color: transparent;
}

.cds--number__invalid {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-inline-end: 6rem;
}

.cds--number--lg .cds--number__invalid {
  inset-inline-end: 7rem;
}

.cds--number--sm .cds--number__invalid {
  inset-inline-end: 5rem;
}

.cds--number__invalid + .cds--number__rule-divider {
  position: absolute;
  inset-inline-end: 5rem;
}

.cds--number--lg .cds--number__invalid + .cds--number__rule-divider {
  inset-inline-end: 6rem;
}

.cds--number--sm .cds--number__invalid + .cds--number__rule-divider {
  inset-inline-end: 4rem;
}

.cds--number__control-btn.down-icon:hover ~ .cds--number__rule-divider,
.cds--number__control-btn.up-icon:hover + .cds--number__rule-divider,
.cds--number__control-btn.down-icon:focus ~ .cds--number__rule-divider,
.cds--number__control-btn.up-icon:focus + .cds--number__rule-divider {
  background-color: transparent;
}

.cds--number__invalid--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--number__invalid--warning path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--number--lg input[type=number],
.cds--number--lg input[type=text] {
  block-size: 3rem;
}

.cds--number--lg .cds--number__controls {
  inline-size: 6rem;
}

.cds--number--lg .cds--number__control-btn {
  inline-size: 3rem;
}

.cds--number--sm input[type=number],
.cds--number--sm input[type=text] {
  block-size: 2rem;
}

.cds--number--sm .cds--number__controls {
  inline-size: 4rem;
}

.cds--number--sm .cds--number__control-btn {
  inline-size: 2rem;
}

.cds--number--nolabel .cds--label + .cds--form__helper-text {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--number--nosteppers input[type=number],
.cds--number--nosteppers input[type=text] {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}

.cds--number--nosteppers input[type=number][data-invalid],
.cds--number--nosteppers input[type=text][data-invalid],
.cds--number--nosteppers .cds--number__input-wrapper--warning input[type=number],
.cds--number--nosteppers .cds--number__input-wrapper--warning input[type=text] {
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--number--nosteppers .cds--number__invalid {
  inset-inline-end: 1rem;
}

.cds--number--readonly input[type=number],
.cds--number--readonly input[type=text] {
  background: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

.cds--number--readonly .cds--number__control-btn {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
  pointer-events: none;
}
.cds--number--readonly .cds--number__control-btn:hover {
  background-color: transparent;
  cursor: pointer;
}

.cds--number--readonly input[type=number]:focus ~ .cds--number__controls .cds--number__control-btn:hover,
.cds--number--readonly input[type=text]:focus ~ .cds--number__controls .cds--number__control-btn:hover {
  outline: none;
}

.cds--number--readonly .cds--number__controls:hover .cds--number__rule-divider:not(:first-of-type) {
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
}

.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator > *,
.cds--number__input-wrapper--slug .cds--ai-label,
.cds--number__input-wrapper--slug .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: 6rem;
  transform: translateY(-50%);
}

.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator:not(:has(.cds--ai-label)) > * {
  block-size: 1rem;
}

.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator > *::before,
.cds--number__input-wrapper--decorator .cds--number__control-btn::before,
.cds--number__input-wrapper--decorator .cds--number__control-btn::after,
.cds--number__input-wrapper--slug .cds--ai-label::before,
.cds--number__input-wrapper--slug .cds--slug::before,
.cds--number__input-wrapper--slug .cds--number__control-btn::before,
.cds--number__input-wrapper--slug .cds--number__control-btn::after {
  position: absolute;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
}

.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator > *::before,
.cds--number__input-wrapper--slug .cds--ai-label::before,
.cds--number__input-wrapper--slug .cds--slug::before {
  display: none;
  inset-inline-start: -1rem;
}

.cds--number__input-wrapper--decorator .cds--number__input-inner-wrapper--decorator .cds--ai-label--revert::before,
.cds--number__input-wrapper--slug .cds--ai-label--revert::before,
.cds--number__input-wrapper--slug .cds--slug--revert::before {
  inset-block-start: 0.5rem;
  inset-inline-start: -0.5rem;
}

.cds--number__control-btn::after {
  display: block;
  inset-inline-end: 0;
}

.cds--number__input-wrapper--decorator .cds--number__control-btn::before,
.cds--number__input-wrapper--slug .cds--number__control-btn::before {
  display: block;
  inset-inline-end: 2.5rem;
}

.cds--number__input-wrapper--decorator .cds--number__control-btn:focus::before,
.cds--number__input-wrapper--slug .cds--number__control-btn:focus::before {
  display: none;
}

.cds--number__control-btn:hover::after,
.cds--number__control-btn:hover::before {
  display: none;
  inset-inline-end: 0;
}

.cds--number__input-wrapper:has(.cds--number__control-btn:hover) ~ .cds--number__input-wrapper--decorator::after,
.cds--number__input-wrapper:has(.cds--number__control-btn:hover) ~ .cds--number__input-wrapper--slug::after {
  display: none;
}

.cds--number__control-btn:has(.up-icon)::after,
.cds--number__control-btn:has(.up-icon)::before {
  display: none;
}

.cds--number__input-wrapper--decorator .cds--number__invalid,
.cds--number__input-wrapper--slug .cds--number__invalid {
  inset-inline-end: 9rem;
}

.cds--number__input-wrapper--decorator:has(.cds--number__invalid) .cds--number__input-inner-wrapper--decorator > *::before,
.cds--number__input-wrapper--slug:has(.cds--number__invalid) .cds--ai-label::before,
.cds--number__input-wrapper--slug:has(.cds--number__invalid) .cds--ai-label::before,
.cds--number__input-wrapper--slug:has(.cds--number__invalid) .cds--slug::before {
  display: block;
}

.cds--number .cds--number__input-wrapper--decorator input[data-invalid],
.cds--number .cds--number__input-wrapper--decorator.cds--number__input-wrapper--warning input,
.cds--number .cds--number__input-wrapper--slug input[data-invalid],
.cds--number .cds--number__input-wrapper--slug.cds--number__input-wrapper--warning input {
  -webkit-padding-end: 9rem;
          padding-inline-end: 9rem;
}

.cds--number__input-wrapper--decorator input[type=number]:has(~ .cds--number__input-inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--number__input-inner-wrapper--decorator .cds--ai-label--revert)),
.cds--number__input-wrapper--slug input[type=number]:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--number__input-wrapper--slug input[type=number]:has(~ .cds--slug):not(:has(~ .cds--slug--revert)),
.cds--number__input-wrapper--slug input[type=number]:disabled,
.cds--number__input-wrapper--decorator input[type=text]:has(~ .cds--number__input-inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--number__input-inner-wrapper--decorator .cds--ai-label--revert)),
.cds--number__input-wrapper--slug input[type=text]:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--number__input-wrapper--slug input[type=text]:has(~ .cds--slug):not(:has(~ .cds--slug--revert)),
.cds--number__input-wrapper--slug input[type=text]:disabled {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
  -webkit-padding-end: 9.0625rem;
          padding-inline-end: 9.0625rem;
}

.cds--number.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--number.cds--skeleton:hover, .cds--number.cds--skeleton:focus, .cds--number.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--number.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--number.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--number.cds--skeleton {
    background: CanvasText;
  }
  .cds--number.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--number.cds--skeleton {
  inline-size: 100%;
}
.cds--number.cds--skeleton input[type=number],
.cds--number.cds--skeleton input[type=text] {
  display: none;
}

.cds--number.cds--skeleton.cds--number--sm {
  block-size: 2rem;
}

.cds--number.cds--skeleton.cds--number--md {
  block-size: 2.5rem;
}

.cds--number.cds--skeleton.cds--number--lg {
  block-size: 3rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--number__control-btn:hover,
  .cds--number__control-btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--number__control-btn {
    outline: 1px solid transparent;
  }
}

.cds--slider-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  -webkit-user-select: none;
          user-select: none;
}

.cds--slider {
  position: relative;
  padding: 1rem 0;
  cursor: pointer;
  inline-size: 100%;
  max-inline-size: 40rem;
  min-inline-size: 12.5rem;
}
.cds--slider-container--two-handles .cds--slider {
  margin-inline: 0.25rem;
}

.cds--slider__range-label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  white-space: nowrap;
}

.cds--slider__track {
  position: absolute;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 0.125rem;
  inline-size: 100%;
  transform: translate(0%, -50%);
}

.cds--slider__track:before {
  position: absolute;
  display: inline-block;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 0.25rem;
  content: "";
  inline-size: 0.125rem;
  inset-block-start: -0.3125rem;
  inset-inline-start: 50%;
  transform: translate(-50%, 0);
}

.cds--slider__filled-track {
  position: absolute;
  background: #161616;
  background: var(--cds-layer-selected-inverse, #161616);
  block-size: 0.125rem;
  inline-size: 100%;
  pointer-events: none;
  transform: translate(0%, -50%);
  transform-origin: left;
  transition: background 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--slider__thumb-wrapper {
  position: absolute;
  z-index: 3;
  block-size: 0.875rem;
  inline-size: 0.875rem;
  transform: translate(-50%, -50%);
  --cds-tooltip-padding-inline: 0.5rem;
  --cds-popover-offset: 0.5rem;
}
.cds--slider-container--rtl .cds--slider__thumb-wrapper {
  transform: translate(50%, -50%);
}

.cds--slider__thumb-wrapper--lower,
.cds--slider__thumb-wrapper--upper {
  block-size: 24px;
  inline-size: 16px;
  --cds-popover-offset: var(--cds-popover-caret-height, 0.5rem);
}

.cds--slider__thumb-wrapper--lower {
  transform: translate(-100%, -50%);
}
.cds--slider__thumb-wrapper--lower > .cds--popover > .cds--popover-content {
  transform: translate(50%, calc(-100% - 0rem));
  transform: translate(50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}
.cds--slider__thumb-wrapper--lower > .cds--popover > .cds--popover-caret {
  inset-inline-start: revert;
  transform: translate(50%, calc(-1 * 0rem));
  transform: translate(50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower {
  transform: translate(100%, -50%);
}
.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower > .cds--popover > .cds--popover-content {
  transform: translate(0, calc(-100% - 0rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 0rem)));
}
.cds--slider-container--rtl .cds--slider__thumb-wrapper--lower > .cds--popover > .cds--popover-caret {
  transform: translate(-50%, calc(-1 * 0rem));
  transform: translate(-50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--slider__thumb-wrapper--upper {
  transform: translate(0, -50%);
}
.cds--slider__thumb-wrapper--upper > .cds--popover > .cds--popover-content {
  transform: translate(-50%, calc(-100% - 0rem));
  transform: translate(-50%, calc(-100% - var(--cds-popover-offset, 0rem)));
}
.cds--slider__thumb-wrapper--upper > .cds--popover > .cds--popover-caret {
  transform: translate(-50%, calc(-1 * 0rem));
  transform: translate(-50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper {
  transform: translate(0, -50%);
}
.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper > .cds--popover > .cds--popover-content {
  transform: translate(0, calc(-100% - 0rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 0rem)));
}
.cds--slider-container--rtl .cds--slider__thumb-wrapper--upper > .cds--popover > .cds--popover-caret {
  transform: translate(50%, calc(-1 * 0rem));
  transform: translate(50%, calc(-1 * var(--cds-popover-offset, 0rem)));
}

.cds--slider__thumb {
  position: absolute;
  border-radius: 50%;
  background: #161616;
  background: var(--cds-layer-selected-inverse, #161616);
  box-shadow: inset 0 0 0 1px transparent, inset 0 0 0 2px transparent;
  inset: 0;
  outline: none;
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background 110ms cubic-bezier(0.2, 0, 0.38, 0.9), box-shadow 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--slider__thumb:hover {
  transform: scale(1.4286);
}
.cds--slider__thumb:focus {
  background-color: var(--color-primary);
  background-color: var(--cds-interactive, #0f62fe);
  box-shadow: inset 0 0 0 2px var(--color-primary), inset 0 0 0 3px #f4f4f4;
  box-shadow: inset 0 0 0 2px var(--cds-interactive, #0f62fe), inset 0 0 0 3px var(--cds-layer);
  transform: scale(1.4286);
}
.cds--slider__thumb:active {
  box-shadow: inset 0 0 0 2px var(--color-primary);
  box-shadow: inset 0 0 0 2px var(--cds-interactive, #0f62fe);
  transform: scale(1.4286);
}

.cds--slider__thumb-icon {
  fill: #161616;
  fill: var(--cds-layer-selected-inverse, #161616);
}

.cds--slider__thumb-icon--focus {
  display: none;
  fill: var(--color-primary);
  fill: var(--cds-interactive, #0f62fe);
}

.cds--slider__thumb--lower,
.cds--slider__thumb--upper {
  position: absolute;
  border-radius: 0;
  border-radius: initial;
  background-color: transparent;
  box-shadow: none;
  inset: 0;
  transition: none;
}
.cds--slider__thumb--lower::before,
.cds--slider__thumb--upper::before {
  position: absolute;
  z-index: -1;
  display: block;
  background: #ffffff;
  background: var(--cds-background, #ffffff);
  block-size: 0.125rem;
  content: "";
  inline-size: 0.375rem;
  inset-block-start: calc(50% - 0.0625rem);
  inset-inline-end: 0;
}
.cds--slider__thumb--lower:hover,
.cds--slider__thumb--upper:hover {
  transform: none;
}
.cds--slider__thumb--lower:hover .cds--slider__thumb-icon,
.cds--slider__thumb--upper:hover .cds--slider__thumb-icon {
  fill: #525252;
  fill: var(--cds-text-secondary, #525252);
}
.cds--slider__thumb--lower:active,
.cds--slider__thumb--upper:active {
  box-shadow: none;
  transform: none;
}
.cds--slider__thumb--lower:focus,
.cds--slider__thumb--upper:focus {
  background-color: transparent;
  box-shadow: none;
  transform: none;
}
.cds--slider__thumb--lower:focus .cds--slider__thumb-icon,
.cds--slider__thumb--upper:focus .cds--slider__thumb-icon {
  display: none;
  fill: var(--color-primary);
  fill: var(--cds-interactive, #0f62fe);
}
.cds--slider__thumb--lower:focus .cds--slider__thumb-icon--focus,
.cds--slider__thumb--upper:focus .cds--slider__thumb-icon--focus {
  display: block;
}

.cds--slider__thumb--lower:focus::before,
.cds--slider__thumb--upper:focus::before {
  inline-size: 100%;
}

.cds--slider__thumb--upper {
  transform: none;
}
.cds--slider__thumb--upper::before {
  inset-inline: 0 auto;
}
.cds--slider__thumb--upper:hover, .cds--slider__thumb--upper:active, .cds--slider__thumb--upper:focus {
  transform: none;
}

.cds--slider__input {
  display: none;
}

.cds--slider-text-input-wrapper {
  position: relative;
}

.cds--slider-text-input-wrapper--hidden {
  display: none;
}

.cds--slider-text-input,
.cds-slider-text-input {
  -webkit-appearance: textfield;
          appearance: textfield;
  block-size: 2.5rem;
  inline-size: 4rem;
}
.cds--slider-text-input::-webkit-outer-spin-button, .cds--slider-text-input::-webkit-inner-spin-button,
.cds-slider-text-input::-webkit-outer-spin-button,
.cds-slider-text-input::-webkit-inner-spin-button {
  display: none;
}

.cds--slider__thumb:focus ~ .cds--slider__filled-track,
.cds--slider__thumb-wrapper:focus-within ~ .cds--slider__filled-track {
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
}

.cds--slider-text-input.cds--text-input--invalid,
.cds--slider-text-input--warn {
  inline-size: 6rem;
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--slider__invalid-icon {
  position: absolute;
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  transform: translateY(-50%);
}

.cds--slider__validation-msg.cds--form-requirement {
  display: block;
  overflow: visible;
  max-block-size: 100%;
}

.cds--slider__validation-msg--invalid {
  color: #da1e28;
  color: var(--cds-text-error, #da1e28);
}

.cds--slider__invalid-icon.cds--slider__invalid-icon--warning {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--slider__invalid-icon--warning path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--label--disabled ~ .cds--slider-container > .cds--slider__range-label {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--slider--disabled.cds--slider {
  cursor: not-allowed;
}

.cds--slider--disabled .cds--slider__thumb {
  background-color: #c6c6c6;
  background-color: var(--cds-border-disabled, #c6c6c6);
}
.cds--slider--disabled .cds--slider__thumb:hover {
  cursor: not-allowed;
  transform: none;
}
.cds--slider--disabled .cds--slider__thumb:focus {
  background-color: #c6c6c6;
  background-color: var(--cds-border-disabled, #c6c6c6);
  box-shadow: none;
  outline: none;
  transform: none;
}
.cds--slider--disabled .cds--slider__thumb:active {
  background: #c6c6c6;
  background: var(--cds-border-disabled, #c6c6c6);
  box-shadow: none;
  transform: none;
}

.cds--slider--disabled .cds--slider__thumb--lower,
.cds--slider--disabled .cds--slider__thumb--upper {
  background-color: transparent;
}
.cds--slider--disabled .cds--slider__thumb--lower:active, .cds--slider--disabled .cds--slider__thumb--lower:hover, .cds--slider--disabled .cds--slider__thumb--lower:focus,
.cds--slider--disabled .cds--slider__thumb--upper:active,
.cds--slider--disabled .cds--slider__thumb--upper:hover,
.cds--slider--disabled .cds--slider__thumb--upper:focus {
  background-color: transparent;
  transform: none;
}
.cds--slider--disabled .cds--slider__thumb--lower .cds--slider__thumb-icon,
.cds--slider--disabled .cds--slider__thumb--upper .cds--slider__thumb-icon {
  fill: #c6c6c6;
  fill: var(--cds-border-disabled, #c6c6c6);
}

.cds--slider--disabled .cds--slider__track,
.cds--slider--disabled .cds--slider__filled-track,
.cds--slider--disabled .cds--slider__thumb:focus ~ .cds--slider__filled-track {
  background-color: #c6c6c6;
  background-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--slider--disabled ~ .cds--form-item .cds--slider-text-input,
.cds--slider--disabled ~ .cds--slider-text-input {
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  transition: none;
}
.cds--slider--disabled ~ .cds--form-item .cds--slider-text-input:active, .cds--slider--disabled ~ .cds--form-item .cds--slider-text-input:focus, .cds--slider--disabled ~ .cds--form-item .cds--slider-text-input:hover,
.cds--slider--disabled ~ .cds--slider-text-input:active,
.cds--slider--disabled ~ .cds--slider-text-input:focus,
.cds--slider--disabled ~ .cds--slider-text-input:hover {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}

.cds--slider--readonly {
  cursor: default;
}

.cds--slider-container--readonly .cds--slider__thumb {
  block-size: 0;
  inline-size: 0;
}
.cds--slider-container--readonly .cds--slider__thumb::before, .cds--slider-container--readonly .cds--slider__thumb::after {
  display: none;
}

.cds--slider-container--readonly .cds--slider-text-input {
  background-color: transparent;
}

.cds--slider__status-msg.cds--form-requirement {
  display: block;
  overflow: visible;
  max-block-size: 100%;
}

.cds--slider-container.cds--skeleton .cds--slider__range-label {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--slider-container.cds--skeleton .cds--slider__range-label:hover, .cds--slider-container.cds--skeleton .cds--slider__range-label:focus, .cds--slider-container.cds--skeleton .cds--slider__range-label:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--slider-container.cds--skeleton .cds--slider__range-label::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--slider-container.cds--skeleton .cds--slider__range-label::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--slider-container.cds--skeleton .cds--slider__range-label {
    background: CanvasText;
  }
  .cds--slider-container.cds--skeleton .cds--slider__range-label::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--slider-container.cds--skeleton .cds--slider__range-label {
  block-size: 0.75rem;
  inline-size: 1.25rem;
}

.cds--slider-container.cds--skeleton .cds--slider__track {
  cursor: default;
  pointer-events: none;
}

.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper {
  inset-inline-start: 50%;
}
.cds--slider-container.cds--skeleton .cds--slider__thumb {
  cursor: default;
  pointer-events: none;
}
.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper--lower {
  inset-inline-start: 0;
}
.cds--slider-container.cds--skeleton .cds--slider__thumb-wrapper--upper {
  inset-inline-start: 100%;
}

.cds--popover-container.cds--slider__thumb-wrapper {
  position: absolute;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--slider__thumb {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--slider__thumb:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--slider__track {
    outline: 1px solid transparent;
  }
}

@keyframes ai-skeleton-animation {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
.cds--icon--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--icon--skeleton:hover, .cds--icon--skeleton:focus, .cds--icon--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--icon--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--icon--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--icon--skeleton {
    background: CanvasText;
  }
  .cds--icon--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--icon--skeleton {
  display: inline-block;
  block-size: 1rem;
  inline-size: 1rem;
}

.cds--skeleton__placeholder {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--skeleton__placeholder:hover, .cds--skeleton__placeholder:focus, .cds--skeleton__placeholder:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--skeleton__placeholder::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--skeleton__placeholder::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--skeleton__placeholder {
    background: CanvasText;
  }
  .cds--skeleton__placeholder::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--skeleton__placeholder {
  block-size: 6.25rem;
  inline-size: 6.25rem;
}

.cds--skeleton__text {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--skeleton__text:hover, .cds--skeleton__text:focus, .cds--skeleton__text:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--skeleton__text::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--skeleton__text::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--skeleton__text {
    background: CanvasText;
  }
  .cds--skeleton__text::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--skeleton__text {
  block-size: 1rem;
  inline-size: 100%;
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
}

.cds--skeleton__heading {
  block-size: 1.5rem;
}

.cds--skeleton__text--ai,
.cds--skeleton__placeholder--ai,
.cds--skeleton__icon--ai {
  overflow: hidden;
  background: #d0e2ff;
  background: var(--cds-ai-skeleton-background, #d0e2ff);
}

.cds--skeleton__text--ai::before,
.cds--skeleton__placeholder--ai::before,
.cds--skeleton__icon--ai::before {
  animation: 1250ms ease-in-out ai-skeleton-animation infinite;
  background: linear-gradient(to right, rgba(69, 137, 255, 0) 0%, rgba(69, 137, 255, 0.5) 50%, rgba(69, 137, 255, 0) 100%);
}

.cds--skeleton__placeholder--ai::before,
.cds--skeleton__icon--ai::before {
  inline-size: 200%;
}

.cds--skeleton__placeholder--ai {
  border-radius: 0.5rem;
}

.cds--skeleton__text--ai {
  border-radius: 1rem;
}

.cds--skeleton__icon--ai {
  border-radius: 0.125rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--skeleton__text--ai,
  .cds--skeleton__placeholder--ai,
  .cds--skeleton__icon--ai {
    background: CanvasText;
  }
  .cds--skeleton__text--ai::before,
  .cds--skeleton__placeholder--ai::before,
  .cds--skeleton__icon--ai::before {
    background: Canvas;
  }
}
.cds--data-table-container {
  position: relative;
  -webkit-padding-before: 0.125rem;
          padding-block-start: 0.125rem;
}

.cds--data-table-content {
  display: block;
  overflow-x: auto;
}

.cds--data-table-content:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--data-table-content:focus {
    outline-style: dotted;
  }
}

.cds--data-table-container--ai-enabled {
  position: relative;
  padding: 1px;
  border: none;
}

.cds--data-table-container--ai-enabled::after {
  position: absolute;
  z-index: -1;
  background-image: linear-gradient(to top, #78a9ff, rgba(166, 200, 255, 0.64));
  background-image: linear-gradient(to top, var(--cds-ai-border-end, #78a9ff), var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)));
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset: 0;
  pointer-events: none;
}

.cds--data-table-container--ai-enabled tbody {
  position: relative;
}

.cds--data-table-container--ai-enabled tbody::before {
  position: absolute;
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(to top, rgba(69, 137, 255, 0.1) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
  background: linear-gradient(to top, var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

.cds--data-table-header {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  padding-block: 1rem 1.5rem;
  padding-inline: 1rem;
}

.cds--data-table-header.cds--data-table-header__with-decorator {
  display: flex;
  justify-content: space-between;
}

.cds--data-table-header.cds--data-table-header__with-decorator.cds--data-table-header__with-decorator--standalone {
  justify-content: flex-end;
}

.cds--data-table-header__title {
  font-size: 1.25rem;
  font-size: var(--cds-heading-03-font-size, 1.25rem);
  font-weight: 400;
  font-weight: var(--cds-heading-03-font-weight, 400);
  line-height: 1.4;
  line-height: var(--cds-heading-03-line-height, 1.4);
  letter-spacing: 0;
  letter-spacing: var(--cds-heading-03-letter-spacing, 0);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--data-table-header__description {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}
@media (min-width: 42rem) {
  .cds--data-table-header__description {
    max-inline-size: 50ch;
  }
}
@media (min-width: 66rem) {
  .cds--data-table-header__description {
    max-inline-size: 80ch;
  }
}

.cds--data-table {
  border-collapse: collapse;
  border-spacing: 0;
  inline-size: 100%;
}

.cds--data-table thead {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
}

.cds--data-table tbody {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
}

.cds--data-table tr {
  border: none;
  block-size: 3rem;
  inline-size: 100%;
}

.cds--data-table tbody tr,
.cds--data-table tbody tr td,
.cds--data-table tbody tr th {
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--data-table tbody tr:not([data-child-row]):hover,
.cds--data-table tbody tr[data-child-row]:hover > td {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--data-table tbody tr:hover td,
.cds--data-table tbody tr:hover th {
  -webkit-border-after: 1px solid #e8e8e8;
          border-block-end: 1px solid #e8e8e8;
  -webkit-border-after: 1px solid var(--cds-layer-hover);
          border-block-end: 1px solid var(--cds-layer-hover);
  -webkit-border-before: 1px solid #e8e8e8;
          border-block-start: 1px solid #e8e8e8;
  -webkit-border-before: 1px solid var(--cds-layer-hover);
          border-block-start: 1px solid var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--data-table tr:hover .cds--link:not(.cds--popover-container .cds--link) {
  color: #0043ce;
  color: var(--cds-link-secondary, #0043ce);
}

.cds--data-table tr:hover .cds--link--disabled:not(.cds--popover-container .cds--link) {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--data-table th,
.cds--data-table td {
  text-align: start;
  vertical-align: middle;
}

.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand) {
  padding-block: 1rem 1rem;
}
.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-menu {
  -webkit-padding-before: 0.5rem;
          padding-block-start: 0.5rem;
}
.cds--data-table.cds--data-table--top-aligned-body.cds--data-table--lg tr:not([data-child-row]) td:not(.cds--table-expand).cds--table-column-checkbox:not(.cds--table-column-radio) {
  -webkit-padding-before: 0.8125rem;
          padding-block-start: 0.8125rem;
}
.cds--data-table.cds--data-table--top-aligned-body td {
  vertical-align: top;
}

.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header) {
  padding-block: 1rem 1rem;
}
.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-menu {
  -webkit-padding-before: 0.5rem;
          padding-block-start: 0.5rem;
}
.cds--data-table.cds--data-table--top-aligned-header.cds--data-table--lg th:not(.cds--table-expand):not(.cds--table-sort__header).cds--table-column-checkbox {
  -webkit-padding-before: 0.8125rem;
          padding-block-start: 0.8125rem;
}
.cds--data-table.cds--data-table--top-aligned-header th {
  vertical-align: top;
}

.cds--data-table th[align=right],
.cds--data-table td[align=right] {
  text-align: end;
}

.cds--data-table th[align=center],
.cds--data-table td[align=center] {
  text-align: center;
}

.cds--data-table th {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  padding-inline: 1rem 1rem;
}

.cds--data-table th:last-of-type {
  position: static;
  inline-size: auto;
}

.cds--data-table .cds--table-header-label {
  text-align: start;
}

.cds--data-table td,
.cds--data-table tbody th {
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-border-subtle-01, #c6c6c6);
          border-block-end: 1px solid var(--cds-border-subtle-01, #c6c6c6);
  -webkit-border-before: 1px solid #f4f4f4;
          border-block-start: 1px solid #f4f4f4;
  -webkit-border-before: 1px solid var(--cds-layer);
          border-block-start: 1px solid var(--cds-layer);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  padding-inline: 1rem 1rem;
}
.cds--data-table td + td:first-of-type,
.cds--data-table tbody th + td:first-of-type {
  -webkit-padding-start: 0.75rem;
          padding-inline-start: 0.75rem;
}

.cds--layer-two .cds--data-table td,
.cds--layer-two .cds--data-table tbody th {
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle-02, #e0e0e0);
          border-block-end: 1px solid var(--cds-border-subtle-02, #e0e0e0);
}

.cds--layer-three .cds--data-table td,
.cds--layer-three .cds--data-table tbody th {
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-border-subtle-03, #c6c6c6);
          border-block-end: 1px solid var(--cds-border-subtle-03, #c6c6c6);
}

@supports (-moz-appearance: none) {
  .cds--data-table td {
    background-clip: padding-box;
  }
}
.cds--data-table .cds--list-box input[role=combobox],
.cds--data-table .cds--list-box input[type=text],
.cds--data-table .cds--dropdown,
.cds--data-table .cds--list-box,
.cds--data-table .cds--number input[type=number],
.cds--data-table .cds--number input[type=text],
.cds--data-table .cds--number__control-btn::before,
.cds--data-table .cds--number__control-btn::after,
.cds--data-table .cds--text-input,
.cds--data-table .cds--select-input {
  background-color: #ffffff;
  background-color: var(--cds-field-02, #ffffff);
}

.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=false]:focus {
    outline-style: dotted;
  }
}

.cds--data-table td.cds--table-column-menu .cds--overflow-menu[aria-expanded=true]:focus {
  outline: none;
}

@media screen and (hover: hover), (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .cds--data-table td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon {
    opacity: 0;
  }
}
.cds--data-table td.cds--table-column-menu .cds--overflow-menu.cds--overflow-menu--open .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--data-table.cds--data-table--visible-overflow-menu td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon,
.cds--data-table td.cds--table-column-menu .cds--overflow-menu:hover .cds--overflow-menu__icon,
.cds--data-table td.cds--table-column-menu .cds--overflow-menu:focus .cds--overflow-menu__icon,
.cds--data-table tr:hover td.cds--table-column-menu .cds--overflow-menu .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--table-row--menu-option .cds--overflow-menu-options__btn .cds--overflow-menu-options__option-content svg {
  position: relative;
  inset-block-start: 0.1875rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--data-table .cds--overflow-menu:hover,
.cds--data-table .cds--overflow-menu__trigger:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--data-table--selected .cds--overflow-menu:hover,
.cds--data-table--selected .cds--overflow-menu__trigger:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--data-table--selected .cds--link:not(.cds--link--disabled) {
  color: #0043ce;
  color: var(--cds-link-secondary, #0043ce);
}

.cds--data-table--xs td.cds--table-column-menu,
.cds--data-table--sm td.cds--table-column-menu {
  block-size: 1.5rem;
  padding-block: 0;
}

.cds--data-table--sm td.cds--table-column-menu {
  block-size: 2rem;
}

.cds--data-table--md td.cds--table-column-menu {
  block-size: 2.5rem;
}

.cds--data-table--xl .cds--table-column-menu {
  -webkit-padding-before: 0.5rem;
          padding-block-start: 0.5rem;
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(odd) td {
  -webkit-border-after: 1px solid #f4f4f4;
          border-block-end: 1px solid #f4f4f4;
  -webkit-border-after: 1px solid var(--cds-layer);
          border-block-end: 1px solid var(--cds-layer);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):nth-child(even) td {
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-layer-accent);
          border-block-end: 1px solid var(--cds-layer-accent);
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-layer-accent);
          border-block-start: 1px solid var(--cds-layer-accent);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):nth-child(even) {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):hover td {
  -webkit-border-after: 1px solid #e8e8e8;
          border-block-end: 1px solid #e8e8e8;
  -webkit-border-after: 1px solid var(--cds-layer-hover);
          border-block-end: 1px solid var(--cds-layer-hover);
  -webkit-border-before: 1px solid #e8e8e8;
          border-block-start: 1px solid #e8e8e8;
  -webkit-border-before: 1px solid var(--cds-layer-hover);
          border-block-start: 1px solid var(--cds-layer-hover);
}

.cds--data-table--zebra tbody tr:not(.cds--parent-row):not(.cds--data-table--selected):hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--table-column-checkbox .cds--checkbox-label {
  min-block-size: 1.5rem;
  -webkit-padding-start: 0;
          padding-inline-start: 0;
}

.cds--table-column-checkbox .cds--checkbox-label::before {
  -webkit-margin-before: 0.125rem;
          margin-block-start: 0.125rem;
}

.cds--table-column-checkbox .cds--checkbox-label::after {
  inset-block-start: 0.46875rem;
}

.cds--data-table th.cds--table-column-checkbox {
  position: static;
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
  inline-size: 2rem;
  transition: background-color 70ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--data-table thead th.cds--table-column-checkbox,
.cds--data-table tbody td.cds--table-column-checkbox,
.cds--data-table thead th.cds--table-expand,
.cds--data-table tbody td.cds--table-expand {
  min-inline-size: 0;
}

.cds--data-table thead th.cds--table-column-checkbox,
.cds--data-table tbody td.cds--table-column-checkbox {
  min-inline-size: 2.5rem;
  padding-inline: 1rem 0.25rem;
}

.cds--data-table thead th.cds--table-expand,
.cds--data-table tbody td.cds--table-expand {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--data-table--xs thead th.cds--table-expand,
.cds--data-table--xs tbody td.cds--table-expand {
  padding: 0 0 0 0.5rem;
  block-size: 1.5rem;
  inline-size: 1.5rem;
}

.cds--data-table--sm thead th.cds--table-expand,
.cds--data-table--sm tbody td.cds--table-expand {
  padding: 0;
  block-size: 2rem;
  inline-size: 2rem;
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}

.cds--data-table--md thead th.cds--table-expand,
.cds--data-table--md tbody td.cds--table-expand {
  padding: 0.25rem 0 0.25rem 0.5rem;
  block-size: 2.5rem;
  inline-size: 2.5rem;
}

.cds--data-table--xl thead th.cds--table-expand,
.cds--data-table--xl tbody td.cds--table-expand {
  block-size: 4rem;
  padding-block: 0.625rem 1.375rem;
}

.cds--data-table--xl .cds--table-column-checkbox {
  -webkit-padding-before: 0.8125rem;
          padding-block-start: 0.8125rem;
}

.cds--data-table--xl .cds--table-column-radio {
  -webkit-padding-before: 1rem;
          padding-block-start: 1rem;
}

.cds--table-column-radio {
  inline-size: 48px;
}

.cds--table-column-radio .cds--radio-button__appearance {
  -webkit-margin-end: -0.125rem;
          margin-inline-end: -0.125rem;
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected td,
tr.cds--data-table--selected td {
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-layer-active);
          border-block-end: 1px solid var(--cds-layer-active);
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-layer-selected);
          border-block-start: 1px solid var(--cds-layer-selected);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected,
tr.cds--data-table--selected {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}

.cds--data-table--zebra tbody tr:first-of-type:nth-child(odd).cds--data-table--selected td,
tr.cds--data-table--selected:first-of-type td {
  -webkit-border-before: 1px solid #c6c6c6;
          border-block-start: 1px solid #c6c6c6;
  -webkit-border-before: 1px solid var(--cds-border-subtle-selected);
          border-block-start: 1px solid var(--cds-border-subtle-selected);
}

.cds--data-table--zebra tbody tr:last-of-type:nth-child(odd).cds--data-table--selected td,
.cds--data-table--zebra tbody tr:last-of-type:nth-child(even).cds--data-table--selected td,
tr.cds--data-table--selected:last-of-type td {
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-layer-selected);
          border-block-end: 1px solid var(--cds-layer-selected);
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-layer-selected);
          border-block-start: 1px solid var(--cds-layer-selected);
}

.cds--data-table--zebra tbody tr:nth-child(even).cds--data-table--selected td {
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-layer-active);
          border-block-end: 1px solid var(--cds-layer-active);
}

.cds--data-table--zebra tbody tr:nth-child(even).cds--data-table--selected:hover td {
  -webkit-border-after: 1px solid #d1d1d1;
          border-block-end: 1px solid #d1d1d1;
  -webkit-border-after: 1px solid var(--cds-layer-selected-hover);
          border-block-end: 1px solid var(--cds-layer-selected-hover);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover td,
.cds--data-table tbody .cds--data-table--selected:hover td {
  -webkit-border-after: 1px solid #d1d1d1;
          border-block-end: 1px solid #d1d1d1;
  -webkit-border-after: 1px solid var(--cds-layer-selected-hover);
          border-block-end: 1px solid var(--cds-layer-selected-hover);
  -webkit-border-before: 1px solid #d1d1d1;
          border-block-start: 1px solid #d1d1d1;
  -webkit-border-before: 1px solid var(--cds-layer-selected-hover);
          border-block-start: 1px solid var(--cds-layer-selected-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--data-table--zebra tbody tr:nth-child(odd).cds--data-table--selected:hover,
.cds--data-table tbody .cds--data-table--selected:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--data-table--selected .cds--overflow-menu .cds--overflow-menu__icon {
  opacity: 1;
}

.cds--data-table--xs thead tr,
.cds--data-table--xs tbody tr,
.cds--data-table--xs tbody tr th {
  block-size: 1.5rem;
}

.cds--data-table--xs .cds--table-header-label {
  padding-block: 0.125rem 0.125rem;
}

.cds--data-table--xs td,
.cds--data-table--xs tbody tr th {
  padding-block: 0.125rem 0.125rem;
}

.cds--data-table--xs .cds--overflow-menu {
  block-size: calc(100% + 1px);
  inline-size: 2rem;
}

.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--xs:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block: 0;
}

.cds--data-table.cds--data-table--xs .cds--table-column-checkbox .cds--checkbox-label {
  block-size: 1.4375rem;
  min-block-size: 1.4375rem;
}

.cds--data-table--sm thead tr,
.cds--data-table--sm tbody tr,
.cds--data-table--sm tbody tr th {
  block-size: 2rem;
}

.cds--data-table--sm .cds--table-header-label {
  padding-block: 0.4375rem 0.4375rem;
}

.cds--data-table--sm td,
.cds--data-table--sm tbody tr th,
.cds--data-table--sm.cds--data-table--top-aligned-header th.cds--table-column-checkbox {
  padding-block: 0.4375rem 0.375rem;
}

.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--sm:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block: 0.1875rem 0.1875rem;
}

.cds--data-table--sm .cds--overflow-menu {
  block-size: calc(100% + 1px);
}

.cds--data-table--md thead tr,
.cds--data-table--md tbody tr,
.cds--data-table--md tbody tr th {
  block-size: 2.5rem;
}

.cds--data-table--md .cds--table-header-label,
.cds--data-table--md.cds--data-table--top-aligned-header th.cds--table-column-checkbox {
  padding-block: 0.4375rem 0.4375rem;
}

.cds--data-table--md td,
.cds--data-table--md tbody tr th {
  padding-block: 0.4375rem 0.375rem;
}

.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-body) td.cds--table-column-checkbox,
.cds--data-table.cds--data-table--md:not(.cds--data-table--top-aligned-header) th.cds--table-column-checkbox {
  padding-block: 0.1875rem 0.1875rem;
}

.cds--data-table--md .cds--table-column-menu {
  padding-block: 0.1875rem 0.1875rem;
}

.cds--data-table--xl thead tr,
.cds--data-table--xl tbody tr,
.cds--data-table--xl tbody tr th {
  block-size: 4rem;
}

.cds--data-table--xl .cds--table-header-label {
  padding-block: 1rem 1rem;
}

.cds--data-table--xl td,
.cds--data-table--xl tbody tr th {
  padding-block: 1rem 1rem;
}

.cds--data-table--xl th,
.cds--data-table--xl td {
  vertical-align: top;
}

.cds--data-table--xl .cds--data-table--cell-secondary-text {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--data-table--static {
  inline-size: auto;
}

.cds--data-table-container--static {
  inline-size: -webkit-fit-content;
  inline-size: fit-content;
}

.cds--data-table_inner-container {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
  transform: translateZ(0);
}

.cds--data-table--sticky-header {
  display: block;
  overflow-y: scroll;
}
.cds--data-table--sticky-header thead,
.cds--data-table--sticky-header tbody,
.cds--data-table--sticky-header tr,
.cds--data-table--sticky-header th,
.cds--data-table--sticky-header td {
  display: flex;
}
.cds--data-table--sticky-header thead {
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  overflow: scroll;
  inline-size: 100%;
  inset-block-start: 0;
  -ms-overflow-style: none;
  will-change: transform;
}
.cds--data-table--sticky-header thead tr th {
  -webkit-border-after: 1px solid #c6c6c6;
          border-block-end: 1px solid #c6c6c6;
  -webkit-border-after: 1px solid var(--cds-layer-active);
          border-block-end: 1px solid var(--cds-layer-active);
}
.cds--data-table--sticky-header tbody {
  flex-direction: column;
  -ms-overflow-style: none;
  overflow-x: scroll;
  will-change: transform;
}
.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row {
  block-size: auto;
  min-block-size: 3rem;
}
.cds--data-table--sticky-header tr.cds--expandable-row:not(.cds--parent-row) {
  block-size: auto;
}
.cds--data-table--sticky-header .cds--table-expand {
  max-inline-size: 3rem;
}
.cds--data-table--sticky-header thead .cds--table-expand {
  align-items: center;
}
.cds--data-table--sticky-header .cds--parent-row {
  min-block-size: 3rem;
}
.cds--data-table--sticky-header:not(.cds--data-table--xs):not(.cds--data-table--xl):not(.cds--data-table--sm) td:not(.cds--table-column-menu):not(.cds--table-column-checkbox) {
  -webkit-padding-before: 0.875rem;
          padding-block-start: 0.875rem;
}
.cds--data-table--sticky-header tr.cds--parent-row.cds--expandable-row:hover + tr[data-child-row] td {
  -webkit-border-before: 1px solid #e8e8e8;
          border-block-start: 1px solid #e8e8e8;
  -webkit-border-before: 1px solid var(--cds-layer-hover);
          border-block-start: 1px solid var(--cds-layer-hover);
}
.cds--data-table--sticky-header tr.cds--expandable-row:last-of-type {
  overflow: hidden;
}
.cds--data-table--sticky-header tr.cds--data-table--selected:first-of-type td {
  -webkit-border-before: none;
          border-block-start: none;
}
.cds--data-table--sticky-header thead th.cds--table-column-checkbox,
.cds--data-table--sticky-header tbody tr td.cds--table-column-checkbox {
  align-items: center;
  inline-size: 2.25rem;
  min-inline-size: 2.25rem;
}
.cds--data-table--sticky-header.cds--data-table--xl thead th.cds--table-column-checkbox, .cds--data-table--sticky-header.cds--data-table--xl td.cds--table-column-checkbox {
  align-items: flex-start;
}
.cds--data-table--sticky-header {
  /* When using sticky header, with a selection element in the first column, we need to set the last item to a fixed width to match the table body. We only want this to happen when the last table header does not have any text */
}
.cds--data-table--sticky-header th.cds--table-column-checkbox ~ th:last-of-type:empty {
  max-inline-size: 4rem;
}
.cds--data-table--sticky-header th:empty:not(.cds--table-expand) {
  max-inline-size: 2.25rem;
}
.cds--data-table--sticky-header td.cds--table-column-menu {
  align-items: center;
  block-size: auto;
  -webkit-padding-before: 0;
          padding-block-start: 0;
}
.cds--data-table--sticky-header thead::-webkit-scrollbar,
.cds--data-table--sticky-header tbody::-webkit-scrollbar {
  display: none;
}
.cds--data-table--sticky-header {
  /* This is for targeting styles specific to firefox */
  /* To hide the firefox scrollbar */
  /* https://sass-lang.com/documentation/breaking-changes/moz-document/ */
  /* stylelint-disable-next-line at-rule-no-vendor-prefix */
}
@-moz-document url-prefix() {
  .cds--data-table--sticky-header thead,
  .cds--data-table--sticky-header tbody {
    scrollbar-width: none;
  }
}
.cds--data-table--sticky-header tbody tr:last-of-type {
  -webkit-border-after: 0;
          border-block-end: 0;
}
.cds--data-table--sticky-header th:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon),
.cds--data-table--sticky-header td:not(.cds--table-column-checkbox):not(.cds--table-column-menu):not(.cds--table-expand):not(.cds--table-column-icon) {
  inline-size: 100%;
  min-inline-size: 0;
}
.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row), .cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row), .cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row) {
  block-size: auto;
}
.cds--data-table--sticky-header.cds--data-table--xs tr:not(.cds--expandable-row) {
  min-block-size: 1.5rem;
}
.cds--data-table--sticky-header.cds--data-table--sm tr:not(.cds--expandable-row) {
  min-block-size: 2rem;
}
.cds--data-table--sticky-header.cds--data-table--xl tr:not(.cds--expandable-row) {
  min-block-size: 4rem;
}
.cds--data-table--sticky-header.cds--data-table--xs tr td.cds--table-expand {
  -webkit-padding-before: 0.25rem;
          padding-block-start: 0.25rem;
}
.cds--data-table--sticky-header.cds--data-table--sm tr td.cds--table-expand {
  -webkit-padding-before: 0.5rem;
          padding-block-start: 0.5rem;
}
.cds--data-table--sticky-header .cds--table-header-label {
  display: block;
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-inline-size: calc(100% - 10px);
  overflow-y: hidden;
  padding-block: 0.9375rem 1rem;
}
.cds--data-table--sticky-header.cds--data-table--xs th .cds--table-header-label {
  padding-block: 0.1875rem 0;
}
.cds--data-table--sticky-header.cds--data-table--sm th .cds--table-header-label {
  padding-block: 0.5rem 0;
}
.cds--data-table--sticky-header.cds--data-table--xl th .cds--table-header-label {
  -webkit-padding-before: 1rem;
          padding-block-start: 1rem;
}
.cds--data-table--sticky-header.cds--data-table--xl th.cds--table-expand {
  display: flex;
  align-items: flex-start;
}
.cds--data-table--sticky-header.cds--data-table--xs tr.cds--parent-row .cds--table-column-checkbox, .cds--data-table--sticky-header.cds--data-table--sm tr.cds--parent-row .cds--table-column-checkbox {
  align-items: flex-start;
}

.cds--data-table--max-width {
  max-inline-size: 100%;
}

.cds--data-table--sticky-header {
  max-block-size: 18.75rem;
}

.cds--data-table .cds--form-item.cds--checkbox-wrapper:last-of-type {
  margin: 0;
}

.cds--data-table--xs .cds--form-item.cds--checkbox-wrapper:last-of-type,
.cds--data-table--sm .cds--form-item.cds--checkbox-wrapper:last-of-type {
  margin: -0.1875rem 0;
}

.cds--data-table .cds--table-column-slug,
.cds--data-table .cds--table-column-decorator {
  inline-size: 1rem;
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}

tr.cds--data-table--slug-row,
tr.cds--data-table--slug-row + .cds--expandable-row,
tr.cds--data-table--ai-label-row,
tr.cds--data-table--ai-label-row + .cds--expandable-row {
  background: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
  background-attachment: fixed;
}

.cds--data-table--slug-row,
.cds--data-table--ai-label-row {
  box-shadow: inset 1px 0 #4589ff;
  box-shadow: inset 1px 0 var(--cds-ai-border-strong, #4589ff);
}

.cds--data-table tbody tr.cds--data-table--ai-label-row:hover td,
tr.cds--data-table--ai-label-row.cds--expandable-row:hover + .cds--expandable-row[data-child-row] td,
tr.cds--data-table--ai-label-row.cds--expandable-row--hover + .cds--expandable-row[data-child-row]:hover > td,
tr.cds--data-table--ai-label-row.cds--expandable-row--hover > td,
tr.cds--data-table--selected.cds--data-table--ai-label-row.cds--expandable-row + tr.cds--expandable-row[data-child-row] > td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:first-of-type,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected:not(.cds--expandable-row):hover > td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover + tr[data-child-row] > td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover > td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row--hover > td:first-of-type {
  background-color: transparent;
}

.cds--data-table tbody tr.cds--data-table--ai-label-row:hover,
tr.cds--data-table--ai-label-row:hover + .cds--expandable-row[data-child-row],
tr.cds--data-table--ai-label-row.cds--expandable-row--hover + .cds--expandable-row[data-child-row]:hover,
tr.cds--expandable-row--hover.cds--data-table--ai-label-row,
tr.cds--data-table--selected.cds--parent-row.cds--expandable-row--hover.cds--data-table--ai-label-row {
  background: linear-gradient(to right, rgba(69, 137, 255, 0.32) 0%, 15%, rgba(255, 255, 255, 0) 50%), #edf5ff;
  background: linear-gradient(to right, var(--cds-ai-aura-hover-start, rgba(69, 137, 255, 0.32)) 0%, 15%, var(--cds-ai-aura-hover-end, rgba(255, 255, 255, 0)) 50%), var(--cds-ai-aura-hover-background, #edf5ff);
  background-attachment: fixed;
}

tr.cds--parent-row.cds--data-table--selected.cds--data-table--slug-row,
.cds--data-table--selected.cds--data-table--slug-row,
tr.cds--data-table--selected.cds--data-table--slug-row + .cds--expandable-row,
tr.cds--parent-row.cds--data-table--selected.cds--data-table--ai-label-row,
.cds--data-table--selected.cds--data-table--ai-label-row,
tr.cds--data-table--selected.cds--data-table--ai-label-row + .cds--expandable-row {
  background: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%), #e0e0e0;
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%), var(--cds-layer-selected);
  background-attachment: fixed;
}

tr.cds--data-table--ai-label-row.cds--data-table--selected td,
tr.cds--data-table--ai-label-row.cds--data-table--selected:hover td,
tbody tr.cds--data-table--ai-label-row:hover td,
tr.cds--data-table--ai-label-row.cds--parent-row.cds--data-table--selected.cds--expandable-row:hover td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug) {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}

tr.cds--expandable-row.cds--data-table--selected.cds--data-table--slug-row[data-parent-row] > td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug),
tr.cds--expandable-row.cds--data-table--selected.cds--data-table--slug-row[data-parent-row] > td:not(.cds--table-expand):not(.cds--table-column-checkbox):not(.cds--table-column-slug) {
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-layer-selected);
          border-block-end: 1px solid var(--cds-layer-selected);
}

tr.cds--parent-row.cds--data-table--slug-row.cds--expandable-row:hover td:first-of-type,
tr.cds--parent-row.cds--data-table--ai-label-row.cds--expandable-row:hover td:first-of-type,
tr.cds--parent-row.cds--data-table--decoratorß-row.cds--expandable-row:hover td:first-of-type {
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
}

.cds--data-table thead th.cds--table-sort__header--slug .cds--table-sort,
.cds--data-table thead th:has(> .cds--table-header-label--slug),
.cds--data-table thead th.cds--table-sort__header--ai-label .cds--table-sort,
.cds--data-table thead th:has(> .cds--table-header-label--ai-label) {
  background: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

.cds--table-column-slug .cds--ai-label,
.cds--table-column-slug .cds--slug,
.cds--table-column-decorator .cds--decorator {
  position: absolute;
  z-index: 2;
  transform: translateY(-50%);
}

.cds--data-table--xl .cds--table-column-slug .cds--ai-label,
.cds--data-table--xl .cds--table-column-slug .cds--slug,
.cds--data-table--xl .cds--table-column-decorator .cds--decorator {
  transform: translateY(1px);
}

th .cds--table-header-label.cds--table-header-label--slug,
th .cds--table-header-label.cds--table-header-label--ai-label,
th .cds--table-header-label.cds--table-header-label--decorator {
  display: flex;
  align-items: center;
}

th .cds--table-header-label.cds--table-header-label--ai-label .cds--ai-label,
th .cds--table-header-label.cds--table-header-label--ai-label .cds--slug,
th .cds--table-header-label.cds--table-header-label--decorator .cds--table-header-label--decorator-inner,
th .cds--table-header-label.cds--table-header-label--ai-label .cds--table-header-label--decorator-inner {
  -webkit-margin-start: auto;
          margin-inline-start: auto;
}

th.cds--table-sort__header--slug,
th:has(.cds--table-header-label--slug),
th.cds--table-sort__header--ai-label,
th:has(.cds--table-header-label--ai-label) {
  box-shadow: inset 0 1px #4589ff;
  box-shadow: inset 0 1px var(--cds-ai-border-strong, #4589ff);
}

td.cds--table-cell--column-slug {
  background: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
  background: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug {
  -webkit-border-before: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
          border-block-start: linear-gradient(to right, rgba(69, 137, 255, 0.16) 0%, rgba(255, 255, 255, 0) 50%, transparent 50%);
  -webkit-border-before: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
          border-block-start: linear-gradient(to right, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 50%);
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  tr.cds--parent-row:not(.cds--expandable-row):not(:first-of-type) td.cds--table-cell--column-slug,
  .cds--data-table-content {
    outline: 1px solid transparent;
  }
}

.cds--table-toolbar {
  position: relative;
  z-index: 1;
  display: flex;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
  min-block-size: 3rem;
}

.cds--toolbar-content {
  display: flex;
  justify-content: flex-end;
  block-size: 3rem;
  inline-size: 100%;
  transform: translate3d(0, 0, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--toolbar-content .cds--search .cds--search-input {
  padding: 0 3rem;
  background-color: transparent;
  block-size: 3rem;
}

.cds--toolbar-content .cds--overflow-menu {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--batch-actions ~ .cds--toolbar-search-container {
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 110ms;
}

.cds--toolbar-search-container-expandable {
  position: relative;
  block-size: 3rem;
  box-shadow: none;
  cursor: pointer;
  inline-size: 3rem;
  transition: width 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
.cds--toolbar-search-container-expandable:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--search.cds--toolbar-search-container-expandable {
  inline-size: 3rem;
}

.cds--toolbar-search-container-expandable .cds--search-input {
  block-size: 100%;
  cursor: pointer;
  opacity: 0;
}

.cds--toolbar-search-container-expandable:not(.cds--toolbar-search-container-active) .cds--search-input {
  padding: 0;
}

.cds--toolbar-search-container-disabled .cds--search-input {
  cursor: not-allowed;
}

.cds--toolbar-search-container-expandable.cds--search .cds--label {
  visibility: hidden;
}

.cds--toolbar-search-container-expandable.cds--search .cds--search-close {
  block-size: 3rem;
  inline-size: 3rem;
}
.cds--toolbar-search-container-expandable.cds--search .cds--search-close::before {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
  block-size: calc(100% - 0.25rem);
  inset-block-start: 0.125rem;
}

.cds--toolbar-search-container-expandable.cds--search .cds--search-close:focus::before {
  background-color: var(--color-primary);
  background-color: var(--cds-focus, #0f62fe);
}

.cds--table-toolbar .cds--search--lg .cds--search-magnifier-icon {
  inset-inline-start: 0;
}

.cds--table-toolbar:not(.cds--table-toolbar--sm) .cds--toolbar-search-container-persistent.cds--search--lg .cds--search-magnifier-icon {
  inset-inline-start: 1rem;
}

.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm:not(.cds--toolbar-search-container-active):not(.cds--toolbar-search-container-persistent) .cds--search-magnifier-icon {
  inset-inline-start: 0;
}

.cds--table-toolbar.cds--table-toolbar--sm .cds--search--sm.cds--toolbar-search-container-active .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--table-toolbar .cds--toolbar-search-container-persistent.cds--search--sm .cds--search-magnifier-icon {
  inset-inline-start: 0.5rem;
}

.cds--toolbar-search-container-expandable .cds--search-magnifier-icon {
  padding: 1rem;
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--toolbar-search-container-expandable.cds--search--disabled .cds--search-magnifier-icon {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: not-allowed;
  transition: background-color none;
}

.cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,
.cds--toolbar-search-container-active .cds--search-magnifier-icon:active,
.cds--toolbar-search-container-active .cds--search-magnifier-icon:hover {
  border: none;
  background-color: transparent;
  outline: none;
}

.cds--toolbar-search-container-active.cds--search {
  inline-size: 100%;
}

.cds--toolbar-search-container-active .cds--search-input {
  opacity: 1;
}

.cds--toolbar-search-container-active .cds--label,
.cds--toolbar-search-container-active .cds--search-input {
  padding: 0 3rem;
  cursor: text;
}

.cds--toolbar-search-container-active .cds--search-input:focus + .cds--search-close {
  border: none;
  box-shadow: none;
  outline: none;
}

.cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown) {
  border: none;
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-close,
.cds--toolbar-search-container-persistent .cds--search-close:hover,
.cds--toolbar-search-container-active .cds--search-close,
.cds--toolbar-search-container-active .cds--search-close:hover {
  border: none;
  background-color: transparent;
}

.cds--toolbar-search-container-persistent .cds--search-close::before {
  display: none;
}

.cds--overflow-menu.cds--toolbar-action {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--overflow-menu.cds--toolbar-action *,
.cds--overflow-menu.cds--toolbar-action *::before,
.cds--overflow-menu.cds--toolbar-action *::after {
  box-sizing: inherit;
}
.cds--overflow-menu.cds--toolbar-action::-moz-focus-inner {
  border: 0;
}
.cds--overflow-menu.cds--toolbar-action {
  display: flex;
  padding: 1rem;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  transition: background 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--toolbar-action {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--toolbar-action *,
.cds--toolbar-action *::before,
.cds--toolbar-action *::after {
  box-sizing: inherit;
}
.cds--toolbar-action::-moz-focus-inner {
  border: 0;
}
.cds--toolbar-action {
  display: flex;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  transition: background 110ms cubic-bezier(0, 0, 0.38, 0.9);
}

.cds--toolbar-action:hover:not([disabled]) {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--toolbar-action[aria-expanded=true],
.cds--toolbar-action:hover[aria-expanded=true] {
  background-color: #ffffff;
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--toolbar-action[disabled] {
  cursor: not-allowed;
}

.cds--toolbar-action[disabled] .cds--toolbar-action__icon {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--toolbar-action:focus:not([disabled]),
.cds--toolbar-action:active:not([disabled]) {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--toolbar-action:focus:not([disabled]),
  .cds--toolbar-action:active:not([disabled]) {
    outline-style: dotted;
  }
}
.cds--toolbar-action:focus:not([disabled]).cds--toolbar-search-container-expandable,
.cds--toolbar-action:active:not([disabled]).cds--toolbar-search-container-expandable {
  outline: none;
}

.cds--toolbar-action ~ .cds--btn {
  margin: 0;
  max-inline-size: none;
  white-space: nowrap;
}

.cds--overflow-menu--data-table {
  block-size: 3rem;
}

.cds--toolbar-action__icon {
  block-size: 1rem;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: auto;
  max-inline-size: 1rem;
}

.cds--toolbar-action__menu,
.cds--toolbar-action__menu.cds--overflow-menu-options::after {
  background-color: #ffffff;
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--toolbar-search-container-persistent {
  position: relative;
  block-size: 3rem;
  inline-size: 100%;
  opacity: 1;
}

.cds--toolbar-search-container-persistent + .cds--toolbar-content {
  position: relative;
  inline-size: auto;
}

.cds--toolbar-search-container-persistent .cds--search {
  position: static;
  position: initial;
}

.cds--toolbar-search-container-persistent .cds--search-magnifier-icon {
  inset-inline-start: 1rem;
}

.cds--toolbar-search-container-persistent .cds--search-input {
  padding: 0 3rem;
  border: none;
  block-size: 3rem;
}

.cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]) {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--toolbar-search-container-persistent .cds--search-input:focus:not([disabled]) {
    outline-style: dotted;
  }
}

.cds--toolbar-search-container-persistent .cds--search-input:hover:not([disabled]) {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-input:active:not([disabled]),
.cds--toolbar-search-container-persistent .cds--search-input:not(:placeholder-shown) {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}

.cds--toolbar-search-container-persistent .cds--search-close {
  block-size: 3rem;
  inline-size: 3rem;
}

.cds--batch-actions--active ~ .cds--toolbar-search-container,
.cds--batch-actions--active ~ .cds--toolbar-content {
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
          clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  transform: translate3d(0, 48px, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--batch-actions {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #0f62fe;
  background-color: var(--cds-background-brand, #0f62fe);
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
          clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
  inset-block-end: 0;
  inset-inline: 0;
  opacity: 0;
  pointer-events: none;
  transform: translate3d(0, 48px, 0);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9), opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9), clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9), opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), -webkit-clip-path 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  will-change: transform;
}

.cds--batch-actions:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--batch-actions:focus {
    outline-style: dotted;
  }
}

.cds--batch-actions--active {
  z-index: 1;
  -webkit-clip-path: polygon(0 0, 300% 0, 300% 300%, 0 300%);
          clip-path: polygon(0 0, 300% 0, 300% 300%, 0 300%);
  opacity: 1;
  pointer-events: all;
  transform: translate3d(0, 0, 0);
}

.cds--action-list {
  display: flex;
  align-items: center;
}

.cds--action-list .cds--btn,
.cds--batch-summary .cds--btn {
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
  padding-inline: 1rem 1rem;
  white-space: nowrap;
}

.cds--action-list .cds--btn:disabled {
  border-color: transparent;
  background-color: transparent;
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
  opacity: 0.5;
}

.cds--action-list .cds--btn .cds--btn__icon {
  position: static;
  fill: #ffffff;
  fill: var(--cds-icon-on-color, #ffffff);
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--action-list .cds--btn .cds--btn__icon .st0 {
  fill: none;
}

.cds--batch-download {
  padding: 0.0625rem;
}

.cds--action-list .cds--btn--primary:focus::before,
.cds--action-list .cds--btn--primary::before,
.cds--action-list .cds--btn--primary:focus::after,
.cds--action-list .cds--btn--primary::after {
  display: none;
}

.cds--action-list .cds--btn--primary:focus,
.cds--batch-summary .cds--btn--primary:focus {
  outline: 2px solid #f4f4f4;
  outline: 2px solid var(--cds-layer);
  outline-offset: -0.125rem;
}

.cds--action-list .cds--btn--primary:nth-child(3):hover + .cds--btn--primary.cds--batch-summary__cancel::before,
.cds--action-list .cds--btn--primary:nth-child(3):focus + .cds--btn--primary.cds--batch-summary__cancel::before {
  opacity: 0;
}

.cds--btn--primary.cds--batch-summary__cancel::before {
  position: absolute;
  display: block;
  border: none;
  background-color: #ffffff;
  background-color: var(--cds-text-on-color, #ffffff);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
  inset-block-start: 0.9375rem;
  inset-inline-start: 0;
  opacity: 1;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--btn--primary.cds--batch-summary__cancel:hover::before {
  opacity: 0;
  transition: opacity 250ms cubic-bezier(0.5, 0, 0.1, 1);
}

.cds--batch-summary {
  position: -webkit-sticky;
  position: sticky;
  z-index: 100000;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  background-color: #0f62fe;
  background-color: var(--cds-background-brand, #0f62fe);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
  inset-inline-start: 0;
  min-block-size: 3rem;
}

.cds--batch-summary__scroll {
  box-shadow: 0.5px 0 0.2px color-mix(in oklab, var(--color-primary) 80%, black);
  box-shadow: 0.5px 0 0.2px var(--cds-link-primary-hover, #0043ce);
}

.cds--batch-summary__para {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--batch-summary__divider {
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}

.cds--table-toolbar--sm {
  block-size: 2rem;
  min-block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-input,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-input {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-close,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-close {
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search-magnifier-icon,
.cds--table-toolbar--sm .cds--toolbar-search-container-persistent .cds--search-magnifier-icon {
  padding: 0.5rem;
  block-size: 2rem;
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-action.cds--toolbar-search-container-persistent {
  inline-size: 100%;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable {
  inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-expandable .cds--search .cds--search-input {
  padding: 0 3rem;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active {
  flex: auto;
  transition: flex 175ms cubic-bezier(0.5, 0, 0.1, 1);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input {
  visibility: inherit;
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
    outline-style: dotted;
  }
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:focus {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:active,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-input:not(:placeholder-shown) {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:focus,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:active,
.cds--table-toolbar--sm .cds--toolbar-search-container-active .cds--search-magnifier-icon:hover {
  outline: 2px solid transparent;
  outline-offset: -2px;
  background-color: transparent;
}
.cds--table-toolbar--sm .cds--overflow-menu.cds--toolbar-action {
  block-size: 2rem;
  inline-size: 2rem;
  min-inline-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-content {
  block-size: 2rem;
}
.cds--table-toolbar--sm .cds--toolbar-content .cds--overflow-menu {
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--search--disabled .cds--search-magnifier-icon:hover {
  background-color: transparent;
}

.cds--table-toolbar--sm .cds--batch-actions .cds--action-list {
  block-size: 2rem;
}

.cds--table-toolbar--sm .cds--toolbar-action {
  padding: 0.5rem 0;
  block-size: 2rem;
  inline-size: 2rem;
}

.cds--table-toolbar--sm .cds--btn--primary {
  block-size: 2rem;
  min-block-size: auto;
  padding-block: 0.375rem;
}

.cds--table-toolbar--sm .cds--btn--primary.cds--batch-summary__cancel::before {
  inset-block-start: 0.5rem;
}

.cds--table-toolbar--sm .cds--toolbar-action ~ .cds--btn {
  overflow: hidden;
  block-size: 2rem;
}

.cds--table-toolbar--sm .cds--batch-summary {
  min-block-size: 2rem;
}

.cds--icon-indicator {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--icon-indicator svg {
  align-self: center;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--icon-indicator--20 {
  font-size: 1rem;
  font-size: var(--cds-body-compact-02-font-size, 1rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-02-font-weight, 400);
  line-height: 1.375;
  line-height: var(--cds-body-compact-02-line-height, 1.375);
  letter-spacing: 0;
  letter-spacing: var(--cds-body-compact-02-letter-spacing, 0);
}

.cds--icon-indicator--failed {
  fill: #da1e28;
  fill: var(--cds-status-red, #da1e28);
}

.cds--icon-indicator--caution-major {
  fill: #ff832b;
  fill: var(--cds-status-orange, #ff832b);
}
.cds--icon-indicator--caution-major path:first-of-type {
  fill: #000000;
}

.cds--icon-indicator--caution-minor {
  fill: #f1c21b;
  fill: var(--cds-status-yellow, #f1c21b);
}
.cds--icon-indicator--caution-minor path:first-of-type {
  fill: #000000;
}

.cds--icon-indicator--undefined {
  fill: #8a3ffc;
  fill: var(--cds-status-purple, #8a3ffc);
}

.cds--icon-indicator--succeeded {
  fill: #24a148;
  fill: var(--cds-status-green, #24a148);
}

.cds--icon-indicator--normal {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--icon-indicator--in-progress {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--icon-indicator--incomplete {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--icon-indicator--not-started {
  fill: #6f6f6f;
  fill: var(--cds-status-gray, #6f6f6f);
}

.cds--icon-indicator--pending {
  fill: #6f6f6f;
  fill: var(--cds-status-gray, #6f6f6f);
}

.cds--icon-indicator--unknown {
  fill: #6f6f6f;
  fill: var(--cds-status-gray, #6f6f6f);
}

.cds--icon-indicator--informative {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--shape-indicator {
  font-size: 0.75rem;
  font-size: var(--cds-helper-text-01-font-size, 0.75rem);
  line-height: 1.33333;
  line-height: var(--cds-helper-text-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-helper-text-01-letter-spacing, 0.32px);
  display: flex;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--shape-indicator svg {
  align-self: center;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--shape-indicator--14 {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}

.cds--shape-indicator--failed {
  fill: #da1e28;
  fill: var(--cds-status-red, #da1e28);
}

.cds--shape-indicator--critical {
  fill: #da1e28;
  fill: var(--cds-status-red, #da1e28);
}

.cds--shape-indicator--high {
  fill: #da1e28;
  fill: var(--cds-status-red, #da1e28);
}

.cds--shape-indicator--medium {
  fill: #ff832b;
  fill: var(--cds-status-orange, #ff832b);
}
.cds--shape-indicator--medium path:first-of-type {
  fill: #ba4e00;
  fill: var(--cds-status-orange-outline, #ba4e00);
}

.cds--shape-indicator--low {
  fill: #f1c21b;
  fill: var(--cds-status-yellow, #f1c21b);
}
.cds--shape-indicator--low path:nth-of-type(2) {
  fill: #8e6a00;
  fill: var(--cds-status-yellow-outline, #8e6a00);
}

.cds--shape-indicator--cautious {
  fill: #f1c21b;
  fill: var(--cds-status-yellow, #f1c21b);
}
.cds--shape-indicator--cautious path:first-of-type {
  fill: #8e6a00;
  fill: var(--cds-status-yellow-outline, #8e6a00);
}

.cds--shape-indicator--undefined {
  fill: #8a3ffc;
  fill: var(--cds-status-purple, #8a3ffc);
}

.cds--shape-indicator--stable {
  fill: #24a148;
  fill: var(--cds-status-green, #24a148);
}

.cds--shape-indicator--informative {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--shape-indicator--incomplete path:nth-of-type(2) {
  fill: #0043ce;
  fill: var(--cds-status-blue, #0043ce);
}

.cds--shape-indicator--draft {
  fill: #6f6f6f;
  fill: var(--cds-status-gray, #6f6f6f);
}

.cds--breadcrumb {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--breadcrumb *,
.cds--breadcrumb *::before,
.cds--breadcrumb *::after {
  box-sizing: inherit;
}
.cds--breadcrumb {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: inline;
}
@media (min-width: 42rem) {
  .cds--breadcrumb {
    display: flex;
    flex-wrap: wrap;
  }
}

.cds--breadcrumb--sm {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
}

.cds--breadcrumb .cds--link {
  font: inherit;
}

.cds--breadcrumb-item {
  position: relative;
  display: flex;
  align-items: center;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--breadcrumb--sm .cds--breadcrumb-item {
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
}

.cds--breadcrumb--sm .cds--breadcrumb-item .cds--link {
  justify-content: center;
  min-inline-size: 0.75rem;
}

.cds--breadcrumb-item .cds--link:visited {
  color: var(--color-primary);
  color: var(--cds-link-primary, #0f62fe);
}
.cds--breadcrumb-item .cds--link:visited:hover {
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-primary-hover, #0043ce);
}

.cds--breadcrumb-item .cds--link:active,
.cds--breadcrumb-item .cds--link:visited:active:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--breadcrumb-item::after {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  content: "/";
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--breadcrumb--sm .cds--breadcrumb-item::after {
  -webkit-margin-start: 0.25rem;
          margin-inline-start: 0.25rem;
}

.cds--breadcrumb--no-trailing-slash .cds--breadcrumb-item:last-child::after {
  content: "";
}

.cds--breadcrumb-item:last-child,
.cds--breadcrumb-item:last-child::after {
  -webkit-margin-end: 0;
          margin-inline-end: 0;
}

.cds--breadcrumb .cds--link {
  white-space: nowrap;
}

.cds--breadcrumb-item [aria-current=page],
.cds--breadcrumb-item.cds--breadcrumb-item--current .cds--link {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: auto;
}
.cds--breadcrumb-item [aria-current=page]:hover,
.cds--breadcrumb-item.cds--breadcrumb-item--current .cds--link:hover {
  text-decoration: none;
}

.cds--breadcrumb-item .cds--overflow-menu {
  position: relative;
  block-size: 1.125rem;
  inline-size: 1rem;
}
.cds--breadcrumb-item .cds--overflow-menu:focus {
  border: none;
  box-shadow: none;
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
  outline-offset: 0;
}
.cds--breadcrumb-item .cds--overflow-menu:hover {
  background: transparent;
}
.cds--breadcrumb-item .cds--overflow-menu:hover::after {
  background: color-mix(in oklab, var(--color-primary) 80%, black);
  background: var(--cds-link-primary-hover, #0043ce);
}
.cds--breadcrumb-item .cds--overflow-menu:active::after {
  background: #161616;
  background: var(--cds-text-primary, #161616);
}
.cds--breadcrumb-item .cds--overflow-menu:focus::after, .cds--breadcrumb-item .cds--overflow-menu:hover::after {
  opacity: 1;
}
.cds--breadcrumb-item .cds--overflow-menu::after {
  position: absolute;
  background: var(--color-primary);
  background: var(--cds-focus, #0f62fe);
  block-size: 1px;
  content: "";
  inline-size: 0.75rem;
  inset-block-end: 2px;
  opacity: 0;
  transition: opacity 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--breadcrumb-item .cds--overflow-menu::after {
    transition: none;
  }
}

.cds--breadcrumb-item .cds--overflow-menu.cds--overflow-menu--open {
  background: transparent;
  box-shadow: none;
}

.cds--breadcrumb-item .cds--overflow-menu .cds--overflow-menu__icon {
  position: relative;
  fill: var(--color-primary);
  fill: var(--cds-link-primary, #0f62fe);
  transform: translateY(4px);
}

.cds--breadcrumb-item .cds--overflow-menu:hover .cds--overflow-menu__icon {
  fill: color-mix(in oklab, var(--color-primary) 80%, black);
  fill: var(--cds-link-primary-hover, #0043ce);
}

.cds--breadcrumb-item .cds--overflow-menu:active .cds--overflow-menu__icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--breadcrumb-menu-options:focus {
  outline: none;
}

.cds--breadcrumb-menu-options.cds--overflow-menu-options::after {
  margin: 0 auto;
  background: transparent;
  block-size: 0;
  -webkit-border-after: 0.4375rem solid #f4f4f4;
          border-block-end: 0.4375rem solid #f4f4f4;
  -webkit-border-after: 0.4375rem solid var(--cds-field);
          border-block-end: 0.4375rem solid var(--cds-field);
  -webkit-border-end: 0.4375rem solid transparent;
          border-inline-end: 0.4375rem solid transparent;
  -webkit-border-start: 0.4375rem solid transparent;
          border-inline-start: 0.4375rem solid transparent;
  inline-size: 0;
  inset-block-start: -0.4375rem;
  inset-inline-start: 0.875rem;
}

[dir=rtl] .cds--breadcrumb-menu-options.cds--overflow-menu-options::after {
  inset-inline-end: 0.875rem;
  inset-inline-start: initial;
}

.cds--breadcrumb .cds--overflow-menu.cds--btn--icon-only {
  min-block-size: 1.125rem;
  padding-inline: 0;
}

.cds--breadcrumb--sm .cds--breadcrumb-item .cds--overflow-menu {
  block-size: 1rem;
  inline-size: 1rem;
  min-block-size: 1rem;
}
.cds--breadcrumb--sm .cds--breadcrumb-item .cds--overflow-menu .cds--overflow-menu__icon {
  transform: translateY(3px);
}

.cds--breadcrumb.cds--skeleton .cds--link {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--breadcrumb.cds--skeleton .cds--link:hover, .cds--breadcrumb.cds--skeleton .cds--link:focus, .cds--breadcrumb.cds--skeleton .cds--link:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--breadcrumb.cds--skeleton .cds--link::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--breadcrumb.cds--skeleton .cds--link::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--breadcrumb.cds--skeleton .cds--link {
    background: CanvasText;
  }
  .cds--breadcrumb.cds--skeleton .cds--link::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--breadcrumb.cds--skeleton .cds--link {
  block-size: 1rem;
  inline-size: 6.25rem;
}

.cds--link {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--link *,
.cds--link *::before,
.cds--link *::after {
  box-sizing: inherit;
}
.cds--link {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: inline;
  color: var(--color-primary);
  color: var(--cds-link-text-color, var(--cds-link-primary, #0f62fe));
  outline: none;
  text-decoration: none;
  transition: color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--link:hover {
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-hover-text-color, var(--cds-link-primary-hover, #0043ce));
  text-decoration: underline;
}
.cds--link:active:not(.cds--link--disabled), .cds--link:active:visited, .cds--link:active:visited:hover {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--link:active:not(.cds--link--disabled), .cds--link:active:visited, .cds--link:active:visited:hover {
    outline-style: dotted;
  }
}
.cds--link:active:not(.cds--link--disabled), .cds--link:active:visited, .cds--link:active:visited:hover {
  color: var(--color-primary);
  color: var(--cds-link-text-color, var(--cds-link-primary, #0f62fe));
  outline-color: var(--color-primary);
  outline-color: var(--cds-link-focus-text-color, var(--cds-focus, #0f62fe));
  text-decoration: underline;
}
.cds--link:focus:not(.cds--link--disabled) {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--link:focus:not(.cds--link--disabled) {
    outline-style: dotted;
  }
}
.cds--link:focus:not(.cds--link--disabled) {
  outline-color: var(--color-primary);
  outline-color: var(--cds-link-focus-text-color, var(--cds-focus, #0f62fe));
  text-decoration: underline;
}
.cds--link:visited {
  color: var(--color-primary);
  color: var(--cds-link-text-color, var(--cds-link-primary, #0f62fe));
}
.cds--link:visited:hover {
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-hover-text-color, var(--cds-link-primary-hover, #0043ce));
}

.cds--link--disabled,
.cds--link--disabled:hover {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--link--disabled *,
.cds--link--disabled *::before,
.cds--link--disabled *::after,
.cds--link--disabled:hover *,
.cds--link--disabled:hover *::before,
.cds--link--disabled:hover *::after {
  box-sizing: inherit;
}
.cds--link--disabled,
.cds--link--disabled:hover {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
  font-weight: 400;
  text-decoration: none;
}

.cds--link.cds--link--visited,
.cds--link.cds--link--visited:visited {
  color: #8a3ffc;
  color: var(--cds-link-visited-text-color, var(--cds-link-visited, #8a3ffc));
}

.cds--link.cds--link--visited:hover,
.cds--link.cds--link--visited:visited:hover {
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-hover-text-color, var(--cds-link-primary-hover, #0043ce));
}

.cds--link.cds--link--inline {
  display: inline;
  text-decoration: underline;
}

.cds--link--disabled.cds--link--inline {
  text-decoration: underline;
}

.cds--link--sm,
.cds--link--sm.cds--link--disabled:hover {
  font-size: 0.75rem;
  font-size: var(--cds-helper-text-01-font-size, 0.75rem);
  line-height: 1.33333;
  line-height: var(--cds-helper-text-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-helper-text-01-letter-spacing, 0.32px);
}

.cds--link--lg,
.cds--link--lg.cds--link--disabled:hover {
  font-size: 1rem;
  font-size: var(--cds-body-compact-02-font-size, 1rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-02-font-weight, 400);
  line-height: 1.375;
  line-height: var(--cds-body-compact-02-line-height, 1.375);
  letter-spacing: 0;
  letter-spacing: var(--cds-body-compact-02-letter-spacing, 0);
}

.cds--link__icon {
  display: inline-flex;
  align-items: center;
  block-size: 1lh;
  line-height: inherit;
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  vertical-align: text-bottom;
}

.cds--link--lg .cds--link__icon > svg {
  block-size: 1.25rem;
  inline-size: 1.25rem;
}

.cds--link--lg .cds--link__icon {
  block-size: 1.25rem;
}

.cds--inline-notification html {
  font-size: 100%;
}
.cds--inline-notification body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--inline-notification code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--inline-notification strong {
  font-weight: 600;
}
.cds--inline-notification {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: 100%;
  max-inline-size: 18rem;
  min-block-size: 3rem;
  min-inline-size: 18rem;
}
@media (min-width: 42rem) {
  .cds--inline-notification {
    flex-wrap: nowrap;
    max-inline-size: 38rem;
  }
}
@media (min-width: 66rem) {
  .cds--inline-notification {
    max-inline-size: 46rem;
  }
}
@media (min-width: 99rem) {
  .cds--inline-notification {
    max-inline-size: 52rem;
  }
}

.cds--inline-notification:not(.cds--inline-notification--low-contrast) a {
  color: #78a9ff;
  color: var(--cds-link-inverse, #78a9ff);
}

.cds--inline-notification a {
  text-decoration: none;
}

.cds--inline-notification a:hover {
  text-decoration: underline;
}

.cds--inline-notification a:focus {
  outline: 1px solid #78a9ff;
  outline: 1px solid var(--cds-link-inverse, #78a9ff);
}

.cds--inline-notification.cds--inline-notification--low-contrast a:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--inline-notification.cds--inline-notification--low-contrast a:focus {
    outline-style: dotted;
  }
}

.cds--inline-notification--low-contrast {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--inline-notification--low-contrast .cds--inline-notification__close-button:focus {
    outline-style: dotted;
  }
}
.cds--inline-notification--low-contrast .cds--inline-notification__close-button .cds--inline-notification__close-icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--inline-notification--low-contrast::before {
  position: absolute;
  box-sizing: border-box;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  block-size: 100%;
  content: "";
  filter: opacity(0.4);
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  pointer-events: none;
}

.cds--inline-notification--error {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #fa4d56;
          border-inline-start: 3px solid #fa4d56;
  -webkit-border-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
          border-inline-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
}
.cds--inline-notification--error .cds--inline-notification__icon,
.cds--inline-notification--error .cds--toast-notification__icon,
.cds--inline-notification--error .cds--actionable-notification__icon {
  fill: #fa4d56;
  fill: var(--cds-support-error-inverse, #fa4d56);
}

.cds--inline-notification--low-contrast.cds--inline-notification--error {
  background: #fff1f1;
  background: var(--cds-notification-background-error, #fff1f1);
  -webkit-border-start: 3px solid #da1e28;
          border-inline-start: 3px solid #da1e28;
  -webkit-border-start: 3px solid var(--cds-support-error, #da1e28);
          border-inline-start: 3px solid var(--cds-support-error, #da1e28);
}
.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--error .cds--actionable-notification__icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}
.cds--inline-notification--low-contrast.cds--inline-notification--error::before {
  border-color: #da1e28;
  border-color: var(--cds-support-error, #da1e28);
}

.cds--inline-notification--success {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #42be65;
          border-inline-start: 3px solid #42be65;
  -webkit-border-start: 3px solid var(--cds-support-success-inverse, #42be65);
          border-inline-start: 3px solid var(--cds-support-success-inverse, #42be65);
}
.cds--inline-notification--success .cds--inline-notification__icon,
.cds--inline-notification--success .cds--toast-notification__icon,
.cds--inline-notification--success .cds--actionable-notification__icon {
  fill: #42be65;
  fill: var(--cds-support-success-inverse, #42be65);
}

.cds--inline-notification--low-contrast.cds--inline-notification--success {
  background: #defbe6;
  background: var(--cds-notification-background-success, #defbe6);
  -webkit-border-start: 3px solid #24a148;
          border-inline-start: 3px solid #24a148;
  -webkit-border-start: 3px solid var(--cds-support-success, #24a148);
          border-inline-start: 3px solid var(--cds-support-success, #24a148);
}
.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--success .cds--actionable-notification__icon {
  fill: #24a148;
  fill: var(--cds-support-success, #24a148);
}
.cds--inline-notification--low-contrast.cds--inline-notification--success::before {
  border-color: #24a148;
  border-color: var(--cds-support-success, #24a148);
}

.cds--inline-notification--info,
.cds--inline-notification--info-square {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #4589ff;
          border-inline-start: 3px solid #4589ff;
  -webkit-border-start: 3px solid var(--cds-support-info-inverse, #4589ff);
          border-inline-start: 3px solid var(--cds-support-info-inverse, #4589ff);
}
.cds--inline-notification--info .cds--inline-notification__icon,
.cds--inline-notification--info .cds--toast-notification__icon,
.cds--inline-notification--info .cds--actionable-notification__icon,
.cds--inline-notification--info-square .cds--inline-notification__icon,
.cds--inline-notification--info-square .cds--toast-notification__icon,
.cds--inline-notification--info-square .cds--actionable-notification__icon {
  fill: #4589ff;
  fill: var(--cds-support-info-inverse, #4589ff);
}

.cds--inline-notification--low-contrast.cds--inline-notification--info,
.cds--inline-notification--low-contrast.cds--inline-notification--info-square {
  background: #edf5ff;
  background: var(--cds-notification-background-info, #edf5ff);
  -webkit-border-start: 3px solid #0043ce;
          border-inline-start: 3px solid #0043ce;
  -webkit-border-start: 3px solid var(--cds-support-info, #0043ce);
          border-inline-start: 3px solid var(--cds-support-info, #0043ce);
}
.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--info .cds--actionable-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--info-square .cds--actionable-notification__icon {
  fill: #0043ce;
  fill: var(--cds-support-info, #0043ce);
}
.cds--inline-notification--low-contrast.cds--inline-notification--info::before,
.cds--inline-notification--low-contrast.cds--inline-notification--info-square::before {
  border-color: #0043ce;
  border-color: var(--cds-support-info, #0043ce);
}

.cds--inline-notification--warning,
.cds--inline-notification--warning-alt {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
}
.cds--inline-notification--warning .cds--inline-notification__icon,
.cds--inline-notification--warning .cds--toast-notification__icon,
.cds--inline-notification--warning .cds--actionable-notification__icon,
.cds--inline-notification--warning-alt .cds--inline-notification__icon,
.cds--inline-notification--warning-alt .cds--toast-notification__icon,
.cds--inline-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning-inverse, #f1c21b);
}

.cds--inline-notification--low-contrast.cds--inline-notification--warning,
.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt {
  background: #fcf4d6;
  background: var(--cds-notification-background-warning, #fcf4d6);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning, #f1c21b);
}
.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--warning .cds--actionable-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--inline-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--toast-notification__icon,
.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}
.cds--inline-notification--low-contrast.cds--inline-notification--warning::before,
.cds--inline-notification--low-contrast.cds--inline-notification--warning-alt::before {
  border-color: #f1c21b;
  border-color: var(--cds-support-warning, #f1c21b);
}

.cds--inline-notification--warning .cds--inline-notification__icon path[opacity="0"],
.cds--inline-notification--warning-alt .cds--inline-notification__icon path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--inline-notification__details {
  display: flex;
  flex-grow: 1;
  margin-inline: 0.8125rem 3rem;
}
@media (min-width: 42rem) {
  .cds--inline-notification__details {
    margin: 0 0.8125rem;
  }
}

.cds--inline-notification__icon {
  flex-shrink: 0;
  -webkit-margin-before: 0.875rem;
          margin-block-start: 0.875rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--inline-notification__text-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0.9375rem 0;
}

.cds--inline-notification__title {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
}

.cds--inline-notification__subtitle {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  word-break: break-word;
}

.cds--inline-notification__action-button.cds--btn--ghost {
  block-size: 2rem;
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
  -webkit-margin-start: 2.5rem;
          margin-inline-start: 2.5rem;
}
@media (min-width: 42rem) {
  .cds--inline-notification__action-button.cds--btn--ghost {
    margin: 0.5rem 0;
  }
}

.cds--inline-notification:not(.cds--inline-notification--low-contrast) .cds--inline-notification__action-button.cds--btn--ghost {
  color: #78a9ff;
  color: var(--cds-link-inverse, #78a9ff);
}

.cds--inline-notification__action-button.cds--btn--ghost:active,
.cds--inline-notification__action-button.cds--btn--ghost:hover {
  background-color: #474747;
  background-color: var(--cds-background-inverse-hover, #474747);
}

.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:active,
.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:hover {
  background-color: #ffffff;
  background-color: var(--cds-notification-action-hover, #ffffff);
}

.cds--inline-notification__action-button.cds--btn--ghost:focus {
  border-color: transparent;
  box-shadow: none;
  outline: 2px solid #ffffff;
  outline: 2px solid var(--cds-focus-inverse, #ffffff);
  outline-offset: -2px;
}

.cds--inline-notification--low-contrast .cds--inline-notification__action-button.cds--btn--ghost:focus {
  outline-color: var(--color-primary);
  outline-color: var(--cds-focus, #0f62fe);
}

.cds--inline-notification--hide-close-button .cds--inline-notification__action-button.cds--btn--ghost {
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--inline-notification__close-button {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  inset-block-start: 0;
  inset-inline-end: 0;
  max-inline-size: 3rem;
  min-inline-size: 3rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--inline-notification__close-button:focus {
  outline: 2px solid #ffffff;
  outline: 2px solid var(--cds-focus-inverse, #ffffff);
  outline-offset: -2px;
}
.cds--inline-notification__close-button .cds--inline-notification__close-icon {
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
}
@media (min-width: 42rem) {
  .cds--inline-notification__close-button {
    position: static;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--inline-notification {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--inline-notification__close-button:focus,
  .cds--btn.cds--btn--ghost.cds--inline-notification__action-button:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--toast-notification html {
  font-size: 100%;
}
.cds--toast-notification body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--toast-notification code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--toast-notification strong {
  font-weight: 600;
}
.cds--toast-notification {
  display: flex;
  block-size: auto;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: 18rem;
  -webkit-padding-start: 0.8125rem;
          padding-inline-start: 0.8125rem;
}
@media (min-width: 99rem) {
  .cds--toast-notification {
    inline-size: 22rem;
  }
}

.cds--toast-notification:not(.cds--toast-notification--low-contrast) a {
  color: #78a9ff;
  color: var(--cds-link-inverse, #78a9ff);
}

.cds--toast-notification a {
  text-decoration: none;
}

.cds--toast-notification a:hover {
  text-decoration: underline;
}

.cds--toast-notification a:focus {
  outline: 1px solid #78a9ff;
  outline: 1px solid var(--cds-link-inverse, #78a9ff);
}

.cds--toast-notification.cds--toast-notification--low-contrast a:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--toast-notification.cds--toast-notification--low-contrast a:focus {
    outline-style: dotted;
  }
}

.cds--toast-notification--low-contrast {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--toast-notification--low-contrast .cds--toast-notification__subtitle,
.cds--toast-notification--low-contrast .cds--toast-notification__caption {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--toast-notification--low-contrast .cds--toast-notification__close-button .cds--toast-notification__close-icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--toast-notification--low-contrast .cds--toast-notification__close-button:focus {
    outline-style: dotted;
  }
}

.cds--toast-notification--error {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #fa4d56;
          border-inline-start: 3px solid #fa4d56;
  -webkit-border-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
          border-inline-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
}
.cds--toast-notification--error .cds--inline-notification__icon,
.cds--toast-notification--error .cds--toast-notification__icon,
.cds--toast-notification--error .cds--actionable-notification__icon {
  fill: #fa4d56;
  fill: var(--cds-support-error-inverse, #fa4d56);
}

.cds--toast-notification--low-contrast.cds--toast-notification--error {
  background: #fff1f1;
  background: var(--cds-notification-background-error, #fff1f1);
  -webkit-border-start: 3px solid #da1e28;
          border-inline-start: 3px solid #da1e28;
  -webkit-border-start: 3px solid var(--cds-support-error, #da1e28);
          border-inline-start: 3px solid var(--cds-support-error, #da1e28);
}
.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--error .cds--actionable-notification__icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}

.cds--toast-notification--success {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #42be65;
          border-inline-start: 3px solid #42be65;
  -webkit-border-start: 3px solid var(--cds-support-success-inverse, #42be65);
          border-inline-start: 3px solid var(--cds-support-success-inverse, #42be65);
}
.cds--toast-notification--success .cds--inline-notification__icon,
.cds--toast-notification--success .cds--toast-notification__icon,
.cds--toast-notification--success .cds--actionable-notification__icon {
  fill: #42be65;
  fill: var(--cds-support-success-inverse, #42be65);
}

.cds--toast-notification--low-contrast.cds--toast-notification--success {
  background: #defbe6;
  background: var(--cds-notification-background-success, #defbe6);
  -webkit-border-start: 3px solid #24a148;
          border-inline-start: 3px solid #24a148;
  -webkit-border-start: 3px solid var(--cds-support-success, #24a148);
          border-inline-start: 3px solid var(--cds-support-success, #24a148);
}
.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--success .cds--actionable-notification__icon {
  fill: #24a148;
  fill: var(--cds-support-success, #24a148);
}

.cds--toast-notification--info,
.cds--toast-notification--info-square {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #4589ff;
          border-inline-start: 3px solid #4589ff;
  -webkit-border-start: 3px solid var(--cds-support-info-inverse, #4589ff);
          border-inline-start: 3px solid var(--cds-support-info-inverse, #4589ff);
}
.cds--toast-notification--info .cds--inline-notification__icon,
.cds--toast-notification--info .cds--toast-notification__icon,
.cds--toast-notification--info .cds--actionable-notification__icon,
.cds--toast-notification--info-square .cds--inline-notification__icon,
.cds--toast-notification--info-square .cds--toast-notification__icon,
.cds--toast-notification--info-square .cds--actionable-notification__icon {
  fill: #4589ff;
  fill: var(--cds-support-info-inverse, #4589ff);
}

.cds--toast-notification--low-contrast.cds--toast-notification--info,
.cds--toast-notification--low-contrast.cds--toast-notification--info-square {
  background: #edf5ff;
  background: var(--cds-notification-background-info, #edf5ff);
  -webkit-border-start: 3px solid #0043ce;
          border-inline-start: 3px solid #0043ce;
  -webkit-border-start: 3px solid var(--cds-support-info, #0043ce);
          border-inline-start: 3px solid var(--cds-support-info, #0043ce);
}
.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--info .cds--actionable-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--info-square .cds--actionable-notification__icon {
  fill: #0043ce;
  fill: var(--cds-support-info, #0043ce);
}

.cds--toast-notification--warning,
.cds--toast-notification--warning-alt {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
}
.cds--toast-notification--warning .cds--inline-notification__icon,
.cds--toast-notification--warning .cds--toast-notification__icon,
.cds--toast-notification--warning .cds--actionable-notification__icon,
.cds--toast-notification--warning-alt .cds--inline-notification__icon,
.cds--toast-notification--warning-alt .cds--toast-notification__icon,
.cds--toast-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning-inverse, #f1c21b);
}

.cds--toast-notification--low-contrast.cds--toast-notification--warning,
.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt {
  background: #fcf4d6;
  background: var(--cds-notification-background-warning, #fcf4d6);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning, #f1c21b);
}
.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--warning .cds--actionable-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--inline-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--toast-notification__icon,
.cds--toast-notification--low-contrast.cds--toast-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--toast-notification--warning .cds--toast-notification__icon path[opacity="0"],
.cds--toast-notification--warning-alt .cds--toast-notification__icon path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--toast-notification__icon {
  flex-shrink: 0;
  -webkit-margin-before: 1rem;
          margin-block-start: 1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--toast-notification__details {
  -webkit-margin-after: 1rem;
          margin-block-end: 1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--toast-notification__close-button {
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: transparent;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  -webkit-margin-start: auto;
          margin-inline-start: auto;
  min-block-size: 3rem;
  min-inline-size: 3rem;
  transition: outline 250ms, background-color 250ms;
}
.cds--toast-notification__close-button:focus {
  outline: 2px solid #ffffff;
  outline: 2px solid var(--cds-focus-inverse, #ffffff);
  outline-offset: -2px;
}
.cds--toast-notification__close-button .cds--toast-notification__close-icon {
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
}

.cds--toast-notification__title {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  font-weight: 600;
  -webkit-margin-before: 1rem;
          margin-block-start: 1rem;
  word-break: break-word;
}

.cds--toast-notification__subtitle {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  margin-block: 0 1rem;
  word-break: break-word;
}

.cds--toast-notification__caption {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  -webkit-padding-before: 0.5rem;
          padding-block-start: 0.5rem;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toast-notification {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--toast-notification__close-button:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--actionable-notification html {
  font-size: 100%;
}
.cds--actionable-notification body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--actionable-notification code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--actionable-notification strong {
  font-weight: 600;
}
.cds--actionable-notification {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: 100%;
  max-inline-size: 18rem;
  min-block-size: 3rem;
  min-inline-size: 18rem;
}
@media (min-width: 42rem) {
  .cds--actionable-notification {
    flex-wrap: nowrap;
    max-inline-size: 38rem;
  }
}
@media (min-width: 66rem) {
  .cds--actionable-notification {
    max-inline-size: 46rem;
  }
}
@media (min-width: 99rem) {
  .cds--actionable-notification {
    max-inline-size: 52rem;
  }
}

.cds--actionable-notification--toast {
  flex-wrap: wrap;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);
  max-inline-size: 18rem;
  min-inline-size: 18rem;
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) a {
  color: #78a9ff;
  color: var(--cds-link-inverse, #78a9ff);
}

.cds--actionable-notification a {
  text-decoration: none;
}

.cds--actionable-notification a:hover {
  text-decoration: underline;
}

.cds--actionable-notification a:focus {
  outline: 1px solid #ffffff;
  outline: 1px solid var(--cds-focus-inverse, #ffffff);
}

.cds--actionable-notification.cds--actionable-notification--low-contrast a:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--actionable-notification.cds--actionable-notification--low-contrast a:focus {
    outline-style: dotted;
  }
}

.cds--actionable-notification--low-contrast {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--actionable-notification--low-contrast .cds--actionable-notification__subtitle,
.cds--actionable-notification--low-contrast .cds--actionable-notification__caption {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button .cds--actionable-notification__close-icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--actionable-notification--low-contrast:not(.cds--actionable-notification--toast)::before {
  position: absolute;
  box-sizing: border-box;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  block-size: 100%;
  content: "";
  filter: opacity(0.4);
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  pointer-events: none;
}

.cds--actionable-notification--error {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #fa4d56;
          border-inline-start: 3px solid #fa4d56;
  -webkit-border-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
          border-inline-start: 3px solid var(--cds-support-error-inverse, #fa4d56);
}
.cds--actionable-notification--error .cds--inline-notification__icon,
.cds--actionable-notification--error .cds--toast-notification__icon,
.cds--actionable-notification--error .cds--actionable-notification__icon {
  fill: #fa4d56;
  fill: var(--cds-support-error-inverse, #fa4d56);
}

.cds--actionable-notification--low-contrast.cds--actionable-notification--error {
  background: #fff1f1;
  background: var(--cds-notification-background-error, #fff1f1);
  -webkit-border-start: 3px solid #da1e28;
          border-inline-start: 3px solid #da1e28;
  -webkit-border-start: 3px solid var(--cds-support-error, #da1e28);
          border-inline-start: 3px solid var(--cds-support-error, #da1e28);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--error .cds--actionable-notification__icon {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--error::before {
  border-color: #da1e28;
  border-color: var(--cds-support-error, #da1e28);
}

.cds--actionable-notification--success {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #42be65;
          border-inline-start: 3px solid #42be65;
  -webkit-border-start: 3px solid var(--cds-support-success-inverse, #42be65);
          border-inline-start: 3px solid var(--cds-support-success-inverse, #42be65);
}
.cds--actionable-notification--success .cds--inline-notification__icon,
.cds--actionable-notification--success .cds--toast-notification__icon,
.cds--actionable-notification--success .cds--actionable-notification__icon {
  fill: #42be65;
  fill: var(--cds-support-success-inverse, #42be65);
}

.cds--actionable-notification--low-contrast.cds--actionable-notification--success {
  background: #defbe6;
  background: var(--cds-notification-background-success, #defbe6);
  -webkit-border-start: 3px solid #24a148;
          border-inline-start: 3px solid #24a148;
  -webkit-border-start: 3px solid var(--cds-support-success, #24a148);
          border-inline-start: 3px solid var(--cds-support-success, #24a148);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--success .cds--actionable-notification__icon {
  fill: #24a148;
  fill: var(--cds-support-success, #24a148);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--success::before {
  border-color: #24a148;
  border-color: var(--cds-support-success, #24a148);
}

.cds--actionable-notification--info,
.cds--actionable-notification--info-square {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #4589ff;
          border-inline-start: 3px solid #4589ff;
  -webkit-border-start: 3px solid var(--cds-support-info-inverse, #4589ff);
          border-inline-start: 3px solid var(--cds-support-info-inverse, #4589ff);
}
.cds--actionable-notification--info .cds--inline-notification__icon,
.cds--actionable-notification--info .cds--toast-notification__icon,
.cds--actionable-notification--info .cds--actionable-notification__icon,
.cds--actionable-notification--info-square .cds--inline-notification__icon,
.cds--actionable-notification--info-square .cds--toast-notification__icon,
.cds--actionable-notification--info-square .cds--actionable-notification__icon {
  fill: #4589ff;
  fill: var(--cds-support-info-inverse, #4589ff);
}

.cds--actionable-notification--low-contrast.cds--actionable-notification--info,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square {
  background: #edf5ff;
  background: var(--cds-notification-background-info, #edf5ff);
  -webkit-border-start: 3px solid #0043ce;
          border-inline-start: 3px solid #0043ce;
  -webkit-border-start: 3px solid var(--cds-support-info, #0043ce);
          border-inline-start: 3px solid var(--cds-support-info, #0043ce);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info .cds--actionable-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square .cds--actionable-notification__icon {
  fill: #0043ce;
  fill: var(--cds-support-info, #0043ce);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--info::before,
.cds--actionable-notification--low-contrast.cds--actionable-notification--info-square::before {
  border-color: #0043ce;
  border-color: var(--cds-support-info, #0043ce);
}

.cds--actionable-notification--warning,
.cds--actionable-notification--warning-alt {
  background: #393939;
  background: var(--cds-background-inverse, #393939);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning-inverse, #f1c21b);
}
.cds--actionable-notification--warning .cds--inline-notification__icon,
.cds--actionable-notification--warning .cds--toast-notification__icon,
.cds--actionable-notification--warning .cds--actionable-notification__icon,
.cds--actionable-notification--warning-alt .cds--inline-notification__icon,
.cds--actionable-notification--warning-alt .cds--toast-notification__icon,
.cds--actionable-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning-inverse, #f1c21b);
}

.cds--actionable-notification--low-contrast.cds--actionable-notification--warning,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt {
  background: #fcf4d6;
  background: var(--cds-notification-background-warning, #fcf4d6);
  -webkit-border-start: 3px solid #f1c21b;
          border-inline-start: 3px solid #f1c21b;
  -webkit-border-start: 3px solid var(--cds-support-warning, #f1c21b);
          border-inline-start: 3px solid var(--cds-support-warning, #f1c21b);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning .cds--actionable-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--inline-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--toast-notification__icon,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt .cds--actionable-notification__icon {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning::before,
.cds--actionable-notification--low-contrast.cds--actionable-notification--warning-alt::before {
  border-color: #f1c21b;
  border-color: var(--cds-support-warning, #f1c21b);
}

.cds--actionable-notification--warning .cds--toast-notification__icon path[opacity="0"],
.cds--actionable-notification--warning-alt .cds--toast-notification__icon path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--actionable-notification--warning .cds--inline-notification__icon path[opacity="0"],
.cds--actionable-notification--warning-alt .cds--inline-notification__icon path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--actionable-notification__details {
  display: flex;
  flex-grow: 1;
  margin-inline: 0.8125rem 3rem;
}

@media (min-width: 42rem) {
  .cds--actionable-notification:not(.cds--actionable-notification--toast) .cds--actionable-notification__details {
    margin: 0 0.8125rem;
  }
}

.cds--actionable-notification .cds--inline-notification__icon {
  flex-shrink: 0;
  -webkit-margin-before: 0.875rem;
          margin-block-start: 0.875rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--actionable-notification .cds--toast-notification__icon {
  flex-shrink: 0;
  -webkit-margin-before: 1rem;
          margin-block-start: 1rem;
  -webkit-margin-end: 1rem;
          margin-inline-end: 1rem;
}

.cds--actionable-notification__text-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 0.9375rem 0;
}

.cds--actionable-notification__focus-wrapper {
  display: contents;
}

.cds--actionable-notification__button-wrapper {
  display: flex;
}

.cds--actionable-notification--toast .cds--actionable-notification__text-wrapper {
  padding: 0.9375rem 0 1.4375rem 0;
}

.cds--actionable-notification__content {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  flex-wrap: wrap;
  word-break: break-word;
}

.cds--actionable-notification--toast .cds--actionable-notification__content {
  display: block;
}

.cds--actionable-notification__title {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  font-weight: 600;
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
  word-break: break-word;
}

.cds--actionable-notification--toast .cds--actionable-notification__title {
  -webkit-margin-end: 0;
          margin-inline-end: 0;
}

.cds--actionable-notification__subtitle {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  -webkit-margin-before: 0;
          margin-block-start: 0;
  word-break: break-word;
}

.cds--actionable-notification__caption {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  -webkit-padding-before: 1.5rem;
          padding-block-start: 1.5rem;
}

/* Ghost action button when inline */
.cds--actionable-notification__action-button.cds--btn--ghost {
  block-size: 2rem;
  -webkit-margin-after: 0.5rem;
          margin-block-end: 0.5rem;
  -webkit-margin-start: 2.5rem;
          margin-inline-start: 2.5rem;
}
@media (min-width: 42rem) {
  .cds--actionable-notification__action-button.cds--btn--ghost {
    margin: 0.5rem 0;
  }
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--ghost {
  color: #78a9ff;
  color: var(--cds-link-inverse, #78a9ff);
}

.cds--actionable-notification__action-button.cds--btn--ghost:active,
.cds--actionable-notification__action-button.cds--btn--ghost:hover {
  background-color: #474747;
  background-color: var(--cds-background-inverse-hover, #474747);
}

.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:active,
.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:hover {
  background-color: #ffffff;
  background-color: var(--cds-notification-action-hover, #ffffff);
}

.cds--actionable-notification__action-button.cds--btn--ghost:focus {
  border-color: transparent;
  box-shadow: none;
  outline: 2px solid #ffffff;
  outline: 2px solid var(--cds-focus-inverse, #ffffff);
  outline-offset: -2px;
}

.cds--actionable-notification--low-contrast .cds--actionable-notification__action-button.cds--btn--ghost:focus {
  outline-color: var(--color-primary);
  outline-color: var(--cds-focus, #0f62fe);
}

.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--ghost {
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

/* Tertiary action button when not inline (toast) */
.cds--actionable-notification__action-button.cds--btn--tertiary {
  -webkit-margin-after: 1rem;
          margin-block-end: 1rem;
  -webkit-margin-start: calc(2rem + 1.25rem - 0.125rem);
          margin-inline-start: calc(2rem + 1.25rem - 0.125rem);
  padding-inline: 1rem;
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary {
  border-width: 1px;
  border-style: solid;
  border-color: #ffffff;
  border-color: var(--cds-notification-action-tertiary-inverse, #ffffff);
  background-color: transparent;
  color: #ffffff;
  color: var(--cds-notification-action-tertiary-inverse, #ffffff);
}
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-notification-action-tertiary-inverse-hover, #f4f4f4);
}
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-button-focus-color, var(--cds-focus, #0f62fe));
  box-shadow: inset 0 0 0 1px var(--color-primary), inset 0 0 0 2px #ffffff;
  box-shadow: inset 0 0 0 1px var(--cds-button-focus-color, var(--cds-focus, #0f62fe)), inset 0 0 0 2px var(--cds-background, #ffffff);
}
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:active {
  background-color: #c6c6c6;
  background-color: var(--cds-notification-action-tertiary-inverse-active, #c6c6c6);
}
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary .cds--btn__icon path:not([data-icon-path]):not([fill=none]) {
  fill: currentColor;
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover {
  color: #161616;
  color: var(--cds-notification-action-tertiary-inverse-text, #161616);
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus {
  border-color: #ffffff;
  border-color: var(--cds-focus-inverse, #ffffff);
  background-color: #ffffff;
  background-color: var(--cds-notification-action-tertiary-inverse, #ffffff);
  box-shadow: inset 0 0 0 1px #ffffff, inset 0 0 0 2px #393939;
  box-shadow: inset 0 0 0 1px var(--cds-focus-inverse, #ffffff), inset 0 0 0 2px var(--cds-background-inverse, #393939);
  color: #161616;
  color: var(--cds-notification-action-tertiary-inverse-text, #161616);
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:active {
  border-color: transparent;
  background-color: #c6c6c6;
  background-color: var(--cds-notification-action-tertiary-inverse-active, #c6c6c6);
  color: #161616;
  color: var(--cds-notification-action-tertiary-inverse-text, #161616);
}

.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:disabled,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:hover:disabled,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary:focus:disabled,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:hover,
.cds--actionable-notification:not(.cds--actionable-notification--low-contrast) .cds--actionable-notification__action-button.cds--btn--tertiary.cds--btn--disabled:focus {
  background: transparent;
  color: rgba(255, 255, 255, 0.25);
  color: var(--cds-notification-action-tertiary-inverse-text-on-color-disabled, rgba(255, 255, 255, 0.25));
  outline: none;
}

.cds--actionable-notification--hide-close-button .cds--actionable-notification__action-button.cds--btn--tertiary {
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--actionable-notification__close-button {
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: transparent;
  block-size: 3rem;
  cursor: pointer;
  inline-size: 3rem;
  inset-block-start: 0;
  inset-inline-end: 0;
  max-inline-size: 3rem;
  min-inline-size: 3rem;
  transition: outline 110ms cubic-bezier(0.2, 0, 0.38, 0.9), background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--actionable-notification__close-button:focus {
  outline: 2px solid #ffffff;
  outline: 2px solid var(--cds-focus-inverse, #ffffff);
  outline-offset: -2px;
}
.cds--actionable-notification__close-button .cds--actionable-notification__close-icon {
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
}
@media (min-width: 42rem) {
  .cds--actionable-notification__close-button {
    position: static;
  }
}

@media (min-width: 42rem) {
  .cds--actionable-notification--toast .cds--actionable-notification__close-button {
    position: absolute;
  }
}

.cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--actionable-notification--low-contrast .cds--actionable-notification__close-button:focus {
    outline-style: dotted;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--actionable-notification {
    outline: 1px solid transparent;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--actionable-notification__close-button:focus,
  .cds--btn.cds--btn--ghost.cds--actionable-notification__action-button:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--tile-group html {
  font-size: 100%;
}
.cds--tile-group body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--tile-group code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--tile-group strong {
  font-weight: 600;
}

.cds--tile {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  position: relative;
  display: block;
  padding: var(--cds-layout-density-padding-inline-local);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  min-block-size: 4rem;
  min-inline-size: 8rem;
  outline: 2px solid transparent;
  outline-offset: -2px;
}
.cds--tile:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tile:focus {
    outline-style: dotted;
  }
}

.cds--tile--light {
  background-color: #ffffff;
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--tile--clickable,
.cds--tile--selectable {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tile--clickable *,
.cds--tile--clickable *::before,
.cds--tile--clickable *::after,
.cds--tile--selectable *,
.cds--tile--selectable *::before,
.cds--tile--selectable *::after {
  box-sizing: inherit;
}
.cds--tile--clickable,
.cds--tile--selectable {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  padding: var(--cds-layout-density-padding-inline-local);
  cursor: pointer;
  transition: 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tile--clickable:hover,
.cds--tile--selectable:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}

.cds--tile--clickable {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  text-decoration: none;
}
.cds--tile--clickable:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tile--clickable:focus {
    outline-style: dotted;
  }
}
.cds--tile--clickable:focus {
  text-decoration: none;
}
.cds--tile--clickable:hover .cds--tile__checkmark, .cds--tile--clickable:focus .cds--tile__checkmark {
  opacity: 1;
}

.cds--tile--expandable::-moz-focus-inner {
  border: 0;
}

.cds--tile--clickable:hover,
.cds--tile--clickable:active,
.cds--tile--clickable:visited,
.cds--tile--clickable:visited:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  text-decoration: none;
}

.cds--tile--clickable.cds--link--disabled,
.cds--tile--clickable:hover.cds--link--disabled {
  display: block;
  padding: var(--cds-layout-density-padding-inline-local);
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--tile--clickable .cds--tile--icon,
.cds--tile--clickable.cds--link--disabled .cds--tile--disabled-icon {
  position: absolute;
  block-size: 1.25rem;
  inline-size: 1.25rem;
  inset-block-end: 0.75rem;
  inset-inline-end: 0.75rem;
}

.cds--tile--clickable .cds--tile--icon {
  fill: #0f62fe;
  fill: var(--cds-icon-interactive, #0f62fe);
}

.cds--tile--clickable.cds--link--disabled .cds--tile--disabled-icon {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--tile--clickable.cds--link--disabled .cds--tile--icon {
  display: none;
}

.cds--tile--selectable {
  border: 1px solid transparent;
  -webkit-padding-end: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
          padding-inline-end: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
}

.cds--tile__checkmark {
  position: absolute;
  border: none;
  background: transparent;
  block-size: 1rem;
  inset-block-start: var(--cds-layout-density-padding-inline-local);
  inset-inline-end: var(--cds-layout-density-padding-inline-local);
  transition: 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  opacity: 0;
}
.cds--tile__checkmark svg {
  border-radius: 50%;
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}
.cds--tile__checkmark:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tile__checkmark:focus {
    outline-style: dotted;
  }
}

.cds--tile__checkmark--persistent {
  opacity: 1;
}

.cds--tile__chevron {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
  inline-size: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
  inset-block-end: 0;
  inset-inline-end: 0;
}
.cds--tile__chevron svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  transform-origin: center;
  transition: 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--tile__chevron svg {
    transition: none;
  }
}

.cds--tile__chevron--interactive {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tile__chevron--interactive *,
.cds--tile__chevron--interactive *::before,
.cds--tile__chevron--interactive *::after {
  box-sizing: inherit;
}
.cds--tile__chevron--interactive::-moz-focus-inner {
  border: 0;
}
.cds--tile__chevron--interactive {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
  inline-size: calc(var(--cds-layout-density-padding-inline-local) * 2 + 1rem);
  inset-block-end: 0;
  inset-inline-end: 0;
}
.cds--tile__chevron--interactive:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
.cds--tile__chevron--interactive:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  cursor: pointer;
}

.cds--tile--expandable {
  position: relative;
  overflow: hidden;
  border: 0;
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  inline-size: 100%;
  text-align: start;
  transition: max-height 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
.cds--tile--expandable:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}

.cds--tile--expandable.cds--tile--expandable--interactive {
  border: none;
  cursor: default;
  transition: max-height 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tile--expandable.cds--tile--expandable--interactive:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}
.cds--tile--expandable.cds--tile--expandable--interactive:focus {
  outline: none;
}

.cds--tile--expandable--interactive:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tile--expandable--interactive:focus {
    outline-style: dotted;
  }
}

.cds--tile-content__below-the-fold {
  display: block;
  opacity: 0;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), visibility 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  visibility: hidden;
}

.cds--tile--is-expanded {
  overflow: visible;
  transition: max-height 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tile--is-expanded .cds--tile__chevron svg {
  transform: rotate(180deg);
}
.cds--tile--is-expanded .cds--tile-content__below-the-fold {
  opacity: 1;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9), visibility 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  visibility: inherit;
}
@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
  .cds--tile--is-expanded .cds--tile-content__below-the-fold {
    overflow-y: auto;
  }
}

.cds--tile--is-selected {
  border: 1px solid #161616;
  border: 1px solid var(--cds-layer-selected-inverse, #161616);
}

.cds--tile--is-selected .cds--tile__checkmark {
  opacity: 1;
}

.cds--tile--is-selected .cds--tile__checkmark svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--tile-content {
  block-size: 100%;
  inline-size: 100%;
}

.cds--tile-input {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--tile-input:focus + .cds--tile {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tile-input:focus + .cds--tile {
    outline-style: dotted;
  }
}

.cds--tile--disabled.cds--tile--selectable {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--tile--disabled.cds--tile--selectable.cds--tile--light {
  background-color: #ffffff;
  background-color: var(--cds-layer-02, #ffffff);
}

.cds--tile--disabled.cds--tile--is-selected {
  border-color: #c6c6c6;
  border-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--tile--disabled .cds--tile__checkmark svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--tile > .cds--tile--inner-decorator > *,
.cds--tile--expandable > div > .cds--tile--inner-decorator > *,
.cds--tile > .cds--ai-label,
.cds--tile--expandable > div > .cds--ai-label,
.cds--tile > .cds--slug,
.cds--tile--expandable > div > .cds--slug,
.cds--tile--clickable .cds--tile--ai-label-icon {
  position: absolute;
  inset-block-start: 1rem;
  inset-inline-end: 1rem;
}

.cds--tile.cds--tile--selectable > .cds--tile--inner-decorator > *,
.cds--tile.cds--tile--selectable > .cds--ai-label,
.cds--tile.cds--tile--selectable > .cds--slug {
  inset-inline-end: 2.5rem;
}

.cds--tile.cds--tile--selectable.cds--tile--radio > .cds--tile--inner-decorator > *,
.cds--tile.cds--tile--selectable.cds--tile--radio > .cds--ai-label,
.cds--tile.cds--tile--selectable.cds--tile--radio > .cds--slug {
  inset-inline-end: 1rem;
  transition: inset-inline-end 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  inset-inline-end: 2.5rem;
}

.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected > .cds--tile--inner-decorator > *,
.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected > .cds--ai-label,
.cds--tile.cds--tile--selectable.cds--tile--radio.cds--tile--is-selected > .cds--slug {
  inset-inline-end: 2.5rem;
}

.cds--tile.cds--tile--clickable > .cds--tile--inner-decorator > *,
.cds--tile.cds--tile--clickable > .cds--ai-label,
.cds--tile.cds--tile--clickable > .cds--slug {
  pointer-events: none;
}

.cds--tile--decorator:has(.cds--tile--ai-label-icon).cds--tile,
.cds--tile--decorator:has(.cds--ai-label).cds--tile,
.cds--tile--slug.cds--tile {
  background: linear-gradient(to top, #f4f4f4 0%, rgba(69, 137, 255, 0.1) 0%, 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #f4f4f4, #f4f4f4) padding-box, linear-gradient(to bottom, rgba(166, 200, 255, 0.64), #78a9ff) border-box, linear-gradient(to top, #f4f4f4, #f4f4f4) border-box;
  background: linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)) 0%, var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) padding-box, linear-gradient(to bottom, var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)), var(--cds-ai-border-end, #78a9ff)) border-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) border-box;
  border: 1px solid transparent;
  box-shadow: inset 0 -80px 70px -65px rgba(69, 137, 255, 0.1), 0 4px 8px 0 rgba(15, 98, 254, 0.1);
  box-shadow: inset 0 -80px 70px -65px var(--cds-ai-inner-shadow, rgba(69, 137, 255, 0.1)), 0 4px 8px 0 var(--cds-ai-drop-shadow, rgba(15, 98, 254, 0.1));
}

.cds--tile--decorator:has(.cds--ai-label).cds--tile--expandable:hover,
.cds--tile--slug.cds--tile--expandable:hover {
  background: linear-gradient(to top, #f4f4f4 0%, rgba(69, 137, 255, 0.1) 0%, 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #f4f4f4, #f4f4f4) padding-box, linear-gradient(to bottom, rgba(166, 200, 255, 0.64), #78a9ff) border-box, linear-gradient(to top, #f4f4f4, #f4f4f4) border-box;
  background: linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)) 0%, var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) padding-box, linear-gradient(to bottom, var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)), var(--cds-ai-border-end, #78a9ff)) border-box, linear-gradient(to top, var(--cds-layer, var(--cds-ai-popover-background, #ffffff)), var(--cds-layer, var(--cds-ai-popover-background, #ffffff))) border-box;
}

.cds--tile--decorator.cds--tile--selectable::before,
.cds--tile--decorator.cds--tile--selectable::after,
.cds--tile--decorator.cds--tile--clickable::before,
.cds--tile--slug.cds--tile--selectable::before,
.cds--tile--slug.cds--tile--selectable::after,
.cds--tile--slug.cds--tile--clickable::before {
  position: absolute;
  display: block;
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--tile--decorator:has(.cds--ai-label).cds--tile--selectable::before,
.cds--tile--decorator:has(.cds--ai-label).cds--tile--clickable::before,
.cds--tile--decorator:has(.cds--tile--ai-label-icon).cds--tile--clickable::before,
.cds--tile--slug.cds--tile--selectable::before,
.cds--tile--slug.cds--tile--clickable::before {
  background: linear-gradient(to top, rgba(69, 137, 255, 0.32) 0%, 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #edf5ff, #edf5ff) padding-box, linear-gradient(to bottom, rgba(166, 200, 255, 0.64), #78a9ff) border-box, linear-gradient(to top, #edf5ff, #edf5ff) border-box;
  background: linear-gradient(to top, var(--cds-ai-aura-hover-start, rgba(69, 137, 255, 0.32)) 0%, 15%, var(--cds-ai-aura-hover-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-ai-aura-hover-background, #edf5ff), var(--cds-ai-aura-hover-background, #edf5ff)) padding-box, linear-gradient(to bottom, var(--cds-ai-border-start, rgba(166, 200, 255, 0.64)), var(--cds-ai-border-end, #78a9ff)) border-box, linear-gradient(to top, var(--cds-ai-aura-hover-background, #edf5ff), var(--cds-ai-aura-hover-background, #edf5ff)) border-box;
  box-shadow: inset 0 -80px 70px -65px rgba(69, 137, 255, 0.1), 0 4px 10px 2px rgba(15, 98, 254, 0.1);
  box-shadow: inset 0 -80px 70px -65px var(--cds-ai-inner-shadow, rgba(69, 137, 255, 0.1)), 0 4px 10px 2px var(--cds-ai-drop-shadow, rgba(15, 98, 254, 0.1));
}

.cds--tile--decorator.cds--tile--selectable:hover::before,
.cds--tile--decorator.cds--tile--clickable:hover::before,
.cds--tile--slug.cds--tile--selectable:hover::before,
.cds--tile--slug.cds--tile--clickable:hover::before {
  opacity: 1;
}

.cds--tile--decorator.cds--tile--selectable:focus,
.cds--tile--decorator.cds--tile--clickable:focus,
.cds--tile-input:focus + .cds--tile--decorator.cds--tile,
.cds--tile--slug.cds--tile--selectable:focus,
.cds--tile--slug.cds--tile--clickable:focus,
.cds--tile-input:focus + .cds--tile--slug.cds--tile {
  outline-offset: -1px;
}

.cds--tile--decorator:has(.cds--tile--inner-decorator .cds--ai-label).cds--tile--selectable::after,
.cds--tile--slug.cds--tile--selectable::after {
  background: linear-gradient(to top, rgba(69, 137, 255, 0.1) 0%, 15%, rgba(255, 255, 255, 0) 50%) padding-box, linear-gradient(to top, #f4f4f4, #f4f4f4) padding-box, linear-gradient(to bottom, #161616, #161616) border-box, linear-gradient(to top, #f4f4f4, #f4f4f4) border-box;
  background: linear-gradient(to top, var(--cds-ai-aura-start, rgba(69, 137, 255, 0.1)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%) padding-box, linear-gradient(to top, var(--cds-layer), var(--cds-layer)) padding-box, linear-gradient(to bottom, var(--cds-border-inverse, #161616), var(--cds-border-inverse, #161616)) border-box, linear-gradient(to top, var(--cds-layer), var(--cds-layer)) border-box;
  box-shadow: inset 0 -80px 70px -65px rgba(69, 137, 255, 0.1), 0 4px 8px 0 rgba(15, 98, 254, 0.1);
  box-shadow: inset 0 -80px 70px -65px var(--cds-ai-inner-shadow, rgba(69, 137, 255, 0.1)), 0 4px 8px 0 var(--cds-ai-drop-shadow, rgba(15, 98, 254, 0.1));
}

.cds--tile--decorator.cds--tile--selectable:hover::after,
.cds--tile--slug.cds--tile--selectable:hover::after {
  opacity: 0;
}

.cds--tile--decorator.cds--tile--is-selected::after,
.cds--tile--slug.cds--tile--is-selected::after {
  opacity: 1;
}

.cds--tile--decorator:has(.cds--tile--inner-decorator).cds--tile--is-selected,
.cds--tile--slug.cds--tile--is-selected {
  border-color: #161616;
  border-color: var(--cds-border-inverse, #161616);
}

.cds--tile--decorator.cds--tile--selectable .cds--tile-content,
.cds--tile--decorator.cds--tile--clickable .cds--tile-content,
.cds--tile--slug.cds--tile--selectable .cds--tile-content,
.cds--tile--slug.cds--tile--clickable .cds--tile-content {
  position: relative;
  cursor: pointer;
}

.cds--tile--decorator.cds--tile--selectable .cds--tile-content,
.cds--tile--decorator.cds--tile--clickable .cds--tile-content,
.cds--tile--decorator.cds--tile--selectable > .cds--tile__checkmark,
.cds--tile--decorator.cds--tile--is-selected .cds--tile--inner-decorator > *,
.cds--tile--slug.cds--tile--selectable .cds--tile-content,
.cds--tile--slug.cds--tile--clickable .cds--tile-content,
.cds--tile--slug.cds--tile--selectable > .cds--tile__checkmark,
.cds--tile--slug.cds--tile--is-selected .cds--ai-label,
.cds--tile--slug.cds--tile--is-selected .cds--slug {
  z-index: 1;
}

.cds--tile--decorator.cds--tile--selectable .cds--tile--inner-decorator > *:has(> .cds--popover--open),
.cds--tile--slug.cds--tile--selectable .cds--ai-label:has(> .cds--popover--open),
.cds--tile--slug.cds--tile--selectable .cds--slug:has(> .cds--popover--open) {
  z-index: 2;
}

.cds--tile--decorator.cds--tile--selectable > .cds--tile--inner-decorator > *,
.cds--tile--decorator.cds--tile--selectable > .cds--tile__checkmark,
.cds--tile--slug.cds--tile--selectable > .cds--ai-label,
.cds--tile--slug.cds--tile--selectable > .cds--slug,
.cds--tile--slug.cds--tile--selectable > .cds--tile__checkmark {
  z-index: 1;
}

.cds--tile--expandable:has(.cds--tile--inner-decorator > * > .cds--popover--open),
.cds--tile--expandable:has(.cds--ai-label > .cds--popover--open),
.cds--tile--expandable:has(.cds--slug > .cds--popover--open) {
  overflow: visible;
}

.cds--tile--clickable .cds--tile--ai-label-icon rect {
  stroke: #161616;
  stroke: var(--cds-icon-primary, #161616);
}

.cds--tile--clickable .cds--tile--ai-label-icon path {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--tile--decorator-rounded,
.cds--tile--decorator-rounded.cds--tile--selectable::before,
.cds--tile--decorator-rounded.cds--tile--selectable::after,
.cds--tile--decorator-rounded.cds--tile--clickable::before,
.cds--tile--slug-rounded,
.cds--tile--slug-rounded.cds--tile--selectable::before,
.cds--tile--slug-rounded.cds--tile--selectable::after,
.cds--tile--slug-rounded.cds--tile--clickable::before {
  border-radius: 0.5rem;
}

.cds--tile--decorator-rounded .cds--tile__chevron,
.cds--tile--slug-rounded .cds--tile__chevron {
  border-end-end-radius: 0.5rem;
}

.cds--loading {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--loading *,
.cds--loading *::before,
.cds--loading *::after {
  box-sizing: inherit;
}
.cds--loading {
  animation-duration: 690ms;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: cds--rotate;
  animation-timing-function: linear;
}
.cds--loading svg circle {
  animation-duration: 10ms;
  animation-name: cds--init-stroke;
  animation-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--loading svg circle {
    animation: none;
  }
}
.cds--loading {
  block-size: 5.5rem;
  inline-size: 5.5rem;
}

.cds--loading__svg {
  fill: transparent;
}

.cds--loading__svg circle {
  stroke-dasharray: 276.4608 276.4608;
  stroke-linecap: butt;
  stroke-width: 10;
}

.cds--loading__stroke {
  stroke: var(--color-primary);
  stroke: var(--cds-interactive, #0f62fe);
  stroke-dashoffset: 52.527552;
}

.cds--loading--small .cds--loading__stroke {
  stroke-dashoffset: 143.759616;
}

.cds--loading--stop {
  animation: cds--rotate-end-p1 700ms cubic-bezier(0, 0, 0.25, 1) forwards, cds--rotate-end-p2 700ms cubic-bezier(0, 0, 0.25, 1) 700ms forwards;
}
.cds--loading--stop svg circle {
  animation-delay: 700ms;
  animation-duration: 700ms;
  animation-fill-mode: forwards;
  animation-name: cds--stroke-end;
  animation-timing-function: cubic-bezier(0, 0, 0.25, 1);
}
@media screen and (prefers-reduced-motion: reduce) {
  .cds--loading--stop svg circle {
    animation: none;
  }
}

.cds--loading--small {
  block-size: 1rem;
  inline-size: 1rem;
  line-height: 1rem;
}
.cds--loading--small circle {
  stroke-width: 16;
}

.cds--loading--small .cds--loading__svg {
  stroke: var(--color-primary);
  stroke: var(--cds-interactive, #0f62fe);
}

.cds--loading__background {
  stroke: #e0e0e0;
  stroke: var(--cds-layer-accent);
  stroke-dashoffset: -22;
}

@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
  circle.cds--loading__background {
    stroke-dasharray: 265;
    stroke-dashoffset: 0;
  }
}
.cds--loading-overlay {
  position: fixed;
  z-index: 6000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.6);
  background-color: var(--cds-overlay, rgba(0, 0, 0, 0.6));
  block-size: 100%;
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  transition: background-color 700ms cubic-bezier(0.4, 0.14, 0.3, 1);
}

.cds--loading-overlay--stop {
  display: none;
}

@keyframes cds--rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes cds--rotate-end-p1 {
  100% {
    transform: rotate(360deg);
  }
}
@keyframes cds--rotate-end-p2 {
  100% {
    transform: rotate(-360deg);
  }
}
/* Stroke animations */
@keyframes cds--init-stroke {
  0% {
    stroke-dashoffset: 276.4608;
  }
  100% {
    stroke-dashoffset: 52.527552;
  }
}
@keyframes cds--stroke-end {
  0% {
    stroke-dashoffset: 52.527552;
  }
  100% {
    stroke-dashoffset: 276.4608;
  }
}
.cds--copy-btn html {
  font-size: 100%;
}
.cds--copy-btn body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--copy-btn code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--copy-btn strong {
  font-weight: 600;
}
.cds--copy-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: pointer;
}
.cds--copy-btn:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--copy-btn:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
}
.cds--copy-btn::before {
  position: absolute;
  z-index: 6000;
  border-style: solid;
  block-size: 0;
  content: "";
  inline-size: 0;
  display: none;
}
.cds--copy-btn .cds--copy-btn__feedback {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  z-index: 6000;
  padding: 0.1875rem 1rem;
  border-radius: 0.125rem;
  background-color: #393939;
  background-color: var(--cds-background-inverse, #393939);
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  font-weight: 400;
  inline-size: -webkit-max-content;
  inline-size: max-content;
  max-inline-size: 13rem;
  min-inline-size: 1.5rem;
  text-align: start;
  transform: translateX(-50%);
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--copy-btn .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@supports (-ms-accelerator: true) {
  .cds--copy-btn .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@supports (-ms-ime-align: auto) {
  .cds--copy-btn .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--copy-btn .cds--copy-btn__feedback {
    border: 1px solid transparent;
  }
}
.cds--copy-btn .cds--copy-btn__feedback {
  display: none;
  overflow: visible;
  box-sizing: content-box;
  margin: auto;
  clip: auto;
}
.cds--copy-btn:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--copy-btn:focus {
    outline-style: dotted;
  }
}
.cds--copy-btn:focus {
  outline-color: var(--color-primary);
  outline-color: var(--cds-focus, #0f62fe);
}
.cds--copy-btn.cds--copy-btn--animating::before, .cds--copy-btn.cds--copy-btn--animating .cds--copy-btn__feedback {
  display: block;
}
.cds--copy-btn.cds--copy-btn--animating::before {
  border: none;
}
.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out::before, .cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback {
  animation: 110ms cubic-bezier(0.2, 0, 0.38, 0.9) cds--hide-feedback;
}
.cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in::before, .cds--copy-btn.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback {
  animation: 110ms cubic-bezier(0.2, 0, 0.38, 0.9) cds--show-feedback;
}

.cds--copy-btn svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--copy {
  font-size: 0;
}

.cds--snippet html {
  font-size: 100%;
}
.cds--snippet body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--snippet code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--snippet strong {
  font-weight: 600;
}

.cds--snippet--disabled,
.cds--snippet--disabled .cds--btn.cds--snippet-btn--expand {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--snippet--disabled .cds--snippet-btn--expand:hover,
.cds--snippet--disabled .cds--copy-btn,
.cds--snippet--disabled .cds--copy-btn:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--snippet--disabled .cds--snippet__icon,
.cds--snippet--disabled .cds--snippet-btn--expand .cds--icon-chevron--down {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--snippet code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  font-family: var(--cds-code-01-font-family, 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace);
  font-size: 0.75rem;
  font-size: var(--cds-code-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-code-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-code-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-code-01-letter-spacing, 0.32px);
}

.cds--snippet--inline html {
  font-size: 100%;
}
.cds--snippet--inline body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--snippet--inline code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--snippet--inline strong {
  font-weight: 600;
}
.cds--snippet--inline {
  position: relative;
  display: inline;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
}
.cds--snippet--inline:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--snippet--inline:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
}
.cds--snippet--inline:focus {
  border: 1px solid var(--color-primary);
  border: 1px solid var(--cds-focus, #0f62fe);
  outline: none;
}
.cds--snippet--inline::before {
  position: absolute;
  z-index: 6000;
  border-style: solid;
  block-size: 0;
  content: "";
  inline-size: 0;
  display: none;
  border: none;
}
.cds--snippet--inline .cds--copy-btn__feedback {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  z-index: 6000;
  padding: 0.1875rem 1rem;
  border-radius: 0.125rem;
  background-color: #393939;
  background-color: var(--cds-background-inverse, #393939);
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  font-weight: 400;
  inline-size: -webkit-max-content;
  inline-size: max-content;
  max-inline-size: 13rem;
  min-inline-size: 1.5rem;
  text-align: start;
  transform: translateX(-50%);
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .cds--snippet--inline .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@supports (-ms-accelerator: true) {
  .cds--snippet--inline .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@supports (-ms-ime-align: auto) {
  .cds--snippet--inline .cds--copy-btn__feedback {
    inline-size: auto;
  }
}
@media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {
  .cds--snippet--inline .cds--copy-btn__feedback {
    border: 1px solid transparent;
  }
}
.cds--snippet--inline .cds--copy-btn__feedback {
  display: none;
  overflow: visible;
  box-sizing: content-box;
  margin: auto;
  clip: auto;
}

.cds--snippet--inline.cds--copy-btn--animating::before,
.cds--snippet--inline.cds--copy-btn--animating .cds--copy-btn__feedback {
  display: block;
}

.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out::before,
.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-out .cds--copy-btn__feedback {
  animation: 110ms cubic-bezier(0.2, 0, 0.38, 0.9) cds--hide-feedback;
}

.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in::before,
.cds--snippet--inline.cds--copy-btn--animating.cds--copy-btn--fade-in .cds--copy-btn__feedback {
  animation: 110ms cubic-bezier(0.2, 0, 0.38, 0.9) cds--show-feedback;
}

.cds--snippet--inline code {
  padding: 0 0.5rem;
}

.cds--snippet--inline.cds--snippet--no-copy {
  display: inline-block;
}
.cds--snippet--inline.cds--snippet--no-copy:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: auto;
}

.cds--snippet--light.cds--snippet--inline.cds--snippet--no-copy:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  cursor: auto;
}

.cds--snippet--single {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  font-family: var(--cds-code-01-font-family, 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace);
  font-size: 0.75rem;
  font-size: var(--cds-code-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-code-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-code-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-code-01-letter-spacing, 0.32px);
  position: relative;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
  max-inline-size: 48rem;
  display: flex;
  align-items: center;
  block-size: 2.5rem;
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}

.cds--snippet--single.cds--snippet--no-copy {
  padding: 0;
}
.cds--snippet--single.cds--snippet--no-copy::after {
  inset-inline-end: 1rem;
}

.cds--snippet--single .cds--snippet-container {
  position: relative;
  display: flex;
  align-items: center;
  block-size: 100%;
  overflow-x: auto;
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}
.cds--snippet--single .cds--snippet-container:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--snippet--single .cds--snippet-container:focus {
    outline-style: dotted;
  }
}

.cds--snippet--single pre {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  font-family: var(--cds-code-01-font-family, 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace);
  font-size: 0.75rem;
  font-size: var(--cds-code-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-code-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-code-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-code-01-letter-spacing, 0.32px);
  -webkit-padding-end: 2rem;
          padding-inline-end: 2rem;
}

.cds--snippet--single pre,
.cds--snippet--inline code {
  white-space: pre;
}

.cds--snippet--multi {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  font-family: var(--cds-code-01-font-family, 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace);
  font-size: 0.75rem;
  font-size: var(--cds-code-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-code-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-code-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-code-01-letter-spacing, 0.32px);
  position: relative;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  inline-size: 100%;
  max-inline-size: 48rem;
  display: flex;
  padding: 1rem;
}

.cds--snippet--multi .cds--snippet-container {
  position: relative;
  order: 1;
  max-block-size: 100%;
  min-block-size: 100%;
  overflow-y: auto;
  transition: max-height 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--snippet--multi .cds--snippet-container:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--snippet--multi .cds--snippet-container:focus {
    outline-style: dotted;
  }
}
.cds--snippet--multi .cds--snippet-container:focus {
  outline-offset: 0;
}

.cds--snippet--multi.cds--snippet--expand .cds--snippet-container {
  -webkit-padding-after: 1rem;
          padding-block-end: 1rem;
  transition: max-height 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--snippet--multi.cds--snippet--wraptext pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}

.cds--snippet--multi .cds--snippet-container pre {
  overflow: auto;
  -webkit-padding-after: 1.5rem;
          padding-block-end: 1.5rem;
  -webkit-padding-end: 1.5rem;
          padding-inline-end: 1.5rem;
}

.cds--snippet--multi.cds--snippet--no-copy .cds--snippet-container pre {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}

[dir=rtl] .cds--snippet--multi.cds--snippet--has-right-overflow::after {
  background-image: linear-gradient(to left, transparent, #f4f4f4);
  background-image: linear-gradient(to left, transparent, var(--cds-layer));
}

.cds--snippet--multi .cds--snippet-container pre code {
  overflow: hidden;
}

.cds--snippet__icon {
  block-size: 1rem;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 1rem;
  transition: all 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--btn > .cds--snippet__icon {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--copy-btn html {
  font-size: 100%;
}
.cds--copy-btn body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--copy-btn code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--copy-btn strong {
  font-weight: 600;
}
.cds--copy-btn {
  display: flex;
  overflow: visible;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  cursor: pointer;
  outline: none;
}
.cds--copy-btn:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--copy-btn:focus {
    outline-style: dotted;
  }
}
.cds--copy-btn:focus {
  outline-color: var(--color-primary);
  outline-color: var(--cds-focus, #0f62fe);
}

.cds--snippet .cds--popover-container {
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
}

.cds--snippet--inline.cds--btn {
  block-size: 1.25rem;
  inline-size: initial;
  max-inline-size: unset;
  min-block-size: 1.25rem;
  padding-inline: 0;
}

.cds--snippet--inline.cds--btn.cds--btn--primary:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--snippet.cds--snippet--multi .cds--popover-container {
  inset-block-start: 0.5rem;
  inset-inline-end: 0.5rem;
}

.cds--snippet--multi .cds--copy-btn {
  z-index: 10;
}

.cds--snippet-btn--expand {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  position: absolute;
  z-index: 10;
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  border: 0;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  block-size: 2rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  inset-block-end: 0;
  inset-inline-end: 0;
}

.cds--snippet-btn--expand .cds--snippet-btn--text {
  position: relative;
  inset-block-start: -0.0625rem;
}

.cds--snippet-btn--expand--hide.cds--snippet-btn--expand {
  display: none;
}

.cds--snippet-btn--expand .cds--icon-chevron--down {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  transform: rotate(0deg);
  transition: 150ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--snippet-btn--expand:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--snippet-btn--expand:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
}

.cds--snippet-btn--expand:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--snippet-btn--expand:focus {
    outline-style: dotted;
  }
}
.cds--snippet-btn--expand:focus {
  border-color: transparent;
}

.cds--snippet--expand .cds--snippet-btn--expand .cds--icon-chevron--down {
  transform: rotate(180deg);
  transition: transform 300ms;
}

.cds--snippet--light,
.cds--snippet--light .cds--snippet-button,
.cds--snippet--light .cds--btn.cds--snippet-btn--expand,
.cds--snippet--light .cds--copy-btn {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--snippet--light.cds--snippet--inline:hover,
.cds--snippet--light .cds--snippet-button:hover,
.cds--snippet--light .cds--btn.cds--snippet-btn--expand:hover,
.cds--snippet--light .cds--copy-btn:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.cds--snippet--light.cds--snippet--inline:active,
.cds--snippet--light .cds--snippet-button:active,
.cds--snippet--light .cds--btn.cds--snippet-btn--expand:active,
.cds--snippet--light .cds--copy-btn:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
}

.cds--snippet.cds--skeleton .cds--snippet-container {
  block-size: 100%;
  inline-size: 100%;
}

.cds--snippet-button .cds--btn--copy__feedback {
  inset-block-start: 3.175rem;
  inset-inline: 50% auto;
}
.cds--snippet-button .cds--btn--copy__feedback::before {
  inset-block-start: 0;
}
.cds--snippet-button .cds--btn--copy__feedback::after {
  inset-block-start: -0.25rem;
}

.cds--snippet--multi .cds--snippet-button .cds--btn--copy__feedback {
  inset-block-start: 2.675rem;
}

.cds--snippet--inline .cds--btn--copy__feedback {
  inset-block-start: calc(100% - 0.25rem);
  inset-inline: 50% auto;
}

.cds--snippet--single .cds--snippet-container {
  -webkit-mask-image: linear-gradient(to right, #000000 calc(100% - 2rem), transparent 100%);
          mask-image: linear-gradient(to right, #000000 calc(100% - 2rem), transparent 100%);
  pointer-events: auto;
}

.cds--snippet--multi {
  position: relative;
}

.cds--snippet--multi .cds--snippet-container {
  inline-size: 100%;
  -webkit-mask-composite: source-in, xor;
          mask-composite: intersect;
  -webkit-mask-image: linear-gradient(to right, #000000 calc(100% - 2rem), transparent 100%), linear-gradient(to bottom, #000000 calc(100% - 1rem), transparent 100%);
          mask-image: linear-gradient(to right, #000000 calc(100% - 2rem), transparent 100%), linear-gradient(to bottom, #000000 calc(100% - 1rem), transparent 100%);
  pointer-events: auto;
}

[dir=rtl] .cds--snippet--single .cds--snippet-container {
  -webkit-mask-image: linear-gradient(to left, #000000 calc(100% - 2rem), transparent 100%);
          mask-image: linear-gradient(to left, #000000 calc(100% - 2rem), transparent 100%);
}

[dir=rtl] .cds--snippet--multi .cds--snippet-container {
  -webkit-mask-image: linear-gradient(to left, #000000 calc(100% - 2rem), transparent 100%), linear-gradient(to bottom, #000000 calc(100% - 1rem), transparent 100%);
          mask-image: linear-gradient(to left, #000000 calc(100% - 2rem), transparent 100%), linear-gradient(to bottom, #000000 calc(100% - 1rem), transparent 100%);
}

.cds--snippet--single:focus-within .cds--snippet-container,
.cds--snippet--multi:focus-within .cds--snippet-container {
  -webkit-mask-image: none;
          mask-image: none;
}

.cds--snippet--multi.cds--skeleton {
  block-size: 6.125rem;
}

.cds--snippet--single.cds--skeleton {
  block-size: 3.5rem;
}

.cds--snippet.cds--skeleton span {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--snippet.cds--skeleton span:hover, .cds--snippet.cds--skeleton span:focus, .cds--snippet.cds--skeleton span:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--snippet.cds--skeleton span::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--snippet.cds--skeleton span::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--snippet.cds--skeleton span {
    background: CanvasText;
  }
  .cds--snippet.cds--skeleton span::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--snippet.cds--skeleton span {
  display: block;
  block-size: 1rem;
  inline-size: 100%;
  -webkit-margin-before: 0.5rem;
          margin-block-start: 0.5rem;
}
.cds--snippet.cds--skeleton span:first-child {
  margin: 0;
}
.cds--snippet.cds--skeleton span:nth-child(2) {
  inline-size: 85%;
}
.cds--snippet.cds--skeleton span:nth-child(3) {
  inline-size: 95%;
}

.cds--snippet--single.cds--skeleton .cds--snippet-container {
  -webkit-padding-after: 0;
          padding-block-end: 0;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--snippet--inline:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--snippet--single,
  .cds--snippet--multi {
    outline: 1px solid transparent;
  }
}

.cds--content-switcher {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
  display: flex;
  justify-content: space-evenly;
  border-radius: 0.25rem;
  block-size: var(--cds-layout-size-height-local);
  inline-size: 100%;
  outline: 0.0625rem solid #161616;
  outline: 0.0625rem solid var(--cds-border-inverse, #161616);
  outline-offset: -0.0625rem;
}

.cds--content-switcher:has(.cds--content-switcher-btn:disabled) {
  outline-color: #c6c6c6;
  outline-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--content-switcher-btn html {
  font-size: 100%;
}
.cds--content-switcher-btn body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--content-switcher-btn code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--content-switcher-btn strong {
  font-weight: 600;
}
.cds--content-switcher-btn {
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  outline: 2px solid transparent;
  outline-offset: -2px;
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: inline-flex;
  overflow: hidden;
  border: none;
  margin: 0;
  background-color: transparent;
  -webkit-border-after: 0.0625rem solid #161616;
          border-block-end: 0.0625rem solid #161616;
  -webkit-border-after: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-end: 0.0625rem solid var(--cds-border-inverse, #161616);
  -webkit-border-before: 0.0625rem solid #161616;
          border-block-start: 0.0625rem solid #161616;
  -webkit-border-before: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-start: 0.0625rem solid var(--cds-border-inverse, #161616);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  text-align: start;
  text-decoration: none;
  white-space: nowrap;
}
.cds--content-switcher-btn::after {
  position: absolute;
  display: block;
  border-radius: 0.25rem;
  background-color: #161616;
  background-color: var(--cds-layer-selected-inverse, #161616);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-block-start: 0;
  inset-inline-start: 0;
  transform: scaleY(0);
  transform-origin: bottom;
}
.cds--content-switcher-btn:disabled::after {
  display: none;
}
.cds--content-switcher-btn:focus {
  border: 0;
}
.cds--content-switcher-btn:focus::after {
  border-radius: 0.25rem;
  box-shadow: inset 0 0 0 2px var(--color-primary), inset 0 0 0 3px #ffffff;
  box-shadow: inset 0 0 0 2px var(--cds-focus, #0f62fe), inset 0 0 0 3px var(--cds-focus-inset, #ffffff);
}
.cds--content-switcher-btn:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
}
.cds--content-switcher-btn:hover, .cds--content-switcher-btn:active {
  z-index: 3;
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--content-switcher-btn:disabled {
  border-color: #c6c6c6;
  border-color: var(--cds-border-disabled, #c6c6c6);
  background-color: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--content-switcher-btn:disabled:hover {
  cursor: not-allowed;
}

.cds--content-switcher-btn:not(.cds--content-switcher--selected):focus::before {
  display: block;
  border-radius: 0.25rem;
  block-size: 100%;
  box-shadow: inset 0 0 0 0.125rem var(--color-primary);
  box-shadow: inset 0 0 0 0.125rem var(--cds-focus, #0f62fe);
  content: "";
  inline-size: 100%;
}
.cds--content-switcher-btn:not(.cds--content-switcher--selected):focus::after {
  background-color: #ffffff;
  background-color: var(--cds-focus-inset, #ffffff);
  transform: scaleY(1);
}
.cds--content-switcher-btn:not(.cds--content-switcher--selected):focus:hover::after {
  border-radius: 0;
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  -webkit-border-after: 0.0625rem solid #161616;
          border-block-end: 0.0625rem solid #161616;
  -webkit-border-after: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-end: 0.0625rem solid var(--cds-border-inverse, #161616);
  -webkit-border-before: 0.0625rem solid #161616;
          border-block-start: 0.0625rem solid #161616;
  -webkit-border-before: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-start: 0.0625rem solid var(--cds-border-inverse, #161616);
  box-shadow: none;
}

.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn {
  align-items: center;
  padding: 0.5rem var(--cds-layout-density-padding-inline-local);
  inline-size: 100%;
}

.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-child {
  border-end-start-radius: 0.25rem;
  border-start-start-radius: 0.25rem;
  box-shadow: inset 0.0625rem 0 0 0 #161616;
  box-shadow: inset 0.0625rem 0 0 0 var(--cds-border-inverse, #161616);
}
.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-child:disabled {
  box-shadow: none;
}

.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:last-child {
  border-end-end-radius: 0.25rem;
  border-start-end-radius: 0.25rem;
  box-shadow: inset -0.0625rem 0 0 0 #161616;
  box-shadow: inset -0.0625rem 0 0 0 var(--cds-border-inverse, #161616);
}
.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:last-child:disabled {
  box-shadow: none;
}

.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected,
.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:first-child,
.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:last-child {
  border: 0;
}
.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:disabled::before,
.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:first-child:disabled::before,
.cds--content-switcher .cds--content-switcher-btn.cds--content-switcher--selected:last-child:disabled::before {
  display: none;
}

.cds--content-switcher-btn::before {
  position: absolute;
  z-index: 2;
  display: block;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1rem;
  content: "";
  inline-size: 0.0625rem;
  inset-inline-start: 0;
}

.cds--content-switcher:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-of-type::before {
  background-color: transparent;
}

.cds--content-switcher-btn:focus::before,
.cds--content-switcher-btn:focus + .cds--content-switcher-btn::before,
.cds--content-switcher-btn:hover::before,
.cds--content-switcher-btn:hover + .cds--content-switcher-btn::before,
.cds--content-switcher--selected::before,
.cds--content-switcher--selected + .cds--content-switcher-btn::before {
  background-color: transparent;
}

.cds--content-switcher-btn:disabled::before,
.cds--content-switcher-btn:disabled:hover + .cds--content-switcher-btn:disabled::before {
  background-color: #c6c6c6;
  background-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--content-switcher-btn.cds--content-switcher--selected:disabled + .cds--content-switcher-btn::before,
.cds--content-switcher-btn.cds--content-switcher--selected:disabled:hover + .cds--content-switcher-btn::before {
  background-color: transparent;
}

.cds--content-switcher__icon {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--content-switcher__icon + span {
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
}

.cds--content-switcher__label {
  z-index: 1;
  overflow: hidden;
  max-inline-size: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--content-switcher-btn:hover .cds--content-switcher__icon,
.cds--content-switcher-btn:focus .cds--content-switcher__icon {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--content-switcher-btn:focus:has(+ .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover)::before,
.cds--content-switcher-btn:not(.cds--content-switcher--selected):hover + .cds--content-switcher-btn:focus::before,
.cds--content-switcher-btn:hover + .cds--content-switcher-btn.cds--content-switcher--selected::before,
.cds--content-switcher-btn.cds--content-switcher--selected:has(+ .cds--content-switcher-btn:hover)::before {
  z-index: 0;
  border-radius: 0;
  block-size: 100%;
  -webkit-border-after: 0.0625rem solid #161616;
          border-block-end: 0.0625rem solid #161616;
  -webkit-border-after: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-end: 0.0625rem solid var(--cds-border-inverse, #161616);
  -webkit-border-before: 0.0625rem solid #161616;
          border-block-start: 0.0625rem solid #161616;
  -webkit-border-before: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-start: 0.0625rem solid var(--cds-border-inverse, #161616);
  box-shadow: inset 0 0 0 0.0625rem #e8e8e8;
  box-shadow: inset 0 0 0 0.0625rem var(--cds-layer-hover);
  content: "";
  inline-size: 100%;
}
.cds--content-switcher-btn:focus:has(+ .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover):not(.cds--content-switcher--selected)::after,
.cds--content-switcher-btn:not(.cds--content-switcher--selected):hover + .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher-btn:hover + .cds--content-switcher-btn.cds--content-switcher--selected:not(.cds--content-switcher--selected)::after,
.cds--content-switcher-btn.cds--content-switcher--selected:has(+ .cds--content-switcher-btn:hover):not(.cds--content-switcher--selected)::after {
  background-color: #ffffff;
  background-color: var(--cds-focus-inset, #ffffff);
  transform: scaleY(1);
}

.cds--content-switcher-btn.cds--content-switcher--selected {
  z-index: 3;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
}
.cds--content-switcher-btn.cds--content-switcher--selected:hover {
  background-color: transparent;
}
.cds--content-switcher-btn.cds--content-switcher--selected:disabled {
  border-radius: 0.25rem;
  background-color: #c6c6c6;
  background-color: var(--cds-button-disabled, #c6c6c6);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--content-switcher-btn.cds--content-switcher--selected::after {
  transform: scaleY(1);
}

.cds--content-switcher-btn.cds--content-switcher--selected .cds--content-switcher__icon {
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--content-switcher-btn:focus {
    color: Highlight;
    outline: 1px solid Highlight;
  }
}

.cds--content-switcher--icon-only {
  justify-content: flex-start;
  inline-size: -webkit-fit-content;
  inline-size: fit-content;
}

.cds--content-switcher--icon-only .cds--content-switcher-btn {
  align-items: center;
  padding: 0;
  transition: none;
}
.cds--content-switcher--icon-only .cds--content-switcher-btn:focus {
  box-shadow: none;
}

.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn:first-of-type::before {
  background-color: transparent;
}

.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn {
  border-end-start-radius: 0.25rem;
  border-start-start-radius: 0.25rem;
  box-shadow: inset 0.0625rem 0 0 0 #161616;
  box-shadow: inset 0.0625rem 0 0 0 var(--cds-border-inverse, #161616);
}

.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn {
  border-end-end-radius: 0.25rem;
  border-start-end-radius: 0.25rem;
  box-shadow: inset -0.0625rem 0 0 0 #161616;
  box-shadow: inset -0.0625rem 0 0 0 var(--cds-border-inverse, #161616);
}

.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn[disabled],
.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn[disabled] {
  box-shadow: none;
}

.cds--content-switcher--lg .cds--content-switcher-btn {
  padding-inline: 0.875rem 0.875rem;
}

.cds--content-switcher--lg .cds--content-switcher-btn svg {
  block-size: 20px;
  inline-size: 20px;
}

.cds--content-switcher--icon-only .cds--content-switcher-btn svg {
  z-index: 1;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--content-switcher--icon-only .cds--content-switcher-btn.cds--content-switcher--selected svg {
  z-index: 1;
  fill: #ffffff;
  fill: var(--cds-icon-inverse, #ffffff);
}

.cds--content-switcher--icon-only.cds--content-switcher--sm .cds--btn--sm {
  block-size: 2rem;
}

.cds--content-switcher-btn:focus::before,
.cds--content-switcher-popover__wrapper:focus-within + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn::before,
.cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--disabled):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher--selected):not(:focus)::before,
.cds--content-switcher--selected::before,
.cds--content-switcher-popover--selected + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn::before {
  background-color: transparent;
}

.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled] svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled]:not(.cds--content-switcher--selected):hover,
.cds--content-switcher--icon-only .cds--content-switcher-popover--selected + .cds--content-switcher-popover--disabled .cds--content-switcher-btn[disabled]:hover::before {
  background-color: transparent;
}

.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled]:hover::before {
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
}

.cds--content-switcher-popover__wrapper:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover) .cds--content-switcher-btn:focus::before,
.cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--selected):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:focus::before,
.cds--content-switcher-popover__wrapper:hover + .cds--content-switcher-popover__wrapper .cds--content-switcher--selected::before,
.cds--content-switcher-popover--selected:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:hover) .cds--content-switcher-btn::before {
  z-index: 0;
  border-radius: 0;
  block-size: 100%;
  -webkit-border-after: 0.0625rem solid #161616;
          border-block-end: 0.0625rem solid #161616;
  -webkit-border-after: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-end: 0.0625rem solid var(--cds-border-inverse, #161616);
  -webkit-border-before: 0.0625rem solid #161616;
          border-block-start: 0.0625rem solid #161616;
  -webkit-border-before: 0.0625rem solid var(--cds-border-inverse, #161616);
          border-block-start: 0.0625rem solid var(--cds-border-inverse, #161616);
  box-shadow: inset 0 0 0 0.0625rem #e8e8e8;
  box-shadow: inset 0 0 0 0.0625rem var(--cds-layer-hover);
  content: "";
  inline-size: 100%;
}
.cds--content-switcher-popover__wrapper:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover) .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--selected):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher-popover__wrapper:hover + .cds--content-switcher-popover__wrapper .cds--content-switcher--selected:not(.cds--content-switcher--selected)::after,
.cds--content-switcher-popover--selected:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:hover) .cds--content-switcher-btn:not(.cds--content-switcher--selected)::after {
  background-color: #ffffff;
  background-color: var(--cds-focus-inset, #ffffff);
  transform: scaleY(1);
}

.cds--content-switcher--low-contrast {
  background-color: #e0e0e0;
  background-color: var(--cds-content-switcher-background, #e0e0e0);
  outline-color: #8d8d8d;
  outline-color: var(--cds-border-strong);
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn {
  border-color: #8d8d8d;
  border-color: var(--cds-border-strong);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:hover, .cds--content-switcher--low-contrast .cds--content-switcher-btn:active {
  background-color: #d1d1d1;
  background-color: var(--cds-content-switcher-background-hover, #d1d1d1);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn::before {
  background-color: #8d8d8d;
  background-color: var(--cds-border-strong);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn::after {
  background-color: #ffffff;
  background-color: var(--cds-content-switcher-selected, #ffffff);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:disabled {
  border-color: #c6c6c6;
  border-color: var(--cds-border-disabled, #c6c6c6);
  background-color: transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:disabled:hover {
  cursor: not-allowed;
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher--selected):focus::before {
  background: transparent;
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher--selected):focus::after {
  background-color: #e0e0e0;
  background-color: var(--cds-content-switcher-background, #e0e0e0);
  box-shadow: inset 0 0 0 0.125rem var(--color-primary);
  box-shadow: inset 0 0 0 0.125rem var(--cds-focus, #0f62fe);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher--selected):focus:hover::after {
  border-color: #8d8d8d;
  border-color: var(--cds-border-strong);
  background-color: #d1d1d1;
  background-color: var(--cds-content-switcher-background-hover, #d1d1d1);
  box-shadow: none;
}

.cds--content-switcher--low-contrast:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:first-child {
  box-shadow: inset 0.0625rem 0 0 0 #8d8d8d;
  box-shadow: inset 0.0625rem 0 0 0 var(--cds-border-strong);
}

.cds--content-switcher--low-contrast:not(.cds--content-switcher--icon-only) .cds--content-switcher-btn:last-child {
  box-shadow: inset -0.0625rem 0 0 0 #8d8d8d;
  box-shadow: inset -0.0625rem 0 0 0 var(--cds-border-strong);
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn:focus:has(+ .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover)::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover + .cds--content-switcher-btn:focus::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:hover + .cds--content-switcher-btn.cds--content-switcher--selected::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:has(+ .cds--content-switcher-btn:hover)::before {
  border-color: #8d8d8d;
  border-color: var(--cds-border-strong);
  box-shadow: inset 0 0 0 0.0625rem #d1d1d1;
  box-shadow: inset 0 0 0 0.0625rem var(--cds-content-switcher-background-hover, #d1d1d1);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn:focus:has(+ .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover):not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover + .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:hover + .cds--content-switcher-btn.cds--content-switcher--selected:not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:has(+ .cds--content-switcher-btn:hover):not(.cds--content-switcher--selected)::after {
  background-color: #e0e0e0;
  background-color: var(--cds-content-switcher-background, #e0e0e0);
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:hover {
  background-color: transparent;
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected::after {
  border-radius: 0.25rem;
  background-color: #ffffff;
  background-color: var(--cds-content-switcher-selected, #ffffff);
  box-shadow: inset 0 0 0 0.0625rem #161616;
  box-shadow: inset 0 0 0 0.0625rem var(--cds-border-inverse, #161616);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:focus::after {
  box-shadow: inset 0 0 0 0.125rem var(--color-primary);
  box-shadow: inset 0 0 0 0.125rem var(--cds-focus, #0f62fe);
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:disabled {
  border: 0.0625rem solid #c6c6c6;
  border: 0.0625rem solid var(--cds-border-disabled, #c6c6c6);
  border-radius: 0.25rem;
  background-color: #ffffff;
  background-color: var(--cds-content-switcher-selected, #ffffff);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:disabled::before {
  background-color: transparent;
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn:focus::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:focus + .cds--content-switcher-btn::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:hover::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:hover + .cds--content-switcher-btn::before,
.cds--content-switcher--low-contrast .cds--content-switcher--selected::before,
.cds--content-switcher--low-contrast .cds--content-switcher--selected + .cds--content-switcher-btn::before {
  background-color: transparent;
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn:disabled::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:disabled:hover + .cds--content-switcher-btn:disabled::before {
  background-color: #c6c6c6;
  background-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:disabled + .cds--content-switcher-btn::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn.cds--content-switcher--selected:disabled:hover + .cds--content-switcher-btn::before,
.cds--content-switcher--low-contrast .cds--content-switcher-btn:disabled:hover + .cds--content-switcher-btn.cds--content-switcher--selected::before {
  background-color: transparent;
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:first-child .cds--content-switcher-btn:not([disabled]) {
  box-shadow: inset 0.0625rem 0 0 0 #8d8d8d;
  box-shadow: inset 0.0625rem 0 0 0 var(--cds-border-strong);
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-popover__wrapper:last-child .cds--content-switcher-btn:not([disabled]) {
  box-shadow: inset -0.0625rem 0 0 0 #8d8d8d;
  box-shadow: inset -0.0625rem 0 0 0 var(--cds-border-strong);
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn:hover svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn[disabled] svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn.cds--content-switcher--selected svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn.cds--content-switcher--selected[disabled] svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--content-switcher--low-contrast.cds--content-switcher--icon-only .cds--content-switcher-btn.cds--content-switcher--selected:disabled {
  border-color: #c6c6c6;
  border-color: var(--cds-border-disabled, #c6c6c6);
}

.cds--content-switcher--low-contrast .cds--content-switcher-btn:not(.cds--content-switcher__selected-hovered):focus::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:focus-within + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--disabled):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher__selected-hovered)::before,
.cds--content-switcher--low-contrast .cds--content-switcher--selected:not(.cds--content-switcher__selected-hovered)::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover--selected + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn::before {
  background-color: transparent;
}

.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover) .cds--content-switcher-btn:focus::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--selected):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:focus::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:hover + .cds--content-switcher-popover__wrapper .cds--content-switcher--selected::before,
.cds--content-switcher--low-contrast .cds--content-switcher-popover--selected:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:hover) .cds--content-switcher-btn::before {
  border-color: #8d8d8d;
  border-color: var(--cds-border-strong);
  box-shadow: inset 0 0 0 0.0625rem #d1d1d1;
  box-shadow: inset 0 0 0 0.0625rem var(--cds-content-switcher-background-hover, #d1d1d1);
}
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:not(.cds--content-switcher--selected):hover) .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:not(.cds--content-switcher-popover--selected):hover + .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:focus:not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-popover__wrapper:hover + .cds--content-switcher-popover__wrapper .cds--content-switcher--selected:not(.cds--content-switcher--selected)::after,
.cds--content-switcher--low-contrast .cds--content-switcher-popover--selected:has(+ .cds--content-switcher-popover__wrapper .cds--content-switcher-btn:hover) .cds--content-switcher-btn:not(.cds--content-switcher--selected)::after {
  background-color: #e0e0e0;
  background-color: var(--cds-content-switcher-background, #e0e0e0);
}

.cds--progress {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--progress *,
.cds--progress *::before,
.cds--progress *::after {
  box-sizing: inherit;
}
.cds--progress {
  display: flex;
  list-style: none;
}

.cds--progress-step {
  position: relative;
  display: inline-flex;
  overflow: visible;
  flex-direction: row;
  inline-size: 8rem;
  min-inline-size: 7rem;
}
.cds--progress-step .cds--tooltip__label {
  display: block;
}

.cds--progress--space-equal .cds--progress-step {
  flex-grow: 1;
  min-inline-size: 8rem;
}

.cds--progress-line {
  position: absolute;
  border: 1px inset transparent;
  block-size: 2px;
  inline-size: 8rem;
  inset-inline-start: 0;
}

.cds--progress--space-equal .cds--progress-line {
  inline-size: 100%;
  min-inline-size: 8rem;
}

.cds--progress-step svg {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  border-radius: 50%;
  block-size: 1rem;
  fill: var(--color-primary);
  fill: var(--cds-interactive, #0f62fe);
  inline-size: 1rem;
  -webkit-margin-before: 0.625rem;
          margin-block-start: 0.625rem;
  -webkit-margin-end: 0.5rem;
          margin-inline-end: 0.5rem;
}

.cds--progress--space-equal .cds--progress-text {
  overflow: hidden;
  padding: 0.125rem;
  margin: -0.125rem;
}

.cds--progress-label {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: block;
  overflow: hidden;
  margin: 0.5rem 0 0 0;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  line-height: 1.45;
  max-inline-size: 5.5rem;
  text-overflow: ellipsis;
  transition: box-shadow 110ms cubic-bezier(0.2, 0, 0.38, 0.9), color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  white-space: nowrap;
}
.cds--progress-label::before {
  display: block;
  content: "";
}

.cds--progress-label:hover {
  box-shadow: 0 0.0625rem color-mix(in oklab, var(--color-primary) 80%, black);
  box-shadow: 0 0.0625rem var(--cds-link-primary-hover, #0043ce);
  color: color-mix(in oklab, var(--color-primary) 80%, black);
  color: var(--cds-link-primary-hover, #0043ce);
  cursor: pointer;
}

.cds--progress--space-equal .cds--progress-label {
  -webkit-margin-end: 0.75rem;
          margin-inline-end: 0.75rem;
  max-inline-size: 100%;
}

.cds--progress-step-button:focus {
  outline: none;
}
.cds--progress-step-button:focus-visible .cds--progress-label {
  color: var(--color-primary);
  color: var(--cds-focus, #0f62fe);
  outline: 0.0625rem solid var(--color-primary);
  outline: 0.0625rem solid var(--cds-focus, #0f62fe);
}

.cds--progress-step-button:not(.cds--progress-step-button--unclickable) .cds--progress-label:active {
  box-shadow: 0 0.0625rem 0 0 #161616;
  box-shadow: 0 0.0625rem 0 0 var(--cds-text-primary, #161616);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--progress-label-overflow:hover ~ .cds--tooltip,
.cds--progress-label-overflow:focus ~ .cds--tooltip {
  visibility: inherit;
}

.cds--progress-step .cds--tooltip .cds--tooltip__caret {
  -webkit-margin-start: 0.625rem;
          margin-inline-start: 0.625rem;
}

.cds--tooltip__text {
  padding: 0;
  margin: 0;
  font-weight: normal;
}

.cds--progress-step .cds--tooltip {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  display: block;
  padding: 0.5rem 1rem;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: 7.8125rem;
  -webkit-margin-before: 2.5rem;
          margin-block-start: 2.5rem;
  -webkit-margin-start: 1.375rem;
          margin-inline-start: 1.375rem;
  min-block-size: 1.5rem;
  min-inline-size: 7.1875rem;
  visibility: hidden;
}

.cds--progress-step .cds--tooltip_multi {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  block-size: auto;
  color: #ffffff;
  color: var(--cds-text-inverse, #ffffff);
  inline-size: 9.375rem;
}

.cds--progress-optional {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  position: absolute;
  display: block;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inset-inline-start: 0;
  -webkit-margin-before: 1.75rem;
          margin-block-start: 1.75rem;
  -webkit-margin-start: 1.5rem;
          margin-inline-start: 1.5rem;
  text-align: start;
}

.cds--progress-step--current .cds--progress-line {
  background-color: var(--color-primary);
  background-color: var(--cds-interactive, #0f62fe);
}

.cds--progress-step--incomplete svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--progress-step--incomplete .cds--progress-line {
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
}

.cds--progress-step--complete .cds--progress-line {
  background-color: var(--color-primary);
  background-color: var(--cds-interactive, #0f62fe);
}

.cds--progress-step-button {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--progress-step-button *,
.cds--progress-step-button *::before,
.cds--progress-step-button *::after {
  box-sizing: inherit;
}
.cds--progress-step-button::-moz-focus-inner {
  border: 0;
}
.cds--progress-step-button {
  display: flex;
  text-align: start;
}

.cds--progress-step-button--unclickable {
  cursor: default;
  outline: none;
}

.cds--progress-step-button--unclickable .cds--progress-label:hover {
  box-shadow: none;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: default;
}

.cds--progress-step-button--unclickable .cds--tooltip__label:hover {
  box-shadow: 0 0.0625rem var(--color-primary);
  box-shadow: 0 0.0625rem var(--cds-link-primary, #0f62fe);
  color: var(--color-primary);
  color: var(--cds-link-primary, #0f62fe);
  cursor: pointer;
}

.cds--progress-step--disabled {
  cursor: not-allowed;
  pointer-events: none;
}
.cds--progress-step--disabled svg {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--progress-step--disabled .cds--progress-label,
.cds--progress-step--disabled .cds--progress-label:hover {
  box-shadow: none;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--progress-step--disabled .cds--progress-line {
  cursor: not-allowed;
}
.cds--progress-step--disabled .cds--progress-label-overflow:hover ~ .cds--tooltip--definition .cds--tooltip--definition__bottom {
  display: none;
}

.cds--progress__warning > * {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}

.cds--progress.cds--skeleton .cds--progress-label {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--progress.cds--skeleton .cds--progress-label:hover, .cds--progress.cds--skeleton .cds--progress-label:focus, .cds--progress.cds--skeleton .cds--progress-label:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--progress.cds--skeleton .cds--progress-label::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--progress.cds--skeleton .cds--progress-label::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--progress.cds--skeleton .cds--progress-label {
    background: CanvasText;
  }
  .cds--progress.cds--skeleton .cds--progress-label::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--progress.cds--skeleton .cds--progress-label {
  block-size: 0.875rem;
  inline-size: 2.5rem;
  -webkit-margin-before: 0.625rem;
          margin-block-start: 0.625rem;
}

.cds--progress.cds--progress--vertical.cds--skeleton .cds--progress-label {
  -webkit-margin-before: 0.0625rem;
          margin-block-start: 0.0625rem;
}

.cds--progress--vertical {
  display: flex;
  flex-direction: column;
}

.cds--progress--vertical,
.cds--progress-text {
  display: flex;
  flex-direction: column;
}

.cds--progress--vertical .cds--progress-step,
.cds--progress--vertical .cds--progress-step-button {
  align-content: flex-start;
  inline-size: initial;
  min-block-size: 3.625rem;
  min-inline-size: initial;
}

.cds--progress--vertical .cds--progress-step svg,
.cds--progress--vertical .cds--progress-step-button svg {
  display: inline-block;
  margin: 0.0625rem 0.5rem 0;
}

.cds--progress--vertical .cds--progress-label {
  display: inline-block;
  margin: 0;
  inline-size: initial;
  max-inline-size: 10rem;
  vertical-align: top;
  white-space: normal;
  white-space: initial;
}

.cds--progress--vertical .cds--progress-step .cds--tooltip {
  -webkit-margin-before: 0.5rem;
          margin-block-start: 0.5rem;
}

.cds--progress--vertical .cds--progress-optional {
  position: static;
  margin: 0 0 auto;
  inline-size: 100%;
}

.cds--progress--vertical .cds--progress-line {
  position: absolute;
  block-size: 100%;
  inline-size: 1px;
  inset-block-start: 0;
  inset-inline-start: 0;
}

.cds--menu {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--menu *,
.cds--menu *::before,
.cds--menu *::after {
  box-sizing: inherit;
}
.cds--menu {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  position: fixed;
  z-index: 9000;
  padding: 0.25rem 0;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  max-inline-size: 18rem;
  min-inline-size: 10rem;
  opacity: 0;
  overflow-y: auto;
  visibility: hidden;
}

.cds--menu--border {
  outline: 1px solid #e0e0e0;
  outline: 1px solid var(--cds-border-subtle);
}

.cds--menu--background-token__background {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}

.cds--menu--with-icons {
  min-inline-size: 12rem;
}

.cds--menu--open {
  visibility: visible;
}
.cds--menu--open:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .cds--menu--open:focus {
    outline-style: dotted;
  }
}

.cds--menu:not(.cds--menu--open) .cds--menu--open {
  visibility: hidden;
}

.cds--menu--shown {
  overflow: visible;
  opacity: 1;
}

.cds--menu-item {
  font-size: 0.875rem;
  font-size: var(--cds-body-short-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-short-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-short-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-short-01-letter-spacing, 0.16px);
  display: grid;
  align-items: center;
  block-size: 2rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
  cursor: pointer;
  grid-template-columns: 1fr -webkit-max-content;
  grid-template-columns: 1fr max-content;
  padding-inline: 1rem;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--menu-item:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--menu-item:focus {
    outline-style: dotted;
  }
}

.cds--menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--menu--xs .cds--menu-item {
  block-size: 1.5rem;
}

.cds--menu--sm .cds--menu-item {
  block-size: 2rem;
}

.cds--menu--md .cds--menu-item {
  block-size: 2.5rem;
}

.cds--menu--lg .cds--menu-item {
  block-size: 3rem;
}

.cds--menu-item__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--menu-item__shortcut {
  display: flex;
}

.cds--menu-item-group > ul,
.cds--menu-item-radio-group > ul {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--menu-item-group > ul *,
.cds--menu-item-group > ul *::before,
.cds--menu-item-group > ul *::after,
.cds--menu-item-radio-group > ul *,
.cds--menu-item-radio-group > ul *::before,
.cds--menu-item-radio-group > ul *::after {
  box-sizing: inherit;
}

.cds--menu-item__icon,
.cds--menu-item__selection-icon {
  display: none;
}

.cds--menu--with-icons > .cds--menu-item,
.cds--menu--with-icons > .cds--menu-item-group > ul > .cds--menu-item,
.cds--menu--with-icons > .cds--menu-item-radio-group > ul > .cds--menu-item,
.cds--menu--with-selectable-items > .cds--menu-item,
.cds--menu--with-selectable-items > .cds--menu-item-group > ul > .cds--menu-item,
.cds--menu--with-selectable-items > .cds--menu-item-radio-group > ul > .cds--menu-item {
  grid-template-columns: 1rem 1fr -webkit-max-content;
  grid-template-columns: 1rem 1fr max-content;
}

.cds--menu--with-icons > .cds--menu-item > .cds--menu-item__icon,
.cds--menu--with-icons > .cds--menu-item-group > ul > .cds--menu-item > .cds--menu-item__icon,
.cds--menu--with-icons > .cds--menu-item-radio-group > ul > .cds--menu-item > .cds--menu-item__icon,
.cds--menu--with-selectable-items > .cds--menu-item > .cds--menu-item__selection-icon,
.cds--menu--with-selectable-items > .cds--menu-item-group > ul > .cds--menu-item > .cds--menu-item__selection-icon,
.cds--menu--with-selectable-items > .cds--menu-item-radio-group > ul > .cds--menu-item > .cds--menu-item__selection-icon {
  display: flex;
}

.cds--menu--with-icons.cds--menu--with-selectable-items > .cds--menu-item,
.cds--menu--with-icons.cds--menu--with-selectable-items > .cds--menu-item-group > ul > .cds--menu-item,
.cds--menu--with-icons.cds--menu--with-selectable-items > .cds--menu-item-radio-group > ul > .cds--menu-item {
  grid-template-columns: 1rem 1rem 1fr -webkit-max-content;
  grid-template-columns: 1rem 1rem 1fr max-content;
}

.cds--menu-item--disabled {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}

.cds--menu-item--disabled:hover,
.cds--menu-item--disabled.cds--menu-item--danger:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.cds--menu-item--danger:focus,
.cds--menu-item--danger:hover {
  background-color: #da1e28;
  background-color: var(--cds-button-danger-primary, #da1e28);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}

.cds--menu-item-divider {
  display: block;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 0.0625rem;
  inline-size: 100%;
  margin-block: 0.25rem;
}

.cds--combo-button__container {
  display: inline-flex;
  column-gap: 0.0625rem;
}

.cds--combo-button__container--sm .cds--combo-button__primary-action {
  min-inline-size: 7.9375rem;
}

.cds--combo-button__container--md .cds--combo-button__primary-action {
  min-inline-size: 7.4375rem;
}

.cds--combo-button__container--lg .cds--combo-button__primary-action {
  min-inline-size: 6.9375rem;
}

.cds--combo-button__primary-action .cds--btn {
  inline-size: 100%;
  max-inline-size: 14.9375rem;
  min-inline-size: 6.9375rem;
}

.cds--combo-button__primary-action button {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cds--combo-button__trigger svg {
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--combo-button__container--open .cds--combo-button__trigger svg {
  transform: rotate(180deg);
}

.cds--combo-button__top {
  transform: translate(0, calc(-100% - 3rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 3rem)));
}

.cds--combo-button__top-start {
  transform: translate(0, calc(-100% - 3rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 3rem)));
}

.cds--combo-button__top-end {
  transform: translate(0, calc(-100% - 3rem));
  transform: translate(0, calc(-100% - var(--cds-popover-offset, 3rem)));
}

.cds--menu-button__container {
  display: contents;
}

.cds--menu-button__trigger:not(.cds--btn--ghost) {
  min-inline-size: 12rem;
}

.cds--menu-button__trigger svg {
  transition: transform 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--menu-button__trigger--open svg {
  transform: rotate(180deg);
}

.cds--content {
  padding: 2rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  will-change: margin-left;
}

.cds--header ~ .cds--content,
div:has(.cds--header) ~ .cds--content {
  -webkit-margin-before: 3rem;
          margin-block-start: 3rem;
}

.cds--side-nav ~ .cds--content {
  -webkit-margin-start: 3rem;
          margin-inline-start: 3rem;
}

.cds--side-nav.cds--side-nav--expanded ~ .cds--content {
  -webkit-margin-start: 16rem;
          margin-inline-start: 16rem;
}

.cds--header {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header *,
.cds--header *::before,
.cds--header *::after {
  box-sizing: inherit;
}
.cds--header {
  position: fixed;
  z-index: 8000;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 3rem;
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle);
          border-block-end: 1px solid var(--cds-border-subtle);
  inset-block-start: 0;
  inset-inline: 0;
}

.cds--header__action {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header__action *,
.cds--header__action *::before,
.cds--header__action *::after {
  box-sizing: inherit;
}
.cds--header__action::-moz-focus-inner {
  border: 0;
}
.cds--header__action {
  display: inline-flex;
  border: 0.0625rem solid transparent;
  block-size: 3rem;
  inline-size: 3rem;
  transition: background-color 110ms, border-color 110ms;
}
@media (max-width: 41.98rem) {
  .cds--header__action {
    min-inline-size: 3rem;
  }
}

.cds--header__global .cds--popover {
  z-index: 8001;
}

.cds--header__action > :first-child {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--header__action > svg.cds--navigation-menu-panel-collapse-icon,
.cds--header__action--active > svg.cds--navigation-menu-panel-expand-icon {
  display: none;
}

.cds--header__action--active > svg.cds--navigation-menu-panel-collapse-icon {
  display: inline;
}

.cds--header__action:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.cds--header__action--active {
  background: #f4f4f4;
  background: var(--cds-layer);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--header__action--active > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__action:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}

.cds--header__action:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}

.cds--header__action.cds--btn--icon-only {
  align-items: center;
  justify-content: center;
}

.cds--btn.cds--btn--icon-only.cds--header__action svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--btn.cds--btn--icon-only.cds--header__action:hover svg,
.cds--btn.cds--btn--icon-only.cds--header__action:active svg,
.cds--btn.cds--btn--icon-only.cds--header__action--active svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-trigger > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-trigger:hover > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 66rem) {
  .cds--header__menu-toggle__hidden {
    display: none;
  }
}

a.cds--header__name {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  padding: 0 2rem 0 1rem;
  border: 0.125rem solid transparent;
  block-size: 100%;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 1.25rem;
  outline: none;
  text-decoration: none;
  transition: border-color 110ms;
  -webkit-user-select: none;
          user-select: none;
}
@media (max-width: 41.98rem) {
  a.cds--header__name {
    padding: 0 1rem;
  }
}

a.cds--header__name:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
}

.cds--header__name--prefix {
  font-weight: 400;
}

a.cds--header__name,
a.cds--header__name:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-toggle:not(.cds--header__menu-toggle__hidden) ~ .cds--header__name {
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}

.cds--header__nav {
  position: relative;
  display: none;
  block-size: 100%;
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}
@media (min-width: 66rem) {
  .cds--header__nav {
    display: block;
  }
}
.cds--header__nav::before {
  position: absolute;
  display: block;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1.5rem;
  content: "";
  inline-size: 0.0625rem;
  inset-block-start: 50%;
  inset-inline-start: 0;
  transform: translateY(-50%);
}

.cds--header__menu-bar {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header__menu-bar *,
.cds--header__menu-bar *::before,
.cds--header__menu-bar *::after {
  box-sizing: inherit;
}
.cds--header__menu-bar {
  display: flex;
  padding: 0;
  margin: 0;
  block-size: 100%;
  list-style: none;
}

a.cds--header__menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border: 2px solid transparent;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 100%;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.125rem;
  text-decoration: none;
  transition: background-color 110ms, border-color 110ms, color 110ms;
  -webkit-user-select: none;
          user-select: none;
}

a.cds--header__menu-item:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__action:active,
a.cds--header__menu-item:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--header__menu-item:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}

a.cds--header__menu-item:hover > svg,
a.cds--header__menu-item:active > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

a.cds--header__menu-item[aria-current=page],
.cds--header__menu-item--current {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--header__menu-item[aria-current=page]::after,
.cds--header__menu-item--current::after {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: 3px;
  content: "";
  inline-size: calc(100% + 4px);
  inset-block-end: -2px;
  inset-inline-start: -2px;
}

a.cds--header__menu-item[aria-current=page]:focus::after,
.cds--header__menu-item--current:focus::after {
  border: 0;
}

.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]::after,
.cds--header__submenu .cds--header__menu .cds--header__menu-item--current::after {
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: calc(100% + 4px);
  inline-size: 3px;
  inset-block-start: -2px;
  inset-inline-start: -2px;
}
.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]:focus::after,
.cds--header__submenu .cds--header__menu .cds--header__menu-item--current:focus::after {
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: calc(100% + 4px);
  inline-size: 5px;
  inset-block-start: -2px;
  inset-inline-start: -2px;
}

a.cds--header__menu-item[aria-current=page]:focus,
a.cds--header__menu-item.cds--header__menu-item--current:focus {
  border: 2px solid var(--color-primary);
  border: 2px solid var(--cds-focus, #0f62fe);
}

.cds--header__submenu {
  position: relative;
}

.cds--header__menu-title[aria-haspopup=true] {
  position: relative;
}

.cds--header__menu-title[aria-expanded=true] {
  z-index: 8002;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--header__menu-title[aria-expanded=true] > .cds--header__menu-arrow {
  transform: rotate(180deg);
}

.cds--header__menu {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  position: absolute;
  z-index: 8001;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);
  inline-size: 12.5rem;
  inset-block-end: 0;
  inset-inline-start: 0;
  transform: translateY(100%);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item.cds--header__menu-item--current {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}
.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item.cds--header__menu-item--current:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--header__menu .cds--header__menu-item {
  block-size: 3rem;
}

.cds--header__menu-arrow {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  transition: transform 110ms, fill 110ms;
}

.cds--header__global {
  display: flex;
  flex: 1 1;
  justify-content: flex-end;
  block-size: 100%;
}

.cds--skip-to-content {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--skip-to-content:focus {
  z-index: 9999;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border: 4px solid var(--color-primary);
  border: 4px solid var(--cds-focus, #0f62fe);
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 3rem;
  clip: auto;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: auto;
  inset-block-start: 0;
  inset-inline-start: 0;
  outline: none;
}

.cds--header-panel {
  position: fixed;
  z-index: 8000;
  overflow: hidden;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: 0;
  inset-block: 3rem 0;
  inset-inline-end: 0;
  transition: width 110ms cubic-bezier(0.2, 0, 1, 0.9);
  will-change: width;
}

.cds--header-panel--expanded {
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
  inline-size: 16rem;
  overflow-y: auto;
}

.cds--side-nav {
  position: fixed;
  z-index: 8000;
  overflow: hidden;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: 3rem;
  inset-block: 0;
  inset-inline-start: 0;
  max-inline-size: 16rem;
  transition: inline-size 0.11s cubic-bezier(0.2, 0, 1, 0.9), transform 0.11s cubic-bezier(0.2, 0, 1, 0.9);
  will-change: inline-size;
}

.cds--side-nav--ux {
  inline-size: 16rem;
  inset-block-start: 3rem;
}
@media (max-width: 65.98rem) {
  .cds--side-nav--ux {
    inline-size: 0;
  }
}

.cds--side-nav--rail {
  inline-size: 3rem;
}

.cds--side-nav--hidden {
  inline-size: 0;
}

.cds--side-nav--expanded {
  inline-size: 16rem;
}

.cds--side-nav__overlay {
  position: fixed;
  background-color: transparent;
  block-size: 0;
  inline-size: 0;
  inset-block-start: 3rem;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 300ms cubic-bezier(0.5, 0, 0.1, 1);
}

@media (max-width: 65.98rem) {
  .cds--side-nav__overlay-active {
    z-index: 6000;
    background-color: rgba(0, 0, 0, 0.6);
    background-color: var(--cds-overlay, rgba(0, 0, 0, 0.6));
    block-size: 100vh;
    inline-size: 100vw;
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 300ms cubic-bezier(0.5, 0, 0.1, 1);
  }
}

.cds--header ~ .cds--side-nav {
  block-size: calc(100% - 48px);
  inset-block-start: 3rem;
}

.cds--side-nav--fixed {
  inline-size: 16rem;
}

.cds--side-nav--collapsed {
  inline-size: 16rem;
  transform: translateX(-16rem);
}

.cds--side-nav__navigation {
  display: flex;
  flex-direction: column;
}

.cds--side-nav__items {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__items *,
.cds--side-nav__items *::before,
.cds--side-nav__items *::after {
  box-sizing: inherit;
}
.cds--side-nav__items {
  overflow: hidden;
  flex: 1 1;
  padding: 1rem 0 0;
}
.cds--side-nav:hover .cds--side-nav__items, .cds--side-nav--fixed .cds--side-nav__items, .cds--side-nav--expanded .cds--side-nav__items {
  overflow-y: auto;
}

.cds--side-nav--ux .cds--side-nav__items {
  overflow-y: auto;
}

.cds--side-nav__item {
  overflow: hidden;
  block-size: auto;
  inline-size: auto;
}

.cds--side-nav--ux .cds--side-nav__item {
  block-size: auto;
  inline-size: auto;
}

.cds--side-nav__item:not(.cds--side-nav__item--active):hover .cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__submenu:hover,
.cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__link:hover,
.cds--side-nav__menu a.cds--side-nav__link:not(.cds--side-nav__link--current):not([aria-current=page]):hover,
.cds--side-nav a.cds--header__menu-item:hover,
.cds--side-nav .cds--header__menu-title[aria-expanded=true]:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__link:hover > span,
.cds--side-nav__item:not(.cds--side-nav__item--active) .cds--side-nav__menu-item > .cds--side-nav__link:hover > span {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item--large {
  block-size: auto;
}

.cds--side-nav__divider {
  margin: 0.5rem 1rem;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1px;
  list-style-type: none;
}

.cds--side-nav__divider hr {
  border: none;
}

.cds--side-nav__submenu {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__submenu *,
.cds--side-nav__submenu *::before,
.cds--side-nav__submenu *::after {
  box-sizing: inherit;
}
.cds--side-nav__submenu::-moz-focus-inner {
  border: 0;
}
.cds--side-nav__submenu {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  block-size: 2rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  transition: color 110ms, background-color 110ms, outline 110ms;
  -webkit-user-select: none;
          user-select: none;
}

.cds--side-nav__submenu:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__submenu:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--side-nav__submenu:focus {
    outline-style: dotted;
  }
}

.cds--side-nav__submenu-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
}

.cds--side-nav__icon.cds--side-nav__submenu-chevron {
  display: flex;
  flex: 1 1;
  justify-content: flex-end;
}

.cds--side-nav__submenu-chevron > svg {
  block-size: 1rem;
  inline-size: 1rem;
  transition: transform 110ms;
}

.cds--side-nav__submenu[aria-expanded=true] .cds--side-nav__submenu-chevron > svg {
  transform: rotate(180deg);
}

.cds--side-nav__item--large .cds--side-nav__submenu {
  block-size: 3rem;
}

.cds--side-nav__item--active .cds--side-nav__submenu:hover {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false] {
  position: relative;
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false]::before {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  content: "";
  inline-size: 3px;
  inset-block: 0;
  inset-inline-start: 0;
}

.cds--side-nav__item--active .cds--side-nav__submenu-title {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
}

.cds--side-nav__item--active .cds--side-nav__icon > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--side-nav__menu {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__menu *,
.cds--side-nav__menu *::before,
.cds--side-nav__menu *::after {
  box-sizing: inherit;
}
.cds--side-nav__menu {
  display: block;
  max-block-size: 0;
  visibility: hidden;
}

.cds--side-nav__submenu[aria-expanded=true] + .cds--side-nav__menu {
  max-block-size: 93.75rem;
  visibility: inherit;
}

.cds--side-nav__menu a.cds--side-nav__link {
  block-size: 2rem;
  font-weight: 400;
  min-block-size: 2rem;
  -webkit-padding-start: 2rem;
          padding-inline-start: 2rem;
}

.cds--side-nav__item.cds--side-nav__item--icon a.cds--side-nav__link {
  -webkit-padding-start: 4.5rem;
          padding-inline-start: 4.5rem;
}

.cds--side-nav__menu a.cds--side-nav__link--current,
.cds--side-nav__menu a.cds--side-nav__link[aria-current=page],
a.cds--side-nav__link--current {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}
.cds--side-nav__menu a.cds--side-nav__link--current > span,
.cds--side-nav__menu a.cds--side-nav__link[aria-current=page] > span,
a.cds--side-nav__link--current > span {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
}

a.cds--side-nav__link,
.cds--side-nav a.cds--header__menu-item,
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  outline: 2px solid transparent;
  outline-offset: -2px;
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  min-block-size: 2rem;
  text-decoration: none;
  transition: color 110ms, background-color 110ms, outline 110ms;
}

.cds--side-nav__item--large a.cds--side-nav__link {
  block-size: 3rem;
}

a.cds--side-nav__link > .cds--side-nav__link-text,
.cds--side-nav a.cds--header__menu-item .cds--text-truncate-end {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.25rem;
  -webkit-user-select: none;
          user-select: none;
}

a.cds--side-nav__link:focus,
.cds--side-nav a.cds--header__menu-item:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  a.cds--side-nav__link:focus,
  .cds--side-nav a.cds--header__menu-item:focus {
    outline-style: dotted;
  }
}

a.cds--side-nav__link[aria-current=page],
a.cds--side-nav__link--current {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  font-weight: 600;
}

a.cds--side-nav__link[aria-current=page] .cds--side-nav__link-text,
a.cds--side-nav__link--current .cds--side-nav__link-text {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--side-nav__link[aria-current=page]::before,
a.cds--side-nav__link--current::before {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  content: "";
  inline-size: 3px;
  inset-block: 0;
  inset-inline-start: 0;
}

.cds--side-nav__icon {
  display: flex;
  flex: 0 0 1rem;
  align-items: center;
  justify-content: center;
}

.cds--side-nav__icon:not(.cds--side-nav__submenu-chevron) {
  -webkit-margin-end: 1.5rem;
          margin-inline-end: 1.5rem;
}

.cds--side-nav__icon > svg {
  block-size: 1rem;
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
  inline-size: 1rem;
}

.cds--side-nav__icon > svg.cds--side-nav-collapse-icon {
  display: none;
}

.cds--side-nav--expanded .cds--side-nav__icon > svg.cds--side-nav-expand-icon {
  display: none;
}

.cds--side-nav--expanded .cds--side-nav__icon > svg.cds--side-nav-collapse-icon {
  display: block;
}

.cds--side-nav--fixed a.cds--side-nav__link,
.cds--side-nav--fixed .cds--side-nav__submenu {
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}

.cds--side-nav--fixed .cds--side-nav__item:not(.cds--side-nav__item--icon) .cds--side-nav__menu a.cds--side-nav__link {
  -webkit-padding-start: 2rem;
          padding-inline-start: 2rem;
}

@media (max-width: 65.98rem) {
  .cds--side-nav .cds--header__nav {
    display: block;
  }
}

.cds--side-nav__header-navigation {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__header-navigation *,
.cds--side-nav__header-navigation *::before,
.cds--side-nav__header-navigation *::after {
  box-sizing: inherit;
}
.cds--side-nav__header-navigation {
  display: none;
}
@media (max-width: 65.98rem) {
  .cds--side-nav__header-navigation {
    position: relative;
    display: block;
    -webkit-margin-after: 2rem;
            margin-block-end: 2rem;
  }
}

.cds--side-nav__header-divider::after {
  position: absolute;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 0.0625rem;
  content: "";
  inline-size: calc(100% - 32px);
  inset-block-end: -1rem;
  inset-inline-start: 1rem;
}

.cds--side-nav a.cds--header__menu-item {
  justify-content: space-between;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  white-space: nowrap;
}
.cds--side-nav a.cds--header__menu-item[aria-expanded=true] {
  background-color: transparent;
}

.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  inline-size: 100%;
  inset-block-end: inherit;
  transform: none;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu li {
  inline-size: 100%;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item {
  font-weight: 400;
  -webkit-padding-start: 4.25rem;
          padding-inline-start: 4.25rem;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item--current:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--side-nav .cds--side-nav__header-navigation a.cds--header__menu-item[aria-current=page]::after,
.cds--side-nav .cds--side-nav__header-navigation .cds--header__menu-item--current::after {
  block-size: calc(100% + 4px);
  inline-size: 3px;
}

.cds--side-nav .cds--header__menu a.cds--header__menu-item {
  block-size: inherit;
}

.cds--side-nav a.cds--header__menu-item:hover .cds--header__menu-arrow,
.cds--side-nav a.cds--header__menu-item:focus .cds--header__menu-arrow,
.cds--side-nav .cds--header__menu-arrow {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--switcher {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--switcher *,
.cds--switcher *::before,
.cds--switcher *::after {
  box-sizing: inherit;
}
.cds--switcher {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--switcher__item {
  block-size: 2rem;
  inline-size: 100%;
}

.cds--switcher__item:nth-child(1) {
  -webkit-margin-before: 1rem;
          margin-block-start: 1rem;
}

.cds--switcher__item--divider {
  display: block;
  border: none;
  margin: 0.5rem 1rem;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 1px;
  inline-size: 14rem;
}

.cds--switcher__item-link {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  display: block;
  padding: 0.375rem 1rem;
  block-size: 2rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  text-decoration: none;
}
.cds--switcher__item-link:hover:not(.cds--switcher__item-link--selected) {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
}
.cds--switcher__item-link:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
.cds--switcher__item-link:active {
  background: #c6c6c6;
  background: var(--cds-layer-active);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--switcher__item-link--selected {
  background: #e0e0e0;
  background: var(--cds-layer-selected);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--content {
  padding: 2rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  will-change: margin-left;
}

.cds--header ~ .cds--content,
div:has(.cds--header) ~ .cds--content {
  -webkit-margin-before: 3rem;
          margin-block-start: 3rem;
}

.cds--side-nav ~ .cds--content {
  -webkit-margin-start: 3rem;
          margin-inline-start: 3rem;
}

.cds--side-nav.cds--side-nav--expanded ~ .cds--content {
  -webkit-margin-start: 16rem;
          margin-inline-start: 16rem;
}

.cds--header {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header *,
.cds--header *::before,
.cds--header *::after {
  box-sizing: inherit;
}
.cds--header {
  position: fixed;
  z-index: 8000;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 3rem;
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle);
          border-block-end: 1px solid var(--cds-border-subtle);
  inset-block-start: 0;
  inset-inline: 0;
}

.cds--header__action {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header__action *,
.cds--header__action *::before,
.cds--header__action *::after {
  box-sizing: inherit;
}
.cds--header__action::-moz-focus-inner {
  border: 0;
}
.cds--header__action {
  display: inline-flex;
  border: 0.0625rem solid transparent;
  block-size: 3rem;
  inline-size: 3rem;
  transition: background-color 110ms, border-color 110ms;
}
@media (max-width: 41.98rem) {
  .cds--header__action {
    min-inline-size: 3rem;
  }
}

.cds--header__global .cds--popover {
  z-index: 8001;
}

.cds--header__action > :first-child {
  -webkit-margin-before: 0;
          margin-block-start: 0;
}

.cds--header__action > svg.cds--navigation-menu-panel-collapse-icon,
.cds--header__action--active > svg.cds--navigation-menu-panel-expand-icon {
  display: none;
}

.cds--header__action--active > svg.cds--navigation-menu-panel-collapse-icon {
  display: inline;
}

.cds--header__action:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.cds--header__action--active {
  background: #f4f4f4;
  background: var(--cds-layer);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
}

.cds--header__action--active > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__action:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}

.cds--header__action:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}

.cds--header__action.cds--btn--icon-only {
  align-items: center;
  justify-content: center;
}

.cds--btn.cds--btn--icon-only.cds--header__action svg {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--btn.cds--btn--icon-only.cds--header__action:hover svg,
.cds--btn.cds--btn--icon-only.cds--header__action:active svg,
.cds--btn.cds--btn--icon-only.cds--header__action--active svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-trigger > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-trigger:hover > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--header__menu-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (min-width: 66rem) {
  .cds--header__menu-toggle__hidden {
    display: none;
  }
}

a.cds--header__name {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  padding: 0 2rem 0 1rem;
  border: 0.125rem solid transparent;
  block-size: 100%;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 1.25rem;
  outline: none;
  text-decoration: none;
  transition: border-color 110ms;
  -webkit-user-select: none;
          user-select: none;
}
@media (max-width: 41.98rem) {
  a.cds--header__name {
    padding: 0 1rem;
  }
}

a.cds--header__name:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
}

.cds--header__name--prefix {
  font-weight: 400;
}

a.cds--header__name,
a.cds--header__name:hover {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-toggle:not(.cds--header__menu-toggle__hidden) ~ .cds--header__name {
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}

.cds--header__nav {
  position: relative;
  display: none;
  block-size: 100%;
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}
@media (min-width: 66rem) {
  .cds--header__nav {
    display: block;
  }
}
.cds--header__nav::before {
  position: absolute;
  display: block;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1.5rem;
  content: "";
  inline-size: 0.0625rem;
  inset-block-start: 50%;
  inset-inline-start: 0;
  transform: translateY(-50%);
}

.cds--header__menu-bar {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--header__menu-bar *,
.cds--header__menu-bar *::before,
.cds--header__menu-bar *::after {
  box-sizing: inherit;
}
.cds--header__menu-bar {
  display: flex;
  padding: 0;
  margin: 0;
  block-size: 100%;
  list-style: none;
}

a.cds--header__menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border: 2px solid transparent;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 100%;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0;
  line-height: 1.125rem;
  text-decoration: none;
  transition: background-color 110ms, border-color 110ms, color 110ms;
  -webkit-user-select: none;
          user-select: none;
}

a.cds--header__menu-item:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__action:active,
a.cds--header__menu-item:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--header__menu-item:focus {
  border-color: var(--color-primary);
  border-color: var(--cds-focus, #0f62fe);
  outline: none;
}

a.cds--header__menu-item:hover > svg,
a.cds--header__menu-item:active > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

a.cds--header__menu-item[aria-current=page],
.cds--header__menu-item--current {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--header__menu-item[aria-current=page]::after,
.cds--header__menu-item--current::after {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: 3px;
  content: "";
  inline-size: calc(100% + 4px);
  inset-block-end: -2px;
  inset-inline-start: -2px;
}

a.cds--header__menu-item[aria-current=page]:focus::after,
.cds--header__menu-item--current:focus::after {
  border: 0;
}

.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]::after,
.cds--header__submenu .cds--header__menu .cds--header__menu-item--current::after {
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: calc(100% + 4px);
  inline-size: 3px;
  inset-block-start: -2px;
  inset-inline-start: -2px;
}
.cds--header__submenu .cds--header__menu a.cds--header__menu-item[aria-current=page]:focus::after,
.cds--header__submenu .cds--header__menu .cds--header__menu-item--current:focus::after {
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  block-size: calc(100% + 4px);
  inline-size: 5px;
  inset-block-start: -2px;
  inset-inline-start: -2px;
}

a.cds--header__menu-item[aria-current=page]:focus,
a.cds--header__menu-item.cds--header__menu-item--current:focus {
  border: 2px solid var(--color-primary);
  border: 2px solid var(--cds-focus, #0f62fe);
}

.cds--header__submenu {
  position: relative;
}

.cds--header__menu-title[aria-haspopup=true] {
  position: relative;
}

.cds--header__menu-title[aria-expanded=true] {
  z-index: 8002;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--header__menu-title[aria-expanded=true] > .cds--header__menu-arrow {
  transform: rotate(180deg);
}

.cds--header__menu {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  position: absolute;
  z-index: 8001;
  display: flex;
  flex-direction: column;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5);
  inline-size: 12.5rem;
  inset-block-end: 0;
  inset-inline-start: 0;
  transform: translateY(100%);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item:active {
  background-color: #c6c6c6;
  background-color: var(--cds-layer-active);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item.cds--header__menu-item--current {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}
.cds--header__menu-title[aria-expanded=true] + .cds--header__menu .cds--header__menu-item.cds--header__menu-item--current:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--header__menu .cds--header__menu-item {
  block-size: 3rem;
}

.cds--header__menu-arrow {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
  -webkit-margin-start: 0.5rem;
          margin-inline-start: 0.5rem;
  transition: transform 110ms, fill 110ms;
}

.cds--header__global {
  display: flex;
  flex: 1 1;
  justify-content: flex-end;
  block-size: 100%;
}

.cds--skip-to-content {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
}

.cds--skip-to-content:focus {
  z-index: 9999;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  border: 4px solid var(--color-primary);
  border: 4px solid var(--cds-focus, #0f62fe);
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  block-size: 3rem;
  clip: auto;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: auto;
  inset-block-start: 0;
  inset-inline-start: 0;
  outline: none;
}

.cds--header-panel {
  position: fixed;
  z-index: 8000;
  overflow: hidden;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: 0;
  inset-block: 3rem 0;
  inset-inline-end: 0;
  transition: width 110ms cubic-bezier(0.2, 0, 1, 0.9);
  will-change: width;
}

.cds--header-panel--expanded {
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
  -webkit-border-start: 1px solid #e0e0e0;
          border-inline-start: 1px solid #e0e0e0;
  -webkit-border-start: 1px solid var(--cds-border-subtle);
          border-inline-start: 1px solid var(--cds-border-subtle);
  inline-size: 16rem;
  overflow-y: auto;
}

.cds--side-nav {
  position: fixed;
  z-index: 8000;
  overflow: hidden;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  inline-size: 3rem;
  inset-block: 0;
  inset-inline-start: 0;
  max-inline-size: 16rem;
  transition: inline-size 0.11s cubic-bezier(0.2, 0, 1, 0.9), transform 0.11s cubic-bezier(0.2, 0, 1, 0.9);
  will-change: inline-size;
}

.cds--side-nav--ux {
  inline-size: 16rem;
  inset-block-start: 3rem;
}
@media (max-width: 65.98rem) {
  .cds--side-nav--ux {
    inline-size: 0;
  }
}

.cds--side-nav--rail {
  inline-size: 3rem;
}

.cds--side-nav--hidden {
  inline-size: 0;
}

.cds--side-nav--expanded {
  inline-size: 16rem;
}

.cds--side-nav__overlay {
  position: fixed;
  background-color: transparent;
  block-size: 0;
  inline-size: 0;
  inset-block-start: 3rem;
  inset-inline-start: 0;
  opacity: 0;
  transition: opacity 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 300ms cubic-bezier(0.5, 0, 0.1, 1);
}

@media (max-width: 65.98rem) {
  .cds--side-nav__overlay-active {
    z-index: 6000;
    background-color: rgba(0, 0, 0, 0.6);
    background-color: var(--cds-overlay, rgba(0, 0, 0, 0.6));
    block-size: 100vh;
    inline-size: 100vw;
    opacity: 1;
    transition: opacity 300ms cubic-bezier(0.5, 0, 0.1, 1), background-color 300ms cubic-bezier(0.5, 0, 0.1, 1);
  }
}

.cds--header ~ .cds--side-nav {
  block-size: calc(100% - 48px);
  inset-block-start: 3rem;
}

.cds--side-nav--fixed {
  inline-size: 16rem;
}

.cds--side-nav--collapsed {
  inline-size: 16rem;
  transform: translateX(-16rem);
}

.cds--side-nav__navigation {
  display: flex;
  flex-direction: column;
}

.cds--side-nav__items {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__items *,
.cds--side-nav__items *::before,
.cds--side-nav__items *::after {
  box-sizing: inherit;
}
.cds--side-nav__items {
  overflow: hidden;
  flex: 1 1;
  padding: 1rem 0 0;
}
.cds--side-nav:hover .cds--side-nav__items, .cds--side-nav--fixed .cds--side-nav__items, .cds--side-nav--expanded .cds--side-nav__items {
  overflow-y: auto;
}

.cds--side-nav--ux .cds--side-nav__items {
  overflow-y: auto;
}

.cds--side-nav__item {
  overflow: hidden;
  block-size: auto;
  inline-size: auto;
}

.cds--side-nav--ux .cds--side-nav__item {
  block-size: auto;
  inline-size: auto;
}

.cds--side-nav__item:not(.cds--side-nav__item--active):hover .cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__submenu:hover,
.cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__link:hover,
.cds--side-nav__menu a.cds--side-nav__link:not(.cds--side-nav__link--current):not([aria-current=page]):hover,
.cds--side-nav a.cds--header__menu-item:hover,
.cds--side-nav .cds--header__menu-title[aria-expanded=true]:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item:not(.cds--side-nav__item--active) > .cds--side-nav__link:hover > span,
.cds--side-nav__item:not(.cds--side-nav__item--active) .cds--side-nav__menu-item > .cds--side-nav__link:hover > span {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item--large {
  block-size: auto;
}

.cds--side-nav__divider {
  margin: 0.5rem 1rem;
  background-color: #e0e0e0;
  background-color: var(--cds-border-subtle);
  block-size: 1px;
  list-style-type: none;
}

.cds--side-nav__divider hr {
  border: none;
}

.cds--side-nav__submenu {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__submenu *,
.cds--side-nav__submenu *::before,
.cds--side-nav__submenu *::after {
  box-sizing: inherit;
}
.cds--side-nav__submenu::-moz-focus-inner {
  border: 0;
}
.cds--side-nav__submenu {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  block-size: 2rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  transition: color 110ms, background-color 110ms, outline 110ms;
  -webkit-user-select: none;
          user-select: none;
}

.cds--side-nav__submenu:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__submenu:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--side-nav__submenu:focus {
    outline-style: dotted;
  }
}

.cds--side-nav__submenu-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: start;
}

.cds--side-nav__icon.cds--side-nav__submenu-chevron {
  display: flex;
  flex: 1 1;
  justify-content: flex-end;
}

.cds--side-nav__submenu-chevron > svg {
  block-size: 1rem;
  inline-size: 1rem;
  transition: transform 110ms;
}

.cds--side-nav__submenu[aria-expanded=true] .cds--side-nav__submenu-chevron > svg {
  transform: rotate(180deg);
}

.cds--side-nav__item--large .cds--side-nav__submenu {
  block-size: 3rem;
}

.cds--side-nav__item--active .cds--side-nav__submenu:hover {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false] {
  position: relative;
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--side-nav__item--active .cds--side-nav__submenu[aria-expanded=false]::before {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  content: "";
  inline-size: 3px;
  inset-block: 0;
  inset-inline-start: 0;
}

.cds--side-nav__item--active .cds--side-nav__submenu-title {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
}

.cds--side-nav__item--active .cds--side-nav__icon > svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--side-nav__menu {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__menu *,
.cds--side-nav__menu *::before,
.cds--side-nav__menu *::after {
  box-sizing: inherit;
}
.cds--side-nav__menu {
  display: block;
  max-block-size: 0;
  visibility: hidden;
}

.cds--side-nav__submenu[aria-expanded=true] + .cds--side-nav__menu {
  max-block-size: 93.75rem;
  visibility: inherit;
}

.cds--side-nav__menu a.cds--side-nav__link {
  block-size: 2rem;
  font-weight: 400;
  min-block-size: 2rem;
  -webkit-padding-start: 2rem;
          padding-inline-start: 2rem;
}

.cds--side-nav__item.cds--side-nav__item--icon a.cds--side-nav__link {
  -webkit-padding-start: 4.5rem;
          padding-inline-start: 4.5rem;
}

.cds--side-nav__menu a.cds--side-nav__link--current,
.cds--side-nav__menu a.cds--side-nav__link[aria-current=page],
a.cds--side-nav__link--current {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
}
.cds--side-nav__menu a.cds--side-nav__link--current > span,
.cds--side-nav__menu a.cds--side-nav__link[aria-current=page] > span,
a.cds--side-nav__link--current > span {
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
}

a.cds--side-nav__link,
.cds--side-nav a.cds--header__menu-item,
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  outline: 2px solid transparent;
  outline-offset: -2px;
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 1rem;
  min-block-size: 2rem;
  text-decoration: none;
  transition: color 110ms, background-color 110ms, outline 110ms;
}

.cds--side-nav__item--large a.cds--side-nav__link {
  block-size: 3rem;
}

a.cds--side-nav__link > .cds--side-nav__link-text,
.cds--side-nav a.cds--header__menu-item .cds--text-truncate-end {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  font-size: 0.875rem;
  letter-spacing: 0.1px;
  line-height: 1.25rem;
  -webkit-user-select: none;
          user-select: none;
}

a.cds--side-nav__link:focus,
.cds--side-nav a.cds--header__menu-item:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  a.cds--side-nav__link:focus,
  .cds--side-nav a.cds--header__menu-item:focus {
    outline-style: dotted;
  }
}

a.cds--side-nav__link[aria-current=page],
a.cds--side-nav__link--current {
  background-color: rgba(141, 141, 141, 0.2);
  background-color: var(--cds-background-selected, rgba(141, 141, 141, 0.2));
  font-weight: 600;
}

a.cds--side-nav__link[aria-current=page] .cds--side-nav__link-text,
a.cds--side-nav__link--current .cds--side-nav__link-text {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

a.cds--side-nav__link[aria-current=page]::before,
a.cds--side-nav__link--current::before {
  position: absolute;
  background-color: var(--color-primary);
  background-color: var(--cds-border-interactive, #0f62fe);
  content: "";
  inline-size: 3px;
  inset-block: 0;
  inset-inline-start: 0;
}

.cds--side-nav__icon {
  display: flex;
  flex: 0 0 1rem;
  align-items: center;
  justify-content: center;
}

.cds--side-nav__icon:not(.cds--side-nav__submenu-chevron) {
  -webkit-margin-end: 1.5rem;
          margin-inline-end: 1.5rem;
}

.cds--side-nav__icon > svg {
  block-size: 1rem;
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
  inline-size: 1rem;
}

.cds--side-nav__icon > svg.cds--side-nav-collapse-icon {
  display: none;
}

.cds--side-nav--expanded .cds--side-nav__icon > svg.cds--side-nav-expand-icon {
  display: none;
}

.cds--side-nav--expanded .cds--side-nav__icon > svg.cds--side-nav-collapse-icon {
  display: block;
}

.cds--side-nav--fixed a.cds--side-nav__link,
.cds--side-nav--fixed .cds--side-nav__submenu {
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}

.cds--side-nav--fixed .cds--side-nav__item:not(.cds--side-nav__item--icon) .cds--side-nav__menu a.cds--side-nav__link {
  -webkit-padding-start: 2rem;
          padding-inline-start: 2rem;
}

@media (max-width: 65.98rem) {
  .cds--side-nav .cds--header__nav {
    display: block;
  }
}

.cds--side-nav__header-navigation {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--side-nav__header-navigation *,
.cds--side-nav__header-navigation *::before,
.cds--side-nav__header-navigation *::after {
  box-sizing: inherit;
}
.cds--side-nav__header-navigation {
  display: none;
}
@media (max-width: 65.98rem) {
  .cds--side-nav__header-navigation {
    position: relative;
    display: block;
    -webkit-margin-after: 2rem;
            margin-block-end: 2rem;
  }
}

.cds--side-nav__header-divider::after {
  position: absolute;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 0.0625rem;
  content: "";
  inline-size: calc(100% - 32px);
  inset-block-end: -1rem;
  inset-inline-start: 1rem;
}

.cds--side-nav a.cds--header__menu-item {
  justify-content: space-between;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  white-space: nowrap;
}
.cds--side-nav a.cds--header__menu-item[aria-expanded=true] {
  background-color: transparent;
}

.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu {
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  inline-size: 100%;
  inset-block-end: inherit;
  transform: none;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu li {
  inline-size: 100%;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item {
  font-weight: 400;
  -webkit-padding-start: 4.25rem;
          padding-inline-start: 4.25rem;
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--side-nav .cds--header__menu-title[aria-expanded=true] + .cds--header__menu a.cds--header__menu-item--current:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover);
}

.cds--side-nav .cds--side-nav__header-navigation a.cds--header__menu-item[aria-current=page]::after,
.cds--side-nav .cds--side-nav__header-navigation .cds--header__menu-item--current::after {
  block-size: calc(100% + 4px);
  inline-size: 3px;
}

.cds--side-nav .cds--header__menu a.cds--header__menu-item {
  block-size: inherit;
}

.cds--side-nav a.cds--header__menu-item:hover .cds--header__menu-arrow,
.cds--side-nav a.cds--header__menu-item:focus .cds--header__menu-arrow,
.cds--side-nav .cds--header__menu-arrow {
  fill: #525252;
  fill: var(--cds-icon-secondary, #525252);
}

.cds--switcher {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--switcher *,
.cds--switcher *::before,
.cds--switcher *::after {
  box-sizing: inherit;
}
.cds--switcher {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
}

.cds--switcher__item {
  block-size: 2rem;
  inline-size: 100%;
}

.cds--switcher__item:nth-child(1) {
  -webkit-margin-before: 1rem;
          margin-block-start: 1rem;
}

.cds--switcher__item--divider {
  display: block;
  border: none;
  margin: 0.5rem 1rem;
  background: #e0e0e0;
  background: var(--cds-border-subtle);
  block-size: 1px;
  inline-size: 14rem;
}

.cds--switcher__item-link {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  display: block;
  padding: 0.375rem 1rem;
  block-size: 2rem;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  text-decoration: none;
}
.cds--switcher__item-link:hover:not(.cds--switcher__item-link--selected) {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
}
.cds--switcher__item-link:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
.cds--switcher__item-link:active {
  background: #c6c6c6;
  background: var(--cds-layer-active);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--switcher__item-link--selected {
  background: #e0e0e0;
  background: var(--cds-layer-selected);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

@keyframes fp-fade-in-down {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fp-slide-left {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes fp-slide-left-new {
  from {
    transform: translate3d(100%, 0, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fp-slide-right {
  from {
    transform: translate3d(0, 0, 0);
  }
  to {
    transform: translate3d(100%, 0, 0);
  }
}
@keyframes fp-slide-right-new {
  from {
    transform: translate3d(-100%, 0, 0);
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fp-fade-out {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
@keyframes fp-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.flatpickr-calendar {
  position: absolute;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  border-radius: 0;
  animation: none;
  direction: ltr;
  inline-size: 19.6875rem;
  max-block-size: 0;
  opacity: 0;
  text-align: center;
  touch-action: manipulation;
  visibility: hidden;
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .flatpickr-calendar {
    outline: 1px solid transparent;
  }
}

.flatpickr-calendar.open,
.flatpickr-calendar.inline {
  overflow: visible;
  max-block-size: 40rem;
  opacity: 1;
  visibility: inherit;
}

.flatpickr-calendar.open {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  box-shadow: 0 2px 6px var(--cds-shadow, rgba(0, 0, 0, 0.3));
  z-index: 99999;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.25rem 0.25rem 0.5rem 0.25rem;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer-01, #f4f4f4);
  block-size: 21rem;
  inline-size: 18rem;
  -webkit-margin-before: -0.125rem;
          margin-block-start: -0.125rem;
}
.flatpickr-calendar.open:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .flatpickr-calendar.open:focus {
    outline-style: dotted;
  }
}

.flatpickr-calendar.animate.open {
  animation: fp-fade-in-down 110ms cubic-bezier(0, 0, 0.38, 0.9);
}
@media screen and (prefers-reduced-motion: reduce) {
  .flatpickr-calendar.animate.open {
    animation: none;
  }
}

.flatpickr-calendar.inline {
  position: absolute;
  display: block;
  inset-block-start: auto;
}

.flatpickr-calendar.static {
  position: absolute;
  inset-block-start: calc(100% + 2px);
}

.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}

.flatpickr-calendar.hasWeeks {
  inline-size: auto;
}

.dayContainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 0;
  block-size: 15.375rem;
  outline: 0;
}

.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  -webkit-border-after: 0;
          border-block-end: 0;
  border-end-end-radius: 0;
  border-end-start-radius: 0;
}

.flatpickr-calendar .hasWeeks .dayContainer {
  -webkit-border-start: 0;
          border-inline-start: 0;
}

.flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {
  block-size: 2.5rem;
  -webkit-border-before: 1px solid #e6e6e6;
          border-block-start: 1px solid #e6e6e6;
}

.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  block-size: auto;
}

.flatpickr-calendar:focus {
  outline: 0;
}

.flatpickr-months {
  display: flex;
  justify-content: space-between;
  inline-size: 100%;
}

.flatpickr-month {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  background-color: transparent;
  block-size: 2.5rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  line-height: 1;
  text-align: center;
}

.flatpickr-prev-month,
.flatpickr-next-month {
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  block-size: 2.5rem;
  cursor: pointer;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inline-size: 2.5rem;
  line-height: 16px;
  text-decoration: none;
  transform: scale(1, 1) /*rtl: scale(-1,1)*/;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  -webkit-user-select: none;
          user-select: none;
}
@media screen and (prefers-reduced-motion: reduce) {
  .flatpickr-prev-month,
  .flatpickr-next-month {
    transition: none;
  }
}
.flatpickr-prev-month:hover,
.flatpickr-next-month:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.flatpickr-next-month.disabled svg,
.flatpickr-prev-month.disabled svg {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.flatpickr-next-month.disabled:hover svg,
.flatpickr-prev-month.disabled:hover svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.flatpickr-current-month {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 1.75rem;
  text-align: center;
}

.flatpickr-current-month .cur-month {
  margin-inline: 0.25rem 0.25rem;
}
.flatpickr-current-month .cur-month:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}

.numInputWrapper {
  position: relative;
  inline-size: 3.75rem;
}
.numInputWrapper:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}

.numInputWrapper .numInput {
  display: inline-block;
  padding: 0.25rem;
  border: none;
  margin: 0;
  -moz-appearance: textfield; /* Firefox */
  background-color: #f4f4f4;
  background-color: var(--cds-field-01, #f4f4f4);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: default;
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  inline-size: 100%;
}
.numInputWrapper .numInput::-webkit-outer-spin-button, .numInputWrapper .numInput::-webkit-inner-spin-button {
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  -webkit-appearance: none;
}
.numInputWrapper .numInput:focus {
  outline: 1px solid var(--color-primary);
  outline: 1px solid var(--cds-focus, #0f62fe);
}
@media screen and (prefers-contrast) {
  .numInputWrapper .numInput:focus {
    outline-style: dotted;
  }
}
.numInputWrapper .numInput[disabled], .numInputWrapper .numInput[disabled]:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer-01, #f4f4f4);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  pointer-events: none;
}

.numInputWrapper .arrowUp {
  -webkit-border-after: 0;
          border-block-end: 0;
  inset-block-start: 0.25rem;
}
.numInputWrapper .arrowUp::after {
  -webkit-border-after: 0.25rem solid #161616;
          border-block-end: 0.25rem solid #161616;
  -webkit-border-after: 0.25rem solid var(--cds-icon-primary, #161616);
          border-block-end: 0.25rem solid var(--cds-icon-primary, #161616);
}

.numInputWrapper .arrowDown {
  inset-block-start: 0.6875rem;
}
.numInputWrapper .arrowDown::after {
  -webkit-border-before: 0.25rem solid #161616;
          border-block-start: 0.25rem solid #161616;
  -webkit-border-before: 0.25rem solid var(--cds-icon-primary, #161616);
          border-block-start: 0.25rem solid var(--cds-icon-primary, #161616);
}

.numInputWrapper .arrowUp,
.numInputWrapper .arrowDown {
  position: absolute;
  padding: 0 0.25rem 0 0.125rem;
  border: none;
  block-size: 50%;
  cursor: pointer;
  inline-size: 0.75rem;
  inset-inline-start: 2.6rem;
  line-height: 50%;
  opacity: 0;
}
.numInputWrapper .arrowUp::after,
.numInputWrapper .arrowDown::after {
  position: absolute;
  display: block;
  -webkit-border-end: 0.25rem solid transparent;
          border-inline-end: 0.25rem solid transparent;
  -webkit-border-start: 0.25rem solid transparent;
          border-inline-start: 0.25rem solid transparent;
  content: "";
  inset-block-start: 33%;
}
.numInputWrapper .arrowUp:hover::after,
.numInputWrapper .arrowDown:hover::after {
  border-block-end-color: var(--color-primary);
  border-block-end-color: var(--cds-button-primary, #0f62fe);
  border-block-start-color: var(--color-primary);
  border-block-start-color: var(--cds-button-primary, #0f62fe);
}
.numInputWrapper .arrowUp:active::after,
.numInputWrapper .arrowDown:active::after {
  border-block-end-color: var(--color-primary);
  border-block-end-color: var(--cds-border-interactive, #0f62fe);
  border-block-start-color: var(--color-primary);
  border-block-start-color: var(--cds-border-interactive, #0f62fe);
}

.numInput[disabled] ~ .arrowUp::after {
  border-block-end-color: rgba(22, 22, 22, 0.25);
  border-block-end-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.numInput[disabled] ~ .arrowDown::after {
  border-block-start-color: rgba(22, 22, 22, 0.25);
  border-block-start-color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}

.numInputWrapper:hover .arrowUp,
.numInputWrapper:hover .arrowDown {
  opacity: 1;
}

.numInputWrapper:hover .numInput[disabled] ~ .arrowUp,
.numInputWrapper:hover .numInput[disabled] ~ .arrowDown {
  opacity: 0;
}

.flatpickr-weekdays {
  display: flex;
  align-items: center;
  block-size: 2.5rem;
}

.flatpickr-weekdaycontainer {
  display: flex;
  inline-size: 100%;
}

.flatpickr-weekday {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  flex: 1 1;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: default;
}

.flatpickr-days:focus {
  outline: 0;
}

.flatpickr-calendar.animate .dayContainer.slideLeft {
  animation: fp-fade-out 400ms cubic-bezier(0.23, 1, 0.32, 1), fp-slide-left 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.flatpickr-calendar.animate .dayContainer.slideLeft,
.flatpickr-calendar.animate .dayContainer.slideLeftNew {
  transform: translate3d(-100%, 0, 0);
}

.flatpickr-calendar.animate .dayContainer.slideLeftNew {
  animation: fp-fade-in 400ms cubic-bezier(0.23, 1, 0.32, 1), fp-slide-left 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.flatpickr-calendar.animate .dayContainer.slideRight {
  animation: fp-fade-out 400ms cubic-bezier(0.23, 1, 0.32, 1), fp-slide-right 400ms cubic-bezier(0.23, 1, 0.32, 1);
  transform: translate3d(100%, 0, 0);
}

.flatpickr-calendar.animate .dayContainer.slideRightNew {
  animation: fp-fade-in 400ms cubic-bezier(0.23, 1, 0.32, 1), fp-slide-right-new 400ms cubic-bezier(0.23, 1, 0.32, 1);
}

.flatpickr-day {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  display: flex;
  align-items: center;
  justify-content: center;
  block-size: 2.5rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  cursor: pointer;
  inline-size: 2.5rem;
  transition: all 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.flatpickr-day:hover {
  background: #e8e8e8;
  background: var(--cds-layer-hover);
}
.flatpickr-day:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .flatpickr-day:focus {
    outline-style: dotted;
  }
}
.flatpickr-day:focus {
  outline-color: var(--color-primary);
  outline-color: var(--cds-button-primary, #0f62fe);
}

.nextMonthDay,
.prevMonthDay {
  color: #6f6f6f;
  color: var(--cds-text-helper, #6f6f6f);
}

.flatpickr-day.today {
  position: relative;
  color: var(--color-primary);
  color: var(--cds-link-primary, #0f62fe);
  font-weight: 600;
}
.flatpickr-day.today::after {
  position: absolute;
  display: block;
  background-color: var(--color-primary);
  background-color: var(--cds-link-primary, #0f62fe);
  block-size: 0.25rem;
  content: "";
  inline-size: 0.25rem;
  inset-block-end: 0.4375rem;
  inset-inline-start: 50%;
  transform: translateX(-50%);
}

.flatpickr-day.today.no-border {
  border: none;
}

.flatpickr-day.today.selected {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .flatpickr-day.today.selected {
    outline-style: dotted;
  }
}
.flatpickr-day.today.selected::after {
  display: none;
}

.flatpickr-day.inRange {
  background-color: #d0e2ff;
  background-color: var(--cds-highlight, #d0e2ff);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.flatpickr-day.selected {
  background-color: var(--color-primary);
  background-color: var(--cds-button-primary, #0f62fe);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .flatpickr-day.selected {
    color: Highlight;
    outline: 1px solid Highlight;
    outline-style: dotted;
  }
}
.flatpickr-day.selected:focus {
  outline: 0.0625rem solid #ffffff;
  outline: 0.0625rem solid var(--cds-layer-02, #ffffff);
  outline-offset: -0.1875rem;
}

.flatpickr-day.startRange.selected {
  z-index: 2;
  box-shadow: none;
}

.flatpickr-day.startRange.inRange:not(.selected),
.flatpickr-day.endRange.inRange {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .flatpickr-day.startRange.inRange:not(.selected),
  .flatpickr-day.endRange.inRange {
    outline-style: dotted;
  }
}
.flatpickr-day.startRange.inRange:not(.selected),
.flatpickr-day.endRange.inRange {
  z-index: 3;
  background: #f4f4f4;
  background: var(--cds-layer-01, #f4f4f4);
}

.flatpickr-day.endRange:hover {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .flatpickr-day.endRange:hover {
    outline-style: dotted;
  }
}
.flatpickr-day.endRange:hover {
  background: #f4f4f4;
  background: var(--cds-layer-01, #f4f4f4);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.flatpickr-day.endRange.inRange.selected {
  background: var(--color-primary);
  background: var(--cds-button-primary, #0f62fe);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}

.flatpickr-day.flatpickr-disabled {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.flatpickr-day.flatpickr-disabled:hover {
  background-color: transparent;
}

.flatpickr-input[readonly] {
  cursor: pointer;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .flatpickr-day.today,
  .flatpickr-day.inRange {
    color: Highlight;
  }
}

.cds--date-picker {
  display: flex;
}

.cds--date-picker--light .cds--date-picker__input {
  background: #ffffff;
  background: var(--cds-field-02, #ffffff);
}

.cds--date-picker ~ .cds--label {
  order: 1;
}

.cds--date-picker-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cds--date-picker-container .cds--label {
  display: flex;
}

.cds--date-picker-input__wrapper {
  display: flex;
  align-items: center;
}

.cds--date-picker-input__wrapper > span {
  position: relative;
}

.cds--date-picker.cds--date-picker--simple .cds--date-picker__input,
.cds--date-picker.cds--date-picker--simple .cds--label {
  inline-size: 7.5rem;
}

.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--invalid .cds--date-picker__input,
.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--invalid ~ .cds--form-requirement,
.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--warn .cds--date-picker__input,
.cds--date-picker.cds--date-picker--simple .cds--date-picker-input__wrapper--warn ~ .cds--form-requirement {
  inline-size: 9.5rem;
}

.cds--date-picker.cds--date-picker--simple.cds--date-picker--short .cds--date-picker__input {
  inline-size: 5.7rem;
}

.cds--date-picker.cds--date-picker--single .cds--date-picker__input {
  inline-size: 18rem;
}

.cds--date-picker .cds--date-picker-input__wrapper--warn ~ .cds--form-requirement {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--date-picker__input {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--date-picker__input *,
.cds--date-picker__input *::before,
.cds--date-picker__input *::after {
  box-sizing: inherit;
}
.cds--date-picker__input {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  font-family: var(--cds-code-02-font-family, 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace);
  font-size: 0.875rem;
  font-size: var(--cds-code-02-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-code-02-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-code-02-line-height, 1.42857);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-code-02-letter-spacing, 0.32px);
  outline: 2px solid transparent;
  outline-offset: -2px;
  position: relative;
  display: block;
  padding: 0 1rem;
  border: none;
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  block-size: 2.5rem;
  -webkit-border-after: 1px solid #8d8d8d;
          border-block-end: 1px solid #8d8d8d;
  -webkit-border-after: 1px solid var(--cds-border-strong);
          border-block-end: 1px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
  transition: 70ms cubic-bezier(0.2, 0, 0.38, 0.9) all;
}
.cds--date-picker__input:focus, .cds--date-picker__input.cds--focused {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--date-picker__input:focus, .cds--date-picker__input.cds--focused {
    outline-style: dotted;
  }
}
.cds--date-picker__input:disabled {
  background-color: #f4f4f4;
  background-color: var(--cds-field);
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--date-picker__input:disabled::placeholder {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
}
.cds--date-picker__input:disabled:hover {
  -webkit-border-after: 1px solid transparent;
          border-block-end: 1px solid transparent;
}
.cds--date-picker__input::placeholder {
  color: rgba(22, 22, 22, 0.4);
  color: var(--cds-text-placeholder, rgba(22, 22, 22, 0.4));
  opacity: 1;
}

.cds--date-picker__input--lg {
  block-size: 3rem;
}

.cds--date-picker__input--sm {
  block-size: 2rem;
}

.cds--date-picker__icon {
  position: absolute;
  z-index: 1;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
  inset-block-start: 50%;
  inset-inline-end: 1rem;
  pointer-events: none;
  transform: translateY(-50%);
}

.cds--date-picker__icon--invalid,
.cds--date-picker__icon--warn {
  cursor: auto;
}

.cds--date-picker__icon--warn {
  fill: #f1c21b;
  fill: var(--cds-support-warning, #f1c21b);
}

.cds--date-picker__icon--warn path:first-of-type {
  fill: #000000;
  opacity: 1;
}

.cds--date-picker__icon--invalid {
  fill: #da1e28;
  fill: var(--cds-support-error, #da1e28);
}

.cds--date-picker__icon ~ .cds--date-picker__input {
  -webkit-padding-end: 3rem;
          padding-inline-end: 3rem;
}

.cds--date-picker__input:disabled ~ .cds--date-picker__icon {
  cursor: not-allowed;
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--date-picker--range > .cds--date-picker-container:first-child {
  -webkit-margin-end: 0.0625rem;
          margin-inline-end: 0.0625rem;
}

.cds--date-picker--range .cds--date-picker-container,
.cds--date-picker--range .cds--date-picker__input {
  inline-size: 8.96875rem;
}

.cds--date-picker-input__wrapper--decorator .cds--date-picker-input-inner-wrapper--decorator > *,
.cds--date-picker-input__wrapper--slug .cds--ai-label,
.cds--date-picker-input__wrapper--slug .cds--slug {
  position: absolute;
  inset-block-start: 50%;
  inset-inline-end: 2.5rem;
  transform: translateY(-50%);
}

.cds--date-picker-input__wrapper--decorator .cds--date-picker-input-inner-wrapper--decorator:not(:has(.cds--ai-label)) > * {
  block-size: 1rem;
}

.cds--date-picker-input__wrapper--decorator .cds--date-picker__input:has(~ .cds--date-picker-input-inner-wrapper--decorator .cds--ai-label):not(:has(~ .cds--date-picker-input-inner-wrapper--decorator .cds--ai-label--revert)),
.cds--date-picker-input__wrapper--slug .cds--date-picker__input:has(~ .cds--ai-label):not(:has(~ .cds--ai-label--revert)),
.cds--date-picker-input__wrapper--slug .cds--date-picker__input:has(~ .cds--slug):not(:has(~ .cds--slug--revert)) {
  background-image: linear-gradient(0deg, rgba(69, 137, 255, 0.16) 0%, 15%, rgba(255, 255, 255, 0) 50%, transparent 100%);
  background-image: linear-gradient(0deg, var(--cds-ai-aura-start-sm, rgba(69, 137, 255, 0.16)) 0%, 15%, var(--cds-ai-aura-end, rgba(255, 255, 255, 0)) 50%, transparent 100%);
  border-block-end-color: #4589ff;
  border-block-end-color: var(--cds-ai-border-strong, #4589ff);
  -webkit-padding-end: 4rem;
          padding-inline-end: 4rem;
}

.cds--date-picker__input[readonly] {
  background: transparent;
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
  cursor: text;
}

.cds--date-picker__input[readonly] + .cds--date-picker__icon {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}

.cds--date-picker.cds--skeleton input,
.cds--date-picker__input.cds--skeleton {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--date-picker.cds--skeleton input:hover, .cds--date-picker.cds--skeleton input:focus, .cds--date-picker.cds--skeleton input:active,
.cds--date-picker__input.cds--skeleton:hover,
.cds--date-picker__input.cds--skeleton:focus,
.cds--date-picker__input.cds--skeleton:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--date-picker.cds--skeleton input::before,
.cds--date-picker__input.cds--skeleton::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--date-picker.cds--skeleton input::before,
  .cds--date-picker__input.cds--skeleton::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--date-picker.cds--skeleton input,
  .cds--date-picker__input.cds--skeleton {
    background: CanvasText;
  }
  .cds--date-picker.cds--skeleton input::before,
  .cds--date-picker__input.cds--skeleton::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--date-picker.cds--skeleton input,
.cds--date-picker__input.cds--skeleton {
  inline-size: 100%;
}
.cds--date-picker.cds--skeleton input::placeholder,
.cds--date-picker__input.cds--skeleton::placeholder {
  color: transparent;
}

.cds--date-picker.cds--skeleton .cds--label {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--date-picker.cds--skeleton .cds--label:hover, .cds--date-picker.cds--skeleton .cds--label:focus, .cds--date-picker.cds--skeleton .cds--label:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--date-picker.cds--skeleton .cds--label::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--date-picker.cds--skeleton .cds--label::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--date-picker.cds--skeleton .cds--label {
    background: CanvasText;
  }
  .cds--date-picker.cds--skeleton .cds--label::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--date-picker.cds--skeleton .cds--label {
  block-size: 0.875rem;
  inline-size: 4.6875rem;
}

.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  inline-size: 100%;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-label,
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item-secondary-label {
  overflow: hidden;
  text-overflow: ellipsis;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tab--list .cds--tabs__nav-link .cds--tabs__nav-item--icon {
  -webkit-margin-start: auto;
          margin-inline-start: auto;
}

.cds--tabs.cds--tabs--vertical .cds--tabs__nav-link .cds--tabs__nav-item-label {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  white-space: normal;
}

.cds--tabs,
.cds--tab-content {
  --cds-layout-density-padding-inline-local: clamp(var(--cds-layout-density-padding-inline-min), var(--cds-layout-density-padding-inline, var(--cds-layout-density-padding-inline-normal)), var(--cds-layout-density-padding-inline-max));
}

.cds--tabs.cds--tabs--tall,
.cds--tabs.cds--tabs--contained.cds--tabs--tall {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-lg)), var(--cds-layout-size-height, var(--cds-layout-size-height-xl)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-xl)));
}

.cds--tabs html {
  font-size: 100%;
}
.cds--tabs body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--tabs code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--tabs strong {
  font-weight: 600;
}
.cds--tabs {
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-md)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-lg)));
  position: relative;
  display: flex;
  block-size: auto;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  inline-size: 100%;
  max-block-size: 4rem;
  max-block-size: var(--cds-layout-size-height-xl);
  min-block-size: var(--cds-layout-size-height-local);
  overflow-x: hidden;
}
.cds--tabs.cds--tabs--contained {
  --cds-layout-size-height-local: clamp(max(var(--cds-layout-size-height-min), var(--cds-layout-size-height-sm)), var(--cds-layout-size-height, var(--cds-layout-size-height-lg)), min(var(--cds-layout-size-height-max), var(--cds-layout-size-height-xl)));
}
.cds--tabs .cds--tab--list {
  display: flex;
  inline-size: auto;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  will-change: scroll-position;
}
.cds--tabs .cds--tab--list::-webkit-scrollbar {
  display: none;
}
.cds--tabs.cds--tabs--vertical {
  background: #f4f4f4;
  background: var(--cds-layer);
  box-shadow: inset -1px 0 #e0e0e0;
  box-shadow: inset -1px 0 var(--cds-border-subtle);
  grid-column: span 2;
  max-block-size: none;
}
@media (min-width: 66rem) {
  .cds--tabs.cds--tabs--vertical {
    grid-column: span 4;
  }
}
.cds--tabs.cds--tabs--vertical .cds--tab--list {
  overflow: visible auto;
  flex-direction: column;
  inline-size: 100%;
}
.cds--tabs.cds--tabs--vertical .cds--tab--list-gradient_bottom {
  position: absolute;
  background: linear-gradient(to bottom, transparent, #f4f4f4);
  background: linear-gradient(to bottom, transparent, var(--cds-layer));
  block-size: 4rem;
  inset-block-end: 0;
  inset-inline: 0;
  pointer-events: none;
}
.cds--tabs.cds--tabs--vertical .cds--tab--list-gradient_top {
  position: absolute;
  background: linear-gradient(to top, transparent, #f4f4f4);
  background: linear-gradient(to top, transparent, var(--cds-layer));
  block-size: 4rem;
  inset-block-start: 0;
  inset-inline: 0;
  pointer-events: none;
}
.cds--tabs .cds--tabs__nav {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav *,
.cds--tabs .cds--tabs__nav *::before,
.cds--tabs .cds--tabs__nav *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav {
  display: flex;
}
.cds--tabs .cds--tab--overflow-nav-button {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tab--overflow-nav-button *,
.cds--tabs .cds--tab--overflow-nav-button *::before,
.cds--tabs .cds--tab--overflow-nav-button *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tab--overflow-nav-button::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tab--overflow-nav-button {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
  inline-size: 2.5rem;
}
.cds--tabs .cds--tab--overflow-nav-button:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tab--overflow-nav-button:focus {
    outline-style: dotted;
  }
}
.cds--tabs .cds--tab--overflow-nav-button:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover, rgba(141, 141, 141, 0.12));
}
.cds--tabs .cds--tab--overflow-nav-button:active {
  background-color: rgba(141, 141, 141, 0.5);
  background-color: var(--cds-background-active, rgba(141, 141, 141, 0.5));
}
.cds--tabs .cds--tab--overflow-nav-button--hidden {
  display: none;
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button {
  margin: 0;
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
  inline-size: 3rem;
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-accent-hover);
}
.cds--tabs.cds--tabs--contained .cds--tab--overflow-nav-button:active {
  background-color: #a8a8a8;
  background-color: var(--cds-layer-accent-active);
}
.cds--tabs .cds--tab--overflow-nav-button svg {
  z-index: 2;
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tab--overflow-nav-button svg:active, .cds--tabs .cds--tab--overflow-nav-button svg:hover {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tab--overflow-nav-button--next {
  position: relative;
  inset-block: 0;
  inset-inline-end: 0;
}
.cds--tabs .cds--tab--overflow-nav-button--next::before {
  position: absolute;
  z-index: 1;
  block-size: 100%;
  content: "";
  inline-size: 0.5rem;
  inset-inline-start: -0.5rem;
}
.cds--tabs:not(.cds--tabs--contained) .cds--tab--overflow-nav-button--next::before {
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
  background: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-background, #ffffff));
}
.cds--tabs:not(.cds--tabs--contained) .cds--tab--overflow-nav-button--previous::before {
  background: linear-gradient(to left, rgba(255, 255, 255, 0), #ffffff);
  background: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-background, #ffffff));
}
.cds--tabs .cds--tab--overflow-nav-button--previous {
  position: relative;
  z-index: 1;
  inset-block: 0;
  inset-inline-start: 0;
}
.cds--tabs .cds--tab--overflow-nav-button--previous::before {
  position: absolute;
  z-index: 1;
  block-size: 100%;
  content: "";
  inline-size: 0.5rem;
  inset-inline-end: -0.5rem;
}
.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--left {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #f4f4f4);
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-layer));
}
.cds--tabs .cds--tabs--light .cds--tabs__overflow-indicator--right {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #f4f4f4);
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-layer));
}
.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left {
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #e0e0e0);
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
.cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right {
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #e0e0e0);
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), var(--cds-layer-accent));
}
@supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
  .cds--tabs .cds--tabs__overflow-indicator--left {
    background-image: linear-gradient(to left, rgba(#ffffff, 0), #ffffff);
    background-image: linear-gradient(to left, rgba(var(--cds-background, #ffffff), 0), var(--cds-background, #ffffff));
  }
  .cds--tabs .cds--tabs__overflow-indicator--right {
    background-image: linear-gradient(to right, rgba(#ffffff, 0), #ffffff);
    background-image: linear-gradient(to right, rgba(var(--cds-background, #ffffff), 0), var(--cds-background, #ffffff));
  }
  .cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--left {
    background-image: linear-gradient(to left, rgba(#e0e0e0, 0), #e0e0e0);
    background-image: linear-gradient(to left, rgba(var(--cds-layer-accent), 0), var(--cds-layer-accent));
  }
  .cds--tabs.cds--tabs--contained .cds--tabs__overflow-indicator--right {
    background-image: linear-gradient(to right, rgba(#e0e0e0, 0), #e0e0e0);
    background-image: linear-gradient(to right, rgba(var(--cds-layer-accent), 0), var(--cds-layer-accent));
  }
}
.cds--tabs .cds--tabs__nav-item-label-wrapper {
  display: flex;
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item-label-wrapper {
  position: relative;
  inset-block-start: 0.0625rem;
}
.cds--tabs .cds--tabs__nav-item html {
  font-size: 100%;
}
.cds--tabs .cds--tabs__nav-item body {
  font-weight: 400;
  font-family: 'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}
.cds--tabs .cds--tabs__nav-item code {
  font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
}
.cds--tabs .cds--tabs__nav-item strong {
  font-weight: 600;
}
.cds--tabs .cds--tabs__nav-item {
  position: relative;
  display: flex;
  flex: 1 0 auto;
  padding: 0;
  cursor: pointer;
  transition: background-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs .cds--tabs__nav-item + .cds--tabs__nav-item {
  -webkit-margin-start: 0.0625rem;
          margin-inline-start: 0.0625rem;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-accent);
  box-shadow: -0.0625rem 0 0 0 #8d8d8d;
  box-shadow: -0.0625rem 0 0 0 var(--cds-border-strong);
  -webkit-margin-start: 0;
          margin-inline-start: 0;
}
.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item {
  flex: none;
  background-color: #f4f4f4;
  background-color: var(--cds-layer-01, #f4f4f4);
  block-size: 4rem;
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle);
          border-block-end: 1px solid var(--cds-border-subtle);
  -webkit-border-end: 1px solid #e0e0e0;
          border-inline-end: 1px solid #e0e0e0;
  -webkit-border-end: 1px solid var(--cds-border-subtle);
          border-inline-end: 1px solid var(--cds-border-subtle);
  box-shadow: inset 3px 0 0 0 #e0e0e0;
  box-shadow: inset 3px 0 0 0 var(--cds-border-subtle);
  inline-size: 100%;
  -webkit-margin-start: 0;
          margin-inline-start: 0;
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-item--selected + div + .cds--tabs__nav-item {
  box-shadow: -0.0625rem 0 0 0 transparent;
}
.cds--tabs .cds--tabs__nav-item .cds--tabs__nav-link {
  transition: color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), border-bottom-color 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs.cds--tabs--dismissable .cds--tabs__nav-link {
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}
.cds--tabs.cds--tabs--dismissable.cds--tabs--contained .cds--tabs__nav-link {
  -webkit-padding-end: calc(3rem - 1px);
          padding-inline-end: calc(3rem - 1px);
}
.cds--tabs .cds--tabs__nav-item--close {
  position: relative;
  display: flex;
  align-items: center;
  inset-inline-start: calc(-0.75rem - 1px);
  -webkit-margin-start: calc(-1.5rem + 1px);
          margin-inline-start: calc(-1.5rem + 1px);
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item--close--hidden {
  position: absolute;
  overflow: hidden;
  padding: 0;
  border: 0;
  margin: -1px;
  block-size: 1px;
  clip: rect(0, 0, 0, 0);
  inline-size: 1px;
  visibility: inherit;
  white-space: nowrap;
  position: static;
  inline-size: 0.1875rem;
}
.cds--tabs.cds--tabs--contained.cds--tabs--full-width .cds--tabs__nav-item--close--hidden {
  display: none;
}
.cds--tabs .cds--tabs__nav-item--close-icon {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  inline-size: 100%;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav-item--close-icon *,
.cds--tabs .cds--tabs__nav-item--close-icon *::before,
.cds--tabs .cds--tabs__nav-item--close-icon *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav-item--close-icon::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tabs__nav-item--close-icon {
  block-size: 1.5rem;
  inline-size: 1.5rem;
  padding-block: 0.25rem;
  padding-inline: 0.25rem;
  pointer-events: auto;
}
.cds--tabs .cds--tabs__nav-item--close-icon svg {
  block-size: 1rem;
  fill: #525252;
  fill: var(--cds-text-secondary, #525252);
  inline-size: 1rem;
}
.cds--tabs .cds--tabs__nav-item--close-icon svg:hover {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item--close-icon:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
}
.cds--tabs .cds--tabs__nav-item--close-icon:focus, .cds--tabs .cds--tabs__nav-item--close-icon:active {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tabs__nav-item--close-icon:focus, .cds--tabs .cds--tabs__nav-item--close-icon:active {
    outline-style: dotted;
  }
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item--close-icon--selected svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover {
  background-color: inherit;
  cursor: not-allowed;
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled svg,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled svg,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover svg {
  fill: rgba(22, 22, 22, 0.25);
  fill: var(--cds-icon-disabled, rgba(22, 22, 22, 0.25));
}
.cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:focus, .cds--tabs .cds--tabs__nav-item:hover + .cds--tabs__nav-item--close .cds--tabs__nav-item--close-icon--disabled:active,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:focus,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:active,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:focus,
.cds--tabs .cds--tabs__nav-item--close-icon--disabled:hover:active {
  outline: 2px solid transparent;
  outline-offset: -2px;
}
.cds--tabs .cds--tabs__nav-item--icon {
  display: flex;
  align-items: center;
  -webkit-padding-start: 0.5rem;
          padding-inline-start: 0.5rem;
}
.cds--tabs .cds--tabs__nav-item--icon-left {
  display: flex;
  align-items: center;
  -webkit-margin-before: -2px;
          margin-block-start: -2px;
  -webkit-padding-end: 0.5rem;
          padding-inline-end: 0.5rem;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon {
  -webkit-padding-start: var(--cds-layout-density-padding-inline-local);
          padding-inline-start: var(--cds-layout-density-padding-inline-local);
}
.cds--tabs .cds--tabs__nav-link {
  display: inline-block;
  padding: 0;
  border: 0;
  -webkit-appearance: none;
          appearance: none;
  background: none;
  cursor: pointer;
  text-align: start;
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--tabs .cds--tabs__nav-link *,
.cds--tabs .cds--tabs__nav-link *::before,
.cds--tabs .cds--tabs__nav-link *::after {
  box-sizing: inherit;
}
.cds--tabs .cds--tabs__nav-link::-moz-focus-inner {
  border: 0;
}
.cds--tabs .cds--tabs__nav-link {
  outline: 2px solid transparent;
  outline-offset: -2px;
  font-size: 0.875rem;
  font-size: var(--cds-body-compact-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-compact-01-font-weight, 400);
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-compact-01-letter-spacing, 0.16px);
  overflow: hidden;
  -webkit-border-after: 2px solid #e0e0e0;
          border-block-end: 2px solid #e0e0e0;
  -webkit-border-after: 2px solid var(--cds-border-subtle);
          border-block-end: 2px solid var(--cds-border-subtle);
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  padding-inline: var(--cds-layout-density-padding-inline-local);
  text-align: start;
  text-decoration: none;
  text-overflow: ellipsis;
  transition: border 70ms cubic-bezier(0.2, 0, 0.38, 0.9), outline 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
  white-space: nowrap;
}
.cds--tabs .cds--tabs__nav-link:focus, .cds--tabs .cds--tabs__nav-link:active {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tabs .cds--tabs__nav-link:focus, .cds--tabs .cds--tabs__nav-link:active {
    outline-style: dotted;
  }
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-link {
  -webkit-border-after: 0;
          border-block-end: 0;
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item-label {
  line-height: calc(3rem - 0.5rem * 2);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item-secondary-label {
  font-size: 0.75rem;
  font-size: var(--cds-label-01-font-size, 0.75rem);
  font-weight: 400;
  font-weight: var(--cds-label-01-font-weight, 400);
  line-height: 1.33333;
  line-height: var(--cds-label-01-line-height, 1.33333);
  letter-spacing: 0.32px;
  letter-spacing: var(--cds-label-01-letter-spacing, 0.32px);
  min-block-size: 1rem;
}
.cds--tabs.cds--tabs--vertical:not(.cds--tabs--tall) .cds--tabs__nav-item-label {
  line-height: 1.28572;
  line-height: var(--cds-body-compact-01-line-height);
}
.cds--tabs.cds--tabs__icon--default, .cds--tabs.cds--tabs__icon--lg, .cds--tabs.cds--tabs__icon--default .cds--tab--list, .cds--tabs.cds--tabs__icon--lg .cds--tab--list {
  overflow-x: visible;
}
.cds--tabs .cds--tabs__nav-item--icon-only {
  -webkit-margin-end: 0.0625rem;
          margin-inline-end: 0.0625rem;
}
.cds--tabs .cds--tabs__nav-item--icon-only, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  block-size: var(--cds-layout-size-height-local);
  inline-size: var(--cds-layout-size-height-local);
}
.cds--tabs .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--icon-only .cds--tabs__nav-item-label {
  line-height: 0;
}
.cds--tabs .cds--tabs__nav-item--icon-only:not(.cds--tabs__nav-item--icon-only__20) .cds--badge-indicator {
  -webkit-margin-before: 0.25rem;
          margin-block-start: 0.25rem;
  -webkit-margin-end: 0.25rem;
          margin-inline-end: 0.25rem;
}
.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):hover {
  -webkit-border-after: 2px solid #8d8d8d;
          border-block-end: 2px solid #8d8d8d;
  -webkit-border-after: 2px solid var(--cds-border-strong);
          border-block-end: 2px solid var(--cds-border-strong);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):not(.cds--tabs__nav-item--hover-off):hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-accent-hover);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item:not(.cds--tabs__nav-item--selected):not(.cds--tabs__nav-item--disabled):not(.cds--tabs__nav-item--hover-off):hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  box-shadow: inset 3px 0 0 0 #8d8d8d;
  box-shadow: inset 3px 0 0 0 var(--cds-border-strong);
}
.cds--tabs .cds--tabs__nav-item--selected {
  -webkit-border-after: 2px solid var(--color-primary);
          border-block-end: 2px solid var(--color-primary);
  -webkit-border-after: 2px solid var(--cds-border-interactive, #0f62fe);
          border-block-end: 2px solid var(--cds-border-interactive, #0f62fe);
  transition: color 70ms cubic-bezier(0.2, 0, 0.38, 0.9);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected + .cds--tabs__nav-item {
  box-shadow: none;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--selected {
  box-shadow: inset 0 2px 0 0 var(--color-primary);
  box-shadow: inset 0 2px 0 0 var(--cds-border-interactive, #0f62fe);
}
.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--selected {
  border-inline: none;
  box-shadow: inset 3px 0 0 0 var(--color-primary);
  box-shadow: inset 3px 0 0 0 var(--cds-border-interactive, #0f62fe);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected,
.cds--tabs .cds--tabs__nav-item--selected,
.cds--tabs .cds--tabs__nav-item--selected:focus .cds--tabs__nav-link:focus,
.cds--tabs .cds--tabs__nav-item--selected:active .cds--tabs__nav-link:active {
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  color: #161616;
  color: var(--cds-text-primary, #161616);
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--contained:not(.cds--tabs--tall) .cds--tabs__nav-item--selected:hover {
  line-height: calc(3rem - 0.5rem * 2);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:focus,
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected .cds--tabs__nav-link:active, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:focus,
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected:hover .cds--tabs__nav-link:active {
  box-shadow: none;
}
.cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected, .cds--tabs.cds--tabs--light.cds--tabs--contained .cds--tabs__nav-item--selected:hover {
  background-color: #ffffff;
  background-color: var(--cds-background, #ffffff);
}
.cds--tabs .cds--tabs__nav-item--disabled {
  background-color: transparent;
  -webkit-border-after: 2px solid #e0e0e0;
          border-block-end: 2px solid #e0e0e0;
  -webkit-border-after: 2px solid var(--cds-border-subtle);
          border-block-end: 2px solid var(--cds-border-subtle);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  outline: none;
}
.cds--tabs .cds--tabs__nav-item--disabled:hover {
  -webkit-border-after: 2px solid #e0e0e0;
          border-block-end: 2px solid #e0e0e0;
  -webkit-border-after: 2px solid var(--cds-border-subtle);
          border-block-end: 2px solid var(--cds-border-subtle);
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled, rgba(22, 22, 22, 0.25));
  cursor: not-allowed;
}
.cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled, .cds--tabs.cds--tabs--contained .cds--tabs__nav-item.cds--tabs__nav-item--disabled:hover {
  background-color: #c6c6c6;
  background-color: var(--cds-button-disabled, #c6c6c6);
}
.cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--disabled, .cds--tabs.cds--tabs--vertical .cds--tabs__nav-item.cds--tabs__nav-item--disabled:hover {
  background-color: #f4f4f4;
  background-color: var(--cds-layer);
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle);
          border-block-end: 1px solid var(--cds-border-subtle);
}
.cds--tabs .cds--tabs__nav-item--disabled:focus,
.cds--tabs .cds--tabs__nav-item--disabled:active {
  -webkit-border-after: 2px solid #e0e0e0;
          border-block-end: 2px solid #e0e0e0;
  -webkit-border-after: 2px solid var(--cds-border-subtle);
          border-block-end: 2px solid var(--cds-border-subtle);
  outline: none;
  pointer-events: none;
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled:hover .cds--tabs__nav-link {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:focus,
.cds--tabs .cds--tabs--light .cds--tabs__nav-item--disabled .cds--tabs__nav-link:active {
  border-block-end-color: #e0e0e0;
  border-block-end-color: var(--cds-border-subtle);
}
.cds--tabs.cds--tabs--contained:not(.cds--tabs--vertical) .cds--tabs__nav-item--disabled {
  -webkit-border-after: none;
          border-block-end: none;
  color: #8d8d8d;
  color: var(--cds-text-on-color-disabled, #8d8d8d);
}

.cds--tab-content {
  padding: var(--cds-layout-density-padding-inline-local);
}
.cds--tab-content:focus {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--tab-content:focus {
    outline-style: dotted;
  }
}

.cds--tabs--contained ~ .cds--tab-content {
  background: #f4f4f4;
  background: var(--cds-layer);
}

.cds--tabs--vertical ~ .cds--tab-content .cds--text-input--fluid .cds--text-input,
.cds--tabs--vertical ~ .cds--tab-content .cds--text-area--fluid .cds--text-area__wrapper,
.cds--tabs--vertical ~ .cds--tab-content .cds--text-area--fluid .cds--text-area,
.cds--tabs--vertical ~ .cds--tab-content .cds--search--fluid .cds--search-input,
.cds--tabs--vertical ~ .cds--tab-content .cds--select--fluid .cds--select-input,
.cds--tabs--vertical ~ .cds--tab-content .cds--text-area--fluid .cds--text-area__wrapper[data-invalid] .cds--text-area__divider + .cds--form-requirement,
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__wrapper--fluid .cds--list-box,
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__wrapper--fluid.cds--list-box__wrapper,
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid input[type=number],
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid input[type=text],
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn::before,
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn::after,
.cds--tabs--vertical ~ .cds--tab-content .cds--date-picker--fluid .ccdsds--date-picker-input__wrapper .cds--date-picker__input {
  background-color: #f4f4f4;
  background-color: var(--cds-field-01, #f4f4f4);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__wrapper--fluid .cds--list-box__menu {
  background-color: #f4f4f4;
  background-color: var(--cds-layer-01, #f4f4f4);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__menu-item:hover {
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover-02, #e8e8e8);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__menu-item--active {
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected-02, #e0e0e0);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--list-box__menu-item--active:hover {
  background-color: #d1d1d1;
  background-color: var(--cds-layer-selected-hover-02, #d1d1d1);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn:hover::before,
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn:hover::after {
  background-color: #e8e8e8;
  background-color: var(--cds-field-hover);
}
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn:focus::before,
.cds--tabs--vertical ~ .cds--tab-content .cds--number-input--fluid .cds--number__control-btn:focus::after {
  -webkit-border-start: 2px solid var(--color-primary);
          border-inline-start: 2px solid var(--color-primary);
  -webkit-border-start: 2px solid var(--cds-focus, #0f62fe);
          border-inline-start: 2px solid var(--cds-focus, #0f62fe);
}
.cds--tabs--vertical ~ .cds--tab-content {
  grid-column: 3/-1;
  overflow-y: auto;
}
@media (min-width: 66rem) {
  .cds--tabs--vertical ~ .cds--tab-content {
    grid-column: 5/-1;
  }
}

.cds--tabs.cds--skeleton {
  cursor: default;
  pointer-events: none;
}

.cds--skeleton.cds--tabs:not(.cds--tabs--contained) .cds--tabs__nav-link {
  -webkit-border-after: 2px solid #c6c6c6;
          border-block-end: 2px solid #c6c6c6;
  -webkit-border-after: 2px solid var(--cds-skeleton-element, #c6c6c6);
          border-block-end: 2px solid var(--cds-skeleton-element, #c6c6c6);
}

.cds--tabs.cds--skeleton .cds--tabs__nav-link {
  display: flex;
  align-items: center;
  padding: 0 var(--cds-layout-density-padding-inline-local);
  block-size: 100%;
  inline-size: 10rem;
}

.cds--tabs.cds--skeleton .cds--tabs__nav-link span {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span:hover, .cds--tabs.cds--skeleton .cds--tabs__nav-link span:focus, .cds--tabs.cds--skeleton .cds--tabs__nav-link span:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--tabs.cds--skeleton .cds--tabs__nav-link span::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tabs.cds--skeleton .cds--tabs__nav-link span {
    background: CanvasText;
  }
  .cds--tabs.cds--skeleton .cds--tabs__nav-link span::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--tabs.cds--skeleton .cds--tabs__nav-link span {
  display: block;
  block-size: 0.875rem;
  inline-size: 100%;
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tabs__nav-item--selected .cds--tabs__nav-link,
  .cds--tabs__nav-item--selected.cds--tabs__nav-link,
  .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected,
  .cds--tabs.cds--tabs--contained .cds--tabs__nav-item--selected.cds--tabs__nav-link {
    background-color: SelectedItem;
  }
}

@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--tabs .cds--tabs__nav-item--disabled .cds--tabs__nav-link {
    color: GrayText;
    fill: GrayText;
  }
}

.cds--structured-list--selection .cds--structured-list-td,
.cds--structured-list--selection .cds--structured-list-th {
  padding-inline: 1rem 1rem;
}
.cds--structured-list--selection .cds--structured-list-td:first-child,
.cds--structured-list--selection .cds--structured-list-th:first-child {
  padding-inline: 1rem 1rem;
}

.cds--structured-list-row--focused-within {
  outline: 2px solid var(--color-primary);
  outline: 2px solid var(--cds-focus, #0f62fe);
  outline-offset: -2px;
}
@media screen and (prefers-contrast) {
  .cds--structured-list-row--focused-within {
    outline-style: dotted;
  }
}

.cds--structured-list {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--structured-list *,
.cds--structured-list *::before,
.cds--structured-list *::after {
  box-sizing: inherit;
}
.cds--structured-list {
  display: table;
  background-color: #f4f4f4 transparent;
  background-color: var(--cds-layer) transparent;
  border-collapse: collapse;
  border-spacing: 0;
  inline-size: 100%;
  overflow-x: auto;
}
.cds--structured-list.cds--structured-list--condensed .cds--structured-list-td, .cds--structured-list.cds--structured-list--condensed .cds--structured-list-th {
  padding: 0.5rem;
}
.cds--structured-list .cds--structured-list-row .cds--structured-list-td:first-of-type,
.cds--structured-list .cds--structured-list-row .cds--structured-list-th:first-of-type {
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
}
.cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-td, .cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-th, .cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-td:first-of-type, .cds--structured-list.cds--structured-list--flush .cds--structured-list-row .cds--structured-list-th:first-of-type {
  padding-inline: 0 1rem;
}

.cds--structured-list-row {
  display: table-row;
  -webkit-border-before: 1px solid #e0e0e0;
          border-block-start: 1px solid #e0e0e0;
  -webkit-border-before: 1px solid var(--cds-border-subtle);
          border-block-start: 1px solid var(--cds-border-subtle);
  transition: background-color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--structured-list-tbody .cds--structured-list-row:last-child {
  -webkit-border-after: 1px solid #e0e0e0;
          border-block-end: 1px solid #e0e0e0;
  -webkit-border-after: 1px solid var(--cds-border-subtle);
          border-block-end: 1px solid var(--cds-border-subtle);
}

.cds--structured-list-row--header-row {
  border: none;
}

.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected) {
  border-color: #e8e8e8;
  border-color: var(--cds-layer-hover);
  background-color: #e8e8e8;
  background-color: var(--cds-layer-hover);
  cursor: pointer;
}

.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row):not(.cds--structured-list-row--selected) + .cds--structured-list-row {
  border-color: #e8e8e8;
  border-color: var(--cds-layer-hover);
}

.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected {
  border-color: #e0e0e0;
  border-color: var(--cds-layer-selected);
  background-color: #e0e0e0;
  background-color: var(--cds-layer-selected);
}

.cds--structured-list--selection .cds--structured-list-row--selected + .cds--structured-list-row {
  border-color: #e0e0e0;
  border-color: var(--cds-layer-selected);
}

.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected .cds--structured-list-td {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--structured-list-row.cds--structured-list-row--header-row {
  cursor: inherit;
}

.cds--structured-list--selection .cds--structured-list-row:hover:not(.cds--structured-list-row--header-row) > .cds--structured-list-td,
.cds--structured-list--selection .cds--structured-list-row.cds--structured-list-row--selected > .cds--structured-list-td {
  color: #161616;
  color: var(--cds-text-primary, #161616);
}

.cds--structured-list-thead {
  display: table-header-group;
  vertical-align: middle;
}

.cds--structured-list-th {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--structured-list-th *,
.cds--structured-list-th *::before,
.cds--structured-list-th *::after {
  box-sizing: inherit;
}
.cds--structured-list-th {
  padding: 1rem 0.5rem 0.5rem 0.5rem;
  font-size: 0.875rem;
  font-size: var(--cds-heading-compact-01-font-size, 0.875rem);
  font-weight: 600;
  font-weight: var(--cds-heading-compact-01-font-weight, 600);
  line-height: 1.28572;
  line-height: var(--cds-heading-compact-01-line-height, 1.28572);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-heading-compact-01-letter-spacing, 0.16px);
  display: table-cell;
  block-size: 2.5rem;
  color: #161616;
  color: var(--cds-text-primary, #161616);
  font-weight: 600;
  text-align: start;
  text-transform: none;
  vertical-align: top;
}

.cds--structured-list-tbody {
  display: table-row-group;
  vertical-align: middle;
}

.cds--structured-list-td {
  box-sizing: border-box;
  padding: 0;
  border: 0;
  margin: 0;
  font-family: inherit;
  font-size: 100%;
  vertical-align: baseline;
}
.cds--structured-list-td *,
.cds--structured-list-td *::before,
.cds--structured-list-td *::after {
  box-sizing: inherit;
}
.cds--structured-list-td {
  font-size: 0.875rem;
  font-size: var(--cds-body-01-font-size, 0.875rem);
  font-weight: 400;
  font-weight: var(--cds-body-01-font-weight, 400);
  line-height: 1.42857;
  line-height: var(--cds-body-01-line-height, 1.42857);
  letter-spacing: 0.16px;
  letter-spacing: var(--cds-body-01-letter-spacing, 0.16px);
  padding: 1rem 0.5rem 1.5rem 0.5rem;
  position: relative;
  display: table-cell;
  color: #525252;
  color: var(--cds-text-secondary, #525252);
  max-inline-size: 36rem;
  transition: color 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
}

.cds--structured-list-content--nowrap {
  white-space: nowrap;
}

.cds--structured-list-input + .cds--structured-list-td {
  text-align: end;
}

.cds--structured-list-svg {
  display: inline-block;
  -webkit-margin-before: 0.125rem;
          margin-block-start: 0.125rem;
  transition: all 110ms cubic-bezier(0.2, 0, 0.38, 0.9);
  vertical-align: top;
}

.cds--structured-list-input:checked + .cds--structured-list-row .cds--structured-list-svg,
.cds--structured-list-input:checked + .cds--structured-list-td .cds--structured-list-svg {
  fill: #161616;
  fill: var(--cds-icon-primary, #161616);
}

.cds--structured-list-svg {
  fill: transparent;
}

.cds--structured-list--selection .cds--structured-list-td:last-child {
  inline-size: 2rem;
  -webkit-padding-start: 0;
          padding-inline-start: 0;
}

.cds--structured-list.cds--skeleton .cds--structured-list-th:first-child {
  inline-size: 8%;
}
.cds--structured-list.cds--skeleton .cds--structured-list-th:nth-child(3n+2) {
  inline-size: 30%;
}
.cds--structured-list.cds--skeleton .cds--structured-list-th:nth-child(3n+3) {
  inline-size: 15%;
}
.cds--structured-list.cds--skeleton span {
  position: relative;
  padding: 0;
  border: none;
  background: #e8e8e8;
  background: var(--cds-skeleton-background, #e8e8e8);
  box-shadow: none;
  pointer-events: none;
}
.cds--structured-list.cds--skeleton span:hover, .cds--structured-list.cds--skeleton span:focus, .cds--structured-list.cds--skeleton span:active {
  border: none;
  cursor: default;
  outline: none;
}
.cds--structured-list.cds--skeleton span::before {
  position: absolute;
  animation: 3000ms ease-in-out cds--skeleton infinite;
  background: #c6c6c6;
  background: var(--cds-skeleton-element, #c6c6c6);
  block-size: 100%;
  content: "";
  inline-size: 100%;
  inset-inline-start: 0;
  will-change: transform-origin, transform, opacity;
}
@media (prefers-reduced-motion: reduce) {
  .cds--structured-list.cds--skeleton span::before {
    animation: none;
  }
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  .cds--structured-list.cds--skeleton span {
    background: CanvasText;
  }
  .cds--structured-list.cds--skeleton span::before {
    background: Canvas;
    forced-color-adjust: none;
  }
}
.cds--structured-list.cds--skeleton span {
  display: block;
  block-size: 1rem;
  inline-size: 75%;
}

.cds--structured-list.cds--structured-list--selection.cds--skeleton .cds--structured-list-th:first-child {
  inline-size: 5%;
}
.cds--structured-list.cds--structured-list--selection.cds--skeleton .cds--structured-list-th:first-child span {
  display: none;
}

.cds--structured-list__icon {
  -webkit-margin-before: 0.125rem;
          margin-block-start: 0.125rem;
  vertical-align: top;
}

.cds--structured-list--selection .cds--structured-list-td:first-child:has(.cds--structured-list__icon) {
  inline-size: 2rem;
  -webkit-padding-end: 0;
          padding-inline-end: 0;
}

.flatpickr-calendar,
.flatpickr-months,
.flatpickr-month,
.flatpickr-weekdays,
.flatpickr-weekday {
  background: #f4f4f4;
  background: var(--cds-field, var(--cds-layer, #ffffff));
}

.dark .flatpickr-calendar,
.dark .flatpickr-months,
.dark .flatpickr-month,
.dark .flatpickr-weekdays,
.dark .flatpickr-weekday {
  background: #393939;
}

.flatpickr-day {
  color: #161616;
  color: var(--cds-text-primary);
}

.flatpickr-day.prevMonthDay,
.flatpickr-day.nextMonthDay {
  color: rgba(22, 22, 22, 0.25);
  color: var(--cds-text-disabled);
}

.flatpickr-current-month .flatpickr-monthDropdown-months,
.flatpickr-current-month input.cur-year {
  color: #161616;
  color: var(--cds-text-primary);
}

.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  fill: #161616;
  fill: var(--cds-icon-primary);
}

.cds--popover-content {
  max-inline-size: none;
}

.cds--tooltip-content,
.cds--popover {
  z-index: 9999;
}

.cds--batch-actions .cds--batch-summary__cancel {
  background-color: #393939;
  background-color: var(--cds-button-secondary, #393939);
  color: #ffffff;
  color: var(--cds-text-on-color, #ffffff);
}

.cds--batch-actions .cds--action-list .cds--btn,
.cds--batch-actions .cds--action-list .cds--btn::before,
.cds--batch-actions .cds--batch-summary__cancel::before {
  border: none;
  border-left: none;
  box-shadow: none;
}

:root {
  --cds-ai-aura-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-background: #edf5ff;
  --cds-ai-aura-hover-end: rgba(255, 255, 255, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.32);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #78a9ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.64);
  --cds-ai-border-strong: #4589ff;
  --cds-ai-drop-shadow: rgba(15, 98, 254, 0.1);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.1);
  --cds-ai-overlay: rgba(0, 17, 65, 0.5);
  --cds-ai-popover-background: #ffffff;
  --cds-ai-popover-caret-bottom: #78a9ff;
  --cds-ai-popover-caret-bottom-background: #eaf1ff;
  --cds-ai-popover-caret-bottom-background-actions: #e9effa;
  --cds-ai-popover-caret-center: #a0c3ff;
  --cds-ai-popover-shadow-outer-01: rgba(0, 67, 206, 0.06);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.04);
  --cds-ai-skeleton-background: #d0e2ff;
  --cds-ai-skeleton-element-background: #4589ff;
  --cds-background: #ffffff;
  --cds-background-active: rgba(141, 141, 141, 0.5);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.12);
  --cds-background-inverse: #393939;
  --cds-background-inverse-hover: #474747;
  --cds-background-selected: rgba(141, 141, 141, 0.2);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: #c6c6c6;
  --cds-border-interactive: #0f62fe;
  --cds-border-inverse: #161616;
  --cds-border-strong-01: #8d8d8d;
  --cds-border-strong-02: #8d8d8d;
  --cds-border-strong-03: #8d8d8d;
  --cds-border-subtle-00: #e0e0e0;
  --cds-border-subtle-01: #c6c6c6;
  --cds-border-subtle-02: #e0e0e0;
  --cds-border-subtle-03: #c6c6c6;
  --cds-border-subtle-selected-01: #c6c6c6;
  --cds-border-subtle-selected-02: #c6c6c6;
  --cds-border-subtle-selected-03: #c6c6c6;
  --cds-border-tile-01: #c6c6c6;
  --cds-border-tile-02: #a8a8a8;
  --cds-border-tile-03: #c6c6c6;
  --cds-chat-avatar-agent: #393939;
  --cds-chat-avatar-bot: #6f6f6f;
  --cds-chat-avatar-user: #0f62fe;
  --cds-chat-bubble-agent: #ffffff;
  --cds-chat-bubble-agent-text: #161616;
  --cds-chat-bubble-border: #e0e0e0;
  --cds-chat-bubble-user: #e0e0e0;
  --cds-chat-bubble-user-text: #161616;
  --cds-chat-button: #0f62fe;
  --cds-chat-button-active: rgba(141, 141, 141, 0.5);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.12);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.2);
  --cds-chat-button-text-hover: #0043ce;
  --cds-chat-button-text-selected: #525252;
  --cds-chat-header-background: #ffffff;
  --cds-chat-header-text: #161616;
  --cds-chat-prompt-background: #ffffff;
  --cds-chat-prompt-border-end: rgba(244, 244, 244, 0);
  --cds-chat-prompt-border-start: #f4f4f4;
  --cds-chat-prompt-text: #161616;
  --cds-chat-shell-background: #ffffff;
  --cds-color-scheme: light;
  --cds-field-01: #f4f4f4;
  --cds-field-02: #ffffff;
  --cds-field-03: #f4f4f4;
  --cds-field-hover-01: #e8e8e8;
  --cds-field-hover-02: #e8e8e8;
  --cds-field-hover-03: #e8e8e8;
  --cds-focus: #0f62fe;
  --cds-focus-inset: #ffffff;
  --cds-focus-inverse: #ffffff;
  --cds-highlight: #d0e2ff;
  --cds-icon-disabled: rgba(22, 22, 22, 0.25);
  --cds-icon-interactive: #0f62fe;
  --cds-icon-inverse: #ffffff;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: #8d8d8d;
  --cds-icon-primary: #161616;
  --cds-icon-secondary: #525252;
  --cds-interactive: #0f62fe;
  --cds-layer-01: #f4f4f4;
  --cds-layer-02: #ffffff;
  --cds-layer-03: #f4f4f4;
  --cds-layer-accent-01: #e0e0e0;
  --cds-layer-accent-02: #e0e0e0;
  --cds-layer-accent-03: #e0e0e0;
  --cds-layer-accent-active-01: #a8a8a8;
  --cds-layer-accent-active-02: #a8a8a8;
  --cds-layer-accent-active-03: #a8a8a8;
  --cds-layer-accent-hover-01: #d1d1d1;
  --cds-layer-accent-hover-02: #d1d1d1;
  --cds-layer-accent-hover-03: #d1d1d1;
  --cds-layer-active-01: #c6c6c6;
  --cds-layer-active-02: #c6c6c6;
  --cds-layer-active-03: #c6c6c6;
  --cds-layer-background-01: #ffffff;
  --cds-layer-background-02: #f4f4f4;
  --cds-layer-background-03: #ffffff;
  --cds-layer-hover-01: #e8e8e8;
  --cds-layer-hover-02: #e8e8e8;
  --cds-layer-hover-03: #e8e8e8;
  --cds-layer-selected-01: #e0e0e0;
  --cds-layer-selected-02: #e0e0e0;
  --cds-layer-selected-03: #e0e0e0;
  --cds-layer-selected-disabled: #8d8d8d;
  --cds-layer-selected-hover-01: #d1d1d1;
  --cds-layer-selected-hover-02: #d1d1d1;
  --cds-layer-selected-hover-03: #d1d1d1;
  --cds-layer-selected-inverse: #161616;
  --cds-link-inverse: #78a9ff;
  --cds-link-inverse-active: #f4f4f4;
  --cds-link-inverse-hover: #a6c8ff;
  --cds-link-inverse-visited: #be95ff;
  --cds-link-primary: #0f62fe;
  --cds-link-primary-hover: #0043ce;
  --cds-link-secondary: #0043ce;
  --cds-link-visited: #8a3ffc;
  --cds-overlay: rgba(0, 0, 0, 0.6);
  --cds-shadow: rgba(0, 0, 0, 0.3);
  --cds-skeleton-background: #e8e8e8;
  --cds-skeleton-element: #c6c6c6;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #8a3ffc;
  --cds-support-error: #da1e28;
  --cds-support-error-inverse: #fa4d56;
  --cds-support-info: #0043ce;
  --cds-support-info-inverse: #4589ff;
  --cds-support-success: #24a148;
  --cds-support-success-inverse: #42be65;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-syntax-angle-bracket: #697077;
  --cds-syntax-annotation: #007d79;
  --cds-syntax-arithmetic-operator: #343a3f;
  --cds-syntax-atom: #161616;
  --cds-syntax-attribute: #00539a;
  --cds-syntax-attribute-name: #00539a;
  --cds-syntax-attribute-value: #161616;
  --cds-syntax-bitwise-operator: #343a3f;
  --cds-syntax-block-comment: #198038;
  --cds-syntax-bool: #161616;
  --cds-syntax-brace: #343a3f;
  --cds-syntax-bracket: #343a3f;
  --cds-syntax-character: #161616;
  --cds-syntax-class-name: #007d79;
  --cds-syntax-color: #161616;
  --cds-syntax-comment: #198038;
  --cds-syntax-compare-operator: #343a3f;
  --cds-syntax-constant: #0f62fe;
  --cds-syntax-content: #161616;
  --cds-syntax-content-separator: #343a3f;
  --cds-syntax-control-keyword: #6929c4;
  --cds-syntax-control-operator: #6929c4;
  --cds-syntax-definition: #00539a;
  --cds-syntax-definition-keyword: #00539a;
  --cds-syntax-definition-operator: #00539a;
  --cds-syntax-deref-operator: #343a3f;
  --cds-syntax-doc-comment: #198038;
  --cds-syntax-doc-string: #161616;
  --cds-syntax-document-meta: #198038;
  --cds-syntax-emphasis: #161616;
  --cds-syntax-escape: #343a3f;
  --cds-syntax-float: #198038;
  --cds-syntax-function: #8e6a00;
  --cds-syntax-heading: #00539a;
  --cds-syntax-heading-1: #00539a;
  --cds-syntax-heading-2: #00539a;
  --cds-syntax-heading-3: #00539a;
  --cds-syntax-heading-4: #00539a;
  --cds-syntax-heading-5: #00539a;
  --cds-syntax-heading-6: #00539a;
  --cds-syntax-integer: #198038;
  --cds-syntax-invalid: #da1e28;
  --cds-syntax-keyword: #0f62fe;
  --cds-syntax-label-name: #0f62fe;
  --cds-syntax-line-comment: #198038;
  --cds-syntax-link: #0f62fe;
  --cds-syntax-list: #161616;
  --cds-syntax-literal: #161616;
  --cds-syntax-local: #0f62fe;
  --cds-syntax-logic-operator: #343a3f;
  --cds-syntax-macro-name: #161616;
  --cds-syntax-meta: #198038;
  --cds-syntax-modifier: #0f62fe;
  --cds-syntax-module-keyword: #6929c4;
  --cds-syntax-monospace: #161616;
  --cds-syntax-name: #0f62fe;
  --cds-syntax-namespace: #007d79;
  --cds-syntax-null: #161616;
  --cds-syntax-number: #198038;
  --cds-syntax-operator: #343a3f;
  --cds-syntax-operator-keyword: #0f62fe;
  --cds-syntax-paren: #343a3f;
  --cds-syntax-processing-instruction: #161616;
  --cds-syntax-property-name: #00539a;
  --cds-syntax-punctuation: #343a3f;
  --cds-syntax-quote: #198038;
  --cds-syntax-regexp: #6929c4;
  --cds-syntax-self: #007d79;
  --cds-syntax-separator: #343a3f;
  --cds-syntax-special: #0f62fe;
  --cds-syntax-special-string: #8a3ffc;
  --cds-syntax-square-bracket: #343a3f;
  --cds-syntax-standard: #0f62fe;
  --cds-syntax-strikethrough: #161616;
  --cds-syntax-string: #161616;
  --cds-syntax-strong: #161616;
  --cds-syntax-tag: #007d79;
  --cds-syntax-tag-name: #007d79;
  --cds-syntax-type: #007d79;
  --cds-syntax-type-name: #007d79;
  --cds-syntax-type-operator: #007d79;
  --cds-syntax-unit: #198038;
  --cds-syntax-update-operator: #343a3f;
  --cds-syntax-url: #343a3f;
  --cds-syntax-variable: #0f62fe;
  --cds-syntax-variable-name: #0f62fe;
  --cds-text-disabled: rgba(22, 22, 22, 0.25);
  --cds-text-error: #da1e28;
  --cds-text-helper: #6f6f6f;
  --cds-text-inverse: #ffffff;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: #8d8d8d;
  --cds-text-placeholder: rgba(22, 22, 22, 0.4);
  --cds-text-primary: #161616;
  --cds-text-secondary: #525252;
  --cds-toggle-off: #8d8d8d;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-button-separator: #e0e0e0;
  --cds-button-primary: #0f62fe;
  --cds-button-secondary: #393939;
  --cds-button-tertiary: #0f62fe;
  --cds-button-danger-primary: #da1e28;
  --cds-button-danger-secondary: #da1e28;
  --cds-button-danger-active: #750e13;
  --cds-button-primary-active: #002d9c;
  --cds-button-secondary-active: #6f6f6f;
  --cds-button-tertiary-active: #002d9c;
  --cds-button-danger-hover: #b81921;
  --cds-button-primary-hover: #0050e6;
  --cds-button-secondary-hover: #474747;
  --cds-button-tertiary-hover: #0050e6;
  --cds-button-disabled: #c6c6c6;
  --cds-tag-background-red: #ffd7d9;
  --cds-tag-color-red: #a2191f;
  --cds-tag-hover-red: #ffc2c5;
  --cds-tag-background-magenta: #ffd6e8;
  --cds-tag-color-magenta: #9f1853;
  --cds-tag-hover-magenta: #ffbdda;
  --cds-tag-background-purple: #e8daff;
  --cds-tag-color-purple: #6929c4;
  --cds-tag-hover-purple: #dcc7ff;
  --cds-tag-background-blue: #d0e2ff;
  --cds-tag-color-blue: #0043ce;
  --cds-tag-hover-blue: #b8d3ff;
  --cds-tag-background-cyan: #bae6ff;
  --cds-tag-color-cyan: #00539a;
  --cds-tag-hover-cyan: #99daff;
  --cds-tag-background-teal: #9ef0f0;
  --cds-tag-color-teal: #005d5d;
  --cds-tag-hover-teal: #57e5e5;
  --cds-tag-background-green: #a7f0ba;
  --cds-tag-color-green: #0e6027;
  --cds-tag-hover-green: #74e792;
  --cds-tag-background-gray: #e0e0e0;
  --cds-tag-color-gray: #161616;
  --cds-tag-hover-gray: #d1d1d1;
  --cds-tag-border-red: #ff8389;
  --cds-tag-border-blue: #78a9ff;
  --cds-tag-border-cyan: #33b1ff;
  --cds-tag-border-teal: #08bdba;
  --cds-tag-border-green: #42be65;
  --cds-tag-border-magenta: #ff7eb6;
  --cds-tag-border-purple: #be95ff;
  --cds-tag-border-gray: #a8a8a8;
  --cds-tag-border-cool-gray: #a2a9b0;
  --cds-tag-border-warm-gray: #ada8a8;
  --cds-tag-background-cool-gray: #dde1e6;
  --cds-tag-color-cool-gray: #121619;
  --cds-tag-hover-cool-gray: #cdd3da;
  --cds-tag-background-warm-gray: #e5e0df;
  --cds-tag-color-warm-gray: #171414;
  --cds-tag-hover-warm-gray: #d8d0cf;
  --cds-status-red: #da1e28;
  --cds-status-orange: #ff832b;
  --cds-status-orange-outline: #ba4e00;
  --cds-status-yellow: #f1c21b;
  --cds-status-yellow-outline: #8e6a00;
  --cds-status-green: #24a148;
  --cds-status-blue: #0043ce;
  --cds-status-purple: #8a3ffc;
  --cds-status-gray: #6f6f6f;
  --cds-notification-background-error: #fff1f1;
  --cds-notification-background-success: #defbe6;
  --cds-notification-background-info: #edf5ff;
  --cds-notification-background-warning: #fcf4d6;
  --cds-notification-action-hover: #ffffff;
  --cds-notification-action-tertiary-inverse: #ffffff;
  --cds-notification-action-tertiary-inverse-active: #c6c6c6;
  --cds-notification-action-tertiary-inverse-hover: #f4f4f4;
  --cds-notification-action-tertiary-inverse-text: #161616;
  --cds-notification-action-tertiary-inverse-text-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-content-switcher-background: #e0e0e0;
  --cds-content-switcher-background-hover: #d1d1d1;
  --cds-content-switcher-selected: #ffffff;
  color-scheme: light;
  color-scheme: var(--cds-color-scheme, light);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  :root {
    --cds-icon-primary: ButtonText;
    --cds-icon-secondary: ButtonText;
    --cds-icon-interactive: ButtonText;
    --cds-icon-disabled: GrayText;
    --cds-icon-on-color-disabled: GrayText;
    --cds-icon-inverse: SelectedItemText;
    --cds-icon-on-color: SelectedItemText;
    --cds-button-disabled: GrayText;
    --cds-interactive: ButtonText;
    --cds-link-primary: LinkText;
    --cds-link-primary-hover: LinkText;
    --cds-link-secondary: LinkText;
    --cds-link-inverse: SelectedItemText;
    --cds-link-inverse-hover: SelectedItemText;
    --cds-link-inverse-visited: SelectedItemText;
    --cds-link-visited: VisitedText;
    --cds-background-selected: SelectedItem;
    --cds-background-selected-hover: SelectedItem;
    --cds-background-inverse: SelectedItem;
    --cds-layer-selected-inverse: SelectedItem;
  }
}
:root {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
  --cds-interactive: var(--color-primary);
  --cds-button-primary: var(--color-primary);
  --cds-button-primary-hover: color-mix(in oklab, var(--color-primary) 85%, black);
  --cds-button-primary-active: color-mix(in oklab, var(--color-primary) 70%, black);
  --cds-button-tertiary: var(--color-primary);
  --cds-button-tertiary-hover: var(--color-primary);
  --cds-button-tertiary-active: color-mix(in oklab, var(--color-primary) 70%, black);
  --cds-focus: var(--color-primary);
  --cds-border-interactive: var(--color-primary);
  --cds-link-primary: var(--color-primary);
  --cds-link-primary-hover: color-mix(in oklab, var(--color-primary) 80%, black);
}

:is(.dark *),
:root:is(.dark) {
  --cds-ai-aura-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-background: #333333;
  --cds-ai-aura-hover-end: rgba(0, 0, 0, 0);
  --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.4);
  --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
  --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
  --cds-ai-border-end: #4589ff;
  --cds-ai-border-start: rgba(166, 200, 255, 0.36);
  --cds-ai-border-strong: #78a9ff;
  --cds-ai-drop-shadow: rgba(0, 0, 0, 0.28);
  --cds-ai-inner-shadow: rgba(69, 137, 255, 0.16);
  --cds-ai-overlay: rgba(0, 0, 0, 0.5);
  --cds-ai-popover-background: #161616;
  --cds-ai-popover-caret-bottom: #4589ff;
  --cds-ai-popover-caret-bottom-background: #202d45;
  --cds-ai-popover-caret-bottom-background-actions: #1e283a;
  --cds-ai-popover-caret-center: #4870b5;
  --cds-ai-popover-shadow-outer-01: rgba(0, 0, 0, 0.12);
  --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.08);
  --cds-ai-skeleton-background: rgba(120, 169, 255, 0.5);
  --cds-ai-skeleton-element-background: rgba(120, 169, 255, 0.3);
  --cds-background: #161616;
  --cds-background-active: rgba(141, 141, 141, 0.4);
  --cds-background-brand: #0f62fe;
  --cds-background-hover: rgba(141, 141, 141, 0.16);
  --cds-background-inverse: #f4f4f4;
  --cds-background-inverse-hover: #e8e8e8;
  --cds-background-selected: rgba(141, 141, 141, 0.24);
  --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
  --cds-border-disabled: rgba(141, 141, 141, 0.5);
  --cds-border-interactive: #4589ff;
  --cds-border-inverse: #f4f4f4;
  --cds-border-strong-01: #6f6f6f;
  --cds-border-strong-02: #8d8d8d;
  --cds-border-strong-03: #a8a8a8;
  --cds-border-subtle-00: #393939;
  --cds-border-subtle-01: #525252;
  --cds-border-subtle-02: #6f6f6f;
  --cds-border-subtle-03: #6f6f6f;
  --cds-border-subtle-selected-01: #6f6f6f;
  --cds-border-subtle-selected-02: #8d8d8d;
  --cds-border-subtle-selected-03: #8d8d8d;
  --cds-border-tile-01: #525252;
  --cds-border-tile-02: #6f6f6f;
  --cds-border-tile-03: #8d8d8d;
  --cds-chat-avatar-agent: #c6c6c6;
  --cds-chat-avatar-bot: #8d8d8d;
  --cds-chat-avatar-user: #4589ff;
  --cds-chat-bubble-agent: #262626;
  --cds-chat-bubble-agent-text: #f4f4f4;
  --cds-chat-bubble-border: #525252;
  --cds-chat-bubble-user: #393939;
  --cds-chat-bubble-user-text: #f4f4f4;
  --cds-chat-button: #78a9ff;
  --cds-chat-button-active: rgba(141, 141, 141, 0.4);
  --cds-chat-button-hover: rgba(141, 141, 141, 0.16);
  --cds-chat-button-selected: rgba(141, 141, 141, 0.24);
  --cds-chat-button-text-hover: #a6c8ff;
  --cds-chat-button-text-selected: #c6c6c6;
  --cds-chat-header-background: #262626;
  --cds-chat-header-text: #f4f4f4;
  --cds-chat-prompt-background: #161616;
  --cds-chat-prompt-border-end: rgba(38, 38, 38, 0);
  --cds-chat-prompt-border-start: #262626;
  --cds-chat-prompt-text: #f4f4f4;
  --cds-chat-shell-background: #262626;
  --cds-color-scheme: dark;
  --cds-field-01: #262626;
  --cds-field-02: #393939;
  --cds-field-03: #525252;
  --cds-field-hover-01: #333333;
  --cds-field-hover-02: #474747;
  --cds-field-hover-03: #636363;
  --cds-focus: #ffffff;
  --cds-focus-inset: #161616;
  --cds-focus-inverse: #0f62fe;
  --cds-highlight: #001d6c;
  --cds-icon-disabled: rgba(244, 244, 244, 0.25);
  --cds-icon-interactive: #ffffff;
  --cds-icon-inverse: #161616;
  --cds-icon-on-color: #ffffff;
  --cds-icon-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-icon-primary: #f4f4f4;
  --cds-icon-secondary: #c6c6c6;
  --cds-interactive: #4589ff;
  --cds-layer-01: #262626;
  --cds-layer-02: #393939;
  --cds-layer-03: #525252;
  --cds-layer-accent-01: #393939;
  --cds-layer-accent-02: #525252;
  --cds-layer-accent-03: #6f6f6f;
  --cds-layer-accent-active-01: #6f6f6f;
  --cds-layer-accent-active-02: #8d8d8d;
  --cds-layer-accent-active-03: #393939;
  --cds-layer-accent-hover-01: #474747;
  --cds-layer-accent-hover-02: #636363;
  --cds-layer-accent-hover-03: #5e5e5e;
  --cds-layer-active-01: #525252;
  --cds-layer-active-02: #6f6f6f;
  --cds-layer-active-03: #8d8d8d;
  --cds-layer-background-01: #161616;
  --cds-layer-background-02: #262626;
  --cds-layer-background-03: #393939;
  --cds-layer-hover-01: #333333;
  --cds-layer-hover-02: #474747;
  --cds-layer-hover-03: #636363;
  --cds-layer-selected-01: #393939;
  --cds-layer-selected-02: #525252;
  --cds-layer-selected-03: #6f6f6f;
  --cds-layer-selected-disabled: #a8a8a8;
  --cds-layer-selected-hover-01: #474747;
  --cds-layer-selected-hover-02: #636363;
  --cds-layer-selected-hover-03: #5e5e5e;
  --cds-layer-selected-inverse: #f4f4f4;
  --cds-link-inverse: #0f62fe;
  --cds-link-inverse-active: #161616;
  --cds-link-inverse-hover: #0043ce;
  --cds-link-inverse-visited: #8a3ffc;
  --cds-link-primary: #78a9ff;
  --cds-link-primary-hover: #a6c8ff;
  --cds-link-secondary: #a6c8ff;
  --cds-link-visited: #be95ff;
  --cds-overlay: rgba(0, 0, 0, 0.6);
  --cds-shadow: rgba(0, 0, 0, 0.8);
  --cds-skeleton-background: #292929;
  --cds-skeleton-element: #393939;
  --cds-support-caution-major: #ff832b;
  --cds-support-caution-minor: #f1c21b;
  --cds-support-caution-undefined: #a56eff;
  --cds-support-error: #fa4d56;
  --cds-support-error-inverse: #da1e28;
  --cds-support-info: #4589ff;
  --cds-support-info-inverse: #0043ce;
  --cds-support-success: #42be65;
  --cds-support-success-inverse: #24a148;
  --cds-support-warning: #f1c21b;
  --cds-support-warning-inverse: #f1c21b;
  --cds-syntax-angle-bracket: #8d8d8d;
  --cds-syntax-annotation: #08bdba;
  --cds-syntax-arithmetic-operator: #e0e0e0;
  --cds-syntax-atom: #f4f4f4;
  --cds-syntax-attribute: #33b1ff;
  --cds-syntax-attribute-name: #33b1ff;
  --cds-syntax-attribute-value: #f4f4f4;
  --cds-syntax-bitwise-operator: #e0e0e0;
  --cds-syntax-block-comment: #42be65;
  --cds-syntax-bool: #f4f4f4;
  --cds-syntax-brace: #e0e0e0;
  --cds-syntax-bracket: #e0e0e0;
  --cds-syntax-character: #f4f4f4;
  --cds-syntax-class-name: #3ddbd9;
  --cds-syntax-color: #f4f4f4;
  --cds-syntax-comment: #42be65;
  --cds-syntax-compare-operator: #e0e0e0;
  --cds-syntax-constant: #4589ff;
  --cds-syntax-content: #f4f4f4;
  --cds-syntax-content-separator: #e0e0e0;
  --cds-syntax-control-keyword: #be95ff;
  --cds-syntax-control-operator: #be95ff;
  --cds-syntax-definition: #33b1ff;
  --cds-syntax-definition-keyword: #33b1ff;
  --cds-syntax-definition-operator: #33b1ff;
  --cds-syntax-deref-operator: #e0e0e0;
  --cds-syntax-doc-comment: #42be65;
  --cds-syntax-doc-string: #f4f4f4;
  --cds-syntax-document-meta: #42be65;
  --cds-syntax-emphasis: #f4f4f4;
  --cds-syntax-escape: #e0e0e0;
  --cds-syntax-float: #6fdc8c;
  --cds-syntax-function: #f1c21b;
  --cds-syntax-heading: #33b1ff;
  --cds-syntax-heading-1: #33b1ff;
  --cds-syntax-heading-2: #33b1ff;
  --cds-syntax-heading-3: #33b1ff;
  --cds-syntax-heading-4: #33b1ff;
  --cds-syntax-heading-5: #33b1ff;
  --cds-syntax-heading-6: #33b1ff;
  --cds-syntax-integer: #6fdc8c;
  --cds-syntax-invalid: #fa4d56;
  --cds-syntax-keyword: #4589ff;
  --cds-syntax-label-name: #a6c8ff;
  --cds-syntax-line-comment: #42be65;
  --cds-syntax-link: #4589ff;
  --cds-syntax-list: #f4f4f4;
  --cds-syntax-literal: #f4f4f4;
  --cds-syntax-local: #a6c8ff;
  --cds-syntax-logic-operator: #e0e0e0;
  --cds-syntax-macro-name: #f4f4f4;
  --cds-syntax-meta: #42be65;
  --cds-syntax-modifier: #4589ff;
  --cds-syntax-module-keyword: #be95ff;
  --cds-syntax-monospace: #f4f4f4;
  --cds-syntax-name: #a6c8ff;
  --cds-syntax-namespace: #3ddbd9;
  --cds-syntax-null: #f4f4f4;
  --cds-syntax-number: #6fdc8c;
  --cds-syntax-operator: #e0e0e0;
  --cds-syntax-operator-keyword: #4589ff;
  --cds-syntax-paren: #e0e0e0;
  --cds-syntax-processing-instruction: #f4f4f4;
  --cds-syntax-property-name: #33b1ff;
  --cds-syntax-punctuation: #e0e0e0;
  --cds-syntax-quote: #42be65;
  --cds-syntax-regexp: #be95ff;
  --cds-syntax-self: #3ddbd9;
  --cds-syntax-separator: #e0e0e0;
  --cds-syntax-special: #4589ff;
  --cds-syntax-special-string: #be95ff;
  --cds-syntax-square-bracket: #e0e0e0;
  --cds-syntax-standard: #4589ff;
  --cds-syntax-strikethrough: #f4f4f4;
  --cds-syntax-string: #f4f4f4;
  --cds-syntax-strong: #f4f4f4;
  --cds-syntax-tag: #3ddbd9;
  --cds-syntax-tag-name: #3ddbd9;
  --cds-syntax-type: #3ddbd9;
  --cds-syntax-type-name: #3ddbd9;
  --cds-syntax-type-operator: #3ddbd9;
  --cds-syntax-unit: #6fdc8c;
  --cds-syntax-update-operator: #e0e0e0;
  --cds-syntax-url: #e0e0e0;
  --cds-syntax-variable: #a6c8ff;
  --cds-syntax-variable-name: #a6c8ff;
  --cds-text-disabled: rgba(244, 244, 244, 0.25);
  --cds-text-error: #ff8389;
  --cds-text-helper: #a8a8a8;
  --cds-text-inverse: #161616;
  --cds-text-on-color: #ffffff;
  --cds-text-on-color-disabled: rgba(255, 255, 255, 0.25);
  --cds-text-placeholder: rgba(244, 244, 244, 0.4);
  --cds-text-primary: #f4f4f4;
  --cds-text-secondary: #c6c6c6;
  --cds-toggle-off: #6f6f6f;
  --cds-spacing-01: 0.125rem;
  --cds-spacing-02: 0.25rem;
  --cds-spacing-03: 0.5rem;
  --cds-spacing-04: 0.75rem;
  --cds-spacing-05: 1rem;
  --cds-spacing-06: 1.5rem;
  --cds-spacing-07: 2rem;
  --cds-spacing-08: 2.5rem;
  --cds-spacing-09: 3rem;
  --cds-spacing-10: 4rem;
  --cds-spacing-11: 5rem;
  --cds-spacing-12: 6rem;
  --cds-spacing-13: 10rem;
  --cds-fluid-spacing-01: 0;
  --cds-fluid-spacing-02: 2vw;
  --cds-fluid-spacing-03: 5vw;
  --cds-fluid-spacing-04: 10vw;
  --cds-caption-01-font-size: 0.75rem;
  --cds-caption-01-font-weight: 400;
  --cds-caption-01-line-height: 1.33333;
  --cds-caption-01-letter-spacing: 0.32px;
  --cds-caption-02-font-size: 0.875rem;
  --cds-caption-02-font-weight: 400;
  --cds-caption-02-line-height: 1.28572;
  --cds-caption-02-letter-spacing: 0.32px;
  --cds-label-01-font-size: 0.75rem;
  --cds-label-01-font-weight: 400;
  --cds-label-01-line-height: 1.33333;
  --cds-label-01-letter-spacing: 0.32px;
  --cds-label-02-font-size: 0.875rem;
  --cds-label-02-font-weight: 400;
  --cds-label-02-line-height: 1.28572;
  --cds-label-02-letter-spacing: 0.16px;
  --cds-helper-text-01-font-size: 0.75rem;
  --cds-helper-text-01-line-height: 1.33333;
  --cds-helper-text-01-letter-spacing: 0.32px;
  --cds-helper-text-02-font-size: 0.875rem;
  --cds-helper-text-02-font-weight: 400;
  --cds-helper-text-02-line-height: 1.28572;
  --cds-helper-text-02-letter-spacing: 0.16px;
  --cds-body-short-01-font-size: 0.875rem;
  --cds-body-short-01-font-weight: 400;
  --cds-body-short-01-line-height: 1.28572;
  --cds-body-short-01-letter-spacing: 0.16px;
  --cds-body-short-02-font-size: 1rem;
  --cds-body-short-02-font-weight: 400;
  --cds-body-short-02-line-height: 1.375;
  --cds-body-short-02-letter-spacing: 0;
  --cds-body-long-01-font-size: 0.875rem;
  --cds-body-long-01-font-weight: 400;
  --cds-body-long-01-line-height: 1.42857;
  --cds-body-long-01-letter-spacing: 0.16px;
  --cds-body-long-02-font-size: 1rem;
  --cds-body-long-02-font-weight: 400;
  --cds-body-long-02-line-height: 1.5;
  --cds-body-long-02-letter-spacing: 0;
  --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-01-font-size: 0.75rem;
  --cds-code-01-font-weight: 400;
  --cds-code-01-line-height: 1.33333;
  --cds-code-01-letter-spacing: 0.32px;
  --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
  --cds-code-02-font-size: 0.875rem;
  --cds-code-02-font-weight: 400;
  --cds-code-02-line-height: 1.42857;
  --cds-code-02-letter-spacing: 0.32px;
  --cds-heading-01-font-size: 0.875rem;
  --cds-heading-01-font-weight: 600;
  --cds-heading-01-line-height: 1.42857;
  --cds-heading-01-letter-spacing: 0.16px;
  --cds-heading-02-font-size: 1rem;
  --cds-heading-02-font-weight: 600;
  --cds-heading-02-line-height: 1.5;
  --cds-heading-02-letter-spacing: 0;
  --cds-productive-heading-01-font-size: 0.875rem;
  --cds-productive-heading-01-font-weight: 600;
  --cds-productive-heading-01-line-height: 1.28572;
  --cds-productive-heading-01-letter-spacing: 0.16px;
  --cds-productive-heading-02-font-size: 1rem;
  --cds-productive-heading-02-font-weight: 600;
  --cds-productive-heading-02-line-height: 1.375;
  --cds-productive-heading-02-letter-spacing: 0;
  --cds-productive-heading-03-font-size: 1.25rem;
  --cds-productive-heading-03-font-weight: 400;
  --cds-productive-heading-03-line-height: 1.4;
  --cds-productive-heading-03-letter-spacing: 0;
  --cds-productive-heading-04-font-size: 1.75rem;
  --cds-productive-heading-04-font-weight: 400;
  --cds-productive-heading-04-line-height: 1.28572;
  --cds-productive-heading-04-letter-spacing: 0;
  --cds-productive-heading-05-font-size: 2rem;
  --cds-productive-heading-05-font-weight: 400;
  --cds-productive-heading-05-line-height: 1.25;
  --cds-productive-heading-05-letter-spacing: 0;
  --cds-productive-heading-06-font-size: 2.625rem;
  --cds-productive-heading-06-font-weight: 300;
  --cds-productive-heading-06-line-height: 1.199;
  --cds-productive-heading-06-letter-spacing: 0;
  --cds-productive-heading-07-font-size: 3.375rem;
  --cds-productive-heading-07-font-weight: 300;
  --cds-productive-heading-07-line-height: 1.19;
  --cds-productive-heading-07-letter-spacing: 0;
  --cds-expressive-paragraph-01-font-size: 1.5rem;
  --cds-expressive-paragraph-01-font-weight: 300;
  --cds-expressive-paragraph-01-line-height: 1.334;
  --cds-expressive-paragraph-01-letter-spacing: 0;
  --cds-expressive-heading-01-font-size: 0.875rem;
  --cds-expressive-heading-01-font-weight: 600;
  --cds-expressive-heading-01-line-height: 1.42857;
  --cds-expressive-heading-01-letter-spacing: 0.16px;
  --cds-expressive-heading-02-font-size: 1rem;
  --cds-expressive-heading-02-font-weight: 600;
  --cds-expressive-heading-02-line-height: 1.5;
  --cds-expressive-heading-02-letter-spacing: 0;
  --cds-expressive-heading-03-font-size: 1.25rem;
  --cds-expressive-heading-03-font-weight: 400;
  --cds-expressive-heading-03-line-height: 1.4;
  --cds-expressive-heading-03-letter-spacing: 0;
  --cds-expressive-heading-04-font-size: 1.75rem;
  --cds-expressive-heading-04-font-weight: 400;
  --cds-expressive-heading-04-line-height: 1.28572;
  --cds-expressive-heading-04-letter-spacing: 0;
  --cds-expressive-heading-05-font-size: 2rem;
  --cds-expressive-heading-05-font-weight: 400;
  --cds-expressive-heading-05-line-height: 1.25;
  --cds-expressive-heading-05-letter-spacing: 0;
  --cds-expressive-heading-06-font-size: 2rem;
  --cds-expressive-heading-06-font-weight: 600;
  --cds-expressive-heading-06-line-height: 1.25;
  --cds-expressive-heading-06-letter-spacing: 0;
  --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-01-font-size: 1.25rem;
  --cds-quotation-01-font-weight: 400;
  --cds-quotation-01-line-height: 1.3;
  --cds-quotation-01-letter-spacing: 0;
  --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-quotation-02-font-size: 2rem;
  --cds-quotation-02-font-weight: 300;
  --cds-quotation-02-line-height: 1.25;
  --cds-quotation-02-letter-spacing: 0;
  --cds-display-01-font-size: 2.625rem;
  --cds-display-01-font-weight: 300;
  --cds-display-01-line-height: 1.19;
  --cds-display-01-letter-spacing: 0;
  --cds-display-02-font-size: 2.625rem;
  --cds-display-02-font-weight: 600;
  --cds-display-02-line-height: 1.19;
  --cds-display-02-letter-spacing: 0;
  --cds-display-03-font-size: 2.625rem;
  --cds-display-03-font-weight: 300;
  --cds-display-03-line-height: 1.19;
  --cds-display-03-letter-spacing: 0;
  --cds-display-04-font-size: 2.625rem;
  --cds-display-04-font-weight: 300;
  --cds-display-04-line-height: 1.19;
  --cds-display-04-letter-spacing: 0;
  --cds-legal-01-font-size: 0.75rem;
  --cds-legal-01-font-weight: 400;
  --cds-legal-01-line-height: 1.33333;
  --cds-legal-01-letter-spacing: 0.32px;
  --cds-legal-02-font-size: 0.875rem;
  --cds-legal-02-font-weight: 400;
  --cds-legal-02-line-height: 1.28572;
  --cds-legal-02-letter-spacing: 0.16px;
  --cds-body-compact-01-font-size: 0.875rem;
  --cds-body-compact-01-font-weight: 400;
  --cds-body-compact-01-line-height: 1.28572;
  --cds-body-compact-01-letter-spacing: 0.16px;
  --cds-body-compact-02-font-size: 1rem;
  --cds-body-compact-02-font-weight: 400;
  --cds-body-compact-02-line-height: 1.375;
  --cds-body-compact-02-letter-spacing: 0;
  --cds-heading-compact-01-font-size: 0.875rem;
  --cds-heading-compact-01-font-weight: 600;
  --cds-heading-compact-01-line-height: 1.28572;
  --cds-heading-compact-01-letter-spacing: 0.16px;
  --cds-heading-compact-02-font-size: 1rem;
  --cds-heading-compact-02-font-weight: 600;
  --cds-heading-compact-02-line-height: 1.375;
  --cds-heading-compact-02-letter-spacing: 0;
  --cds-body-01-font-size: 0.875rem;
  --cds-body-01-font-weight: 400;
  --cds-body-01-line-height: 1.42857;
  --cds-body-01-letter-spacing: 0.16px;
  --cds-body-02-font-size: 1rem;
  --cds-body-02-font-weight: 400;
  --cds-body-02-line-height: 1.5;
  --cds-body-02-letter-spacing: 0;
  --cds-heading-03-font-size: 1.25rem;
  --cds-heading-03-font-weight: 400;
  --cds-heading-03-line-height: 1.4;
  --cds-heading-03-letter-spacing: 0;
  --cds-heading-04-font-size: 1.75rem;
  --cds-heading-04-font-weight: 400;
  --cds-heading-04-line-height: 1.28572;
  --cds-heading-04-letter-spacing: 0;
  --cds-heading-05-font-size: 2rem;
  --cds-heading-05-font-weight: 400;
  --cds-heading-05-line-height: 1.25;
  --cds-heading-05-letter-spacing: 0;
  --cds-heading-06-font-size: 2.625rem;
  --cds-heading-06-font-weight: 300;
  --cds-heading-06-line-height: 1.199;
  --cds-heading-06-letter-spacing: 0;
  --cds-heading-07-font-size: 3.375rem;
  --cds-heading-07-font-weight: 300;
  --cds-heading-07-line-height: 1.19;
  --cds-heading-07-letter-spacing: 0;
  --cds-fluid-heading-03-font-size: 1.25rem;
  --cds-fluid-heading-03-font-weight: 400;
  --cds-fluid-heading-03-line-height: 1.4;
  --cds-fluid-heading-03-letter-spacing: 0;
  --cds-fluid-heading-04-font-size: 1.75rem;
  --cds-fluid-heading-04-font-weight: 400;
  --cds-fluid-heading-04-line-height: 1.28572;
  --cds-fluid-heading-04-letter-spacing: 0;
  --cds-fluid-heading-05-font-size: 2rem;
  --cds-fluid-heading-05-font-weight: 400;
  --cds-fluid-heading-05-line-height: 1.25;
  --cds-fluid-heading-05-letter-spacing: 0;
  --cds-fluid-heading-06-font-size: 2rem;
  --cds-fluid-heading-06-font-weight: 600;
  --cds-fluid-heading-06-line-height: 1.25;
  --cds-fluid-heading-06-letter-spacing: 0;
  --cds-fluid-paragraph-01-font-size: 1.5rem;
  --cds-fluid-paragraph-01-font-weight: 300;
  --cds-fluid-paragraph-01-line-height: 1.334;
  --cds-fluid-paragraph-01-letter-spacing: 0;
  --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-01-font-size: 1.25rem;
  --cds-fluid-quotation-01-font-weight: 400;
  --cds-fluid-quotation-01-line-height: 1.3;
  --cds-fluid-quotation-01-letter-spacing: 0;
  --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
  --cds-fluid-quotation-02-font-size: 2rem;
  --cds-fluid-quotation-02-font-weight: 300;
  --cds-fluid-quotation-02-line-height: 1.25;
  --cds-fluid-quotation-02-letter-spacing: 0;
  --cds-fluid-display-01-font-size: 2.625rem;
  --cds-fluid-display-01-font-weight: 300;
  --cds-fluid-display-01-line-height: 1.19;
  --cds-fluid-display-01-letter-spacing: 0;
  --cds-fluid-display-02-font-size: 2.625rem;
  --cds-fluid-display-02-font-weight: 600;
  --cds-fluid-display-02-line-height: 1.19;
  --cds-fluid-display-02-letter-spacing: 0;
  --cds-fluid-display-03-font-size: 2.625rem;
  --cds-fluid-display-03-font-weight: 300;
  --cds-fluid-display-03-line-height: 1.19;
  --cds-fluid-display-03-letter-spacing: 0;
  --cds-fluid-display-04-font-size: 2.625rem;
  --cds-fluid-display-04-font-weight: 300;
  --cds-fluid-display-04-line-height: 1.19;
  --cds-fluid-display-04-letter-spacing: 0;
  --cds-button-separator: #161616;
  --cds-button-primary: #0f62fe;
  --cds-button-secondary: #6f6f6f;
  --cds-button-tertiary: #ffffff;
  --cds-button-danger-primary: #da1e28;
  --cds-button-danger-secondary: #fa4d56;
  --cds-button-danger-active: #750e13;
  --cds-button-primary-active: #002d9c;
  --cds-button-secondary-active: #393939;
  --cds-button-tertiary-active: #c6c6c6;
  --cds-button-danger-hover: #b81921;
  --cds-button-primary-hover: #0050e6;
  --cds-button-secondary-hover: #5e5e5e;
  --cds-button-tertiary-hover: #f4f4f4;
  --cds-button-disabled: rgba(141, 141, 141, 0.3);
  --cds-tag-background-red: #a2191f;
  --cds-tag-color-red: #ffd7d9;
  --cds-tag-hover-red: #c21e25;
  --cds-tag-background-magenta: #9f1853;
  --cds-tag-color-magenta: #ffd6e8;
  --cds-tag-hover-magenta: #bf1d63;
  --cds-tag-background-purple: #6929c4;
  --cds-tag-color-purple: #e8daff;
  --cds-tag-hover-purple: #7c3dd6;
  --cds-tag-background-blue: #0043ce;
  --cds-tag-color-blue: #d0e2ff;
  --cds-tag-hover-blue: #0053ff;
  --cds-tag-background-cyan: #00539a;
  --cds-tag-color-cyan: #bae6ff;
  --cds-tag-hover-cyan: #0066bd;
  --cds-tag-background-teal: #005d5d;
  --cds-tag-color-teal: #9ef0f0;
  --cds-tag-hover-teal: #007070;
  --cds-tag-background-green: #0e6027;
  --cds-tag-color-green: #a7f0ba;
  --cds-tag-hover-green: #11742f;
  --cds-tag-background-gray: #525252;
  --cds-tag-color-gray: #f4f4f4;
  --cds-tag-hover-gray: #636363;
  --cds-tag-border-red: #fa4d56;
  --cds-tag-border-blue: #4589ff;
  --cds-tag-border-cyan: #1192e8;
  --cds-tag-border-teal: #009d9a;
  --cds-tag-border-green: #24a148;
  --cds-tag-border-magenta: #ee5396;
  --cds-tag-border-purple: #a56eff;
  --cds-tag-border-gray: #8d8d8d;
  --cds-tag-border-cool-gray: #878d96;
  --cds-tag-border-warm-gray: #8f8b8b;
  --cds-tag-background-cool-gray: #4d5358;
  --cds-tag-color-cool-gray: #f2f4f8;
  --cds-tag-hover-cool-gray: #5d646a;
  --cds-tag-background-warm-gray: #565151;
  --cds-tag-color-warm-gray: #f7f3f2;
  --cds-tag-hover-warm-gray: #696363;
  --cds-status-red: #fa4d56;
  --cds-status-orange: #ff832b;
  --cds-status-orange-outline: #ff832b;
  --cds-status-yellow: #f1c21b;
  --cds-status-yellow-outline: #f1c21b;
  --cds-status-green: #42be65;
  --cds-status-blue: #4589ff;
  --cds-status-purple: #a56eff;
  --cds-status-gray: #8d8d8d;
  --cds-notification-background-error: #262626;
  --cds-notification-background-success: #262626;
  --cds-notification-background-info: #262626;
  --cds-notification-background-warning: #262626;
  --cds-notification-action-hover: var(--cds-layer-hover);
  --cds-notification-action-tertiary-inverse: #0f62fe;
  --cds-notification-action-tertiary-inverse-active: #002d9c;
  --cds-notification-action-tertiary-inverse-hover: #0050e6;
  --cds-notification-action-tertiary-inverse-text: #ffffff;
  --cds-notification-action-tertiary-inverse-text-on-color-disabled: #8d8d8d;
  --cds-content-switcher-background: rgba(0, 0, 0, 0);
  --cds-content-switcher-background-hover: rgba(141, 141, 141, 0.12);
  --cds-content-switcher-selected: rgba(141, 141, 141, 0.24);
  color-scheme: light;
  color-scheme: var(--cds-color-scheme, light);
}
@media screen and (-ms-high-contrast: active), (forced-colors: active) {
  :is(.dark *),
  :root:is(.dark) {
    --cds-icon-primary: ButtonText;
    --cds-icon-secondary: ButtonText;
    --cds-icon-interactive: ButtonText;
    --cds-icon-disabled: GrayText;
    --cds-icon-on-color-disabled: GrayText;
    --cds-icon-inverse: SelectedItemText;
    --cds-icon-on-color: SelectedItemText;
    --cds-button-disabled: GrayText;
    --cds-interactive: ButtonText;
    --cds-link-primary: LinkText;
    --cds-link-primary-hover: LinkText;
    --cds-link-secondary: LinkText;
    --cds-link-inverse: SelectedItemText;
    --cds-link-inverse-hover: SelectedItemText;
    --cds-link-inverse-visited: SelectedItemText;
    --cds-link-visited: VisitedText;
    --cds-background-selected: SelectedItem;
    --cds-background-selected-hover: SelectedItem;
    --cds-background-inverse: SelectedItem;
    --cds-layer-selected-inverse: SelectedItem;
  }
}
:is(.dark *),
:root:is(.dark) {
  --cds-layer: var(--cds-layer-01, #f4f4f4);
  --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
  --cds-layer-background: var(--cds-layer-background-01, #ffffff);
  --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
  --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
  --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
  --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
  --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
  --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
  --cds-field: var(--cds-field-01, #f4f4f4);
  --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
  --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
  --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
  --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
  --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
  --cds-background: #0a0a0a;
  --cds-layer-01: #161616;
  --cds-focus: #4589ff;
  --cds-border-interactive: #4589ff;
  --cds-interactive: #4589ff;
  --cds-link-primary: #4589ff;
  --cds-link-primary-hover: color-mix(in oklab, #4589ff 80%, white);
  --cds-button-primary: #0f62fe;
  --cds-button-primary-hover: #0353e9;
  --cds-button-tertiary: #4589ff;
  --cds-button-tertiary-hover: #4589ff;
}

@media (prefers-color-scheme: dark) {
  :root:not(.light) {
    --cds-ai-aura-end: rgba(0, 0, 0, 0);
    --cds-ai-aura-hover-background: #333333;
    --cds-ai-aura-hover-end: rgba(0, 0, 0, 0);
    --cds-ai-aura-hover-start: rgba(69, 137, 255, 0.4);
    --cds-ai-aura-start: rgba(69, 137, 255, 0.1);
    --cds-ai-aura-start-sm: rgba(69, 137, 255, 0.16);
    --cds-ai-border-end: #4589ff;
    --cds-ai-border-start: rgba(166, 200, 255, 0.36);
    --cds-ai-border-strong: #78a9ff;
    --cds-ai-drop-shadow: rgba(0, 0, 0, 0.28);
    --cds-ai-inner-shadow: rgba(69, 137, 255, 0.16);
    --cds-ai-overlay: rgba(0, 0, 0, 0.5);
    --cds-ai-popover-background: #161616;
    --cds-ai-popover-caret-bottom: #4589ff;
    --cds-ai-popover-caret-bottom-background: #202d45;
    --cds-ai-popover-caret-bottom-background-actions: #1e283a;
    --cds-ai-popover-caret-center: #4870b5;
    --cds-ai-popover-shadow-outer-01: rgba(0, 0, 0, 0.12);
    --cds-ai-popover-shadow-outer-02: rgba(0, 0, 0, 0.08);
    --cds-ai-skeleton-background: rgba(120, 169, 255, 0.5);
    --cds-ai-skeleton-element-background: rgba(120, 169, 255, 0.3);
    --cds-background: #161616;
    --cds-background-active: rgba(141, 141, 141, 0.4);
    --cds-background-brand: #0f62fe;
    --cds-background-hover: rgba(141, 141, 141, 0.16);
    --cds-background-inverse: #f4f4f4;
    --cds-background-inverse-hover: #e8e8e8;
    --cds-background-selected: rgba(141, 141, 141, 0.24);
    --cds-background-selected-hover: rgba(141, 141, 141, 0.32);
    --cds-border-disabled: rgba(141, 141, 141, 0.5);
    --cds-border-interactive: #4589ff;
    --cds-border-inverse: #f4f4f4;
    --cds-border-strong-01: #6f6f6f;
    --cds-border-strong-02: #8d8d8d;
    --cds-border-strong-03: #a8a8a8;
    --cds-border-subtle-00: #393939;
    --cds-border-subtle-01: #525252;
    --cds-border-subtle-02: #6f6f6f;
    --cds-border-subtle-03: #6f6f6f;
    --cds-border-subtle-selected-01: #6f6f6f;
    --cds-border-subtle-selected-02: #8d8d8d;
    --cds-border-subtle-selected-03: #8d8d8d;
    --cds-border-tile-01: #525252;
    --cds-border-tile-02: #6f6f6f;
    --cds-border-tile-03: #8d8d8d;
    --cds-chat-avatar-agent: #c6c6c6;
    --cds-chat-avatar-bot: #8d8d8d;
    --cds-chat-avatar-user: #4589ff;
    --cds-chat-bubble-agent: #262626;
    --cds-chat-bubble-agent-text: #f4f4f4;
    --cds-chat-bubble-border: #525252;
    --cds-chat-bubble-user: #393939;
    --cds-chat-bubble-user-text: #f4f4f4;
    --cds-chat-button: #78a9ff;
    --cds-chat-button-active: rgba(141, 141, 141, 0.4);
    --cds-chat-button-hover: rgba(141, 141, 141, 0.16);
    --cds-chat-button-selected: rgba(141, 141, 141, 0.24);
    --cds-chat-button-text-hover: #a6c8ff;
    --cds-chat-button-text-selected: #c6c6c6;
    --cds-chat-header-background: #262626;
    --cds-chat-header-text: #f4f4f4;
    --cds-chat-prompt-background: #161616;
    --cds-chat-prompt-border-end: rgba(38, 38, 38, 0);
    --cds-chat-prompt-border-start: #262626;
    --cds-chat-prompt-text: #f4f4f4;
    --cds-chat-shell-background: #262626;
    --cds-color-scheme: dark;
    --cds-field-01: #262626;
    --cds-field-02: #393939;
    --cds-field-03: #525252;
    --cds-field-hover-01: #333333;
    --cds-field-hover-02: #474747;
    --cds-field-hover-03: #636363;
    --cds-focus: #ffffff;
    --cds-focus-inset: #161616;
    --cds-focus-inverse: #0f62fe;
    --cds-highlight: #001d6c;
    --cds-icon-disabled: rgba(244, 244, 244, 0.25);
    --cds-icon-interactive: #ffffff;
    --cds-icon-inverse: #161616;
    --cds-icon-on-color: #ffffff;
    --cds-icon-on-color-disabled: rgba(255, 255, 255, 0.25);
    --cds-icon-primary: #f4f4f4;
    --cds-icon-secondary: #c6c6c6;
    --cds-interactive: #4589ff;
    --cds-layer-01: #262626;
    --cds-layer-02: #393939;
    --cds-layer-03: #525252;
    --cds-layer-accent-01: #393939;
    --cds-layer-accent-02: #525252;
    --cds-layer-accent-03: #6f6f6f;
    --cds-layer-accent-active-01: #6f6f6f;
    --cds-layer-accent-active-02: #8d8d8d;
    --cds-layer-accent-active-03: #393939;
    --cds-layer-accent-hover-01: #474747;
    --cds-layer-accent-hover-02: #636363;
    --cds-layer-accent-hover-03: #5e5e5e;
    --cds-layer-active-01: #525252;
    --cds-layer-active-02: #6f6f6f;
    --cds-layer-active-03: #8d8d8d;
    --cds-layer-background-01: #161616;
    --cds-layer-background-02: #262626;
    --cds-layer-background-03: #393939;
    --cds-layer-hover-01: #333333;
    --cds-layer-hover-02: #474747;
    --cds-layer-hover-03: #636363;
    --cds-layer-selected-01: #393939;
    --cds-layer-selected-02: #525252;
    --cds-layer-selected-03: #6f6f6f;
    --cds-layer-selected-disabled: #a8a8a8;
    --cds-layer-selected-hover-01: #474747;
    --cds-layer-selected-hover-02: #636363;
    --cds-layer-selected-hover-03: #5e5e5e;
    --cds-layer-selected-inverse: #f4f4f4;
    --cds-link-inverse: #0f62fe;
    --cds-link-inverse-active: #161616;
    --cds-link-inverse-hover: #0043ce;
    --cds-link-inverse-visited: #8a3ffc;
    --cds-link-primary: #78a9ff;
    --cds-link-primary-hover: #a6c8ff;
    --cds-link-secondary: #a6c8ff;
    --cds-link-visited: #be95ff;
    --cds-overlay: rgba(0, 0, 0, 0.6);
    --cds-shadow: rgba(0, 0, 0, 0.8);
    --cds-skeleton-background: #292929;
    --cds-skeleton-element: #393939;
    --cds-support-caution-major: #ff832b;
    --cds-support-caution-minor: #f1c21b;
    --cds-support-caution-undefined: #a56eff;
    --cds-support-error: #fa4d56;
    --cds-support-error-inverse: #da1e28;
    --cds-support-info: #4589ff;
    --cds-support-info-inverse: #0043ce;
    --cds-support-success: #42be65;
    --cds-support-success-inverse: #24a148;
    --cds-support-warning: #f1c21b;
    --cds-support-warning-inverse: #f1c21b;
    --cds-syntax-angle-bracket: #8d8d8d;
    --cds-syntax-annotation: #08bdba;
    --cds-syntax-arithmetic-operator: #e0e0e0;
    --cds-syntax-atom: #f4f4f4;
    --cds-syntax-attribute: #33b1ff;
    --cds-syntax-attribute-name: #33b1ff;
    --cds-syntax-attribute-value: #f4f4f4;
    --cds-syntax-bitwise-operator: #e0e0e0;
    --cds-syntax-block-comment: #42be65;
    --cds-syntax-bool: #f4f4f4;
    --cds-syntax-brace: #e0e0e0;
    --cds-syntax-bracket: #e0e0e0;
    --cds-syntax-character: #f4f4f4;
    --cds-syntax-class-name: #3ddbd9;
    --cds-syntax-color: #f4f4f4;
    --cds-syntax-comment: #42be65;
    --cds-syntax-compare-operator: #e0e0e0;
    --cds-syntax-constant: #4589ff;
    --cds-syntax-content: #f4f4f4;
    --cds-syntax-content-separator: #e0e0e0;
    --cds-syntax-control-keyword: #be95ff;
    --cds-syntax-control-operator: #be95ff;
    --cds-syntax-definition: #33b1ff;
    --cds-syntax-definition-keyword: #33b1ff;
    --cds-syntax-definition-operator: #33b1ff;
    --cds-syntax-deref-operator: #e0e0e0;
    --cds-syntax-doc-comment: #42be65;
    --cds-syntax-doc-string: #f4f4f4;
    --cds-syntax-document-meta: #42be65;
    --cds-syntax-emphasis: #f4f4f4;
    --cds-syntax-escape: #e0e0e0;
    --cds-syntax-float: #6fdc8c;
    --cds-syntax-function: #f1c21b;
    --cds-syntax-heading: #33b1ff;
    --cds-syntax-heading-1: #33b1ff;
    --cds-syntax-heading-2: #33b1ff;
    --cds-syntax-heading-3: #33b1ff;
    --cds-syntax-heading-4: #33b1ff;
    --cds-syntax-heading-5: #33b1ff;
    --cds-syntax-heading-6: #33b1ff;
    --cds-syntax-integer: #6fdc8c;
    --cds-syntax-invalid: #fa4d56;
    --cds-syntax-keyword: #4589ff;
    --cds-syntax-label-name: #a6c8ff;
    --cds-syntax-line-comment: #42be65;
    --cds-syntax-link: #4589ff;
    --cds-syntax-list: #f4f4f4;
    --cds-syntax-literal: #f4f4f4;
    --cds-syntax-local: #a6c8ff;
    --cds-syntax-logic-operator: #e0e0e0;
    --cds-syntax-macro-name: #f4f4f4;
    --cds-syntax-meta: #42be65;
    --cds-syntax-modifier: #4589ff;
    --cds-syntax-module-keyword: #be95ff;
    --cds-syntax-monospace: #f4f4f4;
    --cds-syntax-name: #a6c8ff;
    --cds-syntax-namespace: #3ddbd9;
    --cds-syntax-null: #f4f4f4;
    --cds-syntax-number: #6fdc8c;
    --cds-syntax-operator: #e0e0e0;
    --cds-syntax-operator-keyword: #4589ff;
    --cds-syntax-paren: #e0e0e0;
    --cds-syntax-processing-instruction: #f4f4f4;
    --cds-syntax-property-name: #33b1ff;
    --cds-syntax-punctuation: #e0e0e0;
    --cds-syntax-quote: #42be65;
    --cds-syntax-regexp: #be95ff;
    --cds-syntax-self: #3ddbd9;
    --cds-syntax-separator: #e0e0e0;
    --cds-syntax-special: #4589ff;
    --cds-syntax-special-string: #be95ff;
    --cds-syntax-square-bracket: #e0e0e0;
    --cds-syntax-standard: #4589ff;
    --cds-syntax-strikethrough: #f4f4f4;
    --cds-syntax-string: #f4f4f4;
    --cds-syntax-strong: #f4f4f4;
    --cds-syntax-tag: #3ddbd9;
    --cds-syntax-tag-name: #3ddbd9;
    --cds-syntax-type: #3ddbd9;
    --cds-syntax-type-name: #3ddbd9;
    --cds-syntax-type-operator: #3ddbd9;
    --cds-syntax-unit: #6fdc8c;
    --cds-syntax-update-operator: #e0e0e0;
    --cds-syntax-url: #e0e0e0;
    --cds-syntax-variable: #a6c8ff;
    --cds-syntax-variable-name: #a6c8ff;
    --cds-text-disabled: rgba(244, 244, 244, 0.25);
    --cds-text-error: #ff8389;
    --cds-text-helper: #a8a8a8;
    --cds-text-inverse: #161616;
    --cds-text-on-color: #ffffff;
    --cds-text-on-color-disabled: rgba(255, 255, 255, 0.25);
    --cds-text-placeholder: rgba(244, 244, 244, 0.4);
    --cds-text-primary: #f4f4f4;
    --cds-text-secondary: #c6c6c6;
    --cds-toggle-off: #6f6f6f;
    --cds-spacing-01: 0.125rem;
    --cds-spacing-02: 0.25rem;
    --cds-spacing-03: 0.5rem;
    --cds-spacing-04: 0.75rem;
    --cds-spacing-05: 1rem;
    --cds-spacing-06: 1.5rem;
    --cds-spacing-07: 2rem;
    --cds-spacing-08: 2.5rem;
    --cds-spacing-09: 3rem;
    --cds-spacing-10: 4rem;
    --cds-spacing-11: 5rem;
    --cds-spacing-12: 6rem;
    --cds-spacing-13: 10rem;
    --cds-fluid-spacing-01: 0;
    --cds-fluid-spacing-02: 2vw;
    --cds-fluid-spacing-03: 5vw;
    --cds-fluid-spacing-04: 10vw;
    --cds-caption-01-font-size: 0.75rem;
    --cds-caption-01-font-weight: 400;
    --cds-caption-01-line-height: 1.33333;
    --cds-caption-01-letter-spacing: 0.32px;
    --cds-caption-02-font-size: 0.875rem;
    --cds-caption-02-font-weight: 400;
    --cds-caption-02-line-height: 1.28572;
    --cds-caption-02-letter-spacing: 0.32px;
    --cds-label-01-font-size: 0.75rem;
    --cds-label-01-font-weight: 400;
    --cds-label-01-line-height: 1.33333;
    --cds-label-01-letter-spacing: 0.32px;
    --cds-label-02-font-size: 0.875rem;
    --cds-label-02-font-weight: 400;
    --cds-label-02-line-height: 1.28572;
    --cds-label-02-letter-spacing: 0.16px;
    --cds-helper-text-01-font-size: 0.75rem;
    --cds-helper-text-01-line-height: 1.33333;
    --cds-helper-text-01-letter-spacing: 0.32px;
    --cds-helper-text-02-font-size: 0.875rem;
    --cds-helper-text-02-font-weight: 400;
    --cds-helper-text-02-line-height: 1.28572;
    --cds-helper-text-02-letter-spacing: 0.16px;
    --cds-body-short-01-font-size: 0.875rem;
    --cds-body-short-01-font-weight: 400;
    --cds-body-short-01-line-height: 1.28572;
    --cds-body-short-01-letter-spacing: 0.16px;
    --cds-body-short-02-font-size: 1rem;
    --cds-body-short-02-font-weight: 400;
    --cds-body-short-02-line-height: 1.375;
    --cds-body-short-02-letter-spacing: 0;
    --cds-body-long-01-font-size: 0.875rem;
    --cds-body-long-01-font-weight: 400;
    --cds-body-long-01-line-height: 1.42857;
    --cds-body-long-01-letter-spacing: 0.16px;
    --cds-body-long-02-font-size: 1rem;
    --cds-body-long-02-font-weight: 400;
    --cds-body-long-02-line-height: 1.5;
    --cds-body-long-02-letter-spacing: 0;
    --cds-code-01-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
    --cds-code-01-font-size: 0.75rem;
    --cds-code-01-font-weight: 400;
    --cds-code-01-line-height: 1.33333;
    --cds-code-01-letter-spacing: 0.32px;
    --cds-code-02-font-family: 'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace;
    --cds-code-02-font-size: 0.875rem;
    --cds-code-02-font-weight: 400;
    --cds-code-02-line-height: 1.42857;
    --cds-code-02-letter-spacing: 0.32px;
    --cds-heading-01-font-size: 0.875rem;
    --cds-heading-01-font-weight: 600;
    --cds-heading-01-line-height: 1.42857;
    --cds-heading-01-letter-spacing: 0.16px;
    --cds-heading-02-font-size: 1rem;
    --cds-heading-02-font-weight: 600;
    --cds-heading-02-line-height: 1.5;
    --cds-heading-02-letter-spacing: 0;
    --cds-productive-heading-01-font-size: 0.875rem;
    --cds-productive-heading-01-font-weight: 600;
    --cds-productive-heading-01-line-height: 1.28572;
    --cds-productive-heading-01-letter-spacing: 0.16px;
    --cds-productive-heading-02-font-size: 1rem;
    --cds-productive-heading-02-font-weight: 600;
    --cds-productive-heading-02-line-height: 1.375;
    --cds-productive-heading-02-letter-spacing: 0;
    --cds-productive-heading-03-font-size: 1.25rem;
    --cds-productive-heading-03-font-weight: 400;
    --cds-productive-heading-03-line-height: 1.4;
    --cds-productive-heading-03-letter-spacing: 0;
    --cds-productive-heading-04-font-size: 1.75rem;
    --cds-productive-heading-04-font-weight: 400;
    --cds-productive-heading-04-line-height: 1.28572;
    --cds-productive-heading-04-letter-spacing: 0;
    --cds-productive-heading-05-font-size: 2rem;
    --cds-productive-heading-05-font-weight: 400;
    --cds-productive-heading-05-line-height: 1.25;
    --cds-productive-heading-05-letter-spacing: 0;
    --cds-productive-heading-06-font-size: 2.625rem;
    --cds-productive-heading-06-font-weight: 300;
    --cds-productive-heading-06-line-height: 1.199;
    --cds-productive-heading-06-letter-spacing: 0;
    --cds-productive-heading-07-font-size: 3.375rem;
    --cds-productive-heading-07-font-weight: 300;
    --cds-productive-heading-07-line-height: 1.19;
    --cds-productive-heading-07-letter-spacing: 0;
    --cds-expressive-paragraph-01-font-size: 1.5rem;
    --cds-expressive-paragraph-01-font-weight: 300;
    --cds-expressive-paragraph-01-line-height: 1.334;
    --cds-expressive-paragraph-01-letter-spacing: 0;
    --cds-expressive-heading-01-font-size: 0.875rem;
    --cds-expressive-heading-01-font-weight: 600;
    --cds-expressive-heading-01-line-height: 1.42857;
    --cds-expressive-heading-01-letter-spacing: 0.16px;
    --cds-expressive-heading-02-font-size: 1rem;
    --cds-expressive-heading-02-font-weight: 600;
    --cds-expressive-heading-02-line-height: 1.5;
    --cds-expressive-heading-02-letter-spacing: 0;
    --cds-expressive-heading-03-font-size: 1.25rem;
    --cds-expressive-heading-03-font-weight: 400;
    --cds-expressive-heading-03-line-height: 1.4;
    --cds-expressive-heading-03-letter-spacing: 0;
    --cds-expressive-heading-04-font-size: 1.75rem;
    --cds-expressive-heading-04-font-weight: 400;
    --cds-expressive-heading-04-line-height: 1.28572;
    --cds-expressive-heading-04-letter-spacing: 0;
    --cds-expressive-heading-05-font-size: 2rem;
    --cds-expressive-heading-05-font-weight: 400;
    --cds-expressive-heading-05-line-height: 1.25;
    --cds-expressive-heading-05-letter-spacing: 0;
    --cds-expressive-heading-06-font-size: 2rem;
    --cds-expressive-heading-06-font-weight: 600;
    --cds-expressive-heading-06-line-height: 1.25;
    --cds-expressive-heading-06-letter-spacing: 0;
    --cds-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
    --cds-quotation-01-font-size: 1.25rem;
    --cds-quotation-01-font-weight: 400;
    --cds-quotation-01-line-height: 1.3;
    --cds-quotation-01-letter-spacing: 0;
    --cds-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
    --cds-quotation-02-font-size: 2rem;
    --cds-quotation-02-font-weight: 300;
    --cds-quotation-02-line-height: 1.25;
    --cds-quotation-02-letter-spacing: 0;
    --cds-display-01-font-size: 2.625rem;
    --cds-display-01-font-weight: 300;
    --cds-display-01-line-height: 1.19;
    --cds-display-01-letter-spacing: 0;
    --cds-display-02-font-size: 2.625rem;
    --cds-display-02-font-weight: 600;
    --cds-display-02-line-height: 1.19;
    --cds-display-02-letter-spacing: 0;
    --cds-display-03-font-size: 2.625rem;
    --cds-display-03-font-weight: 300;
    --cds-display-03-line-height: 1.19;
    --cds-display-03-letter-spacing: 0;
    --cds-display-04-font-size: 2.625rem;
    --cds-display-04-font-weight: 300;
    --cds-display-04-line-height: 1.19;
    --cds-display-04-letter-spacing: 0;
    --cds-legal-01-font-size: 0.75rem;
    --cds-legal-01-font-weight: 400;
    --cds-legal-01-line-height: 1.33333;
    --cds-legal-01-letter-spacing: 0.32px;
    --cds-legal-02-font-size: 0.875rem;
    --cds-legal-02-font-weight: 400;
    --cds-legal-02-line-height: 1.28572;
    --cds-legal-02-letter-spacing: 0.16px;
    --cds-body-compact-01-font-size: 0.875rem;
    --cds-body-compact-01-font-weight: 400;
    --cds-body-compact-01-line-height: 1.28572;
    --cds-body-compact-01-letter-spacing: 0.16px;
    --cds-body-compact-02-font-size: 1rem;
    --cds-body-compact-02-font-weight: 400;
    --cds-body-compact-02-line-height: 1.375;
    --cds-body-compact-02-letter-spacing: 0;
    --cds-heading-compact-01-font-size: 0.875rem;
    --cds-heading-compact-01-font-weight: 600;
    --cds-heading-compact-01-line-height: 1.28572;
    --cds-heading-compact-01-letter-spacing: 0.16px;
    --cds-heading-compact-02-font-size: 1rem;
    --cds-heading-compact-02-font-weight: 600;
    --cds-heading-compact-02-line-height: 1.375;
    --cds-heading-compact-02-letter-spacing: 0;
    --cds-body-01-font-size: 0.875rem;
    --cds-body-01-font-weight: 400;
    --cds-body-01-line-height: 1.42857;
    --cds-body-01-letter-spacing: 0.16px;
    --cds-body-02-font-size: 1rem;
    --cds-body-02-font-weight: 400;
    --cds-body-02-line-height: 1.5;
    --cds-body-02-letter-spacing: 0;
    --cds-heading-03-font-size: 1.25rem;
    --cds-heading-03-font-weight: 400;
    --cds-heading-03-line-height: 1.4;
    --cds-heading-03-letter-spacing: 0;
    --cds-heading-04-font-size: 1.75rem;
    --cds-heading-04-font-weight: 400;
    --cds-heading-04-line-height: 1.28572;
    --cds-heading-04-letter-spacing: 0;
    --cds-heading-05-font-size: 2rem;
    --cds-heading-05-font-weight: 400;
    --cds-heading-05-line-height: 1.25;
    --cds-heading-05-letter-spacing: 0;
    --cds-heading-06-font-size: 2.625rem;
    --cds-heading-06-font-weight: 300;
    --cds-heading-06-line-height: 1.199;
    --cds-heading-06-letter-spacing: 0;
    --cds-heading-07-font-size: 3.375rem;
    --cds-heading-07-font-weight: 300;
    --cds-heading-07-line-height: 1.19;
    --cds-heading-07-letter-spacing: 0;
    --cds-fluid-heading-03-font-size: 1.25rem;
    --cds-fluid-heading-03-font-weight: 400;
    --cds-fluid-heading-03-line-height: 1.4;
    --cds-fluid-heading-03-letter-spacing: 0;
    --cds-fluid-heading-04-font-size: 1.75rem;
    --cds-fluid-heading-04-font-weight: 400;
    --cds-fluid-heading-04-line-height: 1.28572;
    --cds-fluid-heading-04-letter-spacing: 0;
    --cds-fluid-heading-05-font-size: 2rem;
    --cds-fluid-heading-05-font-weight: 400;
    --cds-fluid-heading-05-line-height: 1.25;
    --cds-fluid-heading-05-letter-spacing: 0;
    --cds-fluid-heading-06-font-size: 2rem;
    --cds-fluid-heading-06-font-weight: 600;
    --cds-fluid-heading-06-line-height: 1.25;
    --cds-fluid-heading-06-letter-spacing: 0;
    --cds-fluid-paragraph-01-font-size: 1.5rem;
    --cds-fluid-paragraph-01-font-weight: 300;
    --cds-fluid-paragraph-01-line-height: 1.334;
    --cds-fluid-paragraph-01-letter-spacing: 0;
    --cds-fluid-quotation-01-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
    --cds-fluid-quotation-01-font-size: 1.25rem;
    --cds-fluid-quotation-01-font-weight: 400;
    --cds-fluid-quotation-01-line-height: 1.3;
    --cds-fluid-quotation-01-letter-spacing: 0;
    --cds-fluid-quotation-02-font-family: 'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif;
    --cds-fluid-quotation-02-font-size: 2rem;
    --cds-fluid-quotation-02-font-weight: 300;
    --cds-fluid-quotation-02-line-height: 1.25;
    --cds-fluid-quotation-02-letter-spacing: 0;
    --cds-fluid-display-01-font-size: 2.625rem;
    --cds-fluid-display-01-font-weight: 300;
    --cds-fluid-display-01-line-height: 1.19;
    --cds-fluid-display-01-letter-spacing: 0;
    --cds-fluid-display-02-font-size: 2.625rem;
    --cds-fluid-display-02-font-weight: 600;
    --cds-fluid-display-02-line-height: 1.19;
    --cds-fluid-display-02-letter-spacing: 0;
    --cds-fluid-display-03-font-size: 2.625rem;
    --cds-fluid-display-03-font-weight: 300;
    --cds-fluid-display-03-line-height: 1.19;
    --cds-fluid-display-03-letter-spacing: 0;
    --cds-fluid-display-04-font-size: 2.625rem;
    --cds-fluid-display-04-font-weight: 300;
    --cds-fluid-display-04-line-height: 1.19;
    --cds-fluid-display-04-letter-spacing: 0;
    --cds-button-separator: #161616;
    --cds-button-primary: #0f62fe;
    --cds-button-secondary: #6f6f6f;
    --cds-button-tertiary: #ffffff;
    --cds-button-danger-primary: #da1e28;
    --cds-button-danger-secondary: #fa4d56;
    --cds-button-danger-active: #750e13;
    --cds-button-primary-active: #002d9c;
    --cds-button-secondary-active: #393939;
    --cds-button-tertiary-active: #c6c6c6;
    --cds-button-danger-hover: #b81921;
    --cds-button-primary-hover: #0050e6;
    --cds-button-secondary-hover: #5e5e5e;
    --cds-button-tertiary-hover: #f4f4f4;
    --cds-button-disabled: rgba(141, 141, 141, 0.3);
    --cds-tag-background-red: #a2191f;
    --cds-tag-color-red: #ffd7d9;
    --cds-tag-hover-red: #c21e25;
    --cds-tag-background-magenta: #9f1853;
    --cds-tag-color-magenta: #ffd6e8;
    --cds-tag-hover-magenta: #bf1d63;
    --cds-tag-background-purple: #6929c4;
    --cds-tag-color-purple: #e8daff;
    --cds-tag-hover-purple: #7c3dd6;
    --cds-tag-background-blue: #0043ce;
    --cds-tag-color-blue: #d0e2ff;
    --cds-tag-hover-blue: #0053ff;
    --cds-tag-background-cyan: #00539a;
    --cds-tag-color-cyan: #bae6ff;
    --cds-tag-hover-cyan: #0066bd;
    --cds-tag-background-teal: #005d5d;
    --cds-tag-color-teal: #9ef0f0;
    --cds-tag-hover-teal: #007070;
    --cds-tag-background-green: #0e6027;
    --cds-tag-color-green: #a7f0ba;
    --cds-tag-hover-green: #11742f;
    --cds-tag-background-gray: #525252;
    --cds-tag-color-gray: #f4f4f4;
    --cds-tag-hover-gray: #636363;
    --cds-tag-border-red: #fa4d56;
    --cds-tag-border-blue: #4589ff;
    --cds-tag-border-cyan: #1192e8;
    --cds-tag-border-teal: #009d9a;
    --cds-tag-border-green: #24a148;
    --cds-tag-border-magenta: #ee5396;
    --cds-tag-border-purple: #a56eff;
    --cds-tag-border-gray: #8d8d8d;
    --cds-tag-border-cool-gray: #878d96;
    --cds-tag-border-warm-gray: #8f8b8b;
    --cds-tag-background-cool-gray: #4d5358;
    --cds-tag-color-cool-gray: #f2f4f8;
    --cds-tag-hover-cool-gray: #5d646a;
    --cds-tag-background-warm-gray: #565151;
    --cds-tag-color-warm-gray: #f7f3f2;
    --cds-tag-hover-warm-gray: #696363;
    --cds-status-red: #fa4d56;
    --cds-status-orange: #ff832b;
    --cds-status-orange-outline: #ff832b;
    --cds-status-yellow: #f1c21b;
    --cds-status-yellow-outline: #f1c21b;
    --cds-status-green: #42be65;
    --cds-status-blue: #4589ff;
    --cds-status-purple: #a56eff;
    --cds-status-gray: #8d8d8d;
    --cds-notification-background-error: #262626;
    --cds-notification-background-success: #262626;
    --cds-notification-background-info: #262626;
    --cds-notification-background-warning: #262626;
    --cds-notification-action-hover: var(--cds-layer-hover);
    --cds-notification-action-tertiary-inverse: #0f62fe;
    --cds-notification-action-tertiary-inverse-active: #002d9c;
    --cds-notification-action-tertiary-inverse-hover: #0050e6;
    --cds-notification-action-tertiary-inverse-text: #ffffff;
    --cds-notification-action-tertiary-inverse-text-on-color-disabled: #8d8d8d;
    --cds-content-switcher-background: rgba(0, 0, 0, 0);
    --cds-content-switcher-background-hover: rgba(141, 141, 141, 0.12);
    --cds-content-switcher-selected: rgba(141, 141, 141, 0.24);
    color-scheme: light;
    color-scheme: var(--cds-color-scheme, light);
    --cds-layer: var(--cds-layer-01, #f4f4f4);
    --cds-layer-active: var(--cds-layer-active-01, #c6c6c6);
    --cds-layer-background: var(--cds-layer-background-01, #ffffff);
    --cds-layer-hover: var(--cds-layer-hover-01, #e8e8e8);
    --cds-layer-selected: var(--cds-layer-selected-01, #e0e0e0);
    --cds-layer-selected-hover: var(--cds-layer-selected-hover-01, #d1d1d1);
    --cds-layer-accent: var(--cds-layer-accent-01, #e0e0e0);
    --cds-layer-accent-hover: var(--cds-layer-accent-hover-01, #d1d1d1);
    --cds-layer-accent-active: var(--cds-layer-accent-active-01, #a8a8a8);
    --cds-field: var(--cds-field-01, #f4f4f4);
    --cds-field-hover: var(--cds-field-hover-01, #e8e8e8);
    --cds-border-subtle: var(--cds-border-subtle-00, #e0e0e0);
    --cds-border-subtle-selected: var(--cds-border-subtle-selected-01, #c6c6c6);
    --cds-border-strong: var(--cds-border-strong-01, #8d8d8d);
    --cds-border-tile: var(--cds-border-tile-01, #c6c6c6);
    --cds-background: #0a0a0a;
    --cds-layer-01: #161616;
    --cds-focus: #4589ff;
    --cds-border-interactive: #4589ff;
    --cds-interactive: #4589ff;
    --cds-link-primary: #4589ff;
    --cds-button-primary: #0f62fe;
    --cds-button-primary-hover: #0353e9;
    --cds-button-tertiary: #4589ff;
    --cds-button-tertiary-hover: #4589ff;
  }

@supports (color: color-mix(in oklch, #000, #fff)){
:root:not(.light) {
    --cds-link-primary-hover: color-mix(in oklab, #4589ff 80%, white);
  }
}
}
@media screen and (prefers-color-scheme: dark) and (-ms-high-contrast: active), (prefers-color-scheme: dark) and (forced-colors: active) {
  :root:not(.light) {
    --cds-icon-primary: ButtonText;
    --cds-icon-secondary: ButtonText;
    --cds-icon-interactive: ButtonText;
    --cds-icon-disabled: GrayText;
    --cds-icon-on-color-disabled: GrayText;
    --cds-icon-inverse: SelectedItemText;
    --cds-icon-on-color: SelectedItemText;
    --cds-button-disabled: GrayText;
    --cds-interactive: ButtonText;
    --cds-link-primary: LinkText;
    --cds-link-primary-hover: LinkText;
    --cds-link-secondary: LinkText;
    --cds-link-inverse: SelectedItemText;
    --cds-link-inverse-hover: SelectedItemText;
    --cds-link-inverse-visited: SelectedItemText;
    --cds-link-visited: VisitedText;
    --cds-background-selected: SelectedItem;
    --cds-background-selected-hover: SelectedItem;
    --cds-background-inverse: SelectedItem;
    --cds-layer-selected-inverse: SelectedItem;
  }
}
.cds--table-toolbar {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--cds-border-subtle);
}

.cds--table-header-label {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
}

.cds--switcher__item--divider:has(> span) {
  display: flex;
  align-items: center;
  height: auto;
  padding: 1rem 1rem 0.5rem;
  margin: 0;
  background: none;
  border-top: none;
  border-bottom: 1px solid #e0e0e0;
  border-bottom: 1px solid var(--cds-border-subtle);
  block-size: auto;
  inline-size: 100%;
}
.cds--switcher__item--divider:has(> span) span {
  font-size: 0.625rem;
  font-weight: 500;
  color: #525252;
  color: var(--cds-text-secondary);
  letter-spacing: 0.1em;
  text-transform: capitalize;
  text-align: left;
  width: 100%;
}

.project-selector-dropdown {
  display: flex;
  align-items: center;
  align-self: center;
  min-width: 180px;
  -webkit-border-start: none;
          border-inline-start: none;
  position: relative;
}
.project-selector-dropdown .cds--dropdown,
.project-selector-dropdown .cds--list-box__wrapper {
  position: static;
}
.project-selector-dropdown .cds--list-box {
  border: none;
  height: 3rem;
  max-height: 3rem;
  background-color: transparent;
}
.project-selector-dropdown .cds--list-box__menu {
  position: absolute;
  top: 3rem;
  left: 0;
  z-index: 9000;
}
.project-selector-dropdown .cds--list-box__field {
  height: 3rem;
  -webkit-padding-start: 1rem;
          padding-inline-start: 1rem;
  -webkit-padding-end: 2.5rem;
          padding-inline-end: 2.5rem;
}
.project-selector-dropdown .cds--list-box__label {
  font-size: 0.875rem;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.project-selector-dropdown .cds--list-box__menu-icon {
  right: 0.75rem;
}
.project-selector-dropdown .cds--list-box__menu-item {
  height: 2.5rem;
}
.project-selector-dropdown .cds--list-box__menu-item__option {
  padding-block: 0.625rem;
}
.project-selector-dropdown .cds--list-box:hover {
  background-color: rgba(141, 141, 141, 0.12);
  background-color: var(--cds-background-hover);
}
.project-selector-dropdown .cds--list-box--expanded .cds--list-box__field {
  border-bottom: 2px solid var(--color-primary);
  border-bottom: 2px solid var(--cds-border-interactive);
}

.notice-link-style .cds--actionable-notification__action-button {
  background: none !important;
  border: none !important;
  padding: 0 !important;
  min-height: auto !important;
  color: var(--color-primary) !important;
  color: var(--cds-link-primary) !important;
  font-weight: 600;
  font-size: 0.875rem;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.notice-link-style .cds--actionable-notification__action-button:hover {
  background: none !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  text-decoration: none;
}
.notice-link-style .cds--actionable-notification__action-button:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

.cds--definition-term {
  border-bottom: none !important;
}

.cds--side-nav {
  background-color: #ffffff;
}

:is(.dark *) .cds--side-nav,
:root:is(.dark) .cds--side-nav {
  background-color: #1a1a1a;
}

.cds--side-nav__menu-item .cds--side-nav__link-text {
  font-weight: 500;
}

:root {
  --cds-tag-background-cool-gray: #dde1e6;
  --cds-tag-color-cool-gray: #121619;
  --cds-tag-hover-cool-gray: #cdd3da;
  --cds-tag-background-gray: #e0e0e0;
  --cds-tag-color-gray: #161616;
  --cds-tag-hover-gray: #cacaca;
}

:is(.dark *),
:root:is(.dark) {
  --cds-tag-background-cool-gray: #343a3f;
  --cds-tag-color-cool-gray: #dde1e6;
  --cds-tag-hover-cool-gray: #4d5358;
  --cds-tag-background-gray: #393939;
  --cds-tag-color-gray: #e0e0e0;
  --cds-tag-hover-gray: #474747;
}`, "",{"version":3,"sources":["webpack://./src/styles/carbon.scss","webpack://./node_modules/@carbon/styles/scss/_layout.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_custom-property.scss","webpack://./node_modules/@carbon/styles/scss/_layer.scss","webpack://./node_modules/@carbon/styles/scss/theme/_theme.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_keyframes.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_visually-hidden.scss","webpack://./node_modules/@carbon/styles/scss/components/popover/_popover.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_layout.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_component-reset.scss","webpack://./node_modules/@carbon/themes/scss/generated/_tokens.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_button-reset.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_focus-outline.scss","webpack://./node_modules/@carbon/styles/scss/components/tooltip/_tooltip.scss","webpack://./node_modules/@carbon/type/scss/_styles.scss","webpack://./node_modules/@carbon/styles/scss/components/button/_button.scss","webpack://./node_modules/@carbon/styles/scss/components/button/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/button/_vars.scss","webpack://./node_modules/@carbon/styles/scss/components/button/_tokens.scss","webpack://./node_modules/@carbon/layout/scss/generated/_spacing.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_skeleton.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_high-contrast-mode.scss","webpack://./node_modules/@carbon/styles/scss/components/toggletip/_toggletip.scss","webpack://./node_modules/@carbon/styles/scss/components/toggle/_toggle.scss","webpack://./node_modules/@carbon/styles/scss/components/overflow-menu/_overflow-menu.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_box-shadow.scss","webpack://./node_modules/@carbon/styles/scss/components/modal/_modal.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_update_fields_on_layer.scss","webpack://./node_modules/@carbon/grid/scss/_breakpoint.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_ai-gradient.scss","webpack://./node_modules/@carbon/styles/scss/components/form/_form.scss","webpack://./node_modules/@carbon/type/scss/_reset.scss","webpack://./node_modules/@carbon/type/scss/_font-family.scss","webpack://./node_modules/@carbon/styles/scss/components/stack/_stack.scss","webpack://./node_modules/@carbon/styles/scss/components/checkbox/_checkbox.scss","webpack://./node_modules/@carbon/styles/scss/components/text-input/_text-input.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_placeholder-colors.scss","webpack://./node_modules/@carbon/colors/index.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_tooltip.scss","webpack://./node_modules/@carbon/styles/scss/components/text-area/_text-area.scss","webpack://./node_modules/@carbon/styles/scss/components/tag/_tag.scss","webpack://./node_modules/@carbon/styles/scss/components/tag/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/tag/_tokens.scss","webpack://./node_modules/@carbon/styles/scss/components/list-box/_list-box.scss","webpack://./node_modules/@carbon/styles/scss/components/dropdown/_dropdown.scss","webpack://./node_modules/@carbon/styles/scss/components/multiselect/_multiselect.scss","webpack://./node_modules/@carbon/styles/scss/components/search/_search.scss","webpack://./node_modules/@carbon/motion/index.scss","webpack://./node_modules/@carbon/styles/scss/components/combo-box/_combo-box.scss","webpack://./node_modules/@carbon/styles/scss/components/select/_select.scss","webpack://./node_modules/@carbon/styles/scss/components/pagination/_pagination.scss","webpack://./node_modules/@carbon/styles/scss/components/pagination/_unstable_pagination.scss","webpack://./node_modules/@carbon/styles/scss/components/radio-button/_radio-button.scss","webpack://./node_modules/@carbon/styles/scss/components/number-input/_number-input.scss","webpack://./node_modules/@carbon/styles/scss/components/slider/_slider.scss","webpack://./node_modules/@carbon/styles/scss/components/skeleton-styles/_ai-skeleton-styles.scss","webpack://./node_modules/@carbon/styles/scss/components/skeleton-styles/_skeleton-styles.scss","webpack://./node_modules/@carbon/styles/scss/components/data-table/_data-table.scss","webpack://./node_modules/@carbon/styles/scss/utilities/_text-overflow.scss","webpack://./node_modules/@carbon/styles/scss/components/data-table/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/data-table/action/_data-table-action.scss","webpack://./node_modules/@carbon/styles/scss/components/icon-indicator/_icon-indicator.scss","webpack://./node_modules/@carbon/styles/scss/components/icon-indicator/_tokens.scss","webpack://./node_modules/@carbon/styles/scss/components/shape-indicator/_shape-indicator.scss","webpack://./node_modules/@carbon/styles/scss/components/breadcrumb/_breadcrumb.scss","webpack://./node_modules/@carbon/styles/scss/components/link/_link.scss","webpack://./node_modules/@carbon/styles/scss/components/notification/_inline-notification.scss","webpack://./node_modules/@carbon/styles/scss/components/notification/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/notification/_tokens.scss","webpack://./node_modules/@carbon/styles/scss/components/notification/_toast-notification.scss","webpack://./node_modules/@carbon/styles/scss/components/notification/_actionable-notification.scss","webpack://./node_modules/@carbon/styles/scss/components/tile/_tile.scss","webpack://./node_modules/@carbon/styles/scss/components/loading/_loading.scss","webpack://./node_modules/@carbon/styles/scss/components/loading/_animation.scss","webpack://./node_modules/@carbon/styles/scss/_motion.scss","webpack://./node_modules/@carbon/styles/scss/components/loading/_vars.scss","webpack://./node_modules/@carbon/styles/scss/components/copy-button/_copy-button.scss","webpack://./node_modules/@carbon/styles/scss/components/code-snippet/_code-snippet.scss","webpack://./node_modules/@carbon/styles/scss/components/code-snippet/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/content-switcher/_content-switcher.scss","webpack://./node_modules/@carbon/styles/scss/components/content-switcher/_tokens.scss","webpack://./node_modules/@carbon/styles/scss/components/progress-indicator/_progress-indicator.scss","webpack://./node_modules/@carbon/styles/scss/components/menu/_menu.scss","webpack://./node_modules/@carbon/styles/scss/components/combo-button/_combo-button.scss","webpack://./node_modules/@carbon/styles/scss/components/menu-button/_menu-button.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/content/_content.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/header/_header.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/header-panel/_header-panel.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/side-nav/_side-nav.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/_mixins.scss","webpack://./node_modules/@carbon/styles/scss/components/ui-shell/switcher/_switcher.scss","webpack://./node_modules/@carbon/styles/scss/components/date-picker/_flatpickr.scss","webpack://./node_modules/@carbon/styles/scss/components/date-picker/_date-picker.scss","webpack://./node_modules/@carbon/styles/scss/components/tabs/_tabs.scss","webpack://./node_modules/@carbon/styles/scss/components/tabs/_vars.scss","webpack://./node_modules/@carbon/styles/scss/components/structured-list/_structured-list.scss","webpack://./node_modules/@carbon/styles/scss/components/structured-list/_mixins.scss","webpack://./node_modules/@carbon/themes/scss/_theme.scss","webpack://./node_modules/@carbon/styles/scss/_theme.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC+DV;ECTJ,0EAAA;EAAA,+DAAA;AFlDF;;ACyEM;ECvBJ,yGAAA;AF9CF;;ACmFQ;ECrCN,sEAAA;AF1CF;;AC+EQ;ECrCN,sEAAA;AFtCF;;AC+CM;ECTJ,wEAAA;EAAA,+DAAA;AFjCF;;ACwDM;ECvBJ,uGAAA;AF7BF;;ACkEQ;ECrCN,oEAAA;AFzBF;;AC8DQ;ECrCN,oEAAA;AFrBF;;AC8BM;ECTJ,0EAAA;EAAA,+DAAA;AFhBF;;ACuCM;ECvBJ,yGAAA;AFZF;;ACiDQ;ECrCN,sEAAA;AFRF;;AC6CQ;ECrCN,sEAAA;AFJF;;ACaM;ECTJ,wEAAA;EAAA,+DAAA;AFCF;;ACsBM;ECvBJ,uGAAA;AFKF;;ACgCQ;ECrCN,oEAAA;AFSF;;AC4BQ;ECrCN,oEAAA;AFaF;;ACJM;ECTJ,wEAAA;EAAA,+DAAA;AFkBF;;ACKM;ECvBJ,uGAAA;AFsBF;;ACeQ;ECrCN,oEAAA;AF0BF;;ACWQ;ECrCN,oEAAA;AF8BF;;ACrBM;ECTJ,yEAAA;EAAA,+DAAA;AFmCF;;ACZM;ECvBJ,wGAAA;AFuCF;;ACFQ;ECrCN,qEAAA;AF2CF;;ACNQ;ECrCN,qEAAA;AF+CF;;ACtCM;ECTJ,uGAAA;EAAA,qFAAA;AFoDF;;AC7BM;ECvBJ,iJAAA;AFwDF;;ACnBQ;ECrCN,mGAAA;AF4DF;;ACvBQ;ECrCN,mGAAA;AFgEF;;ACvDM;ECTJ,kGAAA;EAAA,qFAAA;AFqEF;;AC9CM;ECvBJ,4IAAA;AFyEF;;ACpCQ;ECrCN,8FAAA;AF6EF;;ACxCQ;ECrCN,8FAAA;AFiFF;;AC9BA;ECnDE,mCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,oDAAA;AFgGF;;AG1IA;ED0CE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AFkHF;;AGxJA;EDsCE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AFoIF;;AGtKA;EDkCE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AFsJF;;AGpLA;ED8BE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;AFwKF;;AGjME;EACE,yBCHe;EDGf,6CCHe;AJuMnB;;AGrME;EACE,yBCHe;EDGf,6CCHe;AJ2MnB;;AGzME;EACE,yBCHe;EDGf,6CCHe;AJ+MnB;;AKxNA;EACE;IAVA,UAAA;IACA,mBAAA;ELsOA;EKzNA;IATA,UAAA;IACA,kBAAA;ELqOA;AACF;AKzNA;EACE;IAfA,UAAA;IACA,kBAAA;EL2OA;EKzNA;IAxBA,UAAA;IACA,mBAAA;ELoPA;AACF;AKzNA;EACE;IACE,YAAA;IACA,oBAAA;IACA,sBAAA;EL2NF;EKxNA;IACE,UAAA;IACA,oBAAA;IACA,sBAAA;EL0NF;EKvNA;IACE,oBAAA;IACA,uBAAA;ELyNF;EKtNA;IACE,oBAAA;IACA,uBAAA;ELwNF;EKrNA;IACE,oBAAA;IACA,uBAAA;ELuNF;EKpNA;IACE,oBAAA;IACA,uBAAA;ELsNF;EKnNA;IACE,oBAAA;IACA,sBAAA;ELqNF;EKlNA;IACE,oBAAA;IACA,sBAAA;ELoNF;EKjNA;IACE,YAAA;IACA,oBAAA;IACA,sBAAA;ELmNF;AACF;AM/QA;;EAEE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ANiRF;;AOhLE;EACE,qBAAA;APmLJ;;AO7KE;EACE,kBAAA;APgLJ;;AO1KE;EL7FA,sEAAA;EAAA,0DAAA;AF4QF;;AO1KE;EACE,2DAvGkB;EAuGlB,2FAvGkB;APoRtB;;AOzKE;EAGE,0BAAA;EAAA,4EAAA;EACA,oBAAA;AP0KJ;;AOtKE;EL/GA,8BAAA;AFyRF;;AOlKE;EApFA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,oBAAA;AP0PF;;AOpKE;EL5HA,iCAAA;AFoSF;AQjRQ;ENnBN,0DAAA;AFuSF;AO3KE;EL5HA,mCAAA;AF0SF;AQvRQ;ENnBN,0DAAA;AF6SF;AOjLE;EL5HA,iCAAA;AFgTF;AQ7RQ;ENnBN,0DAAA;AFmTF;AOvLE;EEvKA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATiWF;AS/VE;;;EAGE,mBAAA;ATiWJ;AOrME;EAeE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,kBAtIoB;EAsIpB,oDAtIoB;EAuIpB,yBAzJuB;EAyJvB,uEAzJuB;EA0JvB,cArIiB;EAqIjB,sEArIiB;EAsIjB,gCAAA;EAAA,wBAAA;EACA,sBAAA;EACA,oBAAA;APyLJ;;AOtLE;EAGE,cAAA;APuLJ;;AOpLE;EAGE,yBG/LS;EH+LT,gDG/LS;AVoXb;;AO9KE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;APiLJ;;AO9KE;EAGE,cAAA;AP+KJ;;AO3KE;;EAEE,kBAAA;EACA,aAAA;EACA,aAAA;EAKA,sBAAA;AP0KJ;AOvKI;;EACE,kBAAA;EACA,cAAA;EACA,yBA5MqB;EA4MrB,uEA5MqB;EA6MrB,WAAA;AP0KN;AOtKI;;EACE,kBAAA;EACA,aAAA;EACA,yBAxMiB;EAwMjB,2EAxMiB;EAyMjB,WAAA;APyKN;;AOrKE;EAGE,yBGlPS;EHkPT,gDGlPS;AVwZb;;AOnKE;;EAGE,cAAA;APqKJ;;AOlKE;EAGE,cAAA;APmKJ;;AO/JE;EAIE,cAAA;AP+JJ;;AO5JE;EAGE,aAAA;AP6JJ;;AOrJE;EAGE,kBAAA;EACA,uBAAA;EACA,6CAAA;EAAA,wEAAA;APsJJ;;AOnJE;;;EAeE,yBAAA;AP0IJ;;AOvIE;;;EAeE,2BAAA;AP8HJ;;AO3HE;;EAUE,2CAAA;EAAA,sEAAA;APsHJ;;AOpHE;;EAUE,yCAAA;EAAA,oEAAA;AP+GJ;;AO5GE;;;EAeE,wCAAA;APmGJ;;AOhGE;;;EAeE,sCAAA;APuFJ;;AOpFE;EAIE,4CAAA;EAAA,uEAAA;APoFJ;;AOjFE;;EAME,kBAAA;EACA,oCAAA;EAAA,+DAAA;EACA,wDAAA;EAAA,8GAAA;APgFJ;;AO1EE;;EAQE,kCAAA;EAAA,6DAAA;EACA,2BAAA;APuEJ;;AOpEE;;EAME,kBAAA;EACA,kCAAA;EAAA,6DAAA;EACA,6CAAA;EAAA,mGAAA;APmEJ;;AOhEE;;EAQE,oCAAA;EAAA,+DAAA;AP6DJ;;AOzDE;;;;;EAeE,gBAjZa;EAiZb,2CAjZa;EAkZb,oBAAA;EACA,eAAA;EACA,4BAAA;APkDJ;;AO9CE;;;;;EAeE,oBA9ZmB;EA8ZnB,qDA9ZmB;EA+ZnB,oBAnakB;EAmalB,oDAnakB;EAoalB,kBAAA;EACA,uBAAA;EACA,gCAAA;EAAA,2DAAA;APuCJ;AOrCI;;;;;EACE,oBAraiB;EAqajB,qDAraiB;EAsajB,sDAAA;UAAA,8CAAA;EACA,oBA3agB;EA2ahB,oDA3agB;APsdtB;;AOvBI;;;;;EACE,oBA5biB;EA4bjB,qDA5biB;EA6bjB,sDAAA;UAAA,8CAAA;EACA,oBAlcgB;EAkchB,oDAlcgB;APgetB;AO3BI;;;;;EACE,gCAAA;EAAA,gEAAA;EACA,sBAAA;EACA,yBAAA;APiCN;;AO7BE;;;;;EAoBE,+BAAA;EAAA,0DAAA;APiBJ;;AObE;;;;;EAoBE,oBApfmB;EAofnB,qDApfmB;EAqfnB,oBAzfkB;EAyflB,oDAzfkB;AP0ftB;AOCI;;;;;EACE,oBAxfiB;EAwfjB,qDAxfiB;EAyfjB,sDAAA;UAAA,8CAAA;EACA,oBA9fgB;EA8fhB,oDA9fgB;APmgBtB;;AOoBI;;;;;EACE,oBAphBiB;EAohBjB,qDAphBiB;EAqhBjB,sDAAA;UAAA,8CAAA;EACA,oBA1hBgB;EA0hBhB,oDA1hBgB;AP6gBtB;AOgBI;;;;;EACE,gCAAA;EAAA,gEAAA;EACA,sBAAA;EACA,yBAAA;APVN;;AOmBE;EAGE,oBAAA;EACA,uBAAA;EACA,8CAAA;EAAA,yEAAA;APlBJ;;AOqBE;EAIE,6CAAA;EAAA,wEAAA;APrBJ;;AOwBE;;EAME,oBAAA;EACA,oCAAA;EAAA,+DAAA;EACA,yDAAA;EAAA,+GAAA;APzBJ;;AO+BE;;EAQE,kCAAA;EAAA,6DAAA;EACA,2BAAA;APlCJ;;AOqCE;;EAME,oBAAA;EACA,kCAAA;EAAA,6DAAA;EACA,8CAAA;EAAA,oGAAA;APtCJ;;AOyCE;;EAQE,oCAAA;EAAA,+DAAA;AP5CJ;;AOgDE;;;;;EAeE,gBA7nBa;EA6nBb,2CA7nBa;EA8nBb,kBAAA;EACA,eAAA;EACA,2BAAA;APvDJ;;AO2DE;;;;;EAaE,oBAxoBmB;EAwoBnB,qDAxoBmB;EAyoBnB,oBA7oBkB;EA6oBlB,oDA7oBkB;EA8oBlB,oBAAA;EACA,uBAAA;EACA,2CAAA;EAAA,sEAAA;APhEJ;AOkEI;;;;;EACE,oBA/oBiB;EA+oBjB,qDA/oBiB;EAgpBjB,oDAAA;UAAA,4CAAA;EACA,oBArpBgB;EAqpBhB,oDArpBgB;APylBtB;;AOgFI;;;;;EACE,oBAtqBiB;EAsqBjB,qDAtqBiB;EAuqBjB,oDAAA;UAAA,4CAAA;EACA,oBA5qBgB;EA4qBhB,oDA5qBgB;APmmBtB;AO4EI;;;;;EACE,gCAAA;EAAA,gEAAA;EACA,uBAAA;EACA,yBAAA;APtEN;;AO0EE;;;;;EAoBE,0CAAA;EAAA,qEAAA;APtFJ;;AO0FE;;;;;EAoBE,oBA9tBmB;EA8tBnB,qDA9tBmB;EA+tBnB,oBAnuBkB;EAmuBlB,oDAnuBkB;AP6nBtB;AOwGI;;;;;EACE,oBAluBiB;EAkuBjB,qDAluBiB;EAmuBjB,oDAAA;UAAA,4CAAA;EACA,oBAxuBgB;EAwuBhB,oDAxuBgB;APsoBtB;;AO2HI;;;;;EACE,oBA9vBiB;EA8vBjB,qDA9vBiB;EA+vBjB,oDAAA;UAAA,4CAAA;EACA,oBApwBgB;EAowBhB,oDApwBgB;APgpBtB;AOuHI;;;;;EACE,gCAAA;EAAA,gEAAA;EACA,uBAAA;EACA,yBAAA;APjHN;;AO0HE;EAGE,sBAAA;EACA,wBAAA;EAGA,gCAAA;EAAA,2DAAA;AP3HJ;;AO8HE;;EAME,sBAAA;EACA,wBAAA;EACA,wDAAA;EAAA,8GAAA;AP/HJ;;AOqIE;;EAME,oBAAA;EACA,wBAAA;EACA,mDAAA;EAAA,yGAAA;APtIJ;;AOyIE;;;;;EAoBE,sBAAA;EACA,2BAAA;APrJJ;;AOyJE;;;;;EAeE,iBAn2Ba;EAm2Bb,4CAn2Ba;EAo2Bb,cAAA;EACA,qBAAA;EACA,4BAAA;APhKJ;;AOoKE;;;;;EAeE,mBAp3BkB;EAo3BlB,mDAp3BkB;EAq3BlB,qBAj3BmB;EAi3BnB,sDAj3BmB;EAk3BnB,sBAAA;EACA,wBAAA;EACA,6CAAA;EAAA,wEAAA;AP3KJ;AO6KI;;;;;EACE,mBA33BgB;EA23BhB,mDA33BgB;EA43BhB,sDAAA;UAAA,8CAAA;EACA,qBAz3BiB;EAy3BjB,sDAz3BiB;APktBvB;;AO2KE;;;;;EAoBE,sBAAA;EACA,2BAAA;APvLJ;;AOoNI;;;;;EACE,mBAp7BgB;EAo7BhB,mDAp7BgB;EAq7BhB,sDAAA;UAAA,8CAAA;EACA,qBAl7BiB;EAk7BjB,sDAl7BiB;APquBvB;AOgNI;;;;;EACE,uBAAA;AP1MN;;AO4OI;;;;;EACE,wBAAA;APrON;;AO0OE;;;;;EAoBE,mBAt/BkB;EAs/BlB,mDAt/BkB;EAu/BlB,qBAn/BmB;EAm/BnB,sDAn/BmB;AP6vBvB;AOwPI;;;;;EACE,mBA1/BgB;EA0/BhB,mDA1/BgB;EA2/BhB,sDAAA;UAAA,8CAAA;EACA,qBAx/BiB;EAw/BjB,sDAx/BiB;APswBvB;;AO4QI;;;;;EACE,mBAvhCgB;EAuhChB,mDAvhCgB;EAwhChB,sDAAA;UAAA,8CAAA;EACA,qBArhCiB;EAqhCjB,sDArhCiB;APgxBvB;AOyQI;;;;;EACE,uBAAA;APnQN;;AOgSI;;;;;EACE,yBAAA;UAAA,wBAAA;APzRN;AO4RI;;;;;EACE,qBAAA;APtRN;;AO+RE;EAGE,sBAAA;EACA,sBAAA;EAGA,mDAAA;EAAA,8EAAA;APhSJ;;AOmSE;;EAME,sBAAA;EACA,sBAAA;EAGA,+DAAA;EAAA,qHAAA;APtSJ;;AO4SE;;EAME,oBAAA;EACA,sBAAA;EAGA,8DAAA;EAAA,oHAAA;AP/SJ;;AOqTE;;;;;EAoBE,yBAAA;EACA,wBAAA;APjUJ;;AOqUE;;;;;EAeE,iBAhqCa;EAgqCb,4CAhqCa;EAiqCb,cAAA;EACA,mBAAA;EACA,2BAAA;AP5UJ;;AOgVE;;;;;EAeE,mBAjrCkB;EAirClB,mDAjrCkB;EAkrClB,qBA9qCmB;EA8qCnB,sDA9qCmB;EA+qCnB,sBAAA;EACA,sBAAA;EACA,kDAAA;EAAA,6EAAA;APvVJ;AOyVI;;;;;EACE,mBAxrCgB;EAwrChB,mDAxrCgB;EAyrChB,oDAAA;UAAA,4CAAA;EACA,qBAtrCiB;EAsrCjB,sDAtrCiB;APm2BvB;;AOuVE;;;;;EAoBE,yBAAA;EACA,wBAAA;APnWJ;;AOgYI;;;;;EACE,mBAjvCgB;EAivChB,mDAjvCgB;EAkvChB,oDAAA;UAAA,4CAAA;EACA,qBA/uCiB;EA+uCjB,sDA/uCiB;APs3BvB;AO4XI;;;;;EACE,wBAAA;APtXN;;AOwZI;;;;;EACE,uBAAA;APjZN;;AOsZE;;;;;EAoBE,mBAnzCkB;EAmzClB,mDAnzCkB;EAozClB,qBAhzCmB;EAgzCnB,sDAhzCmB;AP84BvB;AOoaI;;;;;EACE,mBAvzCgB;EAuzChB,mDAvzCgB;EAwzChB,oDAAA;UAAA,4CAAA;EACA,qBArzCiB;EAqzCjB,sDArzCiB;APu5BvB;;AOubI;;;;;EACE,mBAn1CgB;EAm1ChB,mDAn1CgB;EAo1ChB,oDAAA;UAAA,4CAAA;EACA,qBAj1CiB;EAi1CjB,sDAj1CiB;APi6BvB;AOmbI;;;;;EACE,wBAAA;AP7aN;;AO0cI;;;;;EACE,0BAAA;UAAA,yBAAA;APncN;AOscI;;;;;EACE,qBAAA;APhcN;;AOucE;EAGE,gBAAA;APtcJ;;AOycE;;;;EAsBE,qBAAA;APxdJ;;AO2dE;;;;EAsBE,mBAAA;EACA,2BAAA;AP1eJ;;AO6eE;EACE,mBAAA;AP1eJ;;AO6eE;EI//CA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATiiCF;AS/hCE;;;EAGE,mBAAA;ATiiCJ;AW3hCE;EACE,SAAA;AX6hCJ;AOmdE;EA95CA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AP88BF;AO58BE;EKzFE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZwiCJ;AYtiCI;ELsFF;IKrFI,qBAAA;EZyiCJ;AACF;AOj9BE;EACE,yBH/FU;EG+FV,wCH/FU;AJkjCd;AOh9BE;EACE,aG8HW;EH9HX,sCG8HW;AVo1Bf;;AOgcE;EAEE,mBH1/CI;EG0/CJ,4BH1/CI;EG2/CJ,wCAAA;AP9bJ;;AOicE;EAEE,kBAAA;EACA,aAAA;EACA,mBHlgDI;EGkgDJ,4BHlgDI;EGmgDJ,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AP/bJ;;AOkcE;EACE,aGtyCW;EHsyCX,sCGtyCW;AVu2Bf;;AavkCE;EXyBA,0BAAA;AFkjCF;;AavkCE;ECi0BE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;ED9zBA,kBAAA;EAAA,uFAAA;EACA,sBAAA;EACA,yBAAA;Ab4kCJ;;Aa1iCE;EXlBA,qCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,4BAAA;AFmkCF;;AajiCE;EC0wBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Ad8RJ;;AarlCE;EF7BA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATioCF;AS/nCE;;;EAGE,mBAAA;ATioCJ;AW3nCE;EACE,SAAA;AX6nCJ;Aa/mCE;EAGE,gBAAA;EACA,wCAAA;UAAA,oCAAA;EAAA,yDAAA;UAAA,qDAAA;EACA,cH0JW;EG1JX,uCH0JW;AVq9Bf;;Aa5mCE;EDnCE,uCAAA;EAAA,4CAAA;AZmpCJ;AYjpCI;ECiCF;IDhCI,qBAAA;EZopCJ;AACF;AarnCE;EAGE,4CH8IiB;EG9IjB,8DH8IiB;AVu+BrB;;AalnCE;EACE,4CH0IiB;EG1IjB,8DH0IiB;AV2+BrB;;AalnCE;ECqyBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EDlyBA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;AbunCJ;;Ae1kCE;Eb1DA,2PAAA;EAAA,uOAAA;Ec7BA;;GAAA;EAMA;;GAAA;EAOA;;;GAAA;EP3BA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT+rCF;AS7rCE;;;EAGE,mBAAA;AT+rCJ;AermCE;EDkvBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EEpzBF,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,8BAAA;EACA,gBC5BqB;ED8BrB,SAAA;EACA,eAAA;EACA,gCAAA;EAAA,wBAAA;EACA,sBAAA;EACA,mDAAA;EACA,aAAA;EAEA,0HAAA;EAIA,4JAAA;EAMA,iBAAA;EACA,qBAAA;EACA,qMACE;EAIF,mBAAA;AhBgqCF;AgB9pCE;EAME,qBEqVc;EFrVd,iDEqVc;EFpVd,mBEoVc;EFpVd,+CEoVc;EFnVd,gBAAA;EACA,cNwIqB;EMxIrB,iDNwIqB;EMvIrB,mBAAA;AhB2pCJ;AgBxpCE;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EAEA,mHAAA;EAMA,gEAAA;EACA,gCAAA;UAAA,6BAAA;AhBopCJ;;AepoCE;EACE,UAAA;EACA,SAAA;AfuoCJ;;AepoCE;ECNA,iBCzCqB;ED0CrB,mBAAA;EACA,yBDOI;ECNJ,sCEoPe;EFpPf,oDEoPe;EFnPf,cNiGc;EMjGd,wCNiGc;AV6iChB;AgB5oCE;EACE,sEE4RmB;EF5RnB,0DE4RmB;AlBk3BvB;AgB3oCE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhB4oCN;AgBxoCE;EACE,sEE6PoB;EF7PpB,2DE6PoB;AlB64BxB;AgBvoCE;;EAEE,kBDXE;AfopCN;AehpCI;EACE,cLoFU;EKpFV,wCLoFU;AV8jChB;;Ae9oCE;ECrBA,iBCzCqB;ED0CrB,mBAAA;EACA,yBDsBI;ECrBJ,yBEsPiB;EFtPjB,sDEsPiB;EFrPjB,cNiGc;EMjGd,wCNiGc;AVskChB;AgBrqCE;EACE,yBEiSqB;EFjSrB,4DEiSqB;AlBs4BzB;AgBpqCE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhBqqCN;AgBjqCE;EACE,yBEkQsB;EFlQtB,6DEkQsB;AlBi6B1B;AgBhqCE;;EAEE,kBDIE;Af8pCN;Ae1pCI;EAEE,cLoEU;EKpEV,wCLoEU;AVulChB;;AevpCE;ECrCA,iBCzCqB;ED0CrB,mBAAA;EACA,kCE4PgB;EF5PhB,iDE4PgB;EF3PhB,6BDoCI;ECnCJ,2BE0PgB;EF1PhB,0CE0PgB;AlBs8BlB;AgB9rCE;EACE,sCEsSoB;EFtSpB,2DEsSoB;AlB05BxB;AgB7rCE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhB8rCN;AgB1rCE;EACE,sEEuQqB;EFvQrB,4DEuQqB;AlBq7BzB;AgBzrCE;;EAEE,kBDoBE;AfuqCN;AenqCI;EACE,cLkDS;EKlDT,uCLkDS;AVmnCf;AelqCI;EACE,sCG0MY;EH1MZ,qDG0MY;EHzMZ,cL6CS;EK7CT,uCL6CS;AVunCf;AejqCI;EACE,yBAAA;EACA,sEG+NmB;EH/NnB,4DG+NmB;EH9NnB,cLuCS;EKvCT,uCLuCS;AV4nCf;AehqCI;EAME,uBAAA;EACA,6BLsCU;EKtCV,uDLsCU;EKrCV,aAAA;Af6pCN;;AezpCE;EC1EA,iBCzCqB;ED0CrB,mBAAA;EACA,yBD2EI;EC1EJ,6BDyEI;ECxEJ,2BN0Ga;EM1Gb,uCN0Ga;AV6nCf;AgBruCE;EACE,2CN5Fe;EM4Ff,wEN5Fe;AVm0CnB;AgBpuCE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhBquCN;AgBjuCE;EACE,0CNhHgB;EMgHhB,wENhHgB;AVm1CpB;AgBhuCE;;EAEE,kBDyDE;AfyqCN;Ae/qCE;EAUE,qFAAA;UAAA,oFAAA;AfwqCJ;AepqCI;EACE,gBAAA;EACA,kBAAA;EACA,4BI7LO;UJ6LP,2BI7LO;AnBm2Cb;AenqCI;EAEE,2DLiBe;EKjBf,6CLiBe;AVmpCrB;AejqCI;EACE,0CLlMc;EKkMd,wELlMc;AVq2CpB;AehqCI;EAME,yBAAA;EACA,uBAAA;EACA,6BLJU;EKIV,uDLJU;EKKV,aAAA;Af6pCN;Ae1pCI;EACE,aLkBS;EKlBT,sCLkBS;AV0oCf;;AexpCE;EACE,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,+CAAA;EACA,gDAAA;EACA,yBAAA;UAAA,sBAAA;Af2pCJ;AezpCI;EACE,qBAAA;Af2pCN;AexpCI;EACE,gBAAA;Af0pCN;AetpCM;EACE,0CLxOY;EKwOZ,wELxOY;EKyOZ,gDAAA;EAAA,oFAAA;AfwpCR;AeppCI;EAEE,SAAA;AfqpCN;AelpCI;EACE,gFAAA;UAAA,+EAAA;AfopCN;;Ae7oCE;EACE,6BAAA;UAAA,0BAAA;AfgpCJ;;Ae5oCE;;;EAGE,wBAAA;UAAA,qBAAA;Af+oCJ;;Ae5oCE;EACE,oCLnQkB;EKmQlB,oELnQkB;AVk5CtB;;Ae5oCE;EACE,UAAA;Af+oCJ;;Ae5oCE;;EAIE,aL7CW;EK6CX,sCL7CW;AV0rCf;;Ae1oCE;;;EAOE,aL3CqB;EK2CrB,gDL3CqB;AVorCzB;;AetoCE;EACE,mBAAA;AfyoCJ;;AepoCE;EACE,mBAAA;AfuoCJ;;AepoCE;EACE,oBAAA;AfuoCJ;;AepoCE;EC9MA,iBCzCqB;ED0CrB,mBAAA;EACA,yBD+MI;EC9MJ,yBE6PsB;EF7PtB,2DE6PsB;EF5PtB,cNiGc;EMjGd,wCNiGc;AVqvChB;AgBp1CE;EACE,yBEuRkB;EFvRlB,yDEuRkB;AlB+jCtB;AgBn1CE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhBo1CN;AgBh1CE;EACE,yBEwPmB;EFxPnB,0DEwPmB;AlB0lCvB;AgB/0CE;;EAEE,kBD6LE;AfopCN;AehpCI;EACE,cLpHU;EKoHV,wCLpHU;AVswChB;Ae/oCI;EC5NF,iBCzCqB;ED0CrB,mBAAA;EACA,qBEmQwB;EFnQxB,yDEmQwB;EFlQxB,6BD2NM;EC1NN,cEiQwB;EFjQxB,kDEiQwB;AlB6mC1B;AgB52CE;EACE,yBEuRkB;EFvRlB,yDEuRkB;AlBulCtB;AgB32CE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhB42CN;AgBx2CE;EACE,yBEwPmB;EFxPnB,0DEwPmB;AlBknCvB;AgBv2CE;;EAEE,kBD2MI;Af8pCR;Ae1pCM;EACE,qBGuDc;EHvDd,qDGuDc;EHtDd,cLnIQ;EKmIR,wCLnIQ;AV+xChB;AezpCM;EACE,yBGoBgB;EHpBhB,2DGoBgB;EHnBhB,cLxIQ;EKwIR,wCLxIQ;AVmyChB;AexpCM;EACE,qBGyBe;EHzBf,sDGyBe;EHxBf,yBGwBe;EHxBf,0DGwBe;EHvBf,cL9IQ;EK8IR,wCL9IQ;AVwyChB;AevpCM;EAME,uBAAA;EACA,6BLlJQ;EKkJR,uDLlJQ;EKmJR,aAAA;AfopCR;AehpCI;EClQF,iBCzCqB;ED0CrB,mBAAA;EACA,yBDmQM;EClQN,6BDiQM;EChQN,cEiQwB;EFjQxB,kDEiQwB;AlBopC1B;AgBn5CE;EACE,yBEuRkB;EFvRlB,yDEuRkB;AlB8nCtB;AgBl5CE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhBm5CN;AgB/4CE;EACE,yBEwPmB;EFxPnB,0DEwPmB;AlBypCvB;AgB94CE;;EAEE,kBDiPI;Af+pCR;AerqCI;EAUE,qFAAA;UAAA,oFAAA;Af8pCN;Ae1pCM;EACE,gBAAA;EACA,4BIpXK;UJoXL,2BIpXK;AnBghDb;AezpCM;EAEE,cLlLQ;EKkLR,wCLlLQ;AV40ChB;AevpCM;EAME,yBAAA;EACA,uBAAA;EACA,6BLvLQ;EKuLR,uDLvLQ;EKwLR,aAAA;AfopCR;;Ae9oCE;EDkcE,eAAA;EAAA,qDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,0DAAA;EAAA,iBAAA;EAAA,4DAAA;EC/bA,qIAAA;AfmpCJ;;AezoCE;EACE,kBAAA;Af4oCJ;;AexoCE;EACE,mBAAA;EACA,oBAAA;Af2oCJ;;AexoCE;EACE,sBAAA;Af2oCJ;;AevoCE;EK3aA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBsjDF;AoBpjDE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBojDJ;AoBjjDE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBmjDJ;AoBjjDI;EAVF;IAWI,eAAA;EpBojDJ;AACF;AqBnlDE;EN+aA;IK3YE,sBAAA;EpBmjDF;EoBjjDE;IACE,kBAAA;IACA,yBAAA;EpBmjDJ;AACF;Ae7qCE;EAGE,qBAAA;Af6qCJ;;AezqCE;EACE,aAAA;Af4qCJ;;AezqCE;EACE,sBAAA;Af4qCJ;;AezqCE;EACE,iBAAA;EAEA,yBAAA;Af2qCJ;AezqCI;EACE,oCAAA;EAAA,iEAAA;Af2qCN;AexqCI;EACE,mBAAA;Af0qCN;;AetqCE;EACE,mBAAA;AfyqCJ;;AetqCE;EACE,oCAAA;EAAA,iEAAA;AfyqCJ;;AetqCE;EACE,mBAAA;AfyqCJ;;AetqCE;EACE,oCAAA;EAAA,uEAAA;AfyqCJ;AevqCI;EACE,gBAAA;AfyqCN;;AerqCE;EACE,oCAAA;EAAA,wEAAA;AfwqCJ;AetqCI;EACE,gBAAA;AfwqCN;;AepqCE;EACE,yBAAA;EACA,6BAAA;EACA,gBAAA;AfuqCJ;;AelqCE;EACE,8BI9eS;UJ8eT,2BI9eS;EJ+eT,2BI/eS;UJ+eT,0BI/eS;AnBopDb;;AqBvpDE;ENsfA;IMpfI,gBAAA;IACA,4BAAA;ErB0pDJ;AACF;;AenqCE;EACE,mCAAA;EAAA,gEAAA;AfsqCJ;;AenqCE;EA/dA,2BAAA;AfsoDF;AepoDE;EACE,qBAAA;EAEA,aAAA;EACA,qCAAA;EACA,oBAAA;EACA,yBAAA;EACA,iBAAA;AfqoDJ;Ae3nDE;EAEE,aAAA;EAGA,wBAAA;Af0nDJ;AevnDE;EACE,sBAXuB;AfooD3B;AetnDE;;EAGE,aAAA;EACA,qBAAA;EACA,2BIxCS;UJwCT,0BIxCS,EJwC0B,kCAAA;AfunDvC;AejnDI;EACE;IAzDJ,wBAAA;Ef6qDA;Ee3qDA;IACE,aAAA;IACA,iBAAA;IACA,qBAAA;Ef6qDF;Ee1qDA;IACE,2BITS;YJST,0BITS;EnBqrDX;AACF;Ae9nDI;EACE;IAzDJ,wBAAA;Ef0rDA;EexrDA;IACE,aAAA;IACA,iBAAA;IACA,qBAAA;Ef0rDF;EevrDA;IACE,2BITS;YJST,0BITS;EnBksDX;AACF;Ae3oDI;EACE;IAzDJ,wBAAA;EfusDA;EersDA;IACE,aAAA;IACA,iBAAA;IACA,qBAAA;EfusDF;EepsDA;IACE,2BITS;YJST,0BITS;EnB+sDX;AACF;AexpDI;EACE;IAzDJ,wBAAA;EfotDA;EeltDA;IACE,aAAA;IACA,iBAAA;IACA,qBAAA;EfotDF;EejtDA;IACE,2BITS;YJST,0BITS;EnB4tDX;AACF;Ae9pDE;EAEI;IACE,eAAA;IACA,qBAAA;Ef+pDN;AACF;Ae3pDE;EACE;IACE,cAAA;IACA,qBAAA;Ef6pDJ;AACF;;AsBtvDE;ERg1BE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;EQ70BA,cZwLa;EYxLb,yCZwLa;EYvLb,0BHDS;UGCT,yBHDS;AnB4vDb;;AsBzvDE;ER00BE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;Ads7BJ;;AsB7vDE;EXbA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATyxDF;ASvxDE;;;EAGE,mBAAA;ATyxDJ;AWnxDE;EACE,SAAA;AXqxDJ;AsBvxDE;EAGE,aAAA;EACA,mBAAA;AtBuxDJ;;AsBpxDE;EACE,aZ6Na;EY7Nb,wCZ6Na;AV0jDjB;;AsBpxDE;;EAEE,aZqNW;EYrNX,sCZqNW;AVkkDf;;AsBpxDE;EV3BE,uCAAA;EAAA,4CAAA;AZmzDJ;AYjzDI;EUyBF;IVxBI,qBAAA;EZozDJ;AACF;;AsBzxDE;EpBOA,+BAAA;AFsxDF;;AsBtxDE;EpBAA,2DAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,uEAAA;EAAA,8DAAA;EY4yBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EQrxBA,aAAA;EACA,aH/CS;EGgDT,sBAAA;EACA,kBHjDS;EGiDT,aHjDS;AnB6zDb;;AsBzwDE;ER+wBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;AdigCJ;;AsB5wDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBH5DS;AnB20Db;;AuBn1DE;EACE,qBAAA;EACA,yBAAA;UAAA,iBAAA;AvBs1DJ;;AuBn1DE;ETs0BE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;ESn0BA,cAAA;EACA,cb6Ka;Ea7Kb,yCb6Ka;Ea5Kb,0BJFS;UIET,sBJFS;AnB01Db;;AuB/0DE;EjB7BA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ANg3DF;AuBz1DI;EACE,aAAA;AvB21DN;;AuBv1DE;EACE,oBAAA;EACA,mBAAA;EACA,kBJhCS;EIiCT,eAAA;EACA,8DAAA;EAAA,8CAAA;AvB01DJ;;AuBv1DE;EACE,kBAAA;EACA,sBAAA;EACA,yBbqoBS;EaroBT,gDbqoBS;EapoBT,kBAAA;EACA,iBAAA;EACA,8DAAA;AvB01DJ;AuBx1DI;EACE,kBAAA;EACA,kBAAA;EACA,yBbiMU;EajMV,mDbiMU;EahMV,oBAAA;EACA,WAAA;EACA,qBAAA;EACA,4BAAA;EACA,6BAAA;EACA,uDAAA;AvB01DN;AuBx1DM;EAXF;IAYI,gBAAA;EvB21DN;AACF;;AuBl1DI;;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,uCAAA;EAAA,4CAAA;EACA,mBAAA;AvBs1DN;;AuBl1DE;EACE,yBbkLc;EalLd,qDbkLc;AVmqDlB;AuBn1DI;EACE,6BAAA;AvBq1DN;;AuBj1DE;ETwvBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;ESrvBA,cb6FW;Ea7FX,uCb6FW;AVyvDf;;AuBn1DE;EACE,gBAAA;EACA,iBAAA;AvBs1DJ;AuBp1DI;EACE,oBAAA;EACA,qBAAA;AvBs1DN;;AuBl1DE;EAEE,2BAAA;AvBo1DJ;;AuBj1DE;EACE,kBAAA;EACA,qBAAA;EACA,abmJc;EanJd,yCbmJc;EalJd,qBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;AvBo1DJ;;AuBj1DE;EACE,mBAAA;AvBo1DJ;;AuB70DE;EACE,mBAAA;AvBg1DJ;;AuB70DE;;EAEE,6Bb2EY;Ea3EZ,uDb2EY;AVqwDhB;;AuB70DE;EACE,yBL8Qc;EK9Qd,qDL8Qc;AlBkkDlB;AuB90DI;EACE,yBb2GmB;Ea3GnB,4Db2GmB;AVquDzB;;AuB50DE;EACE,aLsQc;EKtQd,yCLsQc;AlBykDlB;;AuBz0DE;EACE,eAAA;AvB40DJ;;AuBz0DE;EACE,wCAAA;EAAA,kEAAA;EACA,6BAAA;AvB40DJ;AuB10DI;EACE,yBb2ES;Ea3ET,kDb2ES;Ea1ET,2BAAA;EACA,4BAAA;AvB40DN;;AuBx0DE;EACE,abnKS;EamKT,oCbnKS;EaoKT,4BAAA;EACA,yBAAA;AvB20DJ;;AuBx0DE;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;AvB20DJ;;AqB9/DE;EEwLA;;IFjLI,8BAAA;ErB6/DJ;AACF;;AqBrgEE;EE6LA;;IF3LI,gBAAA;IACA,4BAAA;ErBygEJ;AACF;;AuBv0DE;EACE,aAAA;EACA,mBAAA;AvB00DJ;;AuBv0DE;EHzJA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBV+oBoB;EU/oBpB,mDV+oBoB;AVq1CtB;AoBl+DE;EACE,kBAAA;EACA,oDAAA;EACA,mBV6oBe;EU7oBf,gDV6oBe;EU5oBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,iDAAA;ApBo+DJ;AoBl+DI;EATF;IAUI,eAAA;EpBq+DJ;AACF;AqBviEE;EE2MA;IHnIE,sBAAA;EpBm+DF;EoBj+DE;IACE,kBAAA;IACA,yBAAA;EpBm+DJ;AACF;AuBr2DE;EAGE,kBAAA;EACA,oBAAA;EACA,qBAAA;AvBq2DJ;;AuBl2DE;EH/MA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBqjEF;AoBnjEE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBmjEJ;AoBhjEE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBkjEJ;AoBhjEI;EAVF;IAWI,eAAA;EpBmjEJ;AACF;AqBllEE;EEmNA;IH/KE,sBAAA;EpBkjEF;EoBhjEE;IACE,kBAAA;IACA,yBAAA;EpBkjEJ;AACF;AuBx4DE;EAGE,kBAAA;EACA,mBAAA;EACA,4BAAA;UAAA,2BAAA;AvBw4DJ;;AuBp4DE;EACE,8BAAA;AvBu4DJ;;AuBp4DE;EAGE,4BAAA;AvBq4DJ;;AwBzlEE;;EbdA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATunEF;ASrnEE;;;;;;EAGE,mBAAA;AT0nEJ;AWpnEE;;EACE,SAAA;AXunEJ;AwBxnEE;;EfjBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT6oEF;AS3oEE;;;;;;EAGE,mBAAA;ATgpEJ;AwB1oEE;;EZ4BE,8BAAA;EACA,oBAAA;EYvBA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBLQS;EKPT,eAAA;EACA,mBLMS;EKLT,sBLKS;EKJT,6GACE;AxByoEN;AwBtoEI;;EZjBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ2pEJ;AYzpEI;EYcA;;IZbE,qBAAA;EZ6pEJ;AACF;AwB7oEI;;EACE,2CdjBa;EciBb,wEdjBa;AViqEnB;;AwB5oEE;EACE,wBAAA;UAAA,qBAAA;AxB+oEJ;;AwB5oEE;EACE,kBLxBS;EKyBT,mBLzBS;EK0BT,sBL1BS;AnByqEb;;AwB5oEE;EACE,gBLzBS;EK0BT,iBL1BS;EK2BT,oBL3BS;AnB0qEb;;AwB5oEE;EACE,gBLrBS;EKsBT,iBLtBS;AnBqqEb;;AwB3oEE;EZhDE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ+rEJ;AY7rEI;EY6CF;IZ5CI,qBAAA;EZgsEJ;AACF;AwBlpEI;EACE,aAAA;AxBopEN;;AwBhpEE;;ECvEA,wCAAA;EAAA,2DAAA;ED4EE,yBpBjEI;EoBiEJ,kCpBjEI;EoBkEJ,gBAAA;AxBipEJ;;AwB9oEE;;EAGE,yBpBxEI;EoBwEJ,kCpBxEI;AJwtER;;AwB7oEE;EACE,gBLtES;EKuET,aduJW;EcvJX,sCduJW;EctJX,iBLxES;AnBwtEb;;AwB7oEE;EACE,cAAA;AxBgpEJ;;AwB7oEE;EfnGA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATovEF;ASlvEE;;;EAGE,mBAAA;ATovEJ;AwB5pEE;EChGA,wCAAA;EAAA,2DAAA;EDoGE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBpB9FI;EoB8FJ,kCpB9FI;EoB+FJ,kBLjDS;EKkDT,uBLhFS;EKiFT,qBAAA;EACA,gBAAA;AxB4pEJ;AwB1pEI;EACE,kBAAA;EACA,cAAA;EACA,yBpBvGE;EoBuGF,kCpBvGE;EoBwGF,WAAA;EACA,gEAAA;AxB4pEN;AwBzpEM;EARF;IASI,gBAAA;ExB4pEN;AACF;;AwBxpEE;EACE,yBpBnHI;EoBmHJ,kCpBnHI;AJ8wER;;AwBxpEE;EACE,yBpBpHU;EoBoHV,wCpBpHU;AJ+wEd;AwBzpEI;EACE,yBpB1HE;EoB0HF,kCpB1HE;AJqxER;;AwBvpEE;EACE,yBpB5HU;EoB4HV,wCpB5HU;AJsxEd;;AwBvpEE;EAGE,qBAAA;EACA,mBLjHS;EKkHT,6BAAA;EACA,qBAAA;AxBwpEJ;;AwBrpEE;EACE,kBLhJS;EKiJT,mBLxHS;EKyHT,wBAAA;EACA,qBAAA;AxBwpEJ;;AwBrpEE;EACE,kBL9HS;EK+HT,qBAAA;EACA,oBAAA;EACA,2BAAA;AxBwpEJ;;AwBrpEE;EACE,kBLrIS;EKsIT,qBAAA;EACA,oBAAA;EACA,6BAAA;AxBwpEJ;;AwBppEI;EAEE,mBLxJO;AnB8yEb;AwBnpEI;EAEE,kBL7JO;AnBizEb;;AwB/oEI;EAEE,iBL/JO;AnBgzEb;AwB9oEI;EAEE,gBLpKO;AnBmzEb;;AwB1oEI;EAEE,iBLjKO;AnB6yEb;AwBzoEI;EAEE,gBLtKO;AnBgzEb;;AwBtoEE;;EAEE,oBAAA;AxByoEJ;;AwBtoEE;;EAEE,mBAAA;AxByoEJ;;AwBtoEE;EACE,aAAA;AxByoEJ;;AwBtoEE;EACE,iBAAA;AxByoEJ;;AwBtoEE;EfpOA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT82EF;AS52EE;;;EAGE,mBAAA;AT82EJ;AwBrpEE;EAGE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,kBLxMS;EKyMT,iBAAA;EACA,gEAAA;AxBqpEJ;;AwBlpEE;EAEE,kBLzNS;AnB62Eb;;AwBjpEE;EAEE,gBLzNS;AnB42Eb;;AwBhpEE;EAEE,gBLpNS;AnBs2Eb;;AwB/oEE;EACE,wCAAA;UAAA,qCAAA;EAAA,yDAAA;UAAA,sDAAA;AxBkpEJ;;AwB/oEE;EACE,wCAAA;UAAA,qCAAA;EAAA,yDAAA;UAAA,sDAAA;AxBkpEJ;;AwB/oEE;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AxBkpEJ;;AwB/oEE;EVykBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EF1yBA,8BAAA;EACA,oBAAA;EYoOA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,cdtFa;EcsFb,yCdtFa;EcuFb,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,wJACE;AxBopEN;AwBhpEI;EACE,cdtGS;EcsGT,uCdtGS;AVwvEf;AwB/oEI;EZtRA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZw6EJ;AYt6EI;EYmRA;IZlRE,qBAAA;EZy6EJ;AACF;AwBppEI;EACE,YAAA;AxBspEN;;AwBlpEE;EACE,ad7Da;Ec6Db,wCd7Da;AVktEjB;;AwBlpEE;EACE,adpEW;EcoEX,sCdpEW;AVytEf;;AwBlpEE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AxBqpEJ;;AwBlpEE;EACE,yBpB/SU;EoB+SV,wCpB/SU;AJo8Ed;;AwBlpEE;;EAIE,yBNqCoB;EMrCpB,2DNqCoB;EMpCpB,cdvHY;EcuHZ,wCdvHY;AV0wEhB;AwBjpEI;;EACE,kBAAA;AxBopEN;;AwBhpEE;EACE,yBpBlUI;EoBkUJ,kCpBlUI;EoBmUJ,mBAAA;AxBmpEJ;;AwBhpEE;EAEE,6Bd/HY;Ec+HZ,uDd/HY;EcgIZ,mBAAA;AxBkpEJ;AwBhpEI;EZ5SA,8BAAA;EACA,oBAAA;EYgTE,yBpBhVE;EoBgVF,kCpBhVE;EoBiVF,6BdxIU;EcwIV,uDdxIU;AVwxEhB;;AwB5oEE;EAGE,4BdrGY;EcqGZ,sDdrGY;AVkvEhB;;AwB1oEE;EACE,0BAAA;AxB6oEJ;AwB3oEI;EACE,yBAAA;AxB6oEN;;AwBxoEE,sBAAA;AHhXA;EGiXA;;IH/WI,gBAAA;IACA,4BAAA;ErB6/EJ;AACF;;AwB5oEE,oBAAA;AAIA;EACE,6CAAA;EAAA,wEAAA;AxB4oEJ;;AwBzoEE;EACE,6CAAA;EAAA,wEAAA;AxB4oEJ;;A0Bv/EE;EAYI,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oChB2oBI;EgB3oBJ,wDhB2oBI;EgB1oBJ,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;A1B++EN;A0B7+EM;EAsdF,+EAAA;A1B0hEJ;A0BrhEI;EA3dE;IA4dA,eAAA;E1BwhEJ;AACF;A0BthEI;EACE,iFAAA;A1BwhEN;A0BnhEM;EANF;IAOI,eAAA;E1BshEN;AACF;A0BnhEI;EACE;IACE,UAAA;E1BqhEN;E0BlhEI;IACE,UAAA;E1BohEN;AACF;A0BjhEI;EACE;IACE,UAAA;E1BmhEN;E0BhhEI;IACE,UAAA;E1BkhEN;AACF;A0BzgFM;EAgcF,UAAA;EACA,oFACE;EAEF,kBAAA;A1B0kEJ;A0BxkEI;EACE,UAAA;EACA,2EACE;EAEF,mBAAA;A1BwkEN;A0BtkEM;EAPF;IAQI,gBAAA;E1BykEN;AACF;A2BrkFE;;;;;;;;;;;;;EAkBE,yBjBoGO;EiBpGP,8CjBoGO;AV89EX;A2B9jFE;EACE,yBjBQO;EiBRP,8CjBQO;AVwjFX;A2B7jFE;EACE,yBjB+Ba;EiB/Bb,oDjB+Ba;AVgiFjB;A2B5jFE;EACE,yBjB8BgB;EiB9BhB,uDjB8BgB;AVgiFpB;A2B3jFE;EACE,yBjB6BsB;EiB7BtB,6DjB6BsB;AVgiF1B;A2B1jFE;;EAIE,yBvBrBU;EuBqBV,wCvBrBU;AJ+kFd;A2BvjFE;;EAIE,oDAAA;UAAA,mDAAA;EAAA,yDAAA;UAAA,wDAAA;A3BujFJ;;A0BnjEI;EACE,2FAAA;A1BsjEN;A0BjjEM;EANF;IAOI,eAAA;E1BojEN;AACF;A0BjjEI;EACE,yFAAA;A1BmjEN;A0B9iEM;EANF;IAOI,eAAA;E1BijEN;AACF;A0B9iEI;EACE;IACE,mCAAA;E1BgjEN;E0B7iEI;IACE,+BAAA;E1B+iEN;AACF;A0B5iEI;EACE;IACE,+BAAA;E1B8iEN;E0B3iEI;IACE,mCAAA;E1B6iEN;AACF;;A0B9lEI;EACE,+BAAA;EACA,sDAAA;A1BimEN;A0B9lEI;EACE,mCAAA;EACA,yDAAA;A1BgmEN;;A0BlkFE;EACE,eAAA;EACA,aAAA;EACA,yBAAA;EAAA,sDAAA;EACA,yBtB1EI;EsB0EJ,kCtB1EI;EsB2EJ,2BAAA;EACA,iCAAA;EACA,iBAAA;EACA,oBAAA;EACA,oBAAA;EAEA,8BAAA;EACA,oBAAA;EACA,4BAAA;A1BokFJ;A4BpkFM;EFbJ;IAgBI,kBAAA;IACA,gBAAA;IACA,mBAAA;E1BqkFJ;AACF;A4B3kFM;EFbJ;IAsBI,gBAAA;IACA,mBAAA;E1BskFJ;AACF;A4BjlFM;EFbJ;IA2BI,gBAAA;E1BukFJ;AACF;A0BrkFI;EACE,iBAAA;A1BukFN;;A0BhkFE;EZ6tBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EY1tBA,kBAAA;EACA,chBiEW;EgBjEX,uChBiEW;EgBhEX,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,0BAAA;EAGA,yBAAA;A1BmkFJ;A0BjkFI;EdtHA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ0rFJ;AYxrFI;EcmHA;IdlHE,qBAAA;EZ2rFJ;AACF;;A0BpkFE;EACE,oBAAA;A1BukFJ;;A0BlkFE;;EZmsBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EY/rBA,qCAAA;UAAA,oCAAA;A1BukFJ;;A0BlkFE;EACE,yBP1IS;UO0IT,wBP1IS;AnB+sFb;;A0B/jFE;EACE,iBAAA;EACA,aAAA;EACA,4BP7JS;UO6JT,wBP7JS;EO8JT,oBAAA;EACA,gBAAA;EACA,4BPtJS;UOsJT,yBPtJS;EOuJT,yBAAA;A1BkkFJ;;A0B/jFE;EjB9KA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATivFF;AS/uFE;;;EAGE,mBAAA;ATivFJ;A0B9kFE;EZyqBE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;EYrqBA,chBgBa;EgBhBb,yChBgBa;EgBfb,6BP9KS;UO8KT,yBP9KS;AnB+vFb;;A0B9kFE;EjBtLA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATwwFF;AStwFE;;;EAGE,mBAAA;ATwwFJ;A0B7lFE;EZiqBE,kBAAA;EAAA,mDAAA;EAAA,gBAAA;EAAA,mDAAA;EAAA,gBAAA;EAAA,mDAAA;EAAA,iBAAA;EAAA,uDAAA;EY7pBA,chBKW;EgBLX,uChBKW;EgBHX,qCAAA;UAAA,oCAAA;A1B+lFJ;;A0BvlFI;EACE,yBPjLO;UOiLP,wBPjLO;AnB2wFb;A0BvlFI;EAEE,sBAAA;UAAA,qBAAA;A1BwlFN;A4BjsFM;EFiGJ;IAYI,gBAAA;E1BwlFJ;AACF;A4BtsFM;EFiGJ;IAgBI,gBAAA;IACA,mBAAA;E1BylFJ;AACF;A4B5sFM;EFiGJ;IAqBI,gBAAA;E1B0lFJ;AACF;;A0BllFI;EACE,yBP7MO;UO6MP,wBP7MO;AnBkyFb;A0BllFI;EAEE,sBAAA;UAAA,qBAAA;A1BmlFN;A4BxtFM;EF6HJ;IAYI,gBAAA;E1BmlFJ;AACF;A4B7tFM;EF6HJ;IAgBI,gBAAA;IACA,mBAAA;E1BolFJ;E0BllFI;;IAEE,wBAAA;YAAA,uBAAA;E1BolFN;AACF;A4BvuFM;EF6HJ;IA0BI,gBAAA;E1BolFJ;AACF;;A4B5uFM;EF8JJ;IAEI,gBAAA;E1BilFJ;AACF;A4BlvFM;EF8JJ;IAMI,gBAAA;IACA,mBAAA;E1BklFJ;AACF;A4BxvFM;EF8JJ;IAWI,gBAAA;E1BmlFJ;AACF;;A0B7kFE;EAEE,2CAAA;UAAA,uCAAA;EACA,6SAAA;UAAA,qSAAA;EAAA,iVAAA;UAAA,yUAAA;A1B+kFJ;;A0BpkFE;;;;EAME,wBAAA;UAAA,gBAAA;A1BqkFJ;;A0BjkFE;EACE,wBAAA;UAAA,gBAAA;A1BokFJ;;A0BhkFE;EACE,4BPtRS;UOsRT,wBPtRS;AnBy1Fb;;A0B7jFE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,2BAAA;UAAA,wBAAA;A1BgkFJ;;A0B7jFE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;A1BgkFJ;;A0B7jFE;EACE,4BAAA;A1BgkFJ;;A0B7jFE;EACE,aAAA;EACA,uBAAA;A1BgkFJ;;A0BzjFE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;A1B4jFJ;;A0BzjFE;EACE,gBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kEAAA;A1B4jFJ;A0B1jFI;EACE,yBtBlVQ;EsBkVR,wCtBlVQ;AJ84Fd;A0BzjFI;EACE,kChBsVE;EgBtVF,uChBsVE;EgBrVF,aAAA;A1B2jFN;;A0BvjFE;EACE,SAAA;A1B0jFJ;;A0BvjFE;EACE,mBAAA;EACA,ahBhIW;EgBgIX,sChBhIW;EgBiIX,oBAAA;A1B0jFJ;;A0BvjFE;EACE,gBAAA;A1B0jFJ;;A0BvjFE;;;EAKE,aAAA;A1BwjFJ;;A0BpjFE;EACE,UAAA;EACA,SAAA;A1BujFJ;;A0BnjFE;;EAEE,sChBiNS;EgBjNT,6DhBiNS;AVq2Eb;;A0BnjFE;;EGhRE,gTACE;EADF,4pBACE;EHoRF,6BAAA;EACA,yBtBtYI;EsBsYJ,kCtBtYI;EsBuYJ,sGACE;EADF,6JACE;A1BmjFN;;A0B/iFE;;EG5RE,0UACE;EADF,srBACE;EHiSF,sIACE;EADF,sMACE;A1B8iFN;;A0BziFE;;EAIE,6SAAA;UAAA,qSAAA;EAAA,iVAAA;UAAA,yUAAA;A1B0iFJ;;A0B/hFE;;;;;;;;;EA6BE,kBAAA;EACA,2BAAA;EACA,sBAAA;A1B8gFJ;;A0B3gFE;EAGE,uBAAA;A1B4gFJ;;A0BzgFE;EAGE,2BAAA;A1B0gFJ;;A0BvgFE;;EAGE,aAAA;A1BygFJ;;AqB7+FE;EKweA;ILteI,gBAAA;IACA,4BAAA;ErBg/FJ;AACF;;A8Bx+FE;;;;;;EAME,sCAAA;EAAA,+CAAA;EACA,gCpB0KW;EoB1KX,yDpB0KW;AVi0Ff;;A8Bx+FE;ErBxBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATogGF;ASlgGE;;;EAGE,mBAAA;ATogGJ;;A8Bn/FE;EhB2zBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EgBxzBA,aAAA;EAIA,cAAA;EACA,sBAAA;EACA,uBAAA;A9Bq/FJ;;A+BhhGE;EACE,eAAA;A/BmhGJ;A+BhhGE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BihGJ;A+B9gGE;EACE,0GAhBiB;A/BgiGrB;A+B7gGE;ECiEA,gBAAA;AhC+8FF;A8BngGE;EhB+yBE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;EgB3yBA,qBAAA;EACA,cpBqJa;EoBrJb,yCpBqJa;EoBpJb,gBApCiB;EAqCjB,iBAAA;EACA,4BXtCS;UWsCT,wBXtCS;EWuCT,wBAAA;A9BsgGJ;;A8BngGE;EhBmyBE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;AduuEJ;;A8BtgGE;EACE,uBAAA;UAAA,mBAAA;A9BygGJ;;A8BtgGE;EACE,kBAAA;EACA,yBAAA;EACA,0BAAA;A9BygGJ;;A8BtgGE;EnB/DA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATolGF;ASllGE;;;EAGE,mBAAA;ATolGJ;AW9kGE;EACE,SAAA;AXglGJ;A8BhiGE;EAGE,aAAA;EACA,mBAAA;EACA,uBAAA;EhBgxBA,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;AdoxEJ;;A8BhiGE;EAGE,uCAAA;EAAA,4CAAA;A9BiiGJ;;A8B9hGE;EACE,apBmKa;EoBnKb,wCpBmKa;AV83FjB;;A8B9hGE;EAKE,apBwJW;EoBxJX,sCpBwJW;AVq4Ff;;A8B1hGE;EACE,yBAAA;EACA,0BAAA;A9B6hGJ;;A8BzhGE;EV7FA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB0nGF;AoBxnGE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBwnGJ;AoBrnGE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBunGJ;AoBrnGI;EAVF;IAWI,eAAA;EpBwnGJ;AACF;AqBvpGE;ESiGA;IV7DE,sBAAA;EpBunGF;EoBrnGE;IACE,kBAAA;IACA,yBAAA;EpBunGJ;AACF;A8B/jGE;EAGE,oBAAA;EAEA,sBAAA;A9B8jGJ;;A8B3jGE;;EAEE,2GAAA;A9B8jGJ;;A8B3jGE;;;;;;;;;ElB5EE,0BAAA;EAAA,oDAAA;EACA,oBAAA;AZmpGJ;AYjpGI;EkByEF;;;;;;;;;IlBxEI,qBAAA;EZ4pGJ;AACF;;A8BjjGI;;;;;;;;;;;;;;;;;;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;A9BqkGN;;A8B9jGI;;EACE,oBAAA;EACA,iBAAA;EACA,SAAA;EACA,iBAAA;EACA,uBAAA;UAAA,mBAAA;EACA,oBAAA;EACA,6BX5JO;UW4JP,4BX5JO;AnB8tGb;;A8BnjGI;;;;;;;;;;;EACE,cpBqBO;EoBrBP,qCpBqBO;AV2iGb;;A8B3jGE;;EAEE,cAAA;A9B8jGJ;;A8B3jGE;EACE,aAAA;A9B8jGJ;;A8B3jGE;EACE,kCAAA;EACA,SAAA;A9B8jGJ;;A8B1jGE;EACE,gBAAA;A9B6jGJ;;A+B9vGE;EACE,eAAA;A/BiwGJ;A+B9vGE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B+vGJ;A+B5vGE;EACE,0GAhBiB;A/B8wGrB;A+B3vGE;ECiEA,gBAAA;AhC6rGF;A8B3kGE;EhByoBE,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA,2DAAA;EAAA,sBAAA;EAAA,gEAAA;EgBroBA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;A9B6kGJ;;A8B1kGE;EACE,wBAAA;UAAA,qBAAA;A9B6kGJ;;A8B1kGE;EhB2nBE,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA,2DAAA;EAAA,sBAAA;EAAA,gEAAA;EgBxnBA,UAAA;EACA,cpBxBU;EoBwBV,sCpBxBU;EoB0BV,iBAAA;EACA,8BX9NS;UW8NT,2BX9NS;EW+NT,UAAA;A9B6kGJ;;A8B1kGE;;EAEE,6BpBlBY;EoBkBZ,uDpBlBY;AV+lGhB;;A8BzkGE;;EAEE,6BpBxBY;EoBwBZ,uDpBxBY;AVomGhB;;AiC1zGE;EACE,oBAAA;EACA,aAAA;EAAA,mCAAA;EACA,sBAAA;AjC6zGJ;;AiC1zGE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EAAA,eAAA;EAAA,qCAAA;EAAA,gCAAA;AjC6zGJ;;AiCvzGI;E/B2BF,yBAAA;AFgyGF;;AiC3zGI;E/B2BF,wBAAA;AFoyGF;;AiC/zGI;E/B2BF,uBAAA;AFwyGF;;AiCn0GI;E/B2BF,wBAAA;AF4yGF;;AiCv0GI;E/B2BF,qBAAA;AFgzGF;;AiC30GI;E/B2BF,uBAAA;AFozGF;;AiC/0GI;E/B2BF,qBAAA;AFwzGF;;AiCn1GI;E/B2BF,uBAAA;AF4zGF;;AiCv1GI;E/B2BF,qBAAA;AFg0GF;;AiC31GI;E/B2BF,qBAAA;AFo0GF;;AiC/1GI;E/B2BF,qBAAA;AFw0GF;;AiCn2GI;E/B2BF,qBAAA;AF40GF;;AiCv2GI;E/B2BF,sBAAA;AFg1GF;;AkCn3GE;EzBRA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT+3GF;AS73GE;;;EAGE,mBAAA;AT+3GJ;;AkC73GE;EACE,kBAAA;EACA,8BAAA;UAAA,0BAAA;AlCg4GJ;;AkC53GE;EACE,wBAAA;UAAA,qBAAA;AlC+3GJ;;AkC13GE;EACE,gCAAA;UAAA,6BAAA;AlC63GJ;;AkCz3GE;EACE,+BAAA;UAAA,2BAAA;AlC43GJ;;AkCv3GE;E5BlCA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;E4B4BE,0BAAA;EACA,0BAAA;AlCk4GJ;;A+Bh6GE;EACE,eAAA;A/Bm6GJ;A+Bh6GE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/Bi6GJ;A+B95GE;EACE,0GAhBiB;A/Bg7GrB;A+B75GE;ECiEA,gBAAA;AhC+1GF;AkC74GE;EpByyBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EoBryBA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,iCAAA;UAAA,8BAAA;EACA,8BAAA;UAAA,6BAAA;EACA,yBAAA;UAAA,iBAAA;AlCg5GJ;;AkC74GE;EAEE,+BAAA;UAAA,8BAAA;AlC+4GJ;;AkC34GE;;EAEE,sBAAA;AlC84GJ;AkC54GI;EAJF;;IAKI,iCAAA;YAAA,yBAAA;ElCg5GJ;AACF;;AkC54GE;EAKE,kBAAA;EACA,yBAAA;EAAA,kDAAA;EACA,kBAAA;AlC24GJ;AqB39GE;EayEA;IASI,8BAAA;ElC64GJ;AACF;AkCv5GE;EAaE,6BAAA;EACA,gBAAA;EACA,WAAA;EAKA,iBAAA;EACA,2BAAA;EACA,qBAAA;EAGA,gCAAA;EACA,0BAAA;AlCu4GJ;;AkCn4GE;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yCAAA;UAAA,qCAAA;EAAA,kEAAA;UAAA,8DAAA;EACA,yCAAA;UAAA,wCAAA;EAAA,kEAAA;UAAA,iEAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,iCAAA;UAAA,8BAAA;EACA,kCAAA;EACA,8BAAA;AlCs4GJ;;AkC93GE;;;EAGE,YAAA;EACA,iBAAA;EACA,yBxBgHW;EwBhHX,kDxBgHW;AVixGf;AqBjgHE;Ea2HA;;;IAUI,8BAAA;IACA,8BAAA;ElCk4GJ;AACF;;AkC93GE;;EAEE,kCAAA;AlCi4GJ;;AkC73GE;EACE,uCAAA;UAAA,mCAAA;EAAA,gEAAA;UAAA,4DAAA;EACA,qCAAA;UAAA,oCAAA;EAAA,8DAAA;UAAA,6DAAA;EACA,mBAAA;EACA,4BAAA;EACA,gCAAA;AlCg4GJ;;AkCx3GE;;;;;EAOE,uCAAA;EAAA,4CAAA;EACA,mBAAA;AlCy3GJ;;AkCl3GE;;EAEE,6BxBsCY;EwBtCZ,uDxBsCY;EwBrCZ,mBAAA;AlCq3GJ;;AkCl3GE;;EAEE,oCxB0EY;EwB1EZ,8DxB0EY;AV2yGhB;;AkCl3GE;;;EAIE,wCxBmEY;EwBnEZ,kExBmEY;AVizGhB;;AkC92GE;;;EAKE,yBAAA;EAAA,mDAAA;AlC+2GJ;;AkC32GE;;;EASE,aAAA;AlCw2GJ;;AkCr2GE;;EAOE,yBAAA;EAAA,kDAAA;AlCm2GJ;;AkCh2GE;;EAEE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,8BfnOS;UemOT,2BfnOS;AnBskHb;;AkCh2GE;EACE,uCAAA;EACA,axB0BY;EwB1BZ,uCxB0BY;EwBzBZ,qBAAA;AlCm2GJ;;AkCh2GE;EACE,axB2Bc;EwB3Bd,yCxB2Bc;AVw0GlB;;AkCh2GE;EACE,aAAA;AlCm2GJ;;AkCh2GE;;;;EAQE,aAAA;AlC+1GJ;;AkC51GE;;;;EAYE,cAAA;EACA,iBAAA;EACA,wBAAA;UAAA,qBAAA;EACA,4BfzQS;UeyQT,2BfzQS;Ee0QT,oBAAA;AlCu1GJ;;AkCp1GE;;EAME,cxBlFS;EwBkFT,qCxBlFS;AVq6Gb;;AkC70GE;;EAEE,eAAA;AlCg1GJ;;AkC70GE;;EAEE,YAAA;EACA,yBAAA;UAAA,iBAAA;AlCg1GJ;;AkC70GE;;EAME,oCxBnDY;EwBmDZ,8DxBnDY;AV+3GhB;;AkCz0GE;;EAME,wCAAA;EAAA,kEAAA;EACA,uBAAA;AlCw0GJ;;AkCr0GE;;EAME,qBxBxIW;EwBwIX,8CxBxIW;AV48Gf;AqBzoHE;Ea+TA;;IAWI,sBAAA;ElCo0GJ;AACF;;AkC9zGE;EACE,eAAA;AlCi0GJ;;AkC9zGE;EdjVA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBmpHF;AoBjpHE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBipHJ;AoB9oHE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBgpHJ;AoB9oHI;EAVF;IAWI,eAAA;EpBipHJ;AACF;AqBhrHE;EaqVA;IdjTE,sBAAA;EpBgpHF;EoB9oHE;IACE,kBAAA;IACA,yBAAA;EpBgpHJ;AACF;AkCp2GE;EAIE,gBfvUS;EewUT,oBAAA;EACA,yBAAA;EACA,yBAAA;AlCm2GJ;;AkC71GE;EACE,kBAAA;AlCg2GJ;;AkC51GE;EACE,wBAAA;UAAA,qBAAA;EACA,gCAAA;UAAA,+BAAA;EACA,wBAAA;AlC+1GJ;;AkC51GE;;EAKE,iDAAA;AlC41GJ;;AkCt1GE;;EAEE,aAAA;AlCy1GJ;;AkCt1GE;;EAEE,aAAA;AlCy1GJ;;AkCt1GE;;EAQE,4BflYS;UekYT,2BflYS;AnBqtHb;;AkCh1GE;;;;EAUE,4Bf/YS;Ue+YT,2Bf/YS;AnB4tHb;;AkC10GE;EAGE,oBAAA;EACA,iCAAA;UAAA,8BAAA;AlC20GJ;;AkCx0GE;;EAME,oBAAA;EACA,iCAAA;UAAA,8BAAA;AlCu0GJ;;AkCj0GE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AlCo0GJ;AkCl0GI;EACE,UAAA;EACA,uBAAA;UAAA,mBAAA;AlCo0GN;AkCl0GM;EACE,wBfvaK;UeuaL,uBfvaK;AnB2uHb;AkCh0GI;EACE,6BftbO;UesbP,4BftbO;AnBwvHb;AkC/zGI;EACE,wBAAA;UAAA,qBAAA;AlCi0GN;;AmChvHE;EjCsBA,0PAAA;EAAA,uOAAA;EO3CA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT2wHF;ASzwHE;;;EAGE,mBAAA;AT2wHJ;AmCjwHE;ErBk0BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EF1yBA,8BAAA;EACA,oBAAA;EuBlBA,yDAAA;EACA,YAAA;EACA,yB/BNI;E+BMJ,kC/BNI;E+BOJ,+CAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,czB8JW;EyB9JX,uCzB8JW;EyB7JX,oBAAA;EAEA,iBAAA;EACA,+GACE;AnCiwHN;AmC9vHI;EvBvBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZwxHJ;AYtxHI;EuBoBA;IvBnBE,qBAAA;EZyxHJ;AACF;AmClwHI;EACE,aAAA;AnCowHN;;AmChwHE;EACE,2BhBjBS;UgBiBT,0BhBjBS;AnBoxHb;;AmChwHE;EACE,yBhB1BS;UgB0BT,wBhB1BS;AnB6xHb;;AmChwHE;EACE,yBhBpBS;UgBoBT,wBhBpBS;AnBuxHb;;AmChwHE;EC5DA,4B1BkMiB;E0BlMjB,yD1BkMiB;E0BjMjB,UAAA;ApCg0HF;;AmChwHE;EACE,yBzB2DO;EyB3DP,8CzB2DO;AVwsHX;;AmC7vHE;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;AnCgwHJ;;AmC7vHE;EACE,kBAAA;EACA,azBoLY;EyBpLZ,uCzBoLY;EyBlLZ,sBAAA;EACA,sBhBlES;EgBmET,2BAAA;AnC+vHJ;;AmC5vHE;EACE,azBkLc;EyBlLd,yCzBkLc;AV6kHlB;;AmC5vHE;EACE,aE/FQ;EFgGR,UAAA;AnC+vHJ;;AmC3vHE;EG7BA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;AtC4xHF;AsC1xHE;E1BvEE,uCAAA;EAAA,4CAAA;AZo2HJ;AYl2HI;E0BqEF;I1BpEI,qBAAA;EZq2HJ;AACF;AmC1wHE;EGfE,eAAA;AtC4xHJ;AsC1xHI;EACE,8BAAA;AtC4xHN;AsC1xHM;E1BrFF,uCAAA;EAAA,4CAAA;AZk3HJ;AYh3HI;E0BmFE;I1BlFA,qBAAA;EZm3HJ;AACF;AsCxxHE;;;EAIE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AtCyxHJ;AsCtxHI;EAZF;;;IAaI,qBAAA;EtC2xHJ;AACF;AsCxxHE;EAEE,wDAAA;AtCyxHJ;AsCvxHI;EAJF;IAKI,gBAAA;EtC0xHJ;AACF;AsCvxHE;EAEE,gBAAA;AtCwxHJ;AsCpxHE;EACE,mBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;AtCsxHJ;AsCnxHE;;EAEE,uBAAA;EACA,cAAA;EAGA,UAAA;EAEA,mBAAA;EACA,sBAAA;AtCkxHJ;AsC7wHE;;;EbtJA,wCAAA;EAAA,2DAAA;EawBA,aAAA;EAIE,uBAAA;EAGF,uBAAA;EACA,yB5BNmB;E4BMnB,wD5BNmB;E4BOnB,gBAAA;EACA,c5ByKa;E4BzKb,uC5ByKa;E4BxKb,gBAAA;EACA,gCAAA;EAAA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;ExB4yBE,mBAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;AdomGJ;AsC54HE;EA0GA;;;IAzGE,iBAAA;EtCi5HF;AACF;AsC/4HE;EAsGA;;;IArGE,iBAAA;EtCo5HF;AACF;AsCn5HE;EAmGA;;;IAlGE,iBAAA;EtCw5HF;AACF;AsCr5HE;EA8FA;;;IA7FE,6BAAA;EtC05HF;AACF;AsCxzHE;EACE,yBAAA;AtC0zHJ;AsCvzHE;EACE,aAAA;AtCyzHJ;AsCnzHI;EAEE,UAAA;AtCozHN;AsCjzHI;EACE;IACE,UAAA;EtCmzHN;EsChzHI;IACE,UAAA;EtCkzHN;AACF;AsC/yHI;;;;EAEE,iBAAA;EACA,YAAA;EACA,UAAA;AtCmzHN;AsChzHI;;;;EAGE,iEAAA;AtCmzHN;AsC9yHE;EAEE,gBAAA;EACA,YAAA;EACA,sBAAA;AtC+yHJ;AsC5yHE;EACE,eAAA;EACA,UAAA;AtC8yHJ;AsCjxHE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EAIE,mBAAA;EACA,iBAAA;EACA,qBAAA;EAgBA,2BAAA;AtCiwHN;AsCzvHE;;;EAaI,kBAAA;EACA,uBAAA;AtCivHN;AsCzuHE;EAoBI,iCAAA;EACA,6CAAA;EAAA,4EAAA;EACA,wBAAA;EACA,gCAAA;AtCwtHN;AsCzsHE;;;EAqBI,2BAAA;EAQE,gCAAA;AtCkrHR;;AmCj7HE;EvB5DE,8BAAA;EACA,oBAAA;EuB8DA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wDAAA;AnCo7HJ;;AmCj7HE;EACE,2BAAA;AnCo7HJ;;AmCj7HE;EACE,uBhB7FS;AnBihIb;;AmCj7HE;EAEE,iBAAA;AnCm7HJ;;AmCh7HE;EAEE,iBAAA;AnCk7HJ;;AmC/6HE;EAEE,azBmGW;EyBnGX,sCzBmGW;AV80Hf;;AmC96HE;EvBhIE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZkjIJ;AYhjII;EuB6HF;IvB5HI,qBAAA;EZmjIJ;AACF;;AmCp7HE;;EAEE,2BhBrHS;UgBqHT,0BhBrHS;AnB4iIb;;AmCp7HE;EACE,yBAAA;UAAA,wBAAA;AnCu7HJ;;AmCp7HE;EAEE,sBhB7IS;AnBmkIb;;AmCn7HE;EACE,wBhBlIS;AnBwjIb;;AmCn7HE;EAEE,mBAAA;AnCq7HJ;;AmCl7HE;EAGE,4BzBiFY;EyBjFZ,sDzBiFY;AVk2HhB;AmCj7HI;EACE,4BzB8EU;EyB9EV,sDzB8EU;AVq2HhB;;AmC96HI;EACE,4BzBwEU;EyBxEV,sDzBwEU;AVy2HhB;AmCn7HE;EAKE,eAAA;AnCi7HJ;;AmC76HI;EACE,4BzBgEU;EyBhEV,sDzBgEU;AVg3HhB;AmCl7HE;EAKE,eAAA;AnCg7HJ;;AmC76HE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AnCg7HJ;;AmC16HE;EvBxKE,8BAAA;EACA,oBAAA;EuB0KA,yB/BhMI;E+BgMJ,kC/BhMI;E+BkMJ,2CAAA;UAAA,uCAAA;EACA,6BzBJY;EyBIZ,uDzBJY;EyBKZ,mBAAA;EAEA,+CzBPY;EyBOZ,yEzBPY;AVk7HhB;;AmCv6HE;EACE,yBzBnGO;EyBmGP,8CzBnGO;AV6gIX;;AmCv6HE;EACE,6BzBhBY;EyBgBZ,uDzBhBY;EyBiBZ,UAAA;AnC06HJ;;AmCp6HE;EvB1ME,0BAAA;EAAA,oDAAA;EACA,oBAAA;AZknIJ;AYhnII;EuBuMF;IvBtMI,qBAAA;EZmnIJ;AACF;AmC96HE;EAGE,gBAAA;AnC86HJ;AmC56HI;EACE,wBhBjNO;AnB+nIb;;AmCv6HE;EfrPA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBgqIF;AoB9pIE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB8pIJ;AoB3pIE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB6pIJ;AoB3pII;EAVF;IAWI,eAAA;EpB8pIJ;AACF;AqB7rIE;EcyPA;IfrNE,sBAAA;EpB6pIF;EoB3pIE;IACE,kBAAA;IACA,yBAAA;EpB6pIJ;AACF;;AmCp8HE;EACE,kBAAA;EACA,mB/B9OI;E+B8OJ,4B/B9OI;E+B+OJ,+GACE;AnCs8HN;;AmCl8HE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,wBhBhQS;AnBqsIb;;AmCl8HE;EACE,aAAA;AnCq8HJ;;AmCl8HE;EACE,4BAAA;EACA,oBAAA;AnCq8HJ;;AmCl8HE;;EAEE,aAAA;AnCq8HJ;;AmCl8HE;;EAEE,0BAAA;UAAA,sBAAA;AnCq8HJ;;AmCl8HE;;EAME,cAAA;EACA,mBAAA;EACA,qB/BvRY;E+BuRZ,sC/BvRY;E+BwRZ,cAAA;EACA,0BAAA;UAAA,sBAAA;AnCi8HJ;;AmC97HE;EACE,uBAAA;AnCi8HJ;;AmC97HE;;EAME,aAAA;AnC67HJ;;AmC17HE;EACE,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;AnC67HJ;;AmC17HE;EvBpSE,0BAAA;EAAA,oDAAA;EACA,oBAAA;AZkuIJ;AYhuII;EuBiSF;IvBhSI,qBAAA;EZmuIJ;AACF;;AmC/7HE;;EvB3TE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ+vIJ;AY7vII;EuBwTF;;IvBvTI,qBAAA;EZiwIJ;AACF;;AmCp8HE;;EAME,aAAA;AnCm8HJ;;AmC57HE;EACE,mBAAA;AnC+7HJ;;AmC57HE;EACE,SAAA;EACA,uBAAA;EACA,yBAAA;EACA,sBAAA;AnC+7HJ;;AmC57HE;EACE,gCAAA;UAAA,6BAAA;AnC+7HJ;;AmC57HE;EACE,gCAAA;UAAA,6BAAA;AnC+7HJ;;AmC57HE;EACE,SAAA;EACA,sBAAA;EACA,0BAAA;UAAA,yBAAA;EACA,qBAAA;EACA,yBAAA;AnC+7HJ;;AmC57HE;EACE,+BAAA;UAAA,4BAAA;AnC+7HJ;;AmC57HE;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AnC+7HJ;;AmC57HE;EACE,SAAA;EACA,sBAAA;AnC+7HJ;;AmC57HE;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AnC+7HJ;;AmC57HE;EAEE,czB3MS;EyB2MT,qCzB3MS;AVyoIb;;AmCv7HE;;EAEE,uBAAA;EACA,+B/BrYY;E+BqYZ,gD/BrYY;AJ+zIhB;;AmCt7HE;;;EAKE,kBAAA;EACA,sBAAA;EACA,sBhBvZS;EgBwZT,2BAAA;AnCu7HJ;;AmCp7HE;;;EN7ZA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;AVkyHnB;;AmCt6HE;;;EAQE,2BhBzaS;UgByaT,0BhBzaS;AnB60Ib;;AmCj6HE;;;;;;EAUE,yBhB5aS;UgB4aT,wBhB5aS;AnB40Ib;;AmC75HE;;;;;;EAUE,wBhBncS;AnB+1Ib;;AmCx5HE;EAKE,gBAAA;AnCu5HJ;;AmCp5HE;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;AnCu5HJ;;AuC53IE;E9BhBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATg5IF;AS94IE;;;EAGE,mBAAA;ATg5IJ;AuC34IE;EzBu0BE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EF1yBA,8BAAA;EACA,oBAAA;E2BzBA,iEAAA;EACA,YAAA;EACA,yBnCCI;EmCDJ,kCnCCI;EmCAJ,gBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,c7BqKW;E6BrKX,uC7BqKW;E6BpKX,oBAAA;EACA,sBAAA;EAEA,sBAAA;EACA,gBAAA;EACA,+GACE;AvC64IN;;AuCz4IE;;E3BnBE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZi6IJ;AY/5II;E2BgBF;;I3BfI,qBAAA;EZm6IJ;AACF;;AuCh5IE;EHvCA,4B1BkMiB;E0BlMjB,yD1BkMiB;E0BjMjB,UAAA;EtBm1BE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;Ad4mHJ;;AuCn5IE;EACE,yB7B+EO;E6B/EP,8C7B+EO;AVu0IX;;AuCn5IE;ErCTA,uOAAA;EqCYE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,qBAAA;AvCq5IJ;;AuCl5IE;EACE,iBAAA;AvCq5IJ;;AuCl5IE;EACE,kBAAA;EACA,a7BoMY;E6BpMZ,uC7BoMY;E6BnMZ,0BpBrDS;EoBsDT,gEAAA;AvCq5IJ;;AuCl5IE;EACE,a7BoMc;E6BpMd,yC7BoMc;AVitIlB;;AuCl5IE;EACE,aF7EQ;EE8ER,UAAA;AvCq5IJ;;AuCl5IE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;AvCq5IJ;;AuCj5II;EACE,gCAAA;EAAA,wBAAA;AvCo5IN;;AuC74IE;EACE,yBnC9EI;EmC8EJ,kCnC9EI;EmC+EJ,2CAAA;UAAA,uCAAA;EACA,6B7B+GY;E6B/GZ,uD7B+GY;E6B9GZ,mBAAA;EACA,aAAA;EACA,YAAA;AvCg5IJ;;AuC74IE;EACE,6B7BwGY;E6BxGZ,uD7BwGY;AVwyIhB;;AuC14IE;EACE,uBAAA;EACA,+BnC5FY;EmC4FZ,gDnC5FY;AJy+IhB;;AuCz4IE;;;EAKE,kBAAA;EACA,0BpBlHS;EoBmHT,sBpB9GS;AnBw/Ib;;AuCv4IE;;;EAME,0BpBtIS;EoBuIT,wBpBlIS;EoBmIT,uBAAA;AvCu4IJ;;AuCp4IE;;;EV9HA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;AVm9HnB;;AuCv3IE;;;EAQE,2BpBzIS;UoByIT,0BpBzIS;AnB8/Ib;;AuCl3IE;;;;;;EAUE,yBpB5IS;UoB4IT,wBpB5IS;AnB6/Ib;;AuC92IE;;;;;;EAUE,wBpBnKS;AnBghJb;;AuC12IE;;;;;;EAYE,sBpBvLS;AnB8hJb;;AuCn2IE;EnBnNA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB0jJF;AoBxjJE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBwjJJ;AoBrjJE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBujJJ;AoBrjJI;EAVF;IAWI,eAAA;EpBwjJJ;AACF;AqBvlJE;EkBuNA;InBnLE,sBAAA;EpBujJF;EoBrjJE;IACE,kBAAA;IACA,yBAAA;EpBujJJ;AACF;AuCz4IE;EAGE,mBAAA;EACA,iBAAA;AvCy4IJ;AuCv4II;EACE,kBAAA;AvCy4IN;;AuCr4IE;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;AvCw4IJ;;AwClmJE;EtC6BA,qCAAA;AFykJF;AQtjJQ;ENnBN,0DAAA;AF4kJF;AwCzmJE;EtC6BA,qCAAA;AF+kJF;AQ5jJQ;ENnBN,0DAAA;AFklJF;AwC/mJE;EtC6BA,mCAAA;AFqlJF;AQlkJQ;ENnBN,0DAAA;AFwlJF;AwCrnJE;EtC6BA,iCAAA;AF2lJF;AQxkJQ;ENnBN,0DAAA;AF8lJF;AwC3nJE;EtC6BA,0PAAA;EY4yBE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;E2Bl1BF,yBCg/BoB;EDh/BpB,yDCg/BoB;ED/+BpB,cCo/Be;EDp/Bf,yCCo/Be;A1CwpHjB;AyC1oJE;EACE,yBAAA;EAAA,yDAAA;AzC4oJJ;AyC1oJI;EACE,yBCg/BW;EDh/BX,oDCg/BW;A1C4pHjB;AyCvoJI;EACE,yBC0+BW;ED1+BX,oDC0+BW;A1C+pHjB;AyCpoJI;EACE,cCk+BW;EDl+BX,yCCk+BW;A1CoqHjB;AwChpJE;EAkBE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EAEA,sBAAA;EACA,mDAAA;EAEA,qBAAA;EACA,sBrBhCS;EqBiCT,sBAAA;EACA,sBAAA;AxC+nJJ;AwC7nJI;EACE,8BrBhCO;UqBgCP,6BrBhCO;AnB+pJb;AwC5nJI;EACE,8BrB9CO;UqB8CP,6BrB9CO;AnB4qJb;AwC3nJI;EACE,uBrBxCO;AnBqqJb;AwC1nJI;EACE,6BrBjDO;UqBiDP,4BrBjDO;AnB6qJb;AwCznJI;EACE,SAAA;AxC2nJN;AwCxnJI;EACE,uBAAA;UAAA,sBAAA;AxC0nJN;;AwCtnJE;;;EAGE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AxCynJJ;;AwCtnJE;EACE,uCAAA;EAAA,4CAAA;EACA,mBAAA;AxCynJJ;;AwCrnJE;EACE,gBAAA;EACA,sBAAA;UAAA,qBAAA;AxCwnJJ;AwCtnJI;EACE,aAAA;AxCwnJN;;AwCpnJE;EACE,yBAAA;EAAA,oDAAA;EACA,yBpCnFI;EoCmFJ,kCpCnFI;EoCoFJ,c9B6FW;E8B7FX,uC9B6FW;E8B5FX,eAAA;AxCunJJ;AwCrnJI;EACE,yBpCrFQ;EoCqFR,wCpCrFQ;EoCsFR,aAAA;AxCunJN;AwCpnJI;EACE,uCAAA;EAAA,4CAAA;EACA,mBAAA;AxCsnJN;;AwClnJE;EACE,yB9BxBqB;E8BwBrB,4D9BxBqB;E8ByBrB,c9B4FW;E8B5FX,uC9B4FW;AVyhJf;AwCnnJI;EACE,yB9B5BmB;E8B4BnB,4D9B5BmB;AVipJzB;;AwCjnJE;EACE,yBAAA;EAAA,qDAAA;EACA,yBE03BkB;EF13BlB,yDE03BkB;EFz3BlB,cE83Ba;EF93Bb,yCE83Ba;EF73Bb,eAAA;AxConJJ;AwClnJI;EACE,yBE43BW;EF53BX,oDE43BW;EF33BX,aAAA;AxConJN;AwCjnJI;EACE,uCAAA;EAAA,4CAAA;EACA,mBAAA;AxCmnJN;;AwC/mJE;ECrIA,yBCq6BmB;EDr6BnB,wDCq6BmB;EDp6BnB,cCy6Bc;EDz6Bd,wCCy6Bc;A1C+0HhB;AyCtvJE;EACE,yBAAA;EAAA,oDAAA;AzCwvJJ;AyCtvJI;EACE,yBCq6BU;EDr6BV,mDCq6BU;A1Cm1HhB;AyCnvJI;EACE,yBC+5BU;ED/5BV,mDC+5BU;A1Cs1HhB;AyChvJI;EACE,cCu5BU;EDv5BV,wCCu5BU;A1C21HhB;;AwCvnJE;EC9IA,yBC86BuB;ED96BvB,4DC86BuB;ED76BvB,cCk7BkB;EDl7BlB,4CCk7BkB;A1Cu1HpB;AyCvwJE;EACE,yBAAA;EAAA,wDAAA;AzCywJJ;AyCvwJI;EACE,yBCi7Bc;EDj7Bd,uDCi7Bc;A1Cw1HpB;AyCpwJI;EACE,yBC26Bc;ED36Bd,uDC26Bc;A1C21HpB;AyCjwJI;EACE,cCg6Bc;EDh6Bd,4CCg6Bc;A1Cm2HpB;;AwC/nJE;ECvJA,yBC67BsB;ED77BtB,2DC67BsB;ED57BtB,cCi8BiB;EDj8BjB,2CCi8BiB;A1Cy1HnB;AyCxxJE;EACE,yBAAA;EAAA,uDAAA;AzC0xJJ;AyCxxJI;EACE,yBCg8Ba;EDh8Bb,sDCg8Ba;A1C01HnB;AyCrxJI;EACE,yBC07Ba;ED17Bb,sDC07Ba;A1C61HnB;AyClxJI;EACE,cC+6Ba;ED/6Bb,2CC+6Ba;A1Cq2HnB;;AwCvoJE;EChKA,yBC48BoB;ED58BpB,yDC48BoB;ED38BpB,cCg9Be;EDh9Bf,yCCg9Be;A1C21HjB;AyCzyJE;EACE,yBAAA;EAAA,qDAAA;AzC2yJJ;AyCzyJI;EACE,yBC48BW;ED58BX,oDC48BW;A1C+1HjB;AyCtyJI;EACE,yBCs8BW;EDt8BX,oDCs8BW;A1Ck2HjB;AyCnyJI;EACE,cC87BW;ED97BX,yCC87BW;A1Cu2HjB;;AwC/oJE;ECzKA,yBCq9BoB;EDr9BpB,yDCq9BoB;EDp9BpB,cCy9Be;EDz9Bf,yCCy9Be;A1Cm2HjB;AyC1zJE;EACE,yBAAA;EAAA,qDAAA;AzC4zJJ;AyC1zJI;EACE,yBCq9BW;EDr9BX,oDCq9BW;A1Cu2HjB;AyCvzJI;EACE,yBC+8BW;ED/8BX,oDC+8BW;A1C02HjB;AyCpzJI;EACE,cCu8BW;EDv8BX,yCCu8BW;A1C+2HjB;;AwCvpJE;EClLA,yBC89BoB;ED99BpB,yDC89BoB;ED79BpB,cCk+Be;EDl+Bf,yCCk+Be;A1C22HjB;AyC30JE;EACE,yBAAA;EAAA,qDAAA;AzC60JJ;AyC30JI;EACE,yBC89BW;ED99BX,oDC89BW;A1C+2HjB;AyCx0JI;EACE,yBCw9BW;EDx9BX,oDCw9BW;A1Ck3HjB;AyCr0JI;EACE,cCg9BW;EDh9BX,yCCg9BW;A1Cu3HjB;;AwC/pJE;EC3LA,yBCu+BqB;EDv+BrB,0DCu+BqB;EDt+BrB,cC2+BgB;ED3+BhB,0CC2+BgB;A1Cm3HlB;AyC51JE;EACE,yBAAA;EAAA,sDAAA;AzC81JJ;AyC51JI;EACE,yBCu+BY;EDv+BZ,qDCu+BY;A1Cu3HlB;AyCz1JI;EACE,yBCi+BY;EDj+BZ,qDCi+BY;A1C03HlB;AyCt1JI;EACE,cCy9BY;EDz9BZ,0CCy9BY;A1C+3HlB;;AwCvqJE;ECpMA,yBCg/BoB;EDh/BpB,yDCg/BoB;ED/+BpB,cCo/Be;EDp/Bf,yCCo/Be;A1C23HjB;AyC72JE;EACE,yBAAA;EAAA,qDAAA;AzC+2JJ;AyC72JI;EACE,yBCg/BW;EDh/BX,oDCg/BW;A1C+3HjB;AyC12JI;EACE,yBC0+BW;ED1+BX,oDC0+BW;A1Ck4HjB;AyCv2JI;EACE,cCk+BW;EDl+BX,yCCk+BW;A1Cu4HjB;;AwC/qJE;EC7MA,yBC4hCyB;ED5hCzB,8DC4hCyB;ED3hCzB,cCgiCoB;EDhiCpB,8CCgiCoB;A1Cg2HtB;AyC93JE;EACE,yBAAA;EAAA,0DAAA;AzCg4JJ;AyC93JI;EACE,yBC+hCgB;ED/hChB,yDC+hCgB;A1Ci2HtB;AyC33JI;EACE,yBCyhCgB;EDzhChB,yDCyhCgB;A1Co2HtB;AyCx3JI;EACE,cC8gCgB;ED9gChB,8CC8gCgB;A1C42HtB;;AwCvrJE;ECtNA,yBC2iCyB;ED3iCzB,8DC2iCyB;ED1iCzB,cC+iCoB;ED/iCpB,8CC+iCoB;A1Ck2HtB;AyC/4JE;EACE,yBAAA;EAAA,0DAAA;AzCi5JJ;AyC/4JI;EACE,yBC8iCgB;ED9iChB,yDC8iCgB;A1Cm2HtB;AyC54JI;EACE,yBCwiCgB;EDxiChB,yDCwiCgB;A1Cs2HtB;AyCz4JI;EACE,cC6hCgB;ED7hChB,8CC6hCgB;A1C82HtB;;AwC/rJE;EC/NA,yB/BwBmB;E+BxBnB,wD/BwBmB;E+BvBnB,c/BwMa;E+BxMb,uC/BwMa;AV0tJf;AyCh6JE;EACE,yBAAA;EAAA,wDAAA;AzCk6JJ;AyCh6JI;EACE,yB/BoBqB;E+BpBrB,8D/BoBqB;AV84J3B;AyC75JI;EACE,yB/BcqB;E+BdrB,8D/BcqB;AVi5J3B;AyC15JI;EACE,c/BsLS;E+BtLT,uC/BsLS;AVsuJf;;AwCrsJI;EACE,6BAAA;AxCwsJN;;AwCpsJE;EC/OA,yB/BMW;E+BNX,gD/BMW;E+BLX,c/ByLa;E+BzLb,uC/ByLa;AV8vJf;AyCr7JE;EACE,yBAAA;EAAA,gDAAA;AzCu7JJ;AyCr7JI;EACE,yBrCKQ;EqCLR,wCrCKQ;AJk7Jd;AyCl7JI;EACE,yBrCDQ;EqCCR,wCrCDQ;AJq7Jd;AyC/6JI;EACE,c/BuKS;E+BvKT,uC/BuKS;AV0wJf;AwCrtJE;EAKE,0BAAA;EAAA,yDAAA;EACA,oBAAA;AxCmtJJ;;AwChtJE;;;ECxPA,yBrCSM;EqCTN,kCrCSM;EqCRN,6B/BiNc;E+BjNd,uD/BiNc;AV6vJhB;AyC58JE;;;EACE,yBAAA;EAAA,kCAAA;AzCg9JJ;AyC98JI;;;EACE,yBrCEE;EqCFF,kCrCEE;AJg9JR;AyC78JI;;;EACE,yBrCJE;EqCIF,kCrCJE;AJq9JR;AyC58JI;;;EACE,6B/B+LU;E+B/LV,uD/B+LU;AVixJhB;AwC3uJE;;;EAKE,gBAAA;EACA,aAAA;AxC2uJJ;AwCzuJI;;;EACE,mBAAA;AxC6uJN;AwC1uJI;;;EACE,yBpC5PE;EoC4PF,kCpC5PE;EoC6PF,6B9BpDU;E8BoDV,uD9BpDU;AVkyJhB;;AwC1uJE;;EAEE,yBAAA;EAAA,qDAAA;EACA,yBpCpQI;EoCoQJ,kCpCpQI;EoCqQJ,6B9B5DY;E8B4DZ,uD9B5DY;AVyyJhB;AwC3uJI;;EACE,yBpCxQE;EoCwQF,kCpCxQE;EoCyQF,mBAAA;AxC8uJN;;AwC1uJE;EACE,+DAAA;AxC6uJJ;;AwC1uJE;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,+CAAA;EACA,mBAAA;EACA,eAAA;EACA,gDAAA;EACA,kHACE;AxC4uJN;AwCzuJI;EACE,kBAAA;AxC2uJN;;AwCvuJE;EACE,cAAA;EACA,UAAA;EACA,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BrBzTS;UqByTT,0BrBzTS;EqB0TT,aAAA;AxC0uJJ;AwCxuJI;EACE,kBAAA;AxC0uJN;;AwCtuJE;EACE,mBAAA;AxCyuJJ;;AwCtuJE;EACE,cAAA;EACA,kBAAA;EACA,gDAAA;EAAA,qDAAA;EACA,aAAA;AxCyuJJ;;AwCtuJE;EACE,mCAAA;EAAA,6DAAA;AxCyuJJ;;AwCtuJE;EAEE,6BAAA;AxCwuJJ;;AwCruJE;EACE,4B9B1FY;E8B0FZ,sD9B1FY;AVk0JhB;;AwCruJE;EACE,sBAAA;UAAA,qBAAA;AxCwuJJ;;AwCruJE;EACE,+BAAA;UAAA,8BAAA;AxCwuJJ;;AwCpuJE;EpBjWA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBykKF;AoBvkKE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBukKJ;AoBpkKE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBskKJ;AoBpkKI;EAVF;IAWI,eAAA;EpBukKJ;AACF;AqBtmKE;EmBqWA;IpBjUE,sBAAA;EpBskKF;EoBpkKE;IACE,kBAAA;IACA,yBAAA;EpBskKJ;AACF;AwC1wJE;EClWA,yB/BisBoB;E+BjsBpB,yD/BisBoB;E+BhsBpB,c/ByLa;E+BzLb,uC/ByLa;AVs7Jf;AyC7mKE;EACE,yBAAA;EAAA,yDAAA;AzC+mKJ;AyC7mKI;EACE,yB/B0rBgB;E+B1rBhB,yD/B0rBgB;AVq7ItB;AyC1mKI;EACE,yB/BorBgB;E+BprBhB,yD/BorBgB;AVw7ItB;AyCvmKI;EACE,c/BuKS;E+BvKT,uC/BuKS;AVk8Jf;AwC1xJE;EAQE,gBAAA;EACA,oBAAA;AxCqxJJ;AwClxJI;EAZF;IAcI,wBAAA;ExCoxJJ;AACF;;AwChxJE;;EAEE,mBAAA;EACA,+BAAA;UAAA,8BAAA;AxCmxJJ;;AwChxJE;;EAQE,8BAAA;AxC6wJJ;;AwC1wJE;;EAIE,0BAAA;AxC2wJJ;;AwCxwJE;;;EAGE,2BAAA;AxC2wJJ;;AwCvwJE;EAEE,gBAAA;EACA,kBAAA;AxCywJJ;;AqBnqKE;EmB+ZA;InBxZI,8BAAA;ErBiqKJ;AACF;;AqBzqKE;EmBmaA;InBjaI,gBAAA;IACA,4BAAA;ErB4qKJ;AACF;;AwCzwJE;EACE,uCAAA;AxC4wJJ;;AwCzwJE;EACE,sBAAA;AxC4wJJ;;AwCzwJE;EAGE,yBAAA;AxC0wJJ;;AwCvwJE;EACE,oBAAA;EACA,wBAAA;EACA,mBAAA;AxC0wJJ;;AwCvwJE;EAIE,wBAAA;AxCuwJJ;;AwCpwJE;EACE,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,sBAAA;AxCuwJJ;;AwCpwJE;EAIE,sBAAA;AxCowJJ;;AwCjwJE;EACE,aAAA;AxCowJJ;;AwCjwJE;EAGE,oBAAA;AxCkwJJ;;A2CjrKE;EACE,cAAA;A3CorKJ;;A2CjrKE;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kCAAA;A3CorKJ;A2ClrKI;E7BmyBA,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Adq5IJ;A2CprKI;;;EAGE,SAAA;A3CsrKN;A2CnrKI;EACE,qBAAA;A3CqrKN;A2ClrKI;EACE,cAAA;A3CorKN;;A+B7uKE;EACE,eAAA;A/BgvKJ;A+B7uKE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B8uKJ;A+B3uKE;EACE,0GAhBiB;A/B6vKrB;A+B1uKE;ECiEA,gBAAA;AhC4qKF;A2CjsKE;EAGE,kBAAA;EACA,YAAA;EACA,yBvCpDI;EuCoDJ,kCvCpDI;EuCqDJ,kBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,cjCgHW;EiChHX,uCjCgHW;EiC/GX,eAAA;EACA,iBA9Da;EA+Db,sBAAA;EACA,oDAAA;A3CisKJ;A2C/rKI;EACE,yBvC7DQ;EuC6DR,wCvC7DQ;AJ8vKd;;A2C7rKE;EACE,eAAA;A3CgsKJ;;A2C7rKE;EACE,gBAAA;EACA,oBAAA;A3CgsKJ;;A2C7rKE;EACE,gBAAA;EACA,oBAAA;A3CgsKJ;;A2C7rKE;EACE,+BjCyCe;EiCzCf,4DjCyCe;AVupKnB;;A2C7rKE;EACE,+BjC2Ce;EiC3Cf,4DjC2Ce;AVqpKnB;;A2C7rKE;EACE,+BjC6Ce;EiC7Cf,4DjC6Ce;AVmpKnB;;A2C7rKE;EACE,yBvC7FI;EuC6FJ,kCvC7FI;AJ6xKR;;A2C5rKE;EACE,yBjCMO;EiCNP,8CjCMO;AVyrKX;;A2C5rKE;EACE,gBAAA;EACA,kBAAA;A3C+rKJ;;A2C3rKE;EACE,kBAAA;EACA,ajCkIY;EiClIZ,uCjCkIY;EiCjIZ,sBAAA;EACA,wBxBpGS;EwBqGT,2BAAA;A3C8rKJ;;A2C3rKE;EACE,ajCiIc;EiCjId,yCjCiIc;AV6jKlB;;A2C3rKE;EACE,aNhJQ;EMiJR,UAAA;A3C8rKJ;;A2C3rKE;;EAGE,uBAAA;UAAA,mBAAA;EACA,yBxB3GS;UwB2GT,wBxB3GS;AnBwyKb;;A2C1rKE;;EAIE,2BAAA;UAAA,0BAAA;A3C2rKJ;;A2CtrKE;EACE,yBjCrCO;EiCqCP,8CjCrCO;AV8tKX;A2CvrKI;EACE,yBvC/IQ;EuC+IR,wCvC/IQ;AJw0Kd;;A2CprKE;EACE,mBvChKI;EuCgKJ,4BvChKI;AJu1KR;;A2CnrKE;EACE,iCvCxJY;EuCwJZ,kDvCxJY;AJ80KhB;;A2CnrKE;EACE,mCAAA;A3CsrKJ;;A2ClrKE;EACE,yBvCpKI;EuCoKJ,kCvCpKI;AJy1KR;;A2CjrKE;EACE,yBjCjEO;EiCiEP,8CjCjEO;AVqvKX;;A2CjrKE;;;EAGE,mCAAA;EACA,aAAA;A3CorKJ;;A2CjrKE;;EAGE,6BjCSY;EiCTZ,uDjCSY;AV0qKhB;;A2ChrKE;;EAEE,4BjC8CY;EiC9CZ,sDjC8CY;AVqoKhB;;A2ChrKE;;;EAGE,mBAAA;A3CmrKJ;;A2ChrKE;;;EAIE,6BjCTY;EiCSZ,uDjCTY;EiCUZ,qBAAA;A3CkrKJ;;A2C/qKE;EACE,mBAAA;A3CkrKJ;;A2C9qKE;EAEE,yBxBnMS;UwBmMT,wBxBnMS;AnBm3Kb;;A2C7qKE;EAEE,yBxBlNS;UwBkNT,wBxBlNS;AnBi4Kb;;A2C3qKE;EACE,eAAA;EACA,6BAAA;A3C8qKJ;A2C5qKI;EACE,yBvCxOQ;EuCwOR,wCvCxOQ;AJs5Kd;;A2C1qKE;EACE,yBAAA;A3C6qKJ;;A2C1qKE;EAEE,eAAA;A3C4qKJ;;A2CzqKE;;EAEE,6BAAA;A3C4qKJ;;A2CzqKE;EAEE,wBAAA;A3C2qKJ;;A2CxqKE;EAEE,wBxBxQS;AnBk7Kb;;A2CvqKE;EAEE,sBxBzPS;AnBk6Kb;;A2CtqKE;EACE,cjC5FW;EiC4FX,uCjC5FW;AVqwKf;;A2CtqKE;EACE,gBAAA;A3CyqKJ;;A2CtqKE;EACE,sBAAA;A3CyqKJ;;A2CtqKE;EACE,sBAAA;EACA,sBAAA;A3CyqKJ;;A2CrqKE;EhCzSA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT69KF;AS39KE;;;EAGE,mBAAA;AT69KJ;AWv9KE;EACE,SAAA;AXy9KJ;A2C/rKE;EAGE,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EAEA,4BAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;A3C8rKJ;;A2C3rKE;E/B5SE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ2+KJ;AYz+KI;E+BySF;I/BxSI,qBAAA;EZ4+KJ;AACF;;A2CjsKE;EACE,6BjC5GY;EiC4GZ,uDjC5GY;EiC6GZ,aAAA;A3CosKJ;;A2ChsKE;EACE,6BAAA;UAAA,4BAAA;A3CmsKJ;;A2C/rKE;;EAOE,8BAAA;UAAA,6BAAA;A3C6rKJ;;A2C1rKE;;EASE,0BAAA;A3CsrKJ;;A2ClrKE;EACE,yBxB7TS;UwB6TT,wBxB7TS;AnBk/Kb;;A2CjrKE;;EAME,yBxBlUS;UwBkUT,wBxBlUS;AnBk/Kb;;A2C7qKE;;EASE,wBAAA;A3CyqKJ;;A2CrqKE;E7BwdE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E6BrdA,gBAAA;EACA,cjCpMW;EiCoMX,uCjCpMW;EiCqMX,uBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mBAAA;A3C0qKJ;;A2CtqKE;EhCvYA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EFTA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT2jLF;ASzjLE;;;EAGE,mBAAA;AT2jLJ;AWrjLE;EACE,SAAA;AXujLJ;A2C/rKE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBxBrYS;EwBsYT,aAAA;EACA,0DAAA;A3C+rKJ;;A2C5rKE;EACE,ajCxKW;EiCwKX,sCjCxKW;AVu2Kf;;A2C5rKE;EACE,uBAAA;EACA,mBAAA;EACA,yBAAA;A3C+rKJ;;A2C3rKE;EhCjaA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EFTA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT0mLF;ASxmLE;;;EAGE,mBAAA;AT0mLJ;AWpmLE;EACE,SAAA;AXsmLJ;A2CptKE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,mIAAA;EACA,2BAAA;EACA,2BAAA;EACA,iEAAA;EACA,yBAAA;UAAA,iBAAA;A3CotKJ;A2CltKI;E/BnaA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZwnLJ;AYtnLI;E+BgaA;I/B/ZE,qBAAA;EZynLJ;AACF;A2CxtKM;E/BtaF,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZioLJ;AY/nLI;E+BmaE;I/BlaA,qBAAA;EZkoLJ;AACF;;A2C3tKE;EACE,ajC7MW;EiC6MX,sCjC7MW;AV26Kf;;A2C3tKE;EACE,aAAA;A3C8tKJ;;A2C1tKE;E7BgZE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;E6B7YA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,yBjCnbiB;EiCmbjB,wDjCnbiB;EiCobjB,kBAAA;EACA,cjCpQW;EiCoQX,uCjCpQW;EiCqQX,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,4BAAA;UAAA,2BAAA;EAEA,6BAAA;UAAA,4BAAA;EACA,eAAA;A3C8tKJ;;A2C3tKE;EACE,iBAAA;EACA,mBAAA;EACA,ajCvOW;EiCuOX,sCjCvOW;EiCwOX,oBAAA;EACA,6BAAA;UAAA,4BAAA;A3C8tKJ;A2C5tKI;EACE,kBAAA;EACA,yBzBjFmB;EyBiFnB,4DzBjFmB;AlB+yKzB;;A2C1tKE;EFpeA,wC/BkNc;E+BlNd,kE/BkNc;E+BjNd,crCQM;EqCRN,uBrCQM;AJ0rLR;AyChsLE;EACE,wCAAA;EAAA,kEAAA;AzCksLJ;AyChsLI;EACE,wC/B2MU;E+B3MV,kE/B2MU;AVu/KhB;AyC7rLI;EACE,wC/BqMU;E+BrMV,kE/BqMU;AV0/KhB;AyC1rLI;EACE,crCVE;EqCUF,uBrCVE;AJssLR;A2CxuKI;EACE,4BjC5OU;EiC4OV,sDjC5OU;AVs9KhB;A2CxuKM;EACE,6BAAA;EAAA,yBAAA;A3C0uKR;;A2CruKE;EACE,aAAA;A3CwuKJ;;A2CpuKE;ElBvfA,wCAAA;EAAA,2DAAA;EkB0fE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,yBvClfI;EuCkfJ,kCvClfI;EuCmfJ,iBA9ea;EA+eb,eAAA;EACA,gBAAA;EACA,4DAAA;A3CsuKJ;A2CpuKI;E/BjgBA,uCAAA;EAAA,4CAAA;AZwuLJ;AYtuLI;E+B+fA;I/B9fE,qBAAA;EZyuLJ;AACF;;A2CruKE;EACE,kBAAA;A3CwuKJ;;A2CpuKI;EACE,aAAA;EACA,iBAAA;EACA,kBAAA;A3CuuKN;;A2CnuKE;EACE,cAAA;EAEA,wBAAA;A3CquKJ;;A2CluKE;EAGE,uBAAA;A3CmuKJ;;A2ChuKE;EAGE,qBAAA;A3CiuKJ;;A2C7tKE;E7B2SE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E6BxSA,kBAAA;EACA,kBAAA;EACA,cjC/Wa;EiC+Wb,yCjC/Wa;EiCgXb,eAAA;EACA,2DAAA;EACA,yBAAA;UAAA,iBAAA;A3CkuKJ;A2ChuKI;EACE,yBvCtiBQ;EuCsiBR,wCvCtiBQ;AJwwLd;A2C/tKI;EACE,yBvCziBW;EuCyiBX,2CvCziBW;AJ0wLjB;;A2C5tKE;EACE,yBvChjBU;EuCgjBV,wCvChjBU;AJ+wLd;;A2C5tKE;EACE,gBAAA;A3C+tKJ;;A2C5tKE;EACE,gBAAA;A3C+tKJ;;A2C5tKE;EACE,6BAAA;A3C+tKJ;;A2C3tKE;EACE,yBvChkBa;EuCgkBb,2CvChkBa;AJ8xLjB;;A2C3tKE;EAEE,iCjCrce;EiCqcf,8DjCrce;AVkqLnB;;A2C1tKE;EAGE,iCjCrce;EiCqcf,8DjCrce;AVgqLnB;;A2CxtKE;EAGE,iCjCrce;EiCqcf,8DjCrce;AV8pLnB;;A2CttKE;EAEE,qCAAA;A3CwtKJ;;A2CrtKE;EAEE,cjC9aW;EiC8aX,uCjC9aW;AVqoLf;;A2CptKE;EAIE,iCjClee;EiCkef,8DjClee;AVsrLnB;;A2CjtKE;EAKE,iCjCpee;EiCoef,8DjCpee;AVorLnB;;A2C7sKE;EAKE,iCjCtee;EiCsef,8DjCtee;AVkrLnB;;A2CzsKE;EACE,iCjChfe;EiCgff,8DjChfe;AV4rLnB;;A2CzsKE;EACE,iCjC9ee;EiC8ef,8DjC9ee;AV0rLnB;;A2CzsKE;ElC/oBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT41LF;AS11LE;;;EAGE,mBAAA;AT41LJ;A2CxtKE;E/BlmBE,8BAAA;EACA,oBAAA;E+BqmBA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,cAAA;EACA,kBAAA;EACA,2CAAA;UAAA,uCAAA;EACA,4CAAA;UAAA,yCAAA;EACA,iCjCxgBe;EiCwgBf,8DjCxgBe;EiCygBf,cjCzda;EiCydb,yCjCzda;EiC0db,mBAAA;EACA,iBAAA;EACA,2BxBroBS;UwBqoBT,0BxBroBS;EwBsoBT,qBAAA;EACA,uBAAA;EACA,yGACE;EAEF,mBAAA;A3CutKJ;A2CrtKI;E/BppBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ42LJ;AY12LI;E+BipBA;I/BhpBE,qBAAA;EZ62LJ;AACF;A2C9tKI;EAGE,uBAAA;EACA,yBAAA;EACA,SAAA;A3C8tKN;A2C3tKI;EACE,yBAAA;EACA,cjCjfS;EiCifT,uCjCjfS;AV8sLf;;A2CztKE;EACE,gBAAA;EACA,kCAAA;A3C4tKJ;;A2CztKE;EACE,gBAAA;EACA,kCAAA;A3C4tKJ;;A2CztKE;;EAIE,6BjC3eY;EiC2eZ,uDjC3eY;AVqsLhB;;A2CvtKE;;;;EAKE,6BjCnfY;EiCmfZ,uDjCnfY;EiCofZ,mBAAA;EACA,aAAA;A3CytKJ;;A2CttKE;EACE,wBAAA;A3CytKJ;;A2CttKE;EAEE,oCjC9fY;EiC8fZ,8DjC9fY;AVstLhB;;A2CrtKE;;EAKE,iCjC3kBe;EiC2kBf,8DjC3kBe;AVgyLnB;;A2CltKE;;EAOE,iCjC/kBe;EiC+kBf,8DjC/kBe;AV+xLnB;;A2C7sKE;;EAOE,iCjCnlBe;EiCmlBf,8DjCnlBe;AV8xLnB;;A2CxsKE;;EAME,qCAAA;A3CusKJ;;A2CpsKE;EAEE,gBAAA;A3CssKJ;A2CpsKI;EACE,SAAA;EACA,6BAAA;A3CssKN;;A2ClsKE;E/BrvBE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ27LJ;AYz7LI;E+BkvBF;I/BjvBI,qBAAA;EZ47LJ;AACF;A2C5sKE;EAGE,cjC3kBW;EiC2kBX,uCjC3kBW;AVuxLf;;A2CzsKE;;EAKE,qCAAA;A3CysKJ;;A2CtsKE;EAEE,cjCxlBW;EiCwlBX,uCjCxlBW;AVgyLf;;A2CrsKE;EACE,yBvCzwBa;EuCywBb,2CvCzwBa;EuC0wBb,+BvC1wBa;EuC0wBb,iDvC1wBa;EuC2wBb,cjC9lBW;EiC8lBX,uCjC9lBW;AVsyLf;;A2CpsKE;EACE,yBvChxBa;EuCgxBb,2CvChxBa;EuCixBb,+BvCjxBa;EuCixBb,iDvCjxBa;AJw9LjB;;A2CpsKE;EACE,yBvCpxBmB;EuCoxBnB,iDvCpxBmB;EuCqxBnB,+BvCrxBmB;EuCqxBnB,uDvCrxBmB;AJ49LvB;;A2CpsKE;EAEE,cjC9mBW;EiC8mBX,uCjC9mBW;AVozLf;;A2ClsKE;EAGE,qCAAA;A3CmsKJ;;A2ChsKE;EACE,kBAAA;EACA,aAAA;EACA,ajCxkBW;EiCwkBX,sCjCxkBW;EiCykBX,sBAAA;EACA,sBAAA;EACA,2BAAA;A3CmsKJ;;A2ChsKE;EAEE,wBAAA;A3CksKJ;;A2C/rKE;EAEE,cAAA;A3CisKJ;;A2C9rKE;EACE,iBAAA;A3CisKJ;;A2C9rKE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;A3CisKJ;;A2C7rKE;EACE,uBAAA;A3CgsKJ;;A2C7rKE;;;EAOE,qBAAA;A3C4rKJ;;A2CzrKE;;;EAOE,qBAAA;A3CwrKJ;;A2CjrKE;EACE,yBAAA;EACA,kBAAA;EACA,uBAAA;A3CorKJ;;A2ChrKE;;;EAKE,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iCAAA;UAAA,8BAAA;EACA,2BAAA;A3CirKJ;;A2C9qKE;;;;;;EAcE,kBAAA;EACA,yBjCjwBe;EiCiwBf,sDjCjwBe;EiCkwBf,gBAAA;EACA,WAAA;EACA,sBAAA;A3CyqKJ;;A2CtqKE;;;EAKE,aAAA;EACA,8BAAA;A3CuqKJ;;A2CpqKE;;;;;;;;;EAeE,cAAA;EACA,4BAAA;EACA,4BAAA;A3CiqKJ;;A2C9pKE;;;;;;EAUE,yBAAA;EACA,4BAAA;A3C6pKJ;;A2C1pKE;;;Edl7BA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;AV6hLnB;;A2C7oKE;;EAME,mCAAA;A3C4oKJ;;A2CzoKE;;;;EAIE,yBxBx7BS;UwBw7BT,wBxBx7BS;AnBokMb;;A2CzoKE;;EAIE,8BAAA;UAAA,6BAAA;A3C0oKJ;;A2CvoKE;;;;;;;;EAwBE,yBxBh9BS;UwBg9BT,wBxBh9BS;AnB0kMb;;A2CvnKE;;;;EAYE,8BAAA;UAAA,6BAAA;A3CknKJ;;A2C/mKE;;;;;;EAoBE,2BAAA;A3ComKJ;;A2CjmKE;;;;;;;;EAwBE,cAAA;A3ColKJ;;A2CjlKE;;;;;;EAuBE,mCAAA;A3CmkKJ;;A2ChkKE;EAIE,mCAAA;A3CgkKJ;;A2C7jKE;;;;EAgBE,0BAAA;A3CojKJ;;AqB9qME;EsB8nCA;;;ItBvnCI,8BAAA;ErB8qMJ;AACF;;AqBtrME;EsBooCA;;;ItBloCI,gBAAA;IACA,4BAAA;ErB2rMJ;AACF;;A2CpjKE;EAEE,kBAAA;EACA,yBjC9/Be;EiC8/Bf,sDjC9/Be;EiC+/Bf,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,+BAAA;UAAA,8BAAA;A3CsjKJ;;A2CjjKI;;EAEE,kBAAA;EACA,yBjC1gCa;EiC0gCb,sDjC1gCa;EiC2gCb,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,6BAAA;UAAA,4BAAA;A3CojKN;;A2ChjKE;;EAIE,yBxBzpCS;AnB0sMb;;A2C9iKE;;EAIE,yBxBhqCS;AnB+sMb;;A4ChtME;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EAAA,oCAAA;A5CmtMJ;A4CjtMI;EACE,wBAAA;A5CmtMN;A4ChtMI;E9B+zBA,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Adu5KJ;A4CltMI;;;EAGE,SAAA;A5CotMN;A4CjtMI;EACE,cAAA;A5CmtMN;;A+B5uME;EACE,eAAA;A/B+uMJ;A+B5uME;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B6uMJ;A+B1uME;EACE,0GAhBiB;A/B4vMrB;A+BzuME;ECiEA,gBAAA;AhC2qMF;A4ChuME;EhCME,8BAAA;EACA,oBAAA;EgCHA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,yBxCtBI;EwCsBJ,kCxCtBI;EwCuBJ,kBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,clC8IW;EkC9IX,uClC8IW;EkC7IX,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,8BAAA;EACA,iEAAA;A5CiuMJ;A4C/tMI;EACE,yBxChCQ;EwCgCR,wCxChCQ;AJiwMd;;A4C5tME;EACE,iBAAA;A5C+tMJ;;A4C5tME;EACE,gBAAA;EACA,oBAAA;A5C+tMJ;;A4C5tME;EACE,uBAAA;A5C+tMJ;;A4C5tME;EACE,gBAAA;EACA,oBAAA;A5C+tMJ;;A4C5tME;EACE,yBAAA;A5C+tMJ;;A4C5tME;EACE,+BxC1DY;EwC0DZ,gDxC1DY;AJyxMhB;;A4C5tME;EACE,aAAA;A5C+tMJ;;A4C5tME;EhC1EE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ0yMJ;AYxyMI;EgCuEF;IhCtEI,qBAAA;EZ2yMJ;AACF;;A4CluME;EhC5DE,0BAAA;EAAA,oDAAA;EACA,oBAAA;AZkyMJ;AYhyMI;EgCyDF;IhCxDI,qBAAA;EZmyMJ;AACF;A4CzuMI;EACE,2BAAA;UAAA,0BAAA;A5C2uMN;A4CxuMI;EACE,qBAAA;EACA,clCkGO;EkClGP,qClCkGO;EkCjGP,uBAAA;A5C0uMN;;A4CtuME;EACE,kBAAA;EACA,alCuJY;EkCvJZ,uClCuJY;EkCtJZ,sBAAA;EACA,wBzB/ES;EyBgFT,2BAAA;A5CyuMJ;;A4CtuME;EACE,yBxC/FI;EwC+FJ,kCxC/FI;AJw0MR;;A4CtuME;EACE,8BAAA;A5CyuMJ;;A4CtuME;EnB3HA,wCAAA;EAAA,2DAAA;EmB+HE,wBAAA;EACA,0DAAA;A5CuuMJ;;A4CpuME;EACE,yBlCPO;EkCOP,8ClCPO;AV8uMX;A4CruMI;EACE,yBxCjHQ;EwCiHR,wCxCjHQ;AJw1Md;;A4CnuME;EACE,qBAAA;A5CsuMJ;;A4CnuME;EACE,kBAAA;EACA,alC8FW;EkC9FX,sClC8FW;EkC7FX,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,yBAAA;EACA,2DAAA;A5CsuMJ;;A4CnuME;EACE,YAAA;EAEA,gBAAA;EACA,clC+BW;EkC/BX,uClC+BW;EkC9BX,iBAAA;EACA,iBAAA;A5CquMJ;A4CnuMI;EhClJA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZw3MJ;AYt3MI;EgC+IA;IhC9IE,qBAAA;EZy3MJ;AACF;;A4CvuME;E9B8qBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E8B3qBA,cAAA;EACA,gBAAA;EAEA,4BAAA;EAEA,6BAAA;EACA,uBAAA;EACA,mBAAA;A5C0uMJ;;A+Bn5ME;EACE,eAAA;A/Bs5MJ;A+Bn5ME;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/Bo5MJ;A+Bj5ME;EACE,0GAhBiB;A/Bm6MrB;A+Bh5ME;ECiEA,gBAAA;AhCk1MF;A4CxvME;EhCzIE,8BAAA;EACA,oBAAA;Ea3CF,wCAAA;EAAA,2DAAA;EXo1BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E8B3pBA,kBAAA;EACA,aAAA;EACA,aAAA;EAEA,qBAAA;EACA,sBAAA;EACA,yBxCpLI;EwCoLJ,kCxCpLI;EwCqLJ,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,4DAAA;A5C2vMJ;;A4CvvME;EACE,yBxC7LI;EwC6LJ,kCxC7LI;AJu7MR;;A4CvvME;EAEE,kBAAA;A5CyvMJ;;A4CtvME;EACE,kBAAA;EACA,UAAA;EACA,gKACE;EAGF,mBAAA;A5CsvMJ;A4CpvMI;EACE,yBxC5MQ;EwC4MR,wCxC5MQ;AJk8Md;A4CpvMM;EACE,yBAAA;A5CsvMR;A4ClvMI;EACE,yBxCnNW;EwCmNX,2CxCnNW;AJu8MjB;A4CjvMI;EACE,qCAAA;A5CmvMN;;A4C/uME;EACE,0BAAA;UAAA,sBAAA;A5CkvMJ;;A4C/uME;EhCpME,8BAAA;EACA,oBAAA;EgCsMA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,6BAAA;EACA,cAAA;EACA,kBAAA;EACA,iCxC/NY;EwC+NZ,kDxC/NY;EwCgOZ,clCzDa;EkCyDb,yClCzDa;EkC0Db,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;A5CkvMJ;A4ChvMI;EACE,yBAAA;EACA,clCrES;EkCqET,uClCrES;AVuzMf;;A4C7uME;EACE,iClClHe;EkCkHf,8DlClHe;AVk2MnB;;A4C7uME;EACE,gBAAA;EACA,kCAAA;A5CgvMJ;;A4C7uME;;EhChQE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZk/MJ;AYh/MI;EgC6PF;;IhC5PI,qBAAA;EZo/MJ;AACF;A4CzvME;;EAIE,uBAAA;EACA,SAAA;A5CyvMJ;;A4CrvME;EAGE,oBAAA;EACA,cAAA;EACA,aAAA;A5CsvMJ;;A4ClvME;EhClRE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZwgNJ;AYtgNI;EgC+QF;IhC9QI,qBAAA;EZygNJ;AACF;A4C5vME;EAKE,uBAAA;EACA,SAAA;A5C0vMJ;;A4CjvME;EAEE,yBAAA;A5CmvMJ;;A4ChvME;EACE,+BxCxSU;EwCwSV,8CxCxSU;AJ2hNd;;A4ChvME;EACE,0BAAA;A5CmvMJ;;A4ChvME;EAGE,qBAAA;A5CivMJ;;A4C9uME;EACE,UAAA;A5CivMJ;;A4C9uME;EACE,mCAAA;A5CivMJ;A4C/uMI;EACE,yBxCtTE;EwCsTF,kCxCtTE;AJuiNR;A4C9uMI;EACE,aAAA;A5CgvMN;A4C5uMI;;EAEE,6BlCjIU;EkCiIV,uDlCjIU;AV+2MhB;A4C1uMI;;EAEE,4BlC7FU;EkC6FV,sDlC7FU;AVy0MhB;A4CxuMI;EACE,yBlCnOK;EkCmOL,8ClCnOK;AV68MX;;A4CtuME;;EAEE,mBAAA;A5CyuMJ;;A4CtuME;EACE,iBAAA;EACA,sBAAA;A5CyuMJ;;A4CtuME;EACE,qBAAA;EACA,6BAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,yDAAA;A5CyuMJ;A4CvuMI;EACE,yBxCzWQ;EwCyWR,wCxCzWQ;AJklNd;A4CtuMI;EACE,6BAAA;A5CwuMN;A4CruMI;EACE,yBAAA;EACA,wBAAA;A5CuuMN;;A4CnuME;EACE,6BAAA;A5CsuMJ;;A4CnuME;EACE,qBAAA;EACA,iBAAA;EACA,yCAAA;EACA,gBAAA;EACA,clCjNW;EkCiNX,uClCjNW;AVu7Mf;;A4CnuME;EAEE,6BlC9LY;EkC8LZ,uDlC9LY;AVm6MhB;;A4CluME;EAEE,UAAA;A5CouMJ;;A4CjuME;EAEE,sBAAA;A5CmuMJ;;A4ChuME;EAEE,2BAAA;UAAA,0BAAA;A5CkuMJ;;A4C/tME;EnBpaA,wCAAA;EAAA,2DAAA;AzBuoNF;;A4C9tME;EACE,mBAAA;A5CiuMJ;;A4C9tME;EACE,cAAA;EACA,yBxChaa;EwCgab,2CxChaa;EwCiab,clCpPW;EkCoPX,uClCpPW;AVq9Mf;A4C/tMI;EACE,yBxCnaiB;EwCmajB,iDxCnaiB;AJooNvB;A4C9tMI;EACE,qCAAA;A5CguMN;A4C7tMI;EACE,qCAAA;A5C+tMN;A4C5tMI;EACE,cAAA;A5C8tMN;;A4CztME;;ExBjcA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB+pNF;AoB7pNE;;;;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBgqNJ;AoB7pNE;;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBgqNJ;AoB9pNI;EAVF;;IAWI,eAAA;EpBkqNJ;AACF;AqBjsNE;EuBqcA;;IxBjaE,sBAAA;EpBkqNF;EoBhqNE;;IACE,kBAAA;IACA,yBAAA;EpBmqNJ;AACF;;AqB5sNE;EuB4cA;IvBrcI,8BAAA;ErB0sNJ;AACF;;AqBltNE;EuBgdA;IAEI,aAAA;E5CqwMJ;AACF;;A4CjwME;;EAEE,6BAAA;EACA,+BxCjcY;EwCicZ,gDxCjcY;AJqsNhB;;A4ClwME;EACE,mCAAA;A5CqwMJ;;A4ClwME;;EAEE,eAAA;A5CqwMJ;;A4ClwME;EACE,4BlCvOY;EkCuOZ,sDlCvOY;AV4+MhB;;A6CpuNE;EACE,sBAAA;A7CuuNJ;;A6CpuNE;EACE,oBAAA;EACA,mBAAA;EACA,4BAAA;EACA,iBAAA;A7CuuNJ;;A6CpuNE;EjCyBE,8BAAA;EACA,oBAAA;AZ+sNJ;;A6CruNE;EACE,UAAA;A7CwuNJ;;A6CruNE;EACE,uBAAA;EACA,qBAAA;A7CwuNJ;;A6CruNE;EACE,qBAAA;A7CwuNJ;;A6CluNE;EAGE,uBAAA;EACA,SAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,oEAAA;UAAA,gEAAA;A7CmuNJ;;A6C7tNE;EAGE,2BAAA;UAAA,wBAAA;A7C8tNJ;;A6C3tNE;EAGE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;A7C4tNJ;;A6CztNE;EAGE,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;UAAA,6BAAA;EACA,uBAAA;EACA,mBAAA;A7C0tNJ;;A6CvtNE;EAGE,eAAA;A7CwtNJ;;A6CrtNE;EAIE,4BAAA;A7CqtNJ;;A6CntNE;EAGE,4BAAA;A7CotNJ;;A6CltNE;EAGE,mBAAA;EACA,SAAA;A7CmtNJ;;A6ChtNE;EAIE,cnCsFW;EmCtFX,uCnCsFW;AV0nNf;;A6C7sNE;EACE,8DAAA;A7CgtNJ;;A6C7sNE;EAEE,kCAAA;EACA,4BAAA;EACA,aAAA;A7C+sNJ;;A6C5sNE;;;EjCrGE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZuzNJ;AYrzNI;EiCkGF;;;IjCjGI,qBAAA;EZ0zNJ;AACF;;A6C9sNE;;EAOE,0BAAA;EACA,wBAAA;A7C4sNJ;;A6CzsNE;;EAIE,kBAAA;EACA,sCAAA;EAAA,2CAAA;EACA,gBAAA;EACA,qDAAA;UAAA,kDAAA;EAAA,0DAAA;UAAA,uDAAA;EACA,WAAA;EACA,iBAAA;A7C0sNJ;;A6CvsNE;;EjC7GE,8BAAA;EACA,oBAAA;AZyzNJ;;A6CtsNE;;EAIE,wBAAA;UAAA,uBAAA;A7CusNJ;;A6CpsNE;EAIE,yBzCpJI;EyCoJJ,kCzCpJI;AJw1NR;;A6CjsNE;EAEE,kBAAA;A7CmsNJ;;A6ChsNE;;EAGE,6BAAA;EACA,uBAAA;UAAA,mBAAA;A7CksNJ;;A6C/rNE;EAEE,kBAAA;A7CisNJ;;A6C9rNE;;EAEE,6BAAA;EACA,+BzCxKY;EyCwKZ,gDzCxKY;AJy2NhB;;A6C9rNE;EAGE,4BnCwDY;EmCxDZ,sDnCwDY;AVuoNhB;;A6C5rNE;;EAIE,6BAAA;EACA,cnClBW;EmCkBX,uCnClBW;EmCmBX,eAAA;A7C6rNJ;;A6C1rNE;EAEE,6BAAA;EAAA,8CAAA;A7C4rNJ;;A6CzrNE;EAGE,4BnCoCY;EmCpCZ,sDnCoCY;AVspNhB;;A6CvrNE;;EAIE,eAAA;A7CwrNJ;;A8C14NE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;A9C64NJ;;A8C14NE;ExCvBA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ANq6NF;;A8Cn5NE;ErC7BA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATo7NF;ASl7NE;;;EAGE,mBAAA;ATo7NJ;A8Cl6NE;EhC0zBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EF1yBA,8BAAA;EACA,oBAAA;EkCZA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,wBAAA;UAAA,gBAAA;EACA,yB1CdI;E0CcJ,kC1CdI;E0CeJ,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,cpCuJW;EoCvJX,uCpCuJW;EoCrJX,iBAAA;EACA,uBAAA;EACA,iHACE;A9Co6NN;A8Cj6NI;ElC9BA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZk8NJ;AYh8NI;EkC2BA;IlC1BE,qBAAA;EZm8NJ;AACF;A8Ct6NI;EVjDF,4B1BkMiB;E0BlMjB,yD1BkMiB;E0BjMjB,UAAA;ApC09NF;A8Ct6NI;EACE,aAAA;A9Cw6NN;A8Cr6NI;EAIE,aAAA;EACA,wBAAA;EACA,gBAAA;A9Co6NN;;A8Ch6NE;EACE,yB1C/CI;E0C+CJ,kC1C/CI;E0CgDJ,2CAAA;UAAA,uCAAA;EACA,6BpC8IY;EoC9IZ,uDpC8IY;EoC7IZ,mBAAA;A9Cm6NJ;A8Cj6NI;EACE,c1CrDE;E0CqDF,uB1CrDE;AJw9NR;;A8Ch6NE;EACE,mBpC+CO;EoC/CP,wCpC+CO;AVo3NX;;A8Ch6NE;EACE,mBpC2CO;EoC3CP,wCpC2CO;AVw3NX;;A8C/5NE;;EAIE,eAAA;EACA,gBAAA;A9Cg6NJ;;A8C75NE;EACE,0BAAA;A9Cg6NJ;;A8C55NE;;EAIE,iBAAA;EACA,kBAAA;A9C65NJ;;A8C15NE;EACE,2BAAA;A9C65NJ;;A8Cz5NE;;EAIE,eAAA;EACA,gBAAA;A9C05NJ;;A8Cv5NE;ErC3HA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATshOF;ASphOE;;;EAGE,mBAAA;ATshOJ;A8Ct6NE;EAGE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,apCoHa;EoCpHb,wCpCoHa;EoCnHb,iBAAA;EACA,sBAAA;EACA,wB3BhHS;E2BiHT,oBAAA;EACA,2BAAA;A9Cs6NJ;;A8Cn6NE;EnCtIA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EFTA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATujOF;ASrjOE;;;EAGE,mBAAA;ATujOJ;AWjjOE;EACE,SAAA;AXmjOJ;A8C57NE;ElC5FE,8BAAA;EACA,oBAAA;EkC+FA,kBAAA;EACA,oBAAA;EACA,mBAAA;A9C67NJ;A8C37NI;EACE,kBAAA;EACA,cAAA;EACA,yB1C5HE;E0C4HF,kC1C5HE;E0C6HF,4BAAA;EACA,WAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;EACA,kEAAA;A9C67NN;A8C17NM;EAZF;IAaI,gBAAA;E9C67NN;AACF;A8C17NI;EACE,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;A9C47NN;A8C17NM;EACE,yB1C7IM;E0C6IN,wC1C7IM;AJykOd;;A8Cv7NE;EACE,cAAA;EACA,yB1CrJI;E0CqJJ,kC1CrJI;E0CsJJ,8B3B9KS;U2B8KT,6B3B9KS;AnBwmOb;A8Cx7NI;EACE,kBAAA;EACA,sBAAA;A9C07NN;;A8Ct7NE;EACE,aAAA;A9Cy7NJ;;A8Ct7NE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,apC8CW;EoC9CX,sCpC8CW;EoC7CX,mBAAA;EACA,UAAA;EACA,8MACE;EAIF,mBAAA;A9Cq7NJ;A8Cn7NI;;EACE,yB1CtLQ;E0CsLR,wC1CtLQ;AJ4mOd;A8Cn7NI;;ElChMA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZunOJ;AYrnOI;EkC6LA;;IlC5LE,qBAAA;EZynOJ;AACF;A8C17NI;;ElCpMA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZkoOJ;AYhoOI;EkCiMA;;IlChME,qBAAA;EZooOJ;AACF;A8Cr8NI;;EAGE,0CpCxMgB;EoCwMhB,0EpCxMgB;AV8oOtB;;A8Cl8NE;;EAGE,mBAAA;EACA,aAAA;A9Co8NJ;A8Cl8NI;;EACE,6BAAA;EACA,mCAAA;A9Cq8NN;A8Cl8NI;;EACE,6BAAA;A9Cq8NN;;A8Cj8NE;EACE,apCgBqB;EoChBrB,gDpCgBqB;AVo7NzB;;A8C/7NI;;EACE,sCpCycE;EoCzcF,2CpCycE;AV0/MR;;A8C/7NE;ElCtOE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZyqOJ;AYvqOI;EkCmOF;IlClOI,qBAAA;EZ0qOJ;AACF;;A8Cn8NI;;EAIE,gBAAA;EACA,iBAAA;A9Co8NN;A8Cj8NI;EACE,eAAA;A9Cm8NN;;A8C77NI;;EAIE,kBAAA;EACA,mBAAA;A9C87NN;A8C37NI;EACE,iBAAA;A9C67NN;;A8Cv7NI;;EAIE,gBAAA;EACA,iBAAA;A9Cw7NN;A8Cr7NI;EACE,eAAA;A9Cu7NN;;A8Cn7NE;EACE,UAAA;EACA,kBAAA;A9Cs7NJ;;A8Cn7NE;;;E1BxSA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBiuOF;AoB/tOE;;;;;;;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBquOJ;AoBluOE;;;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBsuOJ;AoBpuOI;EAVF;;;IAWI,eAAA;EpByuOJ;AACF;AqBxwOE;EyB4SA;;;I1BxQE,sBAAA;EpB0uOF;EoBxuOE;;;IACE,kBAAA;IACA,yBAAA;EpB4uOJ;AACF;A8Cz+NE;;;EAKE,iBAAA;A9Cy+NJ;A8Cv+NI;;;EACE,kBAAA;A9C2+NN;;A8Cv+NE;EACE,sDAAA;A9C0+NJ;;A8Cv+NE;EACE,iBAAA;A9C0+NJ;;A8Cv+NE;EACE,UAAA;EACA,cAAA;EACA,0DAAA;A9C0+NJ;A8Cx+NI;EACE,kBAAA;EACA,UAAA;EACA,yBCzRa;ED0Rb,qCAAA;EACA,2DAAA;A9C0+NN;;A8Ct+NE;EAEE,iBAAA;EACA,wDAAA;A9Cw+NJ;A8Ct+NI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;A9Cw+NN;;A8Cp+NE;EACE,kBAAA;EACA,eAAA;A9Cu+NJ;A8Cr+NI;EACE,uCAAA;EAAA,4CAAA;A9Cu+NN;;A8Cn+NE;EACE,2CpC/Ue;EoC+Uf,wEpC/Ue;AVqzOnB;;A8Cn+NE;EAEE,oBAAA;A9Cq+NJ;;A8Cl+NE;EACE,apC7HW;EoC6HX,sCpC7HW;AVkmOf;;A8Cl+NE;EAEE,apC/Ha;EoC+Hb,wCpC/Ha;AVmmOjB;;A8Cj+NE;EACE,4BpCvHY;EoCuHZ,sDpCvHY;AV2lOhB;;A8Cj+NE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;A9Co+NJ;A8Cn+NI;EACE,kBAAA;A9Cq+NN;;AgD/1OE;EACE,yB5CiBI;E4CjBJ,kC5CiBI;AJi1OR;;AgD/1OE;EAEE,kBAAA;EACA,sCAAA;EAAA,2CAAA;EACA,gBAAA;EACA,qDAAA;UAAA,kDAAA;EAAA,0DAAA;UAAA,uDAAA;EACA,WAAA;EACA,iBAAA;AhDi2OJ;;AgD91OE;EpCyBE,8BAAA;EACA,oBAAA;AZy0OJ;;AgD71OE;EACE,yBtCqGO;EsCrGP,8CtCqGO;AV2vOX;;AgD71OE;EACE,aAAA;AhDg2OJ;;AgD71OE;EAEE,+B5CTY;E4CSZ,gD5CTY;AJw2OhB;;AgD51OE;EpCrBE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZq3OJ;AYn3OI;EoCkBF;IpCjBI,qBAAA;EZs3OJ;AACF;;AgDl2OE;EAIE,0BAAA;EACA,wBAAA;AhDk2OJ;;AgD/1OE;;;;;EASE,UAAA;AhD81OJ;;AgD11OE;;EAEE,6BAAA;AhD61OJ;;AgD11OE;EACE,+B5C3CY;E4C2CZ,gD5C3CY;AJw4OhB;;AgD11OE;;EAEE,eAAA;AhD61OJ;;AgD11OE;;EAEE,4BtCiLY;EsCjLZ,sDtCiLY;AV4qOhB;;AiD/5OE;ExCdA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATi7OF;AS/6OE;;;EAGE,mBAAA;ATi7OJ;AiD96OE;EAGE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AjD86OJ;;AiD36OE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AjD86OJ;;AiD36OE;EnCwzBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EF1yBA,8BAAA;EACA,oBAAA;EqCXA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;UAAA,gBAAA;EACA,yB7CfI;E6CeJ,kC7CfI;E6CgBJ,kBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,cvCqJW;EuCrJX,uCvCqJW;EuCpJX,eAAA;EACA,oBAAA;EACA,iBAAA;EAEA,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,uBAAA;EAGA,wDAAA;AjD86OJ;AiD56OI;EACE,yB7C/BQ;E6C+BR,wC7C/BQ;AJ68Od;AiD16OI;EACE,aAAA;AjD46ON;AiD18OE;EAkCE,qDAAA;EACA,+BAAA;EACA,uEAAA;EACA,yDAAA;AjD26OJ;AiD16OI;EACE;IAEE,sBAAA;IACA,kBAAA;IACA,0BAAA;EjD26ON;AACF;AiDx6OI;ErC5DA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZu+OJ;AYr+OI;EqCyDA;IrCxDE,qBAAA;EZw+OJ;AACF;AiDj7OI;EAGE,cvC8GS;EuC9GT,uCvC8GS;AVm0Of;AiD96OI;EAEE,yB7C9DE;E6C8DF,kC7C9DE;E6C+DF,mCAAA;EACA,6BvC+HU;EuC/HV,uDvC+HU;EuC9HV,mBAAA;AjD+6ON;;AiD36OE;EACE,gBAAA;EACA,oBAAA;AjD86OJ;;AiD36OE;EACE,gBAAA;EACA,oBAAA;AjD86OJ;;AiD36OE;;EAEE,6BvC8GY;EuC9GZ,uDvC8GY;AVg0OhB;;AiD36OE;;EAEE,yB9BjES;U8BiET,wB9BjES;AnB++Ob;;AiD36OE;EACE,4BvC+IY;EuC/IZ,sDvC+IY;AV+xOhB;;AiD36OE;EACE,yBvCUO;EuCVP,8CvCUO;AVo6OX;AiD56OI;EACE,yB7ChGQ;E6CgGR,wC7ChGQ;AJ8gPd;AiD36OI;EAEE,yBvCEK;EuCFL,8CvCEK;EuCDL,6BvCwFU;EuCxFV,uDvCwFU;EuCvFV,mBAAA;AjD46ON;;AiDx6OE;EACE,kBAAA;EACA,gBAAA;EACA,avC2GW;EuC3GX,sCvC2GW;EuC1GX,oBAAA;EACA,sB9BrHS;E8BsHT,oBAAA;AjD26OJ;AiDx6OI;EAGE;IACE,gBAAA;EjDw6ON;AACF;;AiDp6OE;EACE,kBAAA;EACA,wB9BrHS;AnB4hPb;;AiDp6OE;EAGE,avCyGY;EuCzGZ,uCvCyGY;AV4zOhB;;AiDj6OI;EACE,avCoGU;EuCpGV,uCvCoGU;AVg0OhB;;AiDh6OE;EACE,avCqGc;EuCrGd,yCvCqGc;AV8zOlB;;AiDh6OE;EACE,aZ5KQ;EY6KR,UAAA;AjDm6OJ;;AiDh6OE;;EAGE,yB7ClKU;E6CkKV,wC7ClKU;E6CmKV,cvCWW;EuCXX,uCvCWW;AVu5Of;AiDh6OI;;EACE,6BvCgCU;EuChCV,uDvCgCU;AVm4OhB;;AiD/5OE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AjDk6OJ;;AiD/5OE;EACE,uBAAA;UAAA,mBAAA;EACA,4B9BzLS;U8ByLT,2B9BzLS;AnB2lPb;;AiD/5OE;EACE,oBAAA;EACA,mBAAA;AjDk6OJ;;AiD/5OE;EACE,6BAAA;EACA,0BAAA;UAAA,sBAAA;EACA,cvCfW;EuCeX,uCvCfW;EuCgBX,iBAAA;EACA,2BAAA;AjDk6OJ;AiDh6OI;EACE,yB7C1LQ;E6C0LR,wC7C1LQ;AJ4lPd;;AiD95OE;;;EAGE,yBvC/MS;EuC+MT,gDvC/MS;AVgnPb;AiD/5OI;;;EACE,yB7CpMQ;E6CoMR,wC7CpMQ;AJumPd;;AiD/5OE;;EAEE,yBvCxNS;EuCwNT,gDvCxNS;AV0nPb;;AiD/5OE;EACE,wB9B7NS;AnB+nPb;;AiD/5OE;EAEE,2BAAA;UAAA,0BAAA;AjDi6OJ;;AiD95OE;;EAME,sB9BvNS;AnBonPb;;AiD15OE;EACE,6BvClCY;EuCkCZ,uDvClCY;EuCmCZ,mBAAA;AjD65OJ;AiD35OI;EACE,mBAAA;AjD65ON;;AiDx5OE;EACE,6BAAA;EACA,+B7CzOY;E6CyOZ,gD7CzOY;E6C0OZ,eAAA;AjD25OJ;;AiDx5OE;EACE,4BvCRY;EuCQZ,sDvCRY;AVm6OhB;;AiDx5OE;EAEE,6BAAA;AjD05OJ;;AiDt5OE;E7B5QA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBsqPF;AoBpqPE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBoqPJ;AoBjqPE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBmqPJ;AoBjqPI;EAVF;IAWI,eAAA;EpBoqPJ;AACF;AqBnsPE;E4BgRA;I7B5OE,sBAAA;EpBmqPF;EoBjqPE;IACE,kBAAA;IACA,yBAAA;EpBmqPJ;AACF;AiD57OE;EAGE,kBAAA;EAEA,iBAAA;AjD27OJ;;AiDx7OE;EACE,aAAA;AjD27OJ;;AiDp7OE;;;EAKE,kBAAA;EACA,sBAAA;EACA,0CAAA;EACA,iCAAA;UAAA,8BAAA;EACA,2BAAA;AjDq7OJ;;AiDl7OE;;;;;;EAUE,kBAAA;EACA,yBvCvKe;EuCuKf,sDvCvKe;EuCwKf,gBAAA;EACA,WAAA;EACA,sBAAA;AjDi7OJ;;AiD96OE;;;EAKE,aAAA;EACA,uCAAA;AjD+6OJ;;AiD56OE;;;EAKE,cAAA;EACA,oBAAA;EACA,qCAAA;AjD66OJ;;AiD16OE;;;EAKE,yBAAA;EACA,qBAAA;AjD26OJ;;AiDx6OE;;EAIE,2BAAA;AjDy6OJ;;AiDt6OE;;;EAGE,yBAAA;EACA,sBAAA;AjDy6OJ;;AiDt6OE;;;EAOE,yB9BnUS;U8BmUT,wB9BnUS;AnBwuPb;;AiDl6OE;;;EAQE,yB9BpUS;U8BoUT,wB9BpUS;AnBouPb;;AiD75OE;;;;EpB5WA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;AV2tOnB;;AiDh5OE;;;EAOE,cAAA;AjD+4OJ;;AiD54OE;;;EAYE,sB9BvXS;AnB6vPb;;AkDjyPE;EACE,wBAAA;UAAA,qBAAA;AlDoyPJ;;AkDjyPE;EzClBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATuzPF;ASrzPE;;;EAGE,mBAAA;ATuzPJ;AkDhzPE;EpCq0BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EoCj0BA,aAAA;EACA,iBAAA;EAAA,iBAAA;EACA,mBAAA;EACA,8BAAA;EACA,yB9CZI;E8CYJ,kC9CZI;E8CaJ,wCAAA;UAAA,qCAAA;EAAA,yDAAA;UAAA,sDAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;AlDmzPJ;AkDhzPI;EACE;IACE,aAAA;ElDkzPN;AACF;AkD9yPI;EACE;;IAEE,aAAA;ElDgzPN;EkD7yPI;IACE,eAAA;IAAA,gBAAA;ElD+yPN;EkD5yPI;IACE,aAAA;ElD8yPN;AACF;;AkD1yPE;EACE,oBAAA;AlD6yPJ;;AkD1yPE;EACE,oBAAA;AlD6yPJ;;AkD1yPE;EACE,mBAAA;EACA,gBAAA;AlD6yPJ;;AkD1yPE;EACE,aAAA;EACA,gBAAA;AlD6yPJ;;AkD1yPE;EpC4wBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EoCzwBA,gBAAA;EAEA,iBAAA;EACA,mBAAA;EAEA,qBAAA;AlD6yPJ;AkDzyPI;EAZF;IAaI,wB/BpEO;I+BqEP,mBAAA;ElD4yPJ;AACF;;AkDxyPE;EAGE,4BAAA;AlDyyPJ;;AkDtyPE;EACE,iBAAA;AlDyyPJ;;AkDtyPE;EACE,iBAAA;AlDyyPJ;;AkDtyPE;EACE,mB9C5FU;E8C4FV,kC9C5FU;AJq4Pd;;AkDtyPE;;;EAWE,yB9C7GI;E8C6GJ,kC9C7GI;AJ84PR;;AkD9xPE;EACE,sBAAA;EACA,mCAAA;AlDiyPJ;;AkD9xPE;EAGE,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;AlD+xPJ;;AkD5xPE;EACE,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;AlD+xPJ;;AkD5xPE;;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;AlD+xPJ;;AkD5xPE;;EAEE,gBAAA;AlD+xPJ;;AkD5xPE;;EAEE,mBAAA;AlD+xPJ;;AkD5xPE;EACE,6BAAA;UAAA,4BAAA;AlD+xPJ;;AkD5xPE;EACE,6BAAA;AlD+xPJ;;AkD5xPE;EAEE,6BAAA;AlD8xPJ;;AkD3xPE;EAEE,wB/BzJS;U+ByJT,uB/BzJS;AnBs7Pb;;AkD1xPE;EACE,SAAA;AlD6xPJ;;AkD1xPE;EACE,mBAAA;AlD6xPJ;AkD1xPI;EAJF;IAKI,eAAA;ElD6xPJ;AACF;;AkDzxPI;EADF;IAEI,qBAAA;ElD6xPJ;AACF;;AkD1xPE;EACE,cxCLW;EwCKX,uCxCLW;EwCMX,0B/BjLS;U+BiLT,yB/BjLS;AnB88Pb;;AkD1xPE;EACE,cxCPa;EwCOb,yCxCPa;AVoyPjB;;AkD1xPE;;EzC5MA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT2+PF;ASz+PE;;;;;;EAGE,mBAAA;AT8+PJ;AkD7yPE;;EAIE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;EACA,eAAA;EACA,axCyBW;EwCzBX,sCxCyBW;EwCxBX,mBAAA;EACA,oBAAA;EACA,iHACE;AlD4yPN;;AkDxyPE;;EAEE,wBAAA;UAAA,qBAAA;AlD2yPJ;;AkDxyPE;;EAEE,0BAAA;AlD2yPJ;;AkDxyPE;;EAGE,gBAAA;EACA,iBAAA;AlD0yPJ;;AkDvyPE;;EAGE,gBAAA;EACA,iBAAA;AlDyyPJ;;AkDtyPE;;EtCvOE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZkhQJ;AYhhQI;EsCoOF;;ItCnOI,qBAAA;EZohQJ;AACF;AkDlzPE;;EAIE,uBAAA;UAAA,sBAAA;AlDkzPJ;;AkD/yPE;;EAEE,mB9CjPU;E8CiPV,kC9CjPU;AJmiQd;;AkD/yPE;;EAEE,mBAAA;EACA,4BxCPY;EwCOZ,sDxCPY;AVyzPhB;;AkD/yPE;;;;EAIE,qB9CpPY;E8CoPZ,sC9CpPY;E8CqPZ,mB9ClQI;E8CkQJ,4B9ClQI;E8CmQJ,mBAAA;EACA,4BxCjBY;EwCiBZ,sDxCjBY;AVm0PhB;;AkD9yPE;EACE,uBAAA;UAAA,mBAAA;EACA,wBAAA;UAAA,uBAAA;AlDizPJ;;AqBvkQE;E6B2RA;;I7BpRI,8BAAA;ErBskQJ;AACF;;AkD7yPE;EACE,kCAAA;AlDgzPJ;;AkD7yPE;;EAME,yB9C/RI;E8C+RJ,kC9C/RI;AJ2kQR;;AmD9kQE;E1CXA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT6lQF;AS3lQE;;;EAGE,mBAAA;AT6lQJ;AmD7lQE;ErC40BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EqCx0BA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yB/CJI;E+CIJ,kC/CJI;E+CKJ,2CAAA;UAAA,uCAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,yDAAA;UAAA,sDAAA;EACA,0BAAA;EACA,2BAAA;EACA,iBAAA;EACA,sBAAA;AnDgmQJ;;AmD3lQI;EAFF;IAGI,qBAAA;EnD+lQJ;AACF;AmDnmQE;EAME,cAAA;EACA,czCgKa;EyChKb,yCzCgKa;AVg8PjB;;AmD7lQE;;EAEE,aAAA;EACA,mBAAA;EACA,gBAAA;AnDgmQJ;;AmD7lQE;EACE,mBAAA;AnDgmQJ;;AmD7lQE;;EAEE,gBAAA;AnDgmQJ;;AmD7lQE;EAEE,6BAAA;UAAA,4BAAA;AnD+lQJ;;AmD5lQE;EAEE,6BAAA;AnD8lQJ;;AmD3lQE;E1C/DA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT8pQF;AS5pQE;;;EAGE,mBAAA;AT8pQJ;AmD1mQE;EAGE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;EACA,czCwKW;EyCxKX,uCzCwKW;EyCvKX,eAAA;EACA,azCsKW;EyCtKX,sCzCsKW;EyCrKX,mBAAA;EACA,oBAAA;EACA,iHACE;AnDymQN;;AmDpmQE;EACE,mBAAA;EACA,oBAAA;AnDumQJ;;AmDpmQE;EvCxEE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZgrQJ;AY9qQI;EuCqEF;IvCpEI,qBAAA;EZirQJ;AACF;;AmD1mQE;EACE,mB/C9EU;E+C8EV,kC/C9EU;E+C+EV,czCkJW;EyClJX,uCzCkJW;AV29Pf;;AmD1mQE;EACE,mBAAA;EACA,4BzC4JY;EyC5JZ,sDzC4JY;AVi9PhB;;AmD1mQE;EACE,qB/C9EY;E+C8EZ,sC/C9EY;E+C+EZ,uBAAA;AnD6mQJ;;AmD1mQE;;EAEE,uBAAA;EACA,mBAAA;EACA,4BzCgJY;EyChJZ,sDzCgJY;AV69PhB;;AmD1mQE;;EAEE,mBAAA;EACA,gBAAA;AnD6mQJ;;AmD1mQE;;EAIE,aAAA;EACA,gBAAA;AnD2mQJ;;AmDxmQE;;ErCqtBE,mBAAA;EAAA,uDAAA;EAAA,gBAAA;EAAA,sDAAA;EAAA,oBAAA;EAAA,0DAAA;EAAA,sBAAA;EAAA,+DAAA;EqCjtBA,yBAAA;EACA,gBAAA;EAEA,iBAAA;EACA,mBAAA;EAEA,qBAAA;AnD2mQJ;;AmDxmQE;;EAGE,mB/CjIU;E+CiIV,kC/CjIU;AJ2uQd;;AmDvmQE;;EAEE,sBAAA;EACA,2BAAA;AnD0mQJ;AmDvmQI;EANF;;IAOI,sBhCxIO;EnBmvQX;AACF;;AmDxmQE;EACE,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;AnD2mQJ;;AmDxmQE;EACE,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;AnD2mQJ;;AoD1vQE;E3CtBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AToxQF;ASlxQE;;;EAGE,mBAAA;AToxQJ;AoDzwQE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;ApDywQJ;;AoDrwQE;EACE,wBAAA;UAAA,qBAAA;ApDwwQJ;;AoDpwQE;EACE,sBAAA;EACA,uBAAA;ApDuwQJ;AoDrwQI;EACE,qBAAA;ApDuwQN;AoDpwQI;EACE,qBAAA;UAAA,oBAAA;ApDswQN;AoDnwQI;EACE,4BjCvCO;UiCuCP,wBjCvCO;AnB4yQb;;AoDjwQE;E9CnDA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;E8C6CE,6BAAA;UAAA,0BAAA;EACA,6BAAA;UAAA,4BAAA;EACA,mBAAA;ApD4wQJ;;AoDzwQE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,wBjC7CS;UiC6CT,uBjC7CS;AnByzQb;;AoDzwQE;EtCmxBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EsChxBA,SAAA;ApD8wQJ;;AoD3wQE;E3C1EA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATy1QF;ASv1QE;;;EAGE,mBAAA;ATy1QJ;AoD1xQE;EAGE,cAAA;EACA,yBAAA;EAAA,kDAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;EACA,qBAAA;EACA,gCAAA;EACA,gCAAA;ApD0xQJ;;AoDvxQE;EAEE,eAAA;ApDyxQJ;;AoDtxQE;EAGE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qB1CgJW;E0ChJX,8C1CgJW;AVuoQf;AoDrxQI;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yB1C0IS;E0C1IT,kD1C0IS;E0CzIT,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;ApDuxQN;AqBj4QE;E+BkGE;IAYI,4BAAA;EpDuxQN;AACF;AoDrxQM;EAfF;IAgBI,iCAAA;YAAA,yBAAA;EpDwxQN;AACF;;AoDpxQE;EACE,6B1C6FY;E0C7FZ,uD1C6FY;E0C5FZ,mBAAA;ApDuxQJ;;AoDpxQE;;EAOE,oC1C4HY;E0C5HZ,8D1C4HY;AVspQhB;AoDhxQI;;EACE,wC1C+EU;E0C/EV,kE1C+EU;AVosQhB;;AoD9wQE;EAIE,oC1CgHY;E0ChHZ,8D1CgHY;AV8pQhB;;AoD3wQE;EACE,eAAA;ApD8wQJ;;AoD3wQE;EAEE,YAAA;EACA,yBAAA;UAAA,iBAAA;ApD6wQJ;;AoDzwQE;EAIE,qB1CoGY;E0CpGZ,+C1CoGY;AVqqQhB;;AoDtwQE;EACE,aAAA;EACA,qBAAA;EACA,+BAAA;UAAA,4BAAA;ApDywQJ;;AoDtwQE;EACE,a1C0FY;E0C1FZ,uC1C0FY;E0CzFZ,kCAAA;ApDywQJ;;AoDtwQE;EACE,a1C2Fc;E0C3Fd,yC1C2Fc;AV8qQlB;;AoDtwQE;EACE,aAAA;ApDywQJ;;AoDtwQE;;EAIE,aAAA;ApDuwQJ;;AoDpwQE;;EAME,cAAA;EACA,iBAAA;EACA,wBAAA;UAAA,qBAAA;EACA,4BjC/LS;UiC+LT,2BjC/LS;EiCgMT,oBAAA;ApDmwQJ;;AoDhwQE;EAGE,c1CLS;E0CKT,qC1CLS;AVswQb;;AoD9vQE;EACE,+BAAA;UAAA,4BAAA;ApDiwQJ;;AoD5vQE;EAGE,uCAAA;EAAA,4CAAA;EACA,qBAAA;ApD6vQJ;;AoDzvQE;EhC3NA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBw9QF;AoBt9QE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBs9QJ;AoBn9QE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBq9QJ;AoBn9QI;EAVF;IAWI,eAAA;EpBs9QJ;AACF;AqBr/QE;E+B+NA;IhC3LE,sBAAA;EpBq9QF;EoBn9QE;IACE,kBAAA;IACA,yBAAA;EpBq9QJ;AACF;AoD/xQE;EAGE,oBAAA;EAEA,oBAAA;ApD8xQJ;;AoD3xQE;EAEE,aAAA;ApD6xQJ;;AoD1xQE;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;ApD6xQJ;;AoD1xQE;EACE,wBjClOS;UiCkOT,uBjClOS;AnB+/Qb;;AoD1xQE;EACE,8BAAA;UAAA,0BAAA;EACA,qBAAA;UAAA,oBAAA;ApD6xQJ;;AoD1xQE;EAGE,gCAAA;UAAA,6BAAA;ApD2xQJ;;AoDxxQE;;EAGE,mBAAA;ApD0xQJ;;AoDvxQE;;EAGE,2BAAA;ApDyxQJ;;AoDtxQE;;EAIE,uBAAA;ApDuxQJ;;AoDnxQE;;;;EAME,aAAA;ApDoxQJ;;AoDjxQE;;;;;;EAoBE,4BjC3SS;UiC2ST,2BjC3SS;AnBijRb;;AoDnwQE;;;EASE,oBAAA;EACA,iCAAA;UAAA,8BAAA;ApDgwQJ;;AqD15PA;EACE,aAAA;ArD65PF;;AqD15PA;;EAEE,aAAA;ArD65PF;;AqD15PA;;EAIE,kCAAA;EAAA,+DAAA;ArD25PF;;AqDv5PA;EAEE,aAAA;ArDy5PF;;A+B1kRE;EACE,eAAA;A/B6kRJ;A+B1kRE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B2kRJ;A+BxkRE;EACE,0GAhBiB;A/B0lRrB;A+BvkRE;ECiEA,gBAAA;AhCygRF;AqDtlRE;EAGE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;ArDslRJ;;AqDnlRE;;EAME,yBAAA;UAAA,wBAAA;ArDklRJ;;AqD/kRE;;EvCszBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EF1yBA,8BAAA;EACA,oBAAA;EyCRA,oBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EAIA,6BAAA;UAAA,qBAAA;EACA,yBjDtBI;EiDsBJ,kCjDtBI;EiDuBJ,kBAAA;EACA,6CAAA;UAAA,yCAAA;EAAA,8DAAA;UAAA,0DAAA;EACA,c3C8IW;E2C9IX,uC3C8IW;E2C7IX,2GAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,+GACE;ArDklRN;AqD/kRI;;EzCzCA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ4nRJ;AY1nRI;EyCsCA;;IzCrCE,qBAAA;EZ8nRJ;AACF;AqDtlRI;;EACE,mBAAA;EACA,oBAAA;ArDylRN;AqDtlRI;;EACE,4B3C4LU;E2C5LV,sD3C4LU;AV65QhB;AqDrlRI;;EACE,aAAA;ArDwlRN;AqDplRI;;EACE,wBAAA;UAAA,gBAAA;ArDulRN;AqDplRI;;EACE,yBAAA;UAAA,wBAAA;ArDulRN;;AqDllRI;;EAEE,yBAAA;UAAA,wBAAA;ArDqlRN;AqDnlRM;;EACE,yBAAA;UAAA,wBAAA;ArDslRR;AqDllRI;;EAEE,yBAAA;UAAA,wBAAA;ArDolRN;;AqD/kRI;;EAEE,yBAAA;UAAA,wBAAA;ArDklRN;AqDhlRM;;EACE,yBAAA;UAAA,wBAAA;ArDmlRR;AqD/kRI;;EAEE,yBAAA;UAAA,wBAAA;ArDilRN;;AqD7kRE;;EAEE,yBjDjGI;EiDiGJ,kCjDjGI;EiDkGJ,6B3C6FY;E2C7FZ,uD3C6FY;E2C5FZ,mBAAA;ArDglRJ;;AqD7kRE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;ArDglRJ;;A+BvsRE;EACE,eAAA;A/B0sRJ;A+BvsRE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BwsRJ;A+BrsRE;EACE,0GAhBiB;A/ButRrB;A+BpsRE;ECiEA,gBAAA;AhCsoRF;AqD9lRE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EAEA,sBAAA;EACA,mBAAA;EACA,2BAAA;ArD6lRJ;;AqD1lRE;E1CjJA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT0vRF;ASxvRE;;;EAGE,mBAAA;AT0vRJ;AWpvRE;EACE,SAAA;AXsvRJ;AqDpnRE;EAGE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,c3CsFW;E2CtFX,uC3CsFW;AV8hRf;AqDlnRI;EACE,kBAAA;ArDonRN;AqDjnRI;EzC7JA,uCAAA;EAAA,4CAAA;AZixRJ;AY/wRI;EyC2JA;IzC1JE,qBAAA;EZkxRJ;AACF;AqDznRI;EAGE,c3C6ES;E2C7ET,uC3C6ES;E2C5ET,oBAAA;EACA,kBAAA;ArDynRN;AqDtnRI;EACE,yBjDlJQ;EiDkJR,wCjDlJQ;EiDmJR,kCAAA;EAAA,mDAAA;EACA,c3CqES;E2CrET,uC3CqES;E2CpET,eAAA;ArDwnRN;AqDrnRI;EACE,mCAAA;EACA,6B3CoCU;E2CpCV,uD3CoCU;E2CnCV,mBAAA;ArDunRN;;AqDlnRE;EACE,QAAA;ArDqnRJ;;AqDlnRE;EACE,QAAA;ArDqnRJ;;AqDlnRE;;EAQE,+B3C8DY;E2C9DZ,yD3C8DY;AVijRhB;;AqD3mRE;;EAQE,mBAAA;EACA,mBAAA;EACA,kC3CseI;E2CteJ,uC3CseI;E2CreJ,gBAAA;EACA,oBAAA;ArDwmRJ;;AqDrmRE;;EAQE,oDAAA;EAAA,yDAAA;ArDkmRJ;;AqD9lRE;;EAQE,uCAAA;EAAA,iEAAA;ArD2lRJ;;AqDxlRE;;EAQE,mBAAA;EACA,mBAAA;EACA,qB3CUY;E2CVZ,+C3CUY;E2CTZ,gBAAA;EACA,oBAAA;ArDqlRJ;;AqDllRE;;EzChPE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZu0RJ;AYr0RI;EyC6OF;;IzC5OI,qBAAA;EZy0RJ;AACF;;AqDnlRE;EACE,kBAAA;EACA,aAAA;EACA,yBjDrPY;EiDqPZ,0CjDrPY;EiDsPZ,gBAAA;EACA,sBAAA;ArDslRJ;AqDplRI;EACE,QAAA;ArDslRN;;AqDjlRE;EAEE,6BAAA;EACA,qBAAA;ArDmlRJ;;AqDhlRE;EAGE,yBjDxQY;EiDwQZ,0CjDxQY;AJy1RhB;;AqD7kRE;;EAKE,yB3CpJe;E2CoJf,sD3CpJe;AViuRnB;;AqD1kRE;;EAQE,6BAAA;ArDukRJ;;AqDpkRE;;EAQE,wC3CjEY;E2CiEZ,kE3CjEY;AVkoRhB;;AqD9jRE;EACE,6BAAA;ArDikRJ;;AqD9jRE;EACE,kBAAA;EACA,a3CpEY;E2CoEZ,uC3CpEY;E2CqEZ,sBlCrRS;AnBs1Rb;;AqD9jRE;EACE,sBAAA;ArDikRJ;;AqD9jRE;EACE,sBAAA;ArDikRJ;;AqD9jRE;EACE,kBAAA;EACA,sBAAA;ArDikRJ;;AqD9jRE;EAGE,sBlCxSS;AnBu2Rb;;AqD5jRE;EAGE,sBAAA;ArD6jRJ;;AqD1jRE;;;;EAQE,6BAAA;ArDyjRJ;;AqDtjRE;EACE,a3CvGc;E2CuGd,yC3CvGc;AVgqRlB;;AqDtjRE;EACE,ahBxXQ;EgByXR,UAAA;ArDyjRJ;;AqDrjRE;;EAEE,gBAAA;ArDwjRJ;;AqDrjRE;EACE,iBlC5US;AnBo4Rb;;AqDrjRE;EACE,iBAAA;ArDwjRJ;;AqDrjRE;;EAEE,gBAAA;ArDwjRJ;;AqDrjRE;EACE,iBAAA;ArDwjRJ;;AqDrjRE;EACE,iBAAA;ArDwjRJ;;AqDpjRE;EAGE,wBAAA;UAAA,qBAAA;ArDqjRJ;;AqDjjRE;;EAEE,sBAAA;UAAA,qBAAA;ArDojRJ;;AqDjjRE;;;;EAQE,yBAAA;UAAA,wBAAA;ArDgjRJ;;AqD7iRE;EACE,sBAAA;ArDgjRJ;;AqD5iRE;;EAEE,uBAAA;EACA,+BjD5ZY;EiD4ZZ,gDjD5ZY;AJ28RhB;;AqD5iRE;EACE,6B3C1LY;E2C0LZ,uD3C1LY;E2C2LZ,oBAAA;ArD+iRJ;AqD7iRI;EACE,6BAAA;EACA,eAAA;ArD+iRN;;AqD3iRE;;EAQE,aAAA;ArDwiRJ;;AqDriRE;EAGE,yBjDvbY;EiDubZ,0CjDvbY;AJ69RhB;;AqDliRE;;;EAKE,kBAAA;EACA,sBAAA;EACA,sBlCtaS;EkCuaT,2BAAA;ArDmiRJ;;AqDhiRE;EAKE,gBAAA;ArD+hRJ;;AqD5hRE;;;;;;;EAaE,kBAAA;EACA,yBjD5dY;EiD4dZ,0CjD5dY;EiD6dZ,gBAAA;EACA,WAAA;EACA,sBAAA;ArDyhRJ;;AqDthRE;;;EAKE,aAAA;EACA,yBAAA;ArDuhRJ;;AqDphRE;;;EAME,yBAAA;EACA,2BAAA;ArDohRJ;;AqDjhRE;EACE,cAAA;EACA,mBAAA;ArDohRJ;;AqDjhRE;;EAIE,cAAA;EACA,wBlCvfS;AnBygSb;;AqD/gRE;;EAIE,aAAA;ArDghRJ;;AqD7gRE;;EAEE,aAAA;EACA,mBAAA;ArDghRJ;;AqD7gRE;;EAIE,aAAA;ArD8gRJ;;AqD3gRE;;EAEE,aAAA;ArD8gRJ;;AqD3gRE;;EAEE,sBAAA;ArD8gRJ;;AqD3gRE;;;;EAWE,cAAA;ArDugRJ;;AqDpgRE;;;;EAYE,yBAAA;UAAA,wBAAA;ArD+/QJ;;AqD5/QE;;;;;;;;ExBtkBA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;E2CwDf,8BAAA;UAAA,6BAAA;ArDi+QJ;;AqD59QE;EjC/nBA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB+lSF;AoB7lSE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB6lSJ;AoB1lSE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB4lSJ;AoB1lSI;EAVF;IAWI,eAAA;EpB6lSJ;AACF;AqB5nSE;EgCmoBA;IjC/lBE,sBAAA;EpB4lSF;EoB1lSE;IACE,kBAAA;IACA,yBAAA;EpB4lSJ;AACF;AqDlgRE;EAGE,iBAAA;ArDkgRJ;AqDhgRI;;EAEE,aAAA;ArDkgRN;;AqD9/QE;EACE,gBlCnnBS;AnBonSb;;AqD9/QE;EACE,kBlClnBS;AnBmnSb;;AqD9/QE;EACE,gBlCjnBS;AnBknSb;;AqBxpSE;EgC4pBA;;IhC1pBI,gBAAA;IACA,4BAAA;ErB4pSJ;AACF;;AqBhqSE;EgCiqBA;IhC1pBI,8BAAA;ErB8pSJ;AACF;;AsDrpSE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;AtDwpSJ;;AsDrpSE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;AtDwpSJ;AsDtpSI;EACE,sBAAA;AtDwpSN;;AsDppSE;ExC+yBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwC5yBA,c5CoJW;E4CpJX,uC5CoJW;E4CnJX,mBAAA;AtDypSJ;;AsDtpSE;EACE,kBAAA;EACA,mBlDtBY;EkDsBZ,oClDtBY;EkDuBZ,oBAAA;EACA,iBAAA;EACA,8BAAA;AtDypSJ;;AsDtpSE;EACE,kBAAA;EACA,qBAAA;EACA,mBlD/BY;EkD+BZ,oClD/BY;EkDgCZ,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,6BAAA;EACA,uBAAA;EACA,6BAAA;AtDypSJ;;AsDtpSE;EACE,kBAAA;EACA,mB5CoBqB;E4CpBrB,sD5CoBqB;E4CnBrB,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,8BAAA;EACA,sBAAA;EACA,4DAAA;AtDypSJ;;AsDtpSE;EACE,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,qBAAA;EACA,gCAAA;EpDxCF,oCAAA;EAAA,4BAAA;AFmsSF;AsDvpSI;EACE,+BAAA;AtDypSN;;AsDrpSE;;EAEE,gBAAA;EACA,iBAAA;EpDpDF,6DAAA;AF6sSF;;AsDlpSE;EACE,iCAAA;AtDqpSJ;AsDnpSI;EACE,6CAAA;EAAA,wEAAA;AtDqpSN;AsD/oSI;EACE,0BAAA;EACA,0CAAA;EAAA,qEAAA;AtDipSN;;AsD1oSE;EACE,gCAAA;AtD6oSJ;AsD3oSI;EACE,2CAAA;EAAA,sEAAA;AtD6oSN;AsDvoSI;EACE,2CAAA;EAAA,sEAAA;AtDyoSN;;AsDloSE;EACE,6BAAA;AtDqoSJ;AsDnoSI;EACE,8CAAA;EAAA,yEAAA;AtDqoSN;AsD/nSI;EACE,2CAAA;EAAA,sEAAA;AtDioSN;;AsD1nSE;EACE,6BAAA;AtD6nSJ;AsD3nSI;EACE,2CAAA;EAAA,sEAAA;AtD6nSN;AsDvnSI;EACE,0CAAA;EAAA,qEAAA;AtDynSN;;AsDlnSE;EACE,kBAAA;EACA,kBAAA;EACA,mB5CzFqB;E4CyFrB,sD5CzFqB;E4C0FrB,oEACE;EAEF,QAAA;EACA,aAAA;EACA,+JACE;AtDknSN;AsD9mSI;EAEE,wBAAA;AtD+mSN;AsD5mSI;EACE,sC5CvDQ;E4CuDR,iD5CvDQ;E4CwDR,yEACE;EADF,6FACE;EAGF,wBAAA;AtD2mSN;AsDxmSI;EACE,gDAAA;EAAA,2DAAA;EACA,wBAAA;AtD0mSN;;AsDtmSE;EACE,a5CzHqB;E4CyHrB,gD5CzHqB;AVkuSzB;;AsDtmSE;EACE,aAAA;EACA,0B5C3EU;E4C2EV,qC5C3EU;AVorSd;;AsDtmSE;;EAEE,kBAAA;EACA,gBAAA;EAAA,sBAAA;EACA,6BAAA;EACA,gBAAA;EACA,QAAA;EACA,gBAAA;AtDymSJ;AsDvmSI;;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,mB5C5NO;E4C4NP,0C5C5NO;E4C6NP,oBAAA;EACA,WAAA;EACA,qBAAA;EACA,wCAAA;EACA,mBAAA;AtD0mSN;AsDvmSI;;EACE,eAAA;AtD0mSN;AsDxmSM;;EACE,a5CjDS;E4CiDT,wC5CjDS;AV4pSjB;AsDvmSI;;EACE,gBAAA;EACA,eAAA;AtD0mSN;AsDvmSI;;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AtD0mSN;AsDxmSM;;EACE,aAAA;EACA,0B5CvHM;E4CuHN,qC5CvHM;AVkuSd;AsDxmSM;;EACE,cAAA;AtD2mSR;;AsDtmSE;;EAEE,iBAAA;AtDymSJ;;AsDtmSE;EACE,eAAA;AtDymSJ;AsDvmSI;EACE,oBAAA;AtDymSN;AsDtmSI;EAGE,eAAA;AtDsmSN;;AsDlmSE;EACE,aAAA;AtDqmSJ;;AsDlmSE;EACE,kBAAA;AtDqmSJ;;AsDlmSE;EACE,aAAA;AtDqmSJ;;AsDlmSE;;EAGE,6BAAA;UAAA,qBAAA;EACA,kBAAA;EACA,iBAAA;AtDqmSJ;AsDnmSI;;;EAEE,aAAA;AtDsmSN;;AsDlmSE;;EAGE,sC5ClIiB;E4CkIjB,wD5ClIiB;AVsuSrB;;AsDhmSE;;EAEE,iBAAA;EACA,yBnC1RS;UmC0RT,wBnC1RS;AnB63Sb;;AsDhmSE;EACE,kBAAA;EACA,a5ChEY;E4CgEZ,uC5ChEY;E4CkEZ,sBAAA;EACA,sBnCtTS;EmCuTT,2BAAA;AtDkmSJ;;AsD/lSE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;AtDkmSJ;;AsD/lSE;EACE,c5C1IS;E4C0IT,qC5C1IS;AV4uSb;;AsD/lSE;EACE,a5C5Ec;E4C4Ed,yC5C5Ec;AV8qSlB;;AsD/lSE;EACE,ajB7VQ;EiB8VR,UAAA;AtDkmSJ;;AsD9lSE;EAGE,6B5C9IY;E4C8IZ,uD5C9IY;AV6uShB;;AsD5lSE;EACE,mBAAA;AtD+lSJ;;AsD5lSE;EACE,yB5CjLc;E4CiLd,qD5CjLc;AVgxSlB;AsD7lSI;EACE,mBAAA;EACA,eAAA;AtD+lSN;AsD5lSI;EACE,yB5CzLY;E4CyLZ,qD5CzLY;E4C0LZ,gBAAA;EACA,aAAA;EACA,eAAA;AtD8lSN;AsD3lSI;EACE,mB5ChMY;E4CgMZ,+C5ChMY;E4CiMZ,gBAAA;EACA,eAAA;AtD6lSN;;AsDzlSE;;EAEE,6BAAA;AtD4lSJ;AsD1lSI;;;;EAGE,6BAAA;EACA,eAAA;AtD6lSN;AsD1lSI;;EACE,a5ClNY;E4CkNZ,yC5ClNY;AV+ySlB;;AsDzlSE;;;EAKE,yB5C3Nc;E4C2Nd,qD5C3Nc;AVqzSlB;;AsDvlSE;;EAIE,YAAA;EACA,yBlDvYI;EkDuYJ,kClDvYI;EkDwYJ,6B5CzMY;E4CyMZ,uD5CzMY;E4C0MZ,mBAAA;EACA,gBAAA;AtDwlSJ;AsDtlSI;;;;EAGE,6B5ChNU;E4CgNV,uD5ChNU;E4CiNV,aAAA;AtDylSN;;AsDplSE;EACE,eAAA;AtDulSJ;;AsDplSE;EACE,aAAA;EACA,cAAA;AtDulSJ;AsDrlSI;EAEE,aAAA;AtDslSN;;AsDllSE;EACE,6BAAA;AtDqlSJ;;AsDllSE;EACE,cAAA;EACA,iBAAA;EACA,oBAAA;AtDqlSJ;;AsDjlSE;ElChcA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBqhTF;AoBnhTE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBmhTJ;AoBhhTE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBkhTJ;AoBhhTI;EAVF;IAWI,eAAA;EpBmhTJ;AACF;AqBljTE;EiCocA;IlChaE,sBAAA;EpBkhTF;EoBhhTE;IACE,kBAAA;IACA,yBAAA;EpBkhTJ;AACF;AsDvnSE;EAIE,mBAAA;EACA,oBAAA;AtDsnSJ;;AsDnnSE;EAEE,eAAA;EACA,oBAAA;AtDqnSJ;;AsDjnSI;EACE,uBAAA;AtDonSN;AsDjnSI;EACE,eAAA;EACA,oBAAA;AtDmnSN;AsDhnSI;EACE,qBAAA;AtDknSN;AsD/mSI;EACE,wBAAA;AtDinSN;;AsD5mSE;EACE,kBAAA;AtD+mSJ;;AqBtlTE;EiC4eA;IjCreI,8BAAA;ErBolTJ;AACF;;AqB5lTE;EiC+eA;IjC7eI,gBAAA;IACA,4BAAA;ErB+lTJ;AACF;;AqBnmTE;EiCkfA;IjC3eI,8BAAA;ErBimTJ;AACF;;AuD1mTA;EACE;IACE,4BAAA;EvD6mTF;EuD1mTA;IACE,2BAAA;EvD4mTF;AACF;AwD9mTE;EpCAA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBinTF;AoB/mTE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB+mTJ;AoB5mTE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB8mTJ;AoB5mTI;EAVF;IAWI,eAAA;EpB+mTJ;AACF;AqB9oTE;EmCIA;IpCgCE,sBAAA;EpB8mTF;EoB5mTE;IACE,kBAAA;IACA,yBAAA;EpB8mTJ;AACF;AwDnpTE;EAGE,qBAAA;EACA,gBAAA;EACA,iBAAA;AxDmpTJ;;AwD/oTE;EpCTA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB4pTF;AoB1pTE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB0pTJ;AoBvpTE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBypTJ;AoBvpTI;EAVF;IAWI,eAAA;EpB0pTJ;AACF;AqBzrTE;EmCaA;IpCuBE,sBAAA;EpBypTF;EoBvpTE;IACE,kBAAA;IACA,yBAAA;EpBypTJ;AACF;AwDrrTE;EAGE,mBAAA;EAEA,oBAAA;AxDorTJ;;AwDhrTE;EpClBA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBssTF;AoBpsTE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBosTJ;AoBjsTE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBmsTJ;AoBjsTI;EAVF;IAWI,eAAA;EpBosTJ;AACF;AqBnuTE;EmCsBA;IpCcE,sBAAA;EpBmsTF;EoBjsTE;IACE,kBAAA;IACA,yBAAA;EpBmsTJ;AACF;AwDttTE;EAGE,gBAAA;EAEA,iBAAA;EAEA,4BrCrBS;UqCqBT,wBrCrBS;AnByuTb;;AwDjtTE;EACE,kBAAA;AxDotTJ;;AuDxuTE;;;EAGE,gBAAA;EACA,mB7CikBqB;E6CjkBrB,sD7CikBqB;AV0qSzB;;AuDxuTE;;;EAGE,4DAAA;EACA,wHAAA;AvD2uTJ;;AuDnuTE;;EAEE,iBAAA;AvDsuTJ;;AuDluTE;EACE,qBAAA;AvDquTJ;;AuDjuTE;EACE,mBAAA;AvDouTJ;;AuDhuTE;EACE,uBAAA;AvDmuTJ;;AqBpxTE;EkCuDE;;;IAGE,sBAAA;EvDiuTJ;EuD9tTE;;;IAGE,kBAAA;EvDguTJ;AACF;AyD/wTE;EACE,kBAAA;EAEA,gCtCvBS;UsCuBT,6BtCvBS;AnBuyTb;;AyD7wTE;EACE,cAAA;EACA,gBAAA;AzDgxTJ;;AyD7wTE;E7CbE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ8xTJ;AY5xTI;E6CUF;I7CTI,qBAAA;EZ+xTJ;AACF;;AyDhxTE;EACE,kBAAA;EAEA,YAAA;EACA,YAAA;AzDkxTJ;;AyD/wTE;EACE,kBAAA;EACA,WAAA;EAEA,6EAAA;EAAA,mIAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;EACA,oBAAA;AzDixTJ;;AyD9wTE;EACE,kBAAA;AzDixTJ;;AyD9wTE;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;EAEA,oBAAA;E5BrBA,4GAAA;EAAA,8JAAA;A7BsyTJ;;AyDzwTE;EACE,yBrD/DI;EqD+DJ,kCrD/DI;EqDgEJ,0BAAA;EACA,oBtC3DS;AnBu0Tb;;AyDzwTE;EACE,aAAA;EACA,8BAAA;AzD4wTJ;;AyDzwTE;EACE,yBAAA;AzD4wTJ;;AyDzwTE;E3C4vBE,kBAAA;EAAA,mDAAA;EAAA,gBAAA;EAAA,mDAAA;EAAA,gBAAA;EAAA,mDAAA;EAAA,iBAAA;EAAA,uDAAA;E2CzvBA,c/CiGW;E+CjGX,uC/CiGW;AV6qTf;;AyD3wTE;E3CsvBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E2CnvBA,c/C8Fa;E+C9Fb,yC/C8Fa;AVkrTjB;A4BnxTM;E6BAJ;IAMI,qBAAA;EzDixTJ;AACF;A4BxxTM;E6BAJ;IAUI,qBAAA;EzDkxTJ;AACF;;AyD5wTE;EACE,yBAAA;EACA,iBAAA;EACA,iBAAA;AzD+wTJ;;AyD5wTE;E3C+tBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E2C5tBA,yBrDvGW;EqDuGX,yCrDvGW;AJw3Tf;;AyD9wTE;E3CytBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E2CttBA,yBrDnHI;EqDmHJ,kCrDnHI;EqDoHJ,iBAAA;AzDmxTJ;;AyDhxTE;EACE,YAAA;EACA,gBtC/FS;EsCgGT,iBAAA;AzDmxTJ;;AyDhxTE;;;EAGE,+DAAA;AzDmxTJ;;AyDhxTE;;EAEE,yBrDlIU;EqDkIV,wCrDlIU;AJq5Td;;AyDhxTE;;EAEE,uCAAA;UAAA,mCAAA;EAAA,sDAAA;UAAA,kDAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,uDAAA;UAAA,oDAAA;EACA,c/CqCW;E+CrCX,uC/CqCW;AV8uTf;;AyDhxTE;EAGE,c/CgEa;E+ChEb,yC/CgEa;AVitTjB;;AyD9wTE;EAKE,6B/C+CY;E+C/CZ,uD/C+CY;AV8tThB;;AyD1wTE;;EAEE,iBAAA;EACA,sBAAA;AzD6wTJ;;AyD1wTI;EAGE,wBAAA;AzD2wTN;AyDzwTM;EACE,8BtC7KK;UsC6KL,2BtC7KK;AnBw7Tb;AyDxwTM;EACE,iCAAA;UAAA,8BAAA;AzD0wTR;AyDtwTI;EACE,mBAAA;AzDwwTN;;AyDnwTI;EAEE,wBAAA;AzDqwTN;AyDnwTM;EACE,8BtChMK;UsCgML,2BtChMK;AnBq8Tb;AyDlwTM;EACE,iCAAA;UAAA,8BAAA;AzDowTR;AyDhwTI;EACE,mBAAA;AzDkwTN;;AyD9vTE;;EAEE,eAAA;AzDiwTJ;;AyD9vTE;;EAEE,kBAAA;AzDiwTJ;;AyD9vTE;EACE,yBrD9MW;EqD8MX,yCrD9MW;EqD+MX,c/CpCW;E+CoCX,uC/CpCW;E+CqCX,yBAAA;AzDiwTJ;;AyD9vTE;EAEE,gBAAA;EACA,iBAAA;AzDgwTJ;;AyD7vTE;EACE,iBAAA;AzDgwTJ;;AyD7vTE;;EAEE,uCAAA;UAAA,mCAAA;EAAA,oEAAA;UAAA,gEAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,iDAAA;UAAA,8CAAA;EACA,c/CnDa;E+CmDb,yC/CnDa;E+CoDb,yBAAA;AzDgwTJ;AyD9vTI;;EACE,8BtC1OO;UsC0OP,6BtC1OO;AnB2+Tb;;AyD7vTE;;EAEE,uCAAA;UAAA,mCAAA;EAAA,oEAAA;UAAA,gEAAA;AzDgwTJ;;AyD7vTE;;EAEE,uCAAA;UAAA,mCAAA;EAAA,oEAAA;UAAA,gEAAA;AzDgwTJ;;AyD7vTE;EACE;IAEE,4BAAA;EzD+vTJ;AACF;AyD1vTE;;;;;;;;;;EAUE,yB/C1JO;E+C0JP,8C/C1JO;AVs5TX;;AyDxvTE;E7C5QE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZwgUJ;AYtgUI;E6CyQF;I7CxQI,qBAAA;EZygUJ;AACF;;AyD5vTE;EAGE,aAAA;AzD6vTJ;;AyD1vTE;EAGE;IAIE,UAAA;EzDwvTJ;AACF;AyDrvTE;EAIE,UAAA;AzDovTJ;;AyDjvTE;;;;EAiBE,UAAA;AzDuuTJ;;AyDpuTE;EAIE,kBAAA;EAEA,4BAAA;EACA,0BtC7US;UsC6UT,yBtC7US;AnBgjUb;;AyD9tTI;;EACE,yBrD1UiB;EqD0UjB,iDrD1UiB;AJ4iUvB;;AyD5tTI;;EACE,yBrDnVQ;EqDmVR,wCrDnVQ;AJmjUd;;AyD5tTE;EAEE,c/C1Ia;E+C0Ib,yC/C1Ia;AVw2TjB;;AyD3tTE;;EAEE,kBAAA;EACA,gBAAA;AzD8tTJ;;AyD3tTE;EACE,gBAAA;AzD8tTJ;;AyD3tTE;EACE,kBAAA;AzD8tTJ;;AyD3tTE;EACE,8BtClXS;UsCkXT,2BtClXS;AnBglUb;;AyDvtTE;EAIE,uCAAA;UAAA,mCAAA;EAAA,gDAAA;UAAA,4CAAA;AzDutTJ;;AyDptTE;EAIE,uCAAA;UAAA,mCAAA;EAAA,uDAAA;UAAA,mDAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,wDAAA;UAAA,qDAAA;AzDotTJ;;AyDjtTE;EAKE,yBrDnYW;EqDmYX,yCrDnYW;AJmlUf;;AyD7sTE;EAIE,uCAAA;UAAA,mCAAA;EAAA,sDAAA;UAAA,kDAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,uDAAA;UAAA,oDAAA;AzD6sTJ;;AyD1sTE;EAKE,yBrDtZU;EqDsZV,wCrDtZU;AJ+lUd;;AyDnsTE;EACE,sBtCrZS;EsCsZT,wBAAA;UAAA,uBAAA;AzDssTJ;;AyDnsTE;EACE,+BAAA;UAAA,4BAAA;AzDssTJ;;AyDnsTE;EACE,6BAAA;AzDssTJ;;AyDnsTE;EAEE,gBAAA;EACA,yBrDzaW;EqDyaX,yCrDzaW;EqD0aX,iBAAA;EACA,+DAAA;AzDqsTJ;;AyDlsTE;;;;EAIE,kBAAA;AzDqsTJ;;AyDlsTE;;EAEE,uBAAA;EAEA,4BAAA;AzDosTJ;;AyDjsTE;;EAEE,gBAAA;EACA,iBAAA;AzDosTJ;;AyDjsTE;;EAEE,qBAAA;EACA,kBAAA;EACA,mBAAA;AzDosTJ;;AyDjsTE;;EAEE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;UAAA,4BAAA;AzDosTJ;;AyDjsTE;;EAEE,iCAAA;EACA,kBAAA;EACA,mBAAA;AzDosTJ;;AyDjsTE;;EAEE,gBAAA;EACA,gCAAA;AzDosTJ;;AyDjsTE;EACE,iCAAA;UAAA,8BAAA;AzDosTJ;;AyDjsTE;EACE,4BtCneS;UsCmeT,yBtCneS;AnBuqUb;;AyD9rTE;EACE,iBAAA;AzDisTJ;;AyD9rTE;EACE,6BAAA;UAAA,4BAAA;AzDisTJ;;AyD7rTE;;EAME,uCAAA;UAAA,mCAAA;EAAA,uDAAA;UAAA,mDAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,0DAAA;UAAA,uDAAA;EACA,c/C/UW;E+C+UX,uC/C/UW;AV2gUf;;AyDzrTE;;EAIE,yBrDngBa;EqDmgBb,2CrDngBa;AJ6rUjB;;AyDtrTE;;EAME,wCAAA;UAAA,qCAAA;EAAA,kEAAA;UAAA,+DAAA;AzDqrTJ;;AyDjrTE;;;EASE,uCAAA;UAAA,mCAAA;EAAA,yDAAA;UAAA,qDAAA;EAEA,wCAAA;UAAA,qCAAA;EAAA,0DAAA;UAAA,uDAAA;AzD6qTJ;;AyDzqTE;EAIE,uCAAA;UAAA,mCAAA;EAAA,uDAAA;UAAA,mDAAA;AzDyqTJ;;AyDtqTE;EAIE,uCAAA;UAAA,mCAAA;EAAA,+DAAA;UAAA,2DAAA;AzDsqTJ;;AyDlqTE;;EAKE,uCAAA;UAAA,mCAAA;EAAA,+DAAA;UAAA,2DAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,gEAAA;UAAA,6DAAA;EACA,c/CzYW;E+CyYX,uC/CzYW;AV2iUf;;AyD/pTE;;EAIE,yBrD5jBmB;EqD4jBnB,iDrD5jBmB;AJ4tUvB;;AyD5pTE;EAGE,UAAA;AzD6pTJ;;AyDvpTE;;;EAGE,kBAAA;AzD0pTJ;;AyDvpTE;EACE,gCAAA;AzD0pTJ;;AyDvpTE;;EAEE,gCAAA;AzD0pTJ;;AyDvpTE;EACE,4BAAA;EACA,iBAAA;AzD0pTJ;;AyDvpTE;;EAQE,gBAAA;AzDopTJ;;AyDjpTE;EAGE,qBAAA;EAEA,yBAAA;AzDipTJ;;AyD3oTE;;;EAGE,gBAAA;AzD8oTJ;;AyD3oTE;EACE,kCAAA;AzD8oTJ;;AyD3oTE;;;EAIE,iCAAA;AzD6oTJ;;AyD1oTE;;EAQE,kCAAA;AzDuoTJ;;AyDpoTE;EACE,4BAAA;AzDuoTJ;;AyDjoTE;;;EAGE,kBAAA;AzDooTJ;;AyDjoTE;;EAGE,kCAAA;AzDmoTJ;;AyDhoTE;;EAEE,iCAAA;AzDmoTJ;;AyDhoTE;;EAQE,kCAAA;AzD6nTJ;;AyD1nTE;EACE,kCAAA;AzD6nTJ;;AyDvnTE;;;EAGE,gBAAA;AzD0nTJ;;AyDvnTE;EACE,wBAAA;AzD0nTJ;;AyDvnTE;;EAEE,wBAAA;AzD0nTJ;;AyDvnTE;;EAEE,mBAAA;AzD0nTJ;;AyDvnTE;E3CuHE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;AdugTJ;;AyDvnTE;EACE,iBAAA;AzD0nTJ;;AyDvnTE;EACE,gCAAA;EAAA,wBAAA;AzD0nTJ;;AyDpnTE;EACE,yBrD/tBW;EqD+tBX,yCrD/tBW;EqDguBX,wBAAA;AzDunTJ;;AyDpnTE;EACE,cAAA;EACA,kBAAA;AzDunTJ;AyDrnTI;;;;;EAKE,aAAA;AzDunTN;AyDpnTI;EACE,wBAAA;EAAA,gBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EAEA,wBAAA;EACA,sBAAA;AzDqnTN;AyDlnTI;EACE,uCAAA;UAAA,mCAAA;EAAA,uDAAA;UAAA,mDAAA;AzDonTN;AyDjnTI;EACE,sBAAA;EAEA,wBAAA;EACA,kBAAA;EACA,sBAAA;AzDknTN;AyD/mTI;EACE,gBAAA;EACA,oBAAA;AzDinTN;AyD9mTI;EACE,gBAAA;AzDgnTN;AyD7mTI;EACE,qBAAA;AzD+mTN;AyD5mTI;EACE,mBAAA;AzD8mTN;AyD3mTI;EACE,oBAAA;AzD6mTN;AyD1mTI;EAME,gCAAA;UAAA,6BAAA;AzDumTN;AyDlmTI;EAGE,wCAAA;UAAA,qCAAA;EAAA,uDAAA;UAAA,oDAAA;AzDkmTN;AyD/lTI;EACE,gBAAA;AzDimTN;AyD9lTI;EACE,2BAAA;UAAA,wBAAA;AzDgmTN;AyD5lTI;;EAEE,mBAAA;EACA,oBAAA;EACA,wBAAA;AzD8lTN;AyD3lTI;EAEE,uBAAA;AzD4lTN;AyDvrTE;EA+FE,iOAAA;AzD2lTJ;AyD1lTI;EACE,qBAAA;AzD4lTN;AyDzlTI;EACE,wBAAA;AzD2lTN;AyDxlTI;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,sBAAA;AzD0lTN;AyDtlTI;;EAEE,aAAA;AzDwlTN;AyDzsTE;EAoHE,qDAAA;EACA,kCAAA;EACA,uEAAA;EACA,yDAAA;AzDwlTJ;AyDvlTI;EACE;;IAEE,qBAAA;EzDylTN;AACF;AyDtlTI;EACE,uBAAA;UAAA,mBAAA;AzDwlTN;AyDrlTI;;EAME,iBAAA;EACA,kBAAA;AzDmlTN;AyDhlTI;EAGE,gBAAA;AzDglTN;AyD7kTI;EACE,sBAAA;AzD+kTN;AyD5kTI;EACE,oBAAA;AzD8kTN;AyD3kTI;EACE,oBAAA;AzD6kTN;AyDzkTI;EACE,+BAAA;UAAA,4BAAA;AzD2kTN;AyDxkTI;EACE,8BAAA;UAAA,2BAAA;AzD0kTN;AyDvkTI;EC75BF,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;ED65BI,kCAAA;EACA,kBAAA;EACA,6BAAA;AzD2kTN;AyDvkTI;EACE,0BAAA;AzDykTN;AyDtkTI;EACE,uBAAA;AzDwkTN;AyDrkTI;EACE,4BAAA;UAAA,yBAAA;AzDukTN;AyDpkTI;EACE,aAAA;EACA,uBAAA;AzDskTN;AyDnkTI;EAME,uBAAA;AzDgkTN;;A2Dt/UE;EACE,qBFy7BiC;AzDgkTrC;;A2Dt/UE;EACE,wBAPW;A3DggVf;;AyD/jTE;EAEE,SAAA;AzDikTJ;;AyD9jTE;;EAIE,oBAAA;AzD+jTJ;;AyDzjTE;;EAEE,iBtCr8BS;EsCs8BT,sBAAA;UAAA,qBAAA;AzD4jTJ;;AyDzjTE;;;;E5Bv6BE,+GAAA;EAAA,oKAAA;E4B66BA,4BAAA;AzD2jTJ;;AyDxjTE;;EAEE,+BAAA;EAAA,4DAAA;AzD2jTJ;;AyDvjTE;;;;;;;;;;;EA8BE,6BAAA;AzDuiTJ;;AyDpiTE;;;;;E5B9+BE,4GAAA;EAAA,+MAAA;E4Bu/BA,4BAAA;AzDoiTJ;;AyDjiTE;;;;;;E5Bl/BE,wHAAA;EAAA,+LAAA;E4B4/BA,4BAAA;AzDiiTJ;;AyD9hTE;;;;EAQE,+BrDnhCY;EqDmhCZ,gDrDnhCY;AJgjVhB;;AyD1hTE;;EAQE,uCAAA;UAAA,mCAAA;EAAA,yDAAA;UAAA,qDAAA;AzDuhTJ;;AyDphTE;;;EAME,2CAAA;UAAA,uCAAA;AzDohTJ;;AyDjhTE;;;;E5B/gCE,+GAAA;EAAA,oKAAA;A7BuiVJ;;AyDzgTE;;;EAGE,kBAAA;EACA,UAAA;EACA,2BAAA;AzD4gTJ;;AyDzgTE;;;EAOE,0BAAA;AzDwgTJ;;AyDpgTE;;;EAGE,aAAA;EACA,mBAAA;AzDugTJ;;AyDpgTE;;;;EAYE,0BAAA;UAAA,yBAAA;AzD+/SJ;;AyD5/SE;;;;EAIE,+BAAA;EAAA,4DAAA;AzD+/SJ;;AyD5/SE;E5B9kCE,+GAAA;EAAA,oKAAA;A7B8kVJ;;AyD5/SE;EAGE,0HAAA;UAAA,uHAAA;EAAA,+KAAA;UAAA,4KAAA;AzD6/SJ;;AqBtoVE;EoCipCA;;IpC1oCI,8BAAA;ErBqoVJ;AACF;;A4DhoVE;EAEE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBxDNI;EwDMJ,kCxDNI;EwDOJ,iBAAA;EACA,oBzCkBS;AnBgnVb;;A4D/nVE;EACE,aAAA;EACA,yBAAA;EACA,gBzCYS;EyCXT,iBAAA;EACA,+BAAA;EACA,oHACE;EADF,4GACE;EADF,qKACE;A5DioVN;;A4D7nVE;EACE,eAAA;EAEA,6BAAA;EACA,gBAAA;A5D+nVJ;;A4D5nVE;EACE,gBAAA;EACA,iBAAA;A5D+nVJ;;A4DznVE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;A5D4nVJ;;A4DtnVE;EACE,kBAAA;EACA,gBzCvBS;EyCwBT,gBAAA;EACA,eAAA;EACA,iBzC1BS;EyC2BT,0GACE;A5DwnVN;A4DrnVI;EACE,yBxD/CQ;EwD+CR,wCxD/CQ;AJsqVd;;A4DnnVE;EACE,iBAAA;A5DsnVJ;;A4DnnVE;EACE,gBAAA;EACA,eAAA;EACA,UAAA;A5DsnVJ;;A4DnnVE;EAIE,UAAA;A5DmnVJ;;A4DhnVE;EACE,mBAAA;A5DmnVJ;;A4DhnVE;EAEE,kBAAA;A5DknVJ;;A4D/mVE;EAEE,gBzChES;EyCiET,iBzCjES;AnBkrVb;A4D/mVI;EACE,yBxDnFQ;EwDmFR,wCxDnFQ;EwDoFR,gCAAA;EACA,2BAAA;A5DinVN;;A4D7mVE;EAEE,sClDykBI;EkDzkBJ,2ClDykBI;AVsiUR;;A4DxmVE;EAGE,qBAAA;A5DymVJ;;A4DrmVE;EAGE,wBAAA;A5DsmVJ;;A4DlmVE;EAKE,qBAAA;A5DimVJ;;A4D9lVE;EAGE,0BAAA;A5D+lVJ;;A4D3lVE;EAGE,0BAAA;A5D4lVJ;;A4DzlVE;EAEE,azC5IS;EyC6IT,gBzCzHS;EyC0HT,iBzC1HS;AnBqtVb;;A4DxlVE;EAEE,yBxDzJI;EwDyJJ,kCxDzJI;EwD0JJ,mBAAA;EACA,iCAAA;A5D0lVJ;;A4DvlVE;;;EAME,YAAA;EACA,6BAAA;EACA,aAAA;A5DulVJ;;A4DhlVE;EACE,iBAAA;A5DmlVJ;;A4DhlVE;EACE,UAAA;A5DmlVJ;;A4DhlVE;;EAEE,eAAA;EACA,YAAA;A5DmlVJ;;A4DhlVE;EAGE,YAAA;EACA,gBAAA;EACA,aAAA;A5DilVJ;;A4D9kVE;EAEE,YAAA;EACA,yBxD3LU;EwD2LV,wCxD3LU;AJ2wVd;;A4D1kVE;;;;EAKE,YAAA;EACA,6BAAA;A5D4kVJ;;A4DzkVE;EAEE,aAAA;A5D2kVJ;;A4DrkVE;EjDxOA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT4zVF;AS1zVE;;;EAGE,mBAAA;AT4zVJ;AWtzVE;EACE,SAAA;AXwzVJ;A4D/lVE;EAGE,aAAA;EACA,azC3NS;EyC4NT,gBzCxMS;EyCyMT,eAAA;EACA,iBzC1MS;EyC2MT,0DAAA;A5D+lVJ;;A4D3lVE;EjDpPA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT81VF;AS51VE;;;EAGE,mBAAA;AT81VJ;AWx1VE;EACE,SAAA;AX01VJ;A4DrnVE;EAGE,aAAA;EACA,gBzCnNS;EyCoNT,eAAA;EACA,iBzCrNS;EyCsNT,0DAAA;A5DqnVJ;;A4DlnVE;EACE,yBxDzOU;EwDyOV,wCxDzOU;AJ81Vd;;A4DlnVE;;EAEE,yBlDlNO;EkDkNP,8ClDlNO;AVu0VX;;A4DlnVE;EACE,mBAAA;A5DqnVJ;;A4DlnVE;EACE,mBAAA;EACA,4BlDfY;EkDeZ,sDlDfY;AVooVhB;;A4DlnVE;;EhDjQE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZw3VJ;AYt3VI;EgD8PF;;IhD7PI,qBAAA;EZ03VJ;AACF;A4D1nVI;;EAEE,aAAA;A5D4nVN;;A4DxnVE;EACE,SAAA;EACA,qBAAA;EACA,mBAAA;A5D2nVJ;;A4DxnVE;EACE,gBzC5PS;AnBu3Vb;;A4DrnVE;EACE,gBzCvRS;EyCwRT,alD1DW;EkD0DX,sClD1DW;EkD2DX,iBAAA;EACA,qBzC1RS;AnBk5Vb;;A4DlnVE;;EAEE,yBlDjQO;EkDiQP,8ClDjQO;AVs3VX;;A4D/mVE;EACE,kBAAA;EACA,gBzCtRS;EyCuRT,iBAAA;EACA,UAAA;A5DknVJ;;A4D/mVE;EAEE,kBAAA;EACA,iBAAA;A5DinVJ;;A4D9mVE;EACE,gBAAA;EAAA,iBAAA;A5DinVJ;;A4D9mVE;EAEE,wBzC3TS;AnB26Vb;;A4D7mVE;EACE,eAAA;EACA,YAAA;EACA,gBzC7SS;AnB65Vb;;A4D7mVE;EhDtUE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZu7VJ;AYr7VI;EgDmUF;IhDlUI,qBAAA;EZw7VJ;AACF;;A4DlnVE;EAEE,yBxDtUU;EwDsUV,wCxDtUU;AJ07Vd;;A4DjnVE;;EAIE,yBxD7UU;EwD6UV,wCxD7UU;AJ+7Vd;;A4D/mVE;EACE,gBzClUS;EyCmUT,iBzCnUS;AnBq7Vb;;A4D/mVE;;EAEE,oDAAA;UAAA,4CAAA;EACA,kCAAA;EACA,oHACE;EADF,4GACE;EADF,qKACE;A5DinVN;;A4D1mVE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBlDrWe;EkDqWf,sDlDrWe;EkDsWf,oDAAA;UAAA,4CAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,kCAAA;EACA,mKACE;EADF,2JACE;EADF,oNACE;EAGF,sBAAA;A5D0mVJ;;A4DvmVE;EhDxYE,uCAAA;EAAA,4CAAA;AZm/VJ;AYj/VI;EgDsYF;IhDrYI,qBAAA;EZo/VJ;AACF;;A4D5mVE;EACE,UAAA;EACA,0DAAA;UAAA,kDAAA;EACA,UAAA;EACA,mBAAA;EACA,+BAAA;A5D+mVJ;;A4D3mVE;EACE,aAAA;EACA,mBAAA;A5D8mVJ;;A4D3mVE;;EAEE,clDhNY;EkDgNZ,wClDhNY;EkDiNZ,yBAAA;EACA,mBAAA;A5D8mVJ;;A4D3mVE;EACE,yBAAA;EACA,6BAAA;EACA,clDxNY;EkDwNZ,wClDxNY;EkDyNZ,YAAA;A5D8mVJ;;A4D3mVE;EACE,gBAAA;EACA,alDpLY;EkDoLZ,uClDpLY;EkDqLZ,4BzCtaS;UyCsaT,2BzCtaS;AnBohWb;;A4D3mVE;EACE,UAAA;A5D8mVJ;;A4D3mVE;EAEE,kBAAA;A5D6mVJ;;A4DzmVE;;;;EAIE,aAAA;A5D4mVJ;;A4DzmVE;;EAEE,0BAAA;EAAA,mCAAA;EACA,yBAAA;A5D4mVJ;;A4DxmVE;;EAME,UAAA;A5DumVJ;;A4DpmVE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,yBlDvQY;EkDuQZ,mDlDvQY;EkDwQZ,gBzCrcS;EyCscT,WAAA;EACA,sBAAA;EAEA,4BAAA;EACA,qBAAA;EACA,UAAA;EACA,yDAAA;A5DsmVJ;;A4DnmVE;EACE,UAAA;EACA,sDAAA;A5DsmVJ;;A4DlmVE;EACE,wBAAA;EAAA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBlDrde;EkDqdf,sDlDrde;EkDudf,clDhSY;EkDgSZ,wClDhSY;EkDiSZ,qBAAA;EACA,oBAAA;A5DomVJ;;A4DjmVE;EACE,8EAAA;EAAA,gEAAA;A5DomVJ;;A4DjmVE;E9C6VE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Ad2wUJ;;A4DpmVE;EACE,6BzCrfS;UyCqfT,4BzCrfS;AnB4lWb;;A4DhmVE;EACE,gBAAA;EACA,oBAAA;A5DmmVJ;A4DjmVI;;EAEE,gBAAA;A5DmmVN;A4DhmVI;;EAEE,gBAAA;A5DkmVN;A4D/lVI;;EAEE,gBAAA;EACA,iBAAA;A5DimVN;A4D9lVI;;EAIE,ezCphBO;EyCqhBP,gBAAA;EACA,iBAAA;A5D8lVN;A4D3lVI;EACE,iBAAA;A5D6lVN;A4DzlVI;EACE,iBAAA;A5D2lVN;A4DxlVI;EAGE,eAAA;A5DwlVN;A4DplVI;EACE,UAAA;EACA,mDAAA;A5DslVN;A4DnlVI;EACE,mBAAA;A5DqlVN;A4DllVI;EhD1iBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ+nWJ;AY7nWI;EgDuiBA;IhDtiBE,qBAAA;EZgoWJ;AACF;A4D3lVI;EAIE,yBxDviBQ;EwDuiBR,wCxDviBQ;AJioWd;A4DvlVI;;EAIE,yBxD9iBQ;EwD8iBR,wCxD9iBQ;AJqoWd;A4DplVI;;;EhD7hBA,8BAAA;EACA,oBAAA;EgDoiBE,6BAAA;A5DmlVN;A4DhlVI;EACE,gBAAA;EACA,iBAAA;EAEA,qBAAA;A5DilVN;A4D9kVI;EACE,gBAAA;A5DglVN;A4D7kVI;EACE,gBAAA;EACA,iBAAA;A5D+kVN;;A4D3kVE;EACE,6BAAA;A5D8kVJ;;A4DvkVE;EAGE,gBAAA;A5DwkVJ;;A4DrkVE;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;A5DwkVJ;;A4DrkVE;EACE,gBAAA;EACA,oBAAA;EACA,uBAAA;A5DwkVJ;;A4DrkVE;EAEE,yBAAA;A5DukVJ;;A4DpkVE;EAGE,gBAAA;EACA,gBAAA;A5DqkVJ;;A4DlkVE;EACE,oBAAA;A5DqkVJ;;A6D3sWE;E/Cg1BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E+C70BA,aAAA;EACA,cnDuLa;EmDvLb,yCnDuLa;AVyhWjB;;A6D7sWE;EACE,kBAAA;EACA,0B1CNS;U0CMT,yB1CNS;AnBstWb;;A6D7sWE;E/Co0BE,eAAA;EAAA,qDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,0DAAA;EAAA,iBAAA;EAAA,4DAAA;Adg5UJ;;A6DhtWE;EACE,aC0MS;ED1MT,oCC0MS;A9DygWb;;A6DhtWE;EACE,aCuMY;EDvMZ,uCCuMY;A9D4gWhB;A6DjtWI;EACE,axBlCE;ArCqvWR;;A6D/sWE;EACE,aCoMY;EDpMZ,uCCoMY;A9D8gWhB;A6DhtWI;EACE,axB1CE;ArC4vWR;;A6D9sWE;EACE,aCmMY;EDnMZ,uCCmMY;A9D8gWhB;;A6D9sWE;EACE,aC6LW;ED7LX,sCC6LW;A9DohWf;;A6D9sWE;EACE,aC0LU;ED1LV,qCC0LU;A9DuhWd;;A6D9sWE;EACE,aCsLU;EDtLV,qCCsLU;A9D2hWd;;A6D9sWE;EACE,aCkLU;EDlLV,qCCkLU;A9D+hWd;;A6D9sWE;EACE,aCgLU;EDhLV,qCCgLU;A9DiiWd;;A6D9sWE;EACE,aC4KU;ED5KV,qCC4KU;A9DqiWd;;A6D9sWE;EACE,aCwKU;EDxKV,qCCwKU;A9DyiWd;;A6D9sWE;EACE,aCkKU;EDlKV,qCCkKU;A9D+iWd;;A+DtxWE;EjDg1BE,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA,2DAAA;EAAA,sBAAA;EAAA,gEAAA;EiD70BA,aAAA;EACA,crDuLa;EqDvLb,yCrDuLa;AVmmWjB;;A+DvxWE;EACE,kBAAA;EACA,0B5CNS;U4CMT,yB5CNS;AnBgyWb;;A+DvxWE;EjDo0BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Ad09UJ;;A+D1xWE;EACE,aD0MS;EC1MT,oCD0MS;A9DmlWb;;A+D1xWE;EACE,aDsMS;ECtMT,oCDsMS;A9DulWb;;A+D1xWE;EACE,aDkMS;EClMT,oCDkMS;A9D2lWb;;A+D1xWE;EACE,aD+LY;EC/LZ,uCD+LY;A9D8lWhB;A+D3xWI;EACE,aD6LkB;EC7LlB,+CD6LkB;A9DgmWxB;;A+DzxWE;EACE,aD4LY;EC5LZ,uCD4LY;A9DgmWhB;A+D1xWI;EACE,aD0LkB;EC1LlB,+CD0LkB;A9DkmWxB;;A+DxxWE;EACE,aDoLY;ECpLZ,uCDoLY;A9DumWhB;A+DzxWI;EACE,aDkLkB;EClLlB,+CDkLkB;A9DymWxB;;A+DvxWE;EACE,aDmLY;ECnLZ,uCDmLY;A9DumWhB;;A+DvxWE;EACE,aD6KW;EC7KX,sCD6KW;A9D6mWf;;A+DvxWE;EACE,aD0KU;EC1KV,qCD0KU;A9DgnWd;;A+DtxWI;EACE,aDqKQ;ECrKR,qCDqKQ;A9DonWd;;A+DrxWE;EACE,aDkKU;EClKV,qCDkKU;A9DsnWd;;AgE71WE;EvDTA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT02WF;ASx2WE;;;EAGE,mBAAA;AT02WJ;AgE52WE;ElD80BE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EkD10BA,eAAA;AhE+2WJ;A4B3xWM;EoCxFJ;IAOI,aAAA;IACA,eAAA;EhEg3WJ;AACF;;AgE72WE;ElDk0BE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;AdkjVJ;;AgEh3WE;EACE,aAAA;AhEm3WJ;;AgEh3WE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0B7CvBS;U6CuBT,yB7CvBS;AnB04Wb;;AgEh3WE;EACE,2B7ChCS;U6CgCT,0B7ChCS;AnBm5Wb;;AgEh3WE;EACE,uBAAA;EACA,wB7C3BS;AnB84Wb;;AgEh3WE;EACE,2BtD4KW;EsD5KX,uCtD4KW;AVusWf;AgEj3WI;EACE,2DtD4Ke;EsD5Kf,6CtD4Ke;AVusWrB;;AgE/2WE;;EAEE,ctDwIW;EsDxIX,uCtDwIW;AV0uWf;;AgE/2WE;EACE,ctDoIW;EsDpIX,uCtDoIW;EsDnIX,YAAA;EACA,4B7CnDS;U6CmDT,2B7CnDS;AnBq6Wb;;AgE/2WE;EACE,6B7C5DS;U6C4DT,4B7C5DS;AnB86Wb;;AgE/2WE;EAEE,WAAA;AhEi3WJ;;AgE92WE;;EAEE,qBAAA;UAAA,oBAAA;AhEi3WJ;;AgE92WE;EACE,mBAAA;AhEi3WJ;;AgE92WE;;EAGE,ctD0GW;EsD1GX,uCtD0GW;EsDzGX,YAAA;AhEg3WJ;AgE92WI;;EACE,qBAAA;AhEi3WN;;AgE52WE;EACE,kBAAA;EACA,oBAAA;EACA,iB7C7ES;AnB47Wb;AgE72WI;EACE,YAAA;EACA,gBAAA;EACA,uCAAA;EAAA,4CAAA;EACA,iBAAA;AhE+2WN;AgE52WI;EACE,uBAAA;AhE82WN;AgE52WM;EACE,gEtD+Ga;EsD/Gb,kDtD+Ga;AV+vWrB;AgEz2WM;EACE,mBtD2EO;EsD3EP,4CtD2EO;AVgyWf;AgEr2WM;EACE,UAAA;AhEu2WR;AgEl2WI;EACE,kBAAA;EACA,gCtD2jBE;EsD3jBF,qCtD2jBE;EsD1jBF,eAAA;EACA,WAAA;EACA,oBAAA;EACA,oBAAA;EACA,UAAA;EACA,wDAAA;AhEo2WN;AgEl2WM;EAVF;IAWI,gBAAA;EhEq2WN;AACF;;AgEj2WE;EAEE,uBAAA;EACA,gBAAA;AhEm2WJ;;AgEh2WE;EAGE,kBAAA;EACA,0BtDgEW;EsDhEX,sCtDgEW;EsD/DX,0BAAA;AhEi2WJ;;AgE91WE;EAGE,0DtD4DiB;EsD5DjB,4CtD4DiB;AVmyWrB;;AgE51WE;EAGE,atD2EW;EsD3EX,sCtD2EW;AVkxWf;;AgE11WE;EACE,aAAA;AhE61WJ;;AgEz1WE;EACE,cAAA;EACA,uBAAA;EACA,aAAA;EACA,6CAAA;UAAA,yCAAA;EAAA,sDAAA;UAAA,kDAAA;EACA,+CAAA;UAAA,8CAAA;EACA,iDAAA;UAAA,gDAAA;EACA,cAAA;EACA,6BAAA;EACA,4BAAA;AhE41WJ;;AgEz1WE;EAEE,0BAAA;EACA,2BAAA;AhE21WJ;;AgEx1WE;EAEE,wBAAA;EACA,iBAAA;AhE01WJ;;AgEv1WE;EAGE,gB7CtLS;E6CuLT,iB7CvLS;E6CwLT,oB7CxLS;AnBghXb;AgEv1WI;EACE,0BAAA;AhEy1WN;;AgEp1WE;E5C7MA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBqiXF;AoBniXE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBmiXJ;AoBhiXE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBkiXJ;AoBhiXI;EAVF;IAWI,eAAA;EpBmiXJ;AACF;AqBlkXE;E2CiNA;I5C7KE,sBAAA;EpBkiXF;EoBhiXE;IACE,kBAAA;IACA,yBAAA;EpBkiXJ;AACF;AgE13WE;EAGE,gBAAA;EACA,oBAAA;AhE03WJ;;AiEzjXE;ExDxBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATqlXF;ASnlXE;;;EAGE,mBAAA;ATqlXJ;AiExkXE;EnD+zBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EmD3zBA,eAAA;EACA,2BAvBc;EAuBd,mEAvBc;EAwBd,aAAA;EACA,qBAAA;EACA,sDAAA;AjE2kXJ;AiEzkXI;EACE,2DA5BkB;EA4BlB,+EA5BkB;EA6BlB,0BAAA;AjE2kXN;AiExkXI;ErDlCA,uCAAA;EAAA,4CAAA;AZ6mXJ;AY3mXI;EqDgCA;IrD/BE,qBAAA;EZ8mXJ;AACF;AiEhlXI;EAKE,2BAtCY;EAsCZ,mEAtCY;EAuCZ,mCA9BkB;EA8BlB,0EA9BkB;EA+BlB,0BAAA;AjE8kXN;AiE3kXI;ErD5CA,uCAAA;EAAA,4CAAA;AZ0nXJ;AYxnXI;EqD0CA;IrDzCE,qBAAA;EZ2nXJ;AACF;AiEnlXI;EAGE,mCArCkB;EAqClB,0EArCkB;EAsClB,0BAAA;AjEmlXN;AiEhlXI;EACE,2BAnDY;EAmDZ,mEAnDY;AjEqoXlB;AiE/kXI;EACE,2DAtDkB;EAsDlB,+EAtDkB;AjEuoXxB;;AiE7kXE;;ExDjEA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATmpXF;ASjpXE;;;;;;EAGE,mBAAA;ATspXJ;AiEhmXE;;EnDsxBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EmDjxBA,6BvDiJY;EuDjJZ,uDvDiJY;EuDhJZ,mBAAA;EACA,gBAAA;EACA,qBAAA;AjEmmXJ;;AiEhmXE;;EAEE,cAnEsB;EAmEtB,2EAnEsB;AjEsqX1B;;AiEhmXE;;EAEE,2DA5EoB;EA4EpB,+EA5EoB;AjE+qXxB;;AiEhmXE;EACE,eAAA;EACA,0BAAA;AjEmmXJ;;AiEhmXE;EACE,0BAAA;AjEmmXJ;;AiEhmXE;;EnDwvBE,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA,2DAAA;EAAA,sBAAA;EAAA,gEAAA;Ad+2VJ;;AiElmXE;;EnDmvBE,eAAA;EAAA,qDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,kBAAA;EAAA,0DAAA;EAAA,iBAAA;EAAA,4DAAA;Adu3VJ;;AiErmXE;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,4B9CpGS;U8CoGT,2B9CpGS;E8CqGT,2BAAA;AjEwmXJ;;AiEpmXE;EACE,mBAAA;EACA,oBAAA;AjEumXJ;;AiEnmXE;EACE,mBAAA;AjEsmXJ;;A+BttXE;EACE,eAAA;A/BytXJ;A+BttXE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/ButXJ;A+BptXE;EACE,0GAhBiB;A/BsuXrB;A+BntXE;ECiEA,gBAAA;AhCqpXF;AkE/jXE;EAlKA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EAEA,cxDyLa;EwDzLb,uCxDyLa;EwDxLb,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;AlEmuXF;A4B3pXM;EsCiFJ;IAtJE,iBAAA;IACA,sBAAA;ElEouXF;AACF;A4BjqXM;EsCiFJ;IAjJE,sBAAA;ElEquXF;AACF;A4BtqXM;EsCiFJ;IA7IE,sBAAA;ElEsuXF;AACF;;AkEtlXE;EAIE,cxD+CW;EwD/CX,uCxD+CW;AVuiXf;;AkEnlXE;EACE,qBAAA;AlEslXJ;;AkEnlXE;EACE,0BAAA;AlEslXJ;;AkEnlXE;EACE,0BAAA;EAAA,mDAAA;AlEslXJ;;AkEnlXE;EtDpME,uCAAA;EAAA,4CAAA;AZ2xXJ;AYzxXI;EsDkMF;ItDjMI,qBAAA;EZ4xXJ;AACF;;AkEvlXE;EAxFA,cxDyEa;EwDzEb,uCxDyEa;AV0mXf;AkEjrXE;EtDtGE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ0xXJ;AYxxXI;EsDmGF;ItDlGI,qBAAA;EZ2xXJ;AACF;AkEtrXE;EAEE,axDoHW;EwDpHX,sCxDoHW;AVmkXf;AkEprXE;EApFA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;AlE2wXF;;AkEhnXE;EC5LA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,yEAAA;UAAA,wEAAA;AnEgzXF;AmE9yXE;;;EAGE,azDuPoB;EyDvPpB,+CzDuPoB;AVyjXxB;;AkEtnXE;EChMA,mBCkR8B;EDlR9B,6DCkR8B;EDjR9B,uCAAA;UAAA,sCAAA;EAAA,iEAAA;UAAA,gEAAA;AnE0zXF;AmExzXE;;;EAGE,azD2OY;EyD3OZ,uCzD2OY;AV+kXhB;AkEnxXE;EACE,qBxDmMY;EwDnMZ,+CxDmMY;AVklXhB;;AkE/nXE;ECpMA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnEu0XF;AmEr0XE;;;EAGE,azD0PsB;EyD1PtB,iDzD0PsB;AV6kX1B;;AkEroXE;ECxMA,mBCuRgC;EDvRhC,+DCuRgC;EDtRhC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnEi1XF;AmE/0XE;;;EAGE,azD8Oc;EyD9Od,yCzD8Oc;AVmmXlB;AkE5xXE;EACE,qBxDwLc;EwDxLd,iDxDwLc;AVsmXlB;;AkE9oXE;;EC5MA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,wEAAA;UAAA,uEAAA;AnE+1XF;AmE71XE;;;;;;EAGE,azDgQmB;EyDhQnB,8CzDgQmB;AVkmXvB;;AkEvpXE;;ECjNA,mBC4R6B;ED5R7B,4DC4R6B;ED3R7B,uCAAA;UAAA,sCAAA;EAAA,gEAAA;UAAA,+DAAA;AnE62XF;AmE32XE;;;;;;EAGE,azDoPW;EyDpPX,sCzDoPW;AV4nXf;AkE7yXE;;EACE,qBxDgLW;EwDhLX,8CxDgLW;AVgoXf;;AkEpqXE;;ECtNA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnE+3XF;AmE73XE;;;;;;EAGE,azD6PsB;EyD7PtB,iDzD6PsB;AVqoX1B;;AkE7qXE;;EC3NA,mBCiSgC;EDjShC,+DCiSgC;EDhShC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnE64XF;AmE34XE;;;;;;EAGE,azDiPc;EyDjPd,yCzDiPc;AV+pXlB;AkE/zXE;;EACE,qBxD+Jc;EwD/Jd,iDxD+Jc;AVmqXlB;;AkE1rXE;;EAME,a7B5PQ;E6B6PR,UAAA;AlEyrXJ;;AkEtrXE;EACE,aAAA;EACA,YAAA;EACA,6BAAA;AlEyrXJ;A4B31XM;EsC+JJ;IAMI,mBAAA;ElE0rXJ;AACF;;AkEvrXE;EACE,cAAA;EACA,+BAAA;UAAA,4BAAA;EACA,wB/CzPS;U+CyPT,uB/CzPS;AnBm7Xb;;AkEvrXE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AlE0rXJ;;AkEvrXE;EpDikBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EoD9jBA,2B/CpRS;U+CoRT,0B/CpRS;AnBg9Xb;;AkEzrXE;EpD2jBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EoDxjBA,sBAAA;AlE8rXJ;;AkE3rXE;EACE,gBAAA;EACA,4B/C1RS;U+C0RT,wB/C1RS;E+C2RT,4B/ClQS;U+CkQT,2B/ClQS;AnBg8Xb;A4Bl4XM;EsCiMJ;IAMI,gBAAA;ElE+rXJ;AACF;;AkE5rXE;EAIE,cxDvEW;EwDuEX,uCxDvEW;AVmwXf;;AkEzrXE;;EAEE,yBxDrRuB;EwDqRvB,8DxDrRuB;AVi9X3B;;AkEzrXE;;EAIE,yBAAA;EAAA,+DAAA;AlE0rXJ;;AkEvrXE;EACE,yBAAA;EACA,gBAAA;EACA,0BAAA;EAAA,oDAAA;EACA,oBAAA;AlE0rXJ;;AkEvrXE;EAEE,mCxDqXI;EwDrXJ,wCxDqXI;AVo0WR;;AkEtrXE;EAEE,0B/CnUS;U+CmUT,yB/CnUS;AnB2/Xb;;AkErrXE;EtDnSE,8BAAA;EACA,oBAAA;EsDqSA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iHACE;AlEurXN;AkEprXI;EACE,0BAAA;EAAA,oDAAA;EACA,oBAAA;AlEsrXN;AkEnrXI;EACE,axDpHS;EwDoHT,sCxDpHS;AVyyXf;A4Bh8XM;EsC+OJ;IAgCI,gBAAA;ElEqrXJ;AACF;;AqBpiYE;E6CoXA;I7C7WI,8BAAA;ErBkiYJ;AACF;;AqB1iYE;E6CwXA;;I7CtXI,gBAAA;IACA,4BAAA;ErB8iYJ;AACF;;A+B1iYE;EACE,eAAA;A/B6iYJ;A+B1iYE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B2iYJ;A+BxiYE;EACE,0GAhBiB;A/B0jYrB;A+BviYE;ECiEA,gBAAA;AhCy+XF;AqE97XE;EArHA,aAAA;EACA,gBAAA;EACA,0CAAA;EACA,c3DyLa;E2DzLb,uC3DyLa;E2DxLb,kBAAA;EACA,gCAAA;UAAA,+BAAA;ArEsjYF;A4B5+XM;EyCsCJ;IA7GE,kBAAA;ErEujYF;AACF;;AqEv8XE;EAIE,c3D0FW;E2D1FX,uC3D0FW;AV62Xf;;AqEp8XE;EACE,qBAAA;ArEu8XJ;;AqEp8XE;EACE,0BAAA;ArEu8XJ;;AqEp8XE;EACE,0BAAA;EAAA,mDAAA;ArEu8XJ;;AqEp8XE;EzDzJE,uCAAA;EAAA,4CAAA;AZimYJ;AY/lYI;EyDuJF;IzDtJI,qBAAA;EZkmYJ;AACF;;AqEx8XE;EAjIA,c3D6Ja;E2D7Jb,uC3D6Ja;AVg7Xf;AqE3kYE;;EAEE,c3DyJW;E2DzJX,uC3DyJW;AVo7Xf;AqE1kYE;EAEE,a3DuMW;E2DvMX,sC3DuMW;AVo4Xf;AqExkYE;EzD5BE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZumYJ;AYrmYI;EyDyBF;IzDxBI,qBAAA;EZwmYJ;AACF;;AqEx9XE;EFjJA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,yEAAA;UAAA,wEAAA;AnE6mYF;AmE3mYE;;;EAGE,azDuPoB;EyDvPpB,+CzDuPoB;AVs3XxB;;AqE99XE;EFrJA,mBCkR8B;EDlR9B,6DCkR8B;EDjR9B,uCAAA;UAAA,sCAAA;EAAA,iEAAA;UAAA,gEAAA;AnEunYF;AmErnYE;;;EAGE,azD2OY;EyD3OZ,uCzD2OY;AV44XhB;;AqEp+XE;EFzJA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnEioYF;AmE/nYE;;;EAGE,azD0PsB;EyD1PtB,iDzD0PsB;AVu4X1B;;AqE1+XE;EF7JA,mBCuRgC;EDvRhC,+DCuRgC;EDtRhC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnE2oYF;AmEzoYE;;;EAGE,azD8Oc;EyD9Od,yCzD8Oc;AV65XlB;;AqEh/XE;;EFjKA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,wEAAA;UAAA,uEAAA;AnEspYF;AmEppYE;;;;;;EAGE,azDgQmB;EyDhQnB,8CzDgQmB;AVy5XvB;;AqEz/XE;;EFtKA,mBC4R6B;ED5R7B,4DC4R6B;ED3R7B,uCAAA;UAAA,sCAAA;EAAA,gEAAA;UAAA,+DAAA;AnEoqYF;AmElqYE;;;;;;EAGE,azDoPW;EyDpPX,sCzDoPW;AVm7Xf;;AqElgYE;;EF3KA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnEkrYF;AmEhrYE;;;;;;EAGE,azD6PsB;EyD7PtB,iDzD6PsB;AVw7X1B;;AqE3gYE;;EFhLA,mBCiSgC;EDjShC,+DCiSgC;EDhShC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnEgsYF;AmE9rYE;;;;;;EAGE,azDiPc;EyDjPd,yCzDiPc;AVk9XlB;;AqEphYE;;EAME,ahCjNQ;EgCkNR,UAAA;ArEmhYJ;;AqEhhYE;EACE,cAAA;EACA,2BlDnMS;UkDmMT,wBlDnMS;EkDoMT,wBlDpMS;UkDoMT,uBlDpMS;AnButYb;;AqEhhYE;EACE,0BlDxMS;UkDwMT,sBlDxMS;EkDyMT,wBlDzMS;UkDyMT,uBlDzMS;AnB4tYb;;AqEhhYE;EzDnLE,8BAAA;EACA,oBAAA;EyDqLA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;UAAA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iDACE;ArEkhYN;AqE/gYI;EACE,0BAAA;EAAA,oDAAA;EACA,oBAAA;ArEihYN;AqE9gYI;EACE,a3DFS;E2DET,sC3DFS;AVkhYf;;AqE5gYE;EvDylBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EuDtlBA,gBAAA;EACA,2BlD9OS;UkD8OT,wBlD9OS;EkD+OT,sBAAA;ArEihYJ;;AqE9gYE;EvDilBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EuD9kBA,c3D3DW;E2D2DX,uC3D3DW;E2D4DX,oBAAA;EACA,sBAAA;ArEmhYJ;;AqEhhYE;EvDykBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EuDtkBA,c3DnEW;E2DmEX,uC3DnEW;E2DoEX,8BlDxQS;UkDwQT,2BlDxQS;AnB6xYb;;AqBryYE;EgDqRA;IhD9QI,8BAAA;ErBmyYJ;AACF;;AqB3yYE;EgDwRA;IhDtRI,gBAAA;IACA,4BAAA;ErB8yYJ;AACF;;A+B1yYE;EACE,eAAA;A/B6yYJ;A+B1yYE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B2yYJ;A+BxyYE;EACE,0GAhBiB;A/B0zYrB;A+BvyYE;ECiEA,gBAAA;AhCyuYF;AsE3oYE;EAvKA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,c5DuLa;E4DvLb,uC5DuLa;E4DtLb,iBAAA;EACA,sBAAA;EACA,oBAAA;EACA,sBAAA;AtEqzYF;A4B/uYM;E0CyFJ;IA5JE,iBAAA;IACA,sBAAA;EtEszYF;AACF;A4BrvYM;E0CyFJ;IAvJE,sBAAA;EtEuzYF;AACF;A4B1vYM;E0CyFJ;IAnJE,sBAAA;EtEwzYF;AACF;;AsElqYE;EAhJA,eAAA;EACA,0CAAA;EACA,sBAAA;EACA,sBAAA;AtEszYF;;AsErqYE;EAIE,c5DmCW;E4DnCX,uC5DmCW;AVkoYf;;AsElqYE;EACE,qBAAA;AtEqqYJ;;AsElqYE;EACE,0BAAA;AtEqqYJ;;AsElqYE;EACE,0BAAA;EAAA,oDAAA;AtEqqYJ;;AsElqYE;E1DhNE,uCAAA;EAAA,4CAAA;AZs3YJ;AYp3YI;E0D8MF;I1D7MI,qBAAA;EZu3YJ;AACF;;AsEtqYE;EAlKA,c5DuIa;E4DvIb,uC5DuIa;AVqsYf;AsE10YE;;EAEE,c5DmIW;E4DnIX,uC5DmIW;AVysYf;AsEz0YE;EAEE,a5DiLW;E4DjLX,sC5DiLW;AVypYf;;AsE7qYE;EArDA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;AtEsuYF;;AsErrYE;EH9MA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,yEAAA;UAAA,wEAAA;AnEu4YF;AmEr4YE;;;EAGE,azDuPoB;EyDvPpB,+CzDuPoB;AVgpYxB;;AsE3rYE;EHlNA,mBCkR8B;EDlR9B,6DCkR8B;EDjR9B,uCAAA;UAAA,sCAAA;EAAA,iEAAA;UAAA,gEAAA;AnEi5YF;AmE/4YE;;;EAGE,azD2OY;EyD3OZ,uCzD2OY;AVsqYhB;AsEvzYE;EACE,qB5DgJY;E4DhJZ,+C5DgJY;AVyqYhB;;AsEpsYE;EHtNA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnE85YF;AmE55YE;;;EAGE,azD0PsB;EyD1PtB,iDzD0PsB;AVoqY1B;;AsE1sYE;EH1NA,mBCuRgC;EDvRhC,+DCuRgC;EDtRhC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnEw6YF;AmEt6YE;;;EAGE,azD8Oc;EyD9Od,yCzD8Oc;AV0rYlB;AsEh0YE;EACE,qB5DqIc;E4DrId,iD5DqIc;AV6rYlB;;AsEntYE;;EH9NA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,wEAAA;UAAA,uEAAA;AnEs7YF;AmEp7YE;;;;;;EAGE,azDgQmB;EyDhQnB,8CzDgQmB;AVyrYvB;;AsE5tYE;;EHnOA,mBC4R6B;ED5R7B,4DC4R6B;ED3R7B,uCAAA;UAAA,sCAAA;EAAA,gEAAA;UAAA,+DAAA;AnEo8YF;AmEl8YE;;;;;;EAGE,azDoPW;EyDpPX,sCzDoPW;AVmtYf;AsEj1YE;;EACE,qB5D6HW;E4D7HX,8C5D6HW;AVutYf;;AsEzuYE;;EHxOA,mBzDOmB;EyDPnB,kDzDOmB;EyDNnB,uCAAA;UAAA,sCAAA;EAAA,2EAAA;UAAA,0EAAA;AnEs9YF;AmEp9YE;;;;;;EAGE,azD6PsB;EyD7PtB,iDzD6PsB;AV4tY1B;;AsElvYE;;EH7OA,mBCiSgC;EDjShC,+DCiSgC;EDhShC,uCAAA;UAAA,sCAAA;EAAA,mEAAA;UAAA,kEAAA;AnEo+YF;AmEl+YE;;;;;;EAGE,azDiPc;EyDjPd,yCzDiPc;AVsvYlB;AsEn2YE;;EACE,qB5D4Gc;E4D5Gd,iD5D4Gc;AV0vYlB;;AsE/vYE;;EAME,ajC9QQ;EiC+QR,UAAA;AtE8vYJ;;AsE3vYE;;EAME,ajCxRQ;EiCyRR,UAAA;AtE0vYJ;;AsEvvYE;EACE,aAAA;EACA,YAAA;EACA,6BAAA;AtE0vYJ;;A4Bx7YM;E0CiMJ;IAKI,mBAAA;EtEuvYJ;AACF;;AsEpvYE;EACE,cAAA;EACA,+BAAA;UAAA,4BAAA;EACA,wBnD1RS;UmD0RT,uBnD1RS;AnBihZb;;AsEpvYE;EACE,cAAA;EACA,2BnD/RS;UmD+RT,wBnD/RS;EmDgST,wBnDhSS;UmDgST,uBnDhSS;AnBuhZb;;AsEpvYE;EACE,aAAA;EACA,eAAA;EACA,oBAAA;AtEuvYJ;;AsEpvYE;EACE,iBAAA;AtEuvYJ;;AsEpvYE;EACE,aAAA;AtEuvYJ;;AsEpvYE;EAEE,gCAAA;AtEsvYJ;;AsEnvYE;ExD6gBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwD1gBA,aAAA;EACA,eAAA;EACA,sBAAA;AtEwvYJ;;AsErvYE;EAEE,cAAA;AtEuvYJ;;AsEpvYE;ExDggBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EwD7fA,gBAAA;EACA,2BnDtVS;UmDsVT,0BnDtVS;EmDuVT,sBAAA;AtEyvYJ;;AsEtvYE;EAEE,qBAAA;UAAA,oBAAA;AtEwvYJ;;AsErvYE;ExDmfE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwDhfA,c5DzJW;E4DyJX,uC5DzJW;E4D0JX,wBAAA;UAAA,qBAAA;EACA,sBAAA;AtE0vYJ;;AsEvvYE;ExD2eE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwDxeA,c5DjKW;E4DiKX,uC5DjKW;E4DkKX,8BnDvVS;UmDuVT,2BnDvVS;AnBmlZb;;AsEzvYE,oCAAA;AACA;EACE,gBAAA;EACA,4BnD5WS;UmD4WT,wBnD5WS;EmD6WT,4BnDpVS;UmDoVT,2BnDpVS;AnBglZb;A4BlhZM;E0CmRJ;IAMI,gBAAA;EtE6vYJ;AACF;;AsE1vYE;EAIE,c5DzJW;E4DyJX,uC5DzJW;AVm5Yf;;AsEvvYE;;EAEE,yB5DvWuB;E4DuWvB,8D5DvWuB;AVimZ3B;;AsEvvYE;;EAIE,yBFlFwB;EEkFxB,+DFlFwB;ApE00Y5B;;AsErvYE;EACE,yBAAA;EACA,gBAAA;EACA,0BAAA;EAAA,oDAAA;EACA,oBAAA;AtEwvYJ;;AsErvYE;EAEE,mC5DmSI;E4DnSJ,wC5DmSI;AVo9XR;;AsEpvYE;EAEE,0BnDrZS;UmDqZT,yBnDrZS;AnB2oZb;;AsEnvYE,mDAAA;AACA;EACE,0BnDhZS;UmDgZT,sBnDhZS;EmDoZT,qDAAA;UAAA,oDAAA;EAGA,oBnDvZS;AnBwoZb;;AsEvuYE;EtDzUA,iBCzCqB;ED0CrB,mBAAA;EACA,qBoDmNqC;EpDnNrC,sEoDmNqC;EpDlNrC,6BsD2UI;EtD1UJ,coDiNqC;EpDjNrC,+DoDiNqC;ApEm2YvC;AgBljZE;EACE,yBoDwNyC;EpDxNzC,gFoDwNyC;ApE41Y7C;AgBjjZE;EACE,kCA7GiB;EA6GjB,sEA7GiB;EA8GjB,yEACE;EADF,oIACE;AhBkjZN;AgB9iZE;EACE,yBoDwM0C;EpDxM1C,iFoDwM0C;ApEw2Y9C;AgB7iZE;;EAEE,kBsD2TE;AtEovYN;;AsE/uYE;EAIE,cFvHwC;EEuHxC,oEFvHwC;ApEs2Y5C;;AsE5uYE;EAIE,qB5DqPY;E4DrPZ,+C5DqPY;E4DpPZ,yBF9ImC;EE8InC,0EF9ImC;EE+InC,4DACE;EADF,qHACE;EAEF,cFnIwC;EEmIxC,oEFnIwC;ApE62Y5C;;AsEvuYE;EAIE,yBAAA;EACA,yBFrJ0C;EEqJ1C,iFFrJ0C;EEsJ1C,cF5IwC;EE4IxC,oEF5IwC;ApEm3Y5C;;AsEpuYE;;;;;;EAwBE,uBAAA;EACA,gCFnK0D;EEmK1D,wGFnK0D;EEoK1D,aAAA;AtEqtYJ;;AsEltYE;EAEE,0BnDpfS;UmDofT,yBnDpfS;AnBwsZb;;AsEjtYE;E1DpdE,8BAAA;EACA,oBAAA;E0DsdA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,iHACE;AtEmtYN;AsEhtYI;EACE,0BAAA;EAAA,oDAAA;EACA,oBAAA;AtEktYN;AsE/sYI;EACE,a5DrSS;E4DqST,sC5DrSS;AVs/Yf;A4B7oZM;E0CgaJ;IAgCI,gBAAA;EtEitYJ;AACF;;A4BlpZM;E0CocJ;IAGI,kBAAA;EtEgtYJ;AACF;;AsE7sYE;E1D1hBE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ2uZJ;AYzuZI;E0DuhBF;I1DthBI,qBAAA;EZ4uZJ;AACF;;AqBjwZE;EiDijBA;IjD1iBI,8BAAA;ErB+vZJ;AACF;;AqBvwZE;EiDqjBA;;IjDnjBI,gBAAA;IACA,4BAAA;ErB2wZJ;AACF;;A+BvwZE;EACE,eAAA;A/B0wZJ;A+BvwZE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BwwZJ;A+BrwZE;EACE,0GAhBiB;A/BuxZrB;A+BpwZE;ECiEA,gBAAA;AhCssZF;;AuEvwZE;EzD4zBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EZ5yBF,uOAAA;EqEZE,kBAAA;EACA,cAAA;EACA,uDAAA;EACA,yBnEpBI;EmEoBJ,kCnEpBI;EmEqBJ,oBAAA;EACA,qBAAA;EACA,8BAAA;EACA,oBAAA;AvE4wZJ;AuE1wZI;E3DtBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZmyZJ;AYjyZI;E2DmBA;I3DlBE,qBAAA;EZoyZJ;AACF;;AuE7wZE;EACE,yB7DMO;E6DNP,8C7DMO;AV0wZX;;AuE7wZE;;E9DlDA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATo0ZF;ASl0ZE;;;;;;EAGE,mBAAA;ATu0ZJ;AuEhyZE;;EzDqyBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EyDhyBA,uDAAA;EACA,eAAA;EACA,iDAAA;AvEmyZJ;AuEjyZI;;EACE,mBnE3CQ;EmE2CR,kCnE3CQ;AJ+0Zd;;AuEhyZE;EACE,c7D8HW;E6D9HX,uC7D8HW;E6D7HX,qBAAA;AvEmyZJ;AuExxZI;E3D3DA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZs1ZJ;AYp1ZI;E2DwDA;I3DvDE,qBAAA;EZu1ZJ;AACF;AuEjyZI;EAGE,qBAAA;AvEiyZN;AuE5xZM;EACE,UAAA;AvE8xZR;;AuExxZE;EACE,SAAA;AvE2xZJ;;AuExxZE;;;;EAIE,c7D2FW;E6D3FX,uC7D2FW;E6D1FX,qBAAA;AvE2xZJ;;AuEvxZE;;EAEE,cAAA;EACA,uDAAA;EACA,yBnE/FI;EmE+FJ,kCnE/FI;EmEgGJ,6B7DyGY;E6DzGZ,uD7DyGY;E6DxGZ,mBAAA;AvE0xZJ;;AuE9wZE;;EAGE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,yBAAA;AvEgxZJ;;AuE7wZE;EACE,a7D8He;E6D9Hf,0C7D8He;AVkpZnB;;AuE7wZE;EAEE,4B7DsHY;E6DtHZ,sD7DsHY;AVypZhB;;AuE5wZE;EAEE,aAAA;AvE8wZJ;;AuE3wZE;EACE,6BAAA;EACA,oFAxImB;UAwInB,mFAxImB;AvEs5ZvB;;AuElwZE;EACE,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,iEAAA;EACA,gEAAA;EACA,iDAAA;EASE,UAAA;AvE6vZN;AuE1vZI;EACE,kBAAA;EACA,a7D+DW;E6D/DX,wC7D+DW;AV6rZjB;AuEzvZI;E3DvKA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZm6ZJ;AYj6ZI;E2DoKA;I3DnKE,qBAAA;EZo6ZJ;AACF;;AuE7vZE;EACE,UAAA;AvEgwZJ;;AuE7vZE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2EA1LmB;EA2LnB,4EA3LmB;EA4LnB,kBAAA;EACA,mBAAA;AvEgwZJ;AuE9vZI;EACE,a7DqCS;E6DrCT,sC7DqCS;E6DpCT,wBAAA;EACA,iDAAA;AvEgwZN;AuE9vZM;EALF;IAMI,gBAAA;EvEiwZN;AACF;;AuE7vZE;E5DpNA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATg+ZF;AS99ZE;;;EAGE,mBAAA;ATg+ZJ;AW19ZE;EACE,SAAA;AX49ZJ;AuEvxZE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2EAjNmB;EAkNnB,4EAlNmB;EAmNnB,kBAAA;EACA,mBAAA;AvEuxZJ;AuE7wZI;EACE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AvE+wZN;AuE5wZI;EACE,yBnEhOQ;EmEgOR,wCnEhOQ;EmEiOR,eAAA;AvE8wZN;;AuE1wZE;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,4DAAA;EzDulBA,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Ad0rYJ;AuEpwZI;EACE,mBnE7PQ;EmE6PR,kCnE7PQ;AJmgad;;AuElwZE;EACE,YAAA;EACA,eAAA;EACA,4DAAA;AvEqwZJ;AuEnwZI;EACE,yBnE1QE;EmE0QF,kCnE1QE;AJ+gaR;AuElwZI;EACE,aAAA;AvEowZN;;AuEhwZE;E3D9QE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZkhaJ;AYhhaI;E2D2QF;I3D1QI,qBAAA;EZmhaJ;AACF;;AuEtwZE;EACE,cAAA;EACA,UAAA;EACA,2GACE;EAEF,kBAAA;AvEuwZJ;;AuEpwZE;EACE,iBAAA;EACA,4DAAA;AvEuwZJ;AuErwZI;EACE,yBAAA;AvEuwZN;AuEpwZI;EACE,UAAA;EACA,2GACE;EAEF,mBAAA;AvEowZN;AuE/vZM;EAVF;IAYI,gBAAA;EvEiwZN;AACF;;AuE7vZE;EACE,yBAAA;EAAA,4DAAA;AvEgwZJ;;AuE7vZE;EACE,UAAA;AvEgwZJ;;AuE7vZE;EACE,a7D7FW;E6D6FX,sC7D7FW;AV61Zf;;AuE7vZE;EACE,gBAAA;EACA,iBAAA;AvEgwZJ;;AuE7vZE;EjErVA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;ANslaF;;AuEtwZE;E3DzUE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZmlaJ;AYjlaI;E2DsUF;I3DrUI,qBAAA;EZolaJ;AACF;;AuE5wZE;EACE,yBnElVI;EmEkVJ,kCnElVI;EmEmVJ,6B7D1IY;E6D0IZ,uD7D1IY;E6D2IZ,mBAAA;AvE+wZJ;;AuElwZE;EACE,yB7D3TO;E6D2TP,8C7D3TO;AVgkaX;;AuElwZE;EACE,qB7DxLc;E6DwLd,iD7DxLc;AV67ZlB;;AuElwZE;EACE,4B7DvHY;E6DuHZ,sD7DvHY;AV43ZhB;;AuEjwZE;;;;;;;EAOE,kBAAA;EACA,uBpDhXS;EoDiXT,sBpDjXS;AnBqnab;;AuEjwZE;;;EAKE,wBpD1WS;AnB4mab;;AuE/vZE;;;EAOE,sBpDnYS;EoDoYT,kEAAA;EAOE,wBpD5XO;AnBonab;;AuEpvZE;;;EAOE,wBpDvYS;AnB0nab;;AuEhvZE;;;EAKE,oBAAA;AvEivZJ;;AuE9uZE;;;E1CvTE,gTACE;EADF,4pBACE;E0C6TF,6BAAA;EACA,gGACE;EADF,uJACE;AvE6uZN;;AuEzuZE;;E1CpUE,gTACE;EADF,4pBACE;A7BijaN;;AuEvuZE;;;;;;EAME,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,UAAA;EACA,yDAAA;AvE0uZJ;;AuEvuZE;;;;;E1CnYE,qSACE;EADF,6iBACE;E0C+YF,mGACE;EADF,0JACE;AvEkuZN;;AuE9tZE;;;;EAIE,UAAA;AvEiuZJ;;AuE9tZE;;;;;;EAME,oBAAA;AvEiuZJ;;AuE9tZE;;E1C7YE,kRACE;EADF,8ZACE;E0CkZF,gGACE;EADF,uJACE;AvE6tZN;;AuEztZE;;EAEE,UAAA;AvE4tZJ;;AuEztZE;;EAEE,UAAA;AvE4tZJ;;AuEztZE;;EAIE,qB7D/Va;E6D+Vb,gD7D/Va;AVyjajB;;AuEvtZE;;;;EAQE,kBAAA;EACA,eAAA;AvEstZJ;;AuEntZE;;;;;;;;;EAgBE,UAAA;AvE+sZJ;;AuE5sZE;;;EAOE,UAAA;AvE2sZJ;;AuExsZE;;;;;EASE,UAAA;AvEusZJ;;AuEpsZE;;;EASE,iBAAA;AvEisZJ;;AuE9rZE;EACE,e7DxWW;E6DwWX,wC7DxWW;AVyiaf;;AuE9rZE;EACE,a7D5WW;E6D4WX,sC7D5WW;AV6iaf;;AuE7rZE;;;;;;;;EAQE,qBpDhmBS;AnBgyab;;AuE7rZE;;EAEE,6BpDrmBS;AnBqyab;;AwEnyaE;E/DZA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATmzaF;ASjzaE;;;EAGE,mBAAA;ATmzaJ;AwElzaE;ECXA,yBAAA;EACA,6BAAA;EACA,mCAAA;EACA,2BAAA;EACA,iCAAA;AzEg0aF;AyE7zaE;EACE,wBAAA;EACA,gCAAA;EACA,uDCGc;A1E4zalB;AyE7zaI;EALF;IAMI,eAAA;EzEg0aJ;AACF;AwEn0aE;EAIE,kBGPW;EHSX,mBGTW;A3E00af;;AwE7zaE;EACE,iBAAA;AxEg0aJ;;AwE7zaE;EACE,mCAAA;EACA,oBAAA;EACA,gBAAA;AxEg0aJ;;AwE7zaE;EACE,4B9D2GU;E8D3GV,uC9D2GU;E8D1GV,4BAAA;AxEg0aJ;;AwE7zaE;EACE,6BAAA;AxEg0aJ;;AwE7zaE;ECpBA,6IACE;AzEo1aJ;AyEh1aE;EACE,sBAAA;EACA,yBAAA;EACA,6BAAA;EACA,+BAAA;EACA,sDCvBO;A1Ey2aX;AyEh1aI;EAPF;IAQI,eAAA;EzEm1aJ;AACF;;AwEz0aE;EACE,gBAAA;EACA,iBAAA;EAGA,iBAAA;AxE00aJ;AwEx0aI;EACE,gBAAA;AxE00aN;;AwEt0aE;EACE,4B9DkFU;E8DlFV,uC9DkFU;AVuvad;;AwEt0aE;EACE,epE1CW;EoE0CX,+BpE1CW;EoE2CX,sBAAA;AxEy0aJ;;AwEr0aE;EAEE;IACE,qBAAA;IACA,oBAAA;ExEu0aJ;AACF;AwEp0aE;EACE,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oC9DgmBM;E8DhmBN,wD9DgmBM;E8D/lBN,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,kEAAA;AxEs0aJ;;AwEn0aE;EACE,aAAA;AxEs0aJ;;AwEn0aE;EACE;IACE,uBAAA;ExEs0aJ;EwEn0aE;IACE,yBAAA;ExEq0aJ;AACF;AwEl0aE;EACE;IACE,yBAAA;ExEo0aJ;AACF;AwEj0aE;EACE;IACE,0BAAA;ExEm0aJ;AACF;AwEh0aE,sBAAA;AACA;EACE;IACE,2BAAA;ExEk0aJ;EwE/zaE;IACE,4BAAA;ExEi0aJ;AACF;AwE9zaE;EACE;IACE,4BAAA;ExEg0aJ;EwE7zaE;IACE,2BAAA;ExE+zaJ;AACF;A+B17aE;EACE,eAAA;A/B47aJ;A+Bz7aE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B07aJ;A+Bv7aE;EACE,0GAhBiB;A/By8arB;A+Bt7aE;ECiEA,gBAAA;AhCw3aF;A4E38aE;EAGE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,yBxEJI;EwEIJ,kCxEJI;EwEKJ,eAAA;A5E28aJ;A4Ez8aI;EACE,yBxELQ;EwEKR,wCxELQ;AJg9ad;A4Ex8aI;EACE,yBxEXS;EwEWT,yCxEXS;AJq9af;A4Ev8aI;EtClBF,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EsCgBI,aAAA;A5E68aN;A4E18aI;EnDhCF,wCAAA;EAAA,2DAAA;EawBA,aAAA;EAIE,uBAAA;EAGF,uBAAA;EACA,yB5BNmB;E4BMnB,wD5BNmB;E4BOnB,gBAAA;EACA,c5ByKa;E4BzKb,uC5ByKa;E4BxKb,gBAAA;EACA,gCAAA;EAAA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;ExB4yBE,mBAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;AdyqZJ;AsCj9aE;EsCZE;ItCaA,iBAAA;EtCo9aF;AACF;AsCl9aE;EsChBE;ItCiBA,iBAAA;EtCq9aF;AACF;AsCp9aE;EsCnBE;ItCoBA,iBAAA;EtCu9aF;AACF;AsCp9aE;EsCxBE;ItCyBA,6BAAA;EtCu9aF;AACF;A4Ej/aI;EAGE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;A5Ei/aN;A4E9+aI;EhE3BA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ4gbJ;AY1gbI;EgEwBA;IhEvBE,qBAAA;EZ6gbJ;AACF;A4Ev/aI;EAGE,mClE6oBE;EkE7oBF,wClE6oBE;AV02ZR;A4Ep/aI;EAEE,cAAA;A5Eq/aN;A4El/aI;EACE,YAAA;A5Eo/aN;A4Ej/aI;EAIE,mEAAA;A5Eg/aN;A4E7+aI;EAGE,mEAAA;A5E6+aN;;A4Ez+aE;EACE,alEuKW;EkEvKX,sClEuKW;AVq0af;;A4Ex+aE;EACE,YAAA;A5E2+aJ;;A+BjjbE;EACE,eAAA;A/BojbJ;A+BjjbE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BkjbJ;A+B/ibE;EACE,0GAhBiB;A/BikbrB;A+B9ibE;ECiEA,gBAAA;AhCg/aF;;A6EhjbE;;EAGE,yBzEjBI;EyEiBJ,kCzEjBI;EyEkBJ,6BnEuLY;EmEvLZ,uDnEuLY;AV23ahB;;A6E/ibE;;;EAGE,yBzExBI;EyEwBJ,kCzExBI;EyEyBJ,6BnEgLY;EmEhLZ,uDnEgLY;EmE/KZ,mBAAA;A7EkjbJ;;A6E/ibE;;EAIE,4BnEkNY;EmElNZ,sDnEkNY;AV81ahB;;A6E7ibE;E/DqyBE,0GAAA;EAAA,0IAAA;EAAA,kBAAA;EAAA,gDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;AdgxZJ;;A+B7lbE;EACE,eAAA;A/BgmbJ;A+B7lbE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B8lbJ;A+B3lbE;EACE,0GAhBiB;A/B6mbrB;A+B1lbE;ECiEA,gBAAA;AhC4hbF;A6EjkbE;EAGE,kBAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBzEjDI;EyEiDJ,kCzEjDI;EyEkDJ,cnE+HW;EmE/HX,uCnE+HW;EmE9HX,eAAA;A7EikbJ;A6E/jbI;EACE,yBzEnDQ;EyEmDR,wCzEnDQ;AJonbd;A6E9jbI;EACE,yBzEzDS;EyEyDT,yCzEzDS;AJynbf;A6E7jbI;EACE,sCAAA;EAAA,2CAAA;EACA,aAAA;A7E+jbN;A6E5jbI;EvCrEF,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EuCmEI,aAAA;EAEA,YAAA;A7EikbN;A6E9jbI;EpDrFF,wCAAA;EAAA,2DAAA;EawBA,aAAA;EAIE,uBAAA;EAGF,uBAAA;EACA,yB5BNmB;E4BMnB,wD5BNmB;E4BOnB,gBAAA;EACA,c5ByKa;E4BzKb,uC5ByKa;E4BxKb,gBAAA;EACA,gCAAA;EAAA,wBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;EACA,2BAAA;ExB4yBE,mBAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;Adk1ZJ;AsC1nbE;EuCyCE;IvCxCA,iBAAA;EtC6nbF;AACF;AsC3nbE;EuCqCE;IvCpCA,iBAAA;EtC8nbF;AACF;AsC7nbE;EuCkCE;IvCjCA,iBAAA;EtCgobF;AACF;AsC7nbE;EuC6BE;IvC5BA,6BAAA;EtCgobF;AACF;A6ErmbI;EAGE,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;A7EqmbN;;A6EjmbE;;EAGE,cAAA;A7EmmbJ;;A6EhmbE;;EAGE,mEAAA;A7EkmbJ;;A6E/lbE;;EAGE,mEAAA;A7EimbJ;;A6E9lbE;EACE,iBAAA;A7EimbJ;;A6E9lbE;EACE,qBAAA;A7EimbJ;A6E/lbI;EACE,yBzE/GE;EyE+GF,kCzE/GE;EyEgHF,YAAA;A7EimbN;;A6E7lbE;EACE,yBzElHU;EyEkHV,wCzElHU;EyEmHV,YAAA;A7EgmbJ;;A6E5lbE;E/D+sBE,0GAAA;EAAA,0IAAA;EAAA,kBAAA;EAAA,gDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EgEj1BF,kBAAA;EACA,yB1EOM;E0EPN,kC1EOM;E0ENN,iBAAA;EACA,sBAAA;EDkIE,aAAA;EACA,mBAAA;EACA,kB1D1GS;E0D2GT,2B1D3GS;U0D2GT,0B1D3GS;AnBitbb;;A6EnmbE;EACE,UAAA;A7EsmbJ;A6EpmbI;EACE,sB1DjIO;AnBuubb;;A6ElmbE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2B1D3IS;U0D2IT,0B1D3IS;AnBgvbb;A6EnmbI;EjE/IA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZqvbJ;AYnvbI;EiE4IA;IjE3IE,qBAAA;EZsvbJ;AACF;;A6EvmbE;E/DirBE,0GAAA;EAAA,0IAAA;EAAA,kBAAA;EAAA,gDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;E+D9qBA,yB1D3IS;U0D2IT,wB1D3IS;AnBwvbb;;A6EzmbE;;EAEE,gBAAA;A7E4mbJ;;A6ExmbE;E/DoqBE,0GAAA;EAAA,0IAAA;EAAA,kBAAA;EAAA,gDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EgEj1BF,kBAAA;EACA,yB1EOM;E0EPN,kC1EOM;E0ENN,iBAAA;EACA,sBAAA;ED6KE,aAAA;EACA,a1DnKS;AnBqxbb;;A6E9mbE;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,oBAAA;EACA,gBAAA;EACA,4DAAA;A7EinbJ;A6E/mbI;EjEjLA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZmybJ;AYjybI;EiE8KA;IjE7KE,qBAAA;EZoybJ;AACF;A6ExnbI;EAGE,iBAAA;A7EwnbN;;A6EnnbE;EAEE,2B1DzLS;U0DyLT,uB1DzLS;E0D0LT,4DAAA;A7EqnbJ;;A6ElnbE;EACE,qBAAA;EACA,qBAAA;A7EqnbJ;;A6ElnbE;EACE,cAAA;EACA,6B1D/LS;U0D+LT,yB1D/LS;E0DgMT,2B1DhMS;U0DgMT,0B1DhMS;AnBqzbb;;A6ElnbE;EAGE,sBAAA;UAAA,qBAAA;A7EmnbJ;;A6EhnbE;EAEE,gEAAA;EAAA,yEAAA;A7EknbJ;;A6E/mbE;EACE,gBAAA;A7EknbJ;;A6E9mbE;EACE,gBAAA;EACA,anEIW;EmEJX,sCnEIW;EmEHX,iBAAA;EACA,oDAAA;A7EinbJ;;A6E9mbE;EACE,wBAAA;UAAA,qBAAA;A7EinbJ;;A+B31bE;EACE,eAAA;A/B81bJ;A+B31bE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/B41bJ;A+Bz1bE;EACE,0GAhBiB;A/B22brB;A+Bx1bE;ECiEA,gBAAA;AhC0xbF;A6E/nbE;EAGE,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,yBzElPI;EyEkPJ,kCzElPI;EyEmPJ,eAAA;EACA,aAAA;A7E+nbJ;A6E7nbI;EjElPA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZk3bJ;AYh3bI;EiE+OA;IjE9OE,qBAAA;EZm3bJ;AACF;A6EtobI;EAGE,mCnEsbE;EmEtbF,wCnEsbE;AVgtaR;;A6EjobE;E7C3MA,2GAAA;E6C8ME,kBAAA;EACA,oBAAA;EACA,mBAAA;A7EmobJ;;A6E7nbE;EACE,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;A7EgobJ;;A6E7nbE;EACE,cnEjGW;EmEiGX,uCnEjGW;AViubf;;A6E5nbE;EAEE,yBAAA;EACA,wBAAA;A7E8nbJ;;A6E3nbE;EACE,WAAA;A7E8nbJ;;A6E1nbE;E/DwiBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EkBtxBF,2GAAA;E6CkPE,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EAEA,oBAAA;EACA,SAAA;EACA,yBzE5SI;EyE4SJ,kCzE5SI;EyE6SJ,gBAAA;EACA,cnE7HW;EmE6HX,uCnE7HW;EmE8HX,kBAAA;EACA,mBAAA;A7E8nbJ;;A6E3nbE;EACE,kBAAA;EACA,6BAAA;A7E8nbJ;;A6E3nbE;EACE,aAAA;A7E8nbJ;;A6E3nbE;EACE,anEzFW;EmEyFX,sCnEzFW;EmE0FX,4B1DlUS;U0DkUT,2B1DlUS;E0DmUT,uBAAA;EACA,iDAAA;A7E8nbJ;;A6E3nbE;EACE,mBzEjUU;EyEiUV,kCzEjUU;EyEkUV,cnEpJW;EmEoJX,uCnEpJW;AVkxbf;;A6E3nbE;EACE,yBzExUW;EyEwUX,yCzExUW;AJs8bf;;A6E3nbE;EjExUE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZu8bJ;AYr8bI;EiEqUF;IjEpUI,qBAAA;EZw8bJ;AACF;A6ErobE;EAGE,yBAAA;A7EqobJ;;A6ElobE;EAGE,yBAAA;EACA,2BAAA;A7EmobJ;;A6E/nbE;;;;EAIE,yBzE9VI;EyE8VJ,kCzE9VI;AJg+bR;;A6E/nbE;;;;EAKE,yBzEnWU;EyEmWV,wCzEnWU;AJo+bd;;A6E9nbE;;;;EAKE,yBzE7WW;EyE6WX,yCzE7WW;AJ6+bf;;A6E5nbE;EACE,gBAAA;EACA,iBAAA;A7E+nbJ;;A6E5nbE;EAEE,2BAAA;EACA,sBAAA;A7E8nbJ;A6E5nbI;EACE,oBAAA;A7E8nbN;A6E3nbI;EACE,2BAAA;A7E6nbN;;A6EznbE;EAIE,2BAAA;A7EynbJ;;A6EtnbE;EAGE,uCAAA;EACA,sBAAA;A7EunbJ;;A6EnnbE;EACE,0FAAA;UAAA,kFAAA;EAKA,oBAAA;A7EknbJ;;A6E/mbE;EACE,kBAAA;A7EknbJ;;A6E/mbE;EACE,iBAAA;EACA,sCAAA;UAAA,yBAAA;EACA,mKAAA;UAAA,2JAAA;EAUA,oBAAA;A7EymbJ;;A6EtmbE;EACE,yFAAA;UAAA,iFAAA;A7EymbJ;;A6ElmbE;EACE,kKAAA;UAAA,0JAAA;A7EqmbJ;;A6EzlbE;;EAEE,wBAAA;UAAA,gBAAA;A7E4lbJ;;A6EzlbE;EACE,oBAAA;A7E4lbJ;;A6EzlbE;EACE,kBAAA;A7E4lbJ;;A6EzlbE;EzD3dA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBwjcF;AoBtjcE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBsjcJ;AoBnjcE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBqjcJ;AoBnjcI;EAVF;IAWI,eAAA;EpBsjcJ;AACF;AqBrlcE;EwD+dA;IzD3bE,sBAAA;EpBqjcF;EoBnjcE;IACE,kBAAA;IACA,yBAAA;EpBqjcJ;AACF;A6E/nbE;EAGE,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;UAAA,0BAAA;A7E+nbJ;A6E7nbI;EACE,SAAA;A7E+nbN;A6E5nbI;EACE,gBAAA;A7E8nbN;A6E3nbI;EACE,gBAAA;A7E6nbN;;A6EznbE;EAEE,wBAAA;UAAA,oBAAA;A7E2nbJ;;AqBjncE;EwD0fA;IxDxfI,gBAAA;IACA,4BAAA;ErBoncJ;AACF;;AqBxncE;EwD8fA;;IxDvfI,8BAAA;ErBuncJ;AACF;;A+EvncE;E7EiCA,0PAAA;EAAA,uOAAA;E6E7BE,aAAA;EACA,6BAAA;EACA,sBAAA;EACA,+CAAA;EACA,iBAAA;EACA,gCAAA;EAAA,2DAAA;EACA,0BAAA;A/EyncJ;;A+EtncE;EAGE,sBrEkKc;EqElKd,kDrEkKc;AVq9blB;;A+BvocE;EACE,eAAA;A/B0ocJ;A+BvocE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BwocJ;A+BrocE;EACE,0GAhBiB;A/BupcrB;A+BpocE;ECiEA,gBAAA;AhCskcF;A+ErocE;E/CoCA,2GAAA;EpBpBE,8BAAA;EACA,oBAAA;EEyyBA,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EiEpzBA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,6CAAA;UAAA,yCAAA;EAAA,wEAAA;UAAA,oEAAA;EACA,8CAAA;UAAA,2CAAA;EAAA,yEAAA;UAAA,sEAAA;EACA,crEuJa;EqEvJb,yCrEuJa;EqEtJb,iBAAA;EACA,qBAAA;EACA,mBAAA;A/EyocJ;A+EvocI;EACE,kBAAA;EACA,cAAA;EACA,sBAAA;EACA,yBrEqCmB;EqErCnB,4DrEqCmB;EqEpCnB,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;A/EyocN;A+EtocI;EACE,aAAA;A/EwocN;A+ErocI;EACE,SAAA;A/EuocN;A+EpocI;EACE,sBAAA;EACA,yEACE;EADF,sGACE;A/EqocR;A+EjocI;EACE,crEiHS;EqEjHT,uCrEiHS;EqEhHT,eAAA;A/EmocN;A+EhocI;EAEE,UAAA;EACA,yB3EpEQ;E2EoER,wC3EpEQ;E2EqER,crEyGS;EqEzGT,uCrEyGS;AVwhcf;A+E9ncI;EACE,qBrEkGY;EqElGZ,iDrEkGY;EqEjGZ,6BAAA;EACA,6BrE2HU;EqE3HV,uDrE2HU;AVqgchB;A+E9ncM;EACE,mBAAA;A/EgocR;;A+ExncI;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,qDAAA;EAAA,0DAAA;EACA,WAAA;EACA,iBAAA;A/E2ncN;A+ExncI;EACE,yBrE+kBQ;EqE/kBR,iDrE+kBQ;EqE9kBR,oBAAA;A/E0ncN;A+EvncI;EACE,gBAAA;EACA,yB3EtGQ;E2EsGR,wC3EtGQ;E2EuGR,6CAAA;UAAA,yCAAA;EAAA,wEAAA;UAAA,oEAAA;EACA,8CAAA;UAAA,2CAAA;EAAA,yEAAA;UAAA,sEAAA;EACA,gBAAA;A/EyncN;;A+ErncE;EAEE,mBAAA;EACA,8DAAA;EACA,iBAAA;A/EuncJ;;A+EpncE;EAEE,gCAAA;EACA,kCAAA;EACA,yCAAA;EAAA,oEAAA;A/EsncJ;A+EpncI;EACE,gBAAA;A/EsncN;;A+ElncE;EAEE,8BAAA;EACA,gCAAA;EACA,0CAAA;EAAA,qEAAA;A/EoncJ;A+ElncI;EACE,gBAAA;A/EoncN;;A+EhncE;;;EAME,SAAA;A/EgncJ;A+E9mcI;;;EACE,aAAA;A/EkncN;;A+E9mcE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,yB3EjJY;E2EiJZ,0C3EjJY;E2EkJZ,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;A/EincJ;;A+E9mcE;EAEE,6BAAA;A/EgncJ;;A+E7mcE;;;;;;EASE,6BAAA;A/E6mcJ;;A+E1mcE;;EAGE,yBrEXc;EqEWd,qDrEXc;AVunclB;;A+EzmcE;;EAIE,6BAAA;A/E0mcJ;;A+EvmcE;EACE,arEmCa;EqEnCb,wCrEmCa;AVukcjB;;A+EvmcE;EACE,4B5D5MS;U4D4MT,2B5D5MS;AnBszcb;;A+EvmcE;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;A/E0mcJ;;A+EvmcE;;EAEE,arEeW;EqEfX,sCrEeW;AV2lcf;;A+EzlcI;;;;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;UAAA,yCAAA;EAAA,wEAAA;UAAA,oEAAA;EACA,8CAAA;UAAA,2CAAA;EAAA,yEAAA;UAAA,sEAAA;EACA,yCAAA;EAAA,wDAAA;EACA,WAAA;EACA,iBAAA;A/E+lcN;A+E5lcI;;;;EACE,yBrEgcQ;EqEhcR,iDrEgcQ;EqE/bR,oBAAA;A/EimcN;;A+E7lcE;EACE,UAAA;EACA,crEzDW;EqEyDX,uCrEzDW;AVypcf;A+E9lcI;EACE,6BAAA;A/EgmcN;A+E7lcI;EACE,sBAAA;EACA,yB7D+IY;E6D/IZ,qD7D+IY;E6D9IZ,6BrEzDU;EqEyDV,uDrEzDU;AVwpchB;A+E5lcI;EACE,oBAAA;A/E8lcN;;A+E1lcE;EAEE,arElCW;EqEkCX,sCrElCW;AV8ncf;;AqBp3cE;E0D4RA;I1D1RI,gBAAA;IACA,4BAAA;ErBu3cJ;AACF;;A+E1lcE;EACE,2BAAA;EACA,gCAAA;EAAA,wBAAA;A/E6lcJ;;A+E1lcE;EACE,mBAAA;EACA,UAAA;EACA,gBAAA;A/E6lcJ;A+E3lcI;EACE,gBAAA;A/E6lcN;;A+EzlcE;EAGE,6BAAA;A/E0lcJ;;A+EvlcE;EAGE,gCAAA;EACA,kCAAA;EACA,yCAAA;EAAA,oEAAA;A/EwlcJ;;A+ErlcE;EAGE,8BAAA;EACA,gCAAA;EACA,0CAAA;EAAA,qEAAA;A/EslcJ;;A+EnlcE;;EAME,gBAAA;A/EklcJ;;A+E/kcE;EAEE,iCAAA;A/EilcJ;;A+E9kcE;EACE,gBAAA;EACA,iBAAA;A/EilcJ;;A+E9kcE;EAGE,UAAA;EACA,arE7GW;EqE6GX,sCrE7GW;AV4rcf;;A+E5kcE;EAGE,UAAA;EACA,arE9GW;EqE8GX,sCrE9GW;AV2rcf;;A+E1kcE;EAEE,gBAAA;A/E4kcJ;;A+EvkcE;;;;;EAeE,6BAAA;A/EgkcJ;;A+E7jcE;EAGE,4BrEpIY;EqEoIZ,sDrEpIY;AVkschB;;A+E3jcE;;EAQE,6BAAA;A/EwjcJ;;A+ErjcE;EAEE,yB3E1XY;E2E0XZ,0C3E1XY;AJi7chB;;A+EhicI;;;;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,6CAAA;UAAA,yCAAA;EAAA,wEAAA;UAAA,oEAAA;EACA,8CAAA;UAAA,2CAAA;EAAA,yEAAA;UAAA,sEAAA;EACA,yCAAA;EAAA,wDAAA;EACA,WAAA;EACA,iBAAA;A/EsicN;A+EnicI;;;;EACE,yBrEwQQ;EqExQR,iDrEwQQ;EqEvQR,oBAAA;A/EwicN;;A+EnicE;EACE,yBCxW0B;EDwW1B,iECxW0B;EDyW1B,sB3EnaY;E2EmaZ,uC3EnaY;AJy8chB;;A+EnicE;EAEE,qB3ExaY;E2EwaZ,sC3ExaY;AJ68chB;A+EnicI;EAEE,yBC9W8B;ED8W9B,uEC9W8B;AhFk5cpC;A+EjicI;EACE,yB3EhbU;E2EgbV,0C3EhbU;AJm9chB;A+EhicI;EACE,yBClXsB;EDkXtB,+DClXsB;AhFo5c5B;A+E/hcI;EACE,qBrEzRY;EqEyRZ,iDrEzRY;EqE0RZ,6BAAA;EACA,6BrEhQU;EqEgQV,uDrEhQU;AViychB;A+E/hcM;EACE,mBAAA;A/EiicR;;A+ExhcI;EACE,uBAAA;A/E2hcN;A+ExhcI;EACE,yBCjZwB;EDiZxB,iECjZwB;EDkZxB,qDAAA;EAAA,0DAAA;A/E0hcN;A+EvhcI;EACE,qB3EhdU;E2EgdV,sC3EhdU;E2EidV,yBCnZ8B;EDmZ9B,uECnZ8B;EDoZ9B,gBAAA;A/EyhcN;;A+ErhcE;EAIE,yCAAA;EAAA,0DAAA;A/EqhcJ;;A+ElhcE;EAIE,0CAAA;EAAA,2DAAA;A/EkhcJ;;A+EhgcM;;;;EACE,qB3EpfQ;E2EofR,sC3EpfQ;E2EqfR,yCAAA;EAAA,uFAAA;A/EsgcR;A+ElgcM;;;;EACE,yBChcsB;EDgctB,iEChcsB;AhFu8c9B;;A+ElgcE;EjE2TE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EiEvTA,crEjWW;EqEiWX,uCrEjWW;AVu2cf;A+EpgcI;EACE,6BAAA;A/EsgcN;A+EngcI;EACE,sBAAA;EACA,yBCzcsB;EDyctB,+DCzcsB;ED0ctB,yCAAA;EAAA,oEAAA;A/EqgcN;A+ElgcI;EACE,qDAAA;EAAA,0DAAA;A/EogcN;A+EjgcI;EACE,+BAAA;EAAA,2DAAA;EACA,sBAAA;EACA,yBCpdsB;EDodtB,+DCpdsB;EDqdtB,6BrE7VU;EqE6VV,uDrE7VU;AVg2chB;A+EhgcI;EACE,6BAAA;A/EkgcN;;A+E9/bE;;;;;;EAeE,6BAAA;A/Ew/bJ;;A+Er/bE;;EAKE,yBrEvZc;EqEuZd,qDrEvZc;AV44clB;;A+El/bE;;;EASE,6BAAA;A/E++bJ;;A+E1+bE;EAGE,yCAAA;EAAA,0DAAA;A/E2+bJ;;A+Ex+bE;EAGE,0CAAA;EAAA,2DAAA;A/Ey+bJ;;A+Et+bE;EAGE,arE9Xa;EqE8Xb,wCrE9Xa;AVq2cjB;;A+Ep+bE;EAGE,arEvYW;EqEuYX,sCrEvYW;AV42cf;;A+El+bE;EAGE,4BrE9XY;EqE8XZ,sDrE9XY;AVi2chB;;A+Eh+bE;EAGE,arEnZW;EqEmZX,sCrEnZW;AVo3cf;;A+E99bE;EAGE,4BrE1YY;EqE0YZ,sDrE1YY;AVy2chB;;A+E79bE;EAEE,qBrEndc;EqEmdd,iDrEndc;AVk7clB;;A+E59bE;;;;;EAwBE,6BAAA;A/E48bJ;;A+Ep7bM;;;;EACE,qB3EtqBQ;E2EsqBR,sC3EtqBQ;E2EuqBR,yCAAA;EAAA,uFAAA;A/E07bR;A+Et7bM;;;;EACE,yBClnBsB;EDknBtB,iEClnBsB;AhF6id9B;;AiFjndE;ExEnBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATwodF;AStodE;;;EAGE,mBAAA;ATwodJ;AiFhodE;EAGE,aAAA;EACA,gBAAA;AjFgodJ;;AiF7ndE;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;AjFgodJ;AiF9ndI;EACE,cAAA;AjFgodN;;AiF5ndE;EACE,YAAA;EACA,qBAAA;AjF+ndJ;;AiF5ndE;EACE,kBAAA;EACA,6BAjC2B;EAkC3B,eAAA;EACA,iBAAA;EACA,qBAAA;AjF+ndJ;;AiF5ndE;EACE,iBAAA;EACA,qBAAA;AjF+ndJ;;AiF5ndE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,gB9D1CS;E8D2CT,0BvE6EU;EuE7EV,qCvE6EU;EuE5EV,iB9D5CS;E8D6CT,+BAAA;UAAA,4BAAA;EACA,0B9DxDS;U8DwDT,yB9DxDS;AnBurdb;;AiF5ndE;EACE,gBAAA;EACA,iB9DvES;E8DwET,iBAAA;AjF+ndJ;;AiF5ndE;EnE4wBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EmEzwBA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,cvE8GW;EuE9GX,uCvE8GW;EuE7GX,iBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yGACE;EAEF,mBAAA;AjF+ndJ;AiF7ndI;EACE,cAAA;EACA,WAAA;AjF+ndN;;AiF3ndE;EACE,4EAAA;EAAA,8DAAA;EACA,2DvE2HiB;EuE3HjB,6CvE2HiB;EuE1HjB,eAAA;AjF8ndJ;;AiF3ndE;EACE,2BAAA;UAAA,0BAAA;EACA,qBAAA;AjF8ndJ;;AiF1ndI;EACE,aAAA;AjF6ndN;AiF3ndI;EACE,2BvE6kBE;EuE7kBF,gCvE6kBE;EuE5kBF,6CAAA;EAAA,kDAAA;AjF6ndN;;AiFzndE;EAIE,mCAAA;EAAA,4DAAA;EACA,cvEqEW;EuErEX,uCvEqEW;AVojdf;;AiFrndE;;EAEE,mBAAA;AjFwndJ;;AiFrndE;EACE,8BAAA;UAAA,6BAAA;AjFwndJ;;AiFrndE;EACE,UAAA;EACA,SAAA;EACA,mBAAA;AjFwndJ;;AiFpndE;EnEysBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EmEtsBA,cAAA;EACA,oBAAA;EACA,cvE2DW;EuE3DX,uCvE2DW;EuE1DX,sBAAA;EACA,6BAAA;UAAA,0BAAA;EACA,8BAAA;UAAA,6BAAA;EACA,sB9D9HS;E8DgIT,0BAAA;EACA,kBAAA;AjFwndJ;;AiFpndE;EnEyrBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EmEtrBA,gBAAA;EACA,cvE4CW;EuE5CX,uCvE4CW;EuE1CX,qBAAA;AjFwndJ;;AiFpndE;EnE+qBE,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;EmE5qBA,kBAAA;EACA,cAAA;EACA,cvEqBa;EuErBb,yCvEqBa;EuEpBb,qBAAA;EACA,8BAAA;UAAA,2BAAA;EACA,4B9DvJS;U8DuJT,2B9DvJS;E8DwJT,iBAAA;AjFyndJ;;AiFpndI;EACE,sCvE3CQ;EuE2CR,iDvE3CQ;AVkqdd;;AiFjndI;EACE,avEoDS;EuEpDT,sCvEoDS;AVgkdf;AiFjndI;EACE,yB7EvKU;E6EuKV,0C7EvKU;AJ0xdhB;;AiF7mdI;EACE,sCvE7DQ;EuE6DR,iDvE7DQ;AV6qdd;;AiF3mdE;EtE3MA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATq0dF;ASn0dE;;;EAGE,mBAAA;ATq0dJ;AW/zdE;EACE,SAAA;AXi0dJ;AiFrodE;EAGE,aAAA;EACA,iBAAA;AjFqodJ;;AiFjodE;EACE,eAAA;EACA,aAAA;AjFoodJ;;AiFjodE;EAEE,gBAAA;EACA,cvE/BW;EuE+BX,uCvE/BW;EuEgCX,eAAA;AjFmodJ;;AiFhodE;EAEE,4CAAA;EAAA,wDAAA;EACA,2BvEXW;EuEWX,uCvEXW;EuEYX,eAAA;AjFkodJ;;AiF9ndE;EACE,mBAAA;EACA,oBAAA;AjFiodJ;AiF/ndI;EACE,mBAAA;EACA,4BvEiBU;EuEjBV,sDvEiBU;AVgndhB;AiF9ndI;;EAEE,gBAAA;EACA,6BvE/BU;EuE+BV,uDvE/BU;EuEgCV,mBAAA;AjFgodN;AiF7ndI;EACE,mBAAA;AjF+ndN;AiF5ndI;EAGE,aAAA;AjF4ndN;;AiFvndE;EACE,aAAA;EAAA,uCAAA;AjF0ndJ;;AiFtndE;E7DrQA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB+3dF;AoB73dE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB63dJ;AoB13dE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB43dJ;AoB13dI;EAVF;IAWI,eAAA;EpB63dJ;AACF;AqB55dE;E4DyQA;I7DrOE,sBAAA;EpB43dF;EoB13dE;IACE,kBAAA;IACA,yBAAA;EpB43dJ;AACF;AiF5pdE;EAGE,oBAAA;EAEA,mBAAA;EAEA,+BAAA;UAAA,4BAAA;AjF0pdJ;;AiFvpdE;EAEE,gCAAA;UAAA,6BAAA;AjFypdJ;;AiFppdE;EACE,aAAA;EACA,sBAAA;AjFupdJ;;AiFppdE;;EAEE,aAAA;EACA,sBAAA;AjFupdJ;;AiFppdE;;EAEE,yBAAA;EACA,oBAAA;EACA,wBAAA;EACA,wBAAA;AjFupdJ;;AiFppdE;;EAEE,qBAAA;EAEA,0BAAA;AjFspdJ;;AiFnpdE;EACE,qBAAA;EACA,SAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EAAA,oBAAA;AjFspdJ;;AiFnpdE;EAGE,6BAAA;UAAA,0BAAA;AjFopdJ;;AiFjpdE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AjFopdJ;;AiFjpdE;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AjFopdJ;;AkFr9dE;EzEfA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATw+dF;ASt+dE;;;EAGE,mBAAA;ATw+dJ;AkFp+dE;EzDZA,wCAAA;EAAA,2DAAA;EyDgBE,eAAA;EACA,aAAA;EACA,kBAAA;EACA,yB9ERI;E8EQJ,kC9ERI;E8ESJ,sBAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;AlFo+dJ;;AkFj+dE;EACE,0BAAA;EAAA,2CAAA;AlFo+dJ;;AkFj+dE;EACE,yBxExBS;EwEwBT,gDxExBS;AV4/db;;AkFj+dE;EACE,sBAAA;AlFo+dJ;;AkFj+dE;EACE,mBAAA;AlFo+dJ;AkFl+dI;EtExCA,uCAAA;EAAA,4CAAA;AZ6geJ;AY3geI;EsEsCA;ItErCE,qBAAA;EZ8geJ;AACF;;AkFr+dE;EACE,kBAAA;AlFw+dJ;;AkFr+dE;EACE,iBAAA;EACA,UAAA;AlFw+dJ;;AkFn+dE;EpE0xBE,mBAAA;EAAA,uDAAA;EAAA,gBAAA;EAAA,sDAAA;EAAA,oBAAA;EAAA,0DAAA;EAAA,sBAAA;EAAA,+DAAA;EoEvxBA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cxE+Ha;EwE/Hb,yCxE+Ha;EwE9Hb,uB/D1DS;E+D0DT,kB/D1DS;E+D2DT,eAAA;EACA,8CAAA;EAAA,sCAAA;EACA,oB/DnDS;E+DoDT,iEAAA;AlFw+dJ;AkFt+dI;EtExDA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZiieJ;AY/heI;EsEqDA;ItEpDE,qBAAA;EZkieJ;AACF;;AkF1+dE;EACE,yB9E/DU;E8E+DV,wC9E/DU;E8EgEV,cxE8GW;EwE9GX,uCxE8GW;AV+3df;;AkFl+dI;EACE,kBATc;AlF8+dpB;;AkFt+dI;EACE,gBATc;AlFk/dpB;;AkF1+dI;EACE,kBATc;AlFs/dpB;;AkF9+dI;EACE,gBATc;AlF0/dpB;;AkF7+dE;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AlFg/dJ;;AkF7+dE;EACE,aAAA;AlFg/dJ;;AkF7+dE;;EzE3GA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT6leF;AS3leE;;;;;;EAGE,mBAAA;ATgmeJ;;AkF3/dE;;EAEE,aAAA;AlF8/dJ;;AkF3/dE;;;;;;EAkBE,mDAAA;EAAA,2CAAA;AlFk/dJ;;AkF/+dE;;;;;;EA0BE,aAAA;AlF89dJ;;AkF39dE;;;EAUE,wDAAA;EAAA,gDAAA;AlFu9dJ;;AkFp9dE;EACE,6BxEkCY;EwElCZ,uDxEkCY;EwEjCZ,mBAAA;AlFu9dJ;;AkFp9dE;;EAEE,yB9E7KI;E8E6KJ,kC9E7KI;E8E8KJ,6BxE2BY;EwE3BZ,uDxE2BY;AV47dhB;;AkFp9dE;;EAEE,yBhE2KoB;EgE3KpB,2DhE2KoB;EgE1KpB,cxEeY;EwEfZ,wCxEeY;AVw8dhB;;AkFl9dE;EACE,cAAA;EACA,yB9E9KY;E8E8KZ,0C9E9KY;E8E+KZ,qBAAA;EACA,iBAAA;EACA,qB/DvMS;AnB4peb;;AmF1peE;EACE,oBAAA;EACA,qBAAA;AnF6peJ;;AmFnpeI;EAEE,0BAAA;AnFqpeN;;AmFvpeI;EAEE,0BAAA;AnFypeN;;AmF3peI;EAEE,0BAAA;AnF6peN;;AmFzpeE;EACE,iBAAA;EACA,2BAAA;EACA,0BAAA;AnF4peJ;;AmFzpeE;EACE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnF4peJ;;AmFzpeE;EACE,2DAAA;AnF4peJ;;AmFzpeE;EAGE,yBAAA;AnF0peJ;;AmFppeE;EACE,2CAAA;EAAA,sEAAA;AnFupeJ;;AmFppeE;EACE,2CAAA;EAAA,sEAAA;AnFupeJ;;AmFppeE;EACE,2CAAA;EAAA,sEAAA;AnFupeJ;;AoF7seE;EACE,iBAAA;ApFgteJ;;AoF7seE;EACE,sBAAA;ApFgteJ;;AoF7seE;EACE,2DAAA;ApFgteJ;;AoF7seE;EACE,yBAAA;ApFgteJ;;AqF/teE;EACE,aAAA;EACA,c3EyLW;E2EzLX,uC3EyLW;E2ExLX,wBAAA;ArFkueJ;;AqF/teE;;EAEE,2BAAA;UAAA,wBAAA;ArFkueJ;;AqF/teE;EACE,0BAAA;UAAA,yBAAA;ArFkueJ;;AqF/teE;EACE,2BAAA;UAAA,0BAAA;ArFkueJ;;AsFvueE;E7EfA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT0veF;ASxveE;;;EAGE,mBAAA;AT0veJ;AsFtveE;EAGE,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yB5EXS;E4EWT,gD5EXS;E4EYT,gBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,oBAAA;EACA,eAAA;AtFsveJ;;AsFnveE;E3E1BA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT4xeF;AS1xeE;;;EAGE,mBAAA;AT4xeJ;AWtxeE;EACE,SAAA;AXwxeJ;AsF7weE;EAGE,oBAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sDACE;AtF4weN;A4BpreI;E0DhGF;IAWI,qBAAA;EtF6weJ;AACF;;AsF1weE;EACE,aAAA;AtF6weJ;;AsF1weE;EACE,wBAAA;UAAA,qBAAA;AtF6weJ;;AsF1weE;;EAIE,aAAA;AtF2weJ;;AsFxweE;EAEE,eAAA;AtF0weJ;;AsFvweE;EACE,2C5E1Ce;E4E0Cf,wE5E1Ce;AVozenB;;AsFvweE;EACE,mBlFvDI;EkFuDJ,4BlFvDI;EkFwDJ,2CAAA;UAAA,uCAAA;EACA,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;AtF0weJ;;AsFvweE;EACE,a5EsKW;E4EtKX,sC5EsKW;AVomef;;AsFvweE;EACE,kC5E6mBI;E4E7mBJ,uC5E6mBI;E4E5mBJ,aAAA;AtF0weJ;;AsFvweE;EACE,0C5EvEgB;E4EuEhB,wE5EvEgB;AVi1epB;;AsFvweE;EACE,mBAAA;EACA,uBAAA;AtF0weJ;;AsFvweE;EACE,a5EuJa;E4EvJb,wC5EuJa;AVmnejB;;AsFvweE;;;EAME,a5E2IW;E4E3IX,sC5E2IW;AV4nef;;AsFpweE;EACE,a5EuIW;E4EvIX,sC5EuIW;AVgoef;;AsFpweE;EACE,a5EmIW;E4EnIX,sC5EmIW;AVooef;;AsFnweE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AtFsweJ;;A4B3xeM;E0DwBJ;IAEI,aAAA;EtFsweJ;AACF;;AsFhweE;ExEqtBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwEltBA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;UAAA,iBAAA;AtFqweJ;A4BxxeI;E0DKF;IAgBI,eAAA;EtFuweJ;AACF;;AsFpweE;EACE,kC5EsiBI;E4EtiBJ,uC5EsiBI;AViudR;;AsFnweE;EACE,gBAAA;AtFsweJ;;AsFnweE;;EAEE,c5E8BW;E4E9BX,uC5E8BW;AVwuef;;AsFnweE;EAEE,6BAAA;UAAA,4BAAA;AtFqweJ;;AsF/veE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;UAAA,0BAAA;AtFkweJ;A4Bj1eM;E0D2EJ;IAOI,cAAA;EtFmweJ;AACF;AsFhweI;EACE,kBAAA;EACA,cAAA;EACA,yBlF/JU;EkF+JV,0ClF/JU;EkFgKV,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;AtFkweN;;AsF9veE;E7EpMA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATs8eF;ASp8eE;;;EAGE,mBAAA;ATs8eJ;AsF7weE;EAGE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AtF6weJ;;AsF1weE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,6BAAA;EACA,yB5E1MS;E4E0MT,gD5E1MS;E4E4MT,gBAAA;EACA,c5EtBa;E4EsBb,yC5EtBa;E4EwBb,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,qBAAA;EACA,mEACE;EAGF,yBAAA;UAAA,iBAAA;AtFsweJ;;AsFnweE;EACE,2C5EjNe;E4EiNf,wE5EjNe;E4EkNf,c5E1CW;E4E0CX,uC5E1CW;AVgzef;;AsFnweE;;EAEE,0C5EhOgB;E4EgOhB,wE5EhOgB;E4EiOhB,c5EhDW;E4EgDX,uC5EhDW;AVszef;;AsFnweE;EACE,kC5E0cI;E4E1cJ,uC5E0cI;E4EzcJ,aAAA;AtFsweJ;;AsFnweE;;EAEE,a5EPW;E4EOX,sC5EPW;AV6wef;;AsFjweE;;EAEE,c5EjEW;E4EiEX,uC5EjEW;AVq0ef;;AsFjweE;;EAEE,kBAAA;EACA,sC5E7EiB;E4E6EjB,wD5E7EiB;E4E8EjB,eAAA;EACA,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,wBAAA;AtFoweJ;;AsFjweE;;EAEE,SAAA;AtFoweJ;;AsFhweI;;EAEE,sC5E7Fe;E4E6Ff,wD5E7Fe;E4E8Ff,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AtFmweN;AsFhweI;;EAEE,sC5EtGe;E4EsGf,wD5EtGe;E4EuGf,4BAAA;EAEA,gBAAA;EACA,uBAAA;EACA,wBAAA;AtFiweN;;AsF7veE;;EAEE,sCAAA;EAAA,2CAAA;AtFgweJ;;AsF7veE;EACE,kBAAA;AtFgweJ;;AsF7veE;EACE,kBAAA;AtFgweJ;;AsF7veE;EAGE,aAAA;EACA,yBlF3SI;EkF2SJ,kClF3SI;EkF4SJ,c5ExHa;E4EwHb,yC5ExHa;AVs3ejB;;AsF3veE;EAEE,yBAAA;AtF6veJ;;AsF1veE;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AtF6veJ;;AsF1veE;EAEE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBlFjUI;EkFiUJ,kClFjUI;EkFkUJ,0CAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;AtF4veJ;;AsFzveE;EAGE,yBlF5UI;EkF4UJ,kClF5UI;AJskfR;;AsFvveE;EAGE,yBlF/UU;EkF+UV,wClF/UU;EkFgVV,c5ElKW;E4EkKX,uC5ElKW;AV05ef;;AsFrveE;EAGE,yBlFxVW;EkFwVX,yClFxVW;EkFyVX,c5EzKW;E4EyKX,uC5EzKW;AV+5ef;;AsFnveE;EAIE,yBlF7Va;EkF6Vb,2ClF7Va;AJglfjB;AsFjveI;EACE,yBlF/ViB;EkF+VjB,iDlF/ViB;AJklfvB;;AsF/ueE;EACE,gBAAA;AtFkveJ;;AsF/ueE;EACE,a5EtIa;E4EsIb,wC5EtIa;E4EuIb,4BAAA;UAAA,2BAAA;EACA,uCACE;AtFiveN;;AsF1ueE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AtF6ueJ;;AsFvueE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AtF0ueJ;;AsFvueE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EAAA,2CAAA;EACA,yB5EvZS;E4EuZT,gD5EvZS;E4EwZT,gBAAA;EACA,UAAA;EACA,c5EnOa;E4EmOb,yC5EnOa;E4EoOb,iBAAA;EACA,oBAAA;EACA,qBAAA;EAEA,aAAA;AtFyueJ;;AuFzofE;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,yBnFDI;EmFCJ,kCnFDI;EmFEJ,c7EkLa;E6ElLb,yC7EkLa;E6EjLb,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,kBAAA;AvF4ofJ;;AuFzofE;EACE,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;EACA,kBAAA;EACA,gBAAA;AvF4ofJ;;AwFtpfE;EACE,eAAA;EACA,aAAA;EAEA,gBAAA;EACA,yB9EZS;E8EYT,gD9EZS;E8EaT,c9E0Ka;E8E1Kb,yC9E0Ka;E8EzKb,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EAEA,wGACE;EAEF,wBAAA;AxFqpfJ;;AwFlpfE;EACE,kBAAA;EACA,uBrEES;AnBmpfb;A4B9jfI;E4DzFF;IAKI,cAAA;ExFspfJ;AACF;;AwF3ofE;EACE,iBAAA;AxF8ofJ;;AwF3ofE;EACE,cAAA;AxF8ofJ;;AwF3ofE;EACE,kBAAA;AxF8ofJ;;AwF3ofE;EACE,eAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,2GACE;AxF6ofN;;A4B1lfI;E4D/CF;IAEI,aAAA;IACA,oC9EgmBI;I8EhmBJ,wD9EgmBI;I8E/lBJ,iBAAA;IACA,kBAAA;IACA,UAAA;IACA,2GACE;ExF2ofN;AACF;;AwFrofE;EACE,6BAAA;EACA,uBAAA;AxFwofJ;;AwFrofE;EACE,kBAAA;AxFwofJ;;AwFrofE;EACE,kBAAA;EACA,6BAAA;AxFwofJ;;AwFlofE;EACE,aAAA;EACA,sBAAA;AxFqofJ;;AwF/nfE;E/EtHA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATyvfF;ASvvfE;;;EAGE,mBAAA;ATyvfJ;AwF9ofE;EAGE,gBAAA;EACA,SAAA;EACA,iBAAA;AxF8ofJ;AyF1ufE;ED+FI,gBAAA;AxF8ofN;;AwF1ofE;EACE,gBAAA;AxF6ofJ;;AwF1ofE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AxF6ofJ;;AwF1ofE;EACE,gBAAA;EACA,iBAAA;AxF6ofJ;;AwF1ofE;;;;;EAaE,2C9EvIe;E8EuIf,wE9EvIe;E8EwIf,c9EgCW;E8EhCX,uC9EgCW;AVqmff;;AwFlofE;;EAOE,c9EsBW;E8EtBX,uC9EsBW;AV0mff;;AwF7nfE;EACE,gBAAA;AxFgofJ;;AwF1nfE;EACE,mBAAA;EACA,yBpF1JY;EoF0JZ,0CpF1JY;EoF2JZ,eAAA;EACA,qBAAA;AxF6nfJ;;AwF1nfE;EACE,YAAA;AxF6nfJ;;AwFvnfE;E7E9LA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATo0fF;ASl0fE;;;EAGE,mBAAA;ATo0fJ;AW9zfE;EACE,SAAA;AXg0fJ;AwFjpfE;E1EspBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EF1yBA,8BAAA;EACA,oBAAA;E4EwJA,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,c9ETa;E8ESb,yC9ETa;E8EUb,8DACE;EAGF,yBAAA;UAAA,iBAAA;AxFipfJ;;AwF9ofE;EACE,2C9E7Le;E8E6Lf,wE9E7Le;E8E8Lf,c9EtBW;E8EsBX,uC9EtBW;AVuqff;;AwF9ofE;E5EtME,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZw1fJ;AYt1fI;E4EmMF;I5ElMI,qBAAA;EZy1fJ;AACF;;AwFppfE;ECrNA,gBAAA;EACA,uBAAA;EACA,mBAAA;EDsNE,iBAAA;AxFwpfJ;;AwFrpfE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AxFwpfJ;;AwFrpfE;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AxFwpfJ;;AwFrpfE;EAGE,yBAAA;AxFspfJ;;AwFnpfE;EACE,gBAAA;AxFspfJ;;AwFnpfE;EAEE,0C9EzOkB;E8EyOlB,0E9EzOkB;E8E0OlB,c9E5DW;E8E4DX,uC9E5DW;AVitff;;AwFlpfE;EAEE,kBAAA;EACA,0C9EhPkB;E8EgPlB,0E9EhPkB;E8EiPlB,c9EnEW;E8EmEX,uC9EnEW;AVutff;AwFlpfI;EACE,kBAAA;EACA,sC9E7Ee;E8E6Ef,wD9E7Ee;E8E8Ef,WAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AxFopfN;;AwFhpfE;EACE,c9EhFW;E8EgFX,uC9EhFW;E8EiFX,gBAAA;AxFmpfJ;;AwFhpfE;EACE,a9ElCW;E8EkCX,sC9ElCW;AVqrff;;AwFhpfE;E/EvRA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT26fF;ASz6fE;;;EAGE,mBAAA;AT26fJ;AwF/pfE;EAGE,cAAA;EACA,iBAAA;EACA,kBAAA;AxF+pfJ;;AwF5pfE;EAEE,wBAAA;EACA,mBAAA;AxF8pfJ;;AwF3pfE;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;UAAA,0BAAA;AxF8pfJ;;AwF3pfE;EAEE,6BAAA;UAAA,4BAAA;AxF6pfJ;;AwF3pfE;;;EAGE,0C9ElSkB;E8EkSlB,0E9ElSkB;AVg8ftB;AwF5pfI;;;EACE,c9EvHS;E8EuHT,uC9EvHS;E8EwHT,gBAAA;AxFgqfN;;AwFzpfE;;;E5EjRE,8BAAA;EACA,oBAAA;EEyyBA,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E0EjhBA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,8DACE;AxF4pfN;;AwFvpfE;EACE,gBAAA;AxF0pfJ;;AwFvpfE;;EC/UA,gBAAA;EACA,uBAAA;EACA,mBAAA;EDmVE,c9E1Ja;E8E0Jb,yC9E1Ja;E8E2Jb,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AxFypfJ;;AwFtpfE;;E5EjVE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ4+fJ;AY1+fI;E4E8UF;;I5E7UI,qBAAA;EZ8+fJ;AACF;;AwF7pfE;;EAEE,0C9EzVkB;E8EyVlB,0E9EzVkB;E8E0VlB,gBAAA;AxFgqfJ;;AwF7pfE;;EAGE,c9ElLW;E8EkLX,uC9ElLW;AVi1ff;;AwF5pfE;;EAEE,kBAAA;EACA,sC9E9LiB;E8E8LjB,wD9E9LiB;E8E+LjB,WAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AxF+pfJ;;AwFzpfE;EACE,aAAA;EAGA,cAAA;EACA,mBAAA;EACA,uBAAA;AxF0pfJ;;AwFvpfE;EACE,0BAAA;UAAA,yBAAA;AxF0pfJ;;AwFvpfE;EACE,gBAAA;EACA,a9E3Ja;E8E2Jb,wC9E3Ja;E8E4Jb,iBAAA;AxF0pfJ;;AwFvpfE;EACE,aAAA;AxF0pfJ;;AwFvpfE;EAGE,aAAA;AxFwpfJ;;AwFrpfE;EAGE,cAAA;AxFspfJ;;AwFhpfE;;EAEE,2BAAA;UAAA,0BAAA;AxFmpfJ;;AwFhpfE;EAIE,2BAAA;UAAA,0BAAA;AxFgpfJ;;A4Bn8fI;E4DyTF;IAEI,cAAA;ExF6ofJ;AACF;;AwF1ofE;E/E5bA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT0kgBF;ASxkgBE;;;EAGE,mBAAA;AT0kgBJ;AwFzpfE;EAGE,aAAA;AxFypfJ;A4B39fI;E4D+TF;IAMI,kBAAA;IACA,cAAA;IACA,0BAAA;YAAA,sBAAA;ExF0pfJ;AACF;;AwFvpfE;EACE,kBAAA;EACA,mBpF/aY;EoF+aZ,oCpF/aY;EoFgbZ,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;AxF0pfJ;;AwFtpfE;EACE,8BAAA;EACA,c9EnRa;E8EmRb,yC9EnRa;E8EoRb,mBAAA;AxFypfJ;AwFvpfI;EACE,6BAAA;AxFypfN;;AwFrpfE;EAGE,UAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;AxFspfJ;AwFppfI;EACE,iBAAA;AxFspfN;AwFnpfI;EACE,gBAAA;EACA,8BAAA;UAAA,6BAAA;AxFqpfN;AwFlpfI;EACE,2C9E1da;E8E0db,wE9E1da;E8E2db,c9EnTS;E8EmTT,uC9EnTS;AVu8ff;AwFhpfI;EACE,yBpFpeiB;EoFoejB,iDpFpeiB;AJsngBvB;;AwF9ofE;;EAME,4BAAA;EACA,gBAAA;AxF6ofJ;;AwF1ofE;EAGE,mBAAA;AxF2ofJ;;AwFxofE;;;EAOE,a9E7Ra;E8E6Rb,wC9E7Ra;AVo6fjB;;A0F/ogBE;EjFVA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT6pgBF;AS3pgBE;;;EAGE,mBAAA;AT6pgBJ;A0F9pgBE;EAGE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,chFiLa;EgFjLb,yChFiLa;AV6+fjB;;A0F3pgBE;EACE,gBvESS;EuERT,iBAAA;A1F8pgBJ;;A0F3pgBE;EACE,2BvENS;UuEMT,wBvENS;AnBoqgBb;;A0F3pgBE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBtFNY;EsFMZ,oCtFNY;EsFOZ,eAAA;EACA,kBAAA;A1F8pgBJ;;A0F3pgBE;E5EizBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E4E9yBA,cAAA;EACA,sBAAA;EACA,gBvEbS;EuEcT,chFsJa;EgFtJb,yChFsJa;EgFrJb,qBAAA;A1FgqgBJ;A0F9pgBI;EACE,mBtF/BQ;EsF+BR,kCtF/BQ;EsFgCR,chF8IS;EgF9IT,uChF8IS;EgF7IT,eAAA;A1FgqgBN;A0F7pgBI;EACE,uCAAA;EAAA,4CAAA;EACA,oBAAA;A1F+pgBN;A0F5pgBI;EACE,mBtF5CS;EsF4CT,mCtF5CS;EsF6CT,chFmIS;EgFnIT,uChFmIS;AV2hgBf;;A0F1pgBE;EAEE,mBtFhDa;EsFgDb,qCtFhDa;EsFiDb,chF4HW;EgF5HX,uChF4HW;AVgigBf;;AqF3tgBE;EACE,aAAA;EACA,c3EyLW;E2EzLX,uC3EyLW;E2ExLX,wBAAA;ArF8tgBJ;;AqF3tgBE;;EAEE,2BAAA;UAAA,wBAAA;ArF8tgBJ;;AqF3tgBE;EACE,0BAAA;UAAA,yBAAA;ArF8tgBJ;;AqF3tgBE;EACE,2BAAA;UAAA,0BAAA;ArF8tgBJ;;AsFnugBE;E7EfA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATsvgBF;ASpvgBE;;;EAGE,mBAAA;ATsvgBJ;AsFlvgBE;EAGE,eAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,yB5EXS;E4EWT,gD5EXS;E4EYT,gBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,oBAAA;EACA,eAAA;AtFkvgBJ;;AsF/ugBE;E3E1BA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATwxgBF;AStxgBE;;;EAGE,mBAAA;ATwxgBJ;AWlxgBE;EACE,SAAA;AXoxgBJ;AsFzwgBE;EAGE,oBAAA;EACA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,sDACE;AtFwwgBN;A4BhrgBI;E0DhGF;IAWI,qBAAA;EtFywgBJ;AACF;;AsFtwgBE;EACE,aAAA;AtFywgBJ;;AsFtwgBE;EACE,wBAAA;UAAA,qBAAA;AtFywgBJ;;AsFtwgBE;;EAIE,aAAA;AtFuwgBJ;;AsFpwgBE;EAEE,eAAA;AtFswgBJ;;AsFnwgBE;EACE,2C5E1Ce;E4E0Cf,wE5E1Ce;AVgzgBnB;;AsFnwgBE;EACE,mBlFvDI;EkFuDJ,4BlFvDI;EkFwDJ,2CAAA;UAAA,uCAAA;EACA,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;AtFswgBJ;;AsFnwgBE;EACE,a5EsKW;E4EtKX,sC5EsKW;AVgmgBf;;AsFnwgBE;EACE,kC5E6mBI;E4E7mBJ,uC5E6mBI;E4E5mBJ,aAAA;AtFswgBJ;;AsFnwgBE;EACE,0C5EvEgB;E4EuEhB,wE5EvEgB;AV60gBpB;;AsFnwgBE;EACE,mBAAA;EACA,uBAAA;AtFswgBJ;;AsFnwgBE;EACE,a5EuJa;E4EvJb,wC5EuJa;AV+mgBjB;;AsFnwgBE;;;EAME,a5E2IW;E4E3IX,sC5E2IW;AVwngBf;;AsFhwgBE;EACE,a5EuIW;E4EvIX,sC5EuIW;AV4ngBf;;AsFhwgBE;EACE,a5EmIW;E4EnIX,sC5EmIW;AVgogBf;;AsF/vgBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AtFkwgBJ;;A4BvxgBM;E0DwBJ;IAEI,aAAA;EtFkwgBJ;AACF;;AsF5vgBE;ExEqtBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EwEltBA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,yBAAA;UAAA,iBAAA;AtFiwgBJ;A4BpxgBI;E0DKF;IAgBI,eAAA;EtFmwgBJ;AACF;;AsFhwgBE;EACE,kC5EsiBI;E4EtiBJ,uC5EsiBI;AV6tfR;;AsF/vgBE;EACE,gBAAA;AtFkwgBJ;;AsF/vgBE;;EAEE,c5E8BW;E4E9BX,uC5E8BW;AVougBf;;AsF/vgBE;EAEE,6BAAA;UAAA,4BAAA;AtFiwgBJ;;AsF3vgBE;EACE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;UAAA,0BAAA;AtF8vgBJ;A4B70gBM;E0D2EJ;IAOI,cAAA;EtF+vgBJ;AACF;AsF5vgBI;EACE,kBAAA;EACA,cAAA;EACA,yBlF/JU;EkF+JV,0ClF/JU;EkFgKV,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;AtF8vgBN;;AsF1vgBE;E7EpMA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATk8gBF;ASh8gBE;;;EAGE,mBAAA;ATk8gBJ;AsFzwgBE;EAGE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;AtFywgBJ;;AsFtwgBE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,6BAAA;EACA,yB5E1MS;E4E0MT,gD5E1MS;E4E4MT,gBAAA;EACA,c5EtBa;E4EsBb,yC5EtBa;E4EwBb,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EAEA,qBAAA;EACA,mEACE;EAGF,yBAAA;UAAA,iBAAA;AtFkwgBJ;;AsF/vgBE;EACE,2C5EjNe;E4EiNf,wE5EjNe;E4EkNf,c5E1CW;E4E0CX,uC5E1CW;AV4ygBf;;AsF/vgBE;;EAEE,0C5EhOgB;E4EgOhB,wE5EhOgB;E4EiOhB,c5EhDW;E4EgDX,uC5EhDW;AVkzgBf;;AsF/vgBE;EACE,kC5E0cI;E4E1cJ,uC5E0cI;E4EzcJ,aAAA;AtFkwgBJ;;AsF/vgBE;;EAEE,a5EPW;E4EOX,sC5EPW;AVywgBf;;AsF7vgBE;;EAEE,c5EjEW;E4EiEX,uC5EjEW;AVi0gBf;;AsF7vgBE;;EAEE,kBAAA;EACA,sC5E7EiB;E4E6EjB,wD5E7EiB;E4E8EjB,eAAA;EACA,WAAA;EACA,6BAAA;EACA,qBAAA;EACA,wBAAA;AtFgwgBJ;;AsF7vgBE;;EAEE,SAAA;AtFgwgBJ;;AsF5vgBI;;EAEE,sC5E7Fe;E4E6Ff,wD5E7Fe;E4E8Ff,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,wBAAA;AtF+vgBN;AsF5vgBI;;EAEE,sC5EtGe;E4EsGf,wD5EtGe;E4EuGf,4BAAA;EAEA,gBAAA;EACA,uBAAA;EACA,wBAAA;AtF6vgBN;;AsFzvgBE;;EAEE,sCAAA;EAAA,2CAAA;AtF4vgBJ;;AsFzvgBE;EACE,kBAAA;AtF4vgBJ;;AsFzvgBE;EACE,kBAAA;AtF4vgBJ;;AsFzvgBE;EAGE,aAAA;EACA,yBlF3SI;EkF2SJ,kClF3SI;EkF4SJ,c5ExHa;E4EwHb,yC5ExHa;AVk3gBjB;;AsFvvgBE;EAEE,yBAAA;AtFyvgBJ;;AsFtvgBE;EACE,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AtFyvgBJ;;AsFtvgBE;EAEE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBlFjUI;EkFiUJ,kClFjUI;EkFkUJ,0CAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;AtFwvgBJ;;AsFrvgBE;EAGE,yBlF5UI;EkF4UJ,kClF5UI;AJkkhBR;;AsFnvgBE;EAGE,yBlF/UU;EkF+UV,wClF/UU;EkFgVV,c5ElKW;E4EkKX,uC5ElKW;AVs5gBf;;AsFjvgBE;EAGE,yBlFxVW;EkFwVX,yClFxVW;EkFyVX,c5EzKW;E4EyKX,uC5EzKW;AV25gBf;;AsF/ugBE;EAIE,yBlF7Va;EkF6Vb,2ClF7Va;AJ4khBjB;AsF7ugBI;EACE,yBlF/ViB;EkF+VjB,iDlF/ViB;AJ8khBvB;;AsF3ugBE;EACE,gBAAA;AtF8ugBJ;;AsF3ugBE;EACE,a5EtIa;E4EsIb,wC5EtIa;E4EuIb,4BAAA;UAAA,2BAAA;EACA,uCACE;AtF6ugBN;;AsFtugBE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AtFyugBJ;;AsFnugBE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AtFsugBJ;;AsFnugBE;EACE,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EAAA,2CAAA;EACA,yB5EvZS;E4EuZT,gD5EvZS;E4EwZT,gBAAA;EACA,UAAA;EACA,c5EnOa;E4EmOb,yC5EnOa;E4EoOb,iBAAA;EACA,oBAAA;EACA,qBAAA;EAEA,aAAA;AtFqugBJ;;AuFrohBE;EACE,eAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,yBnFDI;EmFCJ,kCnFDI;EmFEJ,c7EkLa;E6ElLb,yC7EkLa;E6EjLb,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,kBAAA;AvFwohBJ;;AuFrohBE;EACE,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;EACA,uCAAA;UAAA,sCAAA;EAAA,wDAAA;UAAA,uDAAA;EACA,kBAAA;EACA,gBAAA;AvFwohBJ;;AwFlphBE;EACE,eAAA;EACA,aAAA;EAEA,gBAAA;EACA,yB9EZS;E8EYT,gD9EZS;E8EaT,c9E0Ka;E8E1Kb,yC9E0Ka;E8EzKb,iBAAA;EACA,cAAA;EACA,qBAAA;EACA,sBAAA;EAEA,wGACE;EAEF,wBAAA;AxFiphBJ;;AwF9ohBE;EACE,kBAAA;EACA,uBrEES;AnB+ohBb;A4B1jhBI;E4DzFF;IAKI,cAAA;ExFkphBJ;AACF;;AwFvohBE;EACE,iBAAA;AxF0ohBJ;;AwFvohBE;EACE,cAAA;AxF0ohBJ;;AwFvohBE;EACE,kBAAA;AxF0ohBJ;;AwFvohBE;EACE,eAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,2GACE;AxFyohBN;;A4BtlhBI;E4D/CF;IAEI,aAAA;IACA,oC9EgmBI;I8EhmBJ,wD9EgmBI;I8E/lBJ,iBAAA;IACA,kBAAA;IACA,UAAA;IACA,2GACE;ExFuohBN;AACF;;AwFjohBE;EACE,6BAAA;EACA,uBAAA;AxFoohBJ;;AwFjohBE;EACE,kBAAA;AxFoohBJ;;AwFjohBE;EACE,kBAAA;EACA,6BAAA;AxFoohBJ;;AwF9nhBE;EACE,aAAA;EACA,sBAAA;AxFiohBJ;;AwF3nhBE;E/EtHA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATqvhBF;ASnvhBE;;;EAGE,mBAAA;ATqvhBJ;AwF1ohBE;EAGE,gBAAA;EACA,SAAA;EACA,iBAAA;AxF0ohBJ;AyFtuhBE;ED+FI,gBAAA;AxF0ohBN;;AwFtohBE;EACE,gBAAA;AxFyohBJ;;AwFtohBE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;AxFyohBJ;;AwFtohBE;EACE,gBAAA;EACA,iBAAA;AxFyohBJ;;AwFtohBE;;;;;EAaE,2C9EvIe;E8EuIf,wE9EvIe;E8EwIf,c9EgCW;E8EhCX,uC9EgCW;AVimhBf;;AwF9nhBE;;EAOE,c9EsBW;E8EtBX,uC9EsBW;AVsmhBf;;AwFznhBE;EACE,gBAAA;AxF4nhBJ;;AwFtnhBE;EACE,mBAAA;EACA,yBpF1JY;EoF0JZ,0CpF1JY;EoF2JZ,eAAA;EACA,qBAAA;AxFynhBJ;;AwFtnhBE;EACE,YAAA;AxFynhBJ;;AwFnnhBE;E7E9LA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATg0hBF;AS9zhBE;;;EAGE,mBAAA;ATg0hBJ;AW1zhBE;EACE,SAAA;AX4zhBJ;AwF7ohBE;E1EspBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EF1yBA,8BAAA;EACA,oBAAA;E4EwJA,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,c9ETa;E8ESb,yC9ETa;E8EUb,8DACE;EAGF,yBAAA;UAAA,iBAAA;AxF6ohBJ;;AwF1ohBE;EACE,2C9E7Le;E8E6Lf,wE9E7Le;E8E8Lf,c9EtBW;E8EsBX,uC9EtBW;AVmqhBf;;AwF1ohBE;E5EtME,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZo1hBJ;AYl1hBI;E4EmMF;I5ElMI,qBAAA;EZq1hBJ;AACF;;AwFhphBE;ECrNA,gBAAA;EACA,uBAAA;EACA,mBAAA;EDsNE,iBAAA;AxFophBJ;;AwFjphBE;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AxFophBJ;;AwFjphBE;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AxFophBJ;;AwFjphBE;EAGE,yBAAA;AxFkphBJ;;AwF/ohBE;EACE,gBAAA;AxFkphBJ;;AwF/ohBE;EAEE,0C9EzOkB;E8EyOlB,0E9EzOkB;E8E0OlB,c9E5DW;E8E4DX,uC9E5DW;AV6shBf;;AwF9ohBE;EAEE,kBAAA;EACA,0C9EhPkB;E8EgPlB,0E9EhPkB;E8EiPlB,c9EnEW;E8EmEX,uC9EnEW;AVmthBf;AwF9ohBI;EACE,kBAAA;EACA,sC9E7Ee;E8E6Ef,wD9E7Ee;E8E8Ef,WAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AxFgphBN;;AwF5ohBE;EACE,c9EhFW;E8EgFX,uC9EhFW;E8EiFX,gBAAA;AxF+ohBJ;;AwF5ohBE;EACE,a9ElCW;E8EkCX,sC9ElCW;AVirhBf;;AwF5ohBE;E/EvRA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATu6hBF;ASr6hBE;;;EAGE,mBAAA;ATu6hBJ;AwF3phBE;EAGE,cAAA;EACA,iBAAA;EACA,kBAAA;AxF2phBJ;;AwFxphBE;EAEE,wBAAA;EACA,mBAAA;AxF0phBJ;;AwFvphBE;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,2BAAA;UAAA,0BAAA;AxF0phBJ;;AwFvphBE;EAEE,6BAAA;UAAA,4BAAA;AxFyphBJ;;AwFvphBE;;;EAGE,0C9ElSkB;E8EkSlB,0E9ElSkB;AV47hBtB;AwFxphBI;;;EACE,c9EvHS;E8EuHT,uC9EvHS;E8EwHT,gBAAA;AxF4phBN;;AwFrphBE;;;E5EjRE,8BAAA;EACA,oBAAA;EEyyBA,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E0EjhBA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,8DACE;AxFwphBN;;AwFnphBE;EACE,gBAAA;AxFsphBJ;;AwFnphBE;;EC/UA,gBAAA;EACA,uBAAA;EACA,mBAAA;EDmVE,c9E1Ja;E8E0Jb,yC9E1Ja;E8E2Jb,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,yBAAA;UAAA,iBAAA;AxFqphBJ;;AwFlphBE;;E5EjVE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZw+hBJ;AYt+hBI;E4E8UF;;I5E7UI,qBAAA;EZ0+hBJ;AACF;;AwFzphBE;;EAEE,0C9EzVkB;E8EyVlB,0E9EzVkB;E8E0VlB,gBAAA;AxF4phBJ;;AwFzphBE;;EAGE,c9ElLW;E8EkLX,uC9ElLW;AV60hBf;;AwFxphBE;;EAEE,kBAAA;EACA,sC9E9LiB;E8E8LjB,wD9E9LiB;E8E+LjB,WAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AxF2phBJ;;AwFrphBE;EACE,aAAA;EAGA,cAAA;EACA,mBAAA;EACA,uBAAA;AxFsphBJ;;AwFnphBE;EACE,0BAAA;UAAA,yBAAA;AxFsphBJ;;AwFnphBE;EACE,gBAAA;EACA,a9E3Ja;E8E2Jb,wC9E3Ja;E8E4Jb,iBAAA;AxFsphBJ;;AwFnphBE;EACE,aAAA;AxFsphBJ;;AwFnphBE;EAGE,aAAA;AxFophBJ;;AwFjphBE;EAGE,cAAA;AxFkphBJ;;AwF5ohBE;;EAEE,2BAAA;UAAA,0BAAA;AxF+ohBJ;;AwF5ohBE;EAIE,2BAAA;UAAA,0BAAA;AxF4ohBJ;;A4B/7hBI;E4DyTF;IAEI,cAAA;ExFyohBJ;AACF;;AwFtohBE;E/E5bA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATskiBF;ASpkiBE;;;EAGE,mBAAA;ATskiBJ;AwFrphBE;EAGE,aAAA;AxFqphBJ;A4Bv9hBI;E4D+TF;IAMI,kBAAA;IACA,cAAA;IACA,0BAAA;YAAA,sBAAA;ExFsphBJ;AACF;;AwFnphBE;EACE,kBAAA;EACA,mBpF/aY;EoF+aZ,oCpF/aY;EoFgbZ,qBAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;AxFsphBJ;;AwFlphBE;EACE,8BAAA;EACA,c9EnRa;E8EmRb,yC9EnRa;E8EoRb,mBAAA;AxFqphBJ;AwFnphBI;EACE,6BAAA;AxFqphBN;;AwFjphBE;EAGE,UAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;AxFkphBJ;AwFhphBI;EACE,iBAAA;AxFkphBN;AwF/ohBI;EACE,gBAAA;EACA,8BAAA;UAAA,6BAAA;AxFiphBN;AwF9ohBI;EACE,2C9E1da;E8E0db,wE9E1da;E8E2db,c9EnTS;E8EmTT,uC9EnTS;AVm8hBf;AwF5ohBI;EACE,yBpFpeiB;EoFoejB,iDpFpeiB;AJkniBvB;;AwF1ohBE;;EAME,4BAAA;EACA,gBAAA;AxFyohBJ;;AwFtohBE;EAGE,mBAAA;AxFuohBJ;;AwFpohBE;;;EAOE,a9E7Ra;E8E6Rb,wC9E7Ra;AVg6hBjB;;A0F3oiBE;EjFVA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATypiBF;ASvpiBE;;;EAGE,mBAAA;ATypiBJ;A0F1piBE;EAGE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,chFiLa;EgFjLb,yChFiLa;AVy+hBjB;;A0FvpiBE;EACE,gBvESS;EuERT,iBAAA;A1F0piBJ;;A0FvpiBE;EACE,2BvENS;UuEMT,wBvENS;AnBgqiBb;;A0FvpiBE;EACE,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBtFNY;EsFMZ,oCtFNY;EsFOZ,eAAA;EACA,kBAAA;A1F0piBJ;;A0FvpiBE;E5EizBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E4E9yBA,cAAA;EACA,sBAAA;EACA,gBvEbS;EuEcT,chFsJa;EgFtJb,yChFsJa;EgFrJb,qBAAA;A1F4piBJ;A0F1piBI;EACE,mBtF/BQ;EsF+BR,kCtF/BQ;EsFgCR,chF8IS;EgF9IT,uChF8IS;EgF7IT,eAAA;A1F4piBN;A0FzpiBI;EACE,uCAAA;EAAA,4CAAA;EACA,oBAAA;A1F2piBN;A0FxpiBI;EACE,mBtF5CS;EsF4CT,mCtF5CS;EsF6CT,chFmIS;EgFnIT,uChFmIS;AVuhiBf;;A0FtpiBE;EAEE,mBtFhDa;EsFgDb,qCtFhDa;EsFiDb,chF4HW;EgF5HX,uChF4HW;AV4hiBf;;A2FptiBA;EACE;IACE,UAAA;IACA,mCAAA;E3FutiBF;E2FptiBA;IACE,UAAA;IACA,+BAAA;E3FstiBF;AACF;A2FntiBA;EACE;IACE,+BAAA;E3FqtiBF;E2FltiBA;IACE,mCAAA;E3FotiBF;AACF;A2FjtiBA;EACE;IACE,kCAAA;E3FmtiBF;E2FhtiBA;IACE,+BAAA;E3FktiBF;AACF;A2F/siBA;EACE;IACE,+BAAA;E3FitiBF;E2F9siBA;IACE,kCAAA;E3FgtiBF;AACF;A2F7siBA;EACE;IACE,mCAAA;E3F+siBF;E2F5siBA;IACE,+BAAA;E3F8siBF;AACF;A2F3siBA;EACE;IACE,UAAA;E3F6siBF;E2F1siBA;IACE,UAAA;E3F4siBF;AACF;A2FzsiBA;EACE;IACE,UAAA;E3F2siBF;E2FxsiBA;IACE,UAAA;E3F0siBF;AACF;A2FtsiBE;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;A3FwsiBJ;AqBpyiBE;EsE8EA;ItEvEI,8BAAA;ErBiyiBJ;AACF;;A2FzsiBE;;EAEE,iBAAA;EACA,qBAAA;EACA,UAAA;EACA,mBAAA;A3F4siBJ;;A2FzsiBE;ElEvGA,wCAAA;EAAA,2DAAA;EkE0GE,cAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uCAAA;EACA,YAAA;EACA,yBjFlFO;EiFkFP,8CjFlFO;EiFmFP,iBAAA;EACA,kBAAA;EACA,gCAAA;UAAA,6BAAA;A3F2siBJ;A2FzsiBI;E/ErHA,uCAAA;EAAA,4CAAA;AZi0iBJ;AY/ziBI;E+EmHA;I/ElHE,qBAAA;EZk0iBJ;AACF;;A2F5siBE;EACE,8DAAA;A3F+siBJ;A2F7siBI;EAHF;IAII,eAAA;E3FgtiBJ;AACF;;A2F7siBE;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;A3FgtiBJ;;A2F7siBE;EACE,kBAAA;EACA,mCAAA;A3FgtiBJ;;A2F7siBE;EACE,YAAA;EACA,cAAA;A3FgtiBJ;;A2F7siBE;EACE,iBAAA;A3FgtiBJ;;A2F7siBE;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,UAAA;EACA,qBAAA;EACA,UAAA;A3FgtiBJ;;A2F7siBE;;EAEE,uBAAA;UAAA,mBAAA;EACA,wBAAA;EACA,0BAAA;A3FgtiBJ;;A2F7siBE;EACE,uBAAA;UAAA,sBAAA;A3FgtiBJ;;A2F7siBE;EACE,kBAAA;EACA,wCAAA;UAAA,qCAAA;A3FgtiBJ;;A2F7siBE;EACE,gBAAA;A3FgtiBJ;;A2F7siBE;EACE,UAAA;A3FgtiBJ;;A2F7siBE;EACE,aAAA;EACA,8BAAA;EACA,iBAAA;A3FgtiBJ;;A2F7siBE;E7EqpBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E6ElpBA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cjFVW;EiFUX,uCjFVW;EiFWX,cAAA;EACA,kBAAA;A3FktiBJ;;A2F/siBE;;EAEE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,ajF2BW;EiF3BX,sCjF2BW;EiF1BX,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,2CAAA;EACA,iEAAA;EACA,yBAAA;UAAA,iBAAA;A3FktiBJ;A2FhtiBI;EAjBF;;IAkBI,gBAAA;E3FotiBJ;AACF;A2FltiBI;;EACE,yBvFnNQ;EuFmNR,wCvFnNQ;AJw6iBd;;A2FjtiBE;;EAEE,mBAAA;EACA,4BjFsBY;EiFtBZ,sDjFsBY;AV8riBhB;;A2FjtiBE;;EAEE,4BjFiBY;EiFjBZ,sDjFiBY;AVmsiBhB;;A2FjtiBE;E7EomBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E6EjmBA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A3FstiBJ;;A2FntiBE;EACE,8BAAA;A3FstiBJ;A2FptiBI;EACE,yBvFhPQ;EuFgPR,wCvFhPQ;AJs8iBd;;A2FltiBE;EACE,kBAAA;EACA,oBAAA;A3FqtiBJ;A2FntiBI;EACE,2CjFnPa;EiFmPb,wEjFnPa;AVw8iBnB;;A2FjtiBE;EACE,qBAAA;EACA,gBxE3QS;EwE4QT,YAAA;EACA,SAAA;EAEA,0BAAA,EAAA,YAAA;EACA,yBjF3JO;EiF2JP,8CjF3JO;EiF4JP,cjFvFW;EiFuFX,uCjFvFW;EiFwFX,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A3FmtiBJ;A2FjtiBI;EAEE,SAAA,EAAA,uEAAA;EAEA,wBAAA;A3FitiBN;A2F9siBI;E/E/RA,uCAAA;EAAA,4CAAA;AZg/iBJ;AY9+iBI;E+E6RA;I/E5RE,qBAAA;EZi/iBJ;AACF;A2FltiBI;EAEE,yBjFvQK;EiFuQL,8CjFvQK;EiFwQL,6BjFpFU;EiFoFV,uDjFpFU;EiFqFV,oBAAA;A3FmtiBN;;A2F/siBE;EACE,uBAAA;UAAA,mBAAA;EACA,0BAAA;A3FktiBJ;A2FhtiBI;EACE,2CAAA;UAAA,uCAAA;EAAA,oEAAA;UAAA,gEAAA;A3FktiBN;;A2F9siBE;EACE,4BAAA;A3FitiBJ;A2F/siBI;EACE,4CAAA;UAAA,yCAAA;EAAA,qEAAA;UAAA,kEAAA;A3FitiBN;;A2F7siBE;;EAEE,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,0BAAA;EACA,gBAAA;EACA,UAAA;A3FgtiBJ;A2F9siBI;;EACE,kBAAA;EACA,cAAA;EACA,6CAAA;UAAA,4CAAA;EACA,+CAAA;UAAA,8CAAA;EACA,WAAA;EACA,sBAAA;A3FitiBN;A2F9siBI;;EACE,4CzEYW;EyEZX,0DzEYW;EyEXX,8CzEWW;EyEXX,4DzEWW;AlBssiBjB;A2F9siBI;;EACE,4CjFnKe;EiFmKf,8DjFnKe;EiFoKf,8CjFpKe;EiFoKf,gEjFpKe;AVq3iBrB;;A2F7siBE;EACE,8CjF3IY;EiF2IZ,wEjF3IY;AV21iBhB;;A2F7siBE;EACE,gDjF/IY;EiF+IZ,0EjF/IY;AV+1iBhB;;A2F7siBE;;EAEE,UAAA;A3FgtiBJ;;A2F7siBE;;EAEE,UAAA;A3FgtiBJ;;A2F7siBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;A3FgtiBJ;;A2F7siBE;EACE,aAAA;EACA,iBAAA;A3FgtiBJ;;A2F7siBE;E7EydE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E6EtdA,SAAA;EACA,cjFnMW;EiFmMX,uCjFnMW;EiFoMX,eAAA;A3FktiBJ;;A2F/siBE;EACE,UAAA;A3FktiBJ;;A2F/siBE;EACE,+GACE;A3FitiBN;;A2F7siBE;;EAEE,mCAAA;A3FgtiBJ;;A2F7siBE;EACE,8GACE;A3F+siBN;;A2F3siBE;EACE,gHACE;EAEF,kCAAA;A3F4siBJ;;A2FzsiBE;EACE,mHACE;A3F2siBN;;A2FvsiBE;E7E+aE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E6E5aA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cjFhPW;EiFgPX,uCjFhPW;EiFiPX,eAAA;EACA,mBAAA;EACA,oDAAA;A3F4siBJ;A2F1siBI;EACE,mBvFpaQ;EuFoaR,kCvFpaQ;AJgnjBd;A2FzsiBI;E/EtaA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZknjBJ;AYhnjBI;E+EmaA;I/ElaE,qBAAA;EZmnjBJ;AACF;A2FltiBI;EAGE,mCzExFW;EyEwFX,iDzExFW;AlB0yiBjB;;A2F9siBE;;EAEE,cjFzPU;EiFyPV,sCjFzPU;AV08iBd;;A2F9siBE;EACE,kBAAA;EACA,2BjF5OW;EiF4OX,uCjF5OW;EiF6OX,gBAAA;A3FitiBJ;A2F/siBI;EACE,kBAAA;EACA,cAAA;EACA,sCjFlPS;EiFkPT,kDjFlPS;EiFmPT,mBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,uBAAA;EACA,2BAAA;A3FitiBN;;A2F7siBE;EACE,YAAA;A3FgtiBJ;;A2F7siBE;E/ExcE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZypjBJ;AYvpjBI;E+EqcF;I/EpcI,qBAAA;EZ0pjBJ;AACF;A2FptiBI;EACE,aAAA;A3FstiBN;;A2FltiBE;EACE,yBjF2MQ;EiF3MR,+CjF2MQ;EiF1MR,cjFrSW;EiFqSX,uCjFrSW;AV0/iBf;;A2FltiBE;EACE,sCzErIa;EyEqIb,oDzErIa;EyEsIb,cjFxRY;EiFwRZ,wCjFxRY;AV6+iBhB;AqB5rjBE;EsEqeA;ItEneI,gBAAA;IACA,4BAAA;IsEseA,qBAAA;E3FytiBJ;AACF;A2FvtiBI;EACE,gCAAA;EAAA,qDAAA;EACA,0BAAA;A3FytiBN;;A2FrtiBE;EACE,UAAA;EACA,gBAAA;A3FwtiBJ;;A2FrtiBE;;E/EveE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZisjBJ;AY/rjBI;E+EoeF;;I/EneI,qBAAA;EZmsjBJ;AACF;A2FjuiBE;;EAIE,UAAA;EACA,mBjF3dO;EiF2dP,wCjF3dO;AV4rjBX;;A2F9tiBE;E/E/eE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZitjBJ;AY/sjBI;E+E4eF;I/E3eI,qBAAA;EZktjBJ;AACF;A2FxuiBE;EAGE,mBjFjeO;EiFieP,wCjFjeO;EiFkeP,cjFtUW;EiFsUX,uCjFtUW;AV8ijBf;;A2FruiBE;EACE,gCzEtKa;EyEsKb,8CzEtKa;EyEuKb,cjFzTY;EiFyTZ,wCjFzTY;AViijBhB;;A2FruiBE;EACE,6BjFvTY;EiFuTZ,uDjFvTY;EiFwTZ,mBAAA;A3FwuiBJ;A2FtuiBI;EACE,6BAAA;A3FwuiBN;;A2FpuiBE;EACE,eAAA;A3FuuiBJ;;AqB5vjBE;EsEwhBA;;IAGI,gBAAA;E3FuuiBJ;AACF;;A4FpvjBE;EACE,aAAA;A5FuvjBJ;;A4FnvjBE;EACE,mBlFyGO;EkFzGP,wClFyGO;AV6ojBX;;A4FnvjBE;EACE,QAAA;A5FsvjBJ;;A4FnvjBE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;A5FsvjBJ;;A4FnvjBE;EACE,aAAA;A5FsvjBJ;;A4FnvjBE;EACE,aAAA;EACA,mBAAA;A5FsvjBJ;;A4FnvjBE;EACE,kBAAA;A5FsvjBJ;;A4FnvjBE;;EAGE,mBAAA;A5FqvjBJ;;A4F9ujBI;;;;EAEE,mBAAA;A5FmvjBN;;A4F9ujBI;EACE,mBAAA;A5FivjBN;;A4F7ujBE;EAEE,kBAAA;A5F+ujBJ;;A4F5ujBE;EAGE,clF+GW;EkF/GX,uClF+GW;AV8njBf;;A4F3ujBE;EnFlFA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATi0jBF;AS/zjBE;;;EAGE,mBAAA;ATi0jBJ;A4F1vjBE;E9EqwBE,0GAAA;EAAA,0IAAA;EAAA,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EF1yBA,8BAAA;EACA,oBAAA;EgFyCA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,yBxFnEI;EwFmEJ,kCxFnEI;EwFoEJ,kBAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,clFiGW;EkFjGX,uClFiGW;EkFhGX,oDAAA;A5F+vjBJ;A4F7vjBI;EhF/EA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ+0jBJ;AY70jBI;EgF4EA;IhF3EE,qBAAA;EZg1jBJ;AACF;A4FjwjBI;EACE,yBxF/EE;EwF+EF,kCxF/EE;EwFgFF,2CAAA;UAAA,uCAAA;EACA,6BlF8GU;EkF9GV,uDlF8GU;EkF7GV,mBAAA;A5FmwjBN;A4FhwjBI;EACE,6BlFyGU;EkFzGV,uDlFyGU;AVypjBhB;A4F/vjBI;EACE,2CAAA;UAAA,uCAAA;A5FiwjBN;A4F9vjBI;ExDlHF,4B1BkMiB;E0BlMjB,yD1BkMiB;E0BjMjB,UAAA;ApCm3jBF;;A4F5vjBE;EACE,gBAAA;A5F+vjBJ;;A4F5vjBE;EACE,gBAAA;A5F+vjBJ;;A4F5vjBE;EACE,kBAAA;EACA,UAAA;EACA,alF4GW;EkF5GX,sClF4GW;EkF1GX,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;A5F8vjBJ;;A4F3vjBE;;EAEE,YAAA;A5F8vjBJ;;A4F3vjBE;EACE,alFyHc;EkFzHd,yClFyHc;AVqojBlB;;A4F1vjBE;EACE,avDzJQ;EuD0JR,UAAA;A5F6vjBJ;;A4F1vjBE;EACE,alFyGY;EkFzGZ,uClFyGY;AVopjBhB;;A4F1vjBE;EACE,yBzE1HS;UyE0HT,wBzE1HS;AnBu3jBb;;A4F1vjBE;EACE,mBAAA;EACA,4BlF0FY;EkF1FZ,sDlF0FY;AVmqjBhB;;A4F1vjBE;EAEE,6BAAA;UAAA,4BAAA;A5F4vjBJ;;A4FzvjBE;;EAEE,uBAAA;A5F4vjBJ;;A4FxvjBE;;;EAKE,kBAAA;EACA,sBAAA;EACA,wBzEzJS;EyE0JT,2BAAA;A5FyvjBJ;;A4FtvjBE;EAKE,gBAAA;A5FqvjBJ;;A4FlvjBE;;;E/DtLA,uHAAA;EAAA,4KAAA;EAQA,+BnB8iBiB;EmB9iBjB,4DnB8iBiB;EkF5Wf,yBzE/KS;UyE+KT,wBzE/KS;AnBq5jBb;;A4FlujBE;EACE,uBAAA;EACA,+BxFvMY;EwFuMZ,gDxFvMY;EwFwMZ,YAAA;A5FqujBJ;;A4FlujBE;EACE,4BlF0BY;EkF1BZ,sDlF0BY;AV2sjBhB;;A4FjujBE;;ExErOA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB28jBF;AoBz8jBE;;;;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB48jBJ;AoBz8jBE;;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB48jBJ;AoB18jBI;EAVF;;IAWI,eAAA;EpB88jBJ;AACF;AqB7+jBE;EuEyOA;;IxErME,sBAAA;EpB88jBF;EoB58jBE;;IACE,kBAAA;IACA,yBAAA;EpB+8jBJ;AACF;A4F/wjBE;;EAIE,iBAAA;A5F+wjBJ;A4F7wjBI;;EACE,kBAAA;A5FgxjBN;;A4F5wjBE;ExEhPA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBggkBF;AoB9/jBE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB8/jBJ;AoB3/jBE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB6/jBJ;AoB3/jBI;EAVF;IAWI,eAAA;EpB8/jBJ;AACF;AqB7hkBE;EuEoPA;IxEhNE,sBAAA;EpB6/jBF;EoB3/jBE;IACE,kBAAA;IACA,yBAAA;EpB6/jBJ;AACF;A4FlzjBE;EAGE,oBAAA;EACA,sBAAA;A5FkzjBJ;;A6F3xiBA;EAEE,aAAA;EACA,uDAAA;EACA,iBAAA;A7F6xiBF;A6F1xiBI;;EAEE,gBAAA;EACA,uBAAA;A7F4xiBN;A6F1xiBI;EACE,0BAAA;UAAA,yBAAA;A7F4xiBN;;A6FrxiBI;EACE,oBAAA;EACA,gBAAA;EACA,4BAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;A7FwxiBN;;A6FrikBE;;E3FaA,uOAAA;AF6hkBF;;A6FrikBE;;E3FQA,0PAAA;AFkikBF;;A+BnkkBE;EACE,eAAA;A/BskkBJ;A+BnkkBE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/BokkBJ;A+BjkkBE;EACE,0GAhBiB;A/BmlkBrB;A+BhkkBE;ECiEA,gBAAA;AhCkgkBF;A6FtjkBE;E/E+yBE,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;EZ5yBF,0PAAA;E2FEE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,cnF+IW;EmF/IX,uCnF+IW;EmF9IX,iBAAA;EACA,oBAAA;EAAA,gDAAA;EACA,mDAAA;EACA,kBAAA;A7FyjkBJ;A6FvjkBI;E3FXF,0PAAA;AFqkkBF;A6FtjkBI;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,4BAAA;A7FwjkBN;A6FtjkBM;EACE,aAAA;A7FwjkBR;A6FpjkBI;EACE,mBzF1DE;EyF0DF,4BzF1DE;EyF2DF,gCAAA;EAAA,iDAAA;EACA,mBAAA;EACA,oBAAA;A7FsjkBN;A4BhikBM;EiE1BF;IAOI,mBAAA;E7FujkBN;AACF;A6FrjkBM;EACE,sBAAA;EACA,sBAAA;EACA,iBAAA;A7FujkBR;A6FpjkBM;EACE,kBAAA;EACA,4DAAA;EAAA,qEAAA;EACA,gB1E7CK;E0E8CL,kBAAA;EACA,eAAA;EACA,oBAAA;A7FsjkBR;A6FnjkBM;EACE,kBAAA;EACA,yDAAA;EAAA,kEAAA;EACA,gB1EtDK;E0EuDL,oBAAA;EACA,eAAA;EACA,oBAAA;A7FqjkBR;A6FjjkBI;EpF1GF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT8pkBF;AS5pkBE;;;EAGE,mBAAA;AT8pkBJ;A6F/jkBI;EAGE,aAAA;A7F+jkBN;A6FzjkBI;ElFhHF,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATurkBF;ASrrkBE;;;EAGE,mBAAA;ATurkBJ;AWjrkBE;EACE,SAAA;AXmrkBJ;A6FllkBI;EAGE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBnF/GO;EmF+GP,gDnF/GO;EmFgHP,mB1ExFO;AnB0qkBb;A6FhlkBM;EjF3GF,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ8rkBJ;AY5rkBI;EiFwGE;IjFvGA,qBAAA;EZ+rkBJ;AACF;A6FrlkBM;EACE,2CnF3GW;EmF2GX,wEnF3GW;AVkskBnB;A6FplkBM;EACE,0CnFxHY;EmFwHZ,wEnFxHY;AV8skBpB;A6FllkBI;EACE,aAAA;A7FolkBN;A6FjlkBI;EACE,SAAA;EACA,yBzF5HS;EyF4HT,yCzF5HS;EyF6HT,iB1EzGO;AnB4rkBb;A6FjlkBM;EACE,yBzF/Ha;EyF+Hb,+CzF/Ha;AJktkBrB;A6FhlkBM;EACE,yBzFlIc;EyFkId,gDzFlIc;AJotkBtB;A6F9kkBI;EACE,UAAA;EACA,anFoFS;EmFpFT,sCnFoFS;AV4/jBf;A6F9kkBM;EAEE,anFgFO;EmFhFP,sCnFgFO;AV+/jBf;A6F3kkBI;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;A7F6kkBN;A6F1kkBI;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mB1EvKO;E0EwKP,2BAAA;A7F4kkBN;A6FxkkBM;EACE,sEAAA;EAAA,6FAAA;A7F0kkBR;A6FpkkBM;EACE,qEAAA;EAAA,4FAAA;A7FskkBR;A6F9jkBI;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;A7FgkkBN;A6F7jkBI;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,mB1ExMO;E0EyMP,yBAAA;A7F+jkBN;A6F5jkBI;EACE,2EAAA;EAAA,oFAAA;A7F8jkBN;A6FvjkBI;EACE,4EAAA;EAAA,qFAAA;A7FyjkBN;A6FljkBI;EACE,2EAAA;EAAA,2FAAA;A7FojkBN;A6F7ikBI;EACE,4EAAA;EAAA,4FAAA;A7F+ikBN;A6FrikBI;EAEE;IACE,qEAAA;IAAA,mHAAA;E7FsikBN;E6F/hkBI;IACE,sEAAA;IAAA,oHAAA;E7FiikBN;E6F1hkBI;IAEE,qEAAA;IAAA,qGAAA;E7F2hkBN;E6FphkBI;IAEE,sEAAA;IAAA,sGAAA;E7FqhkBN;AACF;A6F3gkBI;EACE,aAAA;A7F6gkBN;A6F1gkBI;EAEE,kBAAA;EACA,4BAAA;A7F2gkBN;A+BzykBE;EACE,eAAA;A/B2ykBJ;A+BxykBE;EC8EA,gBAAA;ED3EE,2GAViB;EAWjB,kCAAA;EACA,mCAAA;EACA,kCAAA;A/ByykBJ;A+BtykBE;EACE,0GAhBiB;A/BwzkBrB;A+BrykBE;ECiEA,gBAAA;AhCuukBF;A6FrhkBI;EAGE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EACA,iEAAA;A7FqhkBN;A6FjhkBI;EACE,+BAAA;UAAA,8BAAA;A7FmhkBN;A6FhhkBI;EACE,yBzF3SS;EyF2ST,yCzF3SS;EyF6ST,oCAAA;EAAA,qDAAA;EACA,uBAAA;UAAA,sBAAA;A7FihkBN;A6F9gkBI;EACE,UAAA;EACA,yBnFpSK;EmFoSL,8CnFpSK;EmFqSL,gB1E3RO;E0E4RP,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,qCAAA;UAAA,oCAAA;EAAA,sDAAA;UAAA,qDAAA;EACA,mCAAA;EAAA,oDAAA;EACA,iBAAA;EACA,uBAAA;UAAA,sBAAA;A7FghkBN;A6F7gkBI;EAIE,wCAAA;A7F4gkBN;A6FzgkBI;EACE,8JACE;A7F0gkBR;A6FrgkBI;EACE,2B1E5TO;U0E4TP,0B1E5TO;AnBm0kBb;A6FpgkBI;EAEE,qCAAA;UAAA,oCAAA;A7FqgkBN;A6F9/jBI;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,yCAAA;UAAA,wCAAA;A7FggkBN;A6F7/jBI;EvFjXF,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EuF4WI,gBAAA;EACA,sBAAA;A7FsgkBN;A6FngkBI;EAEE,aAAA;A7FogkBN;A6FjgkBI;ElF7XF,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAGE,iBAAA;EFZF,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT44kBF;AS14kBE;;;EAGE,mBAAA;AT44kBJ;AWt4kBE;EACE,SAAA;AXw4kBJ;A6F1hkBI;EAGE,kBAAA;EACA,mBAAA;EACA,sB1EhYO;E0EiYP,uB1EjYO;E0EkYP,oBAAA;A7F0hkBN;A6FxhkBM;EACE,gBAAA;EACA,anFzMS;EmFyMT,wCnFzMS;EmF0MT,iBAAA;A7F0hkBR;A6FvhkBM;EACE,anF9JO;EmF8JP,sCnF9JO;AVurkBf;A6FthkBM;EACE,yBzFnYM;EyFmYN,wCzFnYM;AJ25kBd;A6FrhkBM;EjFrYF,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZ65kBJ;AY35kBI;EiFkYE;IjFjYA,qBAAA;EZ85kBJ;AACF;A6FxhkBI;EAIE,anF/KS;EmF+KT,sCnF/KS;AVsskBf;A6FnhkBM;EACE,anFpLO;EmFoLP,sCnFpLO;AVyskBf;A6FjhkBI;;;EAKE,yBAAA;EACA,mBAAA;A7FihkBN;A6F/gkBM;;;EAGE,4BnFpLQ;EmFoLR,sDnFpLQ;AVqskBhB;A6F9gkBM;;;;;EjF3YF,8BAAA;EACA,oBAAA;AZg6kBJ;A6FhhkBI;EACE,aAAA;EACA,mBAAA;EACA,6B1EvbO;U0EubP,4B1EvbO;AnBy8kBb;A6F/gkBI;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;UAAA,wBAAA;EACA,2B1E9bO;U0E8bP,0B1E9bO;AnB+8kBb;A6F9gkBI;EACE,qEAAA;UAAA,oEAAA;A7FghkBN;A6F1gkBI;ElF/cF,qBAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;UAAA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EFTA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATs+kBF;ASp+kBE;;;EAGE,mBAAA;ATs+kBJ;AWh+kBE;EACE,SAAA;AXk+kBJ;A6FlikBI;EjFraA,8BAAA;EACA,oBAAA;EEyyBA,mBAAA;EAAA,yDAAA;EAAA,gBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA,4DAAA;EAAA,sBAAA;EAAA,iEAAA;E+EhYE,gBAAA;EACA,uCCrdgB;UDqdhB,mCCrdgB;EDqdhB,wDCrdgB;UDqdhB,oDCrdgB;EDsdhB,cnFvRW;EmFuRX,yCnFvRW;EmFwRX,8DAAA;EACA,iBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qGACE;EAEF,mBAAA;A7FoikBN;A6FlikBM;EjFjdF,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZs/kBJ;AYp/kBI;EiF8cE;IjF7cA,qBAAA;EZu/kBJ;AACF;A6FrikBI;EAEE,uBAAA;UAAA,mBAAA;A7FsikBN;A6FnikBI;EAGE,oCAAA;A7FmikBN;A6FhikBI;E/EmWA,kBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,iDAAA;EAAA,oBAAA;EAAA,qDAAA;EAAA,sBAAA;EAAA,0DAAA;E+EhWE,oBAAA;A7FoikBN;A6FjikBI;EAEE,oBAAA;EAAA,mDAAA;A7FkikBN;A6F5hkBI;EAIE,mBAAA;A7F2hkBN;A6FxhkBI;EACE,6BAAA;UAAA,4BAAA;A7F0hkBN;A6FvhkBI;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,+CAAA;EACA,gDAAA;A7FwhkBN;A6FthkBM;EACE,cAAA;A7FwhkBR;A6FphkBI;EAIE,8B1E1hBO;U0E0hBP,2B1E1hBO;E0E2hBP,2B1E3hBO;U0E2hBP,0B1E3hBO;AnB8ilBb;A6F7gkBI;EAIE,uCCliBsB;UDkiBtB,mCCliBsB;EDkiBtB,wDCliBsB;UDkiBtB,oDCliBsB;EDmiBtB,cnF5WS;EmF4WT,uCnF5WS;AVw3kBf;A6FzgkBI;EAME,yBzF/hBe;EyF+hBf,+CzF/hBe;EyFgiBf,cnFtXS;EmFsXT,uCnFtXS;AV43kBf;A6FngkBI;EAME,yBzF7iBQ;EyF6iBR,wCzF7iBQ;EyF8iBR,mCAAA;EAAA,oDAAA;A7FggkBN;A6F1/jBI;EACE,oDAAA;UAAA,gDAAA;EAAA,sEAAA;UAAA,kEAAA;EACA,sDAAA;A7F4/jBN;A6Fz/jBI;EAGE,gBAAA;A7Fy/jBN;A6Ft/jBI;EAGE,gDAAA;EAAA,kEAAA;A7Fs/jBN;A6Fn/jBI;EAEE,mBAAA;EAEA,gDAAA;EAAA,kEAAA;A7Fm/jBN;A6Fh/jBI;;;;E/E0PA,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;E+ElPE,cnFtaS;EmFsaT,uCnFtaS;AVw5kBf;A6F/+jBI;EAKE,oCAAA;A7F6+jBN;A6F1+jBI;EAEE,yBzFpmBE;EyFomBF,kCzFpmBE;AJ+klBR;A6Fz+jBM;;;EAEE,gBAAA;A7F4+jBR;A6Fx+jBI;EAIE,yBnFnnBO;EmFmnBP,gDnFnnBO;AV0llBb;A6Fh+jBI;EACE,6BAAA;EACA,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,6BnFjbU;EmFibV,uDnFjbU;EmFkbV,aAAA;A7Fk+jBN;A6F/9jBI;EACE,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,6BnFvbU;EmFubV,uDnFvbU;EmFwbV,mBAAA;A7Fi+jBN;A6F99jBI;EAIE,yB3ExPY;E2EwPZ,qD3ExPY;AlBqtkBlB;A6F19jBI;EAIE,yBzF/oBE;EyF+oBF,kCzF/oBE;EyFgpBF,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;A7Fy9jBN;A6Ft9jBI;;EAEE,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;EACA,aAAA;EACA,oBAAA;A7Fw9jBN;A6Fr9jBI;EAGE,+BzFhpBU;EyFgpBV,gDzFhpBU;AJqmlBhB;A6Fl9jBI;EAGE,+BzFtpBU;EyFspBV,gDzFtpBU;AJwmlBhB;A6F/8jBI;;EAME,+BzF/pBU;EyF+pBV,gDzF/pBU;AJ4mlBhB;A6F18jBI;EAEE,0BAAA;UAAA,sBAAA;EACA,cnF5emB;EmF4enB,iDnF5emB;AVu7kBzB;;A6Fr8jBE;EACE,uDAAA;A7Fw8jBJ;A6Ft8jBI;EjFvrBA,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZgolBJ;AY9nlBI;EiForBA;IjFnrBE,qBAAA;EZiolBJ;AACF;;A6F18jBE;EACE,mBzFjsBI;EyFisBJ,4BzFjsBI;AJ8olBR;;A2BxplBE;;;;;;;;;;;;;EAkBE,yBjBoGO;EiBpGP,8CjBoGO;AVkjlBX;A2BlplBE;EACE,yBjBQO;EiBRP,8CjBQO;AV4olBX;A2BjplBE;EACE,yBjB+Ba;EiB/Bb,oDjB+Ba;AVonlBjB;A2BhplBE;EACE,yBjB8BgB;EiB9BhB,uDjB8BgB;AVonlBpB;A2B/olBE;EACE,yBjB6BsB;EiB7BtB,6DjB6BsB;AVonlB1B;A2B9olBE;;EAIE,yBvBrBU;EuBqBV,wCvBrBU;AJmqlBd;A2B3olBE;;EAIE,oDAAA;UAAA,mDAAA;EAAA,yDAAA;UAAA,wDAAA;A3B2olBJ;A6F9+jBE;EAGE,iBAAA;EACA,gBAAA;A7F8+jBJ;A4BnmlBM;EiEinBJ;IAOI,iBAAA;E7F++jBJ;AACF;;A6Fz+jBE;EACE,eAAA;EACA,oBAAA;A7F4+jBJ;;A6Fz+jBE;EAEE,uCAAA;UAAA,mCAAA;EAAA,oEAAA;UAAA,gEAAA;A7F2+jBJ;;A6Fx+jBE;EACE,aAAA;EACA,mBAAA;EACA,yDAAA;EACA,gBAAA;EACA,kBAAA;A7F2+jBJ;;A6Fx+jBE;EzE5uBA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApBwtlBF;AoBttlBE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApBstlBJ;AoBntlBE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApBqtlBJ;AoBntlBI;EAVF;IAWI,eAAA;EpBstlBJ;AACF;AqBrvlBE;EwEgvBA;IzE5sBE,sBAAA;EpBqtlBF;EoBntlBE;IACE,kBAAA;IACA,yBAAA;EpBqtlBJ;AACF;A6F9gkBE;EAGE,cAAA;EACA,oBAAA;EACA,iBAAA;A7F8gkBJ;;AqBnwlBE;EwEyvBA;;;;IAOI,8BAAA;E7F2gkBJ;AACF;;AqB5wlBE;EwEowBA;IxEzvBI,eAAA;IACA,cAAA;ErBswlBJ;AACF;;A+F3wlBE;;ECaA,yBAAA;AhGmwlBF;AgGhwlBE;;EACE,yBAAA;AhGmwlBJ;;A+FhxlBE;EnFIE,uCAAA;EAAA,4CAAA;EACA,oBAAA;AZgxlBJ;AY9wlBI;EmFPF;InFQI,qBAAA;EZixlBJ;AACF;;A+FtxlBE;EtFlBA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;AT4ylBF;AS1ylBE;;;EAGE,mBAAA;AT4ylBJ;A+FrylBE;EAGE,cAAA;EAEA,qCAAA;EAAA,8CAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;A/FoylBJ;A+FjylBI;ECfF,eAAA;AhGmzlBF;A+F9xlBI;;EAIE,2BAAA;UAAA,0BAAA;A/F8xlBN;A+FxxlBI;EAYE,sBAAA;A/F+wlBN;;A+F3wlBE;EACE,kBAAA;EACA,wCAAA;UAAA,qCAAA;EAAA,yDAAA;UAAA,sDAAA;EACA,kEAAA;A/F8wlBJ;;A+F1wlBE;EAEE,uCAAA;UAAA,mCAAA;EAAA,wDAAA;UAAA,oDAAA;A/F4wlBJ;;A+FzwlBE;EACE,YAAA;A/F4wlBJ;;A+FzwlBE;EAIE,qB3FjEU;E2FiEV,oC3FjEU;E2FkEV,yB3FlEU;E2FkEV,wC3FlEU;E2FmEV,eAAA;A/FywlBJ;;A+FtwlBE;EAKE,qB3F3EU;E2F2EV,oC3F3EU;AJg1lBd;;A+FlwlBE;EAEE,qB3F/Ea;E2F+Eb,uC3F/Ea;E2FgFb,yB3FhFa;E2FgFb,2C3FhFa;AJo1lBjB;;A+FjwlBE;EAGE,qB3FtFa;E2FsFb,uC3FtFa;AJw1lBjB;;A+F/vlBE;EAGE,crFiFW;EqFjFX,uCrFiFW;AV+qlBf;;A+F7vlBE;EACE,eAAA;A/FgwlBJ;;A+F7vlBE;;EAQE,crFkEW;EqFlEX,uCrFkEW;AVwrlBf;;A+FvvlBE;EACE,2BAAA;EACA,sBAAA;A/F0vlBJ;;A+FvvlBE;EtFrIA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATg4lBF;AS93lBE;;;EAGE,mBAAA;ATg4lBJ;A+FtwlBE;ECjGA,kCAAA;ElFmzBE,mBAAA;EAAA,4DAAA;EAAA,gBAAA;EAAA,2DAAA;EAAA,oBAAA;EAAA,+DAAA;EAAA,sBAAA;EAAA,oEAAA;EiF7sBA,mBAAA;EACA,kBAAA;EACA,crFmDW;EqFnDX,uCrFmDW;EqFlDX,gBAAA;EACA,iBAAA;EACA,oBCvI6B;EDwI7B,mBAAA;A/FywlBJ;;A+FtwlBE;EACE,wBAAA;EACA,sBAAA;A/FywlBJ;;A+FtwlBE;EtFxJA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;EACA,oBAAA;EACA,eAAA;EACA,wBAAA;ATk6lBF;ASh6lBE;;;EAGE,mBAAA;ATk6lBJ;A+FrxlBE;EjF+rBE,mBAAA;EAAA,iDAAA;EAAA,gBAAA;EAAA,gDAAA;EAAA,oBAAA;EAAA,oDAAA;EAAA,sBAAA;EAAA,yDAAA;EkF3yBF,kCAAA;EDiHE,kBAAA;EACA,mBAAA;EACA,crFmCa;EqFnCb,yCrFmCa;EqFlCb,sBAAA;EAEA,uDAAA;A/FuxlBJ;;A+FnxlBE;EACE,mBAAA;A/FsxlBJ;;A+FnxlBE;EACE,eAAA;A/FsxlBJ;;A+FnxlBE;EACE,qBAAA;EACA,+B5EhLS;U4EgLT,4B5EhLS;E4EiLT,qDAAA;EACA,mBAAA;A/FsxlBJ;;A+FnxlBE;;EAME,arFuDW;EqFvDX,sCrFuDW;AV2tlBf;;A+F1wlBI;EACE,iBAAA;A/F6wlBN;;A+F3wlBI;EAEE,iB5E1KO;E4E2KP,wBAAA;UAAA,uBAAA;A/F6wlBN;;A+F5vlBM;EACE,eAAA;A/F+vlBR;A+F5vlBM;EACE,gBAAA;A/F8vlBR;A+F3vlBM;EACE,gBAAA;A/F6vlBR;A+FzvlBI;E3EjOF,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBV6rBoB;EU7rBpB,mDV6rBoB;EU5rBpB,gBAAA;EACA,oBAAA;ApB69lBF;AoB39lBE;EAGE,YAAA;EACA,eAAA;EACA,aAAA;ApB29lBJ;AoBx9lBE;EACE,kBAAA;EACA,oDAAA;EACA,mBVirBe;EUjrBf,gDVirBe;EUhrBf,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,iDAAA;ApB09lBJ;AoBx9lBI;EAVF;IAWI,eAAA;EpB29lBJ;AACF;AqB1/lBE;E0EqOE;I3EjMA,sBAAA;EpB09lBF;EoBx9lBE;IACE,kBAAA;IACA,yBAAA;EpB09lBJ;AACF;A+F9xlBI;EAGE,cAAA;EACA,gBAAA;EAEA,gBAAA;A/F6xlBN;;A+FzxlBE;EAEE,eAAA;A/F2xlBJ;A+FzxlBI;EACE,aAAA;A/F2xlBN;;A+FvxlBE;EACE,+B5E3PS;U4E2PT,4B5E3PS;E4E4PT,mBAAA;A/F0xlBJ;;A+FvxlBE;EAIE,iB5ErOS;E4EsOT,sBAAA;UAAA,qBAAA;A/FuxlBJ;;AAp/lBA;;;;;EAKE,mBAAA;EAAA,uDAAA;AAu/lBF;;AAp/lBA;;;;;EAKE,mBAAA;AAu/lBF;;AAp/lBA;EACE,cAAA;EAAA,8BAAA;AAu/lBF;;AAp/lBA;;EAEE,6BAAA;EAAA,+BAAA;AAu/lBF;;AAp/lBA;;EAEE,cAAA;EAAA,8BAAA;AAu/lBF;;AAp/lBA;;EAEE,aAAA;EAAA,6BAAA;AAu/lBF;;AAn/lBA;EACE,qBAAA;AAs/lBF;;AAl/lBA;;EAEE,aAAA;AAq/lBF;;AAj/lBA;EACE,yBAAA;EAAA,sDAAA;EACA,cAAA;EAAA,wCAAA;AAo/lBF;;AAl/lBA;;;EAGE,YAAA;EACA,iBAAA;EACA,gBAAA;AAq/lBF;;AAj/lBA;EiGOI,yCAAA;EAAA,uCAAA;EAAA,+CAAA;EAAA,mDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,oDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,oDAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,2CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,yCAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,oCAAA;EAAA,gCAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,oCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,2BAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,0BAAA;EAAA,qCAAA;EAAA,yBAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,2CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,6CAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,iCAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,oCAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,wCAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,4FAAA;EAAA,0CAAA;EAAA,gDAAA;EAAA,wCAAA;ECpGF,mBAAA;EAAA,4CAAA;AlGsonBF;AkG9nnBE;ElGqFF;IExDE,8BAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,sCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,4BAAA;IAAA,kCAAA;IAAA,8BAAA;IAAA,oCAAA;IAAA,0CAAA;IAAA,4CAAA;IAAA,+BAAA;IAAA,uCAAA;IAAA,6CAAA;IAAA,sCAAA;IAAA,0CAAA;EFwnnBA;AACF;AAjknBA;EExDE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;EF4DA,uCAAA;EACA,0CAAA;EACA,gFAAA;EACA,iFAAA;EACA,2CAAA;EACA,iDAAA;EACA,kFAAA;EACA,iCAAA;EACA,8CAAA;EACA,wCAAA;EACA,8EAAA;AA+knBF;;AA3knBA;;EiGXI,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kDAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,4BAAA;EAAA,gDAAA;EAAA,+BAAA;EAAA,yCAAA;EAAA,+CAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,iDAAA;EAAA,yDAAA;EAAA,sCAAA;EAAA,qDAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA,8DAAA;EAAA,yBAAA;EAAA,iDAAA;EAAA,+BAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,uCAAA;EAAA,oDAAA;EAAA,0DAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,qCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,0BAAA;EAAA,kDAAA;EAAA,kDAAA;EAAA,qDAAA;EAAA,qCAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,+BAAA;EAAA,qCAAA;EAAA,iDAAA;EAAA,uCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,wBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,oBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,8CAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,2BAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,yCAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,oCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,gCAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,uCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,gCAAA;EAAA,kCAAA;EAAA,0BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,oCAAA;EAAA,gCAAA;EAAA,0BAAA;EAAA,8BAAA;EAAA,oCAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,8BAAA;EAAA,sCAAA;EAAA,2BAAA;EAAA,4CAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,0BAAA;EAAA,qCAAA;EAAA,yBAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,8CAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,uDAAA;EAAA,gDAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,yBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,uCAAA;EAAA,oCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,yCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,wHAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,uCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,+CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,kDAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,4CAAA;EAAA,gDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,4CAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,0HAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,0HAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,yCAAA;EAAA,sCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,qCAAA;EAAA,sCAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,4CAAA;EAAA,yCAAA;EAAA,6CAAA;EAAA,+CAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,iCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,gCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,oCAAA;EAAA,iCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,uCAAA;EAAA,2CAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,sCAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,2CAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,2CAAA;EAAA,yCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,gIAAA;EAAA,wCAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,0CAAA;EAAA,uCAAA;EAAA,wCAAA;EAAA,wCAAA;EAAA,+BAAA;EAAA,6BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,mCAAA;EAAA,oCAAA;EAAA,sCAAA;EAAA,qCAAA;EAAA,kCAAA;EAAA,mCAAA;EAAA,qCAAA;EAAA,oCAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,4BAAA;EAAA,4BAAA;EAAA,qCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,oCAAA;EAAA,+BAAA;EAAA,+BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,mCAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,kCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,8BAAA;EAAA,+BAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,uCAAA;EAAA,kCAAA;EAAA,kCAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,4BAAA;EAAA,oCAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,0BAAA;EAAA,4CAAA;EAAA,8CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,yDAAA;EAAA,wDAAA;EAAA,0EAAA;EAAA,mDAAA;EAAA,kEAAA;EAAA,0DAAA;ECpGF,mBAAA;EAAA,4CAAA;AlGmvoBF;AkG3uoBE;ElGuGF;;IE1EE,8BAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,sCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,4BAAA;IAAA,kCAAA;IAAA,8BAAA;IAAA,oCAAA;IAAA,0CAAA;IAAA,4CAAA;IAAA,+BAAA;IAAA,uCAAA;IAAA,6CAAA;IAAA,sCAAA;IAAA,0CAAA;EFsuoBA;AACF;AA7poBA;;EE1EE,yCAAA;EAAA,uDAAA;EAAA,+DAAA;EAAA,qDAAA;EAAA,2DAAA;EAAA,uEAAA;EAAA,uDAAA;EAAA,mEAAA;EAAA,qEAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA,2EAAA;EAAA,yDAAA;EAAA,qDAAA;EF+EA,yBAAA;EACA,uBAAA;EAGA,oBAAA;EACA,iCAAA;EACA,0BAAA;EACA,2BAAA;EACA,iEAAA;EACA,6BAAA;EACA,mCAAA;EACA,8BAAA;EACA,oCAAA;AAyqoBF;;AArqoBA;EACE;IiGjCE,mCAAA;IAAA,uCAAA;IAAA,yCAAA;IAAA,kDAAA;IAAA,4CAAA;IAAA,gDAAA;IAAA,4BAAA;IAAA,gDAAA;IAAA,+BAAA;IAAA,yCAAA;IAAA,+CAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,sCAAA;IAAA,iDAAA;IAAA,yDAAA;IAAA,sCAAA;IAAA,qDAAA;IAAA,qDAAA;IAAA,sDAAA;IAAA,8DAAA;IAAA,yBAAA;IAAA,iDAAA;IAAA,+BAAA;IAAA,iDAAA;IAAA,iCAAA;IAAA,uCAAA;IAAA,oDAAA;IAAA,0DAAA;IAAA,+CAAA;IAAA,iCAAA;IAAA,6BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,gCAAA;IAAA,8BAAA;IAAA,+BAAA;IAAA,gCAAA;IAAA,qCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,oCAAA;IAAA,0BAAA;IAAA,kDAAA;IAAA,kDAAA;IAAA,qDAAA;IAAA,qCAAA;IAAA,wCAAA;IAAA,qCAAA;IAAA,+BAAA;IAAA,qCAAA;IAAA,iDAAA;IAAA,uCAAA;IAAA,+BAAA;IAAA,oCAAA;IAAA,wBAAA;IAAA,uBAAA;IAAA,uBAAA;IAAA,uBAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,oBAAA;IAAA,0BAAA;IAAA,4BAAA;IAAA,wBAAA;IAAA,8CAAA;IAAA,+BAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,uDAAA;IAAA,2BAAA;IAAA,6BAAA;IAAA,0BAAA;IAAA,uBAAA;IAAA,uBAAA;IAAA,uBAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,qCAAA;IAAA,qCAAA;IAAA,qCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,gCAAA;IAAA,gCAAA;IAAA,gCAAA;IAAA,sCAAA;IAAA,sCAAA;IAAA,sCAAA;IAAA,sCAAA;IAAA,qCAAA;IAAA,2BAAA;IAAA,kCAAA;IAAA,iCAAA;IAAA,mCAAA;IAAA,2BAAA;IAAA,iCAAA;IAAA,6BAAA;IAAA,2BAAA;IAAA,iCAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,+BAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,wCAAA;IAAA,4BAAA;IAAA,oCAAA;IAAA,2BAAA;IAAA,mCAAA;IAAA,8BAAA;IAAA,sCAAA;IAAA,8BAAA;IAAA,sCAAA;IAAA,mCAAA;IAAA,gCAAA;IAAA,yCAAA;IAAA,0BAAA;IAAA,+BAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,sCAAA;IAAA,mCAAA;IAAA,0BAAA;IAAA,2BAAA;IAAA,6BAAA;IAAA,+BAAA;IAAA,gCAAA;IAAA,2BAAA;IAAA,6BAAA;IAAA,sCAAA;IAAA,8BAAA;IAAA,6BAAA;IAAA,uCAAA;IAAA,qCAAA;IAAA,sCAAA;IAAA,gCAAA;IAAA,wCAAA;IAAA,yCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,gCAAA;IAAA,mCAAA;IAAA,8BAAA;IAAA,4BAAA;IAAA,2BAAA;IAAA,8BAAA;IAAA,6BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,0BAAA;IAAA,0BAAA;IAAA,6BAAA;IAAA,2BAAA;IAAA,oCAAA;IAAA,gCAAA;IAAA,0BAAA;IAAA,8BAAA;IAAA,oCAAA;IAAA,+BAAA;IAAA,0BAAA;IAAA,+BAAA;IAAA,0BAAA;IAAA,4BAAA;IAAA,8BAAA;IAAA,sCAAA;IAAA,2BAAA;IAAA,4CAAA;IAAA,mCAAA;IAAA,iCAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,0BAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,yBAAA;IAAA,8BAAA;IAAA,0BAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,0BAAA;IAAA,qCAAA;IAAA,yBAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,8CAAA;IAAA,yBAAA;IAAA,0BAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,uDAAA;IAAA,gDAAA;IAAA,2BAAA;IAAA,6BAAA;IAAA,yBAAA;IAAA,0BAAA;IAAA,yBAAA;IAAA,wBAAA;IAAA,yBAAA;IAAA,sBAAA;IAAA,wBAAA;IAAA,sBAAA;IAAA,wBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,sBAAA;IAAA,uBAAA;IAAA,yBAAA;IAAA,2BAAA;IAAA,2BAAA;IAAA,4BAAA;IAAA,mCAAA;IAAA,iCAAA;IAAA,qCAAA;IAAA,uCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,qCAAA;IAAA,uCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,uCAAA;IAAA,yCAAA;IAAA,2CAAA;IAAA,wCAAA;IAAA,qCAAA;IAAA,yCAAA;IAAA,2CAAA;IAAA,uCAAA;IAAA,oCAAA;IAAA,wCAAA;IAAA,0CAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,sCAAA;IAAA,qCAAA;IAAA,sCAAA;IAAA,mCAAA;IAAA,uCAAA;IAAA,yCAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,wHAAA;IAAA,gCAAA;IAAA,8BAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,wHAAA;IAAA,iCAAA;IAAA,8BAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,qCAAA;IAAA,uCAAA;IAAA,gCAAA;IAAA,iCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,+CAAA;IAAA,4CAAA;IAAA,gDAAA;IAAA,kDAAA;IAAA,2CAAA;IAAA,4CAAA;IAAA,8CAAA;IAAA,6CAAA;IAAA,8CAAA;IAAA,4CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,8CAAA;IAAA,4CAAA;IAAA,gDAAA;IAAA,6CAAA;IAAA,2CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,6CAAA;IAAA,+CAAA;IAAA,4CAAA;IAAA,8CAAA;IAAA,6CAAA;IAAA,+CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,6CAAA;IAAA,+CAAA;IAAA,8CAAA;IAAA,gDAAA;IAAA,+CAAA;IAAA,+CAAA;IAAA,4CAAA;IAAA,gDAAA;IAAA,kDAAA;IAAA,2CAAA;IAAA,4CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,8CAAA;IAAA,4CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,8CAAA;IAAA,4CAAA;IAAA,gDAAA;IAAA,6CAAA;IAAA,2CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,6CAAA;IAAA,2CAAA;IAAA,4CAAA;IAAA,6CAAA;IAAA,6CAAA;IAAA,0HAAA;IAAA,qCAAA;IAAA,mCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,0HAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,iCAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,yCAAA;IAAA,sCAAA;IAAA,0CAAA;IAAA,4CAAA;IAAA,qCAAA;IAAA,sCAAA;IAAA,wCAAA;IAAA,uCAAA;IAAA,4CAAA;IAAA,yCAAA;IAAA,6CAAA;IAAA,+CAAA;IAAA,wCAAA;IAAA,yCAAA;IAAA,2CAAA;IAAA,0CAAA;IAAA,iCAAA;IAAA,8BAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,6BAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,+BAAA;IAAA,mCAAA;IAAA,iCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,iCAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,gCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,mCAAA;IAAA,kCAAA;IAAA,oCAAA;IAAA,iCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,yCAAA;IAAA,uCAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,yCAAA;IAAA,uCAAA;IAAA,2CAAA;IAAA,wCAAA;IAAA,sCAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,sCAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,0CAAA;IAAA,yCAAA;IAAA,2CAAA;IAAA,0CAAA;IAAA,gIAAA;IAAA,2CAAA;IAAA,yCAAA;IAAA,yCAAA;IAAA,0CAAA;IAAA,gIAAA;IAAA,wCAAA;IAAA,yCAAA;IAAA,0CAAA;IAAA,0CAAA;IAAA,0CAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,0CAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,0CAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,0CAAA;IAAA,uCAAA;IAAA,wCAAA;IAAA,wCAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,+BAAA;IAAA,8BAAA;IAAA,oCAAA;IAAA,sCAAA;IAAA,mCAAA;IAAA,oCAAA;IAAA,sCAAA;IAAA,qCAAA;IAAA,kCAAA;IAAA,mCAAA;IAAA,qCAAA;IAAA,oCAAA;IAAA,+CAAA;IAAA,iCAAA;IAAA,4BAAA;IAAA,4BAAA;IAAA,qCAAA;IAAA,gCAAA;IAAA,gCAAA;IAAA,oCAAA;IAAA,+BAAA;IAAA,+BAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,mCAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,6BAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,8BAAA;IAAA,+BAAA;IAAA,iCAAA;IAAA,gCAAA;IAAA,8BAAA;IAAA,mCAAA;IAAA,mCAAA;IAAA,uCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,uCAAA;IAAA,kCAAA;IAAA,kCAAA;IAAA,yBAAA;IAAA,4BAAA;IAAA,oCAAA;IAAA,4BAAA;IAAA,oCAAA;IAAA,2BAAA;IAAA,0BAAA;IAAA,4BAAA;IAAA,0BAAA;IAAA,4CAAA;IAAA,8CAAA;IAAA,2CAAA;IAAA,8CAAA;IAAA,uDAAA;IAAA,mDAAA;IAAA,0DAAA;IAAA,yDAAA;IAAA,wDAAA;IAAA,0EAAA;IAAA,mDAAA;IAAA,kEAAA;IAAA,0DAAA;ICpGF,mBAAA;IAAA,4CAAA;IhGqCA,yCAAA;IAAA,uDAAA;IAAA,+DAAA;IAAA,qDAAA;IAAA,2DAAA;IAAA,uEAAA;IAAA,uDAAA;IAAA,mEAAA;IAAA,qEAAA;IAAA,yCAAA;IAAA,qDAAA;IAAA,yDAAA;IAAA,2EAAA;IAAA,yDAAA;IAAA,qDAAA;IFmGE,yBAAA;IACA,uBAAA;IACA,oBAAA;IACA,iCAAA;IACA,0BAAA;IACA,2BAAA;IAEA,6BAAA;IACA,mCAAA;IACA,8BAAA;IACA,oCAAA;EA0upBF;;AAvvpBA;AAAA;IASE,iEAAA;EA8upBF;AAAA;AACF;AkGr3pBE;ElG6HA;IEhGA,8BAAA;IAAA,gCAAA;IAAA,kCAAA;IAAA,6BAAA;IAAA,sCAAA;IAAA,oCAAA;IAAA,qCAAA;IAAA,+BAAA;IAAA,6BAAA;IAAA,4BAAA;IAAA,kCAAA;IAAA,8BAAA;IAAA,oCAAA;IAAA,0CAAA;IAAA,4CAAA;IAAA,+BAAA;IAAA,uCAAA;IAAA,6CAAA;IAAA,sCAAA;IAAA,0CAAA;EF+2pBA;AACF;AA9vpBA;EACE,6BAAA;EACA,YAAA;EACA,gCAAA;EAAA,iDAAA;AAgwpBF;;AA5vpBA;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AA+vpBF;;AA3vpBA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,gCAAA;EAAA,iDAAA;EACA,gBAAA;EACA,iBAAA;AA8vpBF;AA5vpBE;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EAAA,gCAAA;EACA,qBAAA;EACA,0BAAA;EACA,gBAAA;EACA,WAAA;AA8vpBJ;;AAzvpBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;UAAA,yBAAA;EAEA,kBAAA;AA2vpBF;AAzvpBE;;EAEE,gBAAA;AA2vpBJ;AAxvpBE;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AA0vpBJ;AAvvpBE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;AAyvpBJ;AAtvpBE;EACE,YAAA;EACA,2BAAA;UAAA,0BAAA;EACA,2BAAA;UAAA,0BAAA;AAwvpBJ;AArvpBE;EACE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAuvpBJ;AApvpBE;EACE,cAAA;AAsvpBJ;AAnvpBE;EACE,cAAA;AAqvpBJ;AAlvpBE;EACE,uBAAA;AAovpBJ;AAjvpBE;EACE,2CAAA;EAAA,6CAAA;AAmvpBJ;AAhvpBE;EACE,6CAAA;EAAA,sDAAA;AAkvpBJ;;AA7upBA;EACE,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,2BAAA;EACA,sCAAA;EAAA,yCAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,0BAAA;AAgvpBF;AA9upBE;EACE,2BAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,qBAAA;AAgvpBJ;AA7upBE;EACE,uBAAA;EACA,wBAAA;EACA,2BAAA;AA+upBJ;;AAxupBA;EACE,8BAAA;AA2upBF;;AAvupBA;EACE,yBAAA;AA0upBF;;AAvupBA;;EAEE,yBAAA;AA0upBF;;AAtupBA;EACE,gBAAA;AAyupBF;;AArupBA;EACE,uCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;AAwupBF;;AArupBA;;EAEE,uCAAA;EACA,kCAAA;EACA,kCAAA;EACA,kCAAA;EACA,6BAAA;EACA,6BAAA;AAwupBF","sourcesContent":["@use '@carbon/react/scss/themes' as themes;\r\n@use '@carbon/react/scss/theme' as carbon-theme with (\r\n  $theme: themes.$white\r\n);\r\n@use '@carbon/react/scss/components/button';\r\n@use '@carbon/react/scss/components/tooltip';\r\n@use '@carbon/react/scss/components/toggletip';\r\n@use '@carbon/react/scss/components/toggle';\r\n@use '@carbon/react/scss/components/overflow-menu';\r\n@use '@carbon/react/scss/components/modal';\r\n@use '@carbon/react/scss/components/form';\r\n@use '@carbon/react/scss/components/stack';\r\n@use '@carbon/react/scss/components/checkbox';\r\n@use '@carbon/react/scss/components/text-input';\r\n@use '@carbon/react/scss/components/text-area';\r\n@use '@carbon/react/scss/components/list-box';\r\n@use '@carbon/react/scss/components/dropdown';\r\n@use '@carbon/react/scss/components/multiselect';\r\n@use '@carbon/react/scss/components/search';\r\n@use '@carbon/react/scss/components/combo-box';\r\n@use '@carbon/react/scss/components/select';\r\n@use '@carbon/react/scss/components/pagination';\r\n@use '@carbon/react/scss/components/radio-button';\r\n@use '@carbon/react/scss/components/number-input';\r\n@use '@carbon/react/scss/components/slider';\r\n@use '@carbon/react/scss/components/skeleton-styles';\r\n@use '@carbon/react/scss/components/data-table';\r\n@use '@carbon/react/scss/components/data-table/action';\r\n@use '@carbon/react/scss/components/icon-indicator';\r\n@use '@carbon/styles/scss/components/shape-indicator';\r\n@use '@carbon/react/scss/components/breadcrumb';\r\n@use '@carbon/react/scss/components/notification';\r\n@use '@carbon/react/scss/components/link';\r\n@use '@carbon/react/scss/components/tile';\r\n@use '@carbon/react/scss/components/tag';\r\n@use '@carbon/react/scss/components/loading';\r\n@use '@carbon/react/scss/components/code-snippet';\r\n@use '@carbon/react/scss/components/content-switcher';\r\n@use '@carbon/react/scss/components/progress-indicator';\r\n@use '@carbon/react/scss/components/copy-button';\r\n@use '@carbon/react/scss/components/menu';\r\n@use '@carbon/styles/scss/components/combo-button';\r\n@use '@carbon/styles/scss/components/menu-button';\r\n@use '@carbon/react/scss/components/ui-shell';\r\n@use '@carbon/react/scss/components/popover';\r\n@use '@carbon/react/scss/components/date-picker';\r\n@use '@carbon/react/scss/components/tabs';\r\n@use '@carbon/react/scss/components/structured-list';\r\n\r\n// ─── DatePicker calendar background ─────────────────────────────────────────\r\n.flatpickr-calendar,\r\n.flatpickr-months,\r\n.flatpickr-month,\r\n.flatpickr-weekdays,\r\n.flatpickr-weekday {\r\n  background: var(--cds-field, var(--cds-layer, #ffffff));\r\n}\r\n\r\n.dark .flatpickr-calendar,\r\n.dark .flatpickr-months,\r\n.dark .flatpickr-month,\r\n.dark .flatpickr-weekdays,\r\n.dark .flatpickr-weekday {\r\n  background: #393939;\r\n}\r\n\r\n.flatpickr-day {\r\n  color: var(--cds-text-primary);\r\n}\r\n\r\n.flatpickr-day.prevMonthDay,\r\n.flatpickr-day.nextMonthDay {\r\n  color: var(--cds-text-disabled);\r\n}\r\n\r\n.flatpickr-current-month .flatpickr-monthDropdown-months,\r\n.flatpickr-current-month input.cur-year {\r\n  color: var(--cds-text-primary);\r\n}\r\n\r\n.flatpickr-months .flatpickr-prev-month svg,\r\n.flatpickr-months .flatpickr-next-month svg {\r\n  fill: var(--cds-icon-primary);\r\n}\r\n\r\n// ─── Popover width override ─────────────────────────────────────────────────\r\n.cds--popover-content {\r\n  max-inline-size: none;\r\n}\r\n\r\n// ─── Tooltip / popover z-index ──────────────────────────────────────────────\r\n.cds--tooltip-content,\r\n.cds--popover {\r\n  z-index: 9999;\r\n}\r\n\r\n// ─── Batch action buttons ───────────────────────────────────────────────────\r\n.cds--batch-actions .cds--batch-summary__cancel {\r\n  background-color: var(--cds-button-secondary, #393939);\r\n  color: var(--cds-text-on-color, #ffffff);\r\n}\r\n.cds--batch-actions .cds--action-list .cds--btn,\r\n.cds--batch-actions .cds--action-list .cds--btn::before,\r\n.cds--batch-actions .cds--batch-summary__cancel::before {\r\n  border: none;\r\n  border-left: none;\r\n  box-shadow: none;\r\n}\r\n\r\n// ─── Light theme (default) — Carbon white ───────────────────────────────────\r\n:root {\r\n  @include carbon-theme.theme(themes.$white);\r\n\r\n  // Custom primary overrides\r\n  --cds-interactive: var(--color-primary);\r\n  --cds-button-primary: var(--color-primary);\r\n  --cds-button-primary-hover: color-mix(in oklab, var(--color-primary) 85%, black);\r\n  --cds-button-primary-active: color-mix(in oklab, var(--color-primary) 70%, black);\r\n  --cds-button-tertiary: var(--color-primary);\r\n  --cds-button-tertiary-hover: var(--color-primary);\r\n  --cds-button-tertiary-active: color-mix(in oklab, var(--color-primary) 70%, black);\r\n  --cds-focus: var(--color-primary);\r\n  --cds-border-interactive: var(--color-primary);\r\n  --cds-link-primary: var(--color-primary);\r\n  --cds-link-primary-hover: color-mix(in oklab, var(--color-primary) 80%, black);\r\n}\r\n\r\n// ─── Dark theme — Carbon g100 ───────────────────────────────────────────────\r\n:is(.dark *),\r\n:root:is(.dark) {\r\n  @include carbon-theme.theme(themes.$g100);\r\n\r\n  // Background — use page bg color, not transparent\r\n  --cds-background: #0a0a0a;\r\n  --cds-layer-01: #161616;\r\n\r\n  // Focus / interactive — use primary instead of g100 default white\r\n  --cds-focus: #4589ff;\r\n  --cds-border-interactive: #4589ff;\r\n  --cds-interactive: #4589ff;\r\n  --cds-link-primary: #4589ff;\r\n  --cds-link-primary-hover: color-mix(in oklab, #4589ff 80%, white);\r\n  --cds-button-primary: #0f62fe;\r\n  --cds-button-primary-hover: #0353e9;\r\n  --cds-button-tertiary: #4589ff;\r\n  --cds-button-tertiary-hover: #4589ff;\r\n}\r\n\r\n// ─── System preference dark (when no .dark class) ────────────────────────────\r\n@media (prefers-color-scheme: dark) {\r\n  :root:not(.light) {\r\n    @include carbon-theme.theme(themes.$g100);\r\n\r\n    --cds-background: #0a0a0a;\r\n    --cds-layer-01: #161616;\r\n    --cds-focus: #4589ff;\r\n    --cds-border-interactive: #4589ff;\r\n    --cds-interactive: #4589ff;\r\n    --cds-link-primary: #4589ff;\r\n    --cds-link-primary-hover: color-mix(in oklab, #4589ff 80%, white);\r\n    --cds-button-primary: #0f62fe;\r\n    --cds-button-primary-hover: #0353e9;\r\n    --cds-button-tertiary: #4589ff;\r\n    --cds-button-tertiary-hover: #4589ff;\r\n  }\r\n}\r\n\r\n// ─── Toolbar styling ─────────────────────────────────────────────────────────\r\n.cds--table-toolbar {\r\n  background-color: transparent;\r\n  border: none;\r\n  border-bottom: 1px solid var(--cds-border-subtle);\r\n}\r\n\r\n// ─── Table header overrides ──────────────────────────────────────────────────\r\n.cds--table-header-label {\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n  font-size: 0.75rem;\r\n  letter-spacing: 0.04em;\r\n}\r\n\r\n// ─── Switcher labeled divider (IBM pattern) ──────────────────────────────────\r\n.cds--switcher__item--divider:has(> span) {\r\n  display: flex;\r\n  align-items: center;\r\n  height: auto;\r\n  padding: 1rem 1rem 0.5rem;\r\n  margin: 0;\r\n  background: none;\r\n  border-top: none;\r\n  border-bottom: 1px solid var(--cds-border-subtle);\r\n  block-size: auto;\r\n  inline-size: 100%;\r\n\r\n  span {\r\n    font-size: 0.625rem;\r\n    font-weight: 500;\r\n    color: var(--cds-text-secondary);\r\n    letter-spacing: 0.1em;\r\n    text-transform: capitalize;\r\n    text-align: left;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n// ─── Project selector dropdown in header ─────────────────────────────────────\r\n.project-selector-dropdown {\r\n  display: flex;\r\n  align-items: center;\r\n  align-self: center;\r\n  min-width: 180px;\r\n  border-inline-start: none;\r\n\r\n  position: relative;\r\n\r\n  .cds--dropdown,\r\n  .cds--list-box__wrapper {\r\n    position: static;\r\n  }\r\n\r\n  .cds--list-box {\r\n    border: none;\r\n    height: 3rem;\r\n    max-height: 3rem;\r\n    background-color: transparent;\r\n  }\r\n\r\n  .cds--list-box__menu {\r\n    position: absolute;\r\n    top: 3rem;\r\n    left: 0;\r\n    z-index: 9000;\r\n  }\r\n\r\n  .cds--list-box__field {\r\n    height: 3rem;\r\n    padding-inline-start: 1rem;\r\n    padding-inline-end: 2.5rem;\r\n  }\r\n\r\n  .cds--list-box__label {\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .cds--list-box__menu-icon {\r\n    right: 0.75rem;\r\n  }\r\n\r\n  .cds--list-box__menu-item {\r\n    height: 2.5rem;\r\n  }\r\n\r\n  .cds--list-box__menu-item__option {\r\n    padding-block: 0.625rem;\r\n  }\r\n\r\n  .cds--list-box:hover {\r\n    background-color: var(--cds-background-hover);\r\n  }\r\n\r\n  .cds--list-box--expanded .cds--list-box__field {\r\n    border-bottom: 2px solid var(--cds-border-interactive);\r\n  }\r\n}\r\n\r\n// ─── Notice link style — action button as inline link ────────────────────────\r\n.notice-link-style .cds--actionable-notification__action-button {\r\n  background: none !important;\r\n  border: none !important;\r\n  padding: 0 !important;\r\n  min-height: auto !important;\r\n  color: var(--cds-link-primary) !important;\r\n  font-weight: 600;\r\n  font-size: 0.875rem;\r\n  text-decoration: underline;\r\n  text-underline-offset: 2px;\r\n\r\n  &:hover {\r\n    background: none !important;\r\n    border: none !important;\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n    text-decoration: none;\r\n  }\r\n\r\n  &:focus {\r\n    border: none !important;\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n  }\r\n}\r\n\r\n// ─── Tag tokens (light/dark) ─────────────────────────────────────────────────\r\n// ─── Remove dotted underline from DefinitionTooltip wrapping tags ────────────\r\n// ─── Remove dotted underline from DefinitionTooltip wrapping tags ────────────\r\n.cds--definition-term {\r\n  border-bottom: none !important;\r\n}\r\n\r\n// ─── SideNav background ─────────────────────────────────────────────────────\r\n.cds--side-nav {\r\n  background-color: #ffffff;\r\n}\r\n\r\n:is(.dark *) .cds--side-nav,\r\n:root:is(.dark) .cds--side-nav {\r\n  background-color: #1a1a1a;\r\n}\r\n\r\n// ─── SideNav submenu items font weight ───────────────────────────────────────\r\n.cds--side-nav__menu-item .cds--side-nav__link-text {\r\n  font-weight: 500;\r\n}\r\n\r\n\r\n:root {\r\n  --cds-tag-background-cool-gray: #dde1e6;\r\n  --cds-tag-color-cool-gray: #121619;\r\n  --cds-tag-hover-cool-gray: #cdd3da;\r\n  --cds-tag-background-gray: #e0e0e0;\r\n  --cds-tag-color-gray: #161616;\r\n  --cds-tag-hover-gray: #cacaca;\r\n}\r\n\r\n:is(.dark *),\r\n:root:is(.dark) {\r\n  --cds-tag-background-cool-gray: #343a3f;\r\n  --cds-tag-color-cool-gray: #dde1e6;\r\n  --cds-tag-hover-cool-gray: #4d5358;\r\n  --cds-tag-background-gray: #393939;\r\n  --cds-tag-color-gray: #e0e0e0;\r\n  --cds-tag-hover-gray: #474747;\r\n}\r\n\r\n\r\n","//\n// Copyright IBM Corp. 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n@use 'sass:list';\n\n@use './config' as *;\n@use './utilities/custom-property';\n@use './utilities/convert';\n@use './spacing' as *;\n\n$layout-tokens: (\n  size: (\n    height: (\n      xs: convert.to-rem(24px),\n      sm: convert.to-rem(32px),\n      md: convert.to-rem(40px),\n      lg: convert.to-rem(48px),\n      xl: convert.to-rem(64px),\n      2xl: convert.to-rem(80px),\n    ),\n  ),\n  density: (\n    padding-inline: (\n      condensed: $spacing-03,\n      normal: $spacing-05,\n    ),\n  ),\n);\n\n@mixin emit-layout-tokens {\n  @each $group, $properties in $layout-tokens {\n    @each $property, $steps in $properties {\n      @each $step, $value in $steps {\n        @include custom-property.declaration(\n          'layout-#{$group}-#{$property}-#{$step}',\n          $value\n        );\n      }\n\n      // CSS max() doesn't accept '0' as a value without a unit\n      // stylelint-disable length-zero-no-unit\n      @include custom-property.declaration(\n        'layout-#{$group}-#{$property}-min',\n        0px\n      );\n      // stylelint-enable length-zero-no-unit\n\n      @include custom-property.declaration(\n        'layout-#{$group}-#{$property}-max',\n        999999999px\n      );\n    }\n  }\n}\n\n@each $group, $properties in $layout-tokens {\n  @each $property, $steps in $properties {\n    @each $step, $value in $steps {\n      .#{$prefix}--layout--#{$group}-#{$step} {\n        @include custom-property.declaration(\n          'layout-#{$group}-#{$property}-context',\n          custom-property.get-var(\n            'layout-#{$group}-#{$property}-#{$step}',\n            $value\n          )\n        );\n        @include custom-property.declaration(\n          'layout-#{$group}-#{$property}',\n          custom-property.get-var('layout-#{$group}-#{$property}-context')\n        );\n      }\n\n      .#{$prefix}--layout-constraint--#{$group}__default-#{$step} {\n        @include custom-property.declaration(\n          'layout-#{$group}-#{$property}',\n          custom-property.get-var(\n            'layout-#{$group}-#{$property}-context',\n            custom-property.get-var(\n              'layout-#{$group}-#{$property}-#{$step}',\n              $value\n            )\n          )\n        );\n      }\n\n      @each $constraint in ('min', 'max') {\n        .#{$prefix}--layout-constraint--#{$group}__#{$constraint}-#{$step} {\n          @include custom-property.declaration(\n            'layout-#{$group}-#{$property}-#{$constraint}',\n            custom-property.get-var(\n              'layout-#{$group}-#{$property}-#{$step}',\n              $value\n            )\n          );\n        }\n      }\n    }\n  }\n}\n\n:root {\n  @include emit-layout-tokens();\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../config';\n\n// Some CSS Custom Property terminology\n// @see https://www.w3.org/TR/css-variables-1/\n//\n// <custom-property-name>:\n//   Any valid identifer that starts with two dashes (--)\n//\n// A declaration:\n//   CSS Custom Properties can be used as declarations in a CSS selector. They\n//   take on the form of:\n//\n//   <custom-property-name>: <declaration-value>;\n//\n// The var() notation:\n//   You can use a CSS Custom Property as a substitute for a value of another\n//   property using the var() function. This function has the following syntax:\n//\n//   var( <custom-property-name> [, <declarative-value> ]? )\n//\n//   This function takes in an optional fallback value if the CSS Custom\n//   Property has not been previously defined\n\n/// Get the <custom-property-name> for a given string\n/// @param {String} $name\n/// @returns {String}\n@function get-name($name) {\n  @return --#{config.$prefix}-#{$name};\n}\n\n/// Get the var() representation for a given token\n/// @param {String} $name\n/// @param {Any} $fallback\n/// @returns var()\n@function get-var($name, $fallback: false) {\n  @if $fallback {\n    @return var(--#{config.$prefix}-#{$name}, #{$fallback});\n  }\n  @return var(--#{config.$prefix}-#{$name});\n}\n\n/// Emit a declaration which sets the value of a CSS Custom Property using the\n/// $name as the <custom-property-name> and the $value as the\n/// <declaration-value>\n/// @param {String} $name\n/// @param {any} $value\n@mixin declaration($name, $value) {\n  #{get-name($name)}: #{$value};\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@forward './layer/layer-sets';\n@use './config' as *;\n@use './layer/layer-tokens';\n@use './theme' as *;\n\n:root {\n  @include layer-tokens.emit-layer-tokens(1);\n}\n\n.#{$prefix}--layer-one {\n  @include layer-tokens.emit-layer-tokens(1);\n}\n\n.#{$prefix}--layer-two {\n  @include layer-tokens.emit-layer-tokens(2);\n}\n\n.#{$prefix}--layer-three {\n  @include layer-tokens.emit-layer-tokens(3);\n}\n\n@each $i in (one, two, three) {\n  .#{$prefix}--layer-#{$i}.#{$prefix}--layer__with-background {\n    background-color: $layer-background;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../config' as *;\n@use '@carbon/themes/scss/config' with (\n  $prefix: $prefix\n);\n@use '../compat/themes' as compat;\n@use '../themes';\n\n@forward '@carbon/themes/scss/theme' with (\n  $fallback: themes.$white !default,\n  $theme: compat.$white !default\n);\n@forward '@carbon/themes/scss/tokens';\n\n@use '@carbon/themes/scss/tokens';\n@use '@carbon/themes/scss/theme';\n@use '../utilities/custom-property';\n\n// Layer sets\n$layer: custom-property.get-var('layer');\n$layer-active: custom-property.get-var('layer-active');\n$layer-background: custom-property.get-var('layer-background');\n$layer-hover: custom-property.get-var('layer-hover');\n$layer-selected: custom-property.get-var('layer-selected');\n$layer-selected-hover: custom-property.get-var('layer-selected-hover');\n$layer-accent: custom-property.get-var('layer-accent');\n$layer-accent-hover: custom-property.get-var('layer-accent-hover');\n$layer-accent-active: custom-property.get-var('layer-accent-active');\n\n$field: custom-property.get-var('field');\n$field-hover: custom-property.get-var('field-hover');\n\n$border-subtle: custom-property.get-var('border-subtle');\n$border-subtle-selected: custom-property.get-var('border-subtle-selected');\n$border-strong: custom-property.get-var('border-strong');\n$border-tile: custom-property.get-var('border-tile');\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use '../config' as *;\n\n@mixin content-visible {\n  opacity: 1;\n  visibility: inherit;\n}\n\n@mixin content-hidden {\n  opacity: 0;\n  visibility: hidden;\n}\n\n@keyframes #{$prefix}--hide-feedback {\n  0% {\n    @include content-visible;\n  }\n\n  100% {\n    @include content-hidden;\n  }\n}\n\n@keyframes #{$prefix}--show-feedback {\n  0% {\n    @include content-hidden;\n  }\n\n  100% {\n    @include content-visible;\n  }\n}\n\n@keyframes #{$prefix}--skeleton {\n  0% {\n    opacity: 0.3;\n    transform: scaleX(0);\n    transform-origin: left;\n  }\n\n  20% {\n    opacity: 1;\n    transform: scaleX(1);\n    transform-origin: left;\n  }\n\n  28% {\n    transform: scaleX(1);\n    transform-origin: right;\n  }\n\n  51% {\n    transform: scaleX(0);\n    transform-origin: right;\n  }\n\n  58% {\n    transform: scaleX(0);\n    transform-origin: right;\n  }\n\n  82% {\n    transform: scaleX(1);\n    transform-origin: right;\n  }\n\n  83% {\n    transform: scaleX(1);\n    transform-origin: left;\n  }\n\n  96% {\n    transform: scaleX(0);\n    transform-origin: left;\n  }\n\n  100% {\n    opacity: 0.3;\n    transform: scaleX(0);\n    transform-origin: left;\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../config' as *;\n\n/// Include styles for screen reader/assistive text\n/// @access public\n/// @group utilities\n@mixin visually-hidden {\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  block-size: 1px;\n  clip: rect(0, 0, 0, 0);\n  inline-size: 1px;\n  visibility: inherit;\n  white-space: nowrap;\n}\n\n.#{$prefix}--assistive-text,\n.#{$prefix}--visually-hidden {\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  block-size: 1px;\n  clip: rect(0, 0, 0, 0);\n  inline-size: 1px;\n  visibility: inherit;\n  white-space: nowrap;\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../layer' as *;\n@use '../../spacing' as *;\n@use '../../theme';\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/component-reset';\n@use '../../utilities/custom-property';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/' as *;\n@use '../../utilities/convert';\n@use '../../utilities/layout';\n\n/// The Popover component is used for triggering a pop-up next to a trigger\n/// element, typically a button, in a given direction. It is made up of several\n/// parts and includes a handful of modifiers to change the appearance.\n///\n/// The parts of a popover include:\n///   The popover container `.cds-popover-container`\n///   This container contains the trigger and the popover and is used to\n///   coordinate positioning relative to the trigger button\n///\n///   The popover\n///   This is an intermediate container that is used for the\n///   `filter: drop-shadow()` effect on the popover content and the caret. It is\n///   an absolutely positioned container that matches the dimensions of the\n///   container so that popover content and caret can be positioned absolutely.\n///\n///   Popover content\n///   This is the containing element for user-provided content and sets the\n///   background and text color for the area.\n///\n///   Popover caret\n///   This caret is an optional modifier that displays a character centered with\n///   respect to the trigger element\n\n// The background color for the popover container\n$popover-background-color: custom-property.get-var(\n  'popover-background-color',\n  theme.$layer\n);\n\n// The drop shadow value used for the popover container\n$popover-drop-shadow: custom-property.get-var(\n  'popover-drop-shadow',\n  drop-shadow(0 $spacing-01 $spacing-01 rgba(0, 0, 0, 0.2))\n);\n\n// The border value used for the popover container\n$popover-border-color: custom-property.get-var(\n  'popover-border-color',\n  theme.$border-subtle\n);\n\n// The border radius value for the popover container\n$popover-border-radius: custom-property.get-var('popover-border-radius', 2px);\n\n// The text color used for text placed inside of the popover\n$popover-text-color: custom-property.get-var(\n  'popover-text-color',\n  theme.$text-primary\n);\n\n// The distance between the popover container and the triggering element\n// Specify the distance between the popover and the trigger. This value must\n// have a unit otherwise the `calc()` expression will not work\n$popover-offset: custom-property.get-var('popover-offset', 0rem);\n\n// Customize the dimensions of the caret by specifying its width or height.\n// These values will be flipped in left or right directions to have the\n// correct dimensions\n$popover-caret-width: custom-property.get-var(\n  'popover-caret-width',\n  convert.to-rem(12px)\n);\n$popover-caret-height: custom-property.get-var(\n  'popover-caret-height',\n  convert.to-rem(6px)\n);\n\n/// Mixin for applying base popover styles\n@mixin popover-base {\n  position: absolute;\n  z-index: z('floating');\n  inset: 0;\n  pointer-events: none;\n}\n\n/// Mixin for applying base highcontrast popover styles\n@mixin popover-highcontrast-base {\n  @include custom-property.declaration(\n    'popover-background-color',\n    theme.$background-inverse\n  );\n  @include custom-property.declaration(\n    'popover-text-color',\n    theme.$text-inverse\n  );\n}\n\n/// Mixin for applying popover tab-tip button styles\n@mixin popover-tab-tip-button {\n  @include button-reset.reset;\n\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  block-size: convert.to-rem(32px);\n  inline-size: convert.to-rem(32px);\n\n  &:focus {\n    @include focus-outline('outline');\n  }\n\n  &:hover {\n    background-color: theme.$layer-hover;\n  }\n\n  svg {\n    fill: theme.$icon-primary;\n  }\n}\n\n@mixin popover {\n  // Container\n  .#{$prefix}--popover-container {\n    display: inline-block;\n  }\n\n  // Do not set position: relative on autoAlign popovers.\n  // Without this, autoAlign popovers will be clipped by containing elements\n  // (using overflow: hidden, etc) if position: relative is set on the container.\n  .#{$prefix}--popover-container:not(.#{$prefix}--popover--auto-align) {\n    position: relative;\n  }\n\n  /// Modifiers\n\n  // High contrast modifier\n  .#{$prefix}--popover--high-contrast .#{$prefix}--popover {\n    @include popover-highcontrast-base;\n  }\n\n  // Drop shadow modifier\n  .#{$prefix}--popover--drop-shadow .#{$prefix}--popover {\n    filter: $popover-drop-shadow;\n  }\n\n  // Border modifier\n  .#{$prefix}--popover--border\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    outline: 1px solid $popover-border-color;\n    outline-offset: -1px;\n  }\n\n  // Caret tip modifier\n  .#{$prefix}--popover--caret {\n    @include custom-property.declaration(\n      'popover-offset',\n      convert.to-rem(10px)\n    );\n  }\n\n  // Popover, this element contains both the caret and the popover content\n  .#{$prefix}--popover {\n    @include popover-base;\n  }\n\n  // Popover content\n  .#{$prefix}--popover-content {\n    // The layout.redefine-tokens is been included here because it is been redefined in _tag.scss\n    @include layout.redefine-tokens(\n      (\n        size: (\n          height: (\n            sm: convert.to-rem(32px),\n            md: convert.to-rem(40px),\n            lg: convert.to-rem(48px),\n          ),\n        ),\n      )\n    );\n    @include component-reset.reset;\n\n    position: absolute;\n    z-index: z('floating');\n    display: none;\n    border-radius: $popover-border-radius;\n    background-color: $popover-background-color;\n    color: $popover-text-color;\n    inline-size: max-content;\n    max-inline-size: convert.to-rem(368px);\n    pointer-events: auto;\n  }\n\n  .#{$prefix}--popover--open\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    display: block;\n  }\n\n  .#{$prefix}--popover--background-token__background\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    background-color: theme.$background;\n  }\n\n  // We use a pseudo element inside of the popover to create a space between the\n  // target and the popover. This helps in situations like toolcarets where you do\n  // not want the toolcaret to disappear when the user moves from the target to\n  // the popover.\n  .#{$prefix}--popover-content::before {\n    position: absolute;\n    display: none;\n    content: '';\n  }\n\n  .#{$prefix}--popover--open\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before {\n    display: block;\n  }\n\n  // Popover caret\n  .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--auto-align.#{$prefix}--popover-caret {\n    position: absolute;\n    z-index: z('floating');\n    display: none;\n\n    // We use `will-change: transform` to prevent antialiasing when our caret\n    // has subpixel rendering. When this happens, a single pixel line appears\n    // between the caret and popover-content that we would like to avoid\n    will-change: transform;\n\n    // caret background\n    &::after {\n      position: absolute;\n      display: block;\n      background-color: $popover-background-color;\n      content: '';\n    }\n\n    // caret border\n    &::before {\n      position: absolute;\n      display: none;\n      background-color: $popover-border-color;\n      content: '';\n    }\n  }\n\n  .#{$prefix}--popover--background-token__background\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret::after {\n    background-color: theme.$background;\n  }\n\n  .#{$prefix}--popover--border .#{$prefix}--popover-caret::before,\n  .#{$prefix}--popover--border\n    .#{$prefix}--popover--auto-align.#{$prefix}--popover-caret::before {\n    display: block;\n  }\n\n  .#{$prefix}--popover--caret.#{$prefix}--popover--open\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    display: block;\n  }\n\n  // autoAlign uses a different dom structure where the caret is within the content instead of a sibling\n  .#{$prefix}--popover--auto-align.#{$prefix}--popover--caret.#{$prefix}--popover--open\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    display: block;\n  }\n\n  .#{$prefix}--popover--tab-tip\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    display: none;\n  }\n\n  //-----------------------------------------------------------------------------\n  // Bottom\n  //-----------------------------------------------------------------------------\n\n  // Popover content placement\n  .#{$prefix}--popover--bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: 0;\n    inset-inline-start: 50%;\n    transform: translate(-50%, calc(100% + $popover-offset));\n  }\n\n  .#{$prefix}--popover--bottom:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: -$spacing-02;\n  }\n\n  .#{$prefix}--popover--top:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--top-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--top-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: -$spacing-02;\n  }\n\n  .#{$prefix}--popover--top-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-start: calc(50% - $popover-offset - 1rem);\n  }\n  .#{$prefix}--popover--top-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: calc(50% - $popover-offset - 1rem);\n  }\n\n  .#{$prefix}--popover--right:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--right-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--right-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-start: calc(100% + $spacing-02);\n  }\n\n  .#{$prefix}--popover--left:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--left-start:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--left-end:not(.#{$prefix}--popover--caret):not(\n      .#{$prefix}--popover--auto-align\n    ):not(.#{$prefix}--popover--tab-tip)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: calc(100% + $spacing-02);\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    transform: translate(50%, calc(100% + $popover-offset));\n  }\n\n  .#{$prefix}--popover--bottom-left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: 0;\n    inset-inline-start: calc(50% - $popover-offset);\n    transform: translate(\n      calc(-1 * $popover-offset),\n      calc(100% + $popover-offset)\n    );\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: calc(50% - $popover-offset);\n    inset-inline-start: initial;\n  }\n\n  .#{$prefix}--popover--bottom-right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--bottom-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: 0;\n    inset-inline-end: calc(50% - $popover-offset);\n    transform: translate($popover-offset, calc(100% + $popover-offset));\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-start: calc(50% - $popover-offset);\n  }\n\n  // Popover hover area placement\n  .#{$prefix}--popover--bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--bottom-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--bottom-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--bottom-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--bottom-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before {\n    block-size: $popover-offset;\n    inset-block-start: 0;\n    inset-inline: 0;\n    transform: translateY(-100%);\n  }\n\n  // Caret placement\n  .#{$prefix}--popover--bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-height;\n    inline-size: $popover-caret-width;\n    inset-block-end: 0;\n    inset-inline-start: 50%;\n    transform: translate(-50%, $popover-offset);\n\n    &::after {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 100%, 50% 0%, 100% 100%);\n      inline-size: $popover-caret-width;\n    }\n  }\n\n  // Caret placement with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 100%, 50% 0%, 100% 100%);\n      inline-size: $popover-caret-width;\n    }\n\n    &::after {\n      inline-size: calc($popover-caret-width - 1px);\n      inset-block-start: 1px;\n      inset-inline-start: 0.5px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--bottom-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    transform: translate(50%, $popover-offset);\n  }\n\n  // Caret placement for autoAlign\n  .#{$prefix}--popover--bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--bottom-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-height;\n    inline-size: $popover-caret-width;\n\n    &::after {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 100%, 50% 0%, 100% 100%);\n      inline-size: $popover-caret-width;\n    }\n  }\n\n  // Caret placement for autoAlign with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--bottom-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 100%, 50% 0%, 100% 100%);\n      inline-size: $popover-caret-width;\n    }\n\n    &::after {\n      inline-size: calc($popover-caret-width - 1px);\n      inset-block-start: 1px;\n      inset-inline-start: 0.5px;\n    }\n  }\n\n  //-----------------------------------------------------------------------------\n  // Top\n  //-----------------------------------------------------------------------------\n\n  // Popover content placement\n  .#{$prefix}--popover--top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 0;\n    inset-inline-start: 50%;\n    transform: translate(-50%, calc(-100% - $popover-offset));\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    transform: translate(50%, calc(-100% - $popover-offset));\n  }\n\n  .#{$prefix}--popover--top-left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--top-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 0;\n    inset-inline-start: calc(50% - $popover-offset);\n    transform: translate(\n      calc(-1 * $popover-offset),\n      calc(-100% - $popover-offset)\n    );\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--top-left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--top-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: calc(50% - $popover-offset);\n    inset-inline-start: initial;\n  }\n\n  .#{$prefix}--popover--top-right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--top-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 0;\n    inset-inline-end: calc(50% - $popover-offset);\n    transform: translate($popover-offset, calc(-100% - $popover-offset));\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--top-right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--top-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-start: calc(50% - $popover-offset);\n  }\n\n  // Popover hover area placement\n  .#{$prefix}--popover--top\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--top-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--top-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--top-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--top-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before {\n    block-size: $popover-offset;\n    inset-block-end: 0;\n    inset-inline: 0;\n    transform: translateY(100%);\n  }\n\n  // Caret placement\n  .#{$prefix}--popover--top > .#{$prefix}--popover > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-height;\n    inline-size: $popover-caret-width;\n    inset-block-start: 0;\n    inset-inline-start: 50%;\n    transform: translate(-50%, calc(-1 * $popover-offset));\n\n    &::after {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 0%, 50% 100%, 100% 0%);\n      inline-size: $popover-caret-width;\n    }\n  }\n\n  // Caret placement with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--top\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 0%, 50% 100%, 100% 0%);\n      inline-size: $popover-caret-width;\n    }\n\n    &::after {\n      inline-size: calc($popover-caret-width - 1px);\n      inset-block-start: -1px;\n      inset-inline-start: 0.5px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--top-left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--top-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--top-right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--top-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    transform: translate(50%, calc(-1 * $popover-offset));\n  }\n\n  // Caret placement for autoAlign\n  .#{$prefix}--popover--top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--top-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-height;\n    inline-size: $popover-caret-width;\n\n    &::after {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 0%, 50% 100%, 100% 0%);\n      inline-size: $popover-caret-width;\n    }\n  }\n\n  // Caret placement for autoAlign with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--top-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-height;\n      clip-path: polygon(0% 0%, 50% 100%, 100% 0%);\n      inline-size: $popover-caret-width;\n    }\n\n    &::after {\n      inline-size: calc($popover-caret-width - 1px);\n      inset-block-start: -1px;\n      inset-inline-start: 0.5px;\n    }\n  }\n\n  //-----------------------------------------------------------------------------\n  // Right\n  //-----------------------------------------------------------------------------\n\n  // Popover content placement\n  .#{$prefix}--popover--right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 50%;\n    inset-inline-start: 100%;\n    // Add in 0.1px to prevent rounding errors where the content is\n    // moved farther than the caret\n    transform: translate($popover-offset, -50%);\n  }\n\n  .#{$prefix}--popover--right-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--right-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 50%;\n    inset-inline-start: 100%;\n    transform: translate(\n      $popover-offset,\n      calc(0.5 * $popover-offset * -1 - 16px)\n    );\n  }\n\n  .#{$prefix}--popover--right-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--right-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: 50%;\n    inset-inline-start: 100%;\n    transform: translate($popover-offset, calc(0.5 * $popover-offset + 16px));\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--right-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--right-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--right-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--right-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: 100%;\n    inset-inline-start: initial;\n  }\n\n  // Popover hover area placement\n  .#{$prefix}--popover--right\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--right-top\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--right-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--right-bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--right-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before {\n    inline-size: $popover-offset;\n    inset-block: 0;\n    inset-inline-start: 0;\n    transform: translateX(-100%);\n  }\n\n  // Caret placement\n  .#{$prefix}--popover--right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-width;\n    inline-size: $popover-caret-height;\n    inset-block-start: 50%;\n    inset-inline-start: 100%;\n    transform: translate(calc($popover-offset - 100%), -50%);\n\n    &::after {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 50%, 100% 0%, 100% 100%);\n      inline-size: $popover-caret-height;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--right:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--right-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--right-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--right-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--right-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    inset-inline-end: 100%;\n    inset-inline-start: initial;\n  }\n\n  // Caret placement with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--right:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-top:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-bottom:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 50%, 100% 0%, 100% 100%);\n      inline-size: $popover-caret-height;\n    }\n\n    &::after {\n      inset-inline-start: 1px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-top:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-bottom:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::after {\n      inset-inline-start: -1px;\n    }\n  }\n\n  // Caret placement for autoAlign\n  .#{$prefix}--popover--right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--right-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-width;\n    inline-size: $popover-caret-height;\n\n    &::after {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 50%, 100% 0%, 100% 100%);\n      inline-size: $popover-caret-height;\n      // margin-block-start: calc(-1 * #{$popover-caret-height});\n    }\n  }\n\n  // Caret placement for autoAlign with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--right-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 50%, 100% 0%, 100% 100%);\n      inline-size: $popover-caret-height;\n      // margin-block-start: calc(-1 * #{$popover-caret-height});\n    }\n\n    &::after {\n      inset-inline-start: 1px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--right-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      margin-inline-start: 1px;\n    }\n\n    &::after {\n      inset-inline-start: 0;\n    }\n  }\n\n  //-----------------------------------------------------------------------------\n  // Left\n  //-----------------------------------------------------------------------------\n\n  // Popover content placement\n  .#{$prefix}--popover--left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 50%;\n    inset-inline-end: 100%;\n    // Add in 0.1px to prevent rounding errors where the content is\n    // moved farther than the caret\n    transform: translate(calc(-1 * $popover-offset + 0.1px), -50%);\n  }\n\n  .#{$prefix}--popover--left-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--left-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-start: 50%;\n    inset-inline-end: 100%;\n    // Add in 0.1px to prevent rounding errors where the content is\n    // moved farther than the caret\n    transform: translate(\n      calc(-1 * $popover-offset),\n      calc(-1 * 0.5 * $popover-offset - 16px)\n    );\n  }\n\n  .#{$prefix}--popover--left-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--left-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-block-end: 50%;\n    inset-inline-end: 100%;\n    // Add in 0.1px to prevent rounding errors where the content is\n    // moved farther than the caret\n    transform: translate(\n      calc(-1 * $popover-offset),\n      calc(0.5 * $popover-offset + 16px)\n    );\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--left-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--left-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--left-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--left-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: initial;\n    inset-inline-start: 100%;\n  }\n\n  // Popover hover area placement\n  .#{$prefix}--popover--left\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--left-top\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--left-start\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--left-bottom\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before,\n  .#{$prefix}--popover--left-end\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content::before {\n    inline-size: $popover-offset;\n    inset-block: 0;\n    inset-inline-end: 0;\n    transform: translateX(100%);\n  }\n\n  // Caret placement\n  .#{$prefix}--popover--left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-width;\n    inline-size: $popover-caret-height;\n    inset-block-start: 50%;\n    inset-inline-end: 100%;\n    transform: translate(calc(-1 * $popover-offset + 100%), -50%);\n\n    &::after {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);\n      inline-size: $popover-caret-height;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--left:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--left-top:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--left-start:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--left-bottom:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--left-end:not(.#{$prefix}--popover--auto-align)\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    inset-inline-end: initial;\n    inset-inline-start: 100%;\n  }\n\n  // Caret placement with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--left:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-top:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-bottom:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);\n      inline-size: $popover-caret-height;\n    }\n\n    &::after {\n      inset-inline-start: -1px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-top:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-bottom:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-caret {\n    &::after {\n      inset-inline-start: 1px;\n    }\n  }\n\n  // Caret placement for autoAlign\n  .#{$prefix}--popover--left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--left-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    block-size: $popover-caret-width;\n    inline-size: $popover-caret-height;\n\n    &::after {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);\n      inline-size: $popover-caret-height;\n    }\n  }\n\n  // Caret placement for autoAlign with border\n  .#{$prefix}--popover--border.#{$prefix}--popover--left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  .#{$prefix}--popover--border.#{$prefix}--popover--left-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      block-size: $popover-caret-width;\n      clip-path: polygon(0% 0%, 100% 50%, 0% 100%);\n      inline-size: $popover-caret-height;\n    }\n\n    &::after {\n      inset-inline-start: -1px;\n    }\n  }\n\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-top.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-start.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-bottom.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret,\n  [dir='rtl']\n    .#{$prefix}--popover--border.#{$prefix}--popover--left-end.#{$prefix}--popover--auto-align\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content\n    > .#{$prefix}--popover-caret {\n    &::before {\n      margin-inline-start: -1px;\n    }\n\n    &::after {\n      inset-inline-start: 0;\n    }\n  }\n\n  //-----------------------------------------------------------------------------\n  // Tab Tip Variant\n  //-----------------------------------------------------------------------------\n  .#{$prefix}--popover--tab-tip\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    border-radius: 0;\n  }\n\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--top-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--bottom-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--tab-tip.#{$prefix}--popover--top-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--tab-tip.#{$prefix}--popover--bottom-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--top-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--bottom-end:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--tab-tip.#{$prefix}--popover--top-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content,\n  [dir='rtl']\n    .#{$prefix}--popover--tab-tip.#{$prefix}--popover--bottom-start:not(\n      .#{$prefix}--popover--auto-align\n    )\n    > .#{$prefix}--popover\n    > .#{$prefix}--popover-content {\n    inset-inline-end: 0;\n    inset-inline-start: initial;\n  }\n\n  .#{$prefix}--popover--tab-tip .#{$prefix}--popover {\n    will-change: filter;\n  }\n\n  .#{$prefix}--popover--tab-tip__button {\n    @include popover-tab-tip-button;\n  }\n\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--open\n    .#{$prefix}--popover--tab-tip__button {\n    background: theme.$layer;\n    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);\n  }\n\n  .#{$prefix}--popover--tab-tip.#{$prefix}--popover--open\n    .#{$prefix}--popover--tab-tip__button:not(:focus)::after {\n    position: absolute;\n    z-index: z('floating') + 1;\n    background: theme.$layer;\n    block-size: 2px;\n    content: '';\n    inline-size: 100%;\n    inset-block-end: 0;\n  }\n\n  .#{$prefix}--popover--tab-tip__button svg {\n    fill: theme.$icon-primary;\n  }\n}\n","//\n// Copyright IBM Corp. 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n\n@use '../config';\n@use '../layout' as *;\n@use './custom-property';\n\n/// Enables the use of contextual layout tokens within a component. This mixin should be\n/// included on the outermost selector of the component.\n/// @param {String} $group - The layout group to use for this component\n/// @param {String} $default - The default step if the component is not within a layout\n/// @param {String} $min - The minimum step supported by this component (optional)\n/// @param {String} $max - The maximum step supported by this component (optional)\n/// @example @include use('size', $default: 'md', $min: 'sm', $max: 'lg')\n/// @group utilities\n/// @access public\n@mixin use($group, $default, $min: null, $max: null) {\n  $properties: map.get($layout-tokens, $group);\n\n  @each $property, $steps in $properties {\n    $minValue: custom-property.get-var('layout-#{$group}-#{$property}-min');\n    @if $min {\n      $minValue: max(\n        $minValue,\n        custom-property.get-var('layout-#{$group}-#{$property}-#{$min}')\n      );\n    }\n\n    $maxValue: custom-property.get-var('layout-#{$group}-#{$property}-max');\n    @if $max {\n      $maxValue: min(\n        $maxValue,\n        custom-property.get-var('layout-#{$group}-#{$property}-#{$max}')\n      );\n    }\n\n    $value: clamp(\n      $minValue,\n      custom-property.get-var(\n        'layout-#{$group}-#{$property}',\n        custom-property.get-var('layout-#{$group}-#{$property}-#{$default}')\n      ),\n      $maxValue\n    );\n\n    @include custom-property.declaration(\n      'layout-#{$group}-#{$property}-local',\n      $value\n    );\n  }\n}\n\n/// Allows to redefine any token values of the layout module in case a component is using\n/// non-standard values and should still participate in the layout context\n/// @param {Map} $overrides - The map of overrides. Must follow ( group: ( property: ( step: value ) ) )\n/// @example @include redefine-tokens(( size: ( height: ( sm: 1.125rem, md: 1.5rem ) ) ))\n/// @group utilities\n/// @access public\n@mixin redefine-tokens($overrides) {\n  @each $group, $properties in $overrides {\n    @each $property, $steps in $properties {\n      @each $step, $value in $steps {\n        @include custom-property.declaration(\n          'layout-#{$group}-#{$property}-#{$step}',\n          $value\n        );\n\n        &.#{config.$prefix}--layout--#{$group}-#{$step},\n        .#{config.$prefix}--layout--#{$group}-#{$step} :where(&) {\n          $token: custom-property.get-var(\n            'layout-#{$group}-#{$property}-#{$step}'\n          );\n          @include custom-property.declaration(\n            'layout-#{$group}-#{$property}',\n            $token\n          );\n        }\n      }\n    }\n  }\n}\n\n/// Internal base function for retrieving a property from a layout group.\n/// @param {String} $group - The group name as defined in the $layout-tokens\n/// @param {String} $property - The property name\n/// @example @include -group('size', $property)\n/// @group utilities\n/// @access private\n@function -group($group, $property) {\n  @return custom-property.get-var('layout-#{$group}-#{$property}-local');\n}\n\n/// Retrieves the current value for a property token in the layout size.\n/// @param {String} $property - The property name\n/// @example height: size('height');\n/// @group utilities\n/// @access public\n@function size($property) {\n  @return -group('size', $property);\n}\n\n/// Retrieves the current value for a property token in the layout density.\n/// @param {String} $property - The property name\n/// @example padding-inline: density('padding-inline');\n/// @group utilities\n/// @access public\n@function density($property) {\n  @return -group('density', $property);\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n/// Resets default browser styling\n/// @access public\n/// @group utilities\n@mixin reset {\n  box-sizing: border-box;\n  padding: 0;\n  border: 0;\n  margin: 0;\n  font-family: inherit;\n  font-size: 100%;\n  vertical-align: baseline;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: inherit;\n  }\n}\n","// Code generated by @carbon/themes. DO NOT EDIT.\n//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n@use '../config';\n@use '../theme';\n\n/// Internal helper for generating CSS Custom Properties\n@function _get($token) {\n  @if config.$use-fallback-value == false {\n    @return var(--#{config.$prefix}-#{$token});\n  } @else {\n    @return var(--#{config.$prefix}-#{$token}, #{theme.get($token)});\n  }\n}\n\n/// The CSS Custom Property for the `background` token\n$background: _get('background') !default;\n\n/// The CSS Custom Property for the `background-active` token\n$background-active: _get('background-active') !default;\n\n/// The CSS Custom Property for the `background-selected` token\n$background-selected: _get('background-selected') !default;\n\n/// The CSS Custom Property for the `background-selected-hover` token\n$background-selected-hover: _get('background-selected-hover') !default;\n\n/// The CSS Custom Property for the `background-hover` token\n$background-hover: _get('background-hover') !default;\n\n/// The CSS Custom Property for the `background-brand` token\n$background-brand: _get('background-brand') !default;\n\n/// The CSS Custom Property for the `background-inverse` token\n$background-inverse: _get('background-inverse') !default;\n\n/// The CSS Custom Property for the `background-inverse-hover` token\n$background-inverse-hover: _get('background-inverse-hover') !default;\n\n/// The CSS Custom Property for the `layer-01` token\n$layer-01: _get('layer-01') !default;\n\n/// The CSS Custom Property for the `layer-active-01` token\n$layer-active-01: _get('layer-active-01') !default;\n\n/// The CSS Custom Property for the `layer-background-01` token\n$layer-background-01: _get('layer-background-01') !default;\n\n/// The CSS Custom Property for the `layer-hover-01` token\n$layer-hover-01: _get('layer-hover-01') !default;\n\n/// The CSS Custom Property for the `layer-selected-01` token\n$layer-selected-01: _get('layer-selected-01') !default;\n\n/// The CSS Custom Property for the `layer-selected-hover-01` token\n$layer-selected-hover-01: _get('layer-selected-hover-01') !default;\n\n/// The CSS Custom Property for the `layer-02` token\n$layer-02: _get('layer-02') !default;\n\n/// The CSS Custom Property for the `layer-active-02` token\n$layer-active-02: _get('layer-active-02') !default;\n\n/// The CSS Custom Property for the `layer-background-02` token\n$layer-background-02: _get('layer-background-02') !default;\n\n/// The CSS Custom Property for the `layer-hover-02` token\n$layer-hover-02: _get('layer-hover-02') !default;\n\n/// The CSS Custom Property for the `layer-selected-02` token\n$layer-selected-02: _get('layer-selected-02') !default;\n\n/// The CSS Custom Property for the `layer-selected-hover-02` token\n$layer-selected-hover-02: _get('layer-selected-hover-02') !default;\n\n/// The CSS Custom Property for the `layer-03` token\n$layer-03: _get('layer-03') !default;\n\n/// The CSS Custom Property for the `layer-active-03` token\n$layer-active-03: _get('layer-active-03') !default;\n\n/// The CSS Custom Property for the `layer-background-03` token\n$layer-background-03: _get('layer-background-03') !default;\n\n/// The CSS Custom Property for the `layer-hover-03` token\n$layer-hover-03: _get('layer-hover-03') !default;\n\n/// The CSS Custom Property for the `layer-selected-03` token\n$layer-selected-03: _get('layer-selected-03') !default;\n\n/// The CSS Custom Property for the `layer-selected-hover-03` token\n$layer-selected-hover-03: _get('layer-selected-hover-03') !default;\n\n/// The CSS Custom Property for the `layer-selected-inverse` token\n$layer-selected-inverse: _get('layer-selected-inverse') !default;\n\n/// The CSS Custom Property for the `layer-selected-disabled` token\n$layer-selected-disabled: _get('layer-selected-disabled') !default;\n\n/// The CSS Custom Property for the `layer-accent-01` token\n$layer-accent-01: _get('layer-accent-01') !default;\n\n/// The CSS Custom Property for the `layer-accent-active-01` token\n$layer-accent-active-01: _get('layer-accent-active-01') !default;\n\n/// The CSS Custom Property for the `layer-accent-hover-01` token\n$layer-accent-hover-01: _get('layer-accent-hover-01') !default;\n\n/// The CSS Custom Property for the `layer-accent-02` token\n$layer-accent-02: _get('layer-accent-02') !default;\n\n/// The CSS Custom Property for the `layer-accent-active-02` token\n$layer-accent-active-02: _get('layer-accent-active-02') !default;\n\n/// The CSS Custom Property for the `layer-accent-hover-02` token\n$layer-accent-hover-02: _get('layer-accent-hover-02') !default;\n\n/// The CSS Custom Property for the `layer-accent-03` token\n$layer-accent-03: _get('layer-accent-03') !default;\n\n/// The CSS Custom Property for the `layer-accent-active-03` token\n$layer-accent-active-03: _get('layer-accent-active-03') !default;\n\n/// The CSS Custom Property for the `layer-accent-hover-03` token\n$layer-accent-hover-03: _get('layer-accent-hover-03') !default;\n\n/// The CSS Custom Property for the `field-01` token\n$field-01: _get('field-01') !default;\n\n/// The CSS Custom Property for the `field-hover-01` token\n$field-hover-01: _get('field-hover-01') !default;\n\n/// The CSS Custom Property for the `field-02` token\n$field-02: _get('field-02') !default;\n\n/// The CSS Custom Property for the `field-hover-02` token\n$field-hover-02: _get('field-hover-02') !default;\n\n/// The CSS Custom Property for the `field-03` token\n$field-03: _get('field-03') !default;\n\n/// The CSS Custom Property for the `field-hover-03` token\n$field-hover-03: _get('field-hover-03') !default;\n\n/// The CSS Custom Property for the `interactive` token\n$interactive: _get('interactive') !default;\n\n/// The CSS Custom Property for the `border-subtle-00` token\n$border-subtle-00: _get('border-subtle-00') !default;\n\n/// The CSS Custom Property for the `border-subtle-01` token\n$border-subtle-01: _get('border-subtle-01') !default;\n\n/// The CSS Custom Property for the `border-subtle-selected-01` token\n$border-subtle-selected-01: _get('border-subtle-selected-01') !default;\n\n/// The CSS Custom Property for the `border-subtle-02` token\n$border-subtle-02: _get('border-subtle-02') !default;\n\n/// The CSS Custom Property for the `border-subtle-selected-02` token\n$border-subtle-selected-02: _get('border-subtle-selected-02') !default;\n\n/// The CSS Custom Property for the `border-subtle-03` token\n$border-subtle-03: _get('border-subtle-03') !default;\n\n/// The CSS Custom Property for the `border-subtle-selected-03` token\n$border-subtle-selected-03: _get('border-subtle-selected-03') !default;\n\n/// The CSS Custom Property for the `border-strong-01` token\n$border-strong-01: _get('border-strong-01') !default;\n\n/// The CSS Custom Property for the `border-strong-02` token\n$border-strong-02: _get('border-strong-02') !default;\n\n/// The CSS Custom Property for the `border-strong-03` token\n$border-strong-03: _get('border-strong-03') !default;\n\n/// The CSS Custom Property for the `border-tile-01` token\n$border-tile-01: _get('border-tile-01') !default;\n\n/// The CSS Custom Property for the `border-tile-02` token\n$border-tile-02: _get('border-tile-02') !default;\n\n/// The CSS Custom Property for the `border-tile-03` token\n$border-tile-03: _get('border-tile-03') !default;\n\n/// The CSS Custom Property for the `border-inverse` token\n$border-inverse: _get('border-inverse') !default;\n\n/// The CSS Custom Property for the `border-interactive` token\n$border-interactive: _get('border-interactive') !default;\n\n/// The CSS Custom Property for the `border-disabled` token\n$border-disabled: _get('border-disabled') !default;\n\n/// The CSS Custom Property for the `text-primary` token\n$text-primary: _get('text-primary') !default;\n\n/// The CSS Custom Property for the `text-secondary` token\n$text-secondary: _get('text-secondary') !default;\n\n/// The CSS Custom Property for the `text-placeholder` token\n$text-placeholder: _get('text-placeholder') !default;\n\n/// The CSS Custom Property for the `text-helper` token\n$text-helper: _get('text-helper') !default;\n\n/// The CSS Custom Property for the `text-error` token\n$text-error: _get('text-error') !default;\n\n/// The CSS Custom Property for the `text-inverse` token\n$text-inverse: _get('text-inverse') !default;\n\n/// The CSS Custom Property for the `text-on-color` token\n$text-on-color: _get('text-on-color') !default;\n\n/// The CSS Custom Property for the `text-on-color-disabled` token\n$text-on-color-disabled: _get('text-on-color-disabled') !default;\n\n/// The CSS Custom Property for the `text-disabled` token\n$text-disabled: _get('text-disabled') !default;\n\n/// The CSS Custom Property for the `link-primary` token\n$link-primary: _get('link-primary') !default;\n\n/// The CSS Custom Property for the `link-primary-hover` token\n$link-primary-hover: _get('link-primary-hover') !default;\n\n/// The CSS Custom Property for the `link-secondary` token\n$link-secondary: _get('link-secondary') !default;\n\n/// The CSS Custom Property for the `link-inverse-visited` token\n$link-inverse-visited: _get('link-inverse-visited') !default;\n\n/// The CSS Custom Property for the `link-visited` token\n$link-visited: _get('link-visited') !default;\n\n/// The CSS Custom Property for the `link-inverse` token\n$link-inverse: _get('link-inverse') !default;\n\n/// The CSS Custom Property for the `link-inverse-active` token\n$link-inverse-active: _get('link-inverse-active') !default;\n\n/// The CSS Custom Property for the `link-inverse-hover` token\n$link-inverse-hover: _get('link-inverse-hover') !default;\n\n/// The CSS Custom Property for the `icon-primary` token\n$icon-primary: _get('icon-primary') !default;\n\n/// The CSS Custom Property for the `icon-secondary` token\n$icon-secondary: _get('icon-secondary') !default;\n\n/// The CSS Custom Property for the `icon-inverse` token\n$icon-inverse: _get('icon-inverse') !default;\n\n/// The CSS Custom Property for the `icon-on-color` token\n$icon-on-color: _get('icon-on-color') !default;\n\n/// The CSS Custom Property for the `icon-on-color-disabled` token\n$icon-on-color-disabled: _get('icon-on-color-disabled') !default;\n\n/// The CSS Custom Property for the `icon-disabled` token\n$icon-disabled: _get('icon-disabled') !default;\n\n/// The CSS Custom Property for the `icon-interactive` token\n$icon-interactive: _get('icon-interactive') !default;\n\n/// The CSS Custom Property for the `support-error` token\n$support-error: _get('support-error') !default;\n\n/// The CSS Custom Property for the `support-success` token\n$support-success: _get('support-success') !default;\n\n/// The CSS Custom Property for the `support-warning` token\n$support-warning: _get('support-warning') !default;\n\n/// The CSS Custom Property for the `support-info` token\n$support-info: _get('support-info') !default;\n\n/// The CSS Custom Property for the `support-error-inverse` token\n$support-error-inverse: _get('support-error-inverse') !default;\n\n/// The CSS Custom Property for the `support-success-inverse` token\n$support-success-inverse: _get('support-success-inverse') !default;\n\n/// The CSS Custom Property for the `support-warning-inverse` token\n$support-warning-inverse: _get('support-warning-inverse') !default;\n\n/// The CSS Custom Property for the `support-info-inverse` token\n$support-info-inverse: _get('support-info-inverse') !default;\n\n/// The CSS Custom Property for the `support-caution-major` token\n$support-caution-major: _get('support-caution-major') !default;\n\n/// The CSS Custom Property for the `support-caution-minor` token\n$support-caution-minor: _get('support-caution-minor') !default;\n\n/// The CSS Custom Property for the `support-caution-undefined` token\n$support-caution-undefined: _get('support-caution-undefined') !default;\n\n/// The CSS Custom Property for the `syntax-comment` token\n$syntax-comment: _get('syntax-comment') !default;\n\n/// The CSS Custom Property for the `syntax-line-comment` token\n$syntax-line-comment: _get('syntax-line-comment') !default;\n\n/// The CSS Custom Property for the `syntax-block-comment` token\n$syntax-block-comment: _get('syntax-block-comment') !default;\n\n/// The CSS Custom Property for the `syntax-doc-comment` token\n$syntax-doc-comment: _get('syntax-doc-comment') !default;\n\n/// The CSS Custom Property for the `syntax-doc-string` token\n$syntax-doc-string: _get('syntax-doc-string') !default;\n\n/// The CSS Custom Property for the `syntax-keyword` token\n$syntax-keyword: _get('syntax-keyword') !default;\n\n/// The CSS Custom Property for the `syntax-operator-keyword` token\n$syntax-operator-keyword: _get('syntax-operator-keyword') !default;\n\n/// The CSS Custom Property for the `syntax-control-keyword` token\n$syntax-control-keyword: _get('syntax-control-keyword') !default;\n\n/// The CSS Custom Property for the `syntax-definition-keyword` token\n$syntax-definition-keyword: _get('syntax-definition-keyword') !default;\n\n/// The CSS Custom Property for the `syntax-module-keyword` token\n$syntax-module-keyword: _get('syntax-module-keyword') !default;\n\n/// The CSS Custom Property for the `syntax-variable` token\n$syntax-variable: _get('syntax-variable') !default;\n\n/// The CSS Custom Property for the `syntax-name` token\n$syntax-name: _get('syntax-name') !default;\n\n/// The CSS Custom Property for the `syntax-variable-name` token\n$syntax-variable-name: _get('syntax-variable-name') !default;\n\n/// The CSS Custom Property for the `syntax-label-name` token\n$syntax-label-name: _get('syntax-label-name') !default;\n\n/// The CSS Custom Property for the `syntax-attribute` token\n$syntax-attribute: _get('syntax-attribute') !default;\n\n/// The CSS Custom Property for the `syntax-attribute-name` token\n$syntax-attribute-name: _get('syntax-attribute-name') !default;\n\n/// The CSS Custom Property for the `syntax-property-name` token\n$syntax-property-name: _get('syntax-property-name') !default;\n\n/// The CSS Custom Property for the `syntax-tag` token\n$syntax-tag: _get('syntax-tag') !default;\n\n/// The CSS Custom Property for the `syntax-tag-name` token\n$syntax-tag-name: _get('syntax-tag-name') !default;\n\n/// The CSS Custom Property for the `syntax-type` token\n$syntax-type: _get('syntax-type') !default;\n\n/// The CSS Custom Property for the `syntax-type-name` token\n$syntax-type-name: _get('syntax-type-name') !default;\n\n/// The CSS Custom Property for the `syntax-class-name` token\n$syntax-class-name: _get('syntax-class-name') !default;\n\n/// The CSS Custom Property for the `syntax-namespace` token\n$syntax-namespace: _get('syntax-namespace') !default;\n\n/// The CSS Custom Property for the `syntax-macro-name` token\n$syntax-macro-name: _get('syntax-macro-name') !default;\n\n/// The CSS Custom Property for the `syntax-atom` token\n$syntax-atom: _get('syntax-atom') !default;\n\n/// The CSS Custom Property for the `syntax-literal` token\n$syntax-literal: _get('syntax-literal') !default;\n\n/// The CSS Custom Property for the `syntax-bool` token\n$syntax-bool: _get('syntax-bool') !default;\n\n/// The CSS Custom Property for the `syntax-null` token\n$syntax-null: _get('syntax-null') !default;\n\n/// The CSS Custom Property for the `syntax-self` token\n$syntax-self: _get('syntax-self') !default;\n\n/// The CSS Custom Property for the `syntax-number` token\n$syntax-number: _get('syntax-number') !default;\n\n/// The CSS Custom Property for the `syntax-integer` token\n$syntax-integer: _get('syntax-integer') !default;\n\n/// The CSS Custom Property for the `syntax-float` token\n$syntax-float: _get('syntax-float') !default;\n\n/// The CSS Custom Property for the `syntax-unit` token\n$syntax-unit: _get('syntax-unit') !default;\n\n/// The CSS Custom Property for the `syntax-string` token\n$syntax-string: _get('syntax-string') !default;\n\n/// The CSS Custom Property for the `syntax-character` token\n$syntax-character: _get('syntax-character') !default;\n\n/// The CSS Custom Property for the `syntax-attribute-value` token\n$syntax-attribute-value: _get('syntax-attribute-value') !default;\n\n/// The CSS Custom Property for the `syntax-special-string` token\n$syntax-special-string: _get('syntax-special-string') !default;\n\n/// The CSS Custom Property for the `syntax-regexp` token\n$syntax-regexp: _get('syntax-regexp') !default;\n\n/// The CSS Custom Property for the `syntax-escape` token\n$syntax-escape: _get('syntax-escape') !default;\n\n/// The CSS Custom Property for the `syntax-url` token\n$syntax-url: _get('syntax-url') !default;\n\n/// The CSS Custom Property for the `syntax-color` token\n$syntax-color: _get('syntax-color') !default;\n\n/// The CSS Custom Property for the `syntax-operator` token\n$syntax-operator: _get('syntax-operator') !default;\n\n/// The CSS Custom Property for the `syntax-deref-operator` token\n$syntax-deref-operator: _get('syntax-deref-operator') !default;\n\n/// The CSS Custom Property for the `syntax-arithmetic-operator` token\n$syntax-arithmetic-operator: _get('syntax-arithmetic-operator') !default;\n\n/// The CSS Custom Property for the `syntax-logic-operator` token\n$syntax-logic-operator: _get('syntax-logic-operator') !default;\n\n/// The CSS Custom Property for the `syntax-bitwise-operator` token\n$syntax-bitwise-operator: _get('syntax-bitwise-operator') !default;\n\n/// The CSS Custom Property for the `syntax-compare-operator` token\n$syntax-compare-operator: _get('syntax-compare-operator') !default;\n\n/// The CSS Custom Property for the `syntax-update-operator` token\n$syntax-update-operator: _get('syntax-update-operator') !default;\n\n/// The CSS Custom Property for the `syntax-definition-operator` token\n$syntax-definition-operator: _get('syntax-definition-operator') !default;\n\n/// The CSS Custom Property for the `syntax-type-operator` token\n$syntax-type-operator: _get('syntax-type-operator') !default;\n\n/// The CSS Custom Property for the `syntax-control-operator` token\n$syntax-control-operator: _get('syntax-control-operator') !default;\n\n/// The CSS Custom Property for the `syntax-modifier` token\n$syntax-modifier: _get('syntax-modifier') !default;\n\n/// The CSS Custom Property for the `syntax-punctuation` token\n$syntax-punctuation: _get('syntax-punctuation') !default;\n\n/// The CSS Custom Property for the `syntax-separator` token\n$syntax-separator: _get('syntax-separator') !default;\n\n/// The CSS Custom Property for the `syntax-bracket` token\n$syntax-bracket: _get('syntax-bracket') !default;\n\n/// The CSS Custom Property for the `syntax-angle-bracket` token\n$syntax-angle-bracket: _get('syntax-angle-bracket') !default;\n\n/// The CSS Custom Property for the `syntax-square-bracket` token\n$syntax-square-bracket: _get('syntax-square-bracket') !default;\n\n/// The CSS Custom Property for the `syntax-paren` token\n$syntax-paren: _get('syntax-paren') !default;\n\n/// The CSS Custom Property for the `syntax-brace` token\n$syntax-brace: _get('syntax-brace') !default;\n\n/// The CSS Custom Property for the `syntax-content` token\n$syntax-content: _get('syntax-content') !default;\n\n/// The CSS Custom Property for the `syntax-heading` token\n$syntax-heading: _get('syntax-heading') !default;\n\n/// The CSS Custom Property for the `syntax-heading-1` token\n$syntax-heading-1: _get('syntax-heading-1') !default;\n\n/// The CSS Custom Property for the `syntax-heading-2` token\n$syntax-heading-2: _get('syntax-heading-2') !default;\n\n/// The CSS Custom Property for the `syntax-heading-3` token\n$syntax-heading-3: _get('syntax-heading-3') !default;\n\n/// The CSS Custom Property for the `syntax-heading-4` token\n$syntax-heading-4: _get('syntax-heading-4') !default;\n\n/// The CSS Custom Property for the `syntax-heading-5` token\n$syntax-heading-5: _get('syntax-heading-5') !default;\n\n/// The CSS Custom Property for the `syntax-heading-6` token\n$syntax-heading-6: _get('syntax-heading-6') !default;\n\n/// The CSS Custom Property for the `syntax-content-separator` token\n$syntax-content-separator: _get('syntax-content-separator') !default;\n\n/// The CSS Custom Property for the `syntax-list` token\n$syntax-list: _get('syntax-list') !default;\n\n/// The CSS Custom Property for the `syntax-quote` token\n$syntax-quote: _get('syntax-quote') !default;\n\n/// The CSS Custom Property for the `syntax-emphasis` token\n$syntax-emphasis: _get('syntax-emphasis') !default;\n\n/// The CSS Custom Property for the `syntax-strong` token\n$syntax-strong: _get('syntax-strong') !default;\n\n/// The CSS Custom Property for the `syntax-monospace` token\n$syntax-monospace: _get('syntax-monospace') !default;\n\n/// The CSS Custom Property for the `syntax-link` token\n$syntax-link: _get('syntax-link') !default;\n\n/// The CSS Custom Property for the `syntax-strikethrough` token\n$syntax-strikethrough: _get('syntax-strikethrough') !default;\n\n/// The CSS Custom Property for the `syntax-invalid` token\n$syntax-invalid: _get('syntax-invalid') !default;\n\n/// The CSS Custom Property for the `syntax-meta` token\n$syntax-meta: _get('syntax-meta') !default;\n\n/// The CSS Custom Property for the `syntax-document-meta` token\n$syntax-document-meta: _get('syntax-document-meta') !default;\n\n/// The CSS Custom Property for the `syntax-annotation` token\n$syntax-annotation: _get('syntax-annotation') !default;\n\n/// The CSS Custom Property for the `syntax-processing-instruction` token\n$syntax-processing-instruction: _get('syntax-processing-instruction') !default;\n\n/// The CSS Custom Property for the `syntax-definition` token\n$syntax-definition: _get('syntax-definition') !default;\n\n/// The CSS Custom Property for the `syntax-constant` token\n$syntax-constant: _get('syntax-constant') !default;\n\n/// The CSS Custom Property for the `syntax-function` token\n$syntax-function: _get('syntax-function') !default;\n\n/// The CSS Custom Property for the `syntax-standard` token\n$syntax-standard: _get('syntax-standard') !default;\n\n/// The CSS Custom Property for the `syntax-local` token\n$syntax-local: _get('syntax-local') !default;\n\n/// The CSS Custom Property for the `syntax-special` token\n$syntax-special: _get('syntax-special') !default;\n\n/// The CSS Custom Property for the `ai-popover-background` token\n$ai-popover-background: _get('ai-popover-background') !default;\n\n/// The CSS Custom Property for the `ai-popover-shadow-outer-01` token\n$ai-popover-shadow-outer-01: _get('ai-popover-shadow-outer-01') !default;\n\n/// The CSS Custom Property for the `ai-popover-shadow-outer-02` token\n$ai-popover-shadow-outer-02: _get('ai-popover-shadow-outer-02') !default;\n\n/// The CSS Custom Property for the `ai-inner-shadow` token\n$ai-inner-shadow: _get('ai-inner-shadow') !default;\n\n/// The CSS Custom Property for the `ai-aura-start-sm` token\n$ai-aura-start-sm: _get('ai-aura-start-sm') !default;\n\n/// The CSS Custom Property for the `ai-aura-start` token\n$ai-aura-start: _get('ai-aura-start') !default;\n\n/// The CSS Custom Property for the `ai-aura-end` token\n$ai-aura-end: _get('ai-aura-end') !default;\n\n/// The CSS Custom Property for the `ai-aura-hover-background` token\n$ai-aura-hover-background: _get('ai-aura-hover-background') !default;\n\n/// The CSS Custom Property for the `ai-aura-hover-start` token\n$ai-aura-hover-start: _get('ai-aura-hover-start') !default;\n\n/// The CSS Custom Property for the `ai-aura-hover-end` token\n$ai-aura-hover-end: _get('ai-aura-hover-end') !default;\n\n/// The CSS Custom Property for the `ai-border-strong` token\n$ai-border-strong: _get('ai-border-strong') !default;\n\n/// The CSS Custom Property for the `ai-border-start` token\n$ai-border-start: _get('ai-border-start') !default;\n\n/// The CSS Custom Property for the `ai-border-end` token\n$ai-border-end: _get('ai-border-end') !default;\n\n/// The CSS Custom Property for the `ai-drop-shadow` token\n$ai-drop-shadow: _get('ai-drop-shadow') !default;\n\n/// The CSS Custom Property for the `ai-skeleton-background` token\n$ai-skeleton-background: _get('ai-skeleton-background') !default;\n\n/// The CSS Custom Property for the `ai-skeleton-element-background` token\n$ai-skeleton-element-background: _get(\n  'ai-skeleton-element-background'\n) !default;\n\n/// The CSS Custom Property for the `ai-overlay` token\n$ai-overlay: _get('ai-overlay') !default;\n\n/// The CSS Custom Property for the `ai-popover-caret-center` token\n$ai-popover-caret-center: _get('ai-popover-caret-center') !default;\n\n/// The CSS Custom Property for the `ai-popover-caret-bottom` token\n$ai-popover-caret-bottom: _get('ai-popover-caret-bottom') !default;\n\n/// The CSS Custom Property for the `ai-popover-caret-bottom-background` token\n$ai-popover-caret-bottom-background: _get(\n  'ai-popover-caret-bottom-background'\n) !default;\n\n/// The CSS Custom Property for the `ai-popover-caret-bottom-background-actions` token\n$ai-popover-caret-bottom-background-actions: _get(\n  'ai-popover-caret-bottom-background-actions'\n) !default;\n\n/// The CSS Custom Property for the `chat-prompt-background` token\n$chat-prompt-background: _get('chat-prompt-background') !default;\n\n/// The CSS Custom Property for the `chat-prompt-border-start` token\n$chat-prompt-border-start: _get('chat-prompt-border-start') !default;\n\n/// The CSS Custom Property for the `chat-prompt-border-end` token\n$chat-prompt-border-end: _get('chat-prompt-border-end') !default;\n\n/// The CSS Custom Property for the `chat-prompt-text` token\n$chat-prompt-text: _get('chat-prompt-text') !default;\n\n/// The CSS Custom Property for the `chat-bubble-user` token\n$chat-bubble-user: _get('chat-bubble-user') !default;\n\n/// The CSS Custom Property for the `chat-bubble-user-text` token\n$chat-bubble-user-text: _get('chat-bubble-user-text') !default;\n\n/// The CSS Custom Property for the `chat-bubble-agent` token\n$chat-bubble-agent: _get('chat-bubble-agent') !default;\n\n/// The CSS Custom Property for the `chat-bubble-agent-text` token\n$chat-bubble-agent-text: _get('chat-bubble-agent-text') !default;\n\n/// The CSS Custom Property for the `chat-bubble-border` token\n$chat-bubble-border: _get('chat-bubble-border') !default;\n\n/// The CSS Custom Property for the `chat-avatar-bot` token\n$chat-avatar-bot: _get('chat-avatar-bot') !default;\n\n/// The CSS Custom Property for the `chat-avatar-agent` token\n$chat-avatar-agent: _get('chat-avatar-agent') !default;\n\n/// The CSS Custom Property for the `chat-avatar-user` token\n$chat-avatar-user: _get('chat-avatar-user') !default;\n\n/// The CSS Custom Property for the `chat-shell-background` token\n$chat-shell-background: _get('chat-shell-background') !default;\n\n/// The CSS Custom Property for the `chat-header-background` token\n$chat-header-background: _get('chat-header-background') !default;\n\n/// The CSS Custom Property for the `chat-header-text` token\n$chat-header-text: _get('chat-header-text') !default;\n\n/// The CSS Custom Property for the `chat-button` token\n$chat-button: _get('chat-button') !default;\n\n/// The CSS Custom Property for the `chat-button-hover` token\n$chat-button-hover: _get('chat-button-hover') !default;\n\n/// The CSS Custom Property for the `chat-button-text-hover` token\n$chat-button-text-hover: _get('chat-button-text-hover') !default;\n\n/// The CSS Custom Property for the `chat-button-active` token\n$chat-button-active: _get('chat-button-active') !default;\n\n/// The CSS Custom Property for the `chat-button-selected` token\n$chat-button-selected: _get('chat-button-selected') !default;\n\n/// The CSS Custom Property for the `chat-button-text-selected` token\n$chat-button-text-selected: _get('chat-button-text-selected') !default;\n\n/// The CSS Custom Property for the `highlight` token\n$highlight: _get('highlight') !default;\n\n/// The CSS Custom Property for the `overlay` token\n$overlay: _get('overlay') !default;\n\n/// The CSS Custom Property for the `color-scheme` token\n$color-scheme: _get('color-scheme') !default;\n\n/// The CSS Custom Property for the `toggle-off` token\n$toggle-off: _get('toggle-off') !default;\n\n/// The CSS Custom Property for the `shadow` token\n$shadow: _get('shadow') !default;\n\n/// The CSS Custom Property for the `focus` token\n$focus: _get('focus') !default;\n\n/// The CSS Custom Property for the `focus-inset` token\n$focus-inset: _get('focus-inset') !default;\n\n/// The CSS Custom Property for the `focus-inverse` token\n$focus-inverse: _get('focus-inverse') !default;\n\n/// The CSS Custom Property for the `skeleton-background` token\n$skeleton-background: _get('skeleton-background') !default;\n\n/// The CSS Custom Property for the `skeleton-element` token\n$skeleton-element: _get('skeleton-element') !default;\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use 'component-reset';\n\n/// Resets button styles\n/// @access public\n/// @param {Bool} $width [true] - Sets width to 100% if true\n/// @example @include button-reset($width: false);\n/// @group utilities\n@mixin reset($width: true) {\n  display: inline-block;\n  padding: 0;\n  border: 0;\n  appearance: none;\n  background: none;\n  cursor: pointer;\n  text-align: start;\n\n  @if ($width == true) {\n    inline-size: 100%;\n  }\n\n  @include component-reset.reset;\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../theme';\n\n/// Adds outline styles depending on specific type\n/// @access public\n/// @param {String} $type ['border'] - Type of outline from: `border`, `blurred`, `outline`, `invalid`, `reset`\n/// @example @include focus-outline('outline');\n/// @group utilities\n@mixin focus-outline($type: 'border') {\n  @if ($type == 'border') {\n    outline: 1px solid theme.$focus;\n\n    @media screen and (prefers-contrast) {\n      outline-style: dotted;\n    }\n  }\n\n  @if ($type == 'blurred') {\n    box-shadow: 0 0 0 3px theme.$focus;\n    outline: 1px solid transparent;\n  }\n\n  @if ($type == 'outline') {\n    outline: 2px solid theme.$focus;\n    outline-offset: -2px;\n\n    @media screen and (prefers-contrast) {\n      outline-style: dotted;\n    }\n  }\n\n  @if ($type == 'outline-compat') {\n    box-sizing: border-box;\n    border: 2px solid theme.$focus;\n\n    @media screen and (prefers-contrast) {\n      border-style: dotted;\n    }\n  }\n\n  @if ($type == 'invalid') {\n    outline: 2px solid theme.$support-error;\n    outline-offset: -2px;\n\n    @media screen and (prefers-contrast) {\n      outline-style: dotted;\n    }\n  }\n\n  @if ($type == 'reset') {\n    outline: 2px solid transparent;\n    outline-offset: -2px;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../popover';\n@use '../../config' as *;\n@use '../../spacing';\n@use '../../theme';\n@use '../../type';\n@use '../../layer' as *;\n@use '../../utilities/custom-property';\n@use '../../utilities/convert';\n@use '../../utilities/button-reset';\n@use '../../utilities/focus-outline';\n\n$tooltip-padding-block: custom-property.get-var(\n  'tooltip-padding-block',\n  spacing.$spacing-05\n);\n\n$tooltip-padding-inline: custom-property.get-var(\n  'tooltip-padding-inline',\n  spacing.$spacing-05\n);\n\n@mixin tooltip {\n  .#{$prefix}--tooltip {\n    @include custom-property.declaration('popover-offset', 12px);\n  }\n\n  .#{$prefix}--tooltip-content {\n    @include type.type-style('body-01');\n\n    padding: $tooltip-padding-block $tooltip-padding-inline;\n    max-inline-size: convert.to-rem(288px);\n    overflow-wrap: break-word;\n  }\n}\n\n@mixin definition-tooltip {\n  .#{$prefix}--definition-term {\n    @include button-reset.reset;\n\n    border-radius: 0;\n    border-block-end: 1px dotted theme.$border-strong;\n    color: theme.$text-primary;\n  }\n\n  .#{$prefix}--definition-term:focus {\n    @include focus-outline.focus-outline;\n\n    border-block-end-color: theme.$border-interactive;\n  }\n\n  .#{$prefix}--definition-term:hover {\n    border-block-end-color: theme.$border-interactive;\n  }\n\n  .#{$prefix}--definition-tooltip {\n    @include type.type-style('body-01');\n\n    padding: convert.to-rem(8px) convert.to-rem(16px);\n    max-inline-size: convert.to-rem(176px);\n    text-wrap: auto;\n    word-break: break-word;\n  }\n}\n\n@mixin icon-tooltip {\n  .#{$prefix}--icon-tooltip {\n    @include custom-property.declaration(\n      'tooltip-padding-block',\n      convert.to-rem(2px)\n    );\n    @include custom-property.declaration(\n      'popover-caret-width',\n      convert.to-rem(8px)\n    );\n    @include custom-property.declaration(\n      'popover-caret-height',\n      convert.to-rem(4px)\n    );\n    @include custom-property.declaration('popover-offset', convert.to-rem(8px));\n  }\n\n  .#{$prefix}--icon-tooltip .#{$prefix}--tooltip-content {\n    @include type.type-style('body-compact-01');\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n// stylelint-disable number-max-precision\n\n@use 'sass:map';\n@use 'sass:math';\n@use '@carbon/grid/scss/config' as gridconfig;\n@use '@carbon/grid/scss/breakpoint' as grid;\n@use 'prefix' as *;\n@use 'font-family';\n@use 'scale';\n\n/// @type Map\n/// @access public\n/// @deprecated\n/// @group @carbon/type\n$caption-01: (\n  font-size: scale.type-scale(1),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.33333,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @deprecated\n/// @group @carbon/type\n$caption-02: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$label-01: (\n  font-size: scale.type-scale(1),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.33333,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$label-02: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$legal-01: (\n  font-size: scale.type-scale(1),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.33333,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$legal-02: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @deprecated\n/// @group @carbon/type\n$helper-text-01: (\n  font-size: scale.type-scale(1),\n  line-height: 1.33333,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @deprecated\n/// @group @carbon/type\n$helper-text-02: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-short-01: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-compact-01: $body-short-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-long-01: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.42857,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-01: $body-long-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-short-02: (\n  font-size: scale.type-scale(3),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.375,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-compact-02: $body-short-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-long-02: (\n  font-size: scale.type-scale(3),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.5,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$body-02: $body-long-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$code-01: (\n  font-family: font-family.font-family('mono'),\n  font-size: scale.type-scale(1),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.33333,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$code-02: (\n  font-family: font-family.font-family('mono'),\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.42857,\n  letter-spacing: 0.32px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-01: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.42857,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-01: (\n  font-size: scale.type-scale(2),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.28572,\n  letter-spacing: 0.16px,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-compact-01: $productive-heading-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-02: (\n  font-size: scale.type-scale(3),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.5,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-02: (\n  font-size: scale.type-scale(3),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.375,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-compact-02: $productive-heading-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-03: (\n  font-size: scale.type-scale(5),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.4,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-03: $productive-heading-03 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-04: (\n  font-size: scale.type-scale(7),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-04: $productive-heading-04 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-05: (\n  font-size: scale.type-scale(8),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.25,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-05: $productive-heading-05 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-06: (\n  font-size: scale.type-scale(10),\n  font-weight: font-family.font-weight('light'),\n  // Extra digit needed for precision in Chrome\n  line-height: 1.199,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-06: $productive-heading-06 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$productive-heading-07: (\n  font-size: scale.type-scale(12),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.19,\n  letter-spacing: 0,\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$heading-07: $productive-heading-07 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-01: $heading-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-02: $heading-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-03: (\n  font-size: scale.type-scale(5),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.4,\n  letter-spacing: 0,\n  breakpoints: (\n    xlg: (\n      font-size: scale.type-scale(5),\n      line-height: 1.4,\n    ),\n    max: (\n      font-size: scale.type-scale(6),\n      line-height: 1.334,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-heading-03: $expressive-heading-03 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-04: (\n  font-size: scale.type-scale(7),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.28572,\n  letter-spacing: 0,\n  breakpoints: (\n    xlg: (\n      font-size: scale.type-scale(8),\n      line-height: 1.25,\n      font-weight: font-family.font-weight('regular'),\n    ),\n    max: (\n      font-size: scale.type-scale(8),\n      font-weight: font-family.font-weight('regular'),\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-heading-04: $expressive-heading-04 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-05: (\n  font-size: scale.type-scale(8),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.25,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(9),\n      font-weight: font-family.font-weight('light'),\n      line-height: 1.22,\n    ),\n    lg: (\n      font-size: scale.type-scale(10),\n      line-height: 1.19,\n    ),\n    xlg: (\n      font-size: scale.type-scale(11),\n      line-height: 1.17,\n    ),\n    max: (\n      font-size: scale.type-scale(13),\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-heading-05: $expressive-heading-05 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-heading-06: (\n  font-size: scale.type-scale(8),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.25,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(9),\n      line-height: 1.22,\n    ),\n    lg: (\n      font-size: scale.type-scale(10),\n      line-height: 1.19,\n    ),\n    xlg: (\n      font-size: scale.type-scale(11),\n      line-height: 1.17,\n    ),\n    max: (\n      font-size: scale.type-scale(13),\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-heading-06: $expressive-heading-06 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$expressive-paragraph-01: (\n  font-size: scale.type-scale(6),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.334,\n  letter-spacing: 0,\n  breakpoints: (\n    lg: (\n      font-size: scale.type-scale(7),\n      line-height: 1.28572,\n    ),\n    max: (\n      font-size: scale.type-scale(8),\n      line-height: 1.25,\n    ),\n  ),\n);\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-paragraph-01: $expressive-paragraph-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$quotation-01: (\n  font-family: font-family.font-family('serif'),\n  font-size: scale.type-scale(5),\n  font-weight: font-family.font-weight('regular'),\n  line-height: 1.3,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(5),\n    ),\n    lg: (\n      font-size: scale.type-scale(6),\n      line-height: 1.334,\n    ),\n    xlg: (\n      font-size: scale.type-scale(7),\n      line-height: 1.28572,\n    ),\n    max: (\n      font-size: scale.type-scale(8),\n      line-height: 1.25,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-quotation-01: $quotation-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$quotation-02: (\n  font-family: font-family.font-family('serif'),\n  font-size: scale.type-scale(8),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.25,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(9),\n      line-height: 1.22,\n    ),\n    lg: (\n      font-size: scale.type-scale(10),\n      line-height: 1.19,\n    ),\n    xlg: (\n      font-size: scale.type-scale(11),\n      line-height: 1.17,\n    ),\n    max: (\n      font-size: scale.type-scale(13),\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-quotation-02: $quotation-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$display-01: (\n  font-size: scale.type-scale(10),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.19,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(10),\n    ),\n    lg: (\n      font-size: scale.type-scale(12),\n    ),\n    xlg: (\n      font-size: scale.type-scale(13),\n      line-height: 1.17,\n    ),\n    max: (\n      font-size: scale.type-scale(15),\n      line-height: 1.13,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-display-01: $display-01 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$display-02: (\n  font-size: scale.type-scale(10),\n  font-weight: font-family.font-weight('semibold'),\n  line-height: 1.19,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(10),\n    ),\n    lg: (\n      font-size: scale.type-scale(12),\n    ),\n    xlg: (\n      font-size: scale.type-scale(13),\n      line-height: 1.16,\n    ),\n    max: (\n      font-size: scale.type-scale(15),\n      line-height: 1.13,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-display-02: $display-02 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$display-03: (\n  font-size: scale.type-scale(10),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.19,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(12),\n      line-height: 1.18,\n    ),\n    lg: (\n      font-size: scale.type-scale(13),\n      line-height: 1.16,\n      letter-spacing: -0.64px,\n    ),\n    xlg: (\n      font-size: scale.type-scale(15),\n      line-height: 1.13,\n      letter-spacing: -0.64px,\n    ),\n    max: (\n      font-size: scale.type-scale(16),\n      line-height: 1.11,\n      letter-spacing: -0.96px,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-display-03: $display-03 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$display-04: (\n  font-size: scale.type-scale(10),\n  font-weight: font-family.font-weight('light'),\n  line-height: 1.19,\n  letter-spacing: 0,\n  breakpoints: (\n    md: (\n      font-size: scale.type-scale(14),\n      line-height: 1.15,\n    ),\n    lg: (\n      font-size: scale.type-scale(17),\n      line-height: 1.11,\n      letter-spacing: -0.64px,\n    ),\n    xlg: (\n      font-size: scale.type-scale(20),\n      line-height: 1.07,\n      letter-spacing: -0.64px,\n    ),\n    max: (\n      font-size: scale.type-scale(23),\n      line-height: 1.05,\n      letter-spacing: -0.96px,\n    ),\n  ),\n) !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$fluid-display-04: $display-04 !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$tokens: (\n  caption-01: $caption-01,\n  caption-02: $caption-02,\n  label-01: $label-01,\n  label-02: $label-02,\n  helper-text-01: $helper-text-01,\n  helper-text-02: $helper-text-02,\n  body-short-01: $body-short-01,\n  body-short-02: $body-short-02,\n  body-long-01: $body-long-01,\n  body-long-02: $body-long-02,\n  code-01: $code-01,\n  code-02: $code-02,\n  heading-01: $heading-01,\n  heading-02: $heading-02,\n  productive-heading-01: $productive-heading-01,\n  productive-heading-02: $productive-heading-02,\n  productive-heading-03: $productive-heading-03,\n  productive-heading-04: $productive-heading-04,\n  productive-heading-05: $productive-heading-05,\n  productive-heading-06: $productive-heading-06,\n  productive-heading-07: $productive-heading-07,\n  expressive-paragraph-01: $expressive-paragraph-01,\n  expressive-heading-01: $expressive-heading-01,\n  expressive-heading-02: $expressive-heading-02,\n  expressive-heading-03: $expressive-heading-03,\n  expressive-heading-04: $expressive-heading-04,\n  expressive-heading-05: $expressive-heading-05,\n  expressive-heading-06: $expressive-heading-06,\n  quotation-01: $quotation-01,\n  quotation-02: $quotation-02,\n  display-01: $display-01,\n  display-02: $display-02,\n  display-03: $display-03,\n  display-04: $display-04,\n  // V11 Tokens\n  legal-01: $legal-01,\n  legal-02: $legal-02,\n  body-compact-01: $body-compact-01,\n  body-compact-02: $body-compact-02,\n  heading-compact-01: $heading-compact-01,\n  heading-compact-02: $heading-compact-02,\n  body-01: $body-01,\n  body-02: $body-02,\n  heading-03: $heading-03,\n  heading-04: $heading-04,\n  heading-05: $heading-05,\n  heading-06: $heading-06,\n  heading-07: $heading-07,\n  fluid-heading-03: $fluid-heading-03,\n  fluid-heading-04: $fluid-heading-04,\n  fluid-heading-05: $fluid-heading-05,\n  fluid-heading-06: $fluid-heading-06,\n  fluid-paragraph-01: $fluid-paragraph-01,\n  fluid-quotation-01: $fluid-quotation-01,\n  fluid-quotation-02: $fluid-quotation-02,\n  fluid-display-01: $fluid-display-01,\n  fluid-display-02: $fluid-display-02,\n  fluid-display-03: $fluid-display-03,\n  fluid-display-04: $fluid-display-04,\n) !default;\n\n/// @param {Map} $map\n/// @access public\n/// @group @carbon/type\n@mixin properties($map) {\n  @each $name, $value in $map {\n    #{$name}: $value;\n  }\n}\n\n/// @param {Number} $value - Number with units\n/// @return {Number} Without units\n/// @access public\n/// @group @carbon/type\n@function strip-unit($value) {\n  @return math.div($value, $value * 0 + 1);\n}\n\n/// This helper includes fluid type styles for the given token value. Fluid type\n/// means that the `font-size` is computed using `calc()` in order to be\n/// determined by the screen size instead of a breakpoint. As a result, fluid\n/// styles should be used with caution in fixed width contexts.\n///\n/// In addition, we make use of %-based line-heights so that the line-height of\n/// each type style is computed correctly due to the dynamic nature of the\n/// `font-size`.\n///\n/// Most of the logic for this work comes from CSS Tricks:\n/// https://css-tricks.com/snippets/css/fluid-typography/\n///\n/// @param {Map} $type-styles - The value of a given type token\n/// @param {Map} $breakpoints [$grid-breakpoints] - Custom breakpoints to use\n/// @access public\n/// @group @carbon/type\n@mixin fluid-type($type-styles, $breakpoints: gridconfig.$grid-breakpoints) {\n  // Include the initial styles for the given token by default without any\n  // media query guard. This includes `font-size` as a fallback in the case\n  // that a browser does not support `calc()`\n  @include properties(map.remove($type-styles, breakpoints));\n  // We also need to include the `sm` styles by default since they don't\n  // appear in the fluid styles for tokens\n  @include fluid-type-size($type-styles, sm, $breakpoints);\n\n  // Finally, we need to go through all the breakpoints defined in the type\n  // token and apply the properties and fluid type size for that given\n  // breakpoint\n  @each $name, $values in map.get($type-styles, breakpoints) {\n    @include grid.breakpoint($name) {\n      @include properties($values);\n      @include fluid-type-size($type-styles, $name, $breakpoints);\n    }\n  }\n}\n\n/// Computes the fluid `font-size` for a given type style and breakpoint\n/// @param {Map} $type-styles - The styles for a given token\n/// @param {String} $name - The name of the breakpoint to which we apply the fluid\n/// @param {Map} $breakpoints [$grid-breakpoints] - The breakpoints for the grid system\n/// @access public\n/// @group @carbon/type\n@mixin fluid-type-size(\n  $type-styles,\n  $name,\n  $breakpoints: gridconfig.$grid-breakpoints\n) {\n  // Get the information about the breakpoint we're currently working in. Useful\n  // for getting initial width information\n  $breakpoint: map.get($breakpoints, $name);\n\n  // Our fluid styles are captured under the 'breakpoints' property in our type\n  // styles map. These define what values to treat as `max-` variables below\n  $fluid-sizes: map.get($type-styles, breakpoints);\n  $fluid-breakpoint: ();\n  // Special case for `sm` because the styles for small are on the type style\n  // directly\n  @if $name == sm {\n    $fluid-breakpoint: map.remove($type-styles, breakpoints);\n  } @else {\n    $fluid-breakpoint: map.get($fluid-sizes, $name);\n  }\n\n  // Initialize our font-sizes to the default size for the type style\n  $max-font-size: map.get($type-styles, font-size);\n  $min-font-size: map.get($type-styles, font-size);\n  @if map.has-key($fluid-breakpoint, font-size) {\n    $min-font-size: map.get($fluid-breakpoint, font-size);\n  }\n\n  // Initialize our min and max width to the width of the current breakpoint\n  $max-vw: map.get($breakpoint, width);\n  $min-vw: map.get($breakpoint, width);\n\n  // We can use `breakpoint-next` to see if there is another breakpoint we can\n  // use to update `max-font-size` and `max-vw` with larger values\n  $next-breakpoint-available: grid.breakpoint-next($name, $breakpoints);\n  $next-fluid-breakpoint-name: null;\n\n  // We need to figure out what the next available fluid breakpoint is for our\n  // given $type-styles. In this loop we try and iterate through breakpoints\n  // until we either manually set $next-breakpoint-available to null or\n  // `breakpoint-next` returns null.\n  @while $next-breakpoint-available {\n    @if map.has-key($fluid-sizes, $next-breakpoint-available) {\n      $next-fluid-breakpoint-name: $next-breakpoint-available;\n      $next-breakpoint-available: null;\n    } @else {\n      $next-breakpoint-available: grid.breakpoint-next(\n        $next-breakpoint-available,\n        $breakpoints\n      );\n    }\n  }\n\n  // If we have found the next available fluid breakpoint name, then we know\n  // that we have values that we can use to set max-font-size and max-vw as both\n  // values derive from the next breakpoint\n  @if $next-fluid-breakpoint-name {\n    $next-fluid-breakpoint: map.get($breakpoints, $next-fluid-breakpoint-name);\n    $max-font-size: map.get(\n      map.get($fluid-sizes, $next-fluid-breakpoint-name),\n      font-size\n    );\n    $max-vw: map.get($next-fluid-breakpoint, width);\n\n    // prettier-ignore\n    font-size: calc(#{$min-font-size} +\n      #{strip-unit($max-font-size - $min-font-size)} *\n      ((100vw - #{$min-vw}) / #{strip-unit($max-vw - $min-vw)})\n    );\n  } @else {\n    // Otherwise, just default to setting the font size found from the type\n    // style or the given fluid breakpoint in the type style\n    font-size: $min-font-size;\n  }\n}\n\n// TODO: move following variable and `custom-property` mixin into shared file for\n// both `@carbon/type` and `@carbon/themes`\n\n/// @access private\n/// @group @carbon/type\n@mixin custom-properties($name, $value) {\n  @each $property, $value in $value {\n    #{$property}: var(\n      --#{$custom-property-prefix}-#{$name}-#{$property},\n      #{$value}\n    );\n  }\n}\n\n/// Helper mixin to include the styles for a given token in any selector in your\n/// project. Also includes an optional fluid option that will enable fluid\n/// styles for the token if they are defined. Fluid styles will cause the\n/// token's font-size to be computed based on the viewport size. As a result, use\n/// with caution in fixed contexts.\n/// @param {String} $name - The name of the token to get the styles for\n/// @param {Boolean} $fluid [false] - Specify whether to include fluid styles for the\n/// @param {Map} $breakpoints [$grid-breakpoints] - Provide a custom breakpoint map to use\n/// @access public\n/// @group @carbon/type\n@mixin type-style(\n  $name,\n  $fluid: false,\n  $breakpoints: gridconfig.$grid-breakpoints\n) {\n  @if not map.has-key($tokens, $name) {\n    @error 'Unable to find a token with the name: `#{$name}`';\n  }\n\n  $token: map.get($tokens, $name);\n\n  // If $fluid is set to true and the token has breakpoints defined for fluid\n  // styles, delegate to the fluid-type helper for the given token\n  @if $fluid == true and map.has-key($token, 'breakpoints') {\n    @include fluid-type($token, $breakpoints);\n  } @else {\n    @include custom-properties($name, $token);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2024\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:math';\n@use 'tokens' as *;\n@use 'vars' as *;\n@use 'mixins' as *;\n@use '../tooltip';\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/layout';\n\n@function has-n-children($n) {\n  // Uses nth-child() to select the nth child, and :last-child to ensure that\n  // the selector only matches the last child of its parent.\n  @return ':has(:nth-child(#{$n}):last-child)';\n}\n\n@mixin button-set-fluid-column() {\n  --flex-direction: column;\n\n  .#{$prefix}--btn {\n    flex: initial;\n    inline-size: 100%;\n    max-inline-size: none;\n  }\n\n  .#{$prefix}--btn--ghost {\n    padding-inline-start: $spacing-05;\n  }\n}\n\n@mixin button-set-fluid-layout() {\n  container-type: inline-size;\n\n  .#{$prefix}--btn-set__fluid-inner {\n    --flex-direction: row;\n\n    display: flex;\n    flex-direction: var(--flex-direction);\n    align-items: stretch;\n    justify-content: flex-end;\n    inline-size: 100%;\n  }\n\n  // NOTE: Container queries are based on this value which is based on IBM Products implementation\n  // Side panel has up to 3 buttons unstacked from size lg (640px). Min 160.33px/button\n  // Narrow Tearsheet 540px has 4 buttons unstacked buttons. Min 135px/button\n  // May need to be configurable as 3 * 135px is less than 640px.\n  // Current value 176px only supports up to 3 buttons at 540px.\n  $min-inline-button-size: convert.to-rem(176px);\n\n  .#{$prefix}--btn-set__fluid-inner .#{$prefix}--btn {\n    // default non-column layout\n    flex: 0 1 25%;\n\n    // This increased size comes from use in IBM Products Tearsheet and SidePanel\n    max-inline-size: convert.to-rem(232px);\n  }\n\n  .#{$prefix}--btn-set__fluid-inner--auto-stack .#{$prefix}--btn {\n    min-inline-size: $min-inline-button-size;\n  }\n\n  .#{$prefix}--btn-set__fluid-inner .#{$prefix}--btn--ghost,\n  .#{$prefix}--btn-set__fluid-inner .#{$prefix}--btn--danger--ghost {\n    // ghost buttons always grow to fill the container\n    flex: 1 1 25%;\n    max-inline-size: none;\n    padding-inline-start: $spacing-07; /* increased padding when inline */\n  }\n\n  $max-fluid-buttons: 4;\n  // this determines whether or not column is used\n  @for $i from 1 through $max-fluid-buttons {\n    @container (width <= #{$i * $min-inline-button-size}) {\n      .#{$prefix}--btn-set__fluid-inner--auto-stack#{has-n-children($i)} {\n        @include button-set-fluid-column();\n      }\n    }\n  }\n\n  @container (width <= #{4 * $min-inline-button-size}) {\n    .#{$prefix}--btn-set__fluid-inner#{has-n-children(2)} {\n      .#{$prefix}--btn {\n        flex-basis: 50%;\n        max-inline-size: none;\n      }\n    }\n  }\n\n  @container (width <= #{3 * $min-inline-button-size}) {\n    .#{$prefix}--btn-set__fluid-inner#{has-n-children(1)} .#{$prefix}--btn {\n      flex: 1 1 100%;\n      max-inline-size: none;\n    }\n  }\n}\n\n@mixin button {\n  .#{$prefix}--btn {\n    @include layout.use('size', $min: 'xs', $default: 'lg', $max: '2xl');\n    @include layout.use('density', $default: 'normal');\n\n    @include button-base;\n  }\n\n  // Reset intrinsic padding in Firefox (see #731)\n  .#{$prefix}--btn::-moz-focus-inner {\n    padding: 0;\n    border: 0;\n  }\n\n  .#{$prefix}--btn--primary {\n    @include button-theme(\n      $button-primary,\n      transparent,\n      $text-on-color,\n      $button-primary-hover,\n      currentColor,\n      $button-primary-active\n    );\n\n    &:hover {\n      color: $text-on-color;\n    }\n  }\n\n  .#{$prefix}--btn--secondary {\n    @include button-theme(\n      $button-secondary,\n      transparent,\n      $text-on-color,\n      $button-secondary-hover,\n      currentColor,\n      $button-secondary-active\n    );\n\n    &:hover,\n    &:focus {\n      color: $text-on-color;\n    }\n  }\n\n  .#{$prefix}--btn--tertiary {\n    @include button-theme(\n      transparent,\n      $button-tertiary,\n      $button-tertiary,\n      $button-tertiary-hover,\n      currentColor,\n      $button-tertiary-active\n    );\n\n    &:hover {\n      color: $text-inverse;\n    }\n\n    &:focus {\n      background-color: $button-tertiary;\n      color: $text-inverse;\n    }\n\n    &:active {\n      border-color: transparent;\n      background-color: $button-tertiary-active;\n      color: $text-inverse;\n    }\n\n    &:disabled,\n    &:hover:disabled,\n    &:focus:disabled,\n    &.#{$prefix}--btn--disabled,\n    &.#{$prefix}--btn--disabled:hover,\n    &.#{$prefix}--btn--disabled:focus {\n      background: transparent;\n      color: $text-disabled;\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--btn--ghost {\n    @include button-theme(\n      transparent,\n      transparent,\n      $link-primary,\n      $background-hover,\n      currentColor,\n      $background-active\n    );\n\n    padding-inline-end: calc(\n      layout.density('padding-inline') - convert.to-rem(1px)\n    );\n\n    .#{$prefix}--btn__icon {\n      position: static;\n      align-self: center;\n      margin-inline-start: $spacing-03;\n    }\n\n    &:hover,\n    &:active {\n      color: $link-primary-hover;\n    }\n\n    &:active {\n      background-color: $background-active;\n    }\n\n    &:disabled,\n    &:hover:disabled,\n    &:focus:disabled,\n    &.#{$prefix}--btn--disabled,\n    &.#{$prefix}--btn--disabled:hover,\n    &.#{$prefix}--btn--disabled:focus {\n      border-color: transparent;\n      background: transparent;\n      color: $text-disabled;\n      outline: none;\n    }\n\n    &:not([disabled]) svg {\n      fill: $icon-primary;\n    }\n  }\n\n  .#{$prefix}--btn--icon-only {\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    block-size: layout.size('height');\n    inline-size: layout.size('height');\n    padding-block-start: 0;\n\n    > :first-child {\n      min-inline-size: convert.to-rem(16px);\n    }\n\n    .#{$prefix}--btn__icon {\n      position: static;\n    }\n\n    &.#{$prefix}--btn--ghost {\n      &:focus {\n        background-color: $background-active;\n        box-shadow: inset 0 0 0 $button-outline-width $button-focus-color;\n      }\n    }\n\n    &.#{$prefix}--btn--ghost .#{$prefix}--btn__icon,\n    &.#{$prefix}--btn--danger--ghost .#{$prefix}--btn__icon {\n      margin: 0;\n    }\n\n    &.#{$prefix}--btn--danger--ghost {\n      padding-inline-end: calc(\n        layout.density('padding-inline') - convert.to-rem(16px)\n      );\n    }\n  }\n\n  // Adjust text positioning in extra small variant only\n  .#{$prefix}--btn--xs:not(.#{$prefix}--btn--icon-only) {\n    padding-block-start: 1.5px;\n  }\n\n  // Adjust icon positioning in extra small, small, medium variants only\n  .#{$prefix}--btn--xs:not(.#{$prefix}--btn--icon-only) .#{$prefix}--btn__icon,\n  .#{$prefix}--btn--sm:not(.#{$prefix}--btn--icon-only) .#{$prefix}--btn__icon,\n  .#{$prefix}--btn--md:not(.#{$prefix}--btn--icon-only) .#{$prefix}--btn__icon {\n    margin-block-start: 0;\n  }\n\n  .#{$prefix}--btn--icon-only.#{$prefix}--btn--selected {\n    background: $background-selected;\n  }\n\n  .#{$prefix}--btn path[data-icon-path='inner-path'] {\n    fill: none;\n  }\n\n  .#{$prefix}--btn--ghost.#{$prefix}--btn--icon-only\n    .#{$prefix}--btn__icon\n    path:not([data-icon-path]):not([fill='none']),\n  .#{$prefix}--btn--ghost.#{$prefix}--btn--icon-only .#{$prefix}--btn__icon {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--btn--ghost.#{$prefix}--btn--icon-only[disabled]\n    .#{$prefix}--btn__icon\n    path:not([data-icon-path]):not([fill='none']),\n  .#{$prefix}--btn--ghost.#{$prefix}--btn--icon-only[disabled]\n    .#{$prefix}--btn__icon,\n  .#{$prefix}--btn.#{$prefix}--btn--icon-only.#{$prefix}--btn--ghost[disabled]:hover\n    .#{$prefix}--btn__icon {\n    fill: $icon-on-color-disabled;\n  }\n\n  .#{$prefix}--btn--ghost.#{$prefix}--btn--icon-only[disabled] {\n    cursor: not-allowed;\n  }\n\n  // Workaround to ensure onMouseEnter events fire when moving\n  // from a disabled button to a non-disabled button (#13815)\n  .#{$prefix}--icon-tooltip--disabled .#{$prefix}--tooltip-trigger__wrapper {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--icon-tooltip--disabled .#{$prefix}--btn--icon-only[disabled] {\n    pointer-events: none;\n  }\n\n  .#{$prefix}--btn--danger {\n    @include button-theme(\n      $button-danger-primary,\n      transparent,\n      $text-on-color,\n      $button-danger-hover,\n      currentColor,\n      $button-danger-active\n    );\n\n    &:hover {\n      color: $text-on-color;\n    }\n\n    &--tertiary {\n      @include button-theme(\n        transparent,\n        $button-danger-secondary,\n        $button-danger-secondary,\n        $button-danger-hover,\n        currentColor,\n        $button-danger-active\n      );\n\n      &:hover {\n        border-color: $button-danger-hover;\n        color: $text-on-color;\n      }\n\n      &:focus {\n        background-color: $button-danger-primary;\n        color: $text-on-color;\n      }\n\n      &:active {\n        border-color: $button-danger-active;\n        background-color: $button-danger-active;\n        color: $text-on-color;\n      }\n\n      &:disabled,\n      &:hover:disabled,\n      &:focus:disabled,\n      &.#{$prefix}--btn--disabled,\n      &.#{$prefix}--btn--disabled:hover,\n      &.#{$prefix}--btn--disabled:focus {\n        background: transparent;\n        color: $text-disabled;\n        outline: none;\n      }\n    }\n\n    &--ghost {\n      @include button-theme(\n        transparent,\n        transparent,\n        $button-danger-secondary,\n        $button-danger-hover,\n        currentColor,\n        $button-danger-active\n      );\n\n      padding-inline-end: calc(\n        layout.density('padding-inline') - convert.to-rem(1px)\n      );\n\n      .#{$prefix}--btn__icon {\n        position: static;\n        margin-inline-start: $spacing-03;\n      }\n\n      &:hover,\n      &:active {\n        color: $text-on-color;\n      }\n\n      &:disabled,\n      &:hover:disabled,\n      &:focus:disabled,\n      &.#{$prefix}--btn--disabled,\n      &.#{$prefix}--btn--disabled:hover,\n      &.#{$prefix}--btn--disabled:focus {\n        border-color: transparent;\n        background: transparent;\n        color: $text-disabled;\n        outline: none;\n      }\n    }\n  }\n\n  //expressive styles\n  .#{$prefix}--btn--expressive {\n    @include type-style('body-compact-02');\n\n    padding-block: min(\n      calc(\n        (layout.size('height') - var(--temp-expressive-1lh)) / 2 - convert.to-rem(\n            1px\n          )\n      ),\n      var(--temp-padding-block-max)\n    );\n  }\n\n  .#{$prefix}--btn--icon-only.#{$prefix}--btn--expressive {\n    padding: 12px 13px;\n    //default size 48px\n  }\n\n  .#{$prefix}--btn.#{$prefix}--btn--expressive .#{$prefix}--btn__icon {\n    block-size: convert.to-rem(20px);\n    inline-size: convert.to-rem(20px);\n  }\n\n  .#{$prefix}--btn-set .#{$prefix}--btn.#{$prefix}--btn--expressive {\n    max-inline-size: convert.to-rem(320px);\n  }\n\n  // Skeleton State\n  .#{$prefix}--btn.#{$prefix}--skeleton {\n    @include skeleton;\n\n    inline-size: convert.to-rem(150px);\n  }\n\n  // button set styles\n  .#{$prefix}--btn-set {\n    display: flex;\n  }\n\n  .#{$prefix}--btn-set--stacked {\n    flex-direction: column;\n  }\n\n  .#{$prefix}--btn-set .#{$prefix}--btn {\n    inline-size: 100%;\n    // 196px from design kit\n    max-inline-size: convert.to-rem(196px);\n\n    &:not(:focus) {\n      box-shadow: convert.to-rem(-1px) 0 0 0 $button-separator;\n    }\n\n    &:first-of-type:not(:focus) {\n      box-shadow: inherit;\n    }\n  }\n\n  .#{$prefix}--btn-set .#{$prefix}--btn:focus + .#{$prefix}--btn {\n    box-shadow: inherit;\n  }\n\n  .#{$prefix}--btn-set--stacked .#{$prefix}--btn:not(:focus) {\n    box-shadow: 0 convert.to-rem(-1px) 0 0 $button-separator;\n  }\n\n  .#{$prefix}--btn-set--stacked .#{$prefix}--btn:first-of-type:not(:focus) {\n    box-shadow: inherit;\n  }\n\n  .#{$prefix}--btn-set .#{$prefix}--btn.#{$prefix}--btn--disabled {\n    box-shadow: convert.to-rem(-1px) 0 0 0 $icon-on-color-disabled;\n\n    &:first-of-type {\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--btn-set--stacked .#{$prefix}--btn.#{$prefix}--btn--disabled {\n    box-shadow: 0 convert.to-rem(-1px) 0 0 $layer-selected-disabled;\n\n    &:first-of-type {\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--btn-set .#{$prefix}--btn.#{$prefix}--btn--loading {\n    border-color: transparent;\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  // badge indicator\n\n  .#{$prefix}--btn--sm .#{$prefix}--badge-indicator {\n    margin-block-start: $spacing-02;\n    margin-inline-end: $spacing-02;\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--btn:focus {\n    @include high-contrast-mode('focus');\n  }\n\n  // RTL overrides\n  [dir='rtl'] .#{$prefix}--btn-set .#{$prefix}--btn:not(:focus) {\n    box-shadow: convert.to-rem(1px) 0 0 0 $button-separator;\n  }\n\n  .#{$prefix}--btn-set--fluid {\n    @include button-set-fluid-layout();\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n\n@use 'vars' as *;\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/custom-property';\n@use '../../utilities/layout';\n@use 'tokens' as *;\n\n$button-focus-color: custom-property.get-var('button-focus-color', $focus);\n\n@mixin button-base {\n  // https://caniuse.com/mdn-css_types_length_lh\n  --temp-1lh: (\n    #{custom-property.get-var(\n        'body-compact-01-line-height',\n        map.get($body-compact-01, line-height)\n      )} * 1em\n  );\n  --temp-expressive-1lh: (\n    #{custom-property.get-var(\n        'body-compact-02-line-height',\n        map.get($body-compact-02, line-height)\n      )} * 1em\n  );\n  // -1px to compensate for border width\n  --temp-padding-block-max: calc(\n    (#{custom-property.get-var('layout-size-height-lg')} - var(--temp-1lh)) / 2 -\n      #{convert.to-rem(1px)}\n  );\n\n  @include component-reset.reset;\n  @include type-style('body-compact-01');\n\n  position: relative;\n  display: inline-flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  border-radius: $button-border-radius;\n  // Fix to remove added margins on buttons in safari (see #5155)\n  margin: 0;\n  cursor: pointer;\n  inline-size: max-content;\n  max-inline-size: convert.to-rem(320px);\n  min-block-size: layout.size('height');\n  outline: none;\n  // -1px to compensate for border width\n  padding-block: min(\n    calc((layout.size('height') - var(--temp-1lh)) / 2 - convert.to-rem(1px)),\n    var(--temp-padding-block-max)\n  );\n  padding-inline: calc(layout.density('padding-inline') - convert.to-rem(1px))\n    calc(\n      layout.density('padding-inline') * 3 + convert.to-rem(16px) - convert.to-rem(\n          1px\n        )\n    );\n  text-align: start;\n  text-decoration: none;\n  transition:\n    background $duration-fast-01 motion(entrance, productive),\n    box-shadow $duration-fast-01 motion(entrance, productive),\n    border-color $duration-fast-01 motion(entrance, productive),\n    outline $duration-fast-01 motion(entrance, productive);\n  vertical-align: top;\n\n  &:disabled,\n  &:hover:disabled,\n  &:focus:disabled,\n  &.#{$prefix}--btn--disabled,\n  &.#{$prefix}--btn--disabled:hover,\n  &.#{$prefix}--btn--disabled:focus {\n    border-color: $button-disabled;\n    background: $button-disabled;\n    box-shadow: none;\n    color: $text-on-color-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--btn__icon {\n    position: absolute;\n    flex-shrink: 0;\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(16px);\n    // -1px to compensate for border width\n    inset-block-start: min(\n      calc(\n        (layout.size('height') - convert.to-rem(16px)) / 2 - convert.to-rem(1px)\n      ),\n      var(--temp-padding-block-max)\n    );\n    inset-inline-end: layout.density('padding-inline');\n    margin-block-start: convert.to-rem(1px);\n  }\n}\n\n/// Button variant styles\n/// @access private\n/// @group button\n@mixin button-theme(\n  $bg-color,\n  $border-color,\n  $font-color,\n  $hover-bg-color,\n  $icon-color,\n  $active-color\n) {\n  border-width: $button-outline-width;\n  border-style: solid;\n  border-color: $border-color;\n  background-color: $bg-color;\n  color: $font-color;\n\n  &:hover {\n    background-color: $hover-bg-color;\n  }\n\n  &:focus {\n    border-color: $button-focus-color;\n    box-shadow:\n      inset 0 0 0 $button-outline-width $button-focus-color,\n      inset 0 0 0 $button-border-width $background;\n  }\n\n  &:active {\n    background-color: $active-color;\n  }\n\n  .#{$prefix}--btn__icon,\n  .#{$prefix}--btn__icon path:not([data-icon-path]):not([fill='none']) {\n    fill: $icon-color;\n  }\n}\n\n@mixin button-padding-large {\n  align-items: baseline;\n  padding-block-start: $spacing-05;\n  padding-inline: $spacing-05 $spacing-10;\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../spacing' as *;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-font-weight: 400 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-font-size: 0.875rem !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-border-radius: 0 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-height: 3rem !default;\n\n/// @type Value\n/// @access public\n/// @group button\n$button-padding: calc(0.875rem - 3px) calc(#{$spacing-10} - 1px)\n  calc(0.875rem - 3px) calc(#{$spacing-05} - 1px) !default;\n\n/// @type Value\n/// @access public\n/// @group button\n$button-padding-field: calc(0.675rem - 3px) calc(#{$spacing-10} - 4px)\n  calc(0.675rem - 3px) calc(#{$spacing-05} - 4px) !default;\n\n/// @type Value\n/// @access public\n/// @group button\n$button-padding-sm: calc(0.375rem - 3px) calc(#{$spacing-10} - 4px)\n  calc(0.375rem - 3px) calc(#{$spacing-05} - 4px) !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-padding-lg: $spacing-04 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n/// Uses the same padding-y as normal buttons, but removes extra padding-right\n$button-padding-ghost: calc(0.875rem - 3px) $spacing-05 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n/// Uses the same padding-y as field buttons, but removes extra padding-right\n$button-padding-ghost-field: calc(0.675rem - 3px) $spacing-05 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n/// Uses the same padding-y as small buttons, but removes extra padding-right\n$button-padding-ghost-sm: calc(0.375rem - 3px) $spacing-05 !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-border-width: 2px !default;\n\n/// @type Number\n/// @access public\n/// @group button\n$button-outline-width: 1px !default;\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n@use '../../config';\n@use '../../themes';\n@use '../../utilities/component-tokens';\n@use '@carbon/themes/scss/component-tokens' as button;\n\n$button-separator: (\n  fallback: map.get(button.$button-separator, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-separator, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-separator, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-separator, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-separator, g-100),\n    ),\n  ),\n) !default;\n\n$button-primary: (\n  fallback: map.get(button.$button-primary, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-primary, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-primary, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-primary, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-primary, g-100),\n    ),\n  ),\n) !default;\n\n$button-secondary: (\n  fallback: map.get(button.$button-secondary, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-secondary, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-secondary, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-secondary, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-secondary, g-100),\n    ),\n  ),\n) !default;\n\n$button-tertiary: (\n  fallback: map.get(button.$button-tertiary, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-tertiary, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-tertiary, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-tertiary, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-tertiary, g-100),\n    ),\n  ),\n) !default;\n\n$button-danger-primary: (\n  fallback: map.get(button.$button-danger-primary, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-danger-primary, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-danger-primary, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-danger-primary, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-danger-primary, g-100),\n    ),\n  ),\n) !default;\n\n$button-danger-secondary: (\n  fallback: map.get(button.$button-danger-secondary, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-danger-secondary, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-danger-secondary, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-danger-secondary, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-danger-secondary, g-100),\n    ),\n  ),\n) !default;\n\n$button-danger-active: (\n  fallback: map.get(button.$button-danger-active, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-danger-active, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-danger-active, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-danger-active, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-danger-active, g-100),\n    ),\n  ),\n) !default;\n\n$button-primary-active: (\n  fallback: map.get(button.$button-primary-active, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-primary-active, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-primary-active, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-primary-active, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-primary-active, g-100),\n    ),\n  ),\n) !default;\n\n$button-secondary-active: (\n  fallback: map.get(button.$button-secondary-active, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-secondary-active, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-secondary-active, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-secondary-active, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-secondary-active, g-100),\n    ),\n  ),\n) !default;\n\n$button-tertiary-active: (\n  fallback: map.get(button.$button-tertiary-active, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-tertiary-active, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-tertiary-active, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-tertiary-active, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-tertiary-active, g-100),\n    ),\n  ),\n) !default;\n\n$button-danger-hover: (\n  fallback: map.get(button.$button-danger-hover, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-danger-hover, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-danger-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-danger-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-danger-hover, g-100),\n    ),\n  ),\n) !default;\n\n$button-primary-hover: (\n  fallback: map.get(button.$button-primary-hover, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-primary-hover, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-primary-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-primary-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-primary-hover, g-100),\n    ),\n  ),\n) !default;\n\n$button-secondary-hover: (\n  fallback: map.get(button.$button-secondary-hover, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-secondary-hover, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-secondary-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-secondary-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-secondary-hover, g-100),\n    ),\n  ),\n) !default;\n\n$button-tertiary-hover: (\n  fallback: map.get(button.$button-tertiary-hover, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-tertiary-hover, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-tertiary-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-tertiary-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-tertiary-hover, g-100),\n    ),\n  ),\n) !default;\n\n$button-disabled: (\n  fallback: map.get(button.$button-disabled, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(button.$button-disabled, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(button.$button-disabled, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(button.$button-disabled, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(button.$button-disabled, g-100),\n    ),\n  ),\n) !default;\n\n$button-tokens: (\n  button-separator: $button-separator,\n  button-primary: $button-primary,\n  button-secondary: $button-secondary,\n  button-tertiary: $button-tertiary,\n  button-danger-primary: $button-danger-primary,\n  button-danger-secondary: $button-danger-secondary,\n  button-danger-active: $button-danger-active,\n  button-primary-active: $button-primary-active,\n  button-secondary-active: $button-secondary-active,\n  button-tertiary-active: $button-tertiary-active,\n  button-danger-hover: $button-danger-hover,\n  button-primary-hover: $button-primary-hover,\n  button-secondary-hover: $button-secondary-hover,\n  button-tertiary-hover: $button-tertiary-hover,\n  button-disabled: $button-disabled,\n);\n\n$button-separator: component-tokens.get-var(\n  $button-separator,\n  'button-separator'\n);\n\n$button-primary: component-tokens.get-var($button-primary, 'button-primary');\n\n$button-secondary: component-tokens.get-var(\n  $button-secondary,\n  'button-secondary'\n);\n\n$button-tertiary: component-tokens.get-var($button-tertiary, 'button-tertiary');\n\n$button-danger-primary: component-tokens.get-var(\n  $button-danger-primary,\n  'button-danger-primary'\n);\n\n$button-danger-secondary: component-tokens.get-var(\n  $button-danger-secondary,\n  'button-danger-secondary'\n);\n\n$button-danger-active: component-tokens.get-var(\n  $button-danger-active,\n  'button-danger-active'\n);\n\n$button-primary-active: component-tokens.get-var(\n  $button-primary-active,\n  'button-primary-active'\n);\n\n$button-secondary-active: component-tokens.get-var(\n  $button-secondary-active,\n  'button-secondary-active'\n);\n\n$button-tertiary-active: component-tokens.get-var(\n  $button-tertiary-active,\n  'button-tertiary-active'\n);\n\n$button-danger-hover: component-tokens.get-var(\n  $button-danger-hover,\n  'button-danger-hover'\n);\n\n$button-primary-hover: component-tokens.get-var(\n  $button-primary-hover,\n  'button-primary-hover'\n);\n\n$button-secondary-hover: component-tokens.get-var(\n  $button-secondary-hover,\n  'button-secondary-hover'\n);\n\n$button-tertiary-hover: component-tokens.get-var(\n  $button-tertiary-hover,\n  'button-tertiary-hover'\n);\n\n$button-disabled: component-tokens.get-var($button-disabled, 'button-disabled');\n","// Code generated by @carbon/layout. DO NOT EDIT.\n//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-01: 0.125rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-02: 0.25rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-03: 0.5rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-04: 0.75rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-05: 1rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-06: 1.5rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-07: 2rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-08: 2.5rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-09: 3rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-10: 4rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-11: 5rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-12: 6rem !default;\n\n/// @type Number\n/// @access public\n/// @group @carbon/layout\n$spacing-13: 10rem !default;\n\n/// @type Map\n/// @access public\n/// @group @carbon/layout\n$spacing: (\n  spacing-01: $spacing-01,\n  spacing-02: $spacing-02,\n  spacing-03: $spacing-03,\n  spacing-04: $spacing-04,\n  spacing-05: $spacing-05,\n  spacing-06: $spacing-06,\n  spacing-07: $spacing-07,\n  spacing-08: $spacing-08,\n  spacing-09: $spacing-09,\n  spacing-10: $spacing-10,\n  spacing-11: $spacing-11,\n  spacing-12: $spacing-12,\n  spacing-13: $spacing-13,\n);\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'keyframes';\n@use '../theme' as *;\n@use '../config' as *;\n@use '../utilities/high-contrast-mode' as *;\n\n/// Skeleton loading animation\n/// @access public\n/// @example @include skeleton;\n/// @group utilities\n@mixin skeleton {\n  position: relative;\n  padding: 0;\n  border: none;\n  background: $skeleton-background;\n  box-shadow: none;\n  pointer-events: none;\n\n  &:hover,\n  &:focus,\n  &:active {\n    border: none;\n    cursor: default;\n    outline: none;\n  }\n\n  &::before {\n    position: absolute;\n    animation: 3000ms ease-in-out #{$prefix}--skeleton infinite;\n    background: $skeleton-element;\n    block-size: 100%;\n    content: '';\n    inline-size: 100%;\n    inset-inline-start: 0;\n    will-change: transform-origin, transform, opacity;\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n\n  // High Contrast Mode support\n  @include high-contrast-mode {\n    background: CanvasText;\n\n    &::before {\n      background: Canvas;\n      forced-color-adjust: none;\n    }\n  }\n}\n\n/// Circular Skeleton loading animation\n/// @access public\n/// @example @include circular-skeleton;\n/// @group utilities\n@mixin circular-skeleton {\n  position: relative;\n  overflow: hidden;\n  border-radius: 50%;\n  background: $skeleton-background;\n\n  &::before {\n    position: absolute;\n    animation: 3000ms ease-in-out #{$prefix}--skeleton infinite;\n    background: $skeleton-element;\n    block-size: 100%;\n    content: '';\n    inline-size: 200%;\n    will-change: transform-origin, transform, opacity;\n\n    @media (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n\n  //High Contrast Mode\n  //Ensure Skeleton is visible and animated in Windows HCM\n  @include high-contrast-mode {\n    background: CanvasText;\n\n    &::before {\n      background: Canvas;\n      forced-color-adjust: none;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n/// High Contrast Mode mixin for Windows and macOS\n/// @access public\n/// @example @include high-contrast-mode;\n/// @group utilities\n/// Set HCM styles at the end of each file to ensure they are not overwritten\n@mixin high-contrast-mode($type: '') {\n  @media screen and (-ms-high-contrast: active), (forced-colors: active) {\n    @if ($type == 'focus') {\n      color: Highlight;\n      outline: 1px solid Highlight;\n    }\n\n    @if ($type == 'outline') {\n      outline: 1px solid transparent;\n    }\n\n    @if ($type == 'disabled') {\n      color: GrayText;\n      fill: GrayText;\n    }\n\n    @content;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2026\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../../config' as *;\n@use '../../spacing';\n@use '../../theme';\n@use '../../type';\n@use '../../utilities/button-reset';\n@use '../../utilities/convert';\n@use '../../utilities/custom-property';\n@use '../../utilities/focus-outline';\n\n@mixin toggletip() {\n  .#{$prefix}--toggletip-label {\n    @include type.type-style('label-01');\n\n    color: theme.$text-secondary;\n    margin-inline-end: spacing.$spacing-03;\n  }\n  :host([slot='label-text']) .#{$prefix}--toggletip-label {\n    @include type.type-style('label-01');\n  }\n  .#{$prefix}--toggletip-button {\n    @include button-reset.reset();\n\n    display: flex;\n    align-items: center;\n  }\n\n  .#{$prefix}--toggletip-button svg {\n    fill: theme.$icon-secondary;\n  }\n\n  .#{$prefix}--toggletip-button:hover svg,\n  .#{$prefix}--toggletip--open .#{$prefix}--toggletip-button svg {\n    fill: theme.$icon-primary;\n  }\n\n  .#{$prefix}--toggletip-button:focus {\n    @include focus-outline.focus-outline;\n  }\n\n  .#{$prefix}--toggletip {\n    @include custom-property.declaration(\n      'popover-offset',\n      convert.to-rem(13px)\n    );\n  }\n\n  .#{$prefix}--toggletip-content {\n    @include custom-property.declaration(\n      'button-focus-color',\n      theme.$focus-inverse\n    );\n    @include custom-property.declaration(\n      'link-text-color',\n      theme.$link-inverse\n    );\n    @include custom-property.declaration(\n      'link-hover-text-color',\n      theme.$link-inverse-hover\n    );\n    @include custom-property.declaration(\n      'link-visited-text-color',\n      theme.$link-inverse-visited\n    );\n    @include custom-property.declaration(\n      'link-focus-text-color',\n      theme.$focus-inverse\n    );\n    @include type.type-style('body-01');\n\n    display: grid;\n    padding: spacing.$spacing-05;\n    max-inline-size: 18rem;\n    row-gap: spacing.$spacing-05;\n  }\n\n  .#{$prefix}--toggletip-content p {\n    @include type.type-style('body-01');\n  }\n\n  .#{$prefix}--toggletip-actions {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    column-gap: spacing.$spacing-05;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//3\n\n@use '../../config' as *;\n@use '../../feature-flags' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../button/tokens' as button;\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/skeleton' as *;\n\n/// Toggle styles\n/// @access public\n/// @group toggle\n@mixin toggle($enable-v12-toggle-reduced-label-spacing: false) {\n  .#{$prefix}--toggle {\n    display: inline-block;\n    user-select: none;\n  }\n\n  .#{$prefix}--toggle__label-text {\n    @include type-style('label-01');\n\n    display: block;\n    color: $text-secondary;\n    margin-block-end: $spacing-05;\n    @if (\n      enabled('enable-v12-toggle-reduced-label-spacing') or\n        $enable-v12-toggle-reduced-label-spacing\n    ) {\n      margin-block-end: $spacing-03;\n    }\n  }\n\n  .#{$prefix}--toggle__button {\n    @include visually-hidden;\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--toggle__appearance {\n    display: inline-grid;\n    align-items: center;\n    column-gap: $spacing-03;\n    cursor: pointer;\n    grid-template-columns: max-content max-content;\n  }\n\n  .#{$prefix}--toggle__switch {\n    position: relative;\n    border-radius: convert.to-rem(12px);\n    background-color: $toggle-off;\n    block-size: convert.to-rem(24px);\n    inline-size: convert.to-rem(48px);\n    transition: background-color $duration-fast-01 motion(exit, productive);\n\n    &::before {\n      position: absolute;\n      border-radius: 50%;\n      background-color: $icon-on-color;\n      block-size: convert.to-rem(18px);\n      content: '';\n      inline-size: convert.to-rem(18px);\n      inset-block-start: convert.to-rem(3px);\n      inset-inline-start: convert.to-rem(3px);\n      transition: transform $duration-fast-01 motion(exit, productive);\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n\n  .#{$prefix}--toggle__button:focus\n    + .#{$prefix}--toggle__label\n    .#{$prefix}--toggle__switch,\n  .#{$prefix}--toggle:not(.#{$prefix}--toggle--disabled):active\n    .#{$prefix}--toggle__switch {\n    &::after {\n      display: block;\n      border-radius: convert.to-rem(16px);\n      block-size: 100%;\n      content: '';\n      outline: 2px solid $focus;\n      outline-offset: 1px;\n    }\n  }\n\n  .#{$prefix}--toggle__switch--checked {\n    background-color: $support-success;\n\n    &::before {\n      transform: translateX(convert.to-rem(24px));\n    }\n  }\n\n  .#{$prefix}--toggle__text {\n    @include type-style('body-01');\n\n    color: $text-primary;\n  }\n\n  .#{$prefix}--toggle__appearance--sm .#{$prefix}--toggle__switch {\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(32px);\n\n    &::before {\n      block-size: convert.to-rem(10px);\n      inline-size: convert.to-rem(10px);\n    }\n  }\n\n  .#{$prefix}--toggle__appearance--sm\n    .#{$prefix}--toggle__switch--checked::before {\n    transform: translateX(convert.to-rem(16px));\n  }\n\n  .#{$prefix}--toggle__check {\n    position: absolute;\n    block-size: convert.to-rem(5px);\n    fill: $support-success;\n    inline-size: convert.to-rem(6px);\n    inset-block-start: convert.to-rem(6px);\n    inset-inline-end: convert.to-rem(5px);\n    visibility: hidden;\n  }\n\n  .#{$prefix}--toggle__switch--checked .#{$prefix}--toggle__check {\n    visibility: visible;\n  }\n\n  // ----------------------------------------\n  // disabled\n  // ----------------------------------------\n\n  .#{$prefix}--toggle--disabled .#{$prefix}--toggle__appearance {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--toggle--disabled .#{$prefix}--toggle__label-text,\n  .#{$prefix}--toggle--disabled .#{$prefix}--toggle__text {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--toggle--disabled .#{$prefix}--toggle__switch {\n    background-color: button.$button-disabled;\n\n    &::before {\n      background-color: $icon-on-color-disabled;\n    }\n  }\n\n  .#{$prefix}--toggle--disabled .#{$prefix}--toggle__check {\n    fill: button.$button-disabled;\n  }\n\n  // ----------------------------------------\n  // readonly\n  // ----------------------------------------\n  .#{$prefix}--toggle--readonly .#{$prefix}--toggle__appearance {\n    cursor: default;\n  }\n\n  .#{$prefix}--toggle--readonly .#{$prefix}--toggle__switch {\n    border: 1px solid $icon-disabled;\n    background-color: transparent;\n\n    &::before {\n      background-color: $icon-primary;\n      inset-block-start: convert.to-rem(2px);\n      inset-inline-start: convert.to-rem(2px);\n    }\n  }\n\n  .#{$prefix}--toggle--readonly .#{$prefix}--toggle__check {\n    fill: $background;\n    inset-block-start: convert.to-rem(5px);\n    inset-inline-end: convert.to-rem(4px);\n  }\n\n  .#{$prefix}--toggle--readonly .#{$prefix}--toggle__text {\n    cursor: text;\n    user-select: text;\n  }\n\n  // HCM\n\n  .#{$prefix}--toggle__switch,\n  .#{$prefix}--toggle__switch::before {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--toggle__button:focus\n    + .#{$prefix}--toggle__label\n    .#{$prefix}--toggle__switch,\n  .#{$prefix}--toggle:not(.#{$prefix}--toggle--disabled):active\n    .#{$prefix}--toggle__switch {\n    @include high-contrast-mode('focus');\n  }\n\n  // Skeleton state\n  .#{$prefix}--toggle--skeleton {\n    display: flex;\n    align-items: center;\n  }\n\n  .#{$prefix}--toggle--skeleton .#{$prefix}--toggle__skeleton-circle {\n    @include circular-skeleton;\n\n    border-radius: 50%;\n    block-size: convert.to-rem(18px);\n    inline-size: convert.to-rem(18px);\n  }\n\n  .#{$prefix}--toggle--skeleton .#{$prefix}--toggle__skeleton-rectangle {\n    @include skeleton;\n\n    block-size: convert.to-rem(8px);\n    inline-size: convert.to-rem(24px);\n    margin-inline-start: convert.to-rem(8px);\n  }\n\n  // RTL overrides\n  [dir='rtl'] .#{$prefix}--toggle__switch--checked::before {\n    transform: translateX(convert.to-rem(-24px));\n  }\n\n  [dir='rtl']\n    .#{$prefix}--toggle__appearance--sm\n    .#{$prefix}--toggle__switch--checked::before {\n    transform: translateX(convert.to-rem(-16px));\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button' as button;\n@use '../tooltip';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/component-reset';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/convert';\n@use '../../utilities/z-index' as *;\n@use '../../utilities/custom-property';\n\n/// Overflow menu styles\n/// @access public\n/// @group overflow-menu\n@mixin overflow-menu {\n  .#{$prefix}--overflow-menu,\n  .#{$prefix}--overflow-menu__trigger {\n    @include button-reset.reset;\n    @include component-reset.reset;\n    @include focus-outline('reset');\n\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: $spacing-08;\n    cursor: pointer;\n    inline-size: $spacing-08;\n    min-block-size: $spacing-08;\n    transition:\n      outline $duration-fast-02 motion(entrance, productive),\n      background-color $duration-fast-02 motion(entrance, productive);\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n\n    &:hover {\n      background-color: $background-hover;\n    }\n  }\n\n  .#{$prefix}--overflow-menu > :first-child {\n    margin-block-start: 0;\n  }\n\n  .#{$prefix}--overflow-menu--xs {\n    block-size: $spacing-06;\n    inline-size: $spacing-06;\n    min-block-size: $spacing-06;\n  }\n\n  .#{$prefix}--overflow-menu--sm {\n    block-size: $spacing-07;\n    inline-size: $spacing-07;\n    min-block-size: $spacing-07;\n  }\n\n  .#{$prefix}--overflow-menu--lg {\n    block-size: $spacing-09;\n    inline-size: $spacing-09;\n  }\n\n  // Overwrite Icon Tooltip focus styles\n  .#{$prefix}--overflow-menu__trigger.#{$prefix}--tooltip--a11y.#{$prefix}--tooltip__trigger:focus {\n    @include focus-outline('outline');\n\n    svg {\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--open,\n  .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--open\n    .#{$prefix}--overflow-menu__trigger {\n    @include box-shadow;\n\n    background-color: $layer;\n    transition: none;\n  }\n\n  .#{$prefix}--overflow-menu--light.#{$prefix}--overflow-menu--open,\n  .#{$prefix}--overflow-menu--light.#{$prefix}--overflow-menu--open\n    .#{$prefix}--overflow-menu__trigger {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--overflow-menu__icon {\n    block-size: $spacing-05;\n    fill: $icon-primary;\n    inline-size: $spacing-05;\n  }\n\n  .#{$prefix}--overflow-menu__wrapper {\n    line-height: 0;\n  }\n\n  .#{$prefix}--overflow-menu-options {\n    @include component-reset.reset;\n    @include box-shadow;\n\n    position: absolute;\n    z-index: z('floating');\n    display: none;\n    flex-direction: column;\n    align-items: flex-start;\n    background-color: $layer;\n    inline-size: $spacing-13;\n    inset-block-start: $spacing-07;\n    inset-inline-start: 0;\n    list-style: none;\n\n    &::after {\n      position: absolute;\n      display: block;\n      background-color: $layer;\n      content: '';\n      transition: background-color $duration-fast-02\n        motion(entrance, productive);\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n\n  .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--open:hover {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--overflow-menu-options--light {\n    background-color: $layer-hover;\n\n    &::after {\n      background-color: $layer;\n    }\n  }\n\n  .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--light.#{$prefix}--overflow-menu--open:hover {\n    background-color: $layer-hover;\n  }\n\n  .#{$prefix}--overflow-menu-options[data-floating-menu-direction='bottom']:not(\n      .#{$prefix}--breadcrumb-menu-options\n    )::after {\n    block-size: convert.to-rem(3px);\n    inline-size: $spacing-08;\n    inset-block-start: convert.to-rem(-3px);\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--overflow-menu-options[data-floating-menu-direction='top']::after {\n    block-size: $spacing-03;\n    inline-size: $spacing-08;\n    inset-block-end: -$spacing-03;\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--overflow-menu-options[data-floating-menu-direction='left']::after {\n    block-size: $spacing-08;\n    inline-size: convert.to-rem(6px);\n    inset-block-start: 0;\n    inset-inline-end: convert.to-rem(-6px);\n  }\n\n  .#{$prefix}--overflow-menu-options[data-floating-menu-direction='right']::after {\n    block-size: $spacing-08;\n    inline-size: convert.to-rem(6px);\n    inset-block-start: 0;\n    inset-inline-start: convert.to-rem(-6px);\n  }\n\n  .#{$prefix}--overflow-menu-options--xs.#{$prefix}--overflow-menu-options {\n    &[data-floating-menu-direction='bottom']::after,\n    &[data-floating-menu-direction='top']::after {\n      inline-size: $spacing-06;\n    }\n\n    &[data-floating-menu-direction='left']::after,\n    &[data-floating-menu-direction='right']::after {\n      block-size: $spacing-06;\n    }\n  }\n\n  .#{$prefix}--overflow-menu-options--sm.#{$prefix}--overflow-menu-options {\n    &[data-floating-menu-direction='bottom']::after,\n    &[data-floating-menu-direction='top']::after {\n      inline-size: $spacing-07;\n    }\n\n    &[data-floating-menu-direction='left']::after,\n    &[data-floating-menu-direction='right']::after {\n      block-size: $spacing-07;\n    }\n  }\n\n  .#{$prefix}--overflow-menu-options--lg.#{$prefix}--overflow-menu-options {\n    &[data-floating-menu-direction='bottom']::after,\n    &[data-floating-menu-direction='top']::after {\n      inline-size: $spacing-09;\n    }\n\n    &[data-floating-menu-direction='left']::after,\n    &[data-floating-menu-direction='right']::after {\n      block-size: $spacing-09;\n    }\n  }\n\n  .#{$prefix}--overflow-menu--flip.#{$prefix}--overflow-menu-options[data-floating-menu-direction='top']::after,\n  .#{$prefix}--overflow-menu--flip.#{$prefix}--overflow-menu-options[data-floating-menu-direction='bottom']::after {\n    inset-inline: auto 0;\n  }\n\n  .#{$prefix}--overflow-menu--flip.#{$prefix}--overflow-menu-options[data-floating-menu-direction='left']::after,\n  .#{$prefix}--overflow-menu--flip.#{$prefix}--overflow-menu-options[data-floating-menu-direction='right']::after {\n    inset-block: auto 0;\n  }\n\n  .#{$prefix}--overflow-menu-options--open {\n    display: flex;\n  }\n\n  .#{$prefix}--overflow-menu-options__content {\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--overflow-menu-options__option {\n    @include component-reset.reset;\n\n    display: flex;\n    align-items: center;\n    padding: 0;\n    background-color: transparent;\n    block-size: $spacing-08;\n    inline-size: 100%;\n    transition: background-color $duration-fast-02 motion(entrance, productive);\n  }\n\n  .#{$prefix}--overflow-menu-options--xs\n    .#{$prefix}--overflow-menu-options__option {\n    block-size: $spacing-06;\n  }\n\n  .#{$prefix}--overflow-menu-options--sm\n    .#{$prefix}--overflow-menu-options__option {\n    block-size: $spacing-07;\n  }\n\n  .#{$prefix}--overflow-menu-options--lg\n    .#{$prefix}--overflow-menu-options__option {\n    block-size: $spacing-09;\n  }\n\n  .#{$prefix}--overflow-menu--divider {\n    border-block-start: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--overflow-menu--light .#{$prefix}--overflow-menu--divider {\n    border-block-start: 1px solid $border-subtle;\n  }\n\n  a.#{$prefix}--overflow-menu-options__btn::before {\n    display: inline-block;\n    block-size: 100%;\n    content: '';\n    vertical-align: middle;\n  }\n\n  .#{$prefix}--overflow-menu-options__btn {\n    @include type-style('body-compact-01');\n    @include focus-outline('reset');\n\n    display: inline-flex;\n    align-items: center;\n    padding: 0 $spacing-05;\n    border: none;\n    background-color: transparent;\n    block-size: 100%;\n    color: $text-secondary;\n    cursor: pointer;\n    font-family: inherit;\n    font-weight: 400;\n    inline-size: 100%;\n    max-inline-size: 11.25rem;\n    text-align: start;\n    transition:\n      outline $duration-fast-02 motion(entrance, productive),\n      background-color $duration-fast-02 motion(entrance, productive),\n      color $duration-fast-02 motion(entrance, productive);\n\n    &:hover {\n      color: $text-primary;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n\n    &::-moz-focus-inner {\n      border: none;\n    }\n  }\n\n  .#{$prefix}--overflow-menu-options__btn svg {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--overflow-menu-options__btn:hover svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--overflow-menu-options__option-content {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--overflow-menu-options__option:hover {\n    background-color: $layer-hover;\n  }\n\n  .#{$prefix}--overflow-menu-options__option--danger\n    .#{$prefix}--overflow-menu-options__btn:hover,\n  .#{$prefix}--overflow-menu-options__option--danger\n    .#{$prefix}--overflow-menu-options__btn:focus {\n    background-color: button.$button-danger-primary;\n    color: $text-on-color;\n\n    svg {\n      fill: currentColor;\n    }\n  }\n\n  .#{$prefix}--overflow-menu-options__option--disabled:hover {\n    background-color: $layer;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--overflow-menu-options__option--disabled\n    .#{$prefix}--overflow-menu-options__btn {\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    &:hover,\n    &:active,\n    &:focus {\n      @include focus-outline('reset');\n\n      background-color: $layer;\n      color: $text-disabled;\n    }\n  }\n\n  .#{$prefix}--overflow-menu-options__option--disabled\n    .#{$prefix}--overflow-menu-options__btn\n    svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--overflow-menu--flip {\n    inset-inline-start: -140px;\n\n    &::before {\n      inset-inline-start: 145px;\n    }\n  }\n\n  // Windows HCM fix\n  /* stylelint-disable */\n  .#{$prefix}--overflow-menu:focus,\n  .#{$prefix}--overflow-menu-options__btn:focus {\n    @include high-contrast-mode('focus');\n  }\n  /*stylelint-enable */\n\n  $popover-offset: custom-property.get-var('popover-offset', 2.5rem);\n\n  .#{$prefix}--overflow-menu__top-start {\n    transform: translate(0, calc(-100% - $popover-offset));\n  }\n\n  .#{$prefix}--overflow-menu__top-end {\n    transform: translate(0, calc(-100% - $popover-offset));\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../theme';\n\n/// Adds box shadow\n/// @access public\n/// @example @include box-shadow;\n/// @group utilities\n@mixin box-shadow {\n  box-shadow: 0 2px 6px theme.$shadow;\n}\n\n@mixin box-shadow-top {\n  box-shadow: 0 -2px 6px theme.$shadow;\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../../config' as *;\n@use '../../feature-flags' as *;\n@use '../../breakpoint' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/convert';\n@use '../../utilities/component-reset';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/update_fields_on_layer' as *;\n@use '../../utilities/z-index' as *;\n\n/// Modal styles\n/// @access public\n/// @group modal\n@mixin modal(\n  $enable-experimental-focus-wrap-without-sentinels: false,\n  $enable-focus-wrap-without-sentinels: false,\n  $enable-dialog-element: false,\n  $enable-presence: false\n) {\n  .#{$prefix}--modal {\n    // For modals using the native dialog element, the modal visibility is handled\n    // by the Dialog styles.\n    @if not(\n      enabled('enable-experimental-focus-wrap-without-sentinels') or\n        $enable-experimental-focus-wrap-without-sentinels or\n        enabled('enable-focus-wrap-without-sentinels') or\n        $enable-focus-wrap-without-sentinels or\n        enabled('enable-dialog-element') or\n        $enable-dialog-element\n    )\n    {\n      position: fixed;\n      z-index: z('modal');\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background-color: $overlay;\n      block-size: 100vh;\n      content: '';\n      inline-size: 100vw;\n      inset-block-start: 0;\n      inset-inline-start: 0;\n\n      &.#{$prefix}--modal--enable-presence {\n        @include modal-animations($has-presence: true);\n      }\n\n      &:not(.#{$prefix}--modal--enable-presence) {\n        @include modal-animations(\n          $has-presence: enabled('enable-presence') or $enable-presence\n        );\n      }\n    }\n\n    @include update_fields_on_layer;\n  }\n\n  // For modals using the native dialog element, the modal visibility is handled\n  // by the Dialog styles.\n  @if not(\n    enabled('enable-experimental-focus-wrap-without-sentinels') or\n      $enable-experimental-focus-wrap-without-sentinels or\n      enabled('enable-focus-wrap-without-sentinels') or\n      $enable-focus-wrap-without-sentinels or\n      enabled('enable-dialog-element') or\n      $enable-dialog-element\n  )\n  {\n    .#{$prefix}--modal--enable-presence {\n      @include modal-container-animations($has-presence: true);\n    }\n\n    :not(.#{$prefix}--modal--enable-presence) {\n      @include modal-container-animations(\n        $has-presence: enabled('enable-presence') or $enable-presence\n      );\n    }\n  }\n\n  // -----------------------------\n  // Modal container\n  // -----------------------------\n  .#{$prefix}--modal-container {\n    position: fixed;\n    display: grid;\n    border: 1px solid $border-subtle-01;\n    background-color: $layer;\n    grid-template-columns: 100%;\n    grid-template-rows: auto 1fr auto;\n    inline-size: 100%;\n    inset-block-start: 0;\n    max-block-size: 100%;\n    // make modal edge visible on high contrast themes (#3880)\n    outline: 3px solid transparent;\n    outline-offset: -3px;\n    transform-origin: top center;\n\n    @include breakpoint(md) {\n      position: relative;\n      inline-size: 84%;\n      max-block-size: 90%;\n    }\n\n    @include breakpoint(lg) {\n      inline-size: 60%;\n      max-block-size: 84%;\n    }\n\n    @include breakpoint(xlg) {\n      inline-size: 48%;\n    }\n\n    .#{$prefix}--modal-container-body {\n      display: contents;\n    }\n  }\n\n  // -----------------------------\n  // Modal content\n  // -----------------------------\n  .#{$prefix}--modal-content {\n    @include type-style('body-01');\n\n    position: relative;\n    color: $text-primary;\n    font-weight: 400;\n    grid-column: 1/-1;\n    grid-row: 2/-2;\n    overflow-y: auto;\n    padding-block: $spacing-03 $spacing-09;\n    // Required to accommodate focus outline's negative offset:\n    // anything besides text/p spans full width, with just 16px padding\n    padding-inline: $spacing-05 $spacing-05;\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  // fluid form in modal\n  .#{$prefix}--modal-content .#{$prefix}--form--fluid {\n    margin-inline: -$spacing-05 - $spacing-05;\n  }\n\n  // TODO: remove .#{$prefix}--modal-content__regular-content in v11 since hasForm has been deprecated\n  // text/p gets 20% right padding\n  .#{$prefix}--modal-content > p,\n  .#{$prefix}--modal-content__regular-content {\n    @include type-style('body-01');\n    // padding should take into account the left and right padding of modal container\n    padding-inline-end: calc(20% - $spacing-07);\n  }\n\n  // TODO: remove .#{$prefix}--modal-content--with-form in v11 since hasForm has been deprecated\\\n  // anything besides text/p spans full width, with just 16px padding\n  .#{$prefix}--modal-content--with-form {\n    padding-inline-end: $spacing-05;\n  }\n\n  // -----------------------------\n  // Modal header\n  // -----------------------------\n  .#{$prefix}--modal-header {\n    grid-column: 1/-1;\n    grid-row: 1/1;\n    margin-block-end: $spacing-03;\n    max-block-size: 50vh;\n    overflow-y: auto;\n    padding-block-start: $spacing-05;\n    padding-inline: $spacing-05 $spacing-09;\n  }\n\n  .#{$prefix}--modal-header__label {\n    @include component-reset.reset;\n    @include type-style('label-01');\n\n    color: $text-secondary;\n    margin-block-end: $spacing-02;\n  }\n\n  .#{$prefix}--modal-header__heading {\n    @include component-reset.reset;\n    @include type-style('heading-03');\n\n    color: $text-primary;\n    // padding should take into account the left and right padding of modal container\n    padding-inline-end: calc(20% - $spacing-09);\n  }\n\n  // -----------------------------\n  // XS Modal\n  // -----------------------------\n  .#{$prefix}--modal-container--xs {\n    //text always spans full width in xs modals\n    .#{$prefix}--modal-content__regular-content {\n      padding-inline-end: $spacing-05;\n    }\n\n    .#{$prefix}--modal-content > p {\n      //.#{$prefix}--modal-content already has 16px padding so this doesn't need any\n      padding-inline-end: 0;\n    }\n\n    @include breakpoint(md) {\n      inline-size: 48%;\n    }\n\n    @include breakpoint(lg) {\n      inline-size: 32%;\n      max-block-size: 48%;\n    }\n\n    @include breakpoint(xlg) {\n      inline-size: 24%;\n    }\n  }\n\n  // -----------------------------\n  // SM Modal\n  // -----------------------------\n  .#{$prefix}--modal-container--sm {\n    //text spans full width in sm modals below 1056\n    .#{$prefix}--modal-content__regular-content {\n      padding-inline-end: $spacing-05;\n    }\n\n    .#{$prefix}--modal-content > p {\n      //.#{$prefix}--modal-content already has 16px padding so this doesn't need any\n      padding-inline-end: 0;\n    }\n\n    @include breakpoint(md) {\n      inline-size: 60%;\n    }\n\n    @include breakpoint(lg) {\n      inline-size: 42%;\n      max-block-size: 72%;\n\n      .#{$prefix}--modal-content > p,\n      .#{$prefix}--modal-content__regular-content {\n        padding-inline-end: 20%;\n      }\n    }\n\n    @include breakpoint(xlg) {\n      inline-size: 36%;\n    }\n  }\n\n  // -----------------------------\n  // LG Modal\n  // -----------------------------\n  .#{$prefix}--modal-container--lg {\n    @include breakpoint(md) {\n      inline-size: 96%;\n    }\n\n    @include breakpoint(lg) {\n      inline-size: 84%;\n      max-block-size: 96%;\n    }\n\n    @include breakpoint(xlg) {\n      inline-size: 72%;\n    }\n  }\n\n  // -----------------------------\n  // Modal overflow\n  // -----------------------------\n  .#{$prefix}--modal-scroll-content {\n    // Required to accommodate focus outline's negative offset when scrolling in Chrome\n    border-block-end: 2px solid transparent;\n    mask-image: linear-gradient(\n        to bottom,\n        $layer calc(100% - 80px),\n        transparent calc(100% - 48px),\n        transparent 100%\n      ),\n      linear-gradient(to left, $layer 0, 16px, transparent 16px),\n      linear-gradient(to right, $layer 0, 2px, transparent 2px),\n      linear-gradient(to top, $layer 0, 2px, transparent 2px);\n  }\n\n  .#{$prefix}--modal--slug\n    .#{$prefix}--modal-content.#{$prefix}--modal-scroll-content.#{$prefix}--modal-scroll-content--no-fade,\n  .#{$prefix}--modal--decorator\n    .#{$prefix}--modal-content.#{$prefix}--modal-scroll-content.#{$prefix}--modal-scroll-content--no-fade,\n  .#{$prefix}--modal-scroll-content.#{$prefix}--modal-scroll-content--no-fade,\n  .#{$prefix}--modal-scroll-content--no-fade {\n    mask-image: none;\n  }\n\n  //removing mask image in case we have dropdown in modal\n  .#{$prefix}--modal-scroll-content:has(.#{$prefix}--autoalign) {\n    mask-image: none;\n  }\n\n  // Required so overflow-indicator disappears at end of content\n  .#{$prefix}--modal-scroll-content > *:last-child {\n    margin-block-end: $spacing-06;\n  }\n\n  // -----------------------------\n  // Modal footer\n  // -----------------------------\n  .#{$prefix}--modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    block-size: convert.to-rem(64px);\n    grid-column: 1/-1;\n    grid-row: -1/-1;\n    margin-block-start: auto;\n  }\n\n  .#{$prefix}--modal-footer .#{$prefix}--btn {\n    flex: 0 1 50%;\n    align-items: baseline;\n    margin: 0;\n    block-size: convert.to-rem(64px);\n    max-inline-size: none;\n  }\n\n  .#{$prefix}--modal-footer .#{$prefix}--btn:not(.#{$prefix}--skeleton) {\n    padding-block: calc($spacing-05 - convert.to-rem(2px)) $spacing-07;\n  }\n\n  .#{$prefix}--modal-footer--three-button .#{$prefix}--btn {\n    flex: 0 1 25%;\n    align-items: flex-start;\n  }\n\n  // -----------------------------\n  // Modal close btn\n  // -----------------------------\n\n  .#{$prefix}--modal-close-button {\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-end: 0;\n  }\n\n  .#{$prefix}--modal-close {\n    padding: convert.to-rem(12px);\n    border: 2px solid transparent;\n    background-color: transparent;\n    block-size: 3rem;\n    cursor: pointer;\n    inline-size: 3rem;\n    transition: background-color $duration-fast-02 motion(standard, productive);\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n\n    &:focus {\n      border-color: $focus;\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--modal-close::-moz-focus-inner {\n    border: 0;\n  }\n\n  .#{$prefix}--modal-close__icon {\n    block-size: convert.to-rem(20px);\n    fill: $icon-primary;\n    inline-size: convert.to-rem(20px);\n  }\n\n  .#{$prefix}--body--with-modal-open {\n    overflow: hidden;\n  }\n\n  .#{$prefix}--body--with-modal-open .#{$prefix}--modal .#{$prefix}--tooltip,\n  .#{$prefix}--body--with-modal-open\n    .#{$prefix}--modal\n    .#{$prefix}--overflow-menu-options,\n  .#{$prefix}--body--with-modal-open .#{$prefix}--overflow-menu-options {\n    z-index: z('modal');\n  }\n\n  // Fluid Modal (No padding)\n  .#{$prefix}--modal-container--full-width .#{$prefix}--modal-content {\n    padding: 0;\n    margin: 0;\n  }\n\n  // AIlabel styles\n  .#{$prefix}--modal--slug.#{$prefix}--modal,\n  .#{$prefix}--modal--decorator:has(.#{$prefix}--ai-label).#{$prefix}--modal {\n    background-color: $ai-overlay;\n  }\n\n  .#{$prefix}--modal--slug .#{$prefix}--modal-container,\n  .#{$prefix}--modal--decorator:has(.#{$prefix}--ai-label)\n    .#{$prefix}--modal-container {\n    @include ai-popover-gradient('default', 0, 'layer');\n\n    border: 1px solid transparent;\n    background-color: $layer;\n    box-shadow:\n      inset 0 -80px 70px -65px $ai-inner-shadow,\n      0 24px 40px -24px $ai-drop-shadow;\n  }\n\n  .#{$prefix}--modal--slug\n    .#{$prefix}--modal-container:has(.#{$prefix}--modal-footer),\n  .#{$prefix}--modal--decorator:has(.#{$prefix}--ai-label)\n    .#{$prefix}--modal-container:has(.#{$prefix}--modal-footer) {\n    @include ai-popover-gradient('default', 64px, 'layer');\n\n    box-shadow:\n      inset 0 -80px 0 -16px $layer,\n      inset 0 -160px 70px -65px $ai-inner-shadow,\n      0 24px 40px -24px $ai-drop-shadow;\n  }\n\n  .#{$prefix}--modal--slug\n    .#{$prefix}--modal-content.#{$prefix}--modal-scroll-content,\n  .#{$prefix}--modal--decorator\n    .#{$prefix}--modal-content.#{$prefix}--modal-scroll-content {\n    mask-image: linear-gradient(\n        to bottom,\n        $layer calc(100% - 80px),\n        transparent calc(100% - 48px),\n        transparent 100%\n      ),\n      linear-gradient(to left, $layer 0, 16px, transparent 16px),\n      linear-gradient(to right, $layer 0, 2px, transparent 2px),\n      linear-gradient(to top, $layer 0, 2px, transparent 2px);\n  }\n\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal--inner__decorator:has(\n      + .#{$prefix}--modal-close-button\n    )\n    > *,\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal-close-button\n    ~ .#{$prefix}--modal--inner__decorator\n    > *,\n  .#{$prefix}--modal--decorator\n    .#{$prefix}--modal-container-body\n    > .#{$prefix}--modal--inner__decorator\n    > *,\n  .#{$prefix}--modal-header\n    > .#{$prefix}--ai-label:has(+ .#{$prefix}--modal-close-button),\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal-close-button\n    ~ .#{$prefix}--ai-label,\n  .#{$prefix}--modal--slug\n    .#{$prefix}--modal-container-body\n    > .#{$prefix}--ai-label,\n  .#{$prefix}--modal-header\n    > .#{$prefix}--slug:has(+ .#{$prefix}--modal-close-button),\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal-close-button\n    ~ .#{$prefix}--slug,\n  .#{$prefix}--modal--slug\n    .#{$prefix}--modal-container-body\n    > .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: convert.to-rem(10px);\n    inset-inline-end: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal--inner__decorator:not(:has(.#{$prefix}--ai-label))\n    > * {\n    inset-block-start: 1rem;\n  }\n\n  .#{$prefix}--modal-header\n    > .#{$prefix}--modal--inner__decorator:has(.#{$prefix}--ai-label--revert)\n    > * {\n    inset-block-start: 1.475rem;\n  }\n\n  .#{$prefix}--modal--decorator\n    .#{$prefix}--modal-content--overflow-indicator::before,\n  .#{$prefix}--modal--decorator .#{$prefix}--modal-content--overflow-indicator {\n    display: none;\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--modal-close:focus {\n    @include high-contrast-mode('focus');\n  }\n}\n\n@mixin modal-animations($has-presence: false) {\n  @if not($has-presence) {\n    opacity: 0;\n    transition:\n      opacity $duration-moderate-02 motion(exit, expressive),\n      visibility 0ms linear $duration-moderate-02;\n    visibility: hidden;\n\n    &.is-visible {\n      opacity: 1;\n      transition:\n        opacity $duration-moderate-02 motion(entrance, expressive),\n        visibility 0ms linear;\n      visibility: inherit;\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  } @else {\n    animation: #{$prefix}--presence-modal__enter\n      $duration-moderate-02\n      motion(entrance, expressive)\n      forwards;\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n\n    &[data-exiting] {\n      animation: #{$prefix}--presence-modal__exit\n        $duration-moderate-02\n        motion(exit, expressive)\n        forwards;\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n\n    @keyframes #{$prefix}--presence-modal__enter {\n      from {\n        opacity: 0;\n      }\n\n      to {\n        opacity: 1;\n      }\n    }\n\n    @keyframes #{$prefix}--presence-modal__exit {\n      from {\n        opacity: 1;\n      }\n\n      to {\n        opacity: 0;\n      }\n    }\n  }\n}\n\n@mixin modal-container-animations($has-presence: false) {\n  @if not($has-presence) {\n    &.is-visible .#{$prefix}--modal-container {\n      transform: translate3d(0, 0, 0);\n      transition: transform $duration-moderate-02 motion(entrance, expressive);\n    }\n\n    .#{$prefix}--modal-container {\n      transform: translate3d(0, -24px, 0);\n      transition: transform $duration-moderate-02 motion(exit, expressive);\n    }\n  } @else {\n    &[data-exiting] .#{$prefix}--modal-container {\n      animation: #{$prefix}--presence-modal-container__exit\n        $duration-moderate-02\n        motion(exit, expressive)\n        forwards;\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n\n    .#{$prefix}--modal-container {\n      animation: #{$prefix}--presence-modal-container__enter\n        $duration-moderate-02\n        motion(entrance, expressive)\n        forwards;\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n\n    @keyframes #{$prefix}--presence-modal-container__enter {\n      from {\n        transform: translate3d(0, -24px, 0);\n      }\n\n      to {\n        transform: translate3d(0, 0, 0);\n      }\n    }\n\n    @keyframes #{$prefix}--presence-modal-container__exit {\n      from {\n        transform: translate3d(0, 0, 0);\n      }\n\n      to {\n        transform: translate3d(0, -24px, 0);\n      }\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../config' as *;\n@use '../theme' as *;\n\n/// Update tokens when fields are placed on `layer`\n/// @access public\n/// @group utilities\n@mixin update_fields_on_layer {\n  // Fluid inputs\n  .#{$prefix}--text-input--fluid .#{$prefix}--text-input,\n  .#{$prefix}--text-area--fluid .#{$prefix}--text-area__wrapper,\n  .#{$prefix}--text-area--fluid .#{$prefix}--text-area,\n  .#{$prefix}--search--fluid .#{$prefix}--search-input,\n  .#{$prefix}--select--fluid .#{$prefix}--select-input,\n  .#{$prefix}--text-area--fluid\n    .#{$prefix}--text-area__wrapper[data-invalid]\n    .#{$prefix}--text-area__divider\n    + .#{$prefix}--form-requirement,\n  .#{$prefix}--list-box__wrapper--fluid .#{$prefix}--list-box,\n  .#{$prefix}--list-box__wrapper--fluid.#{$prefix}--list-box__wrapper,\n  .#{$prefix}--number-input--fluid input[type='number'],\n  .#{$prefix}--number-input--fluid input[type='text'],\n  .#{$prefix}--number-input--fluid .#{$prefix}--number__control-btn::before,\n  .#{$prefix}--number-input--fluid .#{$prefix}--number__control-btn::after,\n  .#{$prefix}--date-picker--fluid\n    .c#{$prefix}ds--date-picker-input__wrapper\n    .#{$prefix}--date-picker__input {\n    background-color: $field-01;\n  }\n\n  // Override to align layer token with field\n  .#{$prefix}--list-box__wrapper--fluid .#{$prefix}--list-box__menu {\n    background-color: $layer-01;\n  }\n\n  .#{$prefix}--list-box__menu-item:hover {\n    background-color: $layer-hover-02;\n  }\n\n  .#{$prefix}--list-box__menu-item--active {\n    background-color: $layer-selected-02;\n  }\n\n  .#{$prefix}--list-box__menu-item--active:hover {\n    background-color: $layer-selected-hover-02;\n  }\n\n  .#{$prefix}--number-input--fluid\n    .#{$prefix}--number__control-btn:hover::before,\n  .#{$prefix}--number-input--fluid\n    .#{$prefix}--number__control-btn:hover::after {\n    background-color: $field-hover;\n  }\n\n  .#{$prefix}--number-input--fluid\n    .#{$prefix}--number__control-btn:focus::before,\n  .#{$prefix}--number-input--fluid\n    .#{$prefix}--number__control-btn:focus::after {\n    border-inline-start: 2px solid $focus;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:list';\n@use 'sass:map';\n@use 'sass:meta';\n@use '@carbon/layout/scss/convert';\n@use 'config' as *;\n\n/// Provide a map and index, and get back the relevant key value\n/// @access public\n/// @param {Map} $map - Map\n/// @param {Integer} $index - Key chain\n/// @return {String} Desired value\n/// @group @carbon/layout\n@function -key-by-index($map, $index) {\n  $keys: map.keys($map);\n  @return list.nth($keys, $index);\n}\n\n/// Get the value of the next breakpoint, or null for the last breakpoint\n/// @param {String} $name - The name of the breakpoint\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name of the breakpoint and the value is the values for the breakpoint\n/// @param {List} $breakpoint-names [map.keys($breakpoints)] - A list of names from the `$breakpoints` map\n/// @return {String}\n/// @access public\n/// @group @carbon/layout\n@function breakpoint-next(\n  $name,\n  $breakpoints: $grid-breakpoints,\n  $breakpoint-names: map.keys($breakpoints)\n) {\n  $n: list.index($breakpoint-names, $name);\n  @if $n != null and $n < list.length($breakpoint-names) {\n    @return list.nth($breakpoint-names, $n + 1);\n  }\n  @return null;\n}\n\n/// Get the value of the previous breakpoint, or null for the first breakpoint\n/// @param {String} $name - The name of the breakpoint\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name of the breakpoint and the value is the values for the breakpoint\n/// @param {List} $breakpoint-names [map.keys($breakpoints)] - A list of names from the `$breakpoints` map\n/// @return {String}\n/// @access public\n/// @group @carbon/layout\n@function breakpoint-prev(\n  $name,\n  $breakpoints: $grid-breakpoints,\n  $breakpoint-names: map.keys($breakpoints)\n) {\n  $n: list.index($breakpoint-names, $name);\n  @if $n != null and $n > 1 {\n    @return list.nth($breakpoint-names, $n - 1);\n  }\n  @return null;\n}\n\n/// Check to see if the given breakpoint name\n/// @param {String} $name - The name of the breakpoint\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name of the breakpoint and the value is the values for the breakpoint\n/// @return {Bool}\n/// @access public\n/// @group @carbon/layout\n@function is-smallest-breakpoint($name, $breakpoints: $grid-breakpoints) {\n  @return list.index(map.keys($breakpoints), $name) == 1;\n}\n\n/// Returns the largest breakpoint name\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @return {String}\n/// @access public\n/// @group @carbon/layout\n@function largest-breakpoint-name($breakpoints: $grid-breakpoints) {\n  $total-breakpoints: list.length($breakpoints);\n  @return -key-by-index($breakpoints, $total-breakpoints);\n}\n\n/// Get the infix for a given breakpoint in a list of breakpoints. Useful for generating the size part in a selector, for example: `.prefix--col-sm-2`.\n/// @param {String} $name - The name of the breakpoint\n/// @return {String}\n/// @access public\n/// @group @carbon/layout\n@function breakpoint-infix($name) {\n  @return '-#{$name}';\n}\n\n/// Generate a media query from the width of the given breakpoint to infinity\n/// @param {String | Number} $name\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @content\n/// @access public\n/// @group @carbon/layout\n@mixin breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  @if meta.type-of($name) == 'number' {\n    @media (min-width: $name) {\n      @content;\n    }\n  } @else if map.has-key($breakpoints, $name) {\n    $breakpoint: map.get($breakpoints, $name);\n    $width: map.get($breakpoint, width);\n    @if is-smallest-breakpoint($name, $breakpoints) {\n      @content;\n    } @else {\n      @media (min-width: $width) {\n        @content;\n      }\n    }\n  } @else {\n    @error 'Unable to find a breakpoint with name `#{$name}`. Expected one of: (#{map.keys($breakpoints)})';\n  }\n}\n\n/// Generate a media query for the maximum width of the given styles\n/// @param {String | Number} $name\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @content\n/// @access public\n/// @group @carbon/layout\n@mixin breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  @if meta.type-of($name) == 'number' {\n    @media (max-width: $name) {\n      @content;\n    }\n  } @else if map.has-key($breakpoints, $name) {\n    // We borrow this logic from bootstrap for specifying the value of the\n    // max-width. The maximum width is calculated by finding the breakpoint and\n    // subtracting .02 from its value. This value is used instead of .01 to\n    // avoid rounding issues in Safari\n    // https://github.com/twbs/bootstrap/blob/c5b1919deaf5393fcca9e9b9d7ce9c338160d99d/scss/mixins/_breakpoints.scss#L34-L46\n    $breakpoint: map.get($breakpoints, $name);\n    $width: map.get($breakpoint, width) - 0.02;\n    @media (max-width: $width) {\n      @content;\n    }\n  } @else {\n    @error 'Unable to find a breakpoint with name `#{$name}`. Expected one of: (#{map.keys($breakpoints)})';\n  }\n}\n\n/// Generate a media query for the range between the lower and upper breakpoints\n/// @param {String | Number} $lower\n/// @param {String | Number} $upper\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @content\n/// @access public\n/// @group @carbon/layout\n@mixin breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $is-number-lower: meta.type-of($lower) == 'number';\n  $is-number-upper: meta.type-of($upper) == 'number';\n  $min: null;\n  $max: null;\n\n  @if $is-number-lower {\n    $min: $lower;\n  } @else {\n    $min: map.get($breakpoints, $lower);\n  }\n\n  @if $is-number-upper {\n    $max: $upper;\n  } @else {\n    $max: map.get($breakpoints, $upper);\n  }\n\n  @if $min and $max {\n    $min-width: $min;\n    $max-width: $max;\n\n    @if not $is-number-lower and meta.type-of($min) == 'map' {\n      $min-width: map.get($min, width);\n    }\n\n    @if not $is-number-upper and meta.type-of($max) == 'map' {\n      $max-width: map.get($max, width);\n    }\n\n    @media (min-width: $min-width) and (max-width: $max-width) {\n      @content;\n    }\n  } @else if $min != null and $max == null {\n    @include breakpoint-up($lower) {\n      @content;\n    }\n  } @else if $min == null and $max != null {\n    @include breakpoint-down($upper) {\n      @content;\n    }\n  } @else {\n    @error 'Unable to find a breakpoint to satisfy: (#{$lower},#{$upper}). Expected both to be one of (#{map.keys($breakpoints)}).';\n  }\n}\n\n/// Generate media query for the largest breakpoint\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @content\n/// @access public\n/// @group @carbon/layout\n@mixin largest-breakpoint($breakpoints: $grid-breakpoints) {\n  @include breakpoint(largest-breakpoint-name()) {\n    @content;\n  }\n}\n\n/// Generate a media query for a given breakpoint\n/// @param {String | Number} $name\n/// @param {Map} $breakpoints [$grid-breakpoints] - A map of breakpoints where the key is the name\n/// @content\n/// @access public\n/// @group @carbon/layout\n@mixin breakpoint($name, $breakpoints: $grid-breakpoints) {\n  @include breakpoint-up($name, $breakpoints) {\n    @content;\n  }\n}\n","//\n// Copyright IBM Corp. 2023, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../theme';\n@use './custom-property';\n\n/// Experimental - name and structure subject to change. Use at your own risk!\n/// Adds AI gradient styles to a component\n/// @access private\n/// @param {String} $direction  - Direction of gradient from: `left`, `right`, `top`, and `bottom`\n/// @param {Number} $span - Percentage span of gradient with regards to parent component\n/// @example @include ai-gradient('right', '33%');\n/// @group utilities\n@mixin ai-gradient($direction: 'bottom', $span: 50%) {\n  $deg: 0;\n  @if $direction == 'bottom' {\n    $deg: 0deg;\n  } @else if $direction == 'left' {\n    $deg: 90deg;\n  } @else if $direction == 'top' {\n    $deg: 180deg;\n  } @else if $direction == 'right' {\n    $deg: 270deg;\n  }\n\n  background-image: linear-gradient(\n    $deg,\n    theme.$ai-aura-start-sm 0%,\n    15%,\n    theme.$ai-aura-end $span,\n    transparent 100%\n  );\n\n  border-block-end-color: theme.$ai-border-strong;\n}\n\n@mixin ai-table-gradient($type: 'default', $span: 50%) {\n  @if $type == 'hover' {\n    background: linear-gradient(\n        to right,\n        theme.$ai-aura-hover-start 0%,\n        15%,\n        theme.$ai-aura-hover-end 50%\n      ),\n      theme.$ai-aura-hover-background;\n  } @else if $type == 'selected' {\n    background: linear-gradient(\n        to right,\n        theme.$ai-aura-start-sm 0%,\n        theme.$ai-aura-end 50%,\n        transparent 50%\n      ),\n      theme.$layer-selected;\n  } @else if $type == 'full-table' {\n    background: linear-gradient(\n      to top,\n      theme.$ai-aura-start 0%,\n      theme.$ai-aura-end 50%,\n      transparent 50%\n    );\n  } @else {\n    background: linear-gradient(\n      to right,\n      theme.$ai-aura-start-sm 0%,\n      theme.$ai-aura-end $span,\n      transparent 50%\n    );\n  }\n}\n\n/// Experimental - name and structure subject to change. Use at your own risk!\n/// Adds callout gradient styles to a component\n/// @access private\n/// @example @include ai-popover-gradient();\n/// @param {String} $type  - Type of gradient, either 'default', 'selected' or 'hover'\n/// @param {Number} $offset  - specify a pixel offset the callout should start from the bottom\n/// @param {String} $background  - specify the token to be used as the background\n/// @group utilities\n@mixin ai-popover-gradient(\n  $type: 'default',\n  $offset: 0,\n  $background: 'ai-popover-background'\n) {\n  $start: 0%;\n  @if $offset != 0 {\n    $start: calc(0% + #{$offset});\n  }\n\n  $background: custom-property.get-var(\n    #{$background},\n    theme.$ai-popover-background\n  );\n\n  @if $type == 'hover' {\n    background:\n      linear-gradient(\n          to top,\n          theme.$ai-aura-hover-start $start,\n          15%,\n          theme.$ai-aura-hover-end 50%\n        )\n        padding-box,\n      linear-gradient(\n          to top,\n          theme.$ai-aura-hover-background,\n          theme.$ai-aura-hover-background\n        )\n        padding-box,\n      linear-gradient(to bottom, theme.$ai-border-start, theme.$ai-border-end)\n        border-box,\n      // Needed to underlay the transparent border\n      linear-gradient(\n          to top,\n          theme.$ai-aura-hover-background,\n          theme.$ai-aura-hover-background\n        )\n        border-box;\n  } @else if $type == 'selected' {\n    background:\n      linear-gradient(\n          to top,\n          theme.$ai-aura-start $start,\n          15%,\n          theme.$ai-aura-end 50%\n        )\n        padding-box,\n      linear-gradient(to top, theme.$layer, theme.$layer) padding-box,\n      linear-gradient(to bottom, theme.$border-inverse, theme.$border-inverse)\n        border-box,\n      // Needed to underlay the transparent border\n      linear-gradient(to top, theme.$layer, theme.$layer)\n        border-box;\n  } @else {\n    background:\n      linear-gradient(\n          to top,\n          $background $start,\n          theme.$ai-aura-start $start,\n          15%,\n          theme.$ai-aura-end 50%\n        )\n        padding-box,\n      linear-gradient(to top, $background, $background) padding-box,\n      linear-gradient(to bottom, theme.$ai-border-start, theme.$ai-border-end)\n        border-box,\n      // Needed to underlay the transparent border\n      linear-gradient(to top, $background, $background)\n        border-box;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/skeleton' as *;\n@use '../..//utilities/button-reset';\n\n/// @type Number\n/// @access public\n/// @group global-themes\n$input-label-weight: 400 !default;\n\n@mixin form {\n  // Override Chrome autocomplete styles\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover,\n  textarea:-webkit-autofill:focus {\n    box-shadow: 0 0 0 1000px $field inset;\n    -webkit-text-fill-color: $text-primary;\n  }\n\n  .#{$prefix}--fieldset {\n    @include component-reset.reset;\n  }\n\n  .#{$prefix}--form-item {\n    @include type-style('body-compact-01');\n\n    display: flex;\n    // We specify `auto` as the default value so that the form item does\n    // not collapse in IE11 due to a `flex-basis` of 0 only working with\n    // `flex-direction: row`\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .#{$prefix}--label {\n    @include reset;\n    @include type-style('label-01');\n\n    display: inline-block;\n    color: $text-secondary;\n    font-weight: $input-label-weight;\n    line-height: 1rem;\n    margin-block-end: $spacing-03;\n    vertical-align: baseline;\n  }\n\n  .#{$prefix}--label .#{$prefix}--toggletip-label {\n    @include type-style('label-01');\n  }\n\n  .#{$prefix}--label--no-margin {\n    margin-block-end: 0;\n  }\n\n  .#{$prefix}--label + .#{$prefix}--tooltip {\n    position: relative;\n    inset-block-start: 0.2rem;\n    inset-inline-start: 0.5rem;\n  }\n\n  .#{$prefix}--label + .#{$prefix}--tooltip .#{$prefix}--tooltip__trigger {\n    @include button-reset.reset();\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    @include type-style('label-01');\n  }\n\n  .#{$prefix}--label\n    + .#{$prefix}--tooltip\n    .#{$prefix}--tooltip__trigger:focus {\n    outline: 1px solid $focus;\n  }\n\n  .#{$prefix}--label + .#{$prefix}--tooltip .#{$prefix}--tooltip__trigger svg {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--label\n    + .#{$prefix}--tooltip\n    .#{$prefix}--tooltip__trigger\n    svg\n    :hover {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--label + .#{$prefix}--toggletip {\n    inset-block-start: 0.2rem;\n    inset-inline-start: 0.5rem;\n  }\n\n  // Skeleton State\n  .#{$prefix}--label.#{$prefix}--skeleton {\n    @include skeleton;\n\n    block-size: convert.to-rem(14px);\n\n    inline-size: convert.to-rem(75px);\n  }\n\n  input[type='number'],\n  input[type='text'].#{$prefix}--number {\n    font-family: font-family('sans');\n  }\n\n  input[data-invalid]:not(:focus),\n  .#{$prefix}--number[data-invalid] input[type='number']:not(:focus),\n  .#{$prefix}--number[data-invalid] input[type='text']:not(:focus),\n  .#{$prefix}--text-input__field-wrapper[data-invalid]\n    > .#{$prefix}--text-input--invalid:not(:focus),\n  .#{$prefix}--text-area__wrapper[data-invalid]\n    > .#{$prefix}--text-area--invalid:not(:focus),\n  .#{$prefix}--select-input__wrapper[data-invalid]\n    .#{$prefix}--select-input:not(:focus),\n  .#{$prefix}--list-box[data-invalid]:not(\n      .#{$prefix}--multi-select--invalid--focused,\n      .#{$prefix}--combo-box--invalid--focused\n    ),\n  .#{$prefix}--combo-box[data-invalid]:not(.#{$prefix}--multi-select--selected)\n    .#{$prefix}--text-input:not(:focus) {\n    @include focus-outline('invalid');\n  }\n\n  input[data-invalid],\n  .#{$prefix}--number[data-invalid] .#{$prefix}--number__input-wrapper,\n  .#{$prefix}--number__input-wrapper--warning,\n  .#{$prefix}--date-picker-input__wrapper,\n  .#{$prefix}--date-picker-input__wrapper--warn,\n  .#{$prefix}--date-picker-input__wrapper--invalid,\n  .#{$prefix}--time-picker--invalid,\n  .#{$prefix}--time-picker--warning,\n  .#{$prefix}--text-input__field-wrapper[data-invalid],\n  .#{$prefix}--text-input__field-wrapper--warning,\n  .#{$prefix}--text-input__field-wrapper--warning > .#{$prefix}--text-input,\n  .#{$prefix}--text-area__wrapper[data-invalid],\n  .#{$prefix}--text-area__wrapper--warn,\n  .#{$prefix}--select-input__wrapper[data-invalid],\n  .#{$prefix}--select--warning .#{$prefix}--select-input__wrapper,\n  .#{$prefix}--time-picker[data-invalid],\n  .#{$prefix}--list-box[data-invalid],\n  .#{$prefix}--list-box--warning {\n    ~ .#{$prefix}--form-requirement {\n      display: block;\n      overflow: visible;\n      font-weight: 400;\n      max-block-size: convert.to-rem(200px);\n    }\n  }\n\n  .#{$prefix}--select--inline.#{$prefix}--select--warning\n    .#{$prefix}--select-input--inline__wrapper,\n  .#{$prefix}--select-input--inline__wrapper[data-invalid] {\n    ~ .#{$prefix}--form-requirement {\n      display: inline-flex;\n      overflow: visible;\n      margin: 0;\n      inline-size: 100%;\n      margin-block-end: 0;\n      max-block-size: 100%;\n      padding-inline-start: $spacing-03;\n    }\n  }\n\n  input[data-invalid],\n  .#{$prefix}--number[data-invalid] .#{$prefix}--number__input-wrapper,\n  .#{$prefix}--date-picker-input__wrapper,\n  .#{$prefix}--date-picker-input__wrapper--invalid,\n  .#{$prefix}--time-picker--invalid,\n  .#{$prefix}--text-input__field-wrapper[data-invalid],\n  .#{$prefix}--text-area__wrapper[data-invalid],\n  .#{$prefix}--select-input__wrapper[data-invalid],\n  .#{$prefix}--time-picker[data-invalid],\n  .#{$prefix}--list-box[data-invalid],\n  .#{$prefix}--select-input--inline__wrapper[data-invalid] {\n    ~ .#{$prefix}--form-requirement {\n      color: $text-error;\n    }\n  }\n\n  //Fluid Form\n  .#{$prefix}--form--fluid .#{$prefix}--text-input__field-wrapper[data-invalid],\n  .#{$prefix}--form--fluid .#{$prefix}--text-input__field-wrapper--warning {\n    display: block;\n  }\n\n  .#{$prefix}--form--fluid input[data-invalid] {\n    outline: none;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--form-requirement {\n    padding: $spacing-03 convert.to-rem(40px) $spacing-03 $spacing-05;\n    margin: 0;\n  }\n\n  // Fix for red ring when input is marked required in Firefox, refs #744\n  input:not(output, [data-invalid]):-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  .#{$prefix}--form-requirement {\n    @include reset;\n    @include type-style('helper-text-01');\n\n    display: none;\n    overflow: hidden;\n    margin: $spacing-02 0 0;\n    max-block-size: 0;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--form__helper-text {\n    margin-block-start: 0;\n  }\n\n  .#{$prefix}--form__helper-text {\n    @include type-style('helper-text-01');\n\n    z-index: 0;\n    color: $text-helper;\n    // Added to prevent error text from displaying under helper text in Safari (#6392)\n    inline-size: 100%;\n    margin-block-start: $spacing-02;\n    opacity: 1;\n  }\n\n  .#{$prefix}--label--disabled,\n  .#{$prefix}--form__helper-text--disabled {\n    color: $text-disabled;\n  }\n\n  // If a FormGroup is disabled, Form labels and helper text nested inside should also be disabled\n  fieldset[disabled] .#{$prefix}--label,\n  fieldset[disabled] .#{$prefix}--form__helper-text {\n    color: $text-disabled;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n@use 'sass:meta';\n@use '@carbon/layout';\n@use 'font-family' as *;\n\n/// Include a type reset for a given body and mono font family\n/// @param {String} $body-font-family [font-family('sans')] - The font family used on the `<body>` element\n/// @param {String} $mono-font-family [font-family('mono')] - The font family used on elements that require mono fonts, like the `<code>` element\n/// @access public\n/// @group @carbon/type\n@mixin reset(\n  $body-font-family: font-family('sans'),\n  $mono-font-family: font-family('mono')\n) {\n  html {\n    font-size: 100%;\n  }\n\n  body {\n    @include font-weight('regular');\n\n    font-family: $body-font-family;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    text-rendering: optimizeLegibility;\n  }\n\n  code {\n    font-family: $mono-font-family;\n  }\n\n  strong {\n    @include font-weight('semibold');\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:string';\n@use 'sass:map';\n\n/// Font family fallbacks for: IBM Plex Mono, IBM Plex Sans, IBM Plex Sans\n/// Condensed, IBM Plex Sans Hebrew, and IBM Plex Serif\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$font-families: (\n  'mono':\n    string.unquote(\n      \"'IBM Plex Mono', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', monospace\"\n    ),\n  'sans':\n    string.unquote(\n      \"'IBM Plex Sans', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-condensed':\n    string.unquote(\n      \"'IBM Plex Sans Condensed', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-arabic':\n    string.unquote(\n      \"'IBM Plex Sans Arabic', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-devanagari':\n    string.unquote(\n      \"'IBM Plex Sans Devanagari', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-hebrew':\n    string.unquote(\n      \"'IBM Plex Sans Hebrew', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-jp':\n    string.unquote(\n      \"'IBM Plex Sans JP', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-kr':\n    string.unquote(\n      \"'IBM Plex Sans KR', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-thai-looped':\n    string.unquote(\n      \"'IBM Plex Sans Thai Looped', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'sans-thai':\n    string.unquote(\n      \"'IBM Plex Sans Thai', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', sans-serif\"\n    ),\n  'serif':\n    string.unquote(\n      \"'IBM Plex Serif', system-ui, -apple-system, BlinkMacSystemFont, '.SFNSText-Regular', serif\"\n    ),\n) !default;\n\n/// Get the font-family for an IBM Plex font\n/// @param {String} $name\n/// @return {String}\n/// @access public\n/// @group @carbon/type\n@function font-family($name) {\n  @return map.get($font-families, $name);\n}\n\n/// Include the `font-family` definition for the given name in your selector\n/// @param {String} $name\n/// @access public\n/// @group @carbon/type\n@mixin font-family($name) {\n  font-family: font-family($name);\n}\n\n/// Suggested font weights to be used in product\n/// @type Map\n/// @access public\n/// @group @carbon/type\n$font-weights: (\n  'light': 300,\n  'regular': 400,\n  'semibold': 600,\n) !default;\n\n/// Retrieve the font-weight value for a given name\n/// @param {String} $weight\n/// @return {Number}\n/// @access public\n/// @group @carbon/type\n@function font-weight($weight) {\n  @return map.get($font-weights, $weight);\n}\n\n/// Set the `font-weight` property with the value for a given name\n/// @param {String} $weight\n/// @access public\n/// @group @carbon/type\n@mixin font-weight($weight) {\n  font-weight: font-weight($weight);\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../spacing';\n@use '../../utilities/custom-property';\n\n@mixin stack() {\n  .#{$prefix}--stack-horizontal {\n    display: inline-grid;\n    column-gap: custom-property.get-var('stack-gap', 0);\n    grid-auto-flow: column;\n  }\n\n  .#{$prefix}--stack-vertical {\n    display: grid;\n    grid-auto-flow: row;\n    row-gap: custom-property.get-var('stack-gap', 0);\n  }\n\n  $index: 1;\n\n  @each $step, $value in spacing.$spacing {\n    .#{$prefix}--stack-scale-#{$index} {\n      @include custom-property.declaration('stack-gap', $value);\n    }\n\n    $index: $index + 1;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../form';\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/visually-hidden' as *;\n\n@mixin checkbox {\n  .#{$prefix}--checkbox-group {\n    @include component-reset.reset;\n  }\n\n  // Spacing between checkboxes\n  .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper {\n    position: relative;\n    margin-block-end: convert.to-rem(6px);\n  }\n\n  // Spacing above collection of checkboxes\n  .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper:first-of-type {\n    margin-block-start: 0;\n  }\n\n  // Shift collection of checkboxes up if label is present\n  // to account for the 2px top margin for the first checkbox\n  .#{$prefix}--label + .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper {\n    margin-block-start: -#{$spacing-01};\n  }\n\n  // Spacing below collection of checkboxes\n  .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper:last-of-type {\n    margin-block-end: convert.to-rem(3px);\n  }\n\n  // Visually, we'll hide the checkbox input and create our own styled version\n  // to match the specs.\n  .#{$prefix}--checkbox {\n    @include visually-hidden;\n    //even though its hidden, positioning is for native validation to be aligned to checkbox\n    inset-block-start: 1.25rem;\n    inset-inline-start: 0.7rem;\n  }\n\n  // The label corresponds to the content inside of the `label` tag. Since we're\n  // creating our own checkbox style, we'll need to position this in order to\n  // accommodate the spacing needed for the checkbox.\n  .#{$prefix}--checkbox-label {\n    @include reset;\n    @include type-style('body-compact-01');\n\n    position: relative;\n    display: flex;\n    cursor: pointer;\n    min-block-size: convert.to-rem(20px);\n    padding-block-start: convert.to-rem(1px);\n    padding-inline-start: convert.to-rem(20px);\n    user-select: none;\n  }\n\n  .#{$prefix}--checkbox-label-text {\n    // Add extra spacing when label is present\n    padding-inline-start: convert.to-rem(10px);\n  }\n\n  // Required because `$css--reset: true` cannot currently apply to this `::before` and `::after`\n  .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label::after {\n    box-sizing: border-box;\n\n    @media print {\n      print-color-adjust: exact;\n    }\n  }\n\n  // Spacing for presentational checkbox\n  .#{$prefix}--checkbox-label::before {\n    // We need to position the pseudo-element absolutely in the space that we've\n    // created with the padding from the label itself. We position only with\n    // `top` since we don't want the checkbox to be centered vertically with the\n    // text overflows.\n    position: absolute;\n    border: 1px solid $icon-primary;\n    border-radius: 2px;\n    @include high-contrast-mode {\n      border: 1px solid ButtonBorder;\n    }\n\n    // Checkboxes with a background color look visually off against a parent container.\n    background-color: transparent;\n    block-size: convert.to-rem(16px);\n    content: '';\n\n    // According to the spec, we'll want the bounding box for our checkbox to\n    // be 16px. The border size will be what will be updated during the\n    // different checkbox states.\n    inline-size: convert.to-rem(16px);\n    inset-block-start: convert.to-rem(2px);\n    inset-inline-start: 0;\n\n    // increase left margin for #6480\n    margin-block: convert.to-rem(1px) convert.to-rem(2px);\n    margin-inline: convert.to-rem(3px) 0;\n  }\n\n  // Create the appearance of the check in the `after` pseudo-element\n  .#{$prefix}--checkbox-label::after {\n    position: absolute;\n    background: none;\n    block-size: convert.to-rem(5px);\n    border-block-end: 1.5px solid $icon-inverse;\n    border-inline-start: 1.5px solid $icon-inverse;\n    content: '';\n    inline-size: convert.to-rem(9px);\n    inset-block-start: convert.to-rem(6.5px);\n    inset-inline-start: convert.to-rem(7px);\n    margin-block-start: convert.to-rem(-3px);\n    transform: scale(0) rotate(-45deg);\n    transform-origin: bottom right;\n  }\n\n  //----------------------------------------------\n  // Checked\n  // ---------------------------------------------\n\n  // Update properties for checked checkbox\n  .#{$prefix}--checkbox:checked + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox:indeterminate + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-state='true']::before {\n    border: none;\n    border-width: 1px;\n    background-color: $icon-primary;\n\n    // According to https://developer.mozilla.org/en-US/docs/Web/CSS/system-color, in high contrast mode, the\n    // checkbox should be displayed using SelectedItem and SelectedItemText.\n    @include high-contrast-mode {\n      border: 1px solid ButtonBorder;\n      background-color: SelectedItem;\n    }\n  }\n\n  // Display the check\n  .#{$prefix}--checkbox:checked + .#{$prefix}--checkbox-label::after,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-state='true']::after {\n    transform: scale(1) rotate(-45deg);\n  }\n\n  // Indeterminate symbol\n  .#{$prefix}--checkbox:indeterminate + .#{$prefix}--checkbox-label::after {\n    border-block-end: 2px solid $icon-inverse;\n    border-inline-start: 0 solid $icon-inverse;\n    inline-size: convert.to-rem(8px);\n    inset-block-start: convert.to-rem(11px);\n    transform: scale(1) rotate(0deg);\n  }\n\n  //----------------------------------------------\n  // Focus\n  // ---------------------------------------------\n\n  // Unchecked\n  .#{$prefix}--checkbox:focus + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label__focus::before,\n  // Checked\n  .#{$prefix}--checkbox:checked:focus + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-state='true'].#{$prefix}--checkbox-label__focus::before,\n  // Indeterminate\n  .#{$prefix}--checkbox:indeterminate:focus + .#{$prefix}--checkbox-label::before {\n    outline: 2px solid $focus;\n    outline-offset: 1px;\n  }\n\n  //----------------------------------------------\n  // Disabled\n  // ---------------------------------------------\n\n  .#{$prefix}--checkbox:disabled + .#{$prefix}--checkbox-label,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-disabled='true'] {\n    color: $text-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--checkbox:disabled + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-disabled='true']::before {\n    border-color: $icon-disabled;\n  }\n\n  .#{$prefix}--checkbox:checked:disabled + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox:indeterminate:disabled\n    + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-label[data-contained-checkbox-state='true'][data-contained-checkbox-disabled='true']::before {\n    background-color: $icon-disabled;\n  }\n\n  //----------------------------------------------\n  // Invalid + warn\n  // ---------------------------------------------\n  .#{$prefix}--checkbox-group[data-invalid] .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-wrapper--invalid .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-wrapper--invalid\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::before {\n    border: 1px solid $support-error;\n  }\n\n  // checkbox group overrides for individual validation checkbox\n  .#{$prefix}--checkbox-group\n    .#{$prefix}--checkbox-wrapper--invalid\n    > .#{$prefix}--checkbox__validation-msg,\n  .#{$prefix}--checkbox-group\n    .#{$prefix}--checkbox-wrapper--warning\n    > .#{$prefix}--checkbox__validation-msg,\n  .#{$prefix}--checkbox-group\n    .#{$prefix}--checkbox-wrapper\n    > .#{$prefix}--form__helper-text {\n    display: none;\n  }\n\n  .#{$prefix}--checkbox-group:not(.#{$prefix}--checkbox-group[data-invalid])\n    .#{$prefix}--checkbox-wrapper--invalid\n    .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-group:not(.#{$prefix}--checkbox-group[data-invalid])\n    .#{$prefix}--checkbox-wrapper--invalid\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::before {\n    border: 1px solid $icon-primary;\n  }\n\n  .#{$prefix}--checkbox-group__validation-msg,\n  .#{$prefix}--checkbox__validation-msg {\n    display: none;\n    align-items: flex-start;\n    inline-size: 100%;\n    margin-block-start: $spacing-02;\n  }\n\n  .#{$prefix}--checkbox__invalid-icon {\n    margin: convert.to-rem(1px) convert.to-rem(1px) 0 convert.to-rem(3px);\n    fill: $support-error;\n    min-inline-size: convert.to-rem(16px);\n  }\n\n  .#{$prefix}--checkbox__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--checkbox__invalid-icon--warning path:first-of-type {\n    fill: #000000;\n  }\n\n  .#{$prefix}--checkbox-group--invalid\n    .#{$prefix}--checkbox-group__validation-msg,\n  .#{$prefix}--checkbox-group--warning\n    .#{$prefix}--checkbox-group__validation-msg,\n  .#{$prefix}--checkbox-wrapper--invalid\n    > .#{$prefix}--checkbox__validation-msg,\n  .#{$prefix}--checkbox-wrapper--warning\n    > .#{$prefix}--checkbox__validation-msg {\n    display: flex;\n  }\n\n  .#{$prefix}--checkbox-group--invalid\n    .#{$prefix}--checkbox-group__validation-msg\n    .#{$prefix}--form-requirement,\n  .#{$prefix}--checkbox-group--warning\n    .#{$prefix}--checkbox-group__validation-msg\n    .#{$prefix}--form-requirement,\n  .#{$prefix}--checkbox-wrapper--invalid\n    .#{$prefix}--checkbox__validation-msg\n    .#{$prefix}--form-requirement,\n  .#{$prefix}--checkbox-wrapper--warning\n    .#{$prefix}--checkbox__validation-msg\n    .#{$prefix}--form-requirement {\n    display: block;\n    overflow: visible;\n    margin-block-start: 0;\n    margin-inline-start: $spacing-03;\n    max-block-size: 100%;\n  }\n\n  .#{$prefix}--checkbox-group--invalid\n    .#{$prefix}--checkbox-group__validation-msg\n    .#{$prefix}--form-requirement,\n  .#{$prefix}--checkbox-wrapper--invalid\n    .#{$prefix}--checkbox__validation-msg\n    .#{$prefix}--form-requirement {\n    color: $text-error;\n  }\n\n  //----------------------------------------------\n  // Read-only\n  // ---------------------------------------------\n  .#{$prefix}--checkbox-group--readonly .#{$prefix}--checkbox-label,\n  .#{$prefix}--checkbox-wrapper--readonly .#{$prefix}--checkbox-label {\n    cursor: default;\n  }\n\n  .#{$prefix}--checkbox-group--readonly .#{$prefix}--checkbox-label-text,\n  .#{$prefix}--checkbox-wrapper--readonly .#{$prefix}--checkbox-label-text {\n    cursor: text;\n    user-select: text;\n  }\n\n  .#{$prefix}--checkbox-group--readonly\n    .#{$prefix}--checkbox\n    + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-wrapper--readonly\n    .#{$prefix}--checkbox\n    + .#{$prefix}--checkbox-label::before {\n    border-color: $icon-disabled;\n  }\n\n  .#{$prefix}--checkbox-group--readonly\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::before,\n  .#{$prefix}--checkbox-wrapper--readonly\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::before {\n    border: 1px solid $icon-disabled;\n    background: transparent;\n  }\n\n  .#{$prefix}--checkbox-group--readonly\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::after,\n  .#{$prefix}--checkbox-wrapper--readonly\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::after {\n    border-color: $text-primary;\n\n    // According to https://developer.mozilla.org/en-US/docs/Web/CSS/system-color, in high contrast mode, the\n    // checkbox should be displayed using SelectedItem and SelectedItemText.\n    @include high-contrast-mode {\n      fill: SelectedItemText;\n    }\n  }\n\n  //-----------------------------------------------\n  // Skeleton\n  //-----------------------------------------------\n  .#{$prefix}--checkbox-skeleton .#{$prefix}--checkbox-label {\n    cursor: default;\n  }\n\n  .#{$prefix}--checkbox-label-text.#{$prefix}--skeleton {\n    @include skeleton;\n\n    // Add extra spacing when label is present\n    block-size: $spacing-05;\n    inline-size: convert.to-rem(100px);\n    margin-block: convert.to-rem(1px) 0;\n    margin-inline: convert.to-rem(6px) 0;\n  }\n\n  //-----------------------------------------------\n  // InlineCheckbox\n  //-----------------------------------------------\n  .#{$prefix}--checkbox--inline {\n    position: relative;\n  }\n\n  // RTL overrides\n  [dir='rtl'] .#{$prefix}--checkbox-label::after {\n    margin-block-start: 0;\n    margin-inline-start: convert.to-rem(-1px);\n    transform-origin: center;\n  }\n\n  [dir='rtl']\n    .#{$prefix}--checkbox:checked\n    + .#{$prefix}--checkbox-label::after,\n  [dir='rtl']\n    .#{$prefix}--checkbox-label[data-contained-checkbox-state='true']::after {\n    transform: scale(1.2) rotate3d(0.5, 1, 0, 158deg);\n  }\n\n  //-----------------------------------------------\n  // Decorator\n  //-----------------------------------------------\n  .#{$prefix}--checkbox-group--decorator legend.#{$prefix}--label,\n  .#{$prefix}--checkbox-wrapper--decorator .#{$prefix}--checkbox-label-text {\n    display: flex;\n  }\n  // Remove v12\n  .#{$prefix}--checkbox-group--slug legend.#{$prefix}--label,\n  .#{$prefix}--checkbox-wrapper--slug .#{$prefix}--checkbox-label-text {\n    display: flex;\n  }\n\n  .#{$prefix}--checkbox-group--decorator\n    legend.#{$prefix}--label\n    .#{$prefix}--checkbox-group-inner--decorator\n    > *,\n  .#{$prefix}--checkbox-wrapper--decorator\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--checkbox-wrapper-inner--decorator\n    > * {\n    margin-inline-start: $spacing-03;\n  }\n  // Remove v12\n  .#{$prefix}--checkbox-group--slug\n    legend.#{$prefix}--label\n    .#{$prefix}--ai-label,\n  .#{$prefix}--checkbox-wrapper--slug\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--ai-label,\n  .#{$prefix}--checkbox-group--slug legend.#{$prefix}--label .#{$prefix}--slug,\n  .#{$prefix}--checkbox-wrapper--slug\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--slug {\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--checkbox-wrapper--decorator\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--ai-label__button--inline {\n    line-height: inherit;\n    margin-block-start: convert.to-rem(-1px);\n  }\n  // Remove v12\n  .#{$prefix}--checkbox-wrapper--slug\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--ai-label__button--inline,\n  .#{$prefix}--checkbox-wrapper--slug\n    .#{$prefix}--checkbox-label-text\n    .#{$prefix}--slug__button--inline {\n    line-height: inherit;\n    margin-block-start: convert.to-rem(-1px);\n  }\n\n  //-----------------------------------------------\n  // Horizontal group\n  //-----------------------------------------------\n  .#{$prefix}--checkbox-group--horizontal {\n    position: relative;\n    display: flex;\n    flex-flow: row wrap;\n    justify-content: flex-start;\n\n    .#{$prefix}--form-item {\n      flex: none;\n      margin-block-end: 0;\n\n      &:not(:last-of-type) {\n        margin-inline-end: $spacing-05;\n      }\n    }\n\n    .#{$prefix}--checkbox-label-text {\n      padding-inline-start: $spacing-03;\n    }\n\n    .#{$prefix}--label + .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper {\n      margin-block-start: 0;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n//-----------------------------\n// Text\n//-----------------------------\n@use '../form';\n@use '../../config' as *;\n@use '../../colors' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/placeholder-colors' as *;\n@use '../../utilities/tooltip' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/convert';\n@use '../../utilities/layout';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/visually-hidden' as *;\n\n/// Text input styles\n/// @access public\n/// @group text-input\n@mixin text-input {\n  .#{$prefix}--text-input {\n    @include layout.use('size', $default: 'md', $min: 'sm', $max: 'lg');\n    @include layout.use('density', $default: 'normal');\n    @include component-reset.reset;\n    @include type-style('body-compact-01');\n    @include focus-outline('reset');\n\n    padding: 0 layout.density('padding-inline');\n    border: none;\n    background-color: $field;\n    block-size: layout.size('height');\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    font-family: inherit;\n\n    inline-size: 100%;\n    transition:\n      background-color $duration-fast-01 motion(standard, productive),\n      outline $duration-fast-01 motion(standard, productive);\n\n    &:focus,\n    &:active {\n      @include focus-outline('outline');\n    }\n\n    &-wrapper svg[hidden] {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--password-input {\n    padding-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-input--sm.#{$prefix}--password-input {\n    padding-inline-end: $spacing-07;\n  }\n\n  .#{$prefix}--text-input--lg.#{$prefix}--password-input {\n    padding-inline-end: $spacing-09;\n  }\n\n  .#{$prefix}--text-input::placeholder {\n    @include placeholder-colors;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--text-input--light {\n    background-color: $field-02;\n  }\n\n  //-----------------------------\n  // Disabled & Error icon spacing\n  //-----------------------------\n  .#{$prefix}--text-input__field-wrapper {\n    position: relative;\n    display: flex;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--text-input__invalid-icon {\n    position: absolute;\n    fill: $support-error;\n    // top/transform used to center invalid icon in IE11\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-05;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--text-input__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--text-input__invalid-icon--warning path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  // TODO: deprecate this style block\n  .#{$prefix}--text-input--password__visibility {\n    @include tooltip--trigger('icon', 'bottom');\n    @include tooltip--placement('icon', 'bottom', 'center');\n  }\n\n  .#{$prefix}--btn.#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger {\n    @include focus-outline('reset');\n\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 0;\n    background: none;\n    block-size: 100%;\n    cursor: pointer;\n    inline-size: convert.to-rem(40px);\n    inset-inline-end: 0;\n    min-block-size: auto;\n    transition: outline $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--toggle-password-tooltip .#{$prefix}--popover {\n    inset-inline-start: -($spacing-08);\n  }\n\n  .#{$prefix}--toggle-password-tooltip .#{$prefix}--popover-content {\n    min-inline-size: $spacing-08;\n  }\n\n  .#{$prefix}--text-input--sm\n    + .#{$prefix}--btn.#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger {\n    inline-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--text-input--lg\n    + .#{$prefix}--btn.#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger {\n    inline-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--btn.#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger\n    svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--btn.#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--text-input--invalid,\n  .#{$prefix}--text-input--warning {\n    padding-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-input--invalid.#{$prefix}--password-input {\n    padding-inline-end: convert.to-rem(64px);\n  }\n\n  .#{$prefix}--text-input--invalid\n    + .#{$prefix}--text-input--password__visibility__toggle {\n    inset-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--password-input-wrapper .#{$prefix}--text-input__invalid-icon {\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-input:disabled\n    ~ .#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--text-input:disabled\n    ~ .#{$prefix}--text-input--password__visibility__toggle.#{$prefix}--tooltip__trigger\n    svg {\n    fill: $icon-disabled;\n\n    &:hover {\n      fill: $icon-disabled;\n    }\n  }\n\n  .#{$prefix}--text-input--password__visibility__toggle:disabled.#{$prefix}--tooltip__trigger {\n    svg {\n      fill: $icon-disabled;\n    }\n\n    cursor: default;\n  }\n\n  .#{$prefix}--text-input--password__visibility__toggle:disabled.#{$prefix}--tooltip__trigger:hover {\n    svg {\n      fill: $icon-disabled;\n    }\n\n    cursor: default;\n  }\n\n  .#{$prefix}--text-input__counter-alert {\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    border: 0;\n    margin: -1px;\n    block-size: 1px;\n    clip: rect(0, 0, 0, 0);\n    inline-size: 1px;\n  }\n\n  //-----------------------------\n  // Disabled\n  //-----------------------------\n  .#{$prefix}--text-input:disabled {\n    @include focus-outline('reset');\n\n    background-color: $field;\n\n    border-block-end: 1px solid transparent;\n    color: $text-disabled;\n    cursor: not-allowed;\n    // Needed to fix disabled text in Safari #6673\n    -webkit-text-fill-color: $text-disabled;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--text-input--light:disabled {\n    background-color: $field-02;\n  }\n\n  .#{$prefix}--text-input:disabled::placeholder {\n    color: $text-disabled;\n    opacity: 1;\n  }\n\n  //-----------------------------\n  // Error\n  //-----------------------------\n  .#{$prefix}--text-input--invalid {\n    @include focus-outline('invalid');\n\n    box-shadow: none;\n\n    .#{$prefix}--text-input--password__visibility__toggle {\n      inset-inline-end: $spacing-08;\n    }\n  }\n\n  //-----------------------------\n  // Skeleton\n  //-----------------------------\n  .#{$prefix}--skeleton.#{$prefix}--text-input {\n    @include skeleton;\n  }\n\n  // Deprecated -- Styles have been moved to `fluid-text-input.scss`\n  // V12 - Remove this block\n  //-----------------------------\n  // Fluid Text Input\n  //-----------------------------\n  .#{$prefix}--form--fluid .#{$prefix}--text-input-wrapper {\n    position: relative;\n    background: $field;\n    transition:\n      background-color $duration-fast-01 motion(standard, productive),\n      outline $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--label {\n    position: absolute;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    margin: 0;\n    block-size: convert.to-rem(16px);\n    inset-block-start: convert.to-rem(13px);\n    inset-inline-start: $spacing-05;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--form__helper-text {\n    display: none;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--text-input {\n    padding: convert.to-rem(32px) $spacing-05 convert.to-rem(13px);\n    min-block-size: convert.to-rem(64px);\n  }\n\n  .#{$prefix}--text-input__divider,\n  .#{$prefix}--form--fluid .#{$prefix}--text-input__divider {\n    display: none;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--text-input--invalid,\n  .#{$prefix}--form--fluid .#{$prefix}--text-input--warning {\n    border-block-end: none;\n  }\n\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input--invalid\n    + .#{$prefix}--text-input__divider,\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input--warning\n    + .#{$prefix}--text-input__divider {\n    display: block;\n    border-style: solid;\n    border-color: $border-subtle;\n    margin: 0 1rem;\n    border-block-end: none;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--text-input__invalid-icon {\n    inset-block-start: convert.to-rem(80px);\n  }\n\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper[data-invalid]\n    > .#{$prefix}--text-input--invalid,\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper--warning\n    > .#{$prefix}--text-input--warning {\n    outline: none;\n  }\n\n  .#{$prefix}--form--fluid .#{$prefix}--text-input__field-wrapper--warning {\n    border-block-end: 1px solid $border-strong;\n  }\n\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper[data-invalid]:not(:focus) {\n    @include focus-outline('invalid');\n  }\n\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper[data-invalid]:focus-within,\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper--warning:focus-within {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper[data-invalid]\n    > .#{$prefix}--text-input--invalid:focus,\n  .#{$prefix}--form--fluid\n    .#{$prefix}--text-input__field-wrapper--warning\n    > .#{$prefix}--text-input--warning:focus {\n    outline: none;\n  }\n\n  //-----------------------------\n  // Inline Text Input\n  //-----------------------------\n\n  .#{$prefix}--text-input-wrapper.#{$prefix}--text-input-wrapper--inline {\n    flex-flow: row wrap;\n  }\n\n  .#{$prefix}--text-input-wrapper .#{$prefix}--label--inline {\n    flex: 1;\n    margin: convert.to-rem(13px) 0 0 0;\n    overflow-wrap: break-word;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--text-input-wrapper .#{$prefix}--label--inline--sm {\n    margin-block-start: convert.to-rem(9px);\n  }\n\n  .#{$prefix}--text-input-wrapper .#{$prefix}--label--inline--lg {\n    margin-block-start: convert.to-rem(17px);\n  }\n\n  .#{$prefix}--text-input__label-helper-wrapper {\n    flex: 2;\n    flex-direction: column;\n    margin-inline-end: convert.to-rem(24px);\n    max-inline-size: convert.to-rem(128px);\n    overflow-wrap: break-word;\n  }\n\n  .#{$prefix}--text-input-wrapper .#{$prefix}--form__helper-text--inline {\n    margin-block-start: convert.to-rem(2px);\n  }\n\n  .#{$prefix}--text-input__field-outer-wrapper {\n    display: flex;\n    flex: 1 1 auto;\n    flex-direction: column;\n    align-items: flex-start;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--text-input__field-outer-wrapper--inline {\n    flex: 8;\n    flex-direction: column;\n  }\n\n  .#{$prefix}--text-input-wrapper--inline .#{$prefix}--form-requirement {\n    display: block;\n    overflow: visible;\n    font-weight: 400;\n    max-block-size: convert.to-rem(200px);\n  }\n\n  .#{$prefix}--text-input-wrapper--inline--invalid\n    .#{$prefix}--form-requirement {\n    color: $text-error;\n  }\n\n  //-----------------------------\n  // Readonly\n  //-----------------------------\n\n  .#{$prefix}--form--fluid .#{$prefix}--text-input-wrapper--readonly,\n  .#{$prefix}--text-input-wrapper--readonly .#{$prefix}--text-input {\n    background: transparent;\n    border-block-end-color: $border-subtle;\n  }\n\n  // Styles for AILabel rendered inside TextInput\n  .#{$prefix}--text-input__field-wrapper--decorator\n    .#{$prefix}--text-input__field-inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-input__field-wrapper .#{$prefix}--ai-label,\n  .#{$prefix}--text-input__field-wrapper .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-05;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--text-input__field-wrapper--decorator\n    .#{$prefix}--text-input:has(\n      ~ .#{$prefix}--text-input__field-inner-wrapper--decorator\n        .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--text-input__field-inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--text-input__field-wrapper--slug\n    .#{$prefix}--text-input:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--text-input__field-wrapper--slug\n    .#{$prefix}--text-input:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ) {\n    @include ai-gradient;\n  }\n\n  .#{$prefix}--text-input__field-wrapper--decorator\n    .#{$prefix}--text-input:has(\n      ~ .#{$prefix}--text-input__field-inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-input__field-wrapper--slug\n    .#{$prefix}--text-input:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-input__field-wrapper--slug\n    .#{$prefix}--text-input:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-input--invalid:has(\n      ~ .#{$prefix}--text-input__field-inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-input--warning:has(\n      ~ .#{$prefix}--text-input__field-inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-input--invalid:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-input--warning:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-input--invalid:has(~ .#{$prefix}--slug),\n  .#{$prefix}--text-input--warning:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--text-input--invalid\n    ~ .#{$prefix}--text-input__field-inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-input--warning\n    ~ .#{$prefix}--text-input__field-inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-input--invalid ~ .#{$prefix}--ai-label,\n  .#{$prefix}--text-input--warning ~ .#{$prefix}--ai-label,\n  .#{$prefix}--text-input--invalid ~ .#{$prefix}--slug,\n  .#{$prefix}--text-input--warning ~ .#{$prefix}--slug {\n    inset-inline-end: $spacing-08;\n  }\n\n  // Decorator\n  .#{$prefix}--text-input__field-wrapper--decorator\n    .#{$prefix}--text-input__field-inner-wrapper--decorator:not(\n      :has(.#{$prefix}--ai-label)\n    )\n    > * {\n    block-size: 1rem;\n  }\n\n  .#{$prefix}--text-input__label-wrapper {\n    display: flex;\n    justify-content: space-between;\n    inline-size: 100%;\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../theme' as *;\n\n/// Adds placeholder text color\n/// @access public\n/// @example @include placeholder-colors;\n/// @group utilities\n@mixin placeholder-colors {\n  color: $text-placeholder;\n  opacity: 1;\n}\n","// Code generated by @carbon/colors. DO NOT EDIT.\n//\n// Copyright IBM Corp. 2018, 2026\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n$black: #000000 !default;\n$white: #ffffff !default;\n\n$black-100: #000000 !default;\n$blue-10: #edf5ff !default;\n$blue-20: #d0e2ff !default;\n$blue-30: #a6c8ff !default;\n$blue-40: #78a9ff !default;\n$blue-50: #4589ff !default;\n$blue-60: #0f62fe !default;\n$blue-70: #0043ce !default;\n$blue-80: #002d9c !default;\n$blue-90: #001d6c !default;\n$blue-100: #001141 !default;\n$cool-gray-10: #f2f4f8 !default;\n$cool-gray-20: #dde1e6 !default;\n$cool-gray-30: #c1c7cd !default;\n$cool-gray-40: #a2a9b0 !default;\n$cool-gray-50: #878d96 !default;\n$cool-gray-60: #697077 !default;\n$cool-gray-70: #4d5358 !default;\n$cool-gray-80: #343a3f !default;\n$cool-gray-90: #21272a !default;\n$cool-gray-100: #121619 !default;\n$cyan-10: #e5f6ff !default;\n$cyan-20: #bae6ff !default;\n$cyan-30: #82cfff !default;\n$cyan-40: #33b1ff !default;\n$cyan-50: #1192e8 !default;\n$cyan-60: #0072c3 !default;\n$cyan-70: #00539a !default;\n$cyan-80: #003a6d !default;\n$cyan-90: #012749 !default;\n$cyan-100: #061727 !default;\n$gray-10: #f4f4f4 !default;\n$gray-20: #e0e0e0 !default;\n$gray-30: #c6c6c6 !default;\n$gray-40: #a8a8a8 !default;\n$gray-50: #8d8d8d !default;\n$gray-60: #6f6f6f !default;\n$gray-70: #525252 !default;\n$gray-80: #393939 !default;\n$gray-90: #262626 !default;\n$gray-100: #161616 !default;\n$green-10: #defbe6 !default;\n$green-20: #a7f0ba !default;\n$green-30: #6fdc8c !default;\n$green-40: #42be65 !default;\n$green-50: #24a148 !default;\n$green-60: #198038 !default;\n$green-70: #0e6027 !default;\n$green-80: #044317 !default;\n$green-90: #022d0d !default;\n$green-100: #071908 !default;\n$magenta-10: #fff0f7 !default;\n$magenta-20: #ffd6e8 !default;\n$magenta-30: #ffafd2 !default;\n$magenta-40: #ff7eb6 !default;\n$magenta-50: #ee5396 !default;\n$magenta-60: #d02670 !default;\n$magenta-70: #9f1853 !default;\n$magenta-80: #740937 !default;\n$magenta-90: #510224 !default;\n$magenta-100: #2a0a18 !default;\n$orange-10: #fff2e8 !default;\n$orange-20: #ffd9be !default;\n$orange-30: #ffb784 !default;\n$orange-40: #ff832b !default;\n$orange-50: #eb6200 !default;\n$orange-60: #ba4e00 !default;\n$orange-70: #8a3800 !default;\n$orange-80: #5e2900 !default;\n$orange-90: #3e1a00 !default;\n$orange-100: #231000 !default;\n$purple-10: #f6f2ff !default;\n$purple-20: #e8daff !default;\n$purple-30: #d4bbff !default;\n$purple-40: #be95ff !default;\n$purple-50: #a56eff !default;\n$purple-60: #8a3ffc !default;\n$purple-70: #6929c4 !default;\n$purple-80: #491d8b !default;\n$purple-90: #31135e !default;\n$purple-100: #1c0f30 !default;\n$red-10: #fff1f1 !default;\n$red-20: #ffd7d9 !default;\n$red-30: #ffb3b8 !default;\n$red-40: #ff8389 !default;\n$red-50: #fa4d56 !default;\n$red-60: #da1e28 !default;\n$red-70: #a2191f !default;\n$red-80: #750e13 !default;\n$red-90: #520408 !default;\n$red-100: #2d0709 !default;\n$teal-10: #d9fbfb !default;\n$teal-20: #9ef0f0 !default;\n$teal-30: #3ddbd9 !default;\n$teal-40: #08bdba !default;\n$teal-50: #009d9a !default;\n$teal-60: #007d79 !default;\n$teal-70: #005d5d !default;\n$teal-80: #004144 !default;\n$teal-90: #022b30 !default;\n$teal-100: #081a1c !default;\n$warm-gray-10: #f7f3f2 !default;\n$warm-gray-20: #e5e0df !default;\n$warm-gray-30: #cac5c4 !default;\n$warm-gray-40: #ada8a8 !default;\n$warm-gray-50: #8f8b8b !default;\n$warm-gray-60: #726e6e !default;\n$warm-gray-70: #565151 !default;\n$warm-gray-80: #3c3838 !default;\n$warm-gray-90: #272525 !default;\n$warm-gray-100: #171414 !default;\n$white-0: #ffffff !default;\n$yellow-10: #fcf4d6 !default;\n$yellow-20: #fddc69 !default;\n$yellow-30: #f1c21b !default;\n$yellow-40: #d2a106 !default;\n$yellow-50: #b28600 !default;\n$yellow-60: #8e6a00 !default;\n$yellow-70: #684e00 !default;\n$yellow-80: #483700 !default;\n$yellow-90: #302400 !default;\n$yellow-100: #1c1500 !default;\n\n$white-hover: #e8e8e8 !default;\n$black-hover: #212121 !default;\n$blue-10-hover: #dbebff !default;\n$blue-20-hover: #b8d3ff !default;\n$blue-30-hover: #8ab6ff !default;\n$blue-40-hover: #5c97ff !default;\n$blue-50-hover: #1f70ff !default;\n$blue-60-hover: #0050e6 !default;\n$blue-70-hover: #0053ff !default;\n$blue-80-hover: #0039c7 !default;\n$blue-90-hover: #00258a !default;\n$blue-100-hover: #001f75 !default;\n$cool-gray-10-hover: #e4e9f1 !default;\n$cool-gray-20-hover: #cdd3da !default;\n$cool-gray-30-hover: #adb5bd !default;\n$cool-gray-40-hover: #9199a1 !default;\n$cool-gray-50-hover: #757b85 !default;\n$cool-gray-60-hover: #585e64 !default;\n$cool-gray-70-hover: #5d646a !default;\n$cool-gray-80-hover: #434a51 !default;\n$cool-gray-90-hover: #2b3236 !default;\n$cool-gray-100-hover: #222a2f !default;\n$cyan-10-hover: #cceeff !default;\n$cyan-20-hover: #99daff !default;\n$cyan-30-hover: #57beff !default;\n$cyan-40-hover: #059fff !default;\n$cyan-50-hover: #0f7ec8 !default;\n$cyan-60-hover: #005fa3 !default;\n$cyan-70-hover: #0066bd !default;\n$cyan-80-hover: #00498a !default;\n$cyan-90-hover: #013360 !default;\n$cyan-100-hover: #0b2947 !default;\n$gray-10-hover: #e8e8e8 !default;\n$gray-20-hover: #d1d1d1 !default;\n$gray-30-hover: #b5b5b5 !default;\n$gray-40-hover: #999999 !default;\n$gray-50-hover: #7a7a7a !default;\n$gray-60-hover: #5e5e5e !default;\n$gray-70-hover: #636363 !default;\n$gray-80-hover: #474747 !default;\n$gray-90-hover: #333333 !default;\n$gray-100-hover: #292929 !default;\n$green-10-hover: #b6f6c8 !default;\n$green-20-hover: #74e792 !default;\n$green-30-hover: #36ce5e !default;\n$green-40-hover: #3bab5a !default;\n$green-50-hover: #208e3f !default;\n$green-60-hover: #166f31 !default;\n$green-70-hover: #11742f !default;\n$green-80-hover: #05521c !default;\n$green-90-hover: #033b11 !default;\n$green-100-hover: #0d300f !default;\n$magenta-10-hover: #ffe0ef !default;\n$magenta-20-hover: #ffbdda !default;\n$magenta-30-hover: #ff94c3 !default;\n$magenta-40-hover: #ff57a0 !default;\n$magenta-50-hover: #e3176f !default;\n$magenta-60-hover: #b0215f !default;\n$magenta-70-hover: #bf1d63 !default;\n$magenta-80-hover: #8e0b43 !default;\n$magenta-90-hover: #68032e !default;\n$magenta-100-hover: #53142f !default;\n$orange-10-hover: #ffe2cc !default;\n$orange-20-hover: #ffc69e !default;\n$orange-30-hover: #ff9d57 !default;\n$orange-40-hover: #fa6800 !default;\n$orange-50-hover: #cc5500 !default;\n$orange-60-hover: #9e4200 !default;\n$orange-70-hover: #a84400 !default;\n$orange-80-hover: #753300 !default;\n$orange-90-hover: #522200 !default;\n$orange-100-hover: #421e00 !default;\n$purple-10-hover: #ede5ff !default;\n$purple-20-hover: #dcc7ff !default;\n$purple-30-hover: #c5a3ff !default;\n$purple-40-hover: #ae7aff !default;\n$purple-50-hover: #9352ff !default;\n$purple-60-hover: #7822fb !default;\n$purple-70-hover: #7c3dd6 !default;\n$purple-80-hover: #5b24ad !default;\n$purple-90-hover: #40197b !default;\n$purple-100-hover: #341c59 !default;\n$red-10-hover: #ffe0e0 !default;\n$red-20-hover: #ffc2c5 !default;\n$red-30-hover: #ff99a0 !default;\n$red-40-hover: #ff6168 !default;\n$red-50-hover: #ee0713 !default;\n$red-60-hover: #b81922 !default;\n$red-70-hover: #c21e25 !default;\n$red-80-hover: #921118 !default;\n$red-90-hover: #66050a !default;\n$red-100-hover: #540d11 !default;\n$teal-10-hover: #acf6f6 !default;\n$teal-20-hover: #57e5e5 !default;\n$teal-30-hover: #25cac8 !default;\n$teal-40-hover: #07aba9 !default;\n$teal-50-hover: #008a87 !default;\n$teal-60-hover: #006b68 !default;\n$teal-70-hover: #007070 !default;\n$teal-80-hover: #005357 !default;\n$teal-90-hover: #033940 !default;\n$teal-100-hover: #0f3034 !default;\n$warm-gray-10-hover: #f0e8e6 !default;\n$warm-gray-20-hover: #d8d0cf !default;\n$warm-gray-30-hover: #b9b3b1 !default;\n$warm-gray-40-hover: #9c9696 !default;\n$warm-gray-50-hover: #7f7b7b !default;\n$warm-gray-60-hover: #605d5d !default;\n$warm-gray-70-hover: #696363 !default;\n$warm-gray-80-hover: #4c4848 !default;\n$warm-gray-90-hover: #343232 !default;\n$warm-gray-100-hover: #2c2626 !default;\n$yellow-10-hover: #f8e6a0 !default;\n$yellow-20-hover: #fccd27 !default;\n$yellow-30-hover: #ddb00e !default;\n$yellow-40-hover: #bc9005 !default;\n$yellow-50-hover: #9e7700 !default;\n$yellow-60-hover: #755800 !default;\n$yellow-70-hover: #806000 !default;\n$yellow-80-hover: #5c4600 !default;\n$yellow-90-hover: #3d2e00 !default;\n$yellow-100-hover: #332600 !default;\n\n/// Colors from the IBM Design Language\n/// @access public\n/// @group @carbon/colors\n$colors: (\n  black: (\n    100: #000000,\n  ),\n  blue: (\n    10: #edf5ff,\n    20: #d0e2ff,\n    30: #a6c8ff,\n    40: #78a9ff,\n    50: #4589ff,\n    60: #0f62fe,\n    70: #0043ce,\n    80: #002d9c,\n    90: #001d6c,\n    100: #001141,\n  ),\n  cool-gray: (\n    10: #f2f4f8,\n    20: #dde1e6,\n    30: #c1c7cd,\n    40: #a2a9b0,\n    50: #878d96,\n    60: #697077,\n    70: #4d5358,\n    80: #343a3f,\n    90: #21272a,\n    100: #121619,\n  ),\n  cyan: (\n    10: #e5f6ff,\n    20: #bae6ff,\n    30: #82cfff,\n    40: #33b1ff,\n    50: #1192e8,\n    60: #0072c3,\n    70: #00539a,\n    80: #003a6d,\n    90: #012749,\n    100: #061727,\n  ),\n  gray: (\n    10: #f4f4f4,\n    20: #e0e0e0,\n    30: #c6c6c6,\n    40: #a8a8a8,\n    50: #8d8d8d,\n    60: #6f6f6f,\n    70: #525252,\n    80: #393939,\n    90: #262626,\n    100: #161616,\n  ),\n  green: (\n    10: #defbe6,\n    20: #a7f0ba,\n    30: #6fdc8c,\n    40: #42be65,\n    50: #24a148,\n    60: #198038,\n    70: #0e6027,\n    80: #044317,\n    90: #022d0d,\n    100: #071908,\n  ),\n  magenta: (\n    10: #fff0f7,\n    20: #ffd6e8,\n    30: #ffafd2,\n    40: #ff7eb6,\n    50: #ee5396,\n    60: #d02670,\n    70: #9f1853,\n    80: #740937,\n    90: #510224,\n    100: #2a0a18,\n  ),\n  orange: (\n    10: #fff2e8,\n    20: #ffd9be,\n    30: #ffb784,\n    40: #ff832b,\n    50: #eb6200,\n    60: #ba4e00,\n    70: #8a3800,\n    80: #5e2900,\n    90: #3e1a00,\n    100: #231000,\n  ),\n  purple: (\n    10: #f6f2ff,\n    20: #e8daff,\n    30: #d4bbff,\n    40: #be95ff,\n    50: #a56eff,\n    60: #8a3ffc,\n    70: #6929c4,\n    80: #491d8b,\n    90: #31135e,\n    100: #1c0f30,\n  ),\n  red: (\n    10: #fff1f1,\n    20: #ffd7d9,\n    30: #ffb3b8,\n    40: #ff8389,\n    50: #fa4d56,\n    60: #da1e28,\n    70: #a2191f,\n    80: #750e13,\n    90: #520408,\n    100: #2d0709,\n  ),\n  teal: (\n    10: #d9fbfb,\n    20: #9ef0f0,\n    30: #3ddbd9,\n    40: #08bdba,\n    50: #009d9a,\n    60: #007d79,\n    70: #005d5d,\n    80: #004144,\n    90: #022b30,\n    100: #081a1c,\n  ),\n  warm-gray: (\n    10: #f7f3f2,\n    20: #e5e0df,\n    30: #cac5c4,\n    40: #ada8a8,\n    50: #8f8b8b,\n    60: #726e6e,\n    70: #565151,\n    80: #3c3838,\n    90: #272525,\n    100: #171414,\n  ),\n  white: (\n    0: #ffffff,\n  ),\n  yellow: (\n    10: #fcf4d6,\n    20: #fddc69,\n    30: #f1c21b,\n    40: #d2a106,\n    50: #b28600,\n    60: #8e6a00,\n    70: #684e00,\n    80: #483700,\n    90: #302400,\n    100: #1c1500,\n  ),\n) !default;\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'box-shadow' as *;\n@use 'convert';\n@use 'focus-outline' as *;\n@use 'z-index' as *;\n@use '../config' as *;\n@use '../motion' as *;\n@use '../spacing' as *;\n@use '../theme' as *;\n@use '../type';\n\n// Tooltip\n// Tooltip caret visual styles\n/// @access public\n/// @group tooltip\n@mixin tooltip--caret {\n  position: absolute;\n  z-index: z('floating');\n  border-style: solid;\n  block-size: 0;\n  content: '';\n  inline-size: 0;\n}\n\n// Tooltip\n// Tooltip content box visual styles\n/// @param {String} $tooltip-type ['icon'] - The type, from: `icon`, `definition`\n/// @access public\n/// @group tooltip\n@mixin tooltip--content($tooltip-type: 'icon') {\n  @include box-shadow;\n\n  z-index: z('floating');\n  @if $tooltip-type == 'definition' {\n    padding: $spacing-03 $spacing-05;\n  } @else {\n    padding: convert.to-rem(3px) $spacing-05;\n  }\n\n  border-radius: convert.to-rem(2px);\n  background-color: $background-inverse;\n  block-size: auto;\n  color: $text-inverse;\n  font-weight: 400;\n  inline-size: max-content;\n  max-inline-size: convert.to-rem(208px);\n  min-inline-size: convert.to-rem(24px);\n  text-align: start;\n  transform: translateX(-50%);\n  @include type.type-style('body-compact-01');\n\n  // IE media query\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    inline-size: auto;\n  }\n  // Edge 12-15 and Edge 16 feature queries\n  @supports (-ms-accelerator: true) {\n    inline-size: auto;\n  }\n  @supports (-ms-ime-align: auto) {\n    inline-size: auto;\n  }\n\n  // Windows, Firefox HCM Fix\n  @media screen and (-ms-high-contrast: active), screen and (prefers-contrast) {\n    border: 1px solid transparent;\n  }\n}\n\n// Tooltip\n// Definition and Icon CSS only tooltip\n/// @param {String} $tooltip-type ['icon'] - The type, from: `icon`, `definition`\n/// @param {String} $position ['bottom'] - The position, from: `top`, `right`, `bottom`, `left`\n/// @access public\n/// @group tooltip\n@mixin tooltip--trigger($tooltip-type: 'icon', $position: 'bottom') {\n  position: relative;\n  display: inline-flex;\n  overflow: visible;\n  align-items: center;\n\n  &:focus {\n    @include focus-outline('border');\n  }\n\n  @if $tooltip-type == 'definition' {\n    cursor: default;\n  }\n\n  @if $tooltip-type == 'icon' {\n    cursor: pointer;\n\n    &:focus {\n      outline: 1px solid transparent;\n\n      svg {\n        @include focus-outline('border');\n      }\n    }\n  }\n\n  // ::before - Tooltip caret\n  // ::after - legacy Tooltip content (deprecated)\n  // .#{$prefix}--assistive-text - WCAG 2.1 compliant tooltip content\n  //    that can either be a child (icon tooltip) or sibling (definition tooltip)\n  &::before,\n  &::after,\n  .#{$prefix}--assistive-text,\n  + .#{$prefix}--assistive-text {\n    position: absolute;\n    z-index: z('floating');\n    display: flex;\n    align-items: center;\n    opacity: 0;\n    pointer-events: none;\n\n    // IE media query\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      display: inline-block;\n    }\n  }\n\n  &::before,\n  &::after {\n    transition: opacity $duration-fast-01 motion(standard, productive);\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n  }\n\n  &.#{$prefix}--tooltip--a11y::before,\n  &.#{$prefix}--tooltip--a11y::after {\n    transition: none;\n  }\n\n  // caret\n  &::before {\n    border-style: solid;\n    block-size: 0;\n    content: '';\n    inline-size: 0;\n  }\n\n  .#{$prefix}--assistive-text,\n  + .#{$prefix}--assistive-text {\n    box-sizing: content-box;\n    color: inherit;\n    // In order to pass AAT, opacity must be set to 1 in the default state\n    // On focus/hover use a keyframe animation to mimic transition\n    opacity: 1;\n    // overwrite default nowrap behavior\n    white-space: normal;\n    word-break: break-word;\n  }\n\n  // content box\n  // TODO: Simplify CSS selectors on next major release\n  &::after,\n  .#{$prefix}--assistive-text,\n  + .#{$prefix}--assistive-text {\n    @include tooltip--content($tooltip-type);\n  }\n\n  &::after {\n    content: attr(aria-label);\n  }\n\n  &.#{$prefix}--tooltip--a11y::after {\n    content: none;\n  }\n\n  &.#{$prefix}--tooltip--visible,\n  &:hover,\n  &:focus {\n    &::before,\n    &::after {\n      opacity: 1;\n    }\n\n    @keyframes #{$prefix}--tooltip-fade {\n      from {\n        opacity: 0;\n      }\n\n      to {\n        opacity: 1;\n      }\n    }\n\n    .#{$prefix}--assistive-text,\n    + .#{$prefix}--assistive-text {\n      overflow: visible;\n      margin: auto;\n      clip: auto;\n    }\n\n    .#{$prefix}--assistive-text,\n    + .#{$prefix}--assistive-text,\n    &.#{$prefix}--tooltip--a11y::before {\n      animation: #{$prefix}--tooltip-fade $duration-fast-01\n        motion(standard, productive);\n    }\n  }\n\n  &.#{$prefix}--tooltip--hidden .#{$prefix}--assistive-text,\n  &.#{$prefix}--tooltip--hidden + .#{$prefix}--assistive-text {\n    overflow: hidden;\n    margin: -1px;\n    clip: rect(0, 0, 0, 0);\n  }\n\n  &.#{$prefix}--tooltip--hidden.#{$prefix}--tooltip--a11y::before {\n    animation: none;\n    opacity: 0;\n  }\n}\n\n// Tooltip\n// Definition and Icon CSS only tooltip\n/// @param {String} $tooltip-type ['icon'] - The type, from: `icon`, `definition`\n/// @param {String} $position ['bottom'] - The position, from: `top`, `right`, `bottom`, `left`\n/// @param {String} $align ['center'] - The alignment, from: `start`, `center`, `end`\n/// @access public\n/// @group tooltip\n@mixin tooltip--placement(\n  $tooltip-type: 'icon',\n  $position: 'bottom',\n  $align: 'center'\n) {\n  // position and alignment\n  $caret-spacing: $spacing-03;\n\n  @if $tooltip-type == 'definition' {\n    $caret-spacing: $spacing-02;\n  }\n\n  // space between caret and trigger button\n  $caret-height: convert.to-rem(5px);\n  $caret-width: convert.to-rem(8px);\n  $body-spacing: $caret-spacing + $caret-height;\n\n  // Use pseudo element to create invisible hover area to keep tooltip open on hover\n  .#{$prefix}--assistive-text::after {\n    position: absolute;\n    display: block;\n    content: '';\n    // clip-path: polygon(50% 100%, 0 0, 100% 0);\n\n    @if ($position == 'top' or $position == 'bottom') {\n      block-size: convert.to-rem(12px);\n      inline-size: 100%;\n      inset-inline-start: 0;\n    }\n\n    @if ($position == 'left' or $position == 'right') {\n      block-size: 100%;\n      inline-size: convert.to-rem(12px);\n      inset-block-start: 0;\n    }\n\n    @if ($position == 'top') {\n      inset-block-end: convert.to-rem(-12px);\n    }\n    @if ($position == 'right') {\n      inset-inline-start: convert.to-rem(-12px);\n    }\n    @if ($position == 'bottom') {\n      inset-block-start: convert.to-rem(-12px);\n    }\n    @if ($position == 'left') {\n      inset-inline-end: convert.to-rem(-12px);\n    }\n  }\n\n  // TODO: Simplify CSS selectors on next major release\n  &::before,\n  &::after,\n  .#{$prefix}--assistive-text,\n  + .#{$prefix}--assistive-text {\n    @if ($position == 'top') {\n      inset-block-start: 0;\n      inset-inline-start: 50%;\n    }\n    @if ($position == 'right') {\n      inset-block-start: 50%;\n      inset-inline-end: 0;\n    }\n    @if ($position == 'bottom') {\n      inset-block-end: 0;\n      inset-inline-start: 50%;\n    }\n    @if ($position == 'left') {\n      inset-block-start: 50%;\n      inset-inline-start: 0;\n    }\n  }\n\n  &::before {\n    @if ($position == 'top') {\n      border-width: convert.to-rem(5px)\n        convert.to-rem(4px)\n        0\n        convert.to-rem(4px);\n      border-color: $background-inverse transparent transparent transparent;\n      inset-block-start: -$caret-spacing;\n      transform: translate(-50%, -100%);\n    }\n    @if ($position == 'right') {\n      border-width: convert.to-rem(4px)\n        convert.to-rem(5px)\n        convert.to-rem(4px)\n        0;\n      border-color: transparent $background-inverse transparent transparent;\n      inset-inline-end: -$caret-spacing;\n      transform: translate(100%, -50%);\n    }\n    @if ($position == 'bottom') {\n      border-width: 0 convert.to-rem(4px) convert.to-rem(5px);\n      border-color: transparent transparent $background-inverse;\n      inset-block-end: -$caret-spacing;\n      transform: translate(-50%, 100%);\n    }\n    @if ($position == 'left') {\n      border-width: convert.to-rem(4px)\n        0\n        convert.to-rem(4px)\n        convert.to-rem(5px);\n      border-color: transparent transparent transparent $background-inverse;\n      inset-inline-start: -$caret-spacing;\n      transform: translate(-100%, -50%);\n    }\n  }\n\n  // alignment options available only for top and bottom tooltip position\n  // TODO: Simplify CSS selectors on next major release\n  &::after,\n  .#{$prefix}--assistive-text,\n  + .#{$prefix}--assistive-text {\n    @if ($position == 'top') {\n      inset-block-start: -$body-spacing;\n      @if ($align == 'start') {\n        inset-inline-start: 0;\n        transform: translate(0, -100%);\n      } @else if ($align == 'end') {\n        inset-inline: auto 0;\n        transform: translate(0, -100%);\n      } @else {\n        inset-inline-start: 50%;\n        transform: translate(-50%, -100%);\n      }\n    }\n    @if ($position == 'right') {\n      inset-inline-end: -$body-spacing;\n      transform: translate(100%, -50%);\n    }\n    @if ($position == 'bottom') {\n      inset-block-end: -$body-spacing;\n      @if ($align == 'start') {\n        inset-inline-start: 0;\n        transform: translate(0, 100%);\n      } @else if ($align == 'end') {\n        inset-inline: auto 0;\n        transform: translate(0, 100%);\n      } @else {\n        transform: translate(-50%, 100%);\n      }\n    }\n    @if ($position == 'left') {\n      inset-inline-start: -$body-spacing;\n      transform: translate(-100%, -50%);\n    }\n  }\n\n  // TODO: simplify on next major release to move the ::before pseudo element within the tooltip instead of the trigger\n  @if $tooltip-type == 'definition' {\n    &.#{$prefix}--tooltip--a11y + .#{$prefix}--assistive-text {\n      @if ($position == 'bottom') {\n        // carryover from https://github.com/carbon-design-system/carbon/pull/3151/files#diff-93734be0784e9530b6d14a7b03b0d352R261-R265\n        inset-block-end: -($body-spacing - convert.to-rem(1px));\n        @if ($align == 'start' or $align == 'end') {\n          transform: translate(0, 100%);\n        } @else {\n          transform: translate(-50%, 100%);\n        }\n      }\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../form';\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/placeholder-colors' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/layout';\n@use '../../utilities/visually-hidden' as *;\n\n/// Text area styles\n/// @access public\n/// @group text-area\n@mixin text-area {\n  .#{$prefix}--text-area {\n    @include component-reset.reset;\n    @include type-style('body-01');\n    @include focus-outline('reset');\n\n    padding: convert.to-rem(11px) layout.density('padding-inline');\n    border: none;\n    background-color: $field;\n    block-size: 100%;\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    font-family: inherit;\n    min-block-size: convert.to-rem(40px);\n\n    min-inline-size: 10rem;\n    resize: vertical;\n    transition:\n      background-color $duration-fast-01 motion(standard, productive),\n      outline $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--text-area:focus,\n  .#{$prefix}--text-area:active {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--text-area::placeholder {\n    @include placeholder-colors;\n    @include type-style('body-01');\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--text-area--light {\n    background-color: $field-02;\n  }\n\n  .#{$prefix}--text-area__wrapper {\n    @include layout.use('density', $default: 'normal');\n\n    position: relative;\n    display: flex;\n    inline-size: 100%;\n    max-inline-size: 100%;\n  }\n\n  .#{$prefix}--text-area__wrapper--cols {\n    inline-size: auto;\n  }\n\n  .#{$prefix}--text-area__invalid-icon {\n    position: absolute;\n    fill: $support-error;\n    inset-block-start: $spacing-04;\n    inset-inline-end: layout.density('padding-inline');\n  }\n\n  .#{$prefix}--text-area__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--text-area__invalid-icon--warning path[fill] {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--text-area__counter-alert {\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    border: 0;\n    margin: -1px;\n    block-size: 1px;\n    clip: rect(0, 0, 0, 0);\n    inline-size: 1px;\n  }\n\n  .#{$prefix}--form-item {\n    &:has(.#{$prefix}--text-area__wrapper--cols) {\n      inline-size: fit-content;\n    }\n  }\n\n  //-----------------------------\n  // Disabled\n  //-----------------------------\n  .#{$prefix}--text-area:disabled {\n    background-color: $field;\n    border-block-end: 1px solid transparent;\n    color: $text-disabled;\n    cursor: not-allowed;\n    outline: none;\n    resize: none;\n  }\n\n  .#{$prefix}--text-area:disabled::placeholder {\n    color: $text-disabled;\n  }\n\n  //-----------------------------\n  // Readonly\n  //-----------------------------\n  .#{$prefix}--text-area__wrapper--readonly .#{$prefix}--text-area {\n    background: transparent;\n    border-block-end-color: $border-subtle;\n  }\n\n  // Styles for `AILabel` rendered inside `TextArea`\n  .#{$prefix}--text-area__wrapper--decorator\n    .#{$prefix}--text-area__inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-area__wrapper--slug .#{$prefix}--ai-label,\n  .#{$prefix}--text-area__wrapper--slug .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: $spacing-04;\n    inset-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--text-area__wrapper--decorator\n    .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--slug.#{$prefix}--slug--revert {\n    inset-block-start: $spacing-02;\n    inset-inline-end: $spacing-03;\n    transform: translate(0);\n  }\n\n  .#{$prefix}--text-area__wrapper--decorator\n    .#{$prefix}--text-area:has(\n      ~ .#{$prefix}--text-area__inner-wrapper--decorator .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--text-area__inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--text-area:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--text-area:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ) {\n    @include ai-gradient;\n  }\n\n  .#{$prefix}--text-area__wrapper--decorator\n    .#{$prefix}--text-area:has(\n      ~ .#{$prefix}--text-area__inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--text-area:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-area__wrapper--slug\n    .#{$prefix}--text-area:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-area--invalid:has(\n      ~ .#{$prefix}--text-area__inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-area--warn:has(\n      ~ .#{$prefix}--text-area__inner-wrapper--decorator > *\n    ),\n  .#{$prefix}--text-area--invalid:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-area--warn:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--text-area--invalid:has(~ .#{$prefix}--slug),\n  .#{$prefix}--text-area--warn:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--text-area--invalid\n    ~ .#{$prefix}--text-area__inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-area--warn\n    ~ .#{$prefix}--text-area__inner-wrapper--decorator\n    > *,\n  .#{$prefix}--text-area--invalid ~ .#{$prefix}--ai-label,\n  .#{$prefix}--text-area--warn ~ .#{$prefix}--ai-label,\n  .#{$prefix}--text-area--invalid ~ .#{$prefix}--slug,\n  .#{$prefix}--text-area--warn ~ .#{$prefix}--slug {\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--text-area--invalid\n    ~ .#{$prefix}--text-area__inner-wrapper--decorator\n    > .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area--warn\n    ~ .#{$prefix}--text-area__inner-wrapper--decorator\n    > .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area--invalid\n    ~ .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area--warn\n    ~ .#{$prefix}--ai-label.#{$prefix}--ai-label--revert,\n  .#{$prefix}--text-area--invalid ~ .#{$prefix}--slug.#{$prefix}--slug--revert,\n  .#{$prefix}--text-area--warn ~ .#{$prefix}--slug.#{$prefix}--slug--revert {\n    inset-inline-end: $spacing-07;\n  }\n\n  // Skeleton State\n  .#{$prefix}--text-area.#{$prefix}--skeleton {\n    @include skeleton;\n\n    block-size: convert.to-rem(100px);\n    inline-size: 100%;\n\n    &::placeholder {\n      color: transparent;\n    }\n  }\n\n  .#{$prefix}--text-area__label-wrapper {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    inline-size: 100%;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../theme' as *;\n@use '../../utilities/button-reset';\n@use '../../type' as *;\n@use '../../motion' as *;\n@use '../../config' as *;\n@use '../../utilities/component-tokens' as *;\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/layout';\n@use '../../spacing' as *;\n@use './tokens' as *;\n@use './mixins' as *;\n@use '../../utilities/skeleton' as *;\n\n/// Tag styles\n/// @access public\n/// @group tag\n@mixin tag {\n  .#{$prefix}--tag {\n    @include layout.redefine-tokens(\n      (\n        size: (\n          height: (\n            xs: convert.to-rem(18px),\n            sm: convert.to-rem(18px),\n            md: convert.to-rem(24px),\n            lg: convert.to-rem(32px),\n          ),\n        ),\n      )\n    );\n\n    @include layout.use('size', $default: 'md', $min: 'sm', $max: 'lg');\n    @include type-style('label-01');\n    @include tag-theme($tag-background-gray, $tag-color-gray, $tag-hover-gray);\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: convert.to-rem(16px);\n    cursor: default;\n    // restricts size of contained elements\n    max-inline-size: convert.to-rem(208px);\n    min-block-size: layout.size('height');\n    // ensures tag stays pill shaped;\n    min-inline-size: convert.to-rem(32px);\n    padding-inline: $spacing-03;\n    vertical-align: middle;\n    word-break: break-word;\n\n    &.#{$prefix}--tag--lg {\n      padding-inline-start: $spacing-04;\n    }\n\n    &:has(.#{$prefix}--tag__custom-icon) {\n      padding-inline-start: $spacing-02;\n    }\n\n    &.#{$prefix}--tag--lg:not(.#{$prefix}--tag--filter) {\n      padding-inline: $spacing-04;\n    }\n\n    &.#{$prefix}--tag--lg:has(.#{$prefix}--tag__custom-icon) {\n      padding-inline-start: $spacing-03;\n    }\n\n    &:not(.#{$prefix}--tag--selectable) {\n      border: 0;\n    }\n\n    &:not(:first-child) {\n      margin-inline-start: 0;\n    }\n  }\n\n  .#{$prefix}--tag--operational > span,\n  .#{$prefix}--tag--selectable > span,\n  .#{$prefix}--tag__label {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--tag--interactive:focus {\n    outline: 2px solid $focus;\n    outline-offset: 1px;\n  }\n\n  // tags used for filtering\n  .#{$prefix}--tag--filter {\n    padding-block: 0;\n    padding-inline-end: 0;\n\n    &:hover {\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--tag--selectable {\n    border: 1px solid $border-inverse;\n    background-color: $layer;\n    color: $text-primary;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $layer-hover;\n      outline: none;\n    }\n\n    &:focus {\n      outline: 2px solid $focus;\n      outline-offset: 1px;\n    }\n  }\n\n  .#{$prefix}--tag--selectable-selected {\n    background-color: $layer-selected-inverse;\n    color: $text-inverse;\n\n    &:hover {\n      background-color: $layer-selected-inverse;\n    }\n  }\n\n  .#{$prefix}--tag--operational {\n    border: 1px solid $tag-border-gray;\n    background-color: $tag-background-gray;\n    color: $tag-color-gray;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $tag-hover-gray;\n      outline: none;\n    }\n\n    &:focus {\n      outline: 2px solid $focus;\n      outline-offset: 1px;\n    }\n  }\n\n  .#{$prefix}--tag--red {\n    @include tag-theme(\n      $tag-background-red,\n      $tag-color-red,\n      $tag-hover-red,\n      $tag-border-red\n    );\n  }\n\n  .#{$prefix}--tag--magenta {\n    @include tag-theme(\n      $tag-background-magenta,\n      $tag-color-magenta,\n      $tag-hover-magenta,\n      $tag-border-magenta\n    );\n  }\n\n  .#{$prefix}--tag--purple {\n    @include tag-theme(\n      $tag-background-purple,\n      $tag-color-purple,\n      $tag-hover-purple,\n      $tag-border-purple\n    );\n  }\n\n  .#{$prefix}--tag--blue {\n    @include tag-theme(\n      $tag-background-blue,\n      $tag-color-blue,\n      $tag-hover-blue,\n      $tag-border-blue\n    );\n  }\n\n  .#{$prefix}--tag--cyan {\n    @include tag-theme(\n      $tag-background-cyan,\n      $tag-color-cyan,\n      $tag-hover-cyan,\n      $tag-border-cyan\n    );\n  }\n\n  .#{$prefix}--tag--teal {\n    @include tag-theme(\n      $tag-background-teal,\n      $tag-color-teal,\n      $tag-hover-teal,\n      $tag-border-teal\n    );\n  }\n\n  .#{$prefix}--tag--green {\n    @include tag-theme(\n      $tag-background-green,\n      $tag-color-green,\n      $tag-hover-green,\n      $tag-border-green\n    );\n  }\n\n  .#{$prefix}--tag--gray {\n    @include tag-theme(\n      $tag-background-gray,\n      $tag-color-gray,\n      $tag-hover-gray,\n      $tag-border-gray\n    );\n  }\n\n  .#{$prefix}--tag--cool-gray {\n    @include tag-theme(\n      $tag-background-cool-gray,\n      $tag-color-cool-gray,\n      $tag-hover-cool-gray,\n      $tag-border-cool-gray\n    );\n  }\n\n  .#{$prefix}--tag--warm-gray {\n    @include tag-theme(\n      $tag-background-warm-gray,\n      $tag-color-warm-gray,\n      $tag-hover-warm-gray,\n      $tag-border-warm-gray\n    );\n  }\n\n  .#{$prefix}--tag--high-contrast:not(.#{$prefix}--tag--operational) {\n    @include tag-theme(\n      $background-inverse,\n      $text-inverse,\n      $background-inverse-hover\n    );\n  }\n\n  .#{$prefix}--multi-select--readonly\n    .#{$prefix}--tag--high-contrast:not(.#{$prefix}--tag--operational)\n    .#{$prefix}--tag__close-icon {\n    &:hover {\n      background-color: transparent;\n    }\n  }\n\n  .#{$prefix}--tag--outline:not(.#{$prefix}--tag--operational):not(span):not(\n      [disabled]\n    ) {\n    @include tag-theme($background, $text-primary, $layer-hover);\n\n    outline: 1px solid $background-inverse;\n    outline-offset: -1px;\n  }\n\n  .#{$prefix}--tag--disabled:not(.#{$prefix}--tag--operational),\n  .#{$prefix}--tag--filter.#{$prefix}--tag--disabled,\n  .#{$prefix}--tag--interactive.#{$prefix}--tag--disabled {\n    @include tag-theme($layer, $text-disabled);\n\n    box-shadow: none;\n    outline: none;\n\n    &:hover {\n      cursor: not-allowed;\n    }\n\n    .#{$prefix}--tag__label {\n      background-color: $layer;\n      color: $text-disabled;\n    }\n  }\n\n  .#{$prefix}--tag--selectable.#{$prefix}--tag--disabled,\n  .#{$prefix}--tag--operational.#{$prefix}--tag--disabled {\n    border: 1px solid $border-disabled;\n    background-color: $layer;\n    color: $text-disabled;\n\n    &:hover {\n      background-color: $layer;\n      cursor: not-allowed;\n    }\n  }\n\n  .#{$prefix}--tag--interactive {\n    transition: background-color $duration-fast-01 motion(entrance, productive);\n  }\n\n  .#{$prefix}--tag__close-icon {\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    margin: 0 0 0 convert.to-rem(2px);\n    background-color: transparent;\n    block-size: layout.size('height');\n    color: currentColor;\n    cursor: pointer;\n    inline-size: layout.size('height');\n    transition:\n      background-color $duration-fast-01 motion(standard, productive),\n      box-shadow $duration-fast-01 motion(standard, productive);\n\n    svg {\n      fill: currentColor;\n    }\n  }\n\n  .#{$prefix}--tag__custom-icon {\n    flex-shrink: 0;\n    padding: 0;\n    border: 0;\n    background-color: transparent;\n    block-size: convert.to-rem(16px);\n    color: currentColor;\n    inline-size: convert.to-rem(16px);\n    margin-inline-end: $spacing-02;\n    outline: none;\n\n    svg {\n      fill: currentColor;\n    }\n  }\n\n  .#{$prefix}--tag--disabled .#{$prefix}--tag__close-icon {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--tag__close-icon:focus {\n    z-index: 99999;\n    border-radius: 50%;\n    box-shadow: inset 0 0 0 1px $focus;\n    outline: none;\n  }\n\n  .#{$prefix}--tag--high-contrast .#{$prefix}--tag__close-icon:focus {\n    box-shadow: inset 0 0 0 1px $focus-inverse;\n  }\n\n  .#{$prefix}--tag--filter.#{$prefix}--tag--disabled\n    .#{$prefix}--tag__close-icon:hover {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--tag--filter.#{$prefix}--tag--disabled svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--tag--sm.#{$prefix}--tag--filter {\n    padding-inline-end: 0;\n  }\n\n  .#{$prefix}--tag--sm .#{$prefix}--tag__close-icon {\n    margin-inline-start: convert.to-rem(5px);\n  }\n\n  // Skeleton state\n  .#{$prefix}--tag.#{$prefix}--skeleton {\n    @include skeleton;\n\n    @include tag-theme(\n      $bg-color: $skeleton-background,\n      $text-color: $text-primary\n    );\n\n    overflow: hidden;\n    inline-size: convert.to-rem(60px);\n\n    // Safari specific bug (#7672)\n    @supports (hanging-punctuation: first) and (font: -apple-system-body) and\n      (-webkit-appearance: none) {\n      transform: translateZ(0);\n    }\n  }\n\n  // AILabel styles\n  .#{$prefix}--tag .#{$prefix}--ai-label .#{$prefix}--ai-label__button--inline,\n  .#{$prefix}--tag .#{$prefix}--slug .#{$prefix}--slug__button--inline {\n    color: currentColor;\n    margin-inline-start: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--tag\n    .#{$prefix}--ai-label\n    .#{$prefix}--ai-label__button--inline\n    .#{$prefix}--ai-label__text::before,\n  .#{$prefix}--tag\n    .#{$prefix}--slug\n    .#{$prefix}--slug__button--inline\n    .#{$prefix}--slug__text::before {\n    background-color: currentColor;\n  }\n\n  .#{$prefix}--tag\n    .#{$prefix}--ai-label\n    .#{$prefix}--ai-label__button--inline:hover,\n  .#{$prefix}--tag .#{$prefix}--slug .#{$prefix}--slug__button--inline:hover {\n    border-color: currentColor;\n  }\n\n  .#{$prefix}--tag--filter .#{$prefix}--tag__decorator > *,\n  .#{$prefix}--tag--filter .#{$prefix}--ai-label,\n  .#{$prefix}--tag--filter .#{$prefix}--slug {\n    min-inline-size: convert.to-rem(32.14px);\n  }\n\n  // Decorator styles\n  .#{$prefix}--tag\n    .#{$prefix}--tag__decorator:not(:has(.#{$prefix}--ai-label)) {\n    block-size: 1rem;\n    text-align: center;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--tag {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--tag__close-icon:focus {\n    @include high-contrast-mode('focus');\n  }\n\n  .#{$prefix}--tag-label-tooltip {\n    max-inline-size: -webkit-fill-available;\n  }\n\n  .#{$prefix}--tag__custom-icon + .#{$prefix}--tag-label-tooltip {\n    max-inline-size: convert.to-rem(176px);\n  }\n\n  .#{$prefix}--tag--filter\n    .#{$prefix}--tag__custom-icon\n    + .#{$prefix}--tag-label-tooltip {\n    max-inline-size: convert.to-rem(158px);\n  }\n\n  .#{$prefix}--interactive--tag-children {\n    display: inline-flex;\n    max-inline-size: convert.to-rem(200px);\n    place-items: center;\n  }\n\n  .#{$prefix}--tag--filter\n    .#{$prefix}--tag__custom-icon\n    + span\n    > .#{$prefix}--interactive--tag-children {\n    max-inline-size: convert.to-rem(184px);\n  }\n\n  .#{$prefix}--tag .#{$prefix}--definition-term {\n    -webkit-border-after: none;\n    border-block-end: none;\n    cursor: default;\n    max-inline-size: convert.to-rem(192px);\n  }\n\n  .#{$prefix}--tag\n    .#{$prefix}--tag__custom-icon\n    + span\n    > .#{$prefix}--definition-term {\n    max-inline-size: convert.to-rem(176px);\n  }\n\n  .#{$prefix}--tag > .#{$prefix}--popover-container {\n    display: flex;\n  }\n\n  .#{$prefix}--toggletip-button:has(\n      .#{$prefix}--tag--operational.#{$prefix}--tag--disabled\n    ) {\n    pointer-events: none;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use '../../config' as *;\n\n/// @access private\n/// @group tag\n@mixin tag-theme(\n  $bg-color,\n  $text-color,\n  $filter-hover-color: $bg-color,\n  $border-color: $bg-color\n) {\n  background-color: $bg-color;\n  color: $text-color;\n\n  &.#{$prefix}--tag--operational {\n    border: 1px solid $border-color;\n\n    &:hover {\n      background-color: $filter-hover-color;\n    }\n  }\n\n  .#{$prefix}--tag__close-icon {\n    &:hover {\n      background-color: $filter-hover-color;\n    }\n  }\n\n  .#{$prefix}--definition-term {\n    .#{$prefix}--tag__label {\n      color: $text-color;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2020\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:color';\n@use 'sass:map';\n@use '../../config';\n@use '../../colors';\n@use '../../themes';\n@use '../../theme' as *;\n@use '../../utilities/component-tokens';\n@use '@carbon/themes/scss/component-tokens' as tag;\n\n// red\n$tag-background-red: (\n  fallback: map.get(tag.$tag-background-red, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-red, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-red, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-red, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-red, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-red: (\n  fallback: map.get(tag.$tag-color-red, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-red, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-red, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-red, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-red, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-red: (\n  fallback: map.get(tag.$tag-hover-red, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-red, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-red, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-red, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-red, g-100),\n    ),\n  ),\n) !default;\n\n// magenta\n$tag-background-magenta: (\n  fallback: map.get(tag.$tag-background-magenta, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-magenta, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-magenta, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-magenta, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-magenta, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-magenta: (\n  fallback: map.get(tag.$tag-color-magenta, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-magenta, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-magenta, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-magenta, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-magenta, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-magenta: (\n  fallback: map.get(tag.$tag-hover-magenta, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-magenta, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-magenta, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-magenta, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-magenta, g-100),\n    ),\n  ),\n) !default;\n\n// purple\n$tag-background-purple: (\n  fallback: map.get(tag.$tag-background-purple, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-purple, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-purple, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-purple, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-purple, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-purple: (\n  fallback: map.get(tag.$tag-color-purple, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-purple, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-purple, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-purple, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-purple, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-purple: (\n  fallback: map.get(tag.$tag-hover-purple, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-purple, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-purple, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-purple, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-purple, g-100),\n    ),\n  ),\n) !default;\n\n// blue\n$tag-background-blue: (\n  fallback: map.get(tag.$tag-background-blue, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-blue, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-blue, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-blue, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-blue, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-blue: (\n  fallback: map.get(tag.$tag-color-blue, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-blue, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-blue, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-blue, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-blue, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-blue: (\n  fallback: map.get(tag.$tag-hover-blue, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-blue, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-blue, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-blue, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-blue, g-100),\n    ),\n  ),\n) !default;\n\n// cyan\n$tag-background-cyan: (\n  fallback: map.get(tag.$tag-background-cyan, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-cyan, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-cyan, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-cyan, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-cyan, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-cyan: (\n  fallback: map.get(tag.$tag-color-cyan, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-cyan, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-cyan, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-cyan, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-cyan, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-cyan: (\n  fallback: map.get(tag.$tag-hover-cyan, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-cyan, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-cyan, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-cyan, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-cyan, g-100),\n    ),\n  ),\n) !default;\n\n// teal\n$tag-background-teal: (\n  fallback: map.get(tag.$tag-background-teal, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-teal, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-teal, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-teal, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-teal, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-teal: (\n  fallback: map.get(tag.$tag-color-teal, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-teal, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-teal, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-teal, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-teal, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-teal: (\n  fallback: map.get(tag.$tag-hover-teal, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-teal, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-teal, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-teal, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-teal, g-100),\n    ),\n  ),\n) !default;\n\n// green\n$tag-background-green: (\n  fallback: map.get(tag.$tag-background-green, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-green, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-green, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-green, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-green, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-green: (\n  fallback: map.get(tag.$tag-color-green, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-green, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-green, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-green, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-green, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-green: (\n  fallback: map.get(tag.$tag-hover-green, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-green, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-green, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-green, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-green, g-100),\n    ),\n  ),\n) !default;\n\n// gray\n$tag-background-gray: (\n  fallback: map.get(tag.$tag-background-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-gray: (\n  fallback: map.get(tag.$tag-color-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-gray: (\n  fallback: map.get(tag.$tag-hover-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-gray, g-100),\n    ),\n  ),\n) !default;\n\n// cool-gray\n$tag-background-cool-gray: (\n  fallback: map.get(tag.$tag-background-cool-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-cool-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-cool-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-cool-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-cool-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-cool-gray: (\n  fallback: map.get(tag.$tag-color-cool-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-cool-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-cool-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-cool-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-cool-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-cool-gray: (\n  fallback: map.get(tag.$tag-hover-cool-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-cool-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-cool-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-cool-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-cool-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-gray: (\n  fallback: map.get(tag.$tag-border-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-red: (\n  fallback: map.get(tag.$tag-border-red, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-red, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-red, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-red, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-red, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-blue: (\n  fallback: map.get(tag.$tag-border-blue, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-blue, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-blue, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-blue, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-blue, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-cyan: (\n  fallback: map.get(tag.$tag-border-cyan, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-cyan, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-cyan, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-cyan, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-cyan, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-teal: (\n  fallback: map.get(tag.$tag-border-teal, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-teal, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-teal, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-teal, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-teal, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-green: (\n  fallback: map.get(tag.$tag-border-green, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-green, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-green, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-green, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-green, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-magenta: (\n  fallback: map.get(tag.$tag-border-magenta, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-magenta, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-magenta, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-magenta, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-magenta, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-purple: (\n  fallback: map.get(tag.$tag-border-purple, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-purple, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-purple, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-purple, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-purple, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-cool-gray: (\n  fallback: map.get(tag.$tag-border-cool-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-cool-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-cool-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-cool-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-cool-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-border-warm-gray: (\n  fallback: map.get(tag.$tag-border-warm-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-border-warm-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-border-warm-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-border-warm-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-border-warm-gray, g-100),\n    ),\n  ),\n) !default;\n\n// warm-gray\n$tag-background-warm-gray: (\n  fallback: map.get(tag.$tag-background-warm-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-background-warm-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-background-warm-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-background-warm-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-background-warm-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-color-warm-gray: (\n  fallback: map.get(tag.$tag-color-warm-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-color-warm-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-color-warm-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-color-warm-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-color-warm-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-hover-warm-gray: (\n  fallback: map.get(tag.$tag-hover-warm-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(tag.$tag-hover-warm-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(tag.$tag-hover-warm-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(tag.$tag-hover-warm-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(tag.$tag-hover-warm-gray, g-100),\n    ),\n  ),\n) !default;\n\n$tag-tokens: (\n  tag-background-red: $tag-background-red,\n  tag-color-red: $tag-color-red,\n  tag-hover-red: $tag-hover-red,\n  tag-background-magenta: $tag-background-magenta,\n  tag-color-magenta: $tag-color-magenta,\n  tag-hover-magenta: $tag-hover-magenta,\n  tag-background-purple: $tag-background-purple,\n  tag-color-purple: $tag-color-purple,\n  tag-hover-purple: $tag-hover-purple,\n  tag-background-blue: $tag-background-blue,\n  tag-color-blue: $tag-color-blue,\n  tag-hover-blue: $tag-hover-blue,\n  tag-background-cyan: $tag-background-cyan,\n  tag-color-cyan: $tag-color-cyan,\n  tag-hover-cyan: $tag-hover-cyan,\n  tag-background-teal: $tag-background-teal,\n  tag-color-teal: $tag-color-teal,\n  tag-hover-teal: $tag-hover-teal,\n  tag-background-green: $tag-background-green,\n  tag-color-green: $tag-color-green,\n  tag-hover-green: $tag-hover-green,\n  tag-background-gray: $tag-background-gray,\n  tag-color-gray: $tag-color-gray,\n  tag-hover-gray: $tag-hover-gray,\n  tag-border-red: $tag-border-red,\n  tag-border-blue: $tag-border-blue,\n  tag-border-cyan: $tag-border-cyan,\n  tag-border-teal: $tag-border-teal,\n  tag-border-green: $tag-border-green,\n  tag-border-magenta: $tag-border-magenta,\n  tag-border-purple: $tag-border-purple,\n  tag-border-gray: $tag-border-gray,\n  tag-border-cool-gray: $tag-border-cool-gray,\n  tag-border-warm-gray: $tag-border-warm-gray,\n  tag-background-cool-gray: $tag-background-cool-gray,\n  tag-color-cool-gray: $tag-color-cool-gray,\n  tag-hover-cool-gray: $tag-hover-cool-gray,\n  tag-background-warm-gray: $tag-background-warm-gray,\n  tag-color-warm-gray: $tag-color-warm-gray,\n  tag-hover-warm-gray: $tag-hover-warm-gray,\n);\n\n$tag-background-red: component-tokens.get-var(\n  $tag-background-red,\n  'tag-background-red'\n);\n\n$tag-color-red: component-tokens.get-var($tag-color-red, 'tag-color-red');\n\n$tag-hover-red: component-tokens.get-var($tag-hover-red, 'tag-hover-red');\n\n$tag-background-magenta: component-tokens.get-var(\n  $tag-background-magenta,\n  'tag-background-magenta'\n);\n\n$tag-color-magenta: component-tokens.get-var(\n  $tag-color-magenta,\n  'tag-color-magenta'\n);\n\n$tag-hover-magenta: component-tokens.get-var(\n  $tag-hover-magenta,\n  'tag-hover-magenta'\n);\n\n$tag-background-purple: component-tokens.get-var(\n  $tag-background-purple,\n  'tag-background-purple'\n);\n\n$tag-color-purple: component-tokens.get-var(\n  $tag-color-purple,\n  'tag-color-purple'\n);\n\n$tag-hover-purple: component-tokens.get-var(\n  $tag-hover-purple,\n  'tag-hover-purple'\n);\n\n$tag-background-blue: component-tokens.get-var(\n  $tag-background-blue,\n  'tag-background-blue'\n);\n\n$tag-color-blue: component-tokens.get-var($tag-color-blue, 'tag-color-blue');\n\n$tag-hover-blue: component-tokens.get-var($tag-hover-blue, 'tag-hover-blue');\n\n$tag-background-cyan: component-tokens.get-var(\n  $tag-background-cyan,\n  'tag-background-cyan'\n);\n\n$tag-color-cyan: component-tokens.get-var($tag-color-cyan, 'tag-color-cyan');\n\n$tag-hover-cyan: component-tokens.get-var($tag-hover-cyan, 'tag-hover-cyan');\n\n$tag-background-teal: component-tokens.get-var(\n  $tag-background-teal,\n  'tag-background-teal'\n);\n\n$tag-color-teal: component-tokens.get-var($tag-color-teal, 'tag-color-teal');\n\n$tag-hover-teal: component-tokens.get-var($tag-hover-teal, 'tag-hover-teal');\n\n$tag-background-green: component-tokens.get-var(\n  $tag-background-green,\n  'tag-background-green'\n);\n\n$tag-color-green: component-tokens.get-var($tag-color-green, 'tag-color-green');\n\n$tag-hover-green: component-tokens.get-var($tag-hover-green, 'tag-hover-green');\n\n$tag-background-gray: component-tokens.get-var(\n  $tag-background-gray,\n  'tag-background-gray'\n);\n\n$tag-color-gray: component-tokens.get-var($tag-color-gray, 'tag-color-gray');\n\n$tag-hover-gray: component-tokens.get-var($tag-hover-gray, 'tag-hover-gray');\n\n$tag-border-red: component-tokens.get-var($tag-border-red, 'tag-border-red');\n\n$tag-border-blue: component-tokens.get-var($tag-border-blue, 'tag-border-blue');\n\n$tag-border-cyan: component-tokens.get-var($tag-border-cyan, 'tag-border-cyan');\n\n$tag-border-teal: component-tokens.get-var($tag-border-teal, 'tag-border-teal');\n\n$tag-border-green: component-tokens.get-var(\n  $tag-border-green,\n  'tag-border-green'\n);\n\n$tag-border-magenta: component-tokens.get-var(\n  $tag-border-magenta,\n  'tag-border-magenta'\n);\n\n$tag-border-purple: component-tokens.get-var(\n  $tag-border-purple,\n  'tag-border-purple'\n);\n\n$tag-border-gray: component-tokens.get-var($tag-border-gray, 'tag-border-gray');\n\n$tag-border-cool-gray: component-tokens.get-var(\n  $tag-border-cool-gray,\n  'tag-border-cool-gray'\n);\n\n$tag-border-warm-gray: component-tokens.get-var(\n  $tag-border-warm-gray,\n  'tag-border-warm-gray'\n);\n\n$tag-background-cool-gray: component-tokens.get-var(\n  $tag-background-cool-gray,\n  'tag-background-cool-gray'\n);\n\n$tag-color-cool-gray: component-tokens.get-var(\n  $tag-color-cool-gray,\n  'tag-color-cool-gray'\n);\n\n$tag-hover-cool-gray: component-tokens.get-var(\n  $tag-hover-cool-gray,\n  'tag-hover-cool-gray'\n);\n\n$tag-background-warm-gray: component-tokens.get-var(\n  $tag-background-warm-gray,\n  'tag-background-warm-gray'\n);\n\n$tag-color-warm-gray: component-tokens.get-var(\n  $tag-color-warm-gray,\n  'tag-color-warm-gray'\n);\n\n$tag-hover-warm-gray: component-tokens.get-var(\n  $tag-hover-warm-gray,\n  'tag-hover-warm-gray'\n);\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button/tokens' as *;\n@use '../text-input';\n@use '../tag';\n@use '../tag/mixins' as *;\n@use '../../config' as *;\n@use '../../colors' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../layer' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/z-index' as *;\n\n/// @type Number\n/// @access public\n/// @group list-box\n$list-box-width: 100%;\n\n/// @type Number\n/// @access public\n/// @group list-box\n$list-box-height: convert.to-rem(40px);\n\n/// @type Number\n/// @access public\n/// @group list-box\n$list-box-inline-height: $list-box-height;\n\n/// @type Number\n/// @access public\n/// @group list-box\n$list-box-menu-width: convert.to-rem(300px);\n\n/// List box styles\n/// @access public\n/// @group list-box\n@mixin list-box {\n  // The overall container element for a `list-box`. Has two variants,\n  // `disabled` and `inline`.\n  .#{$prefix}--list-box__wrapper {\n    display: block;\n  }\n\n  .#{$prefix}--list-box__wrapper--inline {\n    display: inline-grid;\n    align-items: center;\n    grid-gap: convert.to-rem(4px);\n    grid-template: auto auto / auto auto;\n\n    .#{$prefix}--label {\n      @include type-style('body-compact-01');\n    }\n\n    .#{$prefix}--label,\n    .#{$prefix}--form__helper-text,\n    .#{$prefix}--form-requirement {\n      margin: 0;\n    }\n\n    .#{$prefix}--form__helper-text {\n      max-inline-size: none;\n    }\n\n    .#{$prefix}--form-requirement {\n      grid-column: 2;\n    }\n  }\n\n  .#{$prefix}--list-box {\n    @include reset;\n\n    position: relative;\n    border: none;\n    background-color: $field;\n    block-size: convert.to-rem(40px);\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    cursor: pointer;\n    inline-size: $list-box-width;\n    max-block-size: convert.to-rem(40px);\n    transition: all $duration-fast-01 motion(standard, productive);\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly.#{$prefix}--list-box {\n    cursor: default;\n  }\n\n  .#{$prefix}--list-box--lg {\n    block-size: convert.to-rem(48px);\n    max-block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--list-box--sm {\n    block-size: convert.to-rem(32px);\n    max-block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--list-box--expanded {\n    border-block-end-color: $border-subtle-01;\n  }\n\n  .#{$prefix}--layer-two .#{$prefix}--list-box--expanded {\n    border-block-end-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three .#{$prefix}--list-box--expanded {\n    border-block-end-color: $border-subtle-03;\n  }\n\n  .#{$prefix}--list-box--expanded:hover {\n    background-color: $field;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--expanded:hover.#{$prefix}--list-box--light:hover {\n    background-color: $field-02;\n  }\n\n  .#{$prefix}--list-box .#{$prefix}--text-input {\n    block-size: 100%;\n    min-inline-size: 0;\n  }\n\n  // invalid states\n  .#{$prefix}--list-box__invalid-icon {\n    position: absolute;\n    fill: $support-error;\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-08;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--list-box__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--list-box__invalid-icon--warning path[fill] {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--list-box[data-invalid] .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box.#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field {\n    border-block-end: 0;\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--list-box[data-invalid].#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box.#{$prefix}--list-box--warning.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__field {\n    padding-inline-end: convert.to-rem(56px);\n  }\n\n  // V11: Possibly deprecate\n  // Light variation for 'list-box'\n  .#{$prefix}--list-box--light {\n    background-color: $field-02;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light .#{$prefix}--list-box__menu {\n    background: $layer;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle;\n  }\n\n  .#{$prefix}--list-box--light.#{$prefix}--list-box--expanded {\n    border-block-end-color: transparent;\n  }\n\n  // Disabled state for `list-box`\n  .#{$prefix}--list-box--disabled:hover {\n    background-color: $field;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light.#{$prefix}--list-box--disabled {\n    background-color: $field-02;\n  }\n\n  .#{$prefix}--list-box--disabled,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__field:focus {\n    border-block-end-color: transparent;\n    outline: none;\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__label,\n  .#{$prefix}--list-box--disabled.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__label {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-icon > svg,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__selection > svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--list-box--disabled,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-icon {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-item,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-item:hover,\n  .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item--highlighted {\n    color: $text-disabled;\n    text-decoration: none;\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__selection:hover {\n    cursor: not-allowed;\n  }\n\n  // disabled && invalid\n  .#{$prefix}--list-box--disabled.#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field {\n    padding-inline-end: $spacing-09;\n  }\n\n  .#{$prefix}--list-box--disabled.#{$prefix}--list-box[data-invalid].#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__field {\n    padding-inline-end: $spacing-07;\n  }\n\n  // Inline variant for a `list-box`\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline {\n    border-width: 0;\n    background-color: transparent;\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline.#{$prefix}--list-box--expanded {\n    border-block-end-width: 0;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline.#{$prefix}--list-box--expanded\n    .#{$prefix}--list-box__field[aria-expanded='true'] {\n    border-width: 0;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline.#{$prefix}--list-box--expanded:hover,\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline.#{$prefix}--list-box--disabled:hover {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__field {\n    padding: 0 $spacing-07 0 $spacing-03;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__menu-icon {\n    inset-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__invalid-icon {\n    inset-inline-end: $spacing-07;\n  }\n\n  .#{$prefix}--list-box--inline .#{$prefix}--list-box__label {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--list-box--inline .#{$prefix}--list-box__field {\n    block-size: 100%;\n  }\n\n  .#{$prefix}--dropdown--inline .#{$prefix}--list-box__field {\n    max-inline-size: convert.to-rem(480px);\n  }\n\n  .#{$prefix}--dropdown--inline .#{$prefix}--list-box__menu {\n    max-inline-size: convert.to-rem(480px);\n    min-inline-size: convert.to-rem(288px);\n  }\n\n  // The field we use for input, showing selection, etc.\n  .#{$prefix}--list-box__field {\n    @include button-reset.reset;\n\n    position: relative;\n    display: inline-flex;\n    overflow: hidden;\n    align-items: center;\n    // Account for the border in `.cds--list-box`\n    block-size: calc(100% + 1px);\n    cursor: pointer;\n    outline: none;\n    padding-block: 0;\n    padding-inline: $spacing-05 $spacing-09;\n    text-overflow: ellipsis;\n    vertical-align: top;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--list-box__field:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--list-box__field[disabled] {\n    color: $text-disabled;\n    outline: none;\n  }\n\n  // populated input field\n  .#{$prefix}--list-box__field .#{$prefix}--text-input {\n    padding-inline-end: convert.to-rem(70px);\n  }\n\n  // invalid && populated input field\n  .#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input,\n  .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input {\n    // to account for clear input button outline\n    padding-inline-end: convert.to-rem(105px);\n  }\n\n  .#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input\n    + .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input\n    + .#{$prefix}--list-box__invalid-icon {\n    // to account for clear input button outline\n    inset-inline-end: convert.to-rem(82px);\n  }\n\n  // empty input field\n  .#{$prefix}--list-box__field .#{$prefix}--text-input--empty {\n    padding-inline-end: $spacing-09;\n  }\n\n  // invalid && empty input field\n  .#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input--empty {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input--empty\n    + .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field\n    .#{$prefix}--text-input--empty\n    + .#{$prefix}--list-box__invalid-icon {\n    // to account for clear input button outline\n    inset-inline-end: convert.to-rem(40px);\n  }\n\n  // Label for a `list-box__field`\n  .#{$prefix}--list-box__label {\n    @include type-style('body-compact-01');\n\n    overflow: hidden;\n    color: $text-primary;\n    text-overflow: ellipsis;\n    user-select: none;\n    white-space: nowrap;\n  }\n\n  // Menu status inside of a `list-box__field`\n  .#{$prefix}--list-box__menu-icon {\n    @include button-reset.reset($width: false);\n\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: convert.to-rem(24px);\n    cursor: pointer;\n    inline-size: convert.to-rem(24px);\n    inset-inline-end: $spacing-04;\n    outline: none;\n    transition: transform $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--list-box__menu-icon > svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--list-box__menu-icon--open {\n    justify-content: center;\n    inline-size: convert.to-rem(24px);\n    transform: rotate(180deg);\n  }\n\n  // Selection indicator for a `list-box__field`\n  .#{$prefix}--list-box__selection {\n    @include button-reset.reset($width: false);\n\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: convert.to-rem(24px);\n    cursor: pointer;\n    inline-size: convert.to-rem(24px);\n    inset-block-start: 50%;\n    /* to preserve .5rem space between icons according to spec top/transform used to center the combobox clear selection icon in IE11 */\n    inset-inline-end: convert.to-rem(45px);\n    transform: translateY(-50%);\n    transition: background-color $duration-fast-01 motion(standard, productive);\n    user-select: none;\n\n    &:focus {\n      @include focus-outline('outline');\n\n      &:hover {\n        @include focus-outline('outline');\n      }\n    }\n  }\n\n  .#{$prefix}--list-box__selection > svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__selection:focus {\n    outline: none;\n  }\n\n  // Modifier for a selection to show that multiple selections have been made\n  .#{$prefix}--list-box__selection--multi {\n    @include type-style('label-01');\n\n    position: static;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: convert.to-rem(8px);\n    border-radius: convert.to-rem(12px);\n    background-color: $background-inverse;\n    block-size: convert.to-rem(24px);\n    color: $text-inverse;\n    inline-size: auto;\n    inset-block-start: auto;\n    line-height: 0;\n    margin-inline-end: convert.to-rem(10px);\n    // Align with hover circle of X button\n    padding-inline-end: convert.to-rem(2px);\n    transform: none;\n  }\n\n  .#{$prefix}--list-box__selection--multi > svg {\n    padding: convert.to-rem(2px);\n    block-size: convert.to-rem(20px);\n    fill: $icon-inverse;\n    inline-size: convert.to-rem(20px);\n    margin-inline-start: convert.to-rem(4px);\n\n    &:hover {\n      border-radius: 50%;\n      background-color: $button-secondary-hover;\n    }\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__selection--multi {\n    @include tag-theme($text-disabled, $layer);\n\n    > svg {\n      fill: $icon-disabled;\n\n      &:hover {\n        background-color: initial;\n      }\n    }\n  }\n\n  .#{$prefix}--list-box__selection--multi:hover {\n    outline: none;\n  }\n\n  // Descendant of a `list-box` that displays a list of options to select\n  .#{$prefix}--list-box__menu {\n    @include box-shadow();\n\n    position: absolute;\n    z-index: z('dropdown');\n    display: none;\n    background-color: $layer;\n    inline-size: $list-box-width;\n    inset-inline: 0;\n    overflow-y: auto;\n    transition: max-height $duration-fast-02 motion(standard, productive);\n\n    &:focus {\n      // remove default browser focus in firefox\n      @include focus-outline('border');\n    }\n  }\n\n  // Allow auto-alignment to control inline placement\n  .#{$prefix}--autoalign .#{$prefix}--list-box__menu {\n    inset-inline: auto;\n  }\n\n  .#{$prefix}--list-box .#{$prefix}--list-box__field[aria-expanded='false'] {\n    .#{$prefix}--list-box__menu {\n      display: none;\n      max-block-size: 0;\n      visibility: hidden;\n    }\n  }\n\n  .#{$prefix}--list-box--expanded .#{$prefix}--list-box__menu {\n    display: block;\n    // 40px item height * 5.5 items shown\n    max-block-size: convert.to-rem(220px);\n  }\n\n  .#{$prefix}--list-box--expanded.#{$prefix}--list-box--lg\n    .#{$prefix}--list-box__menu {\n    // 48px item height * 5.5 items shown\n    max-block-size: convert.to-rem(264px);\n  }\n\n  .#{$prefix}--list-box--expanded.#{$prefix}--list-box--sm\n    .#{$prefix}--list-box__menu {\n    // 32px item height * 5.5 items shown\n    max-block-size: convert.to-rem(176px);\n  }\n\n  // Descendant of a `list-box__menu` that represents a selection for a control\n  .#{$prefix}--list-box__menu-item {\n    @include type-style('body-compact-01');\n\n    position: relative;\n    block-size: convert.to-rem(40px);\n    color: $text-secondary;\n    cursor: pointer;\n    transition: background $duration-fast-01 motion(standard, productive);\n    user-select: none;\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n\n    &:active {\n      background-color: $layer-selected;\n    }\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light .#{$prefix}--list-box__menu-item:hover {\n    background-color: $layer-hover;\n  }\n\n  .#{$prefix}--list-box--sm .#{$prefix}--list-box__menu-item {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--list-box--lg .#{$prefix}--list-box__menu-item {\n    block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-item:hover {\n    background-color: transparent;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light .#{$prefix}--list-box__menu-item:active {\n    background-color: $layer-selected;\n  }\n\n  .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item__option:hover {\n    border-block-start-color: $border-subtle-01;\n  }\n\n  .#{$prefix}--layer-two\n    .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item__option:hover {\n    border-block-start-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three\n    .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item__option:hover {\n    border-block-start-color: $border-subtle-03;\n  }\n\n  .#{$prefix}--list-box__menu-item:first-of-type\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: transparent;\n  }\n\n  .#{$prefix}--list-box__menu-item:hover\n    .#{$prefix}--list-box__menu-item__option {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-01;\n  }\n\n  .#{$prefix}--layer-two\n    .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three\n    .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-03;\n  }\n\n  .#{$prefix}--layer-two .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-03;\n  }\n\n  .#{$prefix}--list-box__menu-item__option {\n    @include component-reset.reset;\n    @include focus-outline('reset');\n\n    display: block;\n    overflow: hidden;\n    padding: convert.to-rem(11px) 0;\n    margin: 0 $spacing-05;\n    block-size: convert.to-rem(40px);\n    border-block-end: 1px solid transparent;\n    border-block-start: 1px solid transparent;\n    border-block-start-color: $border-subtle-01;\n    color: $text-secondary;\n    font-weight: normal;\n    line-height: 1rem;\n    padding-inline-end: $spacing-06;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    transition:\n      border-color $duration-fast-01 motion(standard, productive),\n      color $duration-fast-01 motion(standard, productive);\n    white-space: nowrap;\n\n    &:focus {\n      @include focus-outline('outline');\n\n      padding: convert.to-rem(11px) convert.to-rem(16px);\n      border-color: transparent;\n      margin: 0;\n    }\n\n    &:hover {\n      border-color: transparent;\n      color: $text-primary;\n    }\n  }\n\n  .#{$prefix}--list-box--sm .#{$prefix}--list-box__menu-item__option {\n    block-size: convert.to-rem(32px);\n    padding-block: convert.to-rem(7px) convert.to-rem(7px);\n  }\n\n  .#{$prefix}--list-box--lg .#{$prefix}--list-box__menu-item__option {\n    block-size: convert.to-rem(48px);\n    padding-block: convert.to-rem(15px) convert.to-rem(15px);\n  }\n\n  .#{$prefix}--list-box--disabled\n    .#{$prefix}--list-box__menu-item:hover\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--list-box--disabled .#{$prefix}--list-box__menu-item__option {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--list-box__menu-item[disabled],\n  .#{$prefix}--list-box__menu-item[disabled] *,\n  .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--list-box__menu-item[disabled]:hover {\n    color: $text-disabled;\n    cursor: not-allowed;\n    outline: none;\n  }\n\n  .#{$prefix}--list-box__menu-item[disabled]:hover {\n    background-color: revert;\n  }\n\n  .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--checkbox-label::before {\n    border-color: $text-disabled;\n  }\n\n  .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--list-box__menu-item[disabled]:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-01;\n  }\n\n  .#{$prefix}--layer-two\n    .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--layer-two\n    .#{$prefix}--list-box__menu-item[disabled]:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three\n    .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--layer-three\n    .#{$prefix}--list-box__menu-item[disabled]:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: $border-subtle-03;\n  }\n\n  .#{$prefix}--list-box__menu-item--active\n    + .#{$prefix}--list-box__menu-item[disabled]\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--list-box__menu-item:hover\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: transparent;\n  }\n\n  .#{$prefix}--list-box.#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__menu-item__option {\n    margin: 0 $spacing-03;\n\n    &:focus {\n      margin: 0;\n      padding-inline: $spacing-03 $spacing-03;\n    }\n  }\n\n  .#{$prefix}--list-box__menu-item--highlighted {\n    @include focus-outline('outline');\n\n    color: $text-primary;\n  }\n\n  .#{$prefix}--list-box__menu-item--highlighted\n    .#{$prefix}--list-box__menu-item__option,\n  .#{$prefix}--list-box__menu-item--highlighted\n    + .#{$prefix}--list-box__menu-item\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: transparent;\n  }\n\n  .#{$prefix}--list-box__menu-item--highlighted\n    .#{$prefix}--list-box__menu-item__option {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--list-box__menu-item--active {\n    background-color: $layer-selected;\n    border-block-end-color: $layer-selected;\n    color: $text-primary;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--list-box--light .#{$prefix}--list-box__menu-item--active {\n    background-color: $layer-selected;\n    border-block-end-color: $layer-selected;\n  }\n\n  .#{$prefix}--list-box__menu-item--active:hover {\n    background-color: $layer-selected-hover;\n    border-block-end-color: $layer-selected-hover;\n  }\n\n  .#{$prefix}--list-box__menu-item--active\n    .#{$prefix}--list-box__menu-item__option {\n    color: $text-primary;\n  }\n\n  // Hide top border if previous list item is selected\n  .#{$prefix}--list-box__menu-item--active\n    + .#{$prefix}--list-box__menu-item\n    > .#{$prefix}--list-box__menu-item__option {\n    border-block-start-color: transparent;\n  }\n\n  .#{$prefix}--list-box__menu-item__selected-icon {\n    position: absolute;\n    display: none;\n    fill: $icon-primary;\n    inset-block-start: 50%;\n    inset-inline-end: convert.to-rem(16px);\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--list-box--inline\n    .#{$prefix}--list-box__menu-item__selected-icon {\n    inset-inline-end: convert.to-rem(8px);\n  }\n\n  .#{$prefix}--list-box__menu-item--active\n    .#{$prefix}--list-box__menu-item__selected-icon {\n    display: block;\n  }\n\n  .#{$prefix}--list-box__menu-item .#{$prefix}--checkbox-label {\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--list-box__menu-item .#{$prefix}--checkbox-label-text {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  // Dropdown top orientation modifiers\n  .#{$prefix}--list-box--up .#{$prefix}--list-box__menu {\n    inset-block-end: 2.5rem;\n  }\n\n  .#{$prefix}--list-box--up.#{$prefix}--dropdown--sm\n    .#{$prefix}--list-box__menu,\n  .#{$prefix}--list-box--up.#{$prefix}--list-box--sm\n    .#{$prefix}--list-box__menu,\n  .#{$prefix}--list-box--up\n    .#{$prefix}--list-box--sm\n    .#{$prefix}--list-box__menu {\n    inset-block-end: 2rem;\n  }\n\n  .#{$prefix}--list-box--up.#{$prefix}--dropdown--lg\n    .#{$prefix}--list-box__menu,\n  .#{$prefix}--list-box--up.#{$prefix}--list-box--lg\n    .#{$prefix}--list-box__menu,\n  .#{$prefix}--list-box--up\n    .#{$prefix}--list-box--lg\n    .#{$prefix}--list-box__menu {\n    inset-block-end: 3rem;\n  }\n\n  // Tweaks for descendants\n  // When handling input, we need to target nodes that specifically opt-in to\n  // the type text in order to make sure the text input is styled\n  // correctly.\n  .#{$prefix}--list-box .#{$prefix}--text-input {\n    background-color: inherit;\n    min-inline-size: 0;\n    text-overflow: ellipsis;\n  }\n\n  // AILabel styles\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: 50%;\n    inset-inline-end: calc($spacing-08 + 9px);\n    margin-block-start: convert.to-rem(0.5px);\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator:has(\n      .#{$prefix}--list-box__invalid-icon\n    )\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--list-box__wrapper--slug:has(.#{$prefix}--list-box__invalid-icon)\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug:has(.#{$prefix}--list-box__invalid-icon)\n    .#{$prefix}--slug::before,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug::after {\n    position: absolute;\n    background-color: $border-subtle-01;\n    block-size: convert.to-rem(16px);\n    content: '';\n    inline-size: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug::before {\n    display: none;\n    inset-inline-start: convert.to-rem(-9px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug::before,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug--revert::before,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    > *::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug::after {\n    display: block;\n    inset-block-start: convert.to-rem(1px);\n    inset-inline-end: convert.to-rem(-9px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug--revert::before,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__inner-wrapper--decorator\n    .#{$prefix}--ai-label--revert::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--ai-label--revert::after,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--slug--revert::after {\n    inset-block-start: convert.to-rem(8px);\n    inset-inline-end: convert.to-rem(-1px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box:has(\n      .#{$prefix}--list-box__inner-wrapper--decorator .#{$prefix}--ai-label\n    ):not(\n      :has(\n          .#{$prefix}--list-box__inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box:has(.#{$prefix}--ai-label):not(\n      :has(.#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box:has(.#{$prefix}--slug):not(\n      :has(.#{$prefix}--slug--revert)\n    ) {\n    @include ai-gradient;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box\n    input[role='combobox'],\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box\n    input[role='combobox'] {\n    border-block-end-color: transparent;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__wrapper--decorator .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__wrapper--slug .#{$prefix}--text-input--empty {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty),\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty) {\n    padding-inline-end: convert.to-rem(105px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--text-input--empty,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field {\n    padding-inline-end: $spacing-12;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty),\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty),\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty),\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--text-input:not(.#{$prefix}--text-input--empty) {\n    padding-inline-end: convert.to-rem(137px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input--empty\n    + .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__invalid-icon.#{$prefix}--list-box__invalid-icon--warning,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--text-input--empty\n    + .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__invalid-icon.#{$prefix}--list-box__invalid-icon--warning {\n    inset-inline-end: convert.to-rem(81px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid[data-invalid]\n    > *::before,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    > *::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid[data-invalid]\n    .#{$prefix}--slug::before,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--slug::before {\n    display: block;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--list-box__inner-wrapper--decorator\n    .#{$prefix}--ai-label,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--list-box__inner-wrapper--decorator\n    .#{$prefix}--ai-label,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--ai-label,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--ai-label,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--slug,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--slug {\n    inset-inline-end: calc($spacing-10 + 18px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    ~ .#{$prefix}--list-box__inner-wrapper--decorator\n    > * {\n    inset-inline-end: calc($spacing-10 + 18px);\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--invalid\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--decorator\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--invalid\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    .#{$prefix}--list-box__invalid-icon,\n  .#{$prefix}--list-box__wrapper--slug\n    .#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__selection)\n    .#{$prefix}--list-box__invalid-icon {\n    inset-inline-end: convert.to-rem(114px);\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--list-box__field,\n  .#{$prefix}--list-box__menu,\n  .#{$prefix}--multi-select .#{$prefix}--tag--filter {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--list-box__field:focus,\n  .#{$prefix}--multi-select .#{$prefix}--tag__close-icon:focus,\n  .#{$prefix}--list-box__menu-item--highlighted\n    .#{$prefix}--list-box__menu-item__option {\n    @include high-contrast-mode('focus');\n  }\n\n  .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__menu-icon)\n    .#{$prefix}--list-box__selection::after {\n    position: absolute;\n    background-color: $border-subtle-01;\n    block-size: convert.to-rem(16px);\n    content: '';\n    inline-size: convert.to-rem(1px);\n    margin-inline-start: convert.to-rem(33px);\n  }\n\n  .#{$prefix}--list-box--warning,\n  .#{$prefix}--list-box--invalid[data-invalid] {\n    .#{$prefix}--list-box__field:has(.#{$prefix}--list-box__menu-icon)\n      .#{$prefix}--list-box__selection::before {\n      position: absolute;\n      background-color: $border-subtle-01;\n      block-size: convert.to-rem(16px);\n      content: '';\n      inline-size: convert.to-rem(1px);\n      margin-inline-end: convert.to-rem(33px);\n    }\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator:has(.#{$prefix}--multi-select)\n    .#{$prefix}--list-box__menu-icon,\n  .#{$prefix}--list-box__wrapper--slug:has(.#{$prefix}--multi-select)\n    .#{$prefix}--list-box__menu-icon {\n    inset-inline-end: $spacing-04;\n  }\n\n  .#{$prefix}--list-box__wrapper--decorator:has(.#{$prefix}--dropdown)\n    .#{$prefix}--list-box__menu-icon,\n  .#{$prefix}--list-box__wrapper--slug:has(.#{$prefix}--dropdown)\n    .#{$prefix}--list-box__menu-icon {\n    inset-inline-end: $spacing-04;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../list-box';\n@use '../../config' as *;\n@use '../../layer' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/z-index' as *;\n\n/// Dropdown styles\n/// @access public\n/// @group dropdown\n@mixin dropdown {\n  .#{$prefix}--dropdown__wrapper--inline {\n    display: inline-grid;\n    align-items: center;\n    grid-gap: 0 convert.to-rem(24px);\n    grid-template: auto / auto min-content;\n\n    &:has(.#{$prefix}--label.#{$prefix}--visually-hidden) {\n      grid-template: auto / auto;\n    }\n\n    .#{$prefix}--label {\n      @include type-style('body-compact-01');\n    }\n\n    .#{$prefix}--label,\n    .#{$prefix}--form__helper-text,\n    .#{$prefix}--form-requirement {\n      margin: 0;\n    }\n\n    .#{$prefix}--form-requirement {\n      grid-column: 2;\n    }\n  }\n\n  .#{$prefix}--dropdown {\n    @include reset;\n    @include focus-outline('reset');\n\n    position: relative;\n    display: block;\n    border: none;\n    background-color: $field;\n    block-size: convert.to-rem(40px);\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    cursor: pointer;\n    inline-size: 100%;\n    list-style: none;\n    outline: 2px solid transparent;\n    transition: background-color $duration-fast-01 motion(standard, productive);\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  // Menu's triggering element updated to button with Downshift v5 upgrade\n  .#{$prefix}--dropdown .#{$prefix}--list-box__field {\n    text-align: start;\n  }\n\n  .#{$prefix}--dropdown--lg {\n    block-size: convert.to-rem(48px);\n    max-block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--dropdown--lg .#{$prefix}--dropdown__arrow {\n    inset-block-start: convert.to-rem(16px);\n  }\n\n  .#{$prefix}--dropdown--sm {\n    block-size: convert.to-rem(32px);\n    max-block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--dropdown--sm .#{$prefix}--dropdown__arrow {\n    inset-block-start: convert.to-rem(8px);\n  }\n\n  .#{$prefix}--dropdown--open {\n    border-block-end-color: $border-subtle;\n  }\n\n  .#{$prefix}--dropdown--open .#{$prefix}--list-box__field {\n    outline: none;\n  }\n\n  .#{$prefix}--dropdown--focus .#{$prefix}--list-box__field {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--dropdown--invalid {\n    @include focus-outline('invalid');\n\n    .#{$prefix}--dropdown-text {\n      padding-inline-end: convert.to-rem(56px);\n    }\n\n    + .#{$prefix}--form-requirement {\n      display: inline-block;\n      color: $text-error;\n      max-block-size: convert.to-rem(200px);\n    }\n  }\n\n  .#{$prefix}--dropdown__invalid-icon {\n    position: absolute;\n    fill: $support-error;\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-08;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--dropdown--open:hover {\n    background-color: $field;\n  }\n\n  .#{$prefix}--dropdown--open:focus {\n    outline: 1px solid transparent;\n  }\n\n  .#{$prefix}--dropdown--open .#{$prefix}--dropdown-list {\n    @include box-shadow;\n\n    // 40px item height * 5.5 items shown\n    max-block-size: convert.to-rem(220px);\n    transition: max-height $duration-fast-02 motion(entrance, productive);\n  }\n\n  .#{$prefix}--dropdown--light {\n    background-color: $field-02;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  .#{$prefix}--dropdown--up .#{$prefix}--dropdown-list {\n    inset-block-end: 2rem;\n  }\n\n  .#{$prefix}--dropdown__arrow {\n    position: absolute;\n    fill: $icon-primary;\n    inset-block-start: convert.to-rem(13px);\n    inset-inline-end: 1rem;\n    pointer-events: none;\n    transform-origin: 50% 45%;\n    transition: transform $duration-fast-02 motion(standard, productive);\n  }\n\n  button.#{$prefix}--dropdown-text {\n    border: none;\n    // button-reset mixin contradicts with cds--dropdown-text styles\n    background: none;\n    color: $text-primary;\n    inline-size: 100%;\n    text-align: start;\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  .#{$prefix}--dropdown-text {\n    @include type-style('body-compact-01');\n\n    display: block;\n    overflow: hidden;\n    // Account for the border in `.cds--dropdown`\n    block-size: calc(100% + 1px);\n    // 2rem + SVG width\n    padding-inline: $spacing-05 convert.to-rem(42px);\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--dropdown-list {\n    @include reset;\n    @include focus-outline('reset');\n    @include box-shadow;\n    @include type-style('body-compact-01');\n\n    position: absolute;\n    z-index: z('dropdown');\n    display: flex;\n    // NOTE: IE, Edge, and Safari do not support two value `overflow` shorthand.\n    overflow: hidden auto;\n    flex-direction: column;\n    background-color: $layer;\n    inline-size: 100%;\n    list-style: none;\n    max-block-size: 0;\n    transition: max-height $duration-fast-02 motion(standard, productive);\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--dropdown--light .#{$prefix}--dropdown-list {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--dropdown:not(.#{$prefix}--dropdown--open)\n    .#{$prefix}--dropdown-item {\n    visibility: hidden;\n  }\n\n  .#{$prefix}--dropdown-item {\n    position: relative;\n    opacity: 0;\n    transition:\n      visibility $duration-fast-01 motion(standard, productive),\n      opacity $duration-fast-01 motion(standard, productive),\n      background-color $duration-fast-01 motion(standard, productive);\n    visibility: inherit;\n\n    &:hover {\n      background-color: $layer-hover;\n\n      + .#{$prefix}--dropdown-item .#{$prefix}--dropdown-link {\n        border-color: transparent;\n      }\n    }\n\n    &:active {\n      background-color: $layer-selected;\n    }\n\n    &:first-of-type .#{$prefix}--dropdown-link {\n      border-block-start-color: transparent;\n    }\n  }\n\n  .#{$prefix}--dropdown-item:last-of-type .#{$prefix}--dropdown-link {\n    border-block-end: none;\n  }\n\n  .#{$prefix}--dropdown-link {\n    @include focus-outline('reset');\n\n    display: block;\n    overflow: hidden;\n    padding: convert.to-rem(11px) 0;\n    border: 1px solid transparent;\n    margin: 0 $spacing-05;\n    block-size: convert.to-rem(40px);\n    border-block-start-color: $border-subtle;\n    color: $text-secondary;\n    font-weight: normal;\n    line-height: 1rem;\n    text-decoration: none;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &:hover {\n      border-color: transparent;\n      color: $text-primary;\n    }\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--dropdown--light .#{$prefix}--dropdown-link {\n    border-block-start-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--dropdown--sm .#{$prefix}--dropdown-link {\n    block-size: convert.to-rem(32px);\n    padding-block: convert.to-rem(7px) convert.to-rem(7px);\n  }\n\n  .#{$prefix}--dropdown--focused,\n  .#{$prefix}--dropdown-link:focus {\n    @include focus-outline('outline');\n\n    padding: convert.to-rem(11px) convert.to-rem(16px);\n    margin: 0;\n  }\n\n  // We don't want to apply focus styles via focus selector when using the aria-activedescendant structure\n  .#{$prefix}--dropdown-list[aria-activedescendant]\n    .#{$prefix}--dropdown-link:focus {\n    // Copied from .cds--dropdown-link styles\n    padding: convert.to-rem(11px) 0;\n    margin: 0 $spacing-05;\n    outline: none;\n  }\n\n  // Need added weight for item that is :focused and .cds--dropdown--focused\n  .#{$prefix}--dropdown-list[aria-activedescendant]\n    .#{$prefix}--dropdown--focused:focus {\n    // copied from default focus styles\n    @include focus-outline('outline');\n\n    padding: convert.to-rem(11px) convert.to-rem(16px);\n    margin: 0;\n  }\n\n  // Don't want to allow multiple elements have a \"selected\" style. Not sure why active\n  // had unique styles initially but creating an overwrite for the latest HTML markup for\n  // backwards compatibility. For the next major release it would be possible to clean up\n  // the HTML structure to prevent the user of :active and :focus styles which is creating\n  // these duplicated styles in the list. The Carbon 10 version of dropdown is already\n  // supporting 2 very different HTML structures.\n  .#{$prefix}--dropdown-list[aria-activedescendant]\n    .#{$prefix}--dropdown-item:active {\n    background-color: inherit;\n  }\n\n  .#{$prefix}--dropdown-item:hover .#{$prefix}--dropdown-link {\n    border-block-end-color: $layer-hover;\n  }\n\n  .#{$prefix}--dropdown--open .#{$prefix}--dropdown__arrow {\n    transform: rotate(-180deg);\n  }\n\n  .#{$prefix}--dropdown--open.#{$prefix}--dropdown--sm\n    .#{$prefix}--dropdown-list {\n    // 32px item height * 5.5 items shown\n    max-block-size: convert.to-rem(176px);\n  }\n\n  .#{$prefix}--dropdown--open .#{$prefix}--dropdown-item {\n    opacity: 1;\n  }\n\n  .#{$prefix}--dropdown--disabled {\n    border-block-end-color: transparent;\n\n    &:hover {\n      background-color: $field;\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    // TODO: remove in v11\n    .#{$prefix}--dropdown-text,\n    .#{$prefix}--list-box__label {\n      color: $text-disabled;\n    }\n\n    // TODO: remove in v11\n    .#{$prefix}--dropdown__arrow,\n    .#{$prefix}--list-box__menu-icon svg {\n      fill: $icon-disabled;\n    }\n\n    // V11: Possibly deprecate\n    &.#{$prefix}--dropdown--light:hover {\n      background-color: $field-02;\n    }\n  }\n\n  .#{$prefix}--dropdown--disabled .#{$prefix}--list-box__field,\n  .#{$prefix}--dropdown--disabled .#{$prefix}--list-box__menu-icon {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--dropdown--auto-width {\n    inline-size: auto;\n    max-inline-size: convert.to-rem(400px);\n  }\n\n  .#{$prefix}--dropdown--inline {\n    display: inline-block;\n    background-color: transparent;\n    border-block-end-color: transparent;\n    inline-size: auto;\n    justify-self: start;\n    transition: background $duration-fast-01 motion(entrance, productive);\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n\n    &.#{$prefix}--dropdown--disabled {\n      background-color: transparent;\n    }\n\n    .#{$prefix}--dropdown__arrow {\n      inset-block-start: convert.to-rem(8px);\n      inset-inline-end: convert.to-rem(8px);\n    }\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--open {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--dropdown--inline .#{$prefix}--dropdown-text {\n    display: inline-block;\n    overflow: visible;\n    padding: convert.to-rem(7px) $spacing-07 convert.to-rem(7px) $spacing-04;\n    block-size: convert.to-rem(32px);\n    color: $text-primary;\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--disabled\n    .#{$prefix}--dropdown-text {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--disabled:focus\n    .#{$prefix}--dropdown-text {\n    outline: 0;\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--invalid\n    .#{$prefix}--dropdown__invalid-icon {\n    inset-inline-end: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--invalid\n    .#{$prefix}--dropdown-text {\n    padding-inline-end: convert.to-rem(56px);\n  }\n\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--open:focus\n    .#{$prefix}--dropdown-list {\n    @include box-shadow;\n  }\n\n  .#{$prefix}--dropdown--inline .#{$prefix}--dropdown-link {\n    font-weight: normal;\n  }\n\n  .#{$prefix}--dropdown--show-selected .#{$prefix}--dropdown--selected {\n    display: block;\n    background-color: $layer-selected;\n    color: $text-primary;\n\n    &:hover {\n      background-color: $layer-selected-hover;\n    }\n\n    .#{$prefix}--dropdown-link {\n      border-block-start-color: transparent;\n    }\n\n    + .#{$prefix}--dropdown-item .#{$prefix}--dropdown-link {\n      border-block-start-color: transparent;\n    }\n\n    .#{$prefix}--list-box__menu-item__selected-icon {\n      display: block;\n    }\n  }\n\n  // Skeleton State\n  .#{$prefix}--dropdown-v2.#{$prefix}--skeleton,\n  .#{$prefix}--dropdown.#{$prefix}--skeleton {\n    @include skeleton;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--dropdown .#{$prefix}--list-box__field {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--list-box__menu-item__option {\n    @include high-contrast-mode {\n      outline: none;\n    }\n  }\n\n  // readonly\n  .#{$prefix}--dropdown--readonly,\n  .#{$prefix}--dropdown--readonly:hover {\n    background-color: transparent;\n    border-block-end-color: $border-subtle;\n  }\n  .#{$prefix}--dropdown--inline.#{$prefix}--dropdown--readonly {\n    border-block-end-color: transparent;\n  }\n\n  .#{$prefix}--dropdown--readonly .#{$prefix}--list-box__field,\n  .#{$prefix}--dropdown--readonly .#{$prefix}--list-box__menu-icon {\n    cursor: default;\n  }\n\n  .#{$prefix}--dropdown--readonly .#{$prefix}--list-box__menu-icon svg {\n    fill: $icon-disabled;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../checkbox';\n@use '../list-box';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n\n/// Multi select styles\n/// @access public\n/// @group multi-select\n@mixin multiselect {\n  .#{$prefix}--multi-select {\n    box-sizing: border-box;\n  }\n\n  .#{$prefix}--multi-select .#{$prefix}--list-box__field--wrapper {\n    display: inline-flex;\n    align-items: center;\n    block-size: calc(100% + 1px);\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--multi-select .#{$prefix}--list-box__field:focus {\n    @include focus-outline('reset');\n  }\n\n  .#{$prefix}--multi-select--filterable .#{$prefix}--list-box__field {\n    padding: 0;\n  }\n\n  .#{$prefix}--multi-select .#{$prefix}--tag {\n    margin: 0 $spacing-03 0 $spacing-05;\n    min-inline-size: auto;\n  }\n\n  .#{$prefix}--multi-select .#{$prefix}--list-box__menu {\n    min-inline-size: auto;\n  }\n\n  // When select all is turned on, the first item in the listbox\n  // is always the \"Select all\" option and gets special border\n  // treatment\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--selectall\n    .#{$prefix}--list-box__menu-item:first-child\n    .#{$prefix}--list-box__menu-item__option {\n    padding: 0.6875rem $spacing-05;\n    margin: 0;\n    border-block-end: 1px solid $border-subtle-01;\n  }\n\n  // When select all is turned on, the second item in the list\n  // has special treatment to look correct against the \"Select all\"\n  // border treatment\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--selectall\n    .#{$prefix}--list-box__menu-item:nth-child(2)\n    .#{$prefix}--list-box__menu-item__option {\n    border-block-start: none;\n  }\n\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    .#{$prefix}--checkbox-wrapper {\n    display: flex;\n    align-items: center;\n    block-size: 100%;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    .#{$prefix}--checkbox-label {\n    display: inline-block;\n    overflow: hidden;\n    inline-size: 100%;\n    padding-inline-start: convert.to-rem(28px);\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    .#{$prefix}--checkbox-label::before {\n    margin-block: 0;\n  }\n\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    .#{$prefix}--checkbox:indeterminate\n    + .#{$prefix}--checkbox-label::after {\n    inset-block-start: convert.to-rem(9px);\n  }\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    .#{$prefix}--checkbox-label::after {\n    inset-block-start: convert.to-rem(5px);\n  }\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item__option\n    > .#{$prefix}--form-item {\n    flex-direction: row;\n    margin: 0;\n  }\n\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__menu-item\n    .#{$prefix}--checkbox:checked\n    ~ .#{$prefix}--checkbox-label-text {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--multi-select--filterable {\n    transition: outline-color $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--combo-box\n    .#{$prefix}--text-input {\n    border: convert.to-rem(2px) solid transparent;\n    background-clip: padding-box;\n    outline: none;\n  }\n\n  .#{$prefix}--multi-select--filterable--input-focused,\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__field--wrapper--input-focused:has(\n      button[aria-expanded='false']\n    ),\n  .#{$prefix}--multi-select\n    .#{$prefix}--list-box__field--wrapper--input-focused:has(\n      button[aria-expanded='true']\n    ) {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--list-box--expanded\n    .#{$prefix}--list-box__field--wrapper:has(\n      button[aria-activedescendant]:not([aria-activedescendant=''])\n    ),\n  .#{$prefix}--multi-select--filterable.#{$prefix}--list-box--expanded:has(\n      input[aria-activedescendant]:not([aria-activedescendant=''])\n    ) {\n    outline-offset: convert.to-rem(-1px);\n    outline-width: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--multi-select--selected\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted::before,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--selected\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted::before {\n    position: absolute;\n    border: 2px solid $focus;\n    block-size: 100%;\n    border-block-start: 1px solid $focus;\n    content: '';\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--multi-select--selected\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--selected\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted {\n    @include focus-outline('reset');\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--multi-select--selected\n    .#{$prefix}--text-input,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--selected\n    .#{$prefix}--list-box__field {\n    padding-inline-start: 0;\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--list-box--disabled:hover:not(\n      .#{$prefix}--multi-select--filterable\n    )\n    .#{$prefix}--text-input {\n    background-color: $field;\n  }\n\n  .#{$prefix}--multi-select--filterable\n    .#{$prefix}--list-box__selection--multi {\n    margin: 0 0 0 $spacing-05;\n  }\n\n  .#{$prefix}--multi-select--filterable.#{$prefix}--multi-select--inline,\n  .#{$prefix}--multi-select--filterable.#{$prefix}--multi-select--inline\n    .#{$prefix}--text-input {\n    background-color: transparent;\n    border-block-end: 0;\n  }\n\n  .#{$prefix}--multi-select:not(.#{$prefix}--list-box--expanded)\n    .#{$prefix}--list-box__menu {\n    visibility: hidden;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly:hover {\n    background-color: transparent;\n    border-block-end-color: $border-subtle;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--list-box__menu-icon\n    svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--tag--filter,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--tag__close-icon:hover {\n    background-color: transparent;\n    color: $text-primary;\n    cursor: default;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--tag--filter {\n    box-shadow: 0 0 0 1px $border-subtle;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--tag--filter\n    svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--multi-select.#{$prefix}--multi-select--readonly\n    .#{$prefix}--list-box__menu-icon {\n    cursor: default;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n//-----------------------------\n// Search\n//-----------------------------\n\n@use '../text-input';\n@use '../../theme' as *;\n@use '../../config' as *;\n@use '../../type';\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../utilities/placeholder-colors' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/component-reset' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/convert';\n@use '../../utilities/button-reset';\n\n/// Search styles\n/// @access public\n/// @group search\n@mixin search {\n  .#{$prefix}--search {\n    position: relative;\n    display: flex;\n    align-items: center;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--search .#{$prefix}--label {\n    @include visually-hidden;\n  }\n\n  .#{$prefix}--search-input {\n    @include reset;\n    @include type.type-style('body-compact-01');\n    @include focus-outline('reset');\n\n    order: 1;\n    padding: 0 $spacing-08;\n    border: none;\n    appearance: none;\n    background-color: $field;\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n\n    inline-size: 100%;\n    text-overflow: ellipsis;\n    transition:\n      background-color $duration-fast-02 motion(standard, productive),\n      outline $duration-fast-02 motion(standard, productive);\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n\n    &::placeholder {\n      @include placeholder-colors;\n    }\n\n    &::-ms-clear {\n      display: none;\n    }\n\n    &::-webkit-search-decoration,\n    &::-webkit-search-cancel-button,\n    &::-webkit-search-results-button,\n    &::-webkit-search-results-decoration {\n      display: none;\n      -webkit-appearance: none;\n      appearance: none;\n    }\n  }\n\n  .#{$prefix}--search-input[disabled] {\n    background-color: $field;\n    border-block-end: 1px solid transparent;\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    &::placeholder {\n      color: $field;\n    }\n  }\n  .#{$prefix}--search--light .#{$prefix}--search-input {\n    background: $field-02;\n  }\n\n  .#{$prefix}--search--light .#{$prefix}--search-close::before {\n    background: $field-02;\n  }\n\n  // Small styles\n  .#{$prefix}--search--sm .#{$prefix}--search-input,\n  .#{$prefix}--search--sm.#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-input {\n    // 8px padding on either side of icon + 16px icon (32px)\n    padding: 0 $spacing-07;\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--search--sm .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: convert.to-rem(8px);\n  }\n\n  // Medium styles\n  .#{$prefix}--search--md .#{$prefix}--search-input,\n  .#{$prefix}--search--md.#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-input {\n    // 12px padding on either side of icon + 16px icon (40px)\n    padding: 0 $spacing-08;\n    block-size: convert.to-rem(40px);\n  }\n\n  .#{$prefix}--search--md .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: convert.to-rem(12px);\n  }\n\n  // Large styles\n  .#{$prefix}--search--lg .#{$prefix}--search-input,\n  .#{$prefix}--search--lg.#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-input {\n    // 16px padding on either side of icon + 16px icon (48px)\n    padding: 0 $spacing-09;\n    block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--search-magnifier-icon {\n    @include reset;\n\n    position: absolute;\n    z-index: 2;\n    block-size: convert.to-rem(16px);\n    fill: $icon-secondary;\n    inline-size: convert.to-rem(16px);\n    inset-block-start: 50%;\n    inset-inline-start: $spacing-05;\n    pointer-events: none;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--search-close {\n    @include button-reset.reset(false);\n    @include focus-outline('reset');\n\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-end: 0;\n\n    &::before {\n      position: absolute;\n      display: block;\n      background-color: $field;\n      block-size: calc(100% - 2px);\n      content: '';\n      inline-size: 2px;\n      inset-block-start: convert.to-rem(1px);\n      inset-inline-start: 0;\n      transition: background-color $duration-fast-02\n        motion(standard, productive);\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n\n    &:hover {\n      border-block-end: 1px solid $border-strong;\n\n      &::before {\n        background-color: $field-hover;\n      }\n    }\n  }\n\n  .#{$prefix}--search-button {\n    flex-shrink: 0;\n    background-color: $field;\n    margin-inline-start: $spacing-01;\n\n    svg {\n      fill: currentColor;\n      vertical-align: middle;\n    }\n  }\n\n  .#{$prefix}--search-close svg {\n    fill: inherit;\n  }\n\n  .#{$prefix}--search-close,\n  .#{$prefix}--search-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-width: 1px 0;\n    border-style: solid;\n    border-color: transparent;\n    block-size: convert.to-rem(40px);\n    cursor: pointer;\n    fill: $icon-primary;\n    inline-size: convert.to-rem(40px);\n    opacity: 1;\n    transition:\n      opacity $duration-fast-02 motion(standard, productive),\n      background-color $duration-fast-02 motion(standard, productive),\n      outline $duration-fast-02 motion(standard, productive),\n      border $duration-fast-02 motion(standard, productive);\n    visibility: inherit;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n\n    &:active {\n      @include focus-outline('outline');\n\n      background-color: $background-selected;\n    }\n  }\n\n  .#{$prefix}--search--disabled .#{$prefix}--search-close,\n  .#{$prefix}--search--disabled.#{$prefix}--search--expandable\n    .#{$prefix}--search-magnifier {\n    cursor: not-allowed;\n    outline: none;\n\n    &:hover {\n      background-color: transparent;\n      border-block-end-color: transparent;\n    }\n\n    &:hover::before {\n      background-color: transparent;\n    }\n  }\n\n  .#{$prefix}--search--disabled svg {\n    fill: $icon-on-color-disabled;\n  }\n\n  .#{$prefix}--search-close:focus,\n  .#{$prefix}--search-close:active {\n    &::before {\n      background-color: $focus;\n    }\n  }\n\n  .#{$prefix}--search-input:focus ~ .#{$prefix}--search-close:hover {\n    @include focus-outline('outline');\n  }\n\n  // Small\n  .#{$prefix}--search--sm {\n    .#{$prefix}--search-close,\n    ~ .#{$prefix}--search-button,\n    &.#{$prefix}--search--expandable,\n    &.#{$prefix}--search--expandable .#{$prefix}--search-magnifier {\n      block-size: convert.to-rem(32px);\n      inline-size: convert.to-rem(32px);\n    }\n\n    &.#{$prefix}--search--expandable .#{$prefix}--search-input::placeholder {\n      padding: 0 convert.to-rem(32px);\n    }\n  }\n\n  // Medium\n  .#{$prefix}--search--md {\n    .#{$prefix}--search-close,\n    ~ .#{$prefix}--search-button,\n    &.#{$prefix}--search--expandable,\n    &.#{$prefix}--search--expandable .#{$prefix}--search-magnifier {\n      block-size: convert.to-rem(40px);\n      inline-size: convert.to-rem(40px);\n    }\n\n    &.#{$prefix}--search--expandable .#{$prefix}--search-input::placeholder {\n      padding: 0 convert.to-rem(40px);\n    }\n  }\n\n  // Large\n  .#{$prefix}--search--lg {\n    .#{$prefix}--search-close,\n    ~ .#{$prefix}--search-button,\n    &.#{$prefix}--search--expandable,\n    &.#{$prefix}--search--expandable .#{$prefix}--search-magnifier {\n      block-size: convert.to-rem(48px);\n      inline-size: convert.to-rem(48px);\n    }\n\n    &.#{$prefix}--search--expandable .#{$prefix}--search-input::placeholder {\n      padding: 0 convert.to-rem(48px);\n    }\n  }\n\n  .#{$prefix}--search-close--hidden {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  .#{$prefix}--search--lg.#{$prefix}--skeleton .#{$prefix}--search-input,\n  .#{$prefix}--search--md.#{$prefix}--skeleton .#{$prefix}--search-input,\n  .#{$prefix}--search--sm.#{$prefix}--skeleton .#{$prefix}--search-input {\n    @include skeleton;\n\n    inline-size: 100%;\n\n    &::placeholder {\n      color: transparent;\n    }\n  }\n\n  .#{$prefix}--search--expandable {\n    transition: width $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--search--expandable.#{$prefix}--search--expanded {\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--search--expandable .#{$prefix}--search-input {\n    padding: 0;\n    inline-size: 0;\n    transition: transform $duration-fast-01 motion(standard, productive);\n\n    &::placeholder {\n      position: relative;\n      opacity: 0;\n      transition-duration: $duration-fast-01;\n      transition-property: padding, opacity;\n      transition-timing-function: motion(standard, productive);\n    }\n  }\n\n  .#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-input {\n    inline-size: 100%;\n    transition: padding $duration-fast-01 motion(standard, productive);\n\n    &::placeholder {\n      position: relative;\n      padding: 0;\n      opacity: 1;\n    }\n  }\n\n  .#{$prefix}--search--expandable .#{$prefix}--search-magnifier {\n    position: absolute;\n    cursor: pointer;\n\n    &:focus {\n      outline: 2px solid $focus;\n    }\n  }\n\n  .#{$prefix}--search--expandable .#{$prefix}--search-magnifier:hover {\n    background-color: $background-hover;\n  }\n\n  .#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-magnifier {\n    pointer-events: none;\n  }\n\n  .#{$prefix}--search--expandable .#{$prefix}--search-magnifier-icon {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--search--expandable.#{$prefix}--search--expanded\n    .#{$prefix}--search-magnifier-icon {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--search--expandable.#{$prefix}--search--disabled svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--search-magnifier-tooltip {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    .#{$prefix}--search-magnifier {\n      position: relative;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n\n/// Common component easings\n/// @type Map\n/// @access public\n/// @group @carbon/motion\n$easings: (\n  standard: (\n    productive: cubic-bezier(0.2, 0, 0.38, 0.9),\n    expressive: cubic-bezier(0.4, 0.14, 0.3, 1),\n  ),\n  entrance: (\n    productive: cubic-bezier(0, 0, 0.38, 0.9),\n    expressive: cubic-bezier(0, 0, 0.3, 1),\n  ),\n  exit: (\n    productive: cubic-bezier(0.2, 0, 1, 0.9),\n    expressive: cubic-bezier(0.4, 0.14, 1, 1),\n  ),\n);\n\n/// Get the transition-timing-function for a given easing and motion mode\n/// @param {String} $name - Can be `standard`, `entrance`, or `exit`\n/// @param {String} $mode [productive] - Can be `productive` or `expressive`\n/// @param {Map} $easings [$carbon--easings] - Easings map\n/// @access public\n/// @group @carbon/motion\n/// @return {Function} CSS `cubic-bezier()` function\n@function motion($name, $mode: productive, $easings: $easings) {\n  @if map.has-key($easings, $name) {\n    $easing: map.get($easings, $name);\n    @if map.has-key($easing, $mode) {\n      @return map.get($easing, $mode);\n    } @else {\n      @error 'Unable to find a mode for the easing #{$easing} called: #{$mode}.';\n    }\n  } @else {\n    @error 'Unable to find an easing named #{$name} in our supported easings.';\n  }\n}\n\n/// Set the transition-timing-function for a given easing and motion mode\n/// @param {String} $name - The name of the easing curve to apply\n/// @param {String} $mode - The mode for the easing curve to use\n/// @access public\n/// @group @carbon/motion\n@mixin motion($name, $mode) {\n  transition-timing-function: motion($name, $mode);\n}\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-fast-01: 70ms;\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-fast-02: 110ms;\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-moderate-01: 150ms;\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-moderate-02: 240ms;\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-slow-01: 400ms;\n\n/// @access public\n/// @type Duration\n/// @group @carbon/motion\n$duration-slow-02: 700ms;\n\n/// V10 backwards compatibility tokens\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$fast-01: $duration-fast-01;\n\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$fast-02: $duration-fast-02;\n\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$moderate-01: $duration-moderate-01;\n\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$moderate-02: $duration-moderate-02;\n\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$slow-01: $duration-slow-01;\n\n/// @access public\n/// @deprecated\n/// @type Duration\n/// @group @carbon/motion\n$slow-02: $duration-slow-02;\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../list-box';\n@use '../../config' as *;\n@use '../../theme' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n\n/// Combo box styles\n/// @access public\n/// @group combo-box\n@mixin combo-box {\n  .#{$prefix}--combo-box:hover {\n    background-color: $field;\n  }\n\n  .#{$prefix}--combo-box\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted::before {\n    position: absolute;\n    border: 2px solid $focus;\n    block-size: 100%;\n    border-block-start: 1px solid $focus;\n    content: '';\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--combo-box\n    .#{$prefix}--list-box__menu-item:first-child.#{$prefix}--list-box__menu-item--highlighted {\n    @include focus-outline('reset');\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--combo-box.#{$prefix}--list-box--light:hover {\n    background-color: $field-02;\n  }\n\n  .#{$prefix}--combo-box .#{$prefix}--text-input::-ms-clear {\n    display: none;\n  }\n\n  .#{$prefix}--combo-box.#{$prefix}--list-box--expanded\n    .#{$prefix}--text-input {\n    border-block-end-color: $border-subtle;\n  }\n\n  .#{$prefix}--combo-box--input--focus.#{$prefix}--text-input {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--combo-box.#{$prefix}--list-box--expanded:has(\n      input[aria-activedescendant]:not([aria-activedescendant=''])\n    )\n    .#{$prefix}--combo-box--input--focus.#{$prefix}--text-input {\n    outline-offset: convert.to-rem(-1px);\n    outline-width: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--combo-box .#{$prefix}--list-box__field,\n  .#{$prefix}--combo-box.#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--combo-box.#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--combo-box.#{$prefix}--list-box--disabled.#{$prefix}--list-box[data-invalid]\n    .#{$prefix}--list-box__field,\n  .#{$prefix}--combo-box.#{$prefix}--list-box--disabled.#{$prefix}--list-box--warning\n    .#{$prefix}--list-box__field {\n    padding: 0;\n  }\n\n  // readonly\n  .#{$prefix}--combo-box--readonly,\n  .#{$prefix}--combo-box--readonly:hover {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--combo-box--readonly .#{$prefix}--text-input {\n    border-block-end-color: $border-subtle;\n  }\n\n  .#{$prefix}--combo-box--readonly .#{$prefix}--list-box__menu-icon,\n  .#{$prefix}--combo-box--readonly .#{$prefix}--list-box__selection {\n    cursor: default;\n  }\n\n  .#{$prefix}--combo-box--readonly .#{$prefix}--list-box__menu-icon svg,\n  .#{$prefix}--combo-box--readonly .#{$prefix}--list-box__selection svg {\n    fill: $icon-disabled;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../form';\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../type' as *;\n@use '../../breakpoint' as *;\n@use '../../theme' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/skeleton' as *;\n\n/// Select styles\n/// @access public\n/// @group select\n@mixin select {\n  .#{$prefix}--select {\n    @include component-reset.reset;\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--select-input__wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--select-input {\n    @include type-style('body-compact-01');\n    @include focus-outline('reset');\n\n    display: block;\n    border: none;\n    border-radius: 0;\n    appearance: none;\n    background-color: $field;\n    block-size: convert.to-rem(40px);\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    cursor: pointer;\n    font-family: inherit;\n    inline-size: 100%;\n    // reset disabled <select> opacity\n    opacity: 1;\n    padding-block: 0;\n    padding-inline: $spacing-05 $spacing-09;\n    text-overflow: ellipsis;\n\n    // Do not transition on background-color (see: https://github.com/carbon-design-system/carbon/issues/4464)\n    transition: outline $duration-fast-01 motion(standard, productive);\n\n    &:hover {\n      background-color: $field-hover;\n    }\n\n    // Hide default select arrow in IE10+\n    &::-ms-expand {\n      display: none;\n    }\n\n    //\n    /* This is for targeting styles specific to firefox */\n    /* Removes dotted inner focus */\n    /* https://sass-lang.com/documentation/breaking-changes/moz-document/ */\n    /* stylelint-disable-next-line at-rule-no-vendor-prefix */\n    @-moz-document url-prefix() {\n      &:-moz-focusring,\n      &::-moz-focus-inner {\n        background-image: none;\n        color: transparent;\n        text-shadow: 0 0 0 #000000;\n      }\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n\n      color: $text-primary;\n    }\n\n    &:disabled,\n    &:hover:disabled {\n      background-color: $field;\n      border-block-end-color: transparent;\n      color: $text-disabled;\n      cursor: not-allowed;\n    }\n  }\n\n  .#{$prefix}--select-input--sm {\n    block-size: convert.to-rem(32px);\n    max-block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--select-input--lg {\n    block-size: convert.to-rem(48px);\n    max-block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--select--disabled .#{$prefix}--label,\n  .#{$prefix}--select--disabled .#{$prefix}--form__helper-text {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--select-input__wrapper[data-invalid] .#{$prefix}--select-input,\n  .#{$prefix}--select--warning .#{$prefix}--select-input {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--select-input:disabled ~ .#{$prefix}--select__arrow {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--select--light .#{$prefix}--select-input {\n    background-color: $field-02;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n\n    &:disabled,\n    &:hover:disabled {\n      background-color: $field-02;\n      color: $text-disabled;\n      cursor: not-allowed;\n    }\n  }\n\n  .#{$prefix}--select__arrow {\n    position: absolute;\n    block-size: 100%;\n    fill: $icon-primary;\n    inset-block-start: 0;\n    inset-inline-end: $spacing-05;\n    pointer-events: none;\n\n    // Windows, Firefox HCM Fix\n    @media screen and (-ms-high-contrast: active),\n      screen and (prefers-contrast) {\n      // `ButtonText` is a CSS2 system color to help improve colors in HCM\n      path {\n        fill: ButtonText;\n      }\n    }\n  }\n\n  .#{$prefix}--select__invalid-icon {\n    position: absolute;\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--select-input__wrapper[data-invalid]\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon {\n    fill: $support-error;\n  }\n\n  .#{$prefix}--select-input--inline__wrapper[data-invalid] {\n    .#{$prefix}--select__invalid-icon {\n      fill: $support-error;\n    }\n  }\n\n  .#{$prefix}--select__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--select__invalid-icon--warning path[fill] {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  optgroup.#{$prefix}--select-optgroup,\n  .#{$prefix}--select-option {\n    // For the options to show in IE11\n    background-color: $layer-hover;\n    color: $text-primary;\n\n    &:disabled {\n      color: $text-disabled;\n    }\n  }\n\n  .#{$prefix}--select--inline {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--form__helper-text {\n    margin-block-end: 0;\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--label {\n    margin: 0 $spacing-03 0 0;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--select-input {\n    background-color: transparent;\n    border-block-end: none;\n    color: $text-primary;\n    inline-size: 100%;\n    padding-inline: $spacing-03 $spacing-09;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--select-input:focus,\n  .#{$prefix}--select--inline .#{$prefix}--select-input:focus option,\n  .#{$prefix}--select--inline .#{$prefix}--select-input:focus optgroup {\n    background-color: $background;\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--select-input[disabled],\n  .#{$prefix}--select--inline .#{$prefix}--select-input[disabled]:hover {\n    background-color: $background;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--select__arrow {\n    inset-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--select--inline.#{$prefix}--select--invalid\n    .#{$prefix}--select-input {\n    padding-inline-end: convert.to-rem(56px);\n  }\n\n  .#{$prefix}--select--inline.#{$prefix}--select--invalid\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon,\n  .#{$prefix}--select--inline.#{$prefix}--select--warning\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon--warning {\n    inset-inline-end: $spacing-07;\n  }\n\n  .#{$prefix}--select--inline .#{$prefix}--select-input:disabled {\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    ~ * {\n      cursor: not-allowed;\n    }\n  }\n\n  // readonly\n  .#{$prefix}--select--readonly .#{$prefix}--select-input {\n    background-color: transparent;\n    border-block-end-color: $border-subtle;\n    cursor: default;\n  }\n\n  .#{$prefix}--select--readonly .#{$prefix}--select__arrow {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--select--readonly.#{$prefix}--select--inline\n    .#{$prefix}--select-input:hover {\n    background-color: transparent;\n  }\n\n  // Skeleton State\n  .#{$prefix}--select.#{$prefix}--skeleton {\n    @include skeleton;\n\n    block-size: 2.5rem;\n\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--select.#{$prefix}--skeleton .#{$prefix}--select-input {\n    display: none;\n  }\n\n  // AILabel styles\n\n  $divider-width: 1px;\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label,\n  .#{$prefix}--select--slug .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: 50%;\n    inset-inline-end: calc($spacing-08 + 8px + $divider-width);\n    margin-block-start: convert.to-rem(0.5px);\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *::after,\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label::after,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--select--slug .#{$prefix}--slug::after,\n  .#{$prefix}--select--slug .#{$prefix}--slug::before {\n    position: absolute;\n    background-color: $border-subtle-01;\n    block-size: convert.to-rem(16px);\n    content: '';\n    inline-size: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--select--slug .#{$prefix}--slug::before {\n    display: none;\n    inset-inline-start: calc(-#{$spacing-03} - #{$divider-width});\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *::after,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label::after,\n  .#{$prefix}--select--slug .#{$prefix}--slug::after {\n    display: block;\n    inset-block-start: 0;\n    inset-inline-end: calc(-#{$spacing-03} - #{$divider-width});\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--select--slug .#{$prefix}--slug--revert::before {\n    inset-block-start: 0.5rem;\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select__inner-wrapper--decorator\n    > .#{$prefix}--ai-label--revert,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label--revert {\n    inset-inline-end: convert.to-rem(41px);\n  }\n\n  .#{$prefix}--select--decorator .#{$prefix}--ai-label--revert::after,\n  .#{$prefix}--select--slug .#{$prefix}--ai-label--revert::after,\n  .#{$prefix}--select--slug .#{$prefix}--slug--revert::after {\n    inset-block-start: convert.to-rem(8px);\n    inset-inline-end: -($divider-width);\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select-input:has(\n      ~ .#{$prefix}--select__inner-wrapper--decorator\n    ),\n  .#{$prefix}--select--slug\n    .#{$prefix}--select-input:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--select--slug .#{$prefix}--select-input:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-10;\n  }\n\n  .#{$prefix}--select--decorator:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--select-input:has(\n      ~ .#{$prefix}--select__inner-wrapper--decorator\n    ),\n  .#{$prefix}--select--slug:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--select-input:has(~ .#{$prefix}--ai-label),\n  .#{$prefix}--select--slug:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--select-input:has(~ .#{$prefix}--slug) {\n    padding-inline-end: $spacing-12;\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select-input:has(\n      ~ .#{$prefix}--select__inner-wrapper--decorator .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--select__inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--select--slug\n    .#{$prefix}--select-input:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--select--slug\n    .#{$prefix}--select-input:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ),\n  .#{$prefix}--select-input-has--ai-label {\n    @include ai-gradient;\n  }\n\n  .#{$prefix}--select--decorator:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--select__inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--select--slug:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--select--slug:has(.#{$prefix}--select__invalid-icon)\n    .#{$prefix}--slug::before {\n    display: block;\n  }\n\n  .#{$prefix}--select--decorator\n    .#{$prefix}--select-input__wrapper\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon,\n  .#{$prefix}--select--slug\n    .#{$prefix}--select-input__wrapper[data-invalid]\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon,\n  .#{$prefix}--select--slug\n    .#{$prefix}--select-input__wrapper\n    .#{$prefix}--select-input\n    ~ .#{$prefix}--select__invalid-icon {\n    inset-inline-end: $spacing-11;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../select';\n@use '../../layer' as *;\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../type' as *;\n@use '../../breakpoint' as *;\n@use '../../theme' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n\n/// Pagination styles\n/// @access public\n/// @group pagination\n@mixin pagination {\n  .#{$prefix}--data-table-container + .#{$prefix}--pagination {\n    border-block-start: 0;\n  }\n\n  .#{$prefix}--pagination {\n    @include component-reset.reset;\n    @include type-style('body-compact-01');\n\n    display: flex;\n    overflow: initial;\n    align-items: center;\n    justify-content: space-between;\n    background-color: $layer;\n    border-block-start: 1px solid $border-subtle;\n    container-name: pagination;\n    container-type: inline-size;\n    inline-size: calc(100% - 1px);\n    min-block-size: convert.to-rem(40px);\n\n    // 42rem = 'md' breakpoint\n    @container pagination (min-width: 42rem) {\n      .#{$prefix}--pagination__control-buttons {\n        display: flex;\n      }\n    }\n\n    // mobile friendly pagination\n    @container pagination (max-width: 42rem) {\n      .#{$prefix}--pagination__left > *,\n      .#{$prefix}--pagination__right > * {\n        display: none;\n      }\n\n      .#{$prefix}--pagination__items-count {\n        display: initial;\n      }\n\n      .#{$prefix}--pagination__control-buttons {\n        display: flex;\n      }\n    }\n  }\n\n  .#{$prefix}--pagination--sm {\n    min-block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--pagination--lg {\n    min-block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--pagination .#{$prefix}--select {\n    align-items: center;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--pagination .#{$prefix}--select-input--inline__wrapper {\n    display: flex;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--pagination .#{$prefix}--select-input {\n    @include type-style('body-compact-01');\n\n    block-size: 100%;\n\n    inline-size: auto;\n    line-height: convert.to-rem(40px);\n\n    min-inline-size: auto;\n\n    // Firefox-specific fix for three-digit numbers\n    // stylelint-disable-next-line at-rule-no-vendor-prefix\n    @-moz-document url-prefix() {\n      padding-inline-end: $spacing-05;\n      text-overflow: clip;\n    }\n  }\n\n  // Extra specificity is needed to preserve padding\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input {\n    padding-inline: $spacing-05 2.25rem;\n  }\n\n  .#{$prefix}--pagination--sm .#{$prefix}--select-input {\n    line-height: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--pagination--lg .#{$prefix}--select-input {\n    line-height: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--pagination .#{$prefix}--select-input:hover {\n    background: $layer-hover;\n  }\n\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input:focus,\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input:focus\n    option,\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input:focus\n    optgroup {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--pagination .#{$prefix}--select__arrow {\n    inset-block-start: 50%;\n    transform: translate(-0.5rem, -50%);\n  }\n\n  .#{$prefix}--pagination\n    .#{$prefix}--select__item-count\n    .#{$prefix}--select-input {\n    border-inline-end: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--pagination__right {\n    border-inline-start: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--pagination__left,\n  .#{$prefix}--pagination__right {\n    display: flex;\n    align-items: center;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--pagination__left > .#{$prefix}--form-item,\n  .#{$prefix}--pagination__right > .#{$prefix}--form-item {\n    block-size: 100%;\n  }\n\n  .#{$prefix}--pagination__left .#{$prefix}--pagination__text,\n  .#{$prefix}--pagination__right .#{$prefix}--pagination__text {\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--pagination__left .#{$prefix}--pagination__text {\n    margin-inline-end: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--pagination__right .#{$prefix}--pagination__text {\n    margin-inline: convert.to-rem(1px) 1rem;\n  }\n\n  .#{$prefix}--pagination__right\n    .#{$prefix}--pagination__text.#{$prefix}--pagination__page-text {\n    margin-inline: 1rem convert.to-rem(1px);\n  }\n\n  .#{$prefix}--pagination__right\n    .#{$prefix}--pagination__text.#{$prefix}--pagination__page-text.#{$prefix}--pagination__unknown-pages-text {\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--pagination__right .#{$prefix}--pagination__text:empty {\n    margin: 0;\n  }\n\n  .#{$prefix}--pagination__left {\n    padding: 0 $spacing-05 0 0;\n\n    // 42rem = 'md' breakpoint width\n    @container pagination (min-width: 42rem) {\n      padding: 0 $spacing-05;\n    }\n  }\n\n  .#{$prefix}--pagination__text {\n    @container pagination (min-width: 42rem) {\n      display: inline-block;\n    }\n  }\n\n  span.#{$prefix}--pagination__text {\n    color: $text-primary;\n    margin-inline-start: $spacing-05;\n  }\n\n  span.#{$prefix}--pagination__text.#{$prefix}--pagination__items-count {\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--pagination__button,\n  .#{$prefix}--btn--ghost.#{$prefix}--pagination__button {\n    @include component-reset.reset;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    margin: 0;\n    background: none;\n    block-size: convert.to-rem(40px);\n    border-inline-start: 1px solid $border-subtle;\n    cursor: pointer;\n    fill: $icon-primary;\n    inline-size: convert.to-rem(40px);\n    min-block-size: convert.to-rem(32px);\n    transition:\n      outline $duration-fast-02 motion(standard, productive),\n      background-color $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--pagination__button > svg,\n  .#{$prefix}--btn--ghost.#{$prefix}--pagination__button > svg {\n    margin-block-start: 0;\n  }\n\n  [dir='rtl'] .#{$prefix}--pagination__button > svg,\n  [dir='rtl'] .#{$prefix}--btn--ghost.#{$prefix}--pagination__button > svg {\n    transform: rotate(0.5turn);\n  }\n\n  .#{$prefix}--pagination--sm .#{$prefix}--pagination__button,\n  .#{$prefix}--pagination--sm\n    .#{$prefix}--btn--ghost.#{$prefix}--pagination__button {\n    block-size: convert.to-rem(32px);\n    inline-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--pagination--lg .#{$prefix}--pagination__button,\n  .#{$prefix}--pagination--lg\n    .#{$prefix}--btn--ghost.#{$prefix}--pagination__button {\n    block-size: convert.to-rem(48px);\n    inline-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--pagination__button:focus,\n  .#{$prefix}--btn--ghost:focus.#{$prefix}--pagination__button {\n    @include focus-outline('outline');\n\n    border-inline-start: 0;\n  }\n\n  .#{$prefix}--pagination__button:hover,\n  .#{$prefix}--btn--ghost:hover.#{$prefix}--pagination__button {\n    background: $layer-hover;\n  }\n\n  .#{$prefix}--pagination__button--no-index,\n  .#{$prefix}--btn--ghost.#{$prefix}--pagination__button--no-index {\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--pagination__button:disabled:hover,\n  .#{$prefix}--pagination__button--no-index:hover,\n  .#{$prefix}--btn--ghost:disabled:hover.#{$prefix}--pagination__button,\n  .#{$prefix}--btn--ghost:hover.#{$prefix}--pagination__button--no-index {\n    border-color: $border-subtle;\n    background: $layer;\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  // Skeleton state\n  .#{$prefix}--pagination.#{$prefix}--skeleton .#{$prefix}--skeleton__text {\n    margin-block-end: 0;\n    margin-inline-end: 1rem;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--pagination__button,\n  .#{$prefix}--btn--ghost.#{$prefix}--pagination__button {\n    @include high-contrast-mode('outline');\n  }\n\n  // RTL overrides\n  [dir='rtl'] .#{$prefix}--pagination .#{$prefix}--select__arrow {\n    transform: translate(0.5rem, -50%);\n  }\n  // Override for disabled select inputs to maintain layer background color\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input[disabled],\n  .#{$prefix}--pagination\n    .#{$prefix}--select--inline\n    .#{$prefix}--select-input[disabled]:hover {\n    background-color: $layer;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../breakpoint' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../select';\n\n/// Unstable pagination styles\n/// @access private\n/// @group pagination\n@mixin unstable_pagination {\n  .#{$prefix}--unstable-pagination {\n    @include component-reset.reset;\n    @include type-style('body-compact-01');\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: $layer;\n    border-block-end: 1px solid transparent;\n    border-block-start: 1px solid $border-subtle;\n    container-name: pagination;\n    container-type: inline-size;\n    inline-size: 100%;\n    min-block-size: convert.to-rem(40px);\n  }\n\n  .#{$prefix}--unstable-pagination__text {\n    // 42rem = 'md' breakpoint width\n    @container pagination (min-width: 42rem) {\n      display: inline-block;\n    }\n\n    margin: 0 $spacing-05;\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--unstable-pagination__left,\n  .#{$prefix}--unstable-pagination__right {\n    display: flex;\n    align-items: center;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--unstable-pagination__left {\n    padding: 0 $spacing-05 0 0;\n  }\n\n  .#{$prefix}--unstable-pagination__left > .#{$prefix}--form-item,\n  .#{$prefix}--unstable-pagination__right > .#{$prefix}--form-item {\n    block-size: 100%;\n  }\n\n  .#{$prefix}--unstable-pagination__left\n    .#{$prefix}--unstable-pagination__text {\n    margin-inline-end: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--unstable-pagination__right\n    .#{$prefix}--unstable-pagination__text {\n    margin-inline: convert.to-rem(1px) $spacing-05;\n  }\n\n  .#{$prefix}--unstable-pagination__button {\n    @include component-reset.reset;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    margin: 0;\n    background: none;\n    block-size: convert.to-rem(40px);\n    border-inline-start: 1px solid $border-subtle;\n    color: $icon-primary;\n    cursor: pointer;\n    fill: $icon-primary;\n    inline-size: convert.to-rem(40px);\n    min-block-size: convert.to-rem(32px);\n    transition:\n      outline $duration-fast-02 motion(standard, productive),\n      background-color $duration-fast-02 motion(standard, productive);\n  }\n\n  // Unset height/width set by icon-only button:\n  .#{$prefix}--unstable-pagination__button .#{$prefix}--btn__icon {\n    block-size: initial;\n    inline-size: initial;\n  }\n\n  .#{$prefix}--unstable-pagination__button.#{$prefix}--btn--icon-only.#{$prefix}--tooltip__trigger:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--unstable-pagination__button:hover {\n    background: $layer-hover;\n    color: $icon-primary;\n  }\n\n  .#{$prefix}--unstable-pagination__button--no-index {\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--unstable-pagination__button.#{$prefix}--btn:disabled {\n    border-color: $border-subtle;\n    background: transparent;\n  }\n\n  .#{$prefix}--unstable-pagination__button:disabled:hover,\n  .#{$prefix}--unstable-pagination__button--no-index:hover {\n    background: transparent;\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector,\n  .#{$prefix}--unstable-pagination__page-sizer {\n    align-items: center;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector\n    .#{$prefix}--select-input--inline__wrapper,\n  .#{$prefix}--unstable-pagination__page-sizer\n    .#{$prefix}--select-input--inline__wrapper {\n    display: flex;\n    block-size: 100%;\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector .#{$prefix}--select-input,\n  .#{$prefix}--unstable-pagination__page-sizer .#{$prefix}--select-input {\n    @include type-style('body-short-01');\n\n    padding: 0 2.25rem 0 $spacing-05;\n    block-size: 100%;\n\n    inline-size: auto;\n    line-height: convert.to-rem(40px);\n\n    min-inline-size: auto;\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector\n    .#{$prefix}--select-input:hover,\n  .#{$prefix}--unstable-pagination__page-sizer .#{$prefix}--select-input:hover {\n    background: $layer-hover;\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector .#{$prefix}--select__arrow,\n  .#{$prefix}--unstable-pagination__page-sizer .#{$prefix}--select__arrow {\n    inset-block-start: 50%;\n    transform: translateY(-50%);\n\n    // 42rem = 'md' breakpoint width\n    @container pagination (min-width: 42rem) {\n      inset-inline-end: $spacing-05;\n    }\n  }\n\n  .#{$prefix}--unstable-pagination__page-selector {\n    border-inline-start: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--unstable-pagination__page-sizer {\n    border-inline-end: 1px solid $border-subtle;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n//-----------------------------\n// Radio\n//-----------------------------\n\n@use '../form';\n@use '../button/tokens' as *;\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/component-reset' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/convert';\n\n/// @type Number\n/// @access public\n/// @group radio-button\n$radio-border-width: 1px !default;\n\n/// Radio button styles\n/// @access private\n/// @group radio-button\n@mixin radio-button {\n  .#{$prefix}--radio-button-group {\n    @include reset;\n\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  // Remove spacing above collection of radio buttons if label is present\n  .#{$prefix}--label + .#{$prefix}--form-item .#{$prefix}--radio-button-group {\n    margin-block-start: 0;\n  }\n\n  // vertical radio button\n  .#{$prefix}--radio-button-group--vertical {\n    flex-direction: column;\n    align-items: flex-start;\n\n    &.#{$prefix}--radio-button-group--label-left {\n      align-items: flex-end;\n    }\n\n    .#{$prefix}--radio-button__label {\n      margin-inline-end: 0;\n    }\n\n    .#{$prefix}--radio-button__label:not(:last-of-type) {\n      margin-block-end: $spacing-03;\n    }\n  }\n\n  .#{$prefix}--radio-button {\n    @include visually-hidden;\n\n    margin-block-start: 0.9rem;\n    margin-inline-start: 0.63rem;\n    visibility: inherit;\n  }\n\n  .#{$prefix}--radio-button__label {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--radio-button__label-text {\n    @include type.type-style('body-compact-01');\n\n    flex: 1;\n  }\n\n  .#{$prefix}--radio-button__appearance {\n    @include reset;\n\n    flex-shrink: 0;\n    border: $radio-border-width solid $icon-primary;\n    border-radius: 50%;\n    background-color: transparent;\n    block-size: convert.to-rem(18px);\n    inline-size: convert.to-rem(18px);\n    margin-block: convert.to-rem(1px) convert.to-rem(2px);\n    margin-inline: convert.to-rem(2px) convert.to-rem(10px);\n  }\n\n  .#{$prefix}--radio-button-group--vertical\n    .#{$prefix}--radio-button__appearance {\n    margin-block: 0;\n  }\n\n  .#{$prefix}--radio-button:checked\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-color: $icon-primary;\n\n    &::before {\n      position: relative;\n      display: inline-block;\n      border-radius: 50%;\n      background-color: $icon-primary;\n      block-size: 100%;\n      content: '';\n      inline-size: 100%;\n      transform: scale(0.5);\n\n      // Allow the selected button to be seen in Windows HCM for IE/Edge\n      @include high-contrast-mode {\n        background-color: ButtonText;\n      }\n\n      @media print {\n        print-color-adjust: exact;\n      }\n    }\n  }\n\n  .#{$prefix}--radio-button:disabled + .#{$prefix}--radio-button__label {\n    color: $text-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--radio-button:disabled\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance,\n  .#{$prefix}--radio-button:disabled:checked\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance {\n    // Disabled radio button, checkbox fix #10913\n    border-color: $icon-disabled;\n\n    &::before {\n      background-color: $text-disabled;\n    }\n  }\n\n  // readonly\n  .#{$prefix}--radio-button-group--readonly\n    .#{$prefix}--radio-button\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance {\n    border-color: $icon-disabled;\n  }\n\n  .#{$prefix}--radio-button-group--readonly .#{$prefix}--radio-button__label {\n    cursor: default;\n  }\n\n  .#{$prefix}--radio-button-group--readonly\n    .#{$prefix}--radio-button__label-text {\n    cursor: text;\n    user-select: text;\n  }\n\n  // invalid + warn\n  .#{$prefix}--radio-button-group--invalid\n    .#{$prefix}--radio-button\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance {\n    border-color: $support-error;\n  }\n\n  .#{$prefix}--radio-button__validation-msg {\n    display: none;\n    align-items: flex-end;\n    margin-block-start: convert.to-rem(6px);\n  }\n\n  .#{$prefix}--radio-button__invalid-icon {\n    fill: $support-error;\n    margin-inline: convert.to-rem(3px) convert.to-rem(1px);\n  }\n\n  .#{$prefix}--radio-button__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--radio-button__invalid-icon--warning path:first-of-type {\n    fill: #000000;\n  }\n\n  .#{$prefix}--radio-button-group--invalid\n    + .#{$prefix}--radio-button__validation-msg,\n  .#{$prefix}--radio-button-group--warning\n    + .#{$prefix}--radio-button__validation-msg {\n    display: flex;\n  }\n\n  .#{$prefix}--radio-button-group--invalid\n    + .#{$prefix}--radio-button__validation-msg\n    .#{$prefix}--form-requirement,\n  .#{$prefix}--radio-button-group--warning\n    + .#{$prefix}--radio-button__validation-msg\n    .#{$prefix}--form-requirement {\n    display: block;\n    overflow: visible;\n    margin-block-start: 0;\n    margin-inline-start: $spacing-03;\n    max-block-size: 100%;\n  }\n\n  .#{$prefix}--radio-button-group--invalid\n    + .#{$prefix}--radio-button__validation-msg\n    .#{$prefix}--form-requirement {\n    color: $text-error;\n  }\n\n  .#{$prefix}--radio-button-group ~ .#{$prefix}--form__helper-text {\n    margin-block-start: convert.to-rem(6px);\n  }\n\n  // Focus\n\n  .#{$prefix}--radio-button:focus\n    + .#{$prefix}--radio-button__label\n    .#{$prefix}--radio-button__appearance {\n    outline: 2px solid $focus;\n    outline-offset: 1.5px;\n  }\n\n  // Skeleton State\n  .#{$prefix}--radio-button__label.#{$prefix}--skeleton {\n    @include skeleton;\n\n    block-size: convert.to-rem(18px);\n\n    inline-size: convert.to-rem(100px);\n  }\n\n  .#{$prefix}--radio-button__label.#{$prefix}--skeleton\n    .#{$prefix}--radio-button__appearance {\n    display: none;\n  }\n\n  .#{$prefix}--radio-button-wrapper .#{$prefix}--radio-button__label {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    margin: 0;\n  }\n\n  .#{$prefix}--radio-button-wrapper:not(:last-of-type) {\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--radio-button-group--vertical .#{$prefix}--radio-button-wrapper {\n    margin-block-end: convert.to-rem(6px);\n    margin-inline-end: 0;\n  }\n\n  .#{$prefix}--radio-button-group--vertical\n    .#{$prefix}--radio-button-wrapper\n    .#{$prefix}--radio-button__label {\n    padding-block-start: convert.to-rem(2px);\n  }\n\n  .#{$prefix}--radio-button-group--label-right .#{$prefix}--radio-button__label,\n  .#{$prefix}--radio-button-wrapper.#{$prefix}--radio-button-wrapper--label-right\n    .#{$prefix}--radio-button__label {\n    flex-direction: row;\n  }\n\n  .#{$prefix}--radio-button-group--label-left .#{$prefix}--radio-button__label,\n  .#{$prefix}--radio-button-wrapper.#{$prefix}--radio-button-wrapper--label-left\n    .#{$prefix}--radio-button__label {\n    flex-direction: row-reverse;\n  }\n\n  .#{$prefix}--radio-button-group--label-left\n    .#{$prefix}--radio-button__appearance,\n  .#{$prefix}--radio-button-wrapper.#{$prefix}--radio-button-wrapper--label-left\n    .#{$prefix}--radio-button__appearance {\n    margin-inline: $spacing-03 0;\n  }\n\n  // AILabel styles\n  .#{$prefix}--radio-button-group--decorator legend.#{$prefix}--label,\n  .#{$prefix}--radio-button-wrapper--decorator\n    .#{$prefix}--radio-button__label-text,\n  .#{$prefix}--radio-button-group--slug legend.#{$prefix}--label,\n  .#{$prefix}--radio-button-wrapper--slug\n    .#{$prefix}--radio-button__label-text {\n    display: flex;\n  }\n\n  .#{$prefix}--radio-button-group--decorator\n    legend.#{$prefix}--label\n    .#{$prefix}--radio-button-group-inner--decorator\n    > *,\n  .#{$prefix}--radio-button-wrapper--decorator\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--radio-button-wrapper-inner--decorator\n    > *,\n  .#{$prefix}--radio-button-group--slug\n    legend.#{$prefix}--label\n    .#{$prefix}--ai-label,\n  .#{$prefix}--radio-button-wrapper--slug\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--ai-label,\n  .#{$prefix}--radio-button-group--slug\n    legend.#{$prefix}--label\n    .#{$prefix}--slug,\n  .#{$prefix}--radio-button-wrapper--slug\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--slug {\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--radio-button-wrapper--decorator\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--ai-label__button--inline,\n  .#{$prefix}--radio-button-wrapper--slug\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--ai-label__button--inline,\n  .#{$prefix}--radio-button-wrapper--slug\n    .#{$prefix}--radio-button__label-text\n    .#{$prefix}--slug__button--inline {\n    line-height: inherit;\n    margin-block-start: convert.to-rem(-1px);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../form';\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/convert';\n@use '../../utilities/z-index' as *;\n\n/// Number input styles\n/// @access public\n/// @group number-input\n@mixin number-input {\n  .#{$prefix}--number {\n    @include reset;\n\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--warning\n    input[type='number'],\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--warning\n    input[type='text'] {\n    padding-inline-end: convert.to-rem(128px);\n  }\n\n  .#{$prefix}--number input[type='number'],\n  .#{$prefix}--number input[type='text'] {\n    @include type-style('body-compact-01');\n    @include focus-outline('reset');\n\n    display: inline-flex;\n    box-sizing: border-box;\n    border: 0;\n    border-radius: 0;\n\n    // Firefox: Hide spinner (up and down buttons)\n    -moz-appearance: textfield;\n    appearance: textfield;\n    background-color: $field;\n    block-size: convert.to-rem(40px);\n    border-block-end: convert.to-rem(1px) solid $border-strong;\n    color: $text-primary;\n    font-family: font-family('sans');\n    font-weight: 400;\n    inline-size: 100%;\n    min-inline-size: 9.375rem;\n    padding-inline: $spacing-05 $spacing-12;\n    transition:\n      background-color $duration-fast-01 motion(standard, productive),\n      outline $duration-fast-01 motion(standard, productive);\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n\n    &:disabled ~ .#{$prefix}--number__controls {\n      cursor: not-allowed;\n      pointer-events: none;\n    }\n\n    &:disabled ~ .#{$prefix}--number__controls svg {\n      fill: $icon-disabled;\n    }\n\n    // IE: Hide \"clear-field\" `x` button on input field\n    &::-ms-clear {\n      display: none;\n    }\n\n    // Safari: Hide number spinner\n    &::-webkit-inner-spin-button {\n      appearance: none;\n    }\n\n    &[data-invalid] {\n      padding-inline-end: convert.to-rem(128px);\n    }\n  }\n\n  .#{$prefix}--number--lg.#{$prefix}--number {\n    input[type='number'],\n    input[type='text'] {\n      padding-inline-end: convert.to-rem(112px);\n\n      &[data-invalid] {\n        padding-inline-end: convert.to-rem(144px);\n      }\n    }\n\n    .#{$prefix}--number__input-wrapper--warning input[type='number'],\n    .#{$prefix}--number__input-wrapper--warning input[type='text'] {\n      padding-inline-end: convert.to-rem(144px);\n    }\n  }\n\n  .#{$prefix}--number--sm.#{$prefix}--number {\n    input[type='number'],\n    input[type='text'] {\n      padding-inline-end: convert.to-rem(80px);\n\n      &[data-invalid] {\n        padding-inline-end: convert.to-rem(112px);\n      }\n    }\n\n    .#{$prefix}--number__input-wrapper--warning input[type='number'],\n    .#{$prefix}--number__input-wrapper--warning input[type='text'] {\n      padding-inline-end: convert.to-rem(112px);\n    }\n  }\n\n  .#{$prefix}--number input[type='number']:disabled,\n  .#{$prefix}--number input[type='text']:disabled {\n    background-color: $field;\n    color: $text-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--number__input-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n\n  .#{$prefix}--number__controls {\n    @include reset;\n\n    position: absolute;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    block-size: 100%;\n    inline-size: convert.to-rem(80px);\n    // vertically center controls within parent container on IE11\n    inset-block-start: 50%;\n    inset-inline-end: 0;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--number__control-btn {\n    @include button-reset.reset;\n\n    position: relative;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    block-size: 100%;\n    color: $icon-primary;\n\n    svg {\n      fill: currentColor;\n    }\n\n    &:focus {\n      @include focus-outline;\n\n      color: $icon-primary;\n      outline-offset: -2px;\n      outline-width: 2px;\n    }\n\n    &:hover {\n      background-color: $field-hover;\n      box-shadow: 0 -1px 0 $border-strong inset;\n      color: $icon-primary;\n      cursor: pointer;\n    }\n\n    &:disabled {\n      border-block-end-color: transparent;\n      color: $text-disabled;\n      cursor: not-allowed;\n    }\n  }\n\n  // set orders to facilitate styling for rule dividers\n  .#{$prefix}--number__control-btn.down-icon {\n    order: 1;\n  }\n\n  .#{$prefix}--number__control-btn.up-icon {\n    order: 2;\n  }\n\n  .#{$prefix}--number\n    input[type='number'][data-invalid]\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn,\n  .#{$prefix}--number\n    input[type='text'][data-invalid]\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn {\n    border-block-end-color: $support-error;\n  }\n\n  // add top and bottom outlines to number controls when input is focused\n  .#{$prefix}--number\n    input[type='number']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn,\n  .#{$prefix}--number\n    input[type='text']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn {\n    border-width: 2px 0;\n    border-style: solid;\n    border-color: $focus;\n    box-shadow: none;\n    outline-offset: -2px;\n  }\n\n  .#{$prefix}--number\n    input[type='number']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:last-of-type:hover,\n  .#{$prefix}--number\n    input[type='text']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:last-of-type:hover {\n    box-shadow: -4px 0 0 -2px $focus inset;\n  }\n\n  // add invalid box-shadow to number controls only when invalid input is not focused\n  .#{$prefix}--number\n    input[type='number'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:last-of-type:hover,\n  .#{$prefix}--number\n    input[type='text'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:last-of-type:hover {\n    box-shadow: -4px 0 0 -2px $support-error inset;\n  }\n\n  .#{$prefix}--number\n    input[type='number'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:hover,\n  .#{$prefix}--number\n    input[type='text'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:hover {\n    border-width: 2px 0;\n    border-style: solid;\n    border-color: $support-error;\n    box-shadow: none;\n    outline-offset: -2px;\n  }\n\n  .#{$prefix}--number\n    input[type='number'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:focus:hover,\n  .#{$prefix}--number\n    input[type='text'][data-invalid]:not(:focus)\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:focus:hover {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--number__rule-divider {\n    position: absolute;\n    z-index: z('overlay');\n    background-color: $border-subtle;\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(1px);\n\n    &:first-of-type {\n      order: 0;\n    }\n  }\n\n  // rule divider styles\n  .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider:first-of-type {\n    background-color: transparent;\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--number__invalid\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider:first-of-type {\n    background-color: $border-subtle;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--number--light .#{$prefix}--number__rule-divider,\n  .#{$prefix}--number--light\n    .#{$prefix}--number__invalid\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider:first-of-type {\n    background-color: $border-subtle-02;\n  }\n\n  .#{$prefix}--number\n    input[type='number']:disabled\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider:first-of-type,\n  .#{$prefix}--number\n    input[type='text']:disabled\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider:first-of-type {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--number\n    input[type='number']:disabled\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider,\n  .#{$prefix}--number\n    input[type='text']:disabled\n    + .#{$prefix}--number__controls\n    .#{$prefix}--number__rule-divider {\n    background-color: $icon-disabled;\n  }\n\n  .#{$prefix}--number__control-btn:focus ~ .#{$prefix}--number__rule-divider {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--number__invalid {\n    position: absolute;\n    fill: $support-error;\n    inset-inline-end: $spacing-12;\n  }\n\n  .#{$prefix}--number--lg .#{$prefix}--number__invalid {\n    inset-inline-end: convert.to-rem(112px);\n  }\n\n  .#{$prefix}--number--sm .#{$prefix}--number__invalid {\n    inset-inline-end: convert.to-rem(80px);\n  }\n\n  .#{$prefix}--number__invalid + .#{$prefix}--number__rule-divider {\n    position: absolute;\n    inset-inline-end: convert.to-rem(80px);\n  }\n\n  .#{$prefix}--number--lg\n    .#{$prefix}--number__invalid\n    + .#{$prefix}--number__rule-divider {\n    inset-inline-end: $spacing-12;\n  }\n\n  .#{$prefix}--number--sm\n    .#{$prefix}--number__invalid\n    + .#{$prefix}--number__rule-divider {\n    inset-inline-end: convert.to-rem(64px);\n  }\n\n  .#{$prefix}--number__control-btn.down-icon:hover\n    ~ .#{$prefix}--number__rule-divider,\n  .#{$prefix}--number__control-btn.up-icon:hover\n    + .#{$prefix}--number__rule-divider,\n  .#{$prefix}--number__control-btn.down-icon:focus\n    ~ .#{$prefix}--number__rule-divider,\n  .#{$prefix}--number__control-btn.up-icon:focus\n    + .#{$prefix}--number__rule-divider {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--number__invalid--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--number__invalid--warning path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  // Size Variant styles\n  .#{$prefix}--number--lg input[type='number'],\n  .#{$prefix}--number--lg input[type='text'] {\n    block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--number--lg .#{$prefix}--number__controls {\n    inline-size: $spacing-12;\n  }\n\n  .#{$prefix}--number--lg .#{$prefix}--number__control-btn {\n    inline-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--number--sm input[type='number'],\n  .#{$prefix}--number--sm input[type='text'] {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--number--sm .#{$prefix}--number__controls {\n    inline-size: convert.to-rem(64px);\n  }\n\n  .#{$prefix}--number--sm .#{$prefix}--number__control-btn {\n    inline-size: convert.to-rem(32px);\n  }\n\n  //No label positioning adjustment\n  .#{$prefix}--number--nolabel\n    .#{$prefix}--label\n    + .#{$prefix}--form__helper-text {\n    margin-block-start: 0;\n  }\n\n  // No steppers\n  .#{$prefix}--number--nosteppers input[type='number'],\n  .#{$prefix}--number--nosteppers input[type='text'] {\n    padding-inline-end: 0;\n  }\n\n  .#{$prefix}--number--nosteppers input[type='number'][data-invalid],\n  .#{$prefix}--number--nosteppers input[type='text'][data-invalid],\n  .#{$prefix}--number--nosteppers\n    .#{$prefix}--number__input-wrapper--warning\n    input[type='number'],\n  .#{$prefix}--number--nosteppers\n    .#{$prefix}--number__input-wrapper--warning\n    input[type='text'] {\n    padding-inline-end: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--number--nosteppers .#{$prefix}--number__invalid {\n    inset-inline-end: convert.to-rem(16px);\n  }\n\n  // Readonly\n  .#{$prefix}--number--readonly input[type='number'],\n  .#{$prefix}--number--readonly input[type='text'] {\n    background: transparent;\n    border-block-end-color: $border-subtle;\n  }\n\n  .#{$prefix}--number--readonly .#{$prefix}--number__control-btn {\n    color: $icon-disabled;\n    pointer-events: none;\n\n    &:hover {\n      background-color: transparent;\n      cursor: pointer;\n    }\n  }\n\n  .#{$prefix}--number--readonly\n    input[type='number']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:hover,\n  .#{$prefix}--number--readonly\n    input[type='text']:focus\n    ~ .#{$prefix}--number__controls\n    .#{$prefix}--number__control-btn:hover {\n    outline: none;\n  }\n\n  .#{$prefix}--number--readonly\n    .#{$prefix}--number__controls:hover\n    .#{$prefix}--number__rule-divider:not(:first-of-type) {\n    background-color: $border-subtle;\n  }\n\n  // Styles for `AILabel` rendered inside `NumberInput`\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__input-inner-wrapper--decorator\n    > *,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--ai-label,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-12;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__input-inner-wrapper--decorator:not(\n      :has(.#{$prefix}--ai-label)\n    )\n    > * {\n    block-size: 1rem;\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__input-inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__control-btn::before,\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__control-btn::after,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--slug::before,\n  .#{$prefix}--number__input-wrapper--slug\n    .#{$prefix}--number__control-btn::before,\n  .#{$prefix}--number__input-wrapper--slug\n    .#{$prefix}--number__control-btn::after {\n    position: absolute;\n    background-color: $border-subtle;\n    block-size: convert.to-rem(16px);\n    content: '';\n    inline-size: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__input-inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--ai-label::before,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--slug::before {\n    display: none;\n    inset-inline-start: convert.to-rem(-16px);\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__input-inner-wrapper--decorator\n    .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--number__input-wrapper--slug\n    .#{$prefix}--ai-label--revert::before,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--slug--revert::before {\n    inset-block-start: convert.to-rem(8px);\n    inset-inline-start: convert.to-rem(-8px);\n  }\n\n  .#{$prefix}--number__control-btn::after {\n    display: block;\n    inset-inline-end: 0;\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__control-btn::before,\n  .#{$prefix}--number__input-wrapper--slug\n    .#{$prefix}--number__control-btn::before {\n    display: block;\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    .#{$prefix}--number__control-btn:focus::before,\n  .#{$prefix}--number__input-wrapper--slug\n    .#{$prefix}--number__control-btn:focus::before {\n    display: none;\n  }\n\n  .#{$prefix}--number__control-btn:hover::after,\n  .#{$prefix}--number__control-btn:hover::before {\n    display: none;\n    inset-inline-end: 0;\n  }\n\n  .#{$prefix}--number__input-wrapper:has(.#{$prefix}--number__control-btn:hover)\n    ~ .#{$prefix}--number__input-wrapper--decorator::after,\n  .#{$prefix}--number__input-wrapper:has(.#{$prefix}--number__control-btn:hover)\n    ~ .#{$prefix}--number__input-wrapper--slug::after {\n    display: none;\n  }\n\n  .#{$prefix}--number__control-btn:has(.up-icon)::after,\n  .#{$prefix}--number__control-btn:has(.up-icon)::before {\n    display: none;\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator .#{$prefix}--number__invalid,\n  .#{$prefix}--number__input-wrapper--slug .#{$prefix}--number__invalid {\n    inset-inline-end: $spacing-13 - $spacing-05;\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator:has(\n      .#{$prefix}--number__invalid\n    )\n    .#{$prefix}--number__input-inner-wrapper--decorator\n    > *::before,\n  .#{$prefix}--number__input-wrapper--slug:has(.#{$prefix}--number__invalid)\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--number__input-wrapper--slug:has(.#{$prefix}--number__invalid)\n    .#{$prefix}--ai-label::before,\n  .#{$prefix}--number__input-wrapper--slug:has(.#{$prefix}--number__invalid)\n    .#{$prefix}--slug::before {\n    display: block;\n  }\n\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--decorator\n    input[data-invalid],\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--decorator.#{$prefix}--number__input-wrapper--warning\n    input,\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--slug\n    input[data-invalid],\n  .#{$prefix}--number\n    .#{$prefix}--number__input-wrapper--slug.#{$prefix}--number__input-wrapper--warning\n    input {\n    padding-inline-end: convert.to-rem(144px);\n  }\n\n  .#{$prefix}--number__input-wrapper--decorator\n    input[type='number']:has(\n      ~ .#{$prefix}--number__input-inner-wrapper--decorator\n        .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--number__input-inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--number__input-wrapper--slug\n    input[type='number']:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--number__input-wrapper--slug\n    input[type='number']:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ),\n  .#{$prefix}--number__input-wrapper--slug input[type='number']:disabled,\n  .#{$prefix}--number__input-wrapper--decorator\n    input[type='text']:has(\n      ~ .#{$prefix}--number__input-inner-wrapper--decorator\n        .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--number__input-inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--number__input-wrapper--slug\n    input[type='text']:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--number__input-wrapper--slug\n    input[type='text']:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ),\n  .#{$prefix}--number__input-wrapper--slug input[type='text']:disabled {\n    @include ai-gradient;\n\n    padding-inline-end: convert.to-rem(145px);\n  }\n\n  // Skeleton State\n\n  .#{$prefix}--number.#{$prefix}--skeleton {\n    @include skeleton;\n\n    inline-size: 100%;\n\n    input[type='number'],\n    input[type='text'] {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--number.#{$prefix}--skeleton.#{$prefix}--number--sm {\n    block-size: $spacing-07;\n  }\n\n  .#{$prefix}--number.#{$prefix}--skeleton.#{$prefix}--number--md {\n    block-size: $spacing-08;\n  }\n\n  .#{$prefix}--number.#{$prefix}--skeleton.#{$prefix}--number--lg {\n    block-size: $spacing-09;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--number__control-btn:hover,\n  .#{$prefix}--number__control-btn:focus {\n    @include high-contrast-mode('focus');\n  }\n\n  .#{$prefix}--number__control-btn {\n    @include high-contrast-mode('outline');\n  }\n}\n\n.#{$prefix}--number__controls:hover .#{$prefix}--number__control-btn::after {\n  display: none;\n}\n\n.#{$prefix}--number__input-wrapper--decorator .#{$prefix}--number__rule-divider,\n.#{$prefix}--number__input-wrapper--slug .#{$prefix}--number__rule-divider {\n  display: none;\n}\n\n.#{$prefix}--number__input-wrapper--decorator\n  .#{$prefix}--number__control-btn:hover,\n.#{$prefix}--number__input-wrapper--slug\n  .#{$prefix}--number__control-btn:hover {\n  box-shadow: 0 -1px 0 $ai-border-strong inset;\n}\n\n//hide dividers on button focus\n.#{$prefix}--number__controls:focus-within\n  .#{$prefix}--number__control-btn::after {\n  display: none;\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n//-----------------------------\n// Slider\n//-----------------------------\n\n@use '../form';\n@use '../text-input';\n@use '../../config' as *;\n@use '../../colors' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/convert';\n@use '../../utilities/custom-property';\n@use '../../utilities/visually-hidden' as *;\n\n/// Slider styles\n/// @access public\n/// @group slider\n@mixin slider {\n  .#{$prefix}--slider-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    user-select: none;\n  }\n\n  .#{$prefix}--slider {\n    position: relative;\n    padding: $spacing-05 0;\n    cursor: pointer;\n    inline-size: 100%;\n    max-inline-size: convert.to-rem(640px);\n    min-inline-size: convert.to-rem(200px);\n\n    .#{$prefix}--slider-container--two-handles & {\n      margin-inline: convert.to-rem(4px);\n    }\n  }\n\n  .#{$prefix}--slider__range-label {\n    @include type-style('body-compact-01');\n\n    color: $text-primary;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--slider__track {\n    position: absolute;\n    background: $border-subtle;\n    block-size: convert.to-rem(2px);\n    inline-size: 100%;\n    transform: translate(0%, -50%);\n  }\n\n  .#{$prefix}--slider__track:before {\n    position: absolute;\n    display: inline-block;\n    background: $border-subtle;\n    block-size: convert.to-rem(4px);\n    content: '';\n    inline-size: convert.to-rem(2px);\n    inset-block-start: convert.to-rem(-5px);\n    inset-inline-start: 50%;\n    transform: translate(-50%, 0);\n  }\n\n  .#{$prefix}--slider__filled-track {\n    position: absolute;\n    background: $layer-selected-inverse;\n    block-size: convert.to-rem(2px);\n    inline-size: 100%;\n    pointer-events: none;\n    transform: translate(0%, -50%);\n    transform-origin: left;\n    transition: background $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--slider__thumb-wrapper {\n    position: absolute;\n    z-index: 3;\n    block-size: convert.to-rem(14px);\n    inline-size: convert.to-rem(14px);\n    transform: translate(-50%, -50%);\n    @include custom-property.declaration('tooltip-padding-inline', $spacing-03);\n    @include custom-property.declaration('popover-offset', $spacing-03);\n\n    .#{$prefix}--slider-container--rtl & {\n      transform: translate(50%, -50%);\n    }\n  }\n\n  .#{$prefix}--slider__thumb-wrapper--lower,\n  .#{$prefix}--slider__thumb-wrapper--upper {\n    block-size: 24px;\n    inline-size: 16px;\n    @include custom-property.declaration(\n      'popover-offset',\n      custom-property.get-var('popover-caret-height', $spacing-03)\n    );\n  }\n\n  .#{$prefix}--slider__thumb-wrapper--lower {\n    transform: translate(-100%, -50%);\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-content {\n      transform: translate(\n        50%,\n        calc(-100% - custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-caret {\n      inset-inline-start: revert;\n      transform: translate(\n        50%,\n        calc(-1 * custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n  }\n\n  .#{$prefix}--slider-container--rtl .#{$prefix}--slider__thumb-wrapper--lower {\n    transform: translate(100%, -50%);\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-content {\n      transform: translate(\n        0,\n        calc(-100% - custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-caret {\n      transform: translate(\n        -50%,\n        calc(-1 * custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n  }\n\n  .#{$prefix}--slider__thumb-wrapper--upper {\n    transform: translate(0, -50%);\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-content {\n      transform: translate(\n        -50%,\n        calc(-100% - custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-caret {\n      transform: translate(\n        -50%,\n        calc(-1 * custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n  }\n\n  .#{$prefix}--slider-container--rtl .#{$prefix}--slider__thumb-wrapper--upper {\n    transform: translate(0, -50%);\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-content {\n      transform: translate(\n        0,\n        calc(-100% - custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n\n    > .#{$prefix}--popover > .#{$prefix}--popover-caret {\n      transform: translate(\n        50%,\n        calc(-1 * custom-property.get-var('popover-offset', 0rem))\n      );\n    }\n  }\n\n  .#{$prefix}--slider__thumb {\n    position: absolute;\n    border-radius: 50%;\n    background: $layer-selected-inverse;\n    box-shadow:\n      inset 0 0 0 1px transparent,\n      inset 0 0 0 2px transparent;\n    inset: 0;\n    outline: none;\n    transition:\n      transform $duration-fast-02 motion(standard, productive),\n      background $duration-fast-02 motion(standard, productive),\n      box-shadow $duration-fast-02 motion(standard, productive);\n\n    &:hover {\n      // 20px / 14px = 1.4286\n      transform: scale(1.4286);\n    }\n\n    &:focus {\n      background-color: $interactive;\n      box-shadow:\n        inset 0 0 0 2px $interactive,\n        inset 0 0 0 3px $layer;\n      // 20px / 14px = 1.4286\n      transform: scale(1.4286);\n    }\n\n    &:active {\n      box-shadow: inset 0 0 0 2px $interactive;\n      transform: scale(1.4286);\n    }\n  }\n\n  .#{$prefix}--slider__thumb-icon {\n    fill: $layer-selected-inverse;\n  }\n\n  .#{$prefix}--slider__thumb-icon--focus {\n    display: none;\n    fill: $interactive;\n  }\n\n  .#{$prefix}--slider__thumb--lower,\n  .#{$prefix}--slider__thumb--upper {\n    position: absolute;\n    border-radius: unset;\n    background-color: transparent;\n    box-shadow: none;\n    inset: 0;\n    transition: none;\n\n    &::before {\n      position: absolute;\n      z-index: -1;\n      display: block;\n      background: $background;\n      block-size: convert.to-rem(2px);\n      content: '';\n      inline-size: convert.to-rem(6px);\n      inset-block-start: calc(50% - #{convert.to-rem(2px) * 0.5});\n      inset-inline-end: 0;\n    }\n\n    &:hover {\n      transform: none;\n\n      .#{$prefix}--slider__thumb-icon {\n        fill: $text-secondary;\n      }\n    }\n\n    &:active {\n      box-shadow: none;\n      transform: none;\n    }\n\n    &:focus {\n      background-color: transparent;\n      box-shadow: none;\n      transform: none;\n\n      .#{$prefix}--slider__thumb-icon {\n        display: none;\n        fill: $interactive;\n      }\n\n      .#{$prefix}--slider__thumb-icon--focus {\n        display: block;\n      }\n    }\n  }\n\n  .#{$prefix}--slider__thumb--lower:focus::before,\n  .#{$prefix}--slider__thumb--upper:focus::before {\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--slider__thumb--upper {\n    transform: none;\n\n    &::before {\n      inset-inline: 0 auto;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      transform: none;\n    }\n  }\n\n  .#{$prefix}--slider__input {\n    display: none;\n  }\n\n  .#{$prefix}--slider-text-input-wrapper {\n    position: relative;\n  }\n\n  .#{$prefix}--slider-text-input-wrapper--hidden {\n    display: none;\n  }\n\n  .#{$prefix}--slider-text-input,\n  .#{$prefix}-slider-text-input {\n    -moz-appearance: textfield;\n    appearance: textfield;\n    block-size: convert.to-rem(40px);\n    inline-size: convert.to-rem(64px);\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--slider__thumb:focus ~ .#{$prefix}--slider__filled-track,\n  .#{$prefix}--slider__thumb-wrapper:focus-within\n    ~ .#{$prefix}--slider__filled-track {\n    background-color: $border-interactive;\n  }\n\n  // Invalid & warn state\n  .#{$prefix}--slider-text-input.#{$prefix}--text-input--invalid,\n  .#{$prefix}--slider-text-input--warn {\n    inline-size: 6rem;\n    padding-inline-end: $spacing-09;\n  }\n\n  .#{$prefix}--slider__invalid-icon {\n    position: absolute;\n    fill: $support-error;\n    // top/transform used to center invalid icon in IE11\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-05;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--slider__validation-msg.#{$prefix}--form-requirement {\n    display: block;\n    overflow: visible;\n    max-block-size: 100%;\n  }\n\n  .#{$prefix}--slider__validation-msg--invalid {\n    color: $text-error;\n  }\n\n  .#{$prefix}--slider__invalid-icon.#{$prefix}--slider__invalid-icon--warning {\n    fill: $support-warning;\n  }\n\n  .#{$prefix}--slider__invalid-icon--warning path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  // Disabled state\n  .#{$prefix}--label--disabled\n    ~ .#{$prefix}--slider-container\n    > .#{$prefix}--slider__range-label {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--slider--disabled.#{$prefix}--slider {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--slider--disabled .#{$prefix}--slider__thumb {\n    background-color: $border-disabled;\n\n    &:hover {\n      cursor: not-allowed;\n      transform: none;\n    }\n\n    &:focus {\n      background-color: $border-disabled;\n      box-shadow: none;\n      outline: none;\n      transform: none;\n    }\n\n    &:active {\n      background: $border-disabled;\n      box-shadow: none;\n      transform: none;\n    }\n  }\n\n  .#{$prefix}--slider--disabled .#{$prefix}--slider__thumb--lower,\n  .#{$prefix}--slider--disabled .#{$prefix}--slider__thumb--upper {\n    background-color: transparent;\n\n    &:active,\n    &:hover,\n    &:focus {\n      background-color: transparent;\n      transform: none;\n    }\n\n    .#{$prefix}--slider__thumb-icon {\n      fill: $border-disabled;\n    }\n  }\n\n  .#{$prefix}--slider--disabled .#{$prefix}--slider__track,\n  .#{$prefix}--slider--disabled .#{$prefix}--slider__filled-track,\n  .#{$prefix}--slider--disabled\n    .#{$prefix}--slider__thumb:focus\n    ~ .#{$prefix}--slider__filled-track {\n    background-color: $border-disabled;\n  }\n\n  .#{$prefix}--slider--disabled\n    ~ .#{$prefix}--form-item\n    .#{$prefix}--slider-text-input,\n  .#{$prefix}--slider--disabled ~ .#{$prefix}--slider-text-input {\n    border: none;\n    background-color: $field;\n    color: $text-disabled;\n    cursor: not-allowed;\n    transition: none;\n\n    &:active,\n    &:focus,\n    &:hover {\n      color: $text-disabled;\n      outline: none;\n    }\n  }\n\n  // readonly state\n  .#{$prefix}--slider--readonly {\n    cursor: default;\n  }\n\n  .#{$prefix}--slider-container--readonly .#{$prefix}--slider__thumb {\n    block-size: 0;\n    inline-size: 0;\n\n    &::before,\n    &::after {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--slider-container--readonly .#{$prefix}--slider-text-input {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--slider__status-msg.#{$prefix}--form-requirement {\n    display: block;\n    overflow: visible;\n    max-block-size: 100%;\n  }\n\n  // Skeleton state\n  .#{$prefix}--slider-container.#{$prefix}--skeleton\n    .#{$prefix}--slider__range-label {\n    @include skeleton;\n\n    block-size: convert.to-rem(12px);\n    inline-size: convert.to-rem(20px);\n  }\n\n  .#{$prefix}--slider-container.#{$prefix}--skeleton\n    .#{$prefix}--slider__track {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  .#{$prefix}--slider-container.#{$prefix}--skeleton {\n    .#{$prefix}--slider__thumb-wrapper {\n      inset-inline-start: 50%;\n    }\n\n    .#{$prefix}--slider__thumb {\n      cursor: default;\n      pointer-events: none;\n    }\n\n    .#{$prefix}--slider__thumb-wrapper--lower {\n      inset-inline-start: 0;\n    }\n\n    .#{$prefix}--slider__thumb-wrapper--upper {\n      inset-inline-start: 100%;\n    }\n  }\n\n  // With hidden input\n  .#{$prefix}--popover-container.#{$prefix}--slider__thumb-wrapper {\n    position: absolute;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--slider__thumb {\n    @include high-contrast-mode('outline');\n  }\n  .#{$prefix}--slider__thumb:focus {\n    @include high-contrast-mode('focus');\n  }\n  .#{$prefix}--slider__track {\n    @include high-contrast-mode('outline');\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2024\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../theme';\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n\n@keyframes ai-skeleton-animation {\n  0% {\n    transform: translateX(-100%);\n  }\n\n  100% {\n    transform: translateX(100%);\n  }\n}\n\n/// AI Skeleton styles\n/// @access public\n/// @group skeleton\n@mixin ai-skeleton-styles {\n  .#{$prefix}--skeleton__text--ai,\n  .#{$prefix}--skeleton__placeholder--ai,\n  .#{$prefix}--skeleton__icon--ai {\n    overflow: hidden;\n    background: theme.$ai-skeleton-background;\n  }\n\n  .#{$prefix}--skeleton__text--ai::before,\n  .#{$prefix}--skeleton__placeholder--ai::before,\n  .#{$prefix}--skeleton__icon--ai::before {\n    animation: 1250ms ease-in-out ai-skeleton-animation infinite;\n    background: linear-gradient(\n      to right,\n      rgba(theme.get('ai-skeleton-element-background'), 0) 0%,\n      rgba(theme.get('ai-skeleton-element-background'), 0.5) 50%,\n      rgba(theme.get('ai-skeleton-element-background'), 0) 100%\n    );\n  }\n\n  .#{$prefix}--skeleton__placeholder--ai::before,\n  .#{$prefix}--skeleton__icon--ai::before {\n    inline-size: 200%;\n  }\n\n  // //skeleton placeholder\n  .#{$prefix}--skeleton__placeholder--ai {\n    border-radius: convert.to-rem(8px);\n  }\n\n  //skeleton text\n  .#{$prefix}--skeleton__text--ai {\n    border-radius: convert.to-rem(16px);\n  }\n\n  //skeleton icon\n  .#{$prefix}--skeleton__icon--ai {\n    border-radius: convert.to-rem(2px);\n  }\n\n  //High Contrast Mode\n  //Ensure AI Skeleton is visible and animated in Windows HCM\n  @include high-contrast-mode {\n    .#{$prefix}--skeleton__text--ai,\n    .#{$prefix}--skeleton__placeholder--ai,\n    .#{$prefix}--skeleton__icon--ai {\n      background: CanvasText;\n    }\n\n    .#{$prefix}--skeleton__text--ai::before,\n    .#{$prefix}--skeleton__placeholder--ai::before,\n    .#{$prefix}--skeleton__icon--ai::before {\n      background: Canvas;\n    }\n  }\n}\n\n// rgba($ai-skeleton-element-background, 1)\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/convert';\n@use '../../spacing' as *;\n\n/// Skeleton styles\n/// @access public\n/// @group skeleton\n@mixin skeleton-styles {\n  //skeleton icon\n  .#{$prefix}--icon--skeleton {\n    @include skeleton;\n\n    display: inline-block;\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(16px);\n  }\n\n  //skeleton placeholder\n  .#{$prefix}--skeleton__placeholder {\n    @include skeleton;\n\n    block-size: convert.to-rem(100px);\n\n    inline-size: convert.to-rem(100px);\n  }\n\n  //skeleton text\n  .#{$prefix}--skeleton__text {\n    @include skeleton;\n\n    block-size: 1rem;\n\n    inline-size: 100%;\n\n    margin-block-end: $spacing-03;\n  }\n\n  .#{$prefix}--skeleton__heading {\n    block-size: 1.5rem;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'mixins' as *;\n@use 'vars' as *;\n@use '../checkbox';\n@use '../radio-button';\n@use '../../config' as *;\n@use '../../breakpoint' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/text-overflow' as *;\n\n/// Data table core styles\n/// @access public\n/// @group data-table\n@mixin data-table {\n  //----------------------------------------------------------------------------\n  // Container\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table-container {\n    position: relative;\n    // Allow space for focus styles\n    padding-block-start: $spacing-01;\n  }\n\n  .#{$prefix}--data-table-content {\n    display: block;\n    overflow-x: auto;\n  }\n\n  .#{$prefix}--data-table-content:focus {\n    @include focus-outline('outline');\n  }\n\n  //----------------------------------------------------------------------------\n  // Container, full table ai\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table-container--ai-enabled {\n    position: relative;\n    // Allow for pseudo element to show for gradient border effect\n    padding: 1px;\n    border: none;\n  }\n\n  .#{$prefix}--data-table-container--ai-enabled::after {\n    position: absolute;\n    z-index: -1;\n    // Used for gradient border effect\n    background-image: linear-gradient(to top, $ai-border-end, $ai-border-start);\n    block-size: 100%;\n    content: '';\n    inline-size: 100%;\n    inset: 0;\n    pointer-events: none;\n  }\n\n  .#{$prefix}--data-table-container--ai-enabled tbody {\n    position: relative;\n  }\n\n  .#{$prefix}--data-table-container--ai-enabled tbody::before {\n    position: absolute;\n    block-size: 100%;\n    content: '';\n    inline-size: 100%;\n    inset: 0;\n    // Prevents the pseudo element overlay from obstructing click on elements below the overlay\n    pointer-events: none;\n\n    @include ai-table-gradient('full-table');\n  }\n\n  //----------------------------------------------------------------------------\n  // Table title text\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table-header {\n    background-color: $layer;\n    padding-block: $spacing-05 $spacing-06;\n    padding-inline: $spacing-05;\n  }\n\n  .#{$prefix}--data-table-header.#{$prefix}--data-table-header__with-decorator {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .#{$prefix}--data-table-header.#{$prefix}--data-table-header__with-decorator.#{$prefix}--data-table-header__with-decorator--standalone {\n    justify-content: flex-end;\n  }\n\n  .#{$prefix}--data-table-header__title {\n    @include type-style('heading-03');\n\n    color: $text-primary;\n  }\n\n  .#{$prefix}--data-table-header__description {\n    @include type-style('body-compact-01');\n\n    color: $text-secondary;\n\n    @include breakpoint(md) {\n      max-inline-size: 50ch;\n    }\n\n    @include breakpoint(lg) {\n      max-inline-size: 80ch;\n    }\n  }\n\n  //----------------------------------------------------------------------------\n  // Data table\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--data-table thead {\n    @include type-style('heading-compact-01');\n\n    background-color: $layer-accent;\n  }\n\n  .#{$prefix}--data-table tbody {\n    @include type-style('body-compact-01');\n\n    background-color: $layer;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--data-table tr {\n    border: none;\n    block-size: $spacing-09;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--data-table tbody tr,\n  .#{$prefix}--data-table tbody tr td,\n  .#{$prefix}--data-table tbody tr th {\n    transition: background-color $duration-fast-01 motion(entrance, productive);\n  }\n\n  .#{$prefix}--data-table tbody tr:not([data-child-row]):hover,\n  .#{$prefix}--data-table tbody tr[data-child-row]:hover > td {\n    background-color: $layer-hover;\n  }\n\n  .#{$prefix}--data-table tbody tr:hover td,\n  .#{$prefix}--data-table tbody tr:hover th {\n    border-block-end: 1px solid $layer-hover;\n    border-block-start: 1px solid $layer-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--data-table\n    tr:hover\n    .#{$prefix}--link:not(.#{$prefix}--popover-container .#{$prefix}--link) {\n    color: $link-secondary;\n  }\n\n  .#{$prefix}--data-table\n    tr:hover\n    .#{$prefix}--link--disabled:not(\n      .#{$prefix}--popover-container .#{$prefix}--link\n    ) {\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--data-table th,\n  .#{$prefix}--data-table td {\n    text-align: start;\n    vertical-align: middle;\n  }\n  .#{$prefix}--data-table.#{$prefix}--data-table--top-aligned-body {\n    &.#{$prefix}--data-table--lg\n      tr:not([data-child-row])\n      td:not(.#{$prefix}--table-expand) {\n      padding-block: $spacing-05 $spacing-05;\n\n      &.#{$prefix}--table-column-menu {\n        padding-block-start: $spacing-03;\n      }\n\n      &.#{$prefix}--table-column-checkbox:not(.#{$prefix}--table-column-radio) {\n        padding-block-start: convert.to-rem(13px);\n      }\n    }\n\n    td {\n      vertical-align: top;\n    }\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--top-aligned-header {\n    &.#{$prefix}--data-table--lg\n      th:not(.#{$prefix}--table-expand):not(.#{$prefix}--table-sort__header) {\n      padding-block: $spacing-05 $spacing-05;\n\n      &.#{$prefix}--table-column-menu {\n        padding-block-start: $spacing-03;\n      }\n\n      &.#{$prefix}--table-column-checkbox {\n        padding-block-start: convert.to-rem(13px);\n      }\n    }\n\n    th {\n      vertical-align: top;\n    }\n  }\n\n  .#{$prefix}--data-table th[align='right'],\n  .#{$prefix}--data-table td[align='right'] {\n    text-align: end;\n  }\n\n  .#{$prefix}--data-table th[align='center'],\n  .#{$prefix}--data-table td[align='center'] {\n    text-align: center;\n  }\n\n  .#{$prefix}--data-table th {\n    background-color: $layer-accent;\n    color: $text-primary;\n    padding-inline: $spacing-05 $spacing-05;\n  }\n\n  .#{$prefix}--data-table th:last-of-type {\n    // Do not use `position: relative`, as its behavior is undefined for many table elements: https://www.w3.org/TR/CSS21/visuren.html#propdef-position\n    position: static;\n    inline-size: auto;\n  }\n\n  .#{$prefix}--data-table .#{$prefix}--table-header-label {\n    text-align: start;\n  }\n\n  .#{$prefix}--data-table td,\n  .#{$prefix}--data-table tbody th {\n    border-block-end: 1px solid $border-subtle-01;\n    border-block-start: 1px solid $layer;\n    color: $text-secondary;\n    padding-inline: $spacing-05 $spacing-05;\n\n    + td:first-of-type {\n      padding-inline-start: $spacing-04;\n    }\n  }\n\n  .#{$prefix}--layer-two .#{$prefix}--data-table td,\n  .#{$prefix}--layer-two .#{$prefix}--data-table tbody th {\n    border-block-end: 1px solid $border-subtle-02;\n  }\n\n  .#{$prefix}--layer-three .#{$prefix}--data-table td,\n  .#{$prefix}--layer-three .#{$prefix}--data-table tbody th {\n    border-block-end: 1px solid $border-subtle-03;\n  }\n\n  @supports (-moz-appearance: none) {\n    .#{$prefix}--data-table td {\n      // Fix to show borders in ff\n      background-clip: padding-box;\n    }\n  }\n\n  // Form Control Overrides\n\n  .#{$prefix}--data-table .#{$prefix}--list-box input[role='combobox'],\n  .#{$prefix}--data-table .#{$prefix}--list-box input[type='text'],\n  .#{$prefix}--data-table .#{$prefix}--dropdown,\n  .#{$prefix}--data-table .#{$prefix}--list-box,\n  .#{$prefix}--data-table .#{$prefix}--number input[type='number'],\n  .#{$prefix}--data-table .#{$prefix}--number input[type='text'],\n  .#{$prefix}--data-table .#{$prefix}--number__control-btn::before,\n  .#{$prefix}--data-table .#{$prefix}--number__control-btn::after,\n  .#{$prefix}--data-table .#{$prefix}--text-input,\n  .#{$prefix}--data-table .#{$prefix}--select-input {\n    background-color: $field-02;\n  }\n\n  // Overflow Menu Overrides\n  .#{$prefix}--data-table\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu[aria-expanded='false']:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--data-table\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu[aria-expanded='true']:focus {\n    outline: none;\n  }\n\n  @media screen and (hover: hover),\n    (-ms-high-contrast: active),\n    (-ms-high-contrast: none) {\n    .#{$prefix}--data-table\n      td.#{$prefix}--table-column-menu\n      .#{$prefix}--overflow-menu\n      .#{$prefix}--overflow-menu__icon {\n      opacity: 0;\n    }\n  }\n\n  .#{$prefix}--data-table\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--open\n    .#{$prefix}--overflow-menu__icon {\n    opacity: 1;\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--visible-overflow-menu\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu\n    .#{$prefix}--overflow-menu__icon,\n  .#{$prefix}--data-table\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu:hover\n    .#{$prefix}--overflow-menu__icon,\n  .#{$prefix}--data-table\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu:focus\n    .#{$prefix}--overflow-menu__icon,\n  .#{$prefix}--data-table\n    tr:hover\n    td.#{$prefix}--table-column-menu\n    .#{$prefix}--overflow-menu\n    .#{$prefix}--overflow-menu__icon {\n    opacity: 1;\n  }\n\n  .#{$prefix}--table-row--menu-option\n    .#{$prefix}--overflow-menu-options__btn\n    .#{$prefix}--overflow-menu-options__option-content\n    svg {\n    position: relative;\n    // Used to center svg without setting display flex //display block needed for overflow text truncation\n    inset-block-start: convert.to-rem(3px);\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--data-table .#{$prefix}--overflow-menu,\n  .#{$prefix}--data-table .#{$prefix}--overflow-menu__trigger {\n    &:hover {\n      background-color: $layer-selected-hover;\n    }\n  }\n\n  .#{$prefix}--data-table--selected .#{$prefix}--overflow-menu,\n  .#{$prefix}--data-table--selected .#{$prefix}--overflow-menu__trigger {\n    &:hover {\n      background-color: $layer-hover;\n    }\n  }\n\n  .#{$prefix}--data-table--selected\n    .#{$prefix}--link:not(.#{$prefix}--link--disabled) {\n    color: $link-secondary;\n  }\n\n  .#{$prefix}--data-table--xs td.#{$prefix}--table-column-menu,\n  .#{$prefix}--data-table--sm td.#{$prefix}--table-column-menu {\n    block-size: convert.to-rem(24px);\n    padding-block: 0;\n  }\n\n  .#{$prefix}--data-table--sm td.#{$prefix}--table-column-menu {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--data-table--md td.#{$prefix}--table-column-menu {\n    block-size: convert.to-rem(40px);\n  }\n\n  .#{$prefix}--data-table--xl .#{$prefix}--table-column-menu {\n    padding-block-start: $spacing-03;\n  }\n\n  //----------------------------------------------------------------------------\n  //ZEBRA\n  //----------------------------------------------------------------------------\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:not(.#{$prefix}--parent-row):nth-child(odd)\n    td {\n    border-block-end: 1px solid $layer;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:not(.#{$prefix}--parent-row):nth-child(even)\n    td {\n    border-block-end: 1px solid $layer-accent;\n    border-block-start: 1px solid $layer-accent;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:not(.#{$prefix}--parent-row):not(\n      .#{$prefix}--data-table--selected\n    ):nth-child(even) {\n    background-color: $layer-accent;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:not(.#{$prefix}--parent-row):hover\n    td {\n    border-block-end: 1px solid $layer-hover;\n    border-block-start: 1px solid $layer-hover;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:not(.#{$prefix}--parent-row):not(\n      .#{$prefix}--data-table--selected\n    ):hover {\n    background-color: $layer-hover;\n  }\n\n  //----------------------------------------------------------------------------\n  // Select\n  //----------------------------------------------------------------------------\n  .#{$prefix}--table-column-checkbox .#{$prefix}--checkbox-label {\n    min-block-size: $spacing-06;\n    padding-inline-start: 0;\n  }\n\n  .#{$prefix}--table-column-checkbox .#{$prefix}--checkbox-label::before {\n    margin-block-start: convert.to-rem(2px);\n  }\n\n  .#{$prefix}--table-column-checkbox .#{$prefix}--checkbox-label::after {\n    inset-block-start: convert.to-rem(7.5px);\n  }\n\n  .#{$prefix}--data-table th.#{$prefix}--table-column-checkbox {\n    // Do not use `position: relative`, as its behavior is undefined for many table elements: https://www.w3.org/TR/CSS21/visuren.html#propdef-position\n    position: static;\n    background-color: $layer-accent;\n    inline-size: convert.to-rem(32px);\n    transition: background-color $duration-fast-01 motion(entrance, productive);\n  }\n\n  .#{$prefix}--data-table thead th.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table tbody td.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table tbody td.#{$prefix}--table-expand {\n    min-inline-size: 0;\n  }\n\n  .#{$prefix}--data-table thead th.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table tbody td.#{$prefix}--table-column-checkbox {\n    min-inline-size: 2.5rem;\n    // spacing between checkbox / chevron and next cell should be 8px / 0.5rem\n    padding-inline: 1rem convert.to-rem(4px);\n  }\n\n  .#{$prefix}--data-table thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table tbody td.#{$prefix}--table-expand {\n    block-size: convert.to-rem(32px);\n    inline-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--data-table--xs thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table--xs tbody td.#{$prefix}--table-expand {\n    padding: 0 0 0 0.5rem;\n    block-size: convert.to-rem(24px);\n    inline-size: convert.to-rem(24px);\n  }\n\n  .#{$prefix}--data-table--sm thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table--sm tbody td.#{$prefix}--table-expand {\n    padding: 0;\n    block-size: convert.to-rem(32px);\n    inline-size: convert.to-rem(32px);\n    padding-inline-start: 0.5rem;\n  }\n\n  .#{$prefix}--data-table--md thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table--md tbody td.#{$prefix}--table-expand {\n    padding: convert.to-rem(4px) 0 convert.to-rem(4px) convert.to-rem(8px);\n    block-size: convert.to-rem(40px);\n    inline-size: convert.to-rem(40px);\n  }\n\n  .#{$prefix}--data-table--xl thead th.#{$prefix}--table-expand,\n  .#{$prefix}--data-table--xl tbody td.#{$prefix}--table-expand {\n    block-size: convert.to-rem(64px);\n    padding-block: convert.to-rem(10px) convert.to-rem(22px);\n  }\n\n  .#{$prefix}--data-table--xl .#{$prefix}--table-column-checkbox {\n    padding-block-start: convert.to-rem(13px);\n  }\n\n  .#{$prefix}--data-table--xl .#{$prefix}--table-column-radio {\n    padding-block-start: $spacing-05;\n  }\n\n  //----------------------------------------------------------------------------\n  // Radio\n  //----------------------------------------------------------------------------\n  .#{$prefix}--table-column-radio {\n    inline-size: 48px;\n  }\n\n  .#{$prefix}--table-column-radio .#{$prefix}--radio-button__appearance {\n    margin-inline-end: convert.to-rem(-2px);\n  }\n\n  // default selected row + zebra select - even child\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(odd).#{$prefix}--data-table--selected\n    td,\n  tr.#{$prefix}--data-table--selected td {\n    // Bottom border acts as separator from other rows\n    border-block-end: 1px solid $layer-active;\n    border-block-start: 1px solid $layer-selected;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(odd).#{$prefix}--data-table--selected,\n  tr.#{$prefix}--data-table--selected {\n    background-color: $layer-selected;\n  }\n\n  // First row\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:first-of-type:nth-child(odd).#{$prefix}--data-table--selected\n    td,\n  tr.#{$prefix}--data-table--selected:first-of-type td {\n    // Top border acts as separator from thead\n    border-block-start: 1px solid $border-subtle-selected;\n  }\n\n  // last row + zebra select last\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:last-of-type:nth-child(odd).#{$prefix}--data-table--selected\n    td,\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:last-of-type:nth-child(even).#{$prefix}--data-table--selected\n    td,\n  tr.#{$prefix}--data-table--selected:last-of-type td {\n    border-block-end: 1px solid $layer-selected;\n    // Doesn't need separators\n    border-block-start: 1px solid $layer-selected;\n  }\n\n  // zebra select - odd child\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(even).#{$prefix}--data-table--selected\n    td {\n    border-block-end: 1px solid $layer-active;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(even).#{$prefix}--data-table--selected:hover\n    td {\n    border-block-end: 1px solid $data-table-column-hover;\n  }\n\n  // hover + zebra select - even child\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(odd).#{$prefix}--data-table--selected:hover\n    td,\n  .#{$prefix}--data-table tbody .#{$prefix}--data-table--selected:hover td {\n    border-block-end: 1px solid $data-table-column-hover;\n    border-block-start: 1px solid $data-table-column-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--data-table--zebra\n    tbody\n    tr:nth-child(odd).#{$prefix}--data-table--selected:hover,\n  .#{$prefix}--data-table tbody .#{$prefix}--data-table--selected:hover {\n    background-color: $data-table-column-hover;\n  }\n\n  // selected overflow menu\n  .#{$prefix}--data-table--selected\n    .#{$prefix}--overflow-menu\n    .#{$prefix}--overflow-menu__icon {\n    opacity: 1;\n  }\n\n  //----------------------------------------------------------------------------\n  // Extra Small\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table--xs thead tr,\n  .#{$prefix}--data-table--xs tbody tr,\n  .#{$prefix}--data-table--xs tbody tr th {\n    block-size: convert.to-rem(24px);\n  }\n\n  .#{$prefix}--data-table--xs .#{$prefix}--table-header-label {\n    padding-block: convert.to-rem(2px) convert.to-rem(2px);\n  }\n\n  .#{$prefix}--data-table--xs td,\n  .#{$prefix}--data-table--xs tbody tr th {\n    padding-block: convert.to-rem(2px) convert.to-rem(2px);\n  }\n\n  .#{$prefix}--data-table--xs .#{$prefix}--overflow-menu {\n    block-size: calc(100% + 1px);\n    inline-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--xs:not(\n      .#{$prefix}--data-table--top-aligned-body\n    )\n    td.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table.#{$prefix}--data-table--xs:not(\n      .#{$prefix}--data-table--top-aligned-header\n    )\n    th.#{$prefix}--table-column-checkbox {\n    padding-block: 0;\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--xs\n    .#{$prefix}--table-column-checkbox\n    .#{$prefix}--checkbox-label {\n    block-size: convert.to-rem(23px);\n    // 24px row - 1px border\n    min-block-size: convert.to-rem(23px);\n  }\n\n  //----------------------------------------------------------------------------\n  // Small\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table--sm thead tr,\n  .#{$prefix}--data-table--sm tbody tr,\n  .#{$prefix}--data-table--sm tbody tr th {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--data-table--sm .#{$prefix}--table-header-label {\n    padding-block: convert.to-rem(7px) convert.to-rem(7px);\n  }\n\n  .#{$prefix}--data-table--sm td,\n  .#{$prefix}--data-table--sm tbody tr th,\n  .#{$prefix}--data-table--sm.#{$prefix}--data-table--top-aligned-header\n    th.#{$prefix}--table-column-checkbox {\n    padding-block: convert.to-rem(7px) convert.to-rem(6px);\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--sm:not(\n      .#{$prefix}--data-table--top-aligned-body\n    )\n    td.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table.#{$prefix}--data-table--sm:not(\n      .#{$prefix}--data-table--top-aligned-header\n    )\n    th.#{$prefix}--table-column-checkbox {\n    padding-block: convert.to-rem(3px) convert.to-rem(3px);\n  }\n\n  .#{$prefix}--data-table--sm .#{$prefix}--overflow-menu {\n    block-size: calc(100% + 1px);\n  }\n\n  //----------------------------------------------------------------------------\n  // Medium\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table--md thead tr,\n  .#{$prefix}--data-table--md tbody tr,\n  .#{$prefix}--data-table--md tbody tr th {\n    block-size: convert.to-rem(40px);\n  }\n\n  .#{$prefix}--data-table--md .#{$prefix}--table-header-label,\n  .#{$prefix}--data-table--md.#{$prefix}--data-table--top-aligned-header\n    th.#{$prefix}--table-column-checkbox {\n    padding-block: convert.to-rem(7px) convert.to-rem(7px);\n  }\n\n  .#{$prefix}--data-table--md td,\n  .#{$prefix}--data-table--md tbody tr th {\n    padding-block: convert.to-rem(7px) convert.to-rem(6px);\n  }\n\n  .#{$prefix}--data-table.#{$prefix}--data-table--md:not(\n      .#{$prefix}--data-table--top-aligned-body\n    )\n    td.#{$prefix}--table-column-checkbox,\n  .#{$prefix}--data-table.#{$prefix}--data-table--md:not(\n      .#{$prefix}--data-table--top-aligned-header\n    )\n    th.#{$prefix}--table-column-checkbox {\n    padding-block: convert.to-rem(3px) convert.to-rem(3px);\n  }\n\n  .#{$prefix}--data-table--md .#{$prefix}--table-column-menu {\n    padding-block: convert.to-rem(3px) convert.to-rem(3px);\n  }\n\n  //----------------------------------------------------------------------------\n  // Extra Large\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table--xl thead tr,\n  .#{$prefix}--data-table--xl tbody tr,\n  .#{$prefix}--data-table--xl tbody tr th {\n    block-size: convert.to-rem(64px);\n  }\n\n  .#{$prefix}--data-table--xl .#{$prefix}--table-header-label {\n    padding-block: $spacing-05 $spacing-05;\n  }\n\n  .#{$prefix}--data-table--xl td,\n  .#{$prefix}--data-table--xl tbody tr th {\n    padding-block: $spacing-05 $spacing-05;\n  }\n\n  .#{$prefix}--data-table--xl th,\n  .#{$prefix}--data-table--xl td {\n    vertical-align: top;\n  }\n\n  .#{$prefix}--data-table--xl .#{$prefix}--data-table--cell-secondary-text {\n    @include type-style('label-01');\n  }\n\n  //----------------------------------------------------------------------------\n  // Static\n  //----------------------------------------------------------------------------\n  .#{$prefix}--data-table--static {\n    inline-size: auto;\n  }\n\n  .#{$prefix}--data-table-container--static {\n    inline-size: fit-content;\n  }\n\n  // -------------\n  // Sticky header\n  // -------------\n  .#{$prefix}--data-table_inner-container {\n    background-color: $layer-accent;\n    transform: translateZ(0);\n  }\n\n  .#{$prefix}--data-table--sticky-header {\n    display: block;\n    overflow-y: scroll;\n\n    thead,\n    tbody,\n    tr,\n    th,\n    td {\n      display: flex;\n    }\n\n    thead {\n      position: sticky;\n      z-index: 1;\n      overflow: scroll;\n      inline-size: 100%;\n      inset-block-start: 0;\n      // Hides ie scrollbar\n      -ms-overflow-style: none;\n      will-change: transform;\n    }\n\n    thead tr th {\n      border-block-end: 1px solid $layer-active;\n    }\n\n    tbody {\n      flex-direction: column;\n      // Hides ie scrollbar\n      -ms-overflow-style: none;\n      overflow-x: scroll;\n      will-change: transform;\n    }\n\n    tr.#{$prefix}--parent-row.#{$prefix}--expandable-row {\n      block-size: auto;\n      min-block-size: 3rem;\n    }\n\n    tr.#{$prefix}--expandable-row:not(.#{$prefix}--parent-row) {\n      block-size: auto;\n    }\n\n    .#{$prefix}--table-expand {\n      max-inline-size: convert.to-rem(48px);\n    }\n\n    thead .#{$prefix}--table-expand {\n      align-items: center;\n    }\n\n    .#{$prefix}--parent-row {\n      min-block-size: 3rem;\n    }\n\n    &:not(.#{$prefix}--data-table--xs):not(.#{$prefix}--data-table--xl):not(\n        .#{$prefix}--data-table--sm\n      )\n      td:not(.#{$prefix}--table-column-menu):not(\n        .#{$prefix}--table-column-checkbox\n      ) {\n      padding-block-start: convert.to-rem(14px);\n    }\n\n    // Taken from L125 _data-table-expandable\n    // Used to hide white line when parent row is hovered when child is expanded\n    tr.#{$prefix}--parent-row.#{$prefix}--expandable-row:hover\n      + tr[data-child-row]\n      td {\n      border-block-start: 1px solid $layer-hover;\n    }\n\n    tr.#{$prefix}--expandable-row:last-of-type {\n      overflow: hidden;\n    }\n\n    tr.#{$prefix}--data-table--selected:first-of-type td {\n      border-block-start: none;\n    }\n\n    // Selectable fix\n    thead th.#{$prefix}--table-column-checkbox,\n    tbody tr td.#{$prefix}--table-column-checkbox {\n      align-items: center;\n      inline-size: convert.to-rem(36px);\n      min-inline-size: convert.to-rem(36px);\n    }\n\n    &.#{$prefix}--data-table--xl thead th.#{$prefix}--table-column-checkbox,\n    &.#{$prefix}--data-table--xl td.#{$prefix}--table-column-checkbox {\n      align-items: flex-start;\n    }\n\n    // Overflow fix\n    /* When using sticky header, with a selection element in the first column, we need to set the last item to a fixed width to match the table body. We only want this to happen when the last table header does not have any text */\n    th.#{$prefix}--table-column-checkbox ~ th:last-of-type:empty {\n      max-inline-size: convert.to-rem(64px);\n    }\n\n    th:empty:not(.#{$prefix}--table-expand) {\n      max-inline-size: 2.25rem;\n    }\n\n    td.#{$prefix}--table-column-menu {\n      align-items: center;\n      block-size: auto;\n      padding-block-start: 0;\n    }\n\n    //hides webkit scrollbar\n    thead::-webkit-scrollbar,\n    tbody::-webkit-scrollbar {\n      display: none;\n    }\n\n    /* This is for targeting styles specific to firefox */\n    /* To hide the firefox scrollbar */\n    /* https://sass-lang.com/documentation/breaking-changes/moz-document/ */\n    /* stylelint-disable-next-line at-rule-no-vendor-prefix */\n    @-moz-document url-prefix() {\n      thead,\n      tbody {\n        scrollbar-width: none;\n      }\n    }\n\n    tbody tr:last-of-type {\n      border-block-end: 0;\n    }\n\n    th:not(.#{$prefix}--table-column-checkbox):not(\n        .#{$prefix}--table-column-menu\n      ):not(.#{$prefix}--table-expand):not(.#{$prefix}--table-column-icon),\n    td:not(.#{$prefix}--table-column-checkbox):not(\n        .#{$prefix}--table-column-menu\n      ):not(.#{$prefix}--table-expand):not(.#{$prefix}--table-column-icon) {\n      inline-size: 100%;\n      min-inline-size: 0;\n    }\n\n    &.#{$prefix}--data-table--xs tr:not(.#{$prefix}--expandable-row),\n    &.#{$prefix}--data-table--sm tr:not(.#{$prefix}--expandable-row),\n    &.#{$prefix}--data-table--xl tr:not(.#{$prefix}--expandable-row) {\n      block-size: auto;\n    }\n\n    &.#{$prefix}--data-table--xs tr:not(.#{$prefix}--expandable-row) {\n      min-block-size: convert.to-rem(24px);\n    }\n\n    &.#{$prefix}--data-table--sm tr:not(.#{$prefix}--expandable-row) {\n      min-block-size: convert.to-rem(32px);\n    }\n\n    &.#{$prefix}--data-table--xl tr:not(.#{$prefix}--expandable-row) {\n      min-block-size: convert.to-rem(64px);\n    }\n\n    // Expansion overrides\n    &.#{$prefix}--data-table--xs tr td.#{$prefix}--table-expand {\n      padding-block-start: convert.to-rem(4px);\n    }\n\n    &.#{$prefix}--data-table--sm tr td.#{$prefix}--table-expand {\n      padding-block-start: convert.to-rem(8px);\n    }\n\n    .#{$prefix}--table-header-label {\n      @include text-overflow;\n\n      max-inline-size: calc(100% - 10px);\n      overflow-y: hidden;\n      padding-block: convert.to-rem(15px) 1rem;\n      // Needed to reduce 1px jump when toggling between variations\n    }\n\n    &.#{$prefix}--data-table--xs th .#{$prefix}--table-header-label {\n      padding-block: convert.to-rem(3px) 0;\n    }\n\n    &.#{$prefix}--data-table--sm th .#{$prefix}--table-header-label {\n      padding-block: convert.to-rem(8px) 0;\n    }\n\n    &.#{$prefix}--data-table--xl th .#{$prefix}--table-header-label {\n      padding-block-start: 1rem;\n    }\n\n    &.#{$prefix}--data-table--xl th.#{$prefix}--table-expand {\n      display: flex;\n      align-items: flex-start;\n    }\n\n    &.#{$prefix}--data-table--xs\n      tr.#{$prefix}--parent-row\n      .#{$prefix}--table-column-checkbox,\n    &.#{$prefix}--data-table--sm\n      tr.#{$prefix}--parent-row\n      .#{$prefix}--table-column-checkbox {\n      align-items: flex-start;\n    }\n  }\n\n  @include sticky-header($max-width: 100%);\n\n  // -------------------\n  // with boolean column\n  // -------------------\n  .#{$prefix}--data-table\n    .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper:last-of-type {\n    margin: 0;\n  }\n\n  .#{$prefix}--data-table--xs\n    .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper:last-of-type,\n  .#{$prefix}--data-table--sm\n    .#{$prefix}--form-item.#{$prefix}--checkbox-wrapper:last-of-type {\n    margin: convert.to-rem(-3px) 0;\n  }\n\n  // -------------------\n  // Slug styles\n  // -------------------\n  .#{$prefix}--data-table .#{$prefix}--table-column-slug,\n  .#{$prefix}--data-table .#{$prefix}--table-column-decorator {\n    inline-size: $spacing-05;\n    padding-inline-end: 0;\n  }\n\n  tr.#{$prefix}--data-table--slug-row,\n  tr.#{$prefix}--data-table--slug-row + .#{$prefix}--expandable-row,\n  tr.#{$prefix}--data-table--ai-label-row,\n  tr.#{$prefix}--data-table--ai-label-row + .#{$prefix}--expandable-row {\n    @include ai-table-gradient();\n\n    background-attachment: fixed;\n  }\n\n  .#{$prefix}--data-table--slug-row,\n  .#{$prefix}--data-table--ai-label-row {\n    box-shadow: inset 1px 0 $ai-border-strong;\n  }\n\n  // Remove table cell backgrounds that are overriding gradient background on row\n  .#{$prefix}--data-table\n    tbody\n    tr.#{$prefix}--data-table--ai-label-row:hover\n    td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row:hover\n    + .#{$prefix}--expandable-row[data-child-row]\n    td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row--hover\n    + .#{$prefix}--expandable-row[data-child-row]:hover\n    > td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row--hover\n    > td,\n  tr.#{$prefix}--data-table--selected.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row\n    + tr.#{$prefix}--expandable-row[data-child-row]\n    > td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row:hover\n    td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row:hover\n    td:first-of-type,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected:not(\n      .#{$prefix}--expandable-row\n    ):hover\n    > td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row:hover\n    + tr[data-child-row]\n    > td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row--hover\n    > td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row--hover\n    > td:first-of-type {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--data-table tbody tr.#{$prefix}--data-table--ai-label-row:hover,\n  tr.#{$prefix}--data-table--ai-label-row:hover\n    + .#{$prefix}--expandable-row[data-child-row],\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row--hover\n    + .#{$prefix}--expandable-row[data-child-row]:hover,\n  tr.#{$prefix}--expandable-row--hover.#{$prefix}--data-table--ai-label-row,\n  tr.#{$prefix}--data-table--selected.#{$prefix}--parent-row.#{$prefix}--expandable-row--hover.#{$prefix}--data-table--ai-label-row {\n    @include ai-table-gradient('hover');\n\n    background-attachment: fixed;\n  }\n\n  tr.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--data-table--slug-row,\n  .#{$prefix}--data-table--selected.#{$prefix}--data-table--slug-row,\n  tr.#{$prefix}--data-table--selected.#{$prefix}--data-table--slug-row\n    + .#{$prefix}--expandable-row,\n  tr.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--data-table--ai-label-row,\n  .#{$prefix}--data-table--selected.#{$prefix}--data-table--ai-label-row,\n  tr.#{$prefix}--data-table--selected.#{$prefix}--data-table--ai-label-row\n    + .#{$prefix}--expandable-row {\n    @include ai-table-gradient('selected');\n\n    background-attachment: fixed;\n  }\n\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--data-table--selected td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--data-table--selected:hover\n    td,\n  tbody tr.#{$prefix}--data-table--ai-label-row:hover td,\n  tr.#{$prefix}--data-table--ai-label-row.#{$prefix}--parent-row.#{$prefix}--data-table--selected.#{$prefix}--expandable-row:hover\n    td:not(.#{$prefix}--table-expand):not(\n      .#{$prefix}--table-column-checkbox\n    ):not(.#{$prefix}--table-column-slug) {\n    border-block-end-color: $border-subtle;\n  }\n\n  tr.#{$prefix}--expandable-row.#{$prefix}--data-table--selected.#{$prefix}--data-table--slug-row[data-parent-row]\n    > td:not(.#{$prefix}--table-expand):not(\n      .#{$prefix}--table-column-checkbox\n    ):not(.#{$prefix}--table-column-slug),\n  tr.#{$prefix}--expandable-row.#{$prefix}--data-table--selected.#{$prefix}--data-table--slug-row[data-parent-row]\n    > td:not(.#{$prefix}--table-expand):not(\n      .#{$prefix}--table-column-checkbox\n    ):not(.#{$prefix}--table-column-slug) {\n    border-block-end: 1px solid $layer-selected;\n  }\n\n  tr.#{$prefix}--parent-row.#{$prefix}--data-table--slug-row.#{$prefix}--expandable-row:hover\n    td:first-of-type,\n  tr.#{$prefix}--parent-row.#{$prefix}--data-table--ai-label-row.#{$prefix}--expandable-row:hover\n    td:first-of-type,\n  tr.#{$prefix}--parent-row.#{$prefix}--data-table--decoratorß-row.#{$prefix}--expandable-row:hover\n    td:first-of-type {\n    border-block-end: 1px solid transparent;\n  }\n\n  .#{$prefix}--data-table\n    thead\n    th.#{$prefix}--table-sort__header--slug\n    .#{$prefix}--table-sort,\n  .#{$prefix}--data-table thead th:has(> .#{$prefix}--table-header-label--slug),\n  .#{$prefix}--data-table\n    thead\n    th.#{$prefix}--table-sort__header--ai-label\n    .#{$prefix}--table-sort,\n  .#{$prefix}--data-table\n    thead\n    th:has(> .#{$prefix}--table-header-label--ai-label) {\n    @include ai-table-gradient();\n  }\n\n  .#{$prefix}--table-column-slug .#{$prefix}--ai-label,\n  .#{$prefix}--table-column-slug .#{$prefix}--slug,\n  .#{$prefix}--table-column-decorator .#{$prefix}--decorator {\n    position: absolute;\n    z-index: 2;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--data-table--xl\n    .#{$prefix}--table-column-slug\n    .#{$prefix}--ai-label,\n  .#{$prefix}--data-table--xl .#{$prefix}--table-column-slug .#{$prefix}--slug,\n  .#{$prefix}--data-table--xl\n    .#{$prefix}--table-column-decorator\n    .#{$prefix}--decorator {\n    transform: translateY(1px);\n  }\n\n  // AILabel inside header styles\n  th .#{$prefix}--table-header-label.#{$prefix}--table-header-label--slug,\n  th .#{$prefix}--table-header-label.#{$prefix}--table-header-label--ai-label,\n  th .#{$prefix}--table-header-label.#{$prefix}--table-header-label--decorator {\n    display: flex;\n    align-items: center;\n  }\n\n  th\n    .#{$prefix}--table-header-label.#{$prefix}--table-header-label--ai-label\n    .#{$prefix}--ai-label,\n  th\n    .#{$prefix}--table-header-label.#{$prefix}--table-header-label--ai-label\n    .#{$prefix}--slug,\n  th\n    .#{$prefix}--table-header-label.#{$prefix}--table-header-label--decorator\n    .#{$prefix}--table-header-label--decorator-inner,\n  th\n    .#{$prefix}--table-header-label.#{$prefix}--table-header-label--ai-label\n    .#{$prefix}--table-header-label--decorator-inner {\n    margin-inline-start: auto;\n  }\n\n  th.#{$prefix}--table-sort__header--slug,\n  th:has(.#{$prefix}--table-header-label--slug),\n  th.#{$prefix}--table-sort__header--ai-label,\n  th:has(.#{$prefix}--table-header-label--ai-label) {\n    box-shadow: inset 0 1px $ai-border-strong;\n  }\n\n  td.#{$prefix}--table-cell--column-slug {\n    @include ai-table-gradient();\n  }\n\n  tr.#{$prefix}--parent-row:not(.#{$prefix}--expandable-row):not(:first-of-type)\n    td.#{$prefix}--table-cell--column-slug {\n    // Same gradient as background\n    border-block-start: linear-gradient(\n      to right,\n      $ai-aura-start-sm 0%,\n      $ai-aura-end 50%,\n      transparent 50%\n    );\n  }\n\n  tr.#{$prefix}--parent-row:not(.#{$prefix}--expandable-row):not(:first-of-type)\n    td.#{$prefix}--table-cell--column-slug,\n\n  // Windows HCM fix\n\n  .#{$prefix}--data-table-content {\n    @include high-contrast-mode('outline');\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n/// Adds text overflow styling\n/// @access public\n/// @param {Number} $width [false] - Value of width if you want to set width, else nothing\n/// @example @include text-overflow(300px);\n/// @group utilities\n@mixin text-overflow($width: false) {\n  display: block;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  // apply a width if width parameter exists\n  @if ($width) {\n    inline-size: $width;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use '../../config' as *;\n@use '../../utilities/convert';\n\n// @access public\n// @content Includes a block of styles for sticky data tables that sets table max-width, max-height and column min-width\n// @example - @include sticky-header($max-height: to-rem(900px), $min-width: to-rem(30px));\n// @param {value} $max-width [100%] - sets the max-width of the data table parent container\n// @param {value} $max-height [rem(300px)] - sets the max-height of the data table\n// @param {value} $min-width [rem(100px)] - sets the min-width of th's and td's so their sizes align\n@mixin sticky-header(\n  $min-width: false,\n  $max-width: 100%,\n  $max-height: convert.to-rem(300px)\n) {\n  .#{$prefix}--data-table--max-width {\n    max-inline-size: $max-width;\n  }\n\n  .#{$prefix}--data-table--sticky-header {\n    max-block-size: $max-height;\n\n    @if $min-width {\n      th:not(.#{$prefix}--table-column-checkbox):not(\n          .#{$prefix}--table-column-menu\n        ):not(.#{$prefix}--table-expand):not(.#{$prefix}--table-column-icon),\n      td:not(.#{$prefix}--table-column-checkbox):not(\n          .#{$prefix}--table-column-menu\n        ):not(.#{$prefix}--table-expand):not(.#{$prefix}--table-column-icon) {\n        min-inline-size: $min-width;\n      }\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../button';\n@use '../../overflow-menu';\n@use '../../search';\n@use '../../../config' as *;\n@use '../../../motion' as *;\n@use '../../../spacing' as *;\n@use '../../../theme' as *;\n@use '../../../type' as *;\n@use '../../../utilities/button-reset';\n@use '../../../utilities/convert';\n@use '../../../utilities/focus-outline' as *;\n\n/// Data table action styles\n/// @access public\n/// @group data-table\n@mixin data-table-action {\n  //-------------------------------------------------\n  //TOOLBAR\n  //-------------------------------------------------\n  .#{$prefix}--table-toolbar {\n    // Need for batch actions\n    position: relative;\n    z-index: 1;\n    display: flex;\n    background-color: $layer;\n    inline-size: 100%;\n    min-block-size: $spacing-09;\n  }\n\n  .#{$prefix}--toolbar-content {\n    display: flex;\n    justify-content: flex-end;\n    block-size: $spacing-09;\n    inline-size: 100%;\n    transform: translate3d(0, 0, 0);\n    transition:\n      transform $duration-fast-02 motion(standard, productive),\n      clip-path $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--toolbar-content .#{$prefix}--search .#{$prefix}--search-input {\n    padding: 0 3rem;\n    // For toolbar animation with (esp.) persistent search box\n    background-color: transparent;\n    block-size: 3rem;\n  }\n\n  .#{$prefix}--toolbar-content .#{$prefix}--overflow-menu {\n    block-size: 3rem;\n    inline-size: 3rem;\n  }\n\n  //-------------------------------------------------\n  //DEPRECATED v10/v9 search behavior\n  //-------------------------------------------------\n  .#{$prefix}--batch-actions ~ .#{$prefix}--toolbar-search-container {\n    display: flex;\n    align-items: center;\n    opacity: 1;\n    transition: opacity 110ms;\n  }\n\n  //-------------------------------------------------\n  //HIDDEN SEARCH - DEFAULT TOOLBAR\n  //-------------------------------------------------\n  .#{$prefix}--toolbar-search-container-expandable {\n    position: relative;\n    block-size: $spacing-09;\n    box-shadow: none;\n    cursor: pointer;\n    inline-size: $spacing-09;\n    transition:\n      width $transition-expansion $standard-easing,\n      background-color $duration-fast-02 motion(entrance, productive);\n\n    &:hover {\n      background-color: $field-hover;\n    }\n  }\n\n  .#{$prefix}--search.#{$prefix}--toolbar-search-container-expandable {\n    inline-size: 3rem;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable .#{$prefix}--search-input {\n    block-size: 100%;\n    cursor: pointer;\n    opacity: 0;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable:not(\n      .#{$prefix}--toolbar-search-container-active\n    )\n    .#{$prefix}--search-input {\n    padding: 0;\n  }\n\n  .#{$prefix}--toolbar-search-container-disabled .#{$prefix}--search-input {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable.#{$prefix}--search\n    .#{$prefix}--label {\n    visibility: hidden;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable.#{$prefix}--search\n    .#{$prefix}--search-close {\n    block-size: $spacing-09;\n    inline-size: $spacing-09;\n\n    &::before {\n      background-color: $field-hover;\n      block-size: calc(100% - #{convert.to-rem(4px)});\n      inset-block-start: convert.to-rem(2px);\n    }\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable.#{$prefix}--search\n    .#{$prefix}--search-close:focus::before {\n    background-color: $focus;\n  }\n\n  //-------------------------------------------------\n  // Seach icon\n  //-------------------------------------------------v\n  // lg expandable icon spacing\n  .#{$prefix}--table-toolbar\n    .#{$prefix}--search--lg\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: 0;\n  }\n\n  // lg persistent icon spacing\n  .#{$prefix}--table-toolbar:not(.#{$prefix}--table-toolbar--sm)\n    .#{$prefix}--toolbar-search-container-persistent.#{$prefix}--search--lg\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: 1rem;\n  }\n\n  // sm expandable icon spacing\n  .#{$prefix}--table-toolbar.#{$prefix}--table-toolbar--sm\n    .#{$prefix}--search--sm:not(\n      .#{$prefix}--toolbar-search-container-active\n    ):not(.#{$prefix}--toolbar-search-container-persistent)\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--table-toolbar.#{$prefix}--table-toolbar--sm\n    .#{$prefix}--search--sm.#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: 0.5rem;\n  }\n\n  // sm persistent icon spacing\n  .#{$prefix}--table-toolbar\n    .#{$prefix}--toolbar-search-container-persistent.#{$prefix}--search--sm\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: 0.5rem;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable\n    .#{$prefix}--search-magnifier-icon {\n    padding: $spacing-05;\n    block-size: $spacing-09;\n    inline-size: $spacing-09;\n  }\n\n  .#{$prefix}--toolbar-search-container-expandable.#{$prefix}--search--disabled\n    .#{$prefix}--search-magnifier-icon {\n    background-color: $layer;\n    cursor: not-allowed;\n    transition: background-color none;\n  }\n\n  .#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-magnifier-icon:focus,\n  .#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-magnifier-icon:active,\n  .#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-magnifier-icon:hover {\n    border: none;\n    background-color: transparent;\n    outline: none;\n  }\n\n  //-------------------------------------------------\n  //ACTIVE SEARCH - DEFAULT TOOLBAR\n  //-------------------------------------------------\n\n  .#{$prefix}--toolbar-search-container-active.#{$prefix}--search {\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--toolbar-search-container-active .#{$prefix}--search-input {\n    opacity: 1;\n  }\n\n  .#{$prefix}--toolbar-search-container-active .#{$prefix}--label,\n  .#{$prefix}--toolbar-search-container-active .#{$prefix}--search-input {\n    padding: 0 $spacing-09;\n    cursor: text;\n  }\n\n  .#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-input:focus\n    + .#{$prefix}--search-close {\n    border: none;\n    box-shadow: none;\n    outline: none;\n  }\n\n  .#{$prefix}--toolbar-search-container-active\n    .#{$prefix}--search-input:not(:placeholder-shown) {\n    border: none;\n    background-color: $field-hover;\n  }\n\n  //-------------------------------------------------\n  //SEARCH CLOSE BUTTON\n  //-------------------------------------------------\n  .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search-close,\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-close:hover,\n  .#{$prefix}--toolbar-search-container-active .#{$prefix}--search-close,\n  .#{$prefix}--toolbar-search-container-active .#{$prefix}--search-close:hover {\n    border: none;\n    background-color: transparent;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-close::before {\n    display: none;\n  }\n\n  //-------------------------------------------------\n  //TOOLBAR BUTTONS\n  //-------------------------------------------------\n  .#{$prefix}--overflow-menu.#{$prefix}--toolbar-action {\n    @include button-reset.reset;\n\n    display: flex;\n    padding: $spacing-05;\n    block-size: $spacing-09;\n    cursor: pointer;\n    inline-size: $spacing-09;\n    transition: background $duration-fast-02 motion(entrance, productive);\n  }\n\n  // DEPRECATED prefer .#{$prefix}--overflow-menu.#{$prefix}--toolbar-action instead\n  .#{$prefix}--toolbar-action {\n    @include button-reset.reset;\n\n    display: flex;\n    block-size: $spacing-09;\n    cursor: pointer;\n    inline-size: $spacing-09;\n    transition: background $duration-fast-02 motion(entrance, productive);\n  }\n\n  .#{$prefix}--toolbar-action:hover:not([disabled]) {\n    background-color: $field-hover;\n  }\n\n  .#{$prefix}--toolbar-action[aria-expanded='true'],\n  .#{$prefix}--toolbar-action:hover[aria-expanded='true'] {\n    background-color: $layer-02;\n  }\n\n  .#{$prefix}--toolbar-action[disabled] {\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--toolbar-action[disabled] .#{$prefix}--toolbar-action__icon {\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--toolbar-action:focus:not([disabled]),\n  .#{$prefix}--toolbar-action:active:not([disabled]) {\n    @include focus-outline('outline');\n\n    &.#{$prefix}--toolbar-search-container-expandable {\n      // The focus style is handled by search input in it, need to avoid duplicate animation\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--toolbar-action ~ .#{$prefix}--btn {\n    margin: 0;\n    max-inline-size: none;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--overflow-menu--data-table {\n    block-size: $spacing-09;\n  }\n\n  //-------------------------------------------------\n  //TOOLBAR BUTTON ICONS\n  //-------------------------------------------------\n  .#{$prefix}--toolbar-action__icon {\n    block-size: $spacing-05;\n    fill: $icon-primary;\n    inline-size: auto;\n    max-inline-size: $spacing-05;\n  }\n\n  //-------------------------------------------------\n  //TOOLBAR Menu\n  //-------------------------------------------------\n  .#{$prefix}--toolbar-action__menu,\n  .#{$prefix}--toolbar-action__menu.#{$prefix}--overflow-menu-options::after {\n    background-color: $layer-02;\n  }\n\n  //-------------------------------------------------\n  //PERSISTENT SEARCH - OPTIONAL TOOLBAR\n  //-------------------------------------------------\n  .#{$prefix}--toolbar-search-container-persistent {\n    position: relative;\n    block-size: $spacing-09;\n    inline-size: 100%;\n    opacity: 1;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    + .#{$prefix}--toolbar-content {\n    position: relative;\n    inline-size: auto;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search {\n    position: initial;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-magnifier-icon {\n    inset-inline-start: $spacing-05;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search-input {\n    padding: 0 $spacing-09;\n    border: none;\n    block-size: $spacing-09;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-input:focus:not([disabled]) {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-input:hover:not([disabled]) {\n    background-color: $field-hover;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-input:active:not([disabled]),\n  .#{$prefix}--toolbar-search-container-persistent\n    .#{$prefix}--search-input:not(:placeholder-shown) {\n    background-color: $field-hover;\n  }\n\n  .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search-close {\n    block-size: $spacing-09;\n    inline-size: $spacing-09;\n  }\n\n  .#{$prefix}--batch-actions--active ~ .#{$prefix}--toolbar-search-container,\n  .#{$prefix}--batch-actions--active ~ .#{$prefix}--toolbar-content {\n    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n    transform: translate3d(0, 48px, 0);\n    transition:\n      transform $duration-fast-02 motion(standard, productive),\n      clip-path $duration-fast-02 motion(standard, productive);\n  }\n\n  //-------------------------------------------------\n  //BATCH ACTIONS\n  //-------------------------------------------------\n  .#{$prefix}--batch-actions {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: $background-brand;\n    clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);\n    inset-block-end: 0;\n    inset-inline: 0;\n    opacity: 0;\n    pointer-events: none;\n    transform: translate3d(0, 48px, 0);\n    transition:\n      transform $duration-fast-02 motion(standard, productive),\n      clip-path $duration-fast-02 motion(standard, productive),\n      opacity $duration-fast-02 motion(standard, productive);\n    will-change: transform;\n  }\n\n  .#{$prefix}--batch-actions:focus {\n    @include focus-outline;\n  }\n  // 200% to allow tooltips\n  .#{$prefix}--batch-actions--active {\n    z-index: 1;\n    clip-path: polygon(0 0, 300% 0, 300% 300%, 0 300%);\n    opacity: 1;\n    pointer-events: all;\n    transform: translate3d(0, 0, 0);\n  }\n\n  //btns container\n  .#{$prefix}--action-list {\n    display: flex;\n    align-items: center;\n  }\n\n  .#{$prefix}--action-list .#{$prefix}--btn,\n  .#{$prefix}--batch-summary .#{$prefix}--btn {\n    color: $text-on-color;\n    padding-inline: $spacing-05 $spacing-05;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--action-list .#{$prefix}--btn:disabled {\n    border-color: transparent;\n    background-color: transparent;\n    color: $text-on-color;\n    opacity: 0.5;\n  }\n\n  .#{$prefix}--action-list .#{$prefix}--btn .#{$prefix}--btn__icon {\n    position: static;\n    fill: $icon-on-color;\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--action-list .#{$prefix}--btn .#{$prefix}--btn__icon .st0 {\n    fill: none;\n  }\n\n  .#{$prefix}--batch-download {\n    //makes it smaller to match other icons\n    padding: convert.to-rem(1px);\n  }\n\n  // Override btn styles\n  .#{$prefix}--action-list .#{$prefix}--btn--primary:focus::before,\n  .#{$prefix}--action-list .#{$prefix}--btn--primary::before,\n  .#{$prefix}--action-list .#{$prefix}--btn--primary:focus::after,\n  .#{$prefix}--action-list .#{$prefix}--btn--primary::after {\n    display: none;\n  }\n\n  .#{$prefix}--action-list .#{$prefix}--btn--primary:focus,\n  .#{$prefix}--batch-summary .#{$prefix}--btn--primary:focus {\n    outline: 2px solid $layer;\n    outline-offset: convert.to-rem(-2px);\n  }\n\n  // cancel btn pseudo element\n  .#{$prefix}--action-list\n    .#{$prefix}--btn--primary:nth-child(3):hover\n    + .#{$prefix}--btn--primary.#{$prefix}--batch-summary__cancel::before,\n  .#{$prefix}--action-list\n    .#{$prefix}--btn--primary:nth-child(3):focus\n    + .#{$prefix}--btn--primary.#{$prefix}--batch-summary__cancel::before {\n    opacity: 0;\n  }\n\n  .#{$prefix}--btn--primary.#{$prefix}--batch-summary__cancel::before {\n    position: absolute;\n    display: block;\n    border: none;\n    background-color: $text-on-color;\n    block-size: $spacing-05;\n    content: '';\n    inline-size: convert.to-rem(1px);\n    //visually 16px spacing is 1px too low\n    inset-block-start: convert.to-rem(15px);\n    inset-inline-start: 0;\n    opacity: 1;\n    transition: opacity $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--btn--primary.#{$prefix}--batch-summary__cancel:hover::before {\n    opacity: 0;\n    transition: opacity $transition-base $standard-easing;\n  }\n\n  // items selected text\n  .#{$prefix}--batch-summary {\n    position: sticky;\n    z-index: 100000;\n    display: flex;\n    align-items: center;\n    padding: 0 $spacing-05;\n    background-color: $background-brand;\n\n    color: $text-on-color;\n    inset-inline-start: 0;\n    min-block-size: 3rem;\n  }\n\n  .#{$prefix}--batch-summary__scroll {\n    box-shadow: 0.5px 0 0.2px $link-primary-hover;\n  }\n\n  .#{$prefix}--batch-summary__para {\n    @include type-style('body-compact-01');\n  }\n\n  .#{$prefix}--batch-summary__divider {\n    padding-inline-start: $spacing-03;\n  }\n\n  //-------------------------------------------------\n  //SMALL TOOLBAR\n  //-------------------------------------------------\n\n  .#{$prefix}--table-toolbar--sm {\n    block-size: convert.to-rem(32px);\n    min-block-size: convert.to-rem(32px);\n\n    .#{$prefix}--toolbar-search-container-expandable,\n    .#{$prefix}--toolbar-search-container-persistent {\n      block-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-search-container-expandable .#{$prefix}--search-input,\n    .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search-input {\n      block-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-search-container-expandable .#{$prefix}--search-close,\n    .#{$prefix}--toolbar-search-container-persistent .#{$prefix}--search-close {\n      block-size: convert.to-rem(32px);\n      inline-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-search-container-expandable\n      .#{$prefix}--search-magnifier-icon,\n    .#{$prefix}--toolbar-search-container-persistent\n      .#{$prefix}--search-magnifier-icon {\n      padding: $spacing-03;\n      block-size: convert.to-rem(32px);\n      inline-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-action.#{$prefix}--toolbar-search-container-persistent {\n      inline-size: 100%;\n    }\n\n    //hidden\n    .#{$prefix}--toolbar-search-container-expandable {\n      inline-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-search-container-expandable\n      .#{$prefix}--search\n      .#{$prefix}--search-input {\n      padding: 0 $spacing-09;\n    }\n\n    //active\n    .#{$prefix}--toolbar-search-container-active {\n      flex: auto;\n      transition: flex 175ms $standard-easing;\n    }\n\n    .#{$prefix}--toolbar-search-container-active .#{$prefix}--search-input {\n      visibility: inherit;\n    }\n\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-input:focus {\n      @include focus-outline('outline');\n\n      background-color: $field-hover;\n    }\n\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-input:active,\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-input:not(:placeholder-shown) {\n      background-color: $field-hover;\n    }\n\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-magnifier-icon:focus,\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-magnifier-icon:active,\n    .#{$prefix}--toolbar-search-container-active\n      .#{$prefix}--search-magnifier-icon:hover {\n      @include focus-outline('reset');\n\n      background-color: transparent;\n    }\n\n    .#{$prefix}--overflow-menu.#{$prefix}--toolbar-action {\n      block-size: convert.to-rem(32px);\n      inline-size: convert.to-rem(32px);\n      //:after element is 2rem but w/o this trigger button is for some reason 28px\n      min-inline-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-content {\n      block-size: convert.to-rem(32px);\n    }\n\n    .#{$prefix}--toolbar-content .#{$prefix}--overflow-menu {\n      block-size: 2rem;\n      inline-size: 2rem;\n    }\n  }\n\n  .#{$prefix}--search--disabled .#{$prefix}--search-magnifier-icon:hover {\n    background-color: transparent;\n  }\n\n  //-------------------------------------------------\n  // SMALL BATCH ACTIONS\n  //-------------------------------------------------\n\n  .#{$prefix}--table-toolbar--sm\n    .#{$prefix}--batch-actions\n    .#{$prefix}--action-list {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--table-toolbar--sm .#{$prefix}--toolbar-action {\n    padding: $spacing-03 0;\n    block-size: convert.to-rem(32px);\n    inline-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--table-toolbar--sm .#{$prefix}--btn--primary {\n    block-size: convert.to-rem(32px);\n    min-block-size: auto;\n    padding-block: 0.375rem;\n  }\n\n  .#{$prefix}--table-toolbar--sm\n    .#{$prefix}--btn--primary.#{$prefix}--batch-summary__cancel::before {\n    inset-block-start: convert.to-rem(8px);\n  }\n\n  .#{$prefix}--table-toolbar--sm\n    .#{$prefix}--toolbar-action\n    ~ .#{$prefix}--btn {\n    overflow: hidden;\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--table-toolbar--sm .#{$prefix}--batch-summary {\n    min-block-size: 2rem;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../colors' as *;\n@use './tokens' as *;\n\n/// icon-indicator styles\n/// @access public\n/// @group tag\n@mixin icon-indicator {\n  .#{$prefix}--icon-indicator {\n    @include type-style('body-compact-01');\n\n    display: flex;\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--icon-indicator svg {\n    align-self: center;\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--icon-indicator--20 {\n    @include type-style('body-compact-02');\n  }\n\n  .#{$prefix}--icon-indicator--failed {\n    fill: $status-red;\n  }\n\n  .#{$prefix}--icon-indicator--caution-major {\n    fill: $status-orange;\n\n    path:first-of-type {\n      fill: $black;\n    }\n  }\n\n  .#{$prefix}--icon-indicator--caution-minor {\n    fill: $status-yellow;\n\n    path:first-of-type {\n      fill: $black;\n    }\n  }\n\n  .#{$prefix}--icon-indicator--undefined {\n    fill: $status-purple;\n  }\n\n  .#{$prefix}--icon-indicator--succeeded {\n    fill: $status-green;\n  }\n\n  .#{$prefix}--icon-indicator--normal {\n    fill: $status-blue;\n  }\n\n  .#{$prefix}--icon-indicator--in-progress {\n    fill: $status-blue;\n  }\n\n  .#{$prefix}--icon-indicator--incomplete {\n    fill: $status-blue;\n  }\n\n  .#{$prefix}--icon-indicator--not-started {\n    fill: $status-gray;\n  }\n\n  .#{$prefix}--icon-indicator--pending {\n    fill: $status-gray;\n  }\n\n  .#{$prefix}--icon-indicator--unknown {\n    fill: $status-gray;\n  }\n\n  .#{$prefix}--icon-indicator--informative {\n    fill: $status-blue;\n  }\n}\n","//\n// Copyright IBM Corp. 2020\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:color';\n@use 'sass:map';\n@use '../../config';\n@use '../../colors';\n@use '../../themes';\n@use '../../theme' as *;\n@use '../../utilities/component-tokens';\n@use '@carbon/themes/scss/component-tokens' as status;\n\n// status-red\n$status-red: (\n  fallback: map.get(status.$status-red, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-red, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-red, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-red, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-red, g-100),\n    ),\n  ),\n) !default;\n\n// status-orange\n$status-orange: (\n  fallback: map.get(status.$status-orange, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-orange, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-orange, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-orange, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-orange, g-100),\n    ),\n  ),\n) !default;\n\n// status-orange-outline\n$status-orange-outline: (\n  fallback: map.get(status.$status-orange-outline, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-orange-outline, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-orange-outline, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-orange, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-orange, g-100),\n    ),\n  ),\n) !default;\n\n// status-yellow\n$status-yellow: (\n  fallback: map.get(status.$status-yellow, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-yellow, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-yellow, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-yellow, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-yellow, g-100),\n    ),\n  ),\n) !default;\n\n// status-yellow-outline\n$status-yellow-outline: (\n  fallback: map.get(status.$status-yellow-outline, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-yellow-outline, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-yellow-outline, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-yellow, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-yellow, g-100),\n    ),\n  ),\n) !default;\n\n// status-green\n$status-green: (\n  fallback: map.get(status.$status-green, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-green, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-green, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-green, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-green, g-100),\n    ),\n  ),\n) !default;\n\n// status-blue\n$status-blue: (\n  fallback: map.get(status.$status-blue, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-blue, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-blue, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-blue, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-blue, g-100),\n    ),\n  ),\n) !default;\n\n// status-purple\n$status-purple: (\n  fallback: map.get(status.$status-purple, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-purple, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-purple, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-purple, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-purple, g-100),\n    ),\n  ),\n) !default;\n\n// status-gray\n$status-gray: (\n  fallback: map.get(status.$status-gray, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(status.$status-gray, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(status.$status-gray, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(status.$status-gray, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(status.$status-gray, g-100),\n    ),\n  ),\n) !default;\n\n// Add to $status-tokens map\n$status-tokens: (\n  status-red: $status-red,\n  status-orange: $status-orange,\n  status-orange-outline: $status-orange-outline,\n  status-yellow: $status-yellow,\n  status-yellow-outline: $status-yellow-outline,\n  status-green: $status-green,\n  status-blue: $status-blue,\n  status-purple: $status-purple,\n  status-gray: $status-gray,\n);\n\n// Generate CSS custom properties for each token\n$status-red: component-tokens.get-var($status-red, 'status-red');\n$status-orange: component-tokens.get-var($status-orange, 'status-orange');\n$status-orange-outline: component-tokens.get-var(\n  $status-orange-outline,\n  'status-orange-outline'\n);\n$status-yellow: component-tokens.get-var($status-yellow, 'status-yellow');\n$status-yellow-outline: component-tokens.get-var(\n  $status-yellow-outline,\n  'status-yellow-outline'\n);\n$status-green: component-tokens.get-var($status-green, 'status-green');\n$status-blue: component-tokens.get-var($status-blue, 'status-blue');\n$status-purple: component-tokens.get-var($status-purple, 'status-purple');\n$status-gray: component-tokens.get-var($status-gray, 'status-gray');\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../colors' as *;\n@use '../icon-indicator/tokens' as *;\n\n/// shape-indicator styles\n/// @access public\n/// @group tag\n@mixin shape-indicator {\n  .#{$prefix}--shape-indicator {\n    @include type-style('helper-text-01');\n\n    display: flex;\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--shape-indicator svg {\n    align-self: center;\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--shape-indicator--14 {\n    @include type-style('body-compact-01');\n  }\n\n  .#{$prefix}--shape-indicator--failed {\n    fill: $status-red;\n  }\n\n  .#{$prefix}--shape-indicator--critical {\n    fill: $status-red;\n  }\n\n  .#{$prefix}--shape-indicator--high {\n    fill: $status-red;\n  }\n\n  .#{$prefix}--shape-indicator--medium {\n    fill: $status-orange;\n\n    path:first-of-type {\n      fill: $status-orange-outline;\n    }\n  }\n\n  .#{$prefix}--shape-indicator--low {\n    fill: $status-yellow;\n\n    path:nth-of-type(2) {\n      fill: $status-yellow-outline;\n    }\n  }\n\n  .#{$prefix}--shape-indicator--cautious {\n    fill: $status-yellow;\n\n    path:first-of-type {\n      fill: $status-yellow-outline;\n    }\n  }\n\n  .#{$prefix}--shape-indicator--undefined {\n    fill: $status-purple;\n  }\n\n  .#{$prefix}--shape-indicator--stable {\n    fill: $status-green;\n  }\n\n  .#{$prefix}--shape-indicator--informative {\n    fill: $status-blue;\n  }\n\n  .#{$prefix}--shape-indicator--incomplete {\n    path:nth-of-type(2) {\n      fill: $status-blue;\n    }\n  }\n\n  .#{$prefix}--shape-indicator--draft {\n    fill: $status-gray;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../overflow-menu';\n@use '../../config' as *;\n@use '../../breakpoint' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/skeleton' as *;\n\n@mixin breadcrumb {\n  .#{$prefix}--breadcrumb {\n    @include component-reset.reset;\n    @include type-style('body-compact-01');\n\n    display: inline;\n\n    @include breakpoint(md) {\n      display: flex;\n      flex-wrap: wrap;\n    }\n  }\n\n  .#{$prefix}--breadcrumb--sm {\n    @include type-style('label-01');\n  }\n\n  .#{$prefix}--breadcrumb .#{$prefix}--link {\n    font: inherit;\n  }\n\n  .#{$prefix}--breadcrumb-item {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--breadcrumb--sm .#{$prefix}--breadcrumb-item {\n    margin-inline-end: $spacing-02;\n  }\n\n  .#{$prefix}--breadcrumb--sm .#{$prefix}--breadcrumb-item .#{$prefix}--link {\n    justify-content: center;\n    min-inline-size: $spacing-04;\n  }\n\n  .#{$prefix}--breadcrumb-item .#{$prefix}--link:visited {\n    color: $link-primary;\n\n    &:hover {\n      color: $link-primary-hover;\n    }\n  }\n\n  .#{$prefix}--breadcrumb-item .#{$prefix}--link:active,\n  .#{$prefix}--breadcrumb-item .#{$prefix}--link:visited:active:hover {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--breadcrumb-item::after {\n    color: $text-primary;\n    content: '/';\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--breadcrumb--sm .#{$prefix}--breadcrumb-item::after {\n    margin-inline-start: $spacing-02;\n  }\n\n  .#{$prefix}--breadcrumb--no-trailing-slash\n    .#{$prefix}--breadcrumb-item:last-child::after {\n    content: '';\n  }\n\n  .#{$prefix}--breadcrumb-item:last-child,\n  .#{$prefix}--breadcrumb-item:last-child::after {\n    margin-inline-end: 0;\n  }\n\n  .#{$prefix}--breadcrumb .#{$prefix}--link {\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--breadcrumb-item [aria-current='page'],\n  .#{$prefix}--breadcrumb-item.#{$prefix}--breadcrumb-item--current\n    .#{$prefix}--link {\n    color: $text-primary;\n    cursor: auto;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n\n  // Overflow Menu overrides\n  .#{$prefix}--breadcrumb-item .#{$prefix}--overflow-menu {\n    position: relative;\n    block-size: convert.to-rem(18px);\n    inline-size: $spacing-05;\n\n    &:focus {\n      border: none;\n      box-shadow: none;\n      outline: 1px solid $focus;\n      outline-offset: 0;\n    }\n\n    &:hover {\n      background: transparent;\n\n      &::after {\n        background: $link-primary-hover;\n      }\n    }\n\n    &:active {\n      &::after {\n        background: $text-primary;\n      }\n    }\n\n    &:focus,\n    &:hover {\n      &::after {\n        opacity: 1;\n      }\n    }\n\n    // Used to mimic link underline\n    &::after {\n      position: absolute;\n      background: $focus;\n      block-size: 1px;\n      content: '';\n      inline-size: convert.to-rem(12px);\n      inset-block-end: 2px;\n      opacity: 0;\n      transition: opacity $duration-fast-01 motion(standard, productive);\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n\n  .#{$prefix}--breadcrumb-item\n    .#{$prefix}--overflow-menu.#{$prefix}--overflow-menu--open {\n    background: transparent;\n    box-shadow: none;\n  }\n\n  .#{$prefix}--breadcrumb-item\n    .#{$prefix}--overflow-menu\n    .#{$prefix}--overflow-menu__icon {\n    position: relative;\n    fill: $link-primary;\n    transform: translateY(4px);\n  }\n\n  .#{$prefix}--breadcrumb-item\n    .#{$prefix}--overflow-menu:hover\n    .#{$prefix}--overflow-menu__icon {\n    fill: $link-primary-hover;\n  }\n\n  .#{$prefix}--breadcrumb-item\n    .#{$prefix}--overflow-menu:active\n    .#{$prefix}--overflow-menu__icon {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--breadcrumb-menu-options:focus {\n    outline: none;\n  }\n\n  $caret-size: convert.to-rem(7px);\n  .#{$prefix}--breadcrumb-menu-options.#{$prefix}--overflow-menu-options::after {\n    margin: 0 auto;\n    background: transparent;\n    block-size: 0;\n    border-block-end: $caret-size solid $field;\n    border-inline-end: $caret-size solid transparent;\n    border-inline-start: $caret-size solid transparent;\n    inline-size: 0;\n    inset-block-start: -$caret-size;\n    inset-inline-start: $caret-size * 2;\n  }\n\n  [dir='rtl']\n    .#{$prefix}--breadcrumb-menu-options.#{$prefix}--overflow-menu-options::after {\n    inset-inline-end: $caret-size * 2;\n    inset-inline-start: initial;\n  }\n\n  .#{$prefix}--breadcrumb\n    .#{$prefix}--overflow-menu.#{$prefix}--btn--icon-only {\n    min-block-size: 1.125rem;\n    padding-inline: 0;\n  }\n\n  .#{$prefix}--breadcrumb--sm\n    .#{$prefix}--breadcrumb-item\n    .#{$prefix}--overflow-menu {\n    block-size: $spacing-05;\n    inline-size: $spacing-05;\n    min-block-size: $spacing-05;\n    .#{$prefix}--overflow-menu__icon {\n      transform: translateY(3px);\n    }\n  }\n\n  // Skeleton State\n  .#{$prefix}--breadcrumb.#{$prefix}--skeleton .#{$prefix}--link {\n    @include skeleton;\n\n    block-size: 1rem;\n    inline-size: convert.to-rem(100px);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2026\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type';\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/custom-property';\n@use '../../utilities/focus-outline' as *;\n\n$link-text-color: custom-property.get-var('link-text-color', $link-primary);\n$link-hover-text-color: custom-property.get-var(\n  'link-hover-text-color',\n  $link-primary-hover\n);\n$link-visited-text-color: custom-property.get-var(\n  'link-visited-text-color',\n  $link-visited\n);\n$link-focus-text-color: custom-property.get-var(\n  'link-focus-text-color',\n  $focus\n);\n\n/// Link styles\n/// @access public\n/// @group link\n@mixin link {\n  .#{$prefix}--link {\n    @include component-reset.reset;\n    @include type.type-style('body-compact-01');\n\n    display: inline;\n    color: $link-text-color;\n    outline: none;\n    text-decoration: none;\n    transition: color $duration-fast-01 motion(standard, productive);\n\n    &:hover {\n      color: $link-hover-text-color;\n      text-decoration: underline;\n    }\n\n    &:active:not(.#{$prefix}--link--disabled),\n    &:active:visited,\n    &:active:visited:hover {\n      @include focus-outline;\n\n      color: $link-text-color;\n      outline-color: $link-focus-text-color;\n      text-decoration: underline;\n    }\n\n    &:focus:not(.#{$prefix}--link--disabled) {\n      @include focus-outline;\n\n      outline-color: $link-focus-text-color;\n      text-decoration: underline;\n    }\n\n    &:visited {\n      color: $link-text-color;\n    }\n\n    &:visited:hover {\n      color: $link-hover-text-color;\n    }\n  }\n\n  .#{$prefix}--link--disabled,\n  .#{$prefix}--link--disabled:hover {\n    @include component-reset.reset;\n    @include type.type-style('body-compact-01');\n\n    color: $text-disabled;\n    cursor: not-allowed;\n    font-weight: 400;\n    text-decoration: none;\n  }\n\n  .#{$prefix}--link.#{$prefix}--link--visited,\n  .#{$prefix}--link.#{$prefix}--link--visited:visited {\n    color: $link-visited-text-color;\n  }\n\n  .#{$prefix}--link.#{$prefix}--link--visited:hover,\n  .#{$prefix}--link.#{$prefix}--link--visited:visited:hover {\n    color: $link-hover-text-color;\n  }\n\n  .#{$prefix}--link.#{$prefix}--link--inline {\n    display: inline;\n    text-decoration: underline;\n  }\n\n  .#{$prefix}--link--disabled.#{$prefix}--link--inline {\n    text-decoration: underline;\n  }\n\n  .#{$prefix}--link--sm,\n  .#{$prefix}--link--sm.#{$prefix}--link--disabled:hover {\n    @include type.type-style('helper-text-01');\n  }\n\n  .#{$prefix}--link--lg,\n  .#{$prefix}--link--lg.#{$prefix}--link--disabled:hover {\n    @include type.type-style('body-compact-02');\n  }\n\n  .#{$prefix}--link__icon {\n    display: inline-flex;\n    align-items: center;\n    block-size: 1lh;\n    line-height: inherit;\n    margin-inline-start: $spacing-03;\n    vertical-align: text-bottom;\n  }\n\n  // Large icon size\n  .#{$prefix}--link--lg .#{$prefix}--link__icon > svg {\n    block-size: convert.to-rem(20px);\n    inline-size: convert.to-rem(20px);\n  }\n\n  // For large links, set block-size to match icon size to prevent misalignment\n  .#{$prefix}--link--lg .#{$prefix}--link__icon {\n    block-size: convert.to-rem(20px);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use 'mixins' as *;\n@use '../../breakpoint' as *;\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../feature-flags';\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../themes' as *;\n@use '../../type' as *;\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/focus-outline' as *;\n@use './tokens' as *;\n\n/// Inline notification base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-base {\n  @include reset;\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  block-size: auto;\n\n  color: $text-inverse;\n  inline-size: 100%;\n  max-inline-size: convert.to-rem(288px);\n  min-block-size: convert.to-rem(48px);\n  min-inline-size: convert.to-rem(288px);\n\n  @include breakpoint(md) {\n    flex-wrap: nowrap;\n    max-inline-size: convert.to-rem(608px);\n  }\n\n  @include breakpoint(lg) {\n    max-inline-size: convert.to-rem(736px);\n  }\n\n  @include breakpoint(max) {\n    max-inline-size: convert.to-rem(832px);\n  }\n}\n\n/// Inline notification low contrast ::before styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-before {\n  position: absolute;\n  box-sizing: border-box;\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  block-size: 100%;\n  content: '';\n  filter: opacity(0.4);\n  inline-size: 100%;\n  inset-block-start: 0;\n  inset-inline-start: 0;\n  pointer-events: none;\n}\n\n/// Inline notification low-contrast error variant styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-error {\n  @include notification--experimental(\n    $support-error,\n    $notification-background-error\n  );\n\n  &::before {\n    border-color: $support-error;\n  }\n}\n\n/// Inline notification low-contrast success variant styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-success {\n  @include notification--experimental(\n    $support-success,\n    $notification-background-success\n  );\n\n  &::before {\n    border-color: $support-success;\n  }\n}\n\n/// Inline notification low-contrast info variant styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-info {\n  @include notification--experimental(\n    $support-info,\n    $notification-background-info\n  );\n\n  &::before {\n    border-color: $support-info;\n  }\n}\n\n/// Inline notification low-contrast warning variant styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-warning {\n  @include notification--experimental(\n    $support-warning,\n    $notification-background-warning\n  );\n\n  &::before {\n    border-color: $support-warning;\n  }\n}\n\n/// Inline notification low-contrast base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-low-contrast-base {\n  color: $text-primary;\n\n  .#{$prefix}--inline-notification__close-button:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--inline-notification__close-button\n    .#{$prefix}--inline-notification__close-icon {\n    fill: $icon-primary;\n  }\n\n  &::before {\n    @include inline-notification-low-contrast-before;\n  }\n}\n\n/// Inline notification error variant base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-error-base {\n  @include notification--experimental(\n    $support-error-inverse,\n    $background-inverse\n  );\n}\n\n/// Inline notification success variant base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-success-base {\n  @include notification--experimental(\n    $support-success-inverse,\n    $background-inverse\n  );\n}\n\n/// Inline notification info variant base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-info-base {\n  @include notification--experimental(\n    $support-info-inverse,\n    $background-inverse\n  );\n}\n\n/// Inline notification warning variant base styles\n/// @access public\n/// @group notification\n@mixin inline-notification-warning-base {\n  @include notification--experimental(\n    $support-warning-inverse,\n    $background-inverse\n  );\n}\n\n/// Inline notification styles\n/// @access public\n/// @group notification\n@mixin inline-notification {\n  .#{$prefix}--inline-notification {\n    @include inline-notification-base;\n  }\n\n  .#{$prefix}--inline-notification:not(\n      .#{$prefix}--inline-notification--low-contrast\n    )\n    a {\n    color: $link-inverse;\n  }\n\n  .#{$prefix}--inline-notification a {\n    text-decoration: none;\n  }\n\n  .#{$prefix}--inline-notification a:hover {\n    text-decoration: underline;\n  }\n\n  .#{$prefix}--inline-notification a:focus {\n    outline: 1px solid $link-inverse;\n  }\n\n  .#{$prefix}--inline-notification.#{$prefix}--inline-notification--low-contrast\n    a:focus {\n    @include focus-outline;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast {\n    @include inline-notification-low-contrast-base;\n  }\n\n  .#{$prefix}--inline-notification--error {\n    @include inline-notification-error-base;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--error {\n    @include inline-notification-low-contrast-error;\n  }\n\n  .#{$prefix}--inline-notification--success {\n    @include inline-notification-success-base;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--success {\n    @include inline-notification-low-contrast-success;\n  }\n\n  .#{$prefix}--inline-notification--info,\n  .#{$prefix}--inline-notification--info-square {\n    @include inline-notification-info-base;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--info,\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--info-square {\n    @include inline-notification-low-contrast-info;\n  }\n\n  .#{$prefix}--inline-notification--warning,\n  .#{$prefix}--inline-notification--warning-alt {\n    @include inline-notification-warning-base;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--warning,\n  .#{$prefix}--inline-notification--low-contrast.#{$prefix}--inline-notification--warning-alt {\n    @include inline-notification-low-contrast-warning;\n  }\n\n  .#{$prefix}--inline-notification--warning\n    .#{$prefix}--inline-notification__icon\n    path[opacity='0'],\n  .#{$prefix}--inline-notification--warning-alt\n    .#{$prefix}--inline-notification__icon\n    path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--inline-notification__details {\n    display: flex;\n    flex-grow: 1;\n    margin-inline: convert.to-rem(13px) $spacing-09;\n\n    @include breakpoint(md) {\n      margin: 0 convert.to-rem(13px);\n    }\n  }\n\n  .#{$prefix}--inline-notification__icon {\n    flex-shrink: 0;\n    margin-block-start: convert.to-rem(14px);\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--inline-notification__text-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    padding: convert.to-rem(15px) 0;\n  }\n\n  .#{$prefix}--inline-notification__title {\n    @include type-style('heading-compact-01');\n\n    margin-inline-end: $spacing-02;\n  }\n\n  .#{$prefix}--inline-notification__subtitle {\n    @include type-style('body-compact-01');\n\n    word-break: break-word;\n  }\n\n  .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost {\n    block-size: convert.to-rem(32px);\n    margin-block-end: $spacing-03;\n    margin-inline-start: $spacing-08;\n\n    @include breakpoint(md) {\n      margin: $spacing-03 0;\n    }\n  }\n\n  .#{$prefix}--inline-notification:not(\n      .#{$prefix}--inline-notification--low-contrast\n    )\n    .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost {\n    color: $link-inverse;\n  }\n\n  .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:active,\n  .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:hover {\n    background-color: $background-inverse-hover;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast\n    .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:active,\n  .#{$prefix}--inline-notification--low-contrast\n    .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:hover {\n    background-color: $notification-action-hover;\n  }\n\n  .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:focus {\n    border-color: transparent;\n    box-shadow: none;\n    outline: 2px solid $focus-inverse;\n    outline-offset: -2px;\n  }\n\n  .#{$prefix}--inline-notification--low-contrast\n    .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost:focus {\n    outline-color: $focus;\n  }\n\n  .#{$prefix}--inline-notification--hide-close-button\n    .#{$prefix}--inline-notification__action-button.#{$prefix}--btn--ghost {\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--inline-notification__close-button {\n    @include focus-outline('reset');\n\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    background: transparent;\n    block-size: convert.to-rem(48px);\n    cursor: pointer;\n    inline-size: convert.to-rem(48px);\n    inset-block-start: 0;\n    inset-inline-end: 0;\n    max-inline-size: convert.to-rem(48px);\n    min-inline-size: convert.to-rem(48px);\n    transition:\n      outline $duration-fast-02 motion(standard, productive),\n      background-color $duration-fast-02 motion(standard, productive);\n\n    &:focus {\n      outline: 2px solid $focus-inverse;\n      outline-offset: -2px;\n    }\n\n    .#{$prefix}--inline-notification__close-icon {\n      fill: $icon-inverse;\n    }\n\n    @include breakpoint(md) {\n      position: static;\n    }\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--inline-notification {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--inline-notification__close-button:focus,\n  .#{$prefix}--btn.#{$prefix}--btn--ghost.#{$prefix}--inline-notification__action-button:focus {\n    @include high-contrast-mode('focus');\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n\n/// @access public\n/// @group notification\n@mixin inline-notification--color($color) {\n  border: 1px solid $color;\n  border-inline-start: 6px solid $color;\n\n  .#{$prefix}--inline-notification__icon {\n    fill: $color;\n  }\n}\n\n//----------------------------------------------\n// Toast Notification\n// ---------------------------------------------\n\n/// @access private\n/// @group notification\n@mixin notification--color($color) {\n  border-inline-start: 6px solid $color;\n}\n\n/// @access private\n/// @group notification\n@mixin notification--experimental($color, $background-color) {\n  background: $background-color;\n  border-inline-start: 3px solid $color;\n\n  .#{$prefix}--inline-notification__icon,\n  .#{$prefix}--toast-notification__icon,\n  .#{$prefix}--actionable-notification__icon {\n    fill: $color;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:color';\n@use 'sass:map';\n@use 'sass:list';\n@use '../../config';\n@use '../../colors';\n@use '../../themes';\n@use '../../theme';\n@use '../../utilities/component-tokens';\n@use '@carbon/themes/scss/component-tokens' as notification;\n\n@use '../button/tokens' as button-tokens;\n\n$notification-background-error: (\n  fallback: map.get(notification.$notification-background-error, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(notification.$notification-background-error, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-background-error, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(notification.$notification-background-error, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(notification.$notification-background-error, g-100),\n    ),\n  ),\n) !default;\n\n$notification-background-success: (\n  fallback: map.get(notification.$notification-background-success, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(notification.$notification-background-success, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-background-success, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(notification.$notification-background-success, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(notification.$notification-background-success, g-100),\n    ),\n  ),\n) !default;\n\n$notification-background-info: (\n  fallback: map.get(notification.$notification-background-info, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(notification.$notification-background-info, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-background-info, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(notification.$notification-background-info, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(notification.$notification-background-info, g-100),\n    ),\n  ),\n) !default;\n\n$notification-background-warning: (\n  fallback: map.get(notification.$notification-background-warning, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(notification.$notification-background-warning, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-background-warning, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(notification.$notification-background-warning, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(notification.$notification-background-warning, g-100),\n    ),\n  ),\n) !default;\n\n$notification-action-hover: (\n  fallback: map.get(notification.$notification-background-info, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(notification.$notification-action-hover, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-action-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: theme.$layer-hover,\n    ),\n    (\n      theme: themes.$g100,\n      value: theme.$layer-hover,\n    ),\n  ),\n) !default;\n\n$notification-action-tertiary-inverse: (\n  fallback: map.get(button-tokens.$button-tokens, button-tertiary, fallback),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(notification.$notification-action-tertiary-inverse, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(notification.$notification-action-tertiary-inverse, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(notification.$notification-action-tertiary-inverse, g-100),\n    ),\n  ),\n) !default;\n\n$notification-action-tertiary-inverse-active: (\n  fallback:\n    map.get(button-tokens.$button-tokens, button-tertiary-active, fallback),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-active,\n          white-theme\n        ),\n    ),\n    (\n      theme: themes.$g10,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-active, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-active, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-active,\n          g-100\n        ),\n    ),\n  ),\n) !default;\n\n$notification-action-tertiary-inverse-hover: (\n  fallback:\n    map.get(button-tokens.$button-tokens, button-tertiary-hover, fallback),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-hover,\n          white-theme\n        ),\n    ),\n    (\n      theme: themes.$g10,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-hover, g-100),\n    ),\n  ),\n) !default;\n\n$notification-action-tertiary-inverse-text: (\n  fallback:\n    map.get(\n      notification.$notification-action-tertiary-inverse-text,\n      white-theme\n    ),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-text,\n          white-theme\n        ),\n    ),\n    (\n      theme: themes.$g10,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-text, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-text, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value:\n        map.get(notification.$notification-action-tertiary-inverse-text, g-100),\n    ),\n  ),\n) !default;\n\n$notification-action-tertiary-inverse-text-on-color-disabled: (\n  fallback:\n    map.get(\n      notification.$notification-action-tertiary-inverse-text-on-color-disabled,\n      white-theme\n    ),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-text-on-color-disabled,\n          white-theme\n        ),\n    ),\n    (\n      theme: themes.$g10,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-text-on-color-disabled,\n          g-10\n        ),\n    ),\n    (\n      theme: themes.$g90,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-text-on-color-disabled,\n          g-90\n        ),\n    ),\n    (\n      theme: themes.$g100,\n      value:\n        map.get(\n          notification.$notification-action-tertiary-inverse-text-on-color-disabled,\n          g-100\n        ),\n    ),\n  ),\n) !default;\n\n$notification-tokens: (\n  notification-background-error: $notification-background-error,\n  notification-background-success: $notification-background-success,\n  notification-background-info: $notification-background-info,\n  notification-background-warning: $notification-background-warning,\n  notification-action-hover: $notification-action-hover,\n  notification-action-tertiary-inverse: $notification-action-tertiary-inverse,\n  notification-action-tertiary-inverse-active:\n    $notification-action-tertiary-inverse-active,\n  notification-action-tertiary-inverse-hover:\n    $notification-action-tertiary-inverse-hover,\n  notification-action-tertiary-inverse-text:\n    $notification-action-tertiary-inverse-text,\n  notification-action-tertiary-inverse-text-on-color-disabled:\n    $notification-action-tertiary-inverse-text-on-color-disabled,\n);\n\n$notification-background-error: component-tokens.get-var(\n  $notification-background-error,\n  'notification-background-error'\n);\n\n$notification-background-success: component-tokens.get-var(\n  $notification-background-success,\n  'notification-background-success'\n);\n\n$notification-background-info: component-tokens.get-var(\n  $notification-background-info,\n  'notification-background-info'\n);\n\n$notification-background-warning: component-tokens.get-var(\n  $notification-background-warning,\n  'notification-background-warning'\n);\n\n$notification-action-hover: component-tokens.get-var(\n  $notification-action-hover,\n  'notification-action-hover'\n);\n\n$notification-action-tertiary-inverse: component-tokens.get-var(\n  $notification-action-tertiary-inverse,\n  'notification-action-tertiary-inverse'\n);\n\n$notification-action-tertiary-inverse-active: component-tokens.get-var(\n  $notification-action-tertiary-inverse-active,\n  'notification-action-tertiary-inverse-active'\n);\n\n$notification-action-tertiary-inverse-hover: component-tokens.get-var(\n  $notification-action-tertiary-inverse-hover,\n  'notification-action-tertiary-inverse-hover'\n);\n\n$notification-action-tertiary-inverse-text: component-tokens.get-var(\n  $notification-action-tertiary-inverse-text,\n  'notification-action-tertiary-inverse-text'\n);\n\n$notification-action-tertiary-inverse-text-on-color-disabled: component-tokens.get-var(\n  $notification-action-tertiary-inverse-text-on-color-disabled,\n  'notification-action-tertiary-inverse-text-on-color-disabled'\n);\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'mixins' as *;\n@use 'tokens' as *;\n@use '../../breakpoint' as *;\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../feature-flags';\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../themes' as *;\n@use '../../type' as *;\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/focus-outline' as *;\n@use './tokens' as *;\n\n/// Toast notification base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-base {\n  @include reset;\n\n  display: flex;\n  block-size: auto;\n  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.2);\n  color: $text-inverse;\n  inline-size: convert.to-rem(288px);\n  padding-inline-start: convert.to-rem(13px);\n\n  @include breakpoint(max) {\n    inline-size: convert.to-rem(352px);\n  }\n}\n\n/// Toast notification low-contrast base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-low-contrast-base {\n  color: $text-primary;\n\n  .#{$prefix}--toast-notification__subtitle,\n  .#{$prefix}--toast-notification__caption {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--toast-notification__close-button\n    .#{$prefix}--toast-notification__close-icon {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--toast-notification__close-button:focus {\n    @include focus-outline('outline');\n  }\n}\n\n/// Toast notification error variant base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-error-base {\n  @include notification--experimental(\n    $support-error-inverse,\n    $background-inverse\n  );\n}\n\n/// Toast notification success variant base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-success-base {\n  @include notification--experimental(\n    $support-success-inverse,\n    $background-inverse\n  );\n}\n\n/// Toast notification info variant base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-info-base {\n  @include notification--experimental(\n    $support-info-inverse,\n    $background-inverse\n  );\n}\n\n/// Toast notification warning variant base styles\n/// @access public\n/// @group notification\n@mixin toast-notification-warning-base {\n  @include notification--experimental(\n    $support-warning-inverse,\n    $background-inverse\n  );\n}\n\n/// Toast notification low-contrast error variant styles\n/// @access public\n/// @group notification\n@mixin toast-notification-low-contrast-error {\n  @include notification--experimental(\n    $support-error,\n    $notification-background-error\n  );\n}\n\n/// Toast notification low-contrast success variant styles\n/// @access public\n/// @group notification\n@mixin toast-notification-low-contrast-success {\n  @include notification--experimental(\n    $support-success,\n    $notification-background-success\n  );\n}\n\n/// Toast notification low-contrast info variant styles\n/// @access public\n/// @group notification\n@mixin toast-notification-low-contrast-info {\n  @include notification--experimental(\n    $support-info,\n    $notification-background-info\n  );\n}\n\n/// Toast notification low-contrast warning variant styles\n/// @access public\n/// @group notification\n@mixin toast-notification-low-contrast-warning {\n  @include notification--experimental(\n    $support-warning,\n    $notification-background-warning\n  );\n}\n\n/// Toast notification styles\n/// @access public\n/// @group notification\n@mixin toast-notification {\n  .#{$prefix}--toast-notification {\n    @include toast-notification-base;\n  }\n\n  .#{$prefix}--toast-notification:not(\n      .#{$prefix}--toast-notification--low-contrast\n    )\n    a {\n    color: $link-inverse;\n  }\n\n  .#{$prefix}--toast-notification a {\n    text-decoration: none;\n  }\n\n  .#{$prefix}--toast-notification a:hover {\n    text-decoration: underline;\n  }\n\n  .#{$prefix}--toast-notification a:focus {\n    outline: 1px solid $link-inverse;\n  }\n\n  .#{$prefix}--toast-notification.#{$prefix}--toast-notification--low-contrast\n    a:focus {\n    @include focus-outline;\n  }\n\n  .#{$prefix}--toast-notification--low-contrast {\n    @include toast-notification-low-contrast-base;\n  }\n\n  .#{$prefix}--toast-notification--error {\n    @include toast-notification-error-base;\n  }\n\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--error {\n    @include toast-notification-low-contrast-error;\n  }\n\n  .#{$prefix}--toast-notification--success {\n    @include toast-notification-success-base;\n  }\n\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--success {\n    @include toast-notification-low-contrast-success;\n  }\n\n  .#{$prefix}--toast-notification--info,\n  .#{$prefix}--toast-notification--info-square {\n    @include toast-notification-info-base;\n  }\n\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--info,\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--info-square {\n    @include toast-notification-low-contrast-info;\n  }\n\n  .#{$prefix}--toast-notification--warning,\n  .#{$prefix}--toast-notification--warning-alt {\n    @include toast-notification-warning-base;\n  }\n\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--warning,\n  .#{$prefix}--toast-notification--low-contrast.#{$prefix}--toast-notification--warning-alt {\n    @include toast-notification-low-contrast-warning;\n  }\n\n  .#{$prefix}--toast-notification--warning\n    .#{$prefix}--toast-notification__icon\n    path[opacity='0'],\n  .#{$prefix}--toast-notification--warning-alt\n    .#{$prefix}--toast-notification__icon\n    path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--toast-notification__icon {\n    flex-shrink: 0;\n    margin-block-start: $spacing-05;\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--toast-notification__details {\n    margin-block-end: $spacing-05;\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--toast-notification__close-button {\n    @include focus-outline('reset');\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    background-color: transparent;\n    block-size: convert.to-rem(48px);\n    cursor: pointer;\n    inline-size: convert.to-rem(48px);\n    margin-inline-start: auto;\n    min-block-size: convert.to-rem(48px);\n    min-inline-size: convert.to-rem(48px);\n    transition:\n      outline $transition-base,\n      background-color $transition-base;\n\n    &:focus {\n      outline: 2px solid $focus-inverse;\n      outline-offset: -2px;\n    }\n\n    .#{$prefix}--toast-notification__close-icon {\n      fill: $icon-inverse;\n    }\n  }\n\n  .#{$prefix}--toast-notification__title {\n    @include type-style('heading-compact-01');\n\n    font-weight: 600;\n    margin-block-start: $spacing-05;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--toast-notification__subtitle {\n    @include type-style('body-compact-01');\n\n    color: $text-inverse;\n    margin-block: 0 $spacing-05;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--toast-notification__caption {\n    @include type-style('body-compact-01');\n\n    color: $text-inverse;\n    padding-block-start: $spacing-03;\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--toast-notification {\n    @include high-contrast-mode('outline');\n  }\n  .#{$prefix}--toast-notification__close-button:focus {\n    @include high-contrast-mode('focus');\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2026\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n@use 'mixins' as *;\n@use '../button';\n@use '../../breakpoint' as *;\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../feature-flags' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../themes' as *;\n@use '../../type' as *;\n@use '../../utilities/convert';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/focus-outline' as *;\n@use './tokens' as *;\n@use '../button/mixins' as button-mixins;\n@use '../button/vars' as button-vars;\n\n/// Actionable notification base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-base {\n  @include reset;\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  block-size: auto;\n  color: $text-inverse;\n  inline-size: 100%;\n  max-inline-size: convert.to-rem(288px);\n  min-block-size: convert.to-rem(48px);\n  min-inline-size: convert.to-rem(288px);\n\n  @include breakpoint(md) {\n    flex-wrap: nowrap;\n    max-inline-size: convert.to-rem(608px);\n  }\n\n  @include breakpoint(lg) {\n    max-inline-size: convert.to-rem(736px);\n  }\n\n  @include breakpoint(max) {\n    max-inline-size: convert.to-rem(832px);\n  }\n}\n/// Actionable notification toast variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-toast-base {\n  flex-wrap: wrap;\n  box-shadow: 0 2px 6px 0 rgb(0 0 0 / 20%);\n  max-inline-size: convert.to-rem(288px);\n  min-inline-size: convert.to-rem(288px);\n}\n\n/// Actionable notification low-contrast variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-base {\n  color: $text-primary;\n\n  .#{$prefix}--actionable-notification__subtitle,\n  .#{$prefix}--actionable-notification__caption {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--actionable-notification__close-button\n    .#{$prefix}--actionable-notification__close-icon {\n    fill: $icon-primary;\n  }\n}\n\n/// Actionable notification error variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-error-base {\n  @include notification--experimental(\n    $support-error-inverse,\n    $background-inverse\n  );\n}\n\n/// Actionable notification success variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-success-base {\n  @include notification--experimental(\n    $support-success-inverse,\n    $background-inverse\n  );\n}\n\n/// Actionable notification info variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-info-base {\n  @include notification--experimental(\n    $support-info-inverse,\n    $background-inverse\n  );\n}\n\n/// Actionable notification warning variant base styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-warning-base {\n  @include notification--experimental(\n    $support-warning-inverse,\n    $background-inverse\n  );\n}\n\n/// Actionable notification low-contrast error variant styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-error {\n  @include notification--experimental(\n    $support-error,\n    $notification-background-error\n  );\n\n  &::before {\n    border-color: $support-error;\n  }\n}\n\n/// Actionable notification low-contrast success variant styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-success {\n  @include notification--experimental(\n    $support-success,\n    $notification-background-success\n  );\n\n  &::before {\n    border-color: $support-success;\n  }\n}\n\n/// Actionable notification low-contrast info variant styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-info {\n  @include notification--experimental(\n    $support-info,\n    $notification-background-info\n  );\n\n  &::before {\n    border-color: $support-info;\n  }\n}\n\n/// Actionable notification low-contrast warning variant styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-warning {\n  @include notification--experimental(\n    $support-warning,\n    $notification-background-warning\n  );\n\n  &::before {\n    border-color: $support-warning;\n  }\n}\n\n/// Actionable notification low constrast inline ::before styles\n/// @access public\n/// @group notification\n@mixin actionable-notification-low-contrast-inline-before {\n  position: absolute;\n  box-sizing: border-box;\n  border-width: 1px 1px 1px 0;\n  border-style: solid;\n  block-size: 100%;\n  content: '';\n  filter: opacity(0.4);\n  inline-size: 100%;\n  inset-block-start: 0;\n  inset-inline-start: 0;\n  pointer-events: none;\n}\n\n/// Actionable notification styles\n/// @access public\n/// @group notification\n@mixin actionable-notification {\n  .#{$prefix}--actionable-notification {\n    @include actionable-notification-base;\n  }\n\n  .#{$prefix}--actionable-notification--toast {\n    @include actionable-notification-toast-base;\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    a {\n    color: $link-inverse;\n  }\n\n  .#{$prefix}--actionable-notification a {\n    text-decoration: none;\n  }\n\n  .#{$prefix}--actionable-notification a:hover {\n    text-decoration: underline;\n  }\n\n  .#{$prefix}--actionable-notification a:focus {\n    outline: 1px solid $focus-inverse;\n  }\n\n  .#{$prefix}--actionable-notification.#{$prefix}--actionable-notification--low-contrast\n    a:focus {\n    @include focus-outline;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast {\n    @include actionable-notification-low-contrast-base;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast:not(\n      .#{$prefix}--actionable-notification--toast\n    )::before {\n    @include actionable-notification-low-contrast-inline-before;\n  }\n\n  .#{$prefix}--actionable-notification--error {\n    @include actionable-notification-error-base;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--error {\n    @include actionable-notification-low-contrast-error;\n  }\n\n  .#{$prefix}--actionable-notification--success {\n    @include actionable-notification-success-base;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--success {\n    @include actionable-notification-low-contrast-success;\n  }\n\n  .#{$prefix}--actionable-notification--info,\n  .#{$prefix}--actionable-notification--info-square {\n    @include actionable-notification-info-base;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--info,\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--info-square {\n    @include actionable-notification-low-contrast-info;\n  }\n\n  .#{$prefix}--actionable-notification--warning,\n  .#{$prefix}--actionable-notification--warning-alt {\n    @include actionable-notification-warning-base;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--warning,\n  .#{$prefix}--actionable-notification--low-contrast.#{$prefix}--actionable-notification--warning-alt {\n    @include actionable-notification-low-contrast-warning;\n  }\n\n  .#{$prefix}--actionable-notification--warning\n    .#{$prefix}--toast-notification__icon\n    path[opacity='0'],\n  .#{$prefix}--actionable-notification--warning-alt\n    .#{$prefix}--toast-notification__icon\n    path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--actionable-notification--warning\n    .#{$prefix}--inline-notification__icon\n    path[opacity='0'],\n  .#{$prefix}--actionable-notification--warning-alt\n    .#{$prefix}--inline-notification__icon\n    path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--actionable-notification__details {\n    display: flex;\n    flex-grow: 1;\n    margin-inline: convert.to-rem(13px) $spacing-09;\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--toast\n    )\n    .#{$prefix}--actionable-notification__details {\n    @include breakpoint(md) {\n      margin: 0 convert.to-rem(13px);\n    }\n  }\n\n  .#{$prefix}--actionable-notification .#{$prefix}--inline-notification__icon {\n    flex-shrink: 0;\n    margin-block-start: convert.to-rem(14px);\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--actionable-notification .#{$prefix}--toast-notification__icon {\n    flex-shrink: 0;\n    margin-block-start: $spacing-05;\n    margin-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--actionable-notification__text-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    padding: convert.to-rem(15px) 0;\n  }\n\n  .#{$prefix}--actionable-notification__focus-wrapper {\n    display: contents;\n  }\n\n  .#{$prefix}--actionable-notification__button-wrapper {\n    display: flex;\n  }\n\n  .#{$prefix}--actionable-notification--toast\n    .#{$prefix}--actionable-notification__text-wrapper {\n    padding: convert.to-rem(15px) 0 convert.to-rem(23px) 0;\n  }\n\n  .#{$prefix}--actionable-notification__content {\n    @include type-style('body-compact-01');\n\n    display: flex;\n    flex-wrap: wrap;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--actionable-notification--toast\n    .#{$prefix}--actionable-notification__content {\n    display: block;\n  }\n\n  .#{$prefix}--actionable-notification__title {\n    @include type-style('heading-compact-01');\n\n    font-weight: 600;\n    margin-inline-end: $spacing-02;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--actionable-notification--toast\n    .#{$prefix}--actionable-notification__title {\n    margin-inline-end: 0;\n  }\n\n  .#{$prefix}--actionable-notification__subtitle {\n    @include type-style('body-compact-01');\n\n    color: $text-inverse;\n    margin-block-start: 0;\n    word-break: break-word;\n  }\n\n  .#{$prefix}--actionable-notification__caption {\n    @include type-style('body-compact-01');\n\n    color: $text-inverse;\n    padding-block-start: $spacing-06;\n  }\n\n  /* Ghost action button when inline */\n  .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost {\n    block-size: convert.to-rem(32px);\n    margin-block-end: $spacing-03;\n    margin-inline-start: $spacing-08;\n\n    @include breakpoint(md) {\n      margin: $spacing-03 0;\n    }\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost {\n    color: $link-inverse;\n  }\n\n  .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:active,\n  .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:hover {\n    background-color: $background-inverse-hover;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:active,\n  .#{$prefix}--actionable-notification--low-contrast\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:hover {\n    background-color: $notification-action-hover;\n  }\n\n  .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:focus {\n    border-color: transparent;\n    box-shadow: none;\n    outline: 2px solid $focus-inverse;\n    outline-offset: -2px;\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost:focus {\n    outline-color: $focus;\n  }\n\n  .#{$prefix}--actionable-notification--hide-close-button\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--ghost {\n    margin-inline-end: $spacing-03;\n  }\n\n  /* Tertiary action button when not inline (toast) */\n  .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary {\n    margin-block-end: $spacing-05;\n    // Button should be left aligned with text.\n    // 20px is the width of the notification icon\n    // 2px is the width of the left border that should be negated\n    margin-inline-start: calc(\n      #{$spacing-07} + #{convert.to-rem(20px)} - #{convert.to-rem(2px)}\n    );\n    padding-inline: $spacing-05;\n  }\n\n  // Tertiary button styles by default use mostly \"inverse\" tokens. Since the non-low-contrast notification\n  // background is dark, the button styles have to be inversed again.\n  // So essentially the:\n  // btn-tertiary white theme button styles should become g100 button styles\n  // btn-tertiary g10 theme button styles should become g90 button styles\n  // btn-tertiary g90 theme button styles should become g10 button styles\n  // btn-tertiary g100 theme button styles should become white button styles\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary {\n    @include button-mixins.button-theme(\n      transparent,\n      $notification-action-tertiary-inverse,\n      $notification-action-tertiary-inverse,\n      $notification-action-tertiary-inverse-hover,\n      currentColor,\n      $notification-action-tertiary-inverse-active\n    );\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:hover {\n    color: $notification-action-tertiary-inverse-text;\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:focus {\n    border-color: $focus-inverse;\n    background-color: $notification-action-tertiary-inverse;\n    box-shadow:\n      inset 0 0 0 button-vars.$button-outline-width $focus-inverse,\n      inset 0 0 0 button-vars.$button-border-width $background-inverse;\n    color: $notification-action-tertiary-inverse-text;\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:active {\n    border-color: transparent;\n    background-color: $notification-action-tertiary-inverse-active;\n    color: $notification-action-tertiary-inverse-text;\n  }\n\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:disabled,\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:hover:disabled,\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary:focus:disabled,\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary.#{$prefix}--btn--disabled,\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary.#{$prefix}--btn--disabled:hover,\n  .#{$prefix}--actionable-notification:not(\n      .#{$prefix}--actionable-notification--low-contrast\n    )\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary.#{$prefix}--btn--disabled:focus {\n    background: transparent;\n    color: $notification-action-tertiary-inverse-text-on-color-disabled;\n    outline: none;\n  }\n\n  .#{$prefix}--actionable-notification--hide-close-button\n    .#{$prefix}--actionable-notification__action-button.#{$prefix}--btn--tertiary {\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--actionable-notification__close-button {\n    @include focus-outline('reset');\n\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    background: transparent;\n    block-size: convert.to-rem(48px);\n    cursor: pointer;\n    inline-size: convert.to-rem(48px);\n    inset-block-start: 0;\n    inset-inline-end: 0;\n    max-inline-size: convert.to-rem(48px);\n    min-inline-size: convert.to-rem(48px);\n    transition:\n      outline $duration-fast-02 motion(standard, productive),\n      background-color $duration-fast-02 motion(standard, productive);\n\n    &:focus {\n      outline: 2px solid $focus-inverse;\n      outline-offset: -2px;\n    }\n\n    .#{$prefix}--actionable-notification__close-icon {\n      fill: $icon-inverse;\n    }\n\n    @include breakpoint(md) {\n      position: static;\n    }\n  }\n\n  .#{$prefix}--actionable-notification--toast\n    .#{$prefix}--actionable-notification__close-button {\n    @include breakpoint(md) {\n      position: absolute;\n    }\n  }\n\n  .#{$prefix}--actionable-notification--low-contrast\n    .#{$prefix}--actionable-notification__close-button:focus {\n    @include focus-outline('outline');\n  }\n\n  // Windows HCM fix\n\n  .#{$prefix}--actionable-notification {\n    @include high-contrast-mode('outline');\n  }\n\n  .#{$prefix}--actionable-notification__close-button:focus,\n  .#{$prefix}--btn.#{$prefix}--btn--ghost.#{$prefix}--actionable-notification__action-button:focus {\n    @include high-contrast-mode('focus');\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button/tokens' as button;\n@use '../../config' as *;\n@use '../../feature-flags' as *;\n@use '../../layer' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/convert';\n@use '../../utilities/component-reset';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/layout';\n\n// padding + icon size (1rem) + padding\n$-icon-container-size: calc(#{layout.density('padding-inline')} * 2 + 1rem);\n\n/// Tile styles\n/// @access public\n/// @group tile\n@mixin tile(\n  $enable-experimental-tile-contrast: false,\n  $enable-tile-contrast: false,\n  $enable-v12-tile-radio-icons: false\n) {\n  .#{$prefix}--tile-group {\n    @include reset;\n  }\n\n  .#{$prefix}--tile {\n    @include type-style('body-compact-01');\n    @include layout.use('density', $default: 'normal');\n\n    position: relative;\n    display: block;\n    padding: layout.density('padding-inline');\n    background-color: $layer;\n    min-block-size: 4rem;\n    min-inline-size: 8rem;\n    outline: 2px solid transparent;\n    outline-offset: -2px;\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--tile--light {\n    background-color: $layer-02;\n  }\n\n  .#{$prefix}--tile--clickable,\n  .#{$prefix}--tile--selectable {\n    @include component-reset.reset;\n    @include type-style('body-compact-01');\n\n    padding: layout.density('padding-inline');\n    cursor: pointer;\n    transition: $duration-moderate-01 motion(standard, productive);\n\n    &:hover {\n      background: $layer-hover;\n    }\n  }\n\n  .#{$prefix}--tile--clickable {\n    color: $text-primary;\n    text-decoration: none;\n\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-tile;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n\n      text-decoration: none;\n    }\n\n    &:hover,\n    &:focus {\n      .#{$prefix}--tile__checkmark {\n        opacity: 1;\n      }\n    }\n  }\n\n  // Removes Firefox automatic border on buttons\n  .#{$prefix}--tile--expandable::-moz-focus-inner {\n    border: 0;\n  }\n\n  .#{$prefix}--tile--clickable:hover,\n  .#{$prefix}--tile--clickable:active,\n  .#{$prefix}--tile--clickable:visited,\n  .#{$prefix}--tile--clickable:visited:hover {\n    color: $text-primary;\n    text-decoration: none;\n  }\n\n  // Disabled ClickableTile\n  .#{$prefix}--tile--clickable.#{$prefix}--link--disabled,\n  .#{$prefix}--tile--clickable:hover.#{$prefix}--link--disabled {\n    display: block;\n    padding: layout.density('padding-inline');\n    background-color: $layer;\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-disabled;\n    }\n  }\n\n  .#{$prefix}--tile--clickable .#{$prefix}--tile--icon,\n  .#{$prefix}--tile--clickable.#{$prefix}--link--disabled\n    .#{$prefix}--tile--disabled-icon {\n    position: absolute;\n    block-size: convert.to-rem(20px);\n    inline-size: convert.to-rem(20px);\n    inset-block-end: convert.to-rem(12px);\n    inset-inline-end: convert.to-rem(12px);\n  }\n\n  .#{$prefix}--tile--clickable .#{$prefix}--tile--icon {\n    fill: $icon-interactive;\n  }\n\n  .#{$prefix}--tile--clickable.#{$prefix}--link--disabled\n    .#{$prefix}--tile--disabled-icon {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--tile--clickable.#{$prefix}--link--disabled\n    .#{$prefix}--tile--icon {\n    display: none;\n  }\n\n  .#{$prefix}--tile--selectable {\n    border: 1px solid transparent;\n    padding-inline-end: $-icon-container-size;\n\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-tile;\n    }\n  }\n\n  .#{$prefix}--tile__checkmark {\n    position: absolute;\n    border: none;\n    background: transparent;\n    block-size: 1rem;\n    inset-block-start: layout.density('padding-inline');\n    inset-inline-end: layout.density('padding-inline');\n    transition: $duration-fast-02 motion(standard, productive);\n\n    @if (\n      enabled('enable-v12-tile-radio-icons') or\n        $enable-experimental-tile-contrast or\n        $enable-tile-contrast\n    ) {\n      opacity: 1;\n    } @else {\n      opacity: 0;\n    }\n\n    svg {\n      border-radius: 50%;\n      fill: $icon-secondary;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  .#{$prefix}--tile__checkmark--persistent {\n    opacity: 1;\n  }\n\n  .#{$prefix}--tile__chevron {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: $-icon-container-size;\n    inline-size: $-icon-container-size;\n    inset-block-end: 0;\n    inset-inline-end: 0;\n\n    svg {\n      fill: $icon-primary;\n      transform-origin: center;\n      transition: $duration-fast-02 motion(standard, productive);\n\n      @media screen and (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n\n  .#{$prefix}--tile__chevron--interactive {\n    @include button-reset.reset;\n\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: $-icon-container-size;\n    inline-size: $-icon-container-size;\n    inset-block-end: 0;\n    inset-inline-end: 0;\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-disabled;\n    }\n\n    &:focus {\n      outline: 2px solid $focus;\n      outline-offset: -2px;\n    }\n\n    &:hover {\n      background-color: $layer-hover;\n      cursor: pointer;\n    }\n  }\n\n  .#{$prefix}--tile--expandable {\n    position: relative;\n    overflow: hidden;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: inherit;\n    inline-size: 100%;\n    text-align: start;\n    transition: max-height $duration-moderate-01 motion(standard, productive);\n\n    @include type-style('body-compact-01');\n\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-tile;\n    }\n\n    &:hover {\n      background: $layer-hover;\n    }\n  }\n\n  .#{$prefix}--tile--expandable.#{$prefix}--tile--expandable--interactive {\n    border: none;\n    cursor: default;\n    transition: max-height $duration-moderate-01 motion(standard, productive);\n\n    &:hover {\n      background-color: $layer;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n\n  .#{$prefix}--tile--expandable--interactive:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--tile-content__below-the-fold {\n    display: block;\n    opacity: 0;\n    transition:\n      opacity $duration-fast-02 motion(standard, productive),\n      visibility $duration-fast-02 motion(standard, productive);\n    visibility: hidden;\n  }\n\n  .#{$prefix}--tile--is-expanded {\n    overflow: visible;\n    transition: max-height $duration-fast-02 motion(standard, productive);\n\n    .#{$prefix}--tile__chevron svg {\n      transform: rotate(180deg);\n    }\n\n    .#{$prefix}--tile-content__below-the-fold {\n      opacity: 1;\n      transition:\n        opacity $duration-fast-02 motion(standard, productive),\n        visibility $duration-fast-02 motion(standard, productive);\n      visibility: inherit;\n\n      // Safari-only media query\n      // Fixes an issue with scrolling\n      // and absolutely positioned elements (#8119)\n      @supports (hanging-punctuation: first) and (font: -apple-system-body) and\n        (-webkit-appearance: none) {\n        overflow-y: auto;\n      }\n    }\n  }\n\n  .#{$prefix}--tile--is-selected {\n    border: 1px solid $layer-selected-inverse;\n  }\n\n  .#{$prefix}--tile--is-selected .#{$prefix}--tile__checkmark {\n    opacity: 1;\n  }\n\n  .#{$prefix}--tile--is-selected .#{$prefix}--tile__checkmark svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--tile-content {\n    block-size: 100%;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--tile-input {\n    @include visually-hidden;\n  }\n\n  .#{$prefix}--tile-input:focus + .#{$prefix}--tile {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--tile--disabled.#{$prefix}--tile--selectable {\n    background-color: $layer;\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    @if (\n      enabled('enable-experimental-tile-contrast') or\n        $enable-experimental-tile-contrast or\n        enabled('enable-tile-contrast') or\n        $enable-tile-contrast\n    ) {\n      border: 1px solid $border-disabled;\n    }\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--tile--disabled.#{$prefix}--tile--selectable.#{$prefix}--tile--light {\n    background-color: $layer-02;\n  }\n\n  .#{$prefix}--tile--disabled.#{$prefix}--tile--is-selected {\n    border-color: $border-disabled;\n  }\n\n  .#{$prefix}--tile--disabled .#{$prefix}--tile__checkmark svg {\n    fill: $icon-disabled;\n  }\n\n  // AILabel styles\n  .#{$prefix}--tile > .#{$prefix}--tile--inner-decorator > *,\n  .#{$prefix}--tile--expandable > div > .#{$prefix}--tile--inner-decorator > *,\n  .#{$prefix}--tile > .#{$prefix}--ai-label,\n  .#{$prefix}--tile--expandable > div > .#{$prefix}--ai-label,\n  .#{$prefix}--tile > .#{$prefix}--slug,\n  .#{$prefix}--tile--expandable > div > .#{$prefix}--slug,\n  .#{$prefix}--tile--clickable .#{$prefix}--tile--ai-label-icon {\n    position: absolute;\n    inset-block-start: $spacing-05;\n    inset-inline-end: $spacing-05;\n  }\n\n  .#{$prefix}--tile.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable > .#{$prefix}--ai-label,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable > .#{$prefix}--slug {\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio\n    > .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio\n    > .#{$prefix}--ai-label,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio\n    > .#{$prefix}--slug {\n    inset-inline-end: $spacing-05;\n    transition: inset-inline-end $duration-fast-02 motion(standard, productive);\n\n    @if (\n      enabled('enable-v12-tile-radio-icons') or\n        $enable-experimental-tile-contrast\n        $enable-tile-contrast\n    ) {\n      inset-inline-end: $spacing-08;\n    }\n  }\n\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio.#{$prefix}--tile--is-selected\n    > .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio.#{$prefix}--tile--is-selected\n    > .#{$prefix}--ai-label,\n  .#{$prefix}--tile.#{$prefix}--tile--selectable.#{$prefix}--tile--radio.#{$prefix}--tile--is-selected\n    > .#{$prefix}--slug {\n    inset-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--tile.#{$prefix}--tile--clickable\n    > .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile.#{$prefix}--tile--clickable > .#{$prefix}--ai-label,\n  .#{$prefix}--tile.#{$prefix}--tile--clickable > .#{$prefix}--slug {\n    pointer-events: none;\n  }\n\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--tile--ai-label-icon\n    ).#{$prefix}--tile,\n  .#{$prefix}--tile--decorator:has(.#{$prefix}--ai-label).#{$prefix}--tile,\n  .#{$prefix}--tile--slug.#{$prefix}--tile {\n    @include ai-popover-gradient('default', 0, 'layer');\n\n    border: 1px solid transparent;\n    box-shadow:\n      inset 0 -80px 70px -65px $ai-inner-shadow,\n      0 4px 8px 0 $ai-drop-shadow;\n  }\n\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--ai-label\n    ).#{$prefix}--tile--expandable:hover,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--expandable:hover {\n    @include ai-popover-gradient('default', 0, 'layer');\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable::after,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--clickable::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable::after,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable::before {\n    position: absolute;\n    display: block;\n    block-size: 100%;\n    content: '';\n    inline-size: 100%;\n    inset-block-start: 0;\n    inset-inline-start: 0;\n    opacity: 0;\n    transition: opacity $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--ai-label\n    ).#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--ai-label\n    ).#{$prefix}--tile--clickable::before,\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--tile--ai-label-icon\n    ).#{$prefix}--tile--clickable::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable::before {\n    @include ai-popover-gradient('hover', 0, 'layer');\n\n    box-shadow:\n      inset 0 -80px 70px -65px $ai-inner-shadow,\n      0 4px 10px 2px $ai-drop-shadow;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable:hover::before,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--clickable:hover::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable:hover::before,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable:hover::before {\n    opacity: 1;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable:focus,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--clickable:focus,\n  .#{$prefix}--tile-input:focus + .#{$prefix}--tile--decorator.#{$prefix}--tile,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable:focus,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable:focus,\n  .#{$prefix}--tile-input:focus + .#{$prefix}--tile--slug.#{$prefix}--tile {\n    outline-offset: -1px;\n  }\n\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--tile--inner-decorator .#{$prefix}--ai-label\n    ).#{$prefix}--tile--selectable::after,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable::after {\n    @include ai-popover-gradient('selected', 0, 'layer');\n\n    box-shadow:\n      inset 0 -80px 70px -65px $ai-inner-shadow,\n      0 4px 8px 0 $ai-drop-shadow;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable:hover::after,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable:hover::after {\n    opacity: 0;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--is-selected::after,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--is-selected::after {\n    opacity: 1;\n  }\n\n  .#{$prefix}--tile--decorator:has(\n      .#{$prefix}--tile--inner-decorator\n    ).#{$prefix}--tile--is-selected,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--is-selected {\n    border-color: $border-inverse;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--clickable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable\n    .#{$prefix}--tile-content {\n    position: relative;\n    cursor: pointer;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--clickable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile__checkmark,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--is-selected\n    .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    .#{$prefix}--tile-content,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--clickable .#{$prefix}--tile-content,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile__checkmark,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--is-selected .#{$prefix}--ai-label,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--is-selected .#{$prefix}--slug {\n    z-index: 1;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    .#{$prefix}--tile--inner-decorator\n    > *:has(> .#{$prefix}--popover--open),\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    .#{$prefix}--ai-label:has(> .#{$prefix}--popover--open),\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    .#{$prefix}--slug:has(> .#{$prefix}--popover--open) {\n    z-index: 2;\n  }\n\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile--inner-decorator\n    > *,\n  .#{$prefix}--tile--decorator.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile__checkmark,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable > .#{$prefix}--ai-label,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable > .#{$prefix}--slug,\n  .#{$prefix}--tile--slug.#{$prefix}--tile--selectable\n    > .#{$prefix}--tile__checkmark {\n    z-index: 1;\n  }\n\n  .#{$prefix}--tile--expandable:has(\n      .#{$prefix}--tile--inner-decorator > * > .#{$prefix}--popover--open\n    ),\n  .#{$prefix}--tile--expandable:has(\n      .#{$prefix}--ai-label > .#{$prefix}--popover--open\n    ),\n  .#{$prefix}--tile--expandable:has(\n      .#{$prefix}--slug > .#{$prefix}--popover--open\n    ) {\n    overflow: visible;\n  }\n\n  .#{$prefix}--tile--clickable .#{$prefix}--tile--ai-label-icon rect {\n    stroke: $icon-primary;\n  }\n\n  .#{$prefix}--tile--clickable .#{$prefix}--tile--ai-label-icon path {\n    fill: $icon-primary;\n  }\n\n  // Tile with slug and rounded corners\n  .#{$prefix}--tile--decorator-rounded,\n  .#{$prefix}--tile--decorator-rounded.#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--decorator-rounded.#{$prefix}--tile--selectable::after,\n  .#{$prefix}--tile--decorator-rounded.#{$prefix}--tile--clickable::before,\n  .#{$prefix}--tile--slug-rounded,\n  .#{$prefix}--tile--slug-rounded.#{$prefix}--tile--selectable::before,\n  .#{$prefix}--tile--slug-rounded.#{$prefix}--tile--selectable::after,\n  .#{$prefix}--tile--slug-rounded.#{$prefix}--tile--clickable::before {\n    border-radius: $spacing-03;\n  }\n\n  .#{$prefix}--tile--decorator-rounded .#{$prefix}--tile__chevron,\n  .#{$prefix}--tile--slug-rounded .#{$prefix}--tile__chevron {\n    border-end-end-radius: $spacing-03;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'vars' as *;\n@use 'functions' as *;\n@use 'animation';\n@use '../../config' as *;\n@use '../../layer' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/z-index' as *;\n\n/// Loading styles\n/// @access private\n/// @group loading\n@mixin loading {\n  .#{$prefix}--loading {\n    @include component-reset.reset;\n    @include animation.spin;\n\n    block-size: $loading-size;\n\n    inline-size: $loading-size;\n  }\n\n  // Animation (Spin by default)\n  .#{$prefix}--loading__svg {\n    fill: transparent;\n  }\n\n  .#{$prefix}--loading__svg circle {\n    stroke-dasharray: $circumference $circumference;\n    stroke-linecap: butt;\n    stroke-width: 10;\n  }\n\n  .#{$prefix}--loading__stroke {\n    stroke: $interactive;\n    stroke-dashoffset: loading-progress($circumference, 81);\n  }\n\n  .#{$prefix}--loading--small .#{$prefix}--loading__stroke {\n    stroke-dashoffset: loading-progress($circumference, 48);\n  }\n\n  .#{$prefix}--loading--stop {\n    @include animation.stop;\n  }\n\n  .#{$prefix}--loading--small {\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(16px);\n\n    //See https://github.com/carbon-design-system/carbon/issues/13121\n    line-height: 1rem;\n\n    circle {\n      stroke-width: 16;\n    }\n  }\n\n  .#{$prefix}--loading--small .#{$prefix}--loading__svg {\n    stroke: $interactive;\n  }\n\n  .#{$prefix}--loading__background {\n    stroke: $layer-accent;\n    stroke-dashoffset: -22;\n  }\n\n  // Negative values for `stroke-dashoffset` are not supported in Safari\n  @supports (hanging-punctuation: first) and (font: -apple-system-body) and\n    (-webkit-appearance: none) {\n    circle.#{$prefix}--loading__background {\n      stroke-dasharray: 265;\n      stroke-dashoffset: 0;\n    }\n  }\n\n  .#{$prefix}--loading-overlay {\n    position: fixed;\n    z-index: z('overlay');\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: $overlay;\n    block-size: 100%;\n    inline-size: 100%;\n    inset-block-start: 0;\n    inset-inline-start: 0;\n    transition: background-color $duration-slow-02 motion(standard, expressive);\n  }\n\n  .#{$prefix}--loading-overlay--stop {\n    display: none;\n  }\n\n  @keyframes #{$prefix}--rotate {\n    0% {\n      transform: rotate(0deg);\n    }\n\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes #{$prefix}--rotate-end-p1 {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes #{$prefix}--rotate-end-p2 {\n    100% {\n      transform: rotate(-360deg);\n    }\n  }\n\n  /* Stroke animations */\n  @keyframes #{$prefix}--init-stroke {\n    0% {\n      stroke-dashoffset: loading-progress($circumference, 0);\n    }\n\n    100% {\n      stroke-dashoffset: loading-progress($circumference, 81);\n    }\n  }\n\n  @keyframes #{$prefix}--stroke-end {\n    0% {\n      stroke-dashoffset: loading-progress($circumference, 81);\n    }\n\n    100% {\n      stroke-dashoffset: loading-progress($circumference, 0);\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../motion';\n@use '../../config' as *;\n\n@mixin spin {\n  // Animate the container\n  animation-duration: 690ms;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-name: #{$prefix}--rotate;\n  animation-timing-function: linear;\n\n  // Animate the stroke\n  svg circle {\n    animation-duration: 10ms;\n    animation-name: #{$prefix}--init-stroke;\n    animation-timing-function: motion.$standard-easing;\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n}\n\n@mixin stop {\n  // Animate the container\n  animation:\n    #{$prefix}--rotate-end-p1 700ms motion.$ease-out forwards,\n    #{$prefix}--rotate-end-p2 700ms motion.$ease-out 700ms forwards;\n\n  // Animate the stroke\n  svg circle {\n    animation-delay: 700ms;\n    animation-duration: 700ms;\n    animation-fill-mode: forwards;\n    animation-name: #{$prefix}--stroke-end;\n    animation-timing-function: motion.$ease-out;\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@forward '@carbon/motion';\n\n/// Used primarily for removing elements from the screen\n/// @type Function\n/// @access public\n/// @group motion\n$ease-in: cubic-bezier(0.25, 0, 1, 1);\n\n/// Used for adding elements to the screen or changing on-screen states at a user's input\n/// @type Function\n/// @access public\n/// @group motion\n$ease-out: cubic-bezier(0, 0, 0.25, 1);\n\n/// Used for the majority of animations\n/// @type Function\n/// @access public\n/// @group motion\n$standard-easing: cubic-bezier(0.5, 0, 0.1, 1);\n\n/// Base transition duration\n/// @type Number\n/// @access public\n/// @group motion\n$transition-base: 250ms;\n\n/// Expansion duration\n/// @type Number\n/// @access public\n/// @group motion\n$transition-expansion: 300ms;\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n/// @type Number\n/// @access private\n/// @group loading\n$radius: 44;\n\n/// @type Number\n/// @access private\n/// @group loading\n$circumference: $radius * 2 * 3.1416;\n\n/// @type Number\n/// @access private\n/// @group loading\n$loading-size: 5.5rem;\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../../config' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/keyframes' as *;\n@use '../../utilities/tooltip' as *;\n@use '../../utilities/visually-hidden' as *;\n\n@mixin copy-button {\n  .#{$prefix}--copy-btn {\n    @include reset;\n\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    background-color: $layer;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n\n    &:active {\n      background-color: $layer-active;\n    }\n\n    &::before {\n      @include tooltip--caret;\n\n      display: none;\n    }\n\n    .#{$prefix}--copy-btn__feedback {\n      @include tooltip--content('icon');\n\n      display: none;\n      overflow: visible;\n      box-sizing: content-box;\n      margin: auto;\n      clip: auto;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n\n      outline-color: $focus;\n    }\n\n    &.#{$prefix}--copy-btn--animating::before,\n    &.#{$prefix}--copy-btn--animating .#{$prefix}--copy-btn__feedback {\n      display: block;\n    }\n\n    &.#{$prefix}--copy-btn--animating::before {\n      border: none;\n    }\n\n    &.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-out::before,\n    &.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-out\n      .#{$prefix}--copy-btn__feedback {\n      // https://github.com/stylelint/stylelint/issues/2363\n      animation: $duration-fast-02 motion(standard, productive) #{$prefix}--hide-feedback;\n    }\n\n    &.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-in::before,\n    &.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-in\n      .#{$prefix}--copy-btn__feedback {\n      animation: $duration-fast-02 motion(standard, productive) #{$prefix}--show-feedback;\n    }\n  }\n\n  .#{$prefix}--copy-btn svg {\n    fill: $icon-primary;\n  }\n\n  // Needs to come after reset so hidden text is not set to font-size: 100%\n  .#{$prefix}--copy {\n    font-size: 0;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'mixins' as *;\n@use '../copy-button';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../layer' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/keyframes' as *;\n@use '../../utilities/layout' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/tooltip' as *;\n@use '../../utilities/z-index' as *;\n\n/// @type Color\n/// @access public\n/// @group copy-button\n$copy-active: $layer-active !default;\n\n/// @type Color\n/// @access public\n/// @group copy-button\n$copy-btn-feedback: $background-inverse !default;\n\n@mixin code-snippet {\n  .#{$prefix}--snippet {\n    @include reset;\n  }\n\n  .#{$prefix}--snippet--disabled,\n  .#{$prefix}--snippet--disabled\n    .#{$prefix}--btn.#{$prefix}--snippet-btn--expand {\n    background-color: $layer;\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--snippet--disabled .#{$prefix}--snippet-btn--expand:hover,\n  .#{$prefix}--snippet--disabled .#{$prefix}--copy-btn,\n  .#{$prefix}--snippet--disabled .#{$prefix}--copy-btn:hover {\n    background-color: $layer;\n    color: $text-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--snippet--disabled .#{$prefix}--snippet__icon,\n  .#{$prefix}--snippet--disabled\n    .#{$prefix}--snippet-btn--expand\n    .#{$prefix}--icon-chevron--down {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--snippet code {\n    @include type-style('code-01');\n  }\n\n  // Inline Code Snippet\n  .#{$prefix}--snippet--inline {\n    @include reset;\n\n    position: relative;\n    display: inline;\n    padding: 0;\n    border: 1px solid transparent;\n    border-radius: 4px;\n    background-color: $layer;\n    color: $text-primary;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n\n    &:active {\n      background-color: $layer-active;\n    }\n\n    &:focus {\n      border: 1px solid $focus;\n      outline: none;\n    }\n\n    &::before {\n      @include tooltip--caret;\n\n      display: none;\n\n      border: none;\n    }\n\n    .#{$prefix}--copy-btn__feedback {\n      @include tooltip--content('icon');\n\n      display: none;\n      overflow: visible;\n      box-sizing: content-box;\n      margin: auto;\n      clip: auto;\n    }\n  }\n\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating::before,\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating\n    .#{$prefix}--copy-btn__feedback {\n    display: block;\n  }\n\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-out::before,\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-out\n    .#{$prefix}--copy-btn__feedback {\n    animation: $duration-fast-02 motion(standard, productive) #{$prefix}--hide-feedback;\n  }\n\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-in::before,\n  .#{$prefix}--snippet--inline.#{$prefix}--copy-btn--animating.#{$prefix}--copy-btn--fade-in\n    .#{$prefix}--copy-btn__feedback {\n    animation: $duration-fast-02 motion(standard, productive) #{$prefix}--show-feedback;\n  }\n\n  .#{$prefix}--snippet--inline code {\n    padding: 0 $spacing-03;\n  }\n\n  .#{$prefix}--snippet--inline.#{$prefix}--snippet--no-copy {\n    display: inline-block;\n\n    &:hover {\n      background-color: $layer;\n      cursor: auto;\n    }\n  }\n\n  .#{$prefix}--snippet--light.#{$prefix}--snippet--inline.#{$prefix}--snippet--no-copy:hover {\n    background-color: $layer-hover;\n    cursor: auto;\n  }\n\n  // Single Line Snippet\n  .#{$prefix}--snippet--single {\n    @include bx--snippet;\n\n    display: flex;\n    align-items: center;\n    block-size: $spacing-08;\n    padding-inline-end: $spacing-08;\n  }\n\n  .#{$prefix}--snippet--single.#{$prefix}--snippet--no-copy {\n    padding: 0;\n\n    &::after {\n      inset-inline-end: $spacing-05;\n    }\n  }\n\n  .#{$prefix}--snippet--single .#{$prefix}--snippet-container {\n    position: relative;\n    display: flex;\n    align-items: center;\n    block-size: 100%;\n    overflow-x: auto;\n    padding-inline-start: $spacing-05;\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  .#{$prefix}--snippet--single pre {\n    @include type-style('code-01');\n\n    padding-inline-end: $spacing-07;\n  }\n\n  // Preserve whitespace, but don't allow wrapping for inline and single\n  .#{$prefix}--snippet--single pre,\n  .#{$prefix}--snippet--inline code {\n    white-space: pre;\n  }\n\n  // Multi Line Snippet\n  .#{$prefix}--snippet--multi {\n    @include bx--snippet;\n\n    display: flex;\n    padding: $spacing-05;\n  }\n\n  //collapsed snippet container\n  .#{$prefix}--snippet--multi .#{$prefix}--snippet-container {\n    position: relative;\n    order: 1;\n    max-block-size: 100%;\n    min-block-size: 100%;\n    overflow-y: auto;\n    transition: max-height $duration-moderate-01 motion(standard, productive);\n\n    &:focus {\n      @include focus-outline('outline');\n\n      outline-offset: 0;\n    }\n  }\n\n  // expanded snippet container\n  .#{$prefix}--snippet--multi.#{$prefix}--snippet--expand\n    .#{$prefix}--snippet-container {\n    padding-block-end: $spacing-05;\n    transition: max-height $duration-moderate-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--snippet--multi.#{$prefix}--snippet--wraptext pre {\n    white-space: pre-wrap;\n    word-wrap: break-word;\n  }\n\n  .#{$prefix}--snippet--multi .#{$prefix}--snippet-container pre {\n    overflow: auto;\n    padding-block-end: $spacing-06;\n    padding-inline-end: $spacing-06;\n  }\n\n  .#{$prefix}--snippet--multi.#{$prefix}--snippet--no-copy\n    .#{$prefix}--snippet-container\n    pre {\n    padding-inline-end: 0;\n  }\n\n  [dir='rtl']\n    .#{$prefix}--snippet--multi.#{$prefix}--snippet--has-right-overflow::after {\n    background-image: linear-gradient(to left, transparent, $layer);\n  }\n\n  .#{$prefix}--snippet--multi .#{$prefix}--snippet-container pre code {\n    overflow: hidden;\n  }\n\n  //Copy Button\n  .#{$prefix}--snippet__icon {\n    block-size: convert.to-rem(16px);\n    fill: $icon-primary;\n    inline-size: convert.to-rem(16px);\n    transition: all $duration-fast-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--btn > .#{$prefix}--snippet__icon {\n    margin-block-start: 0;\n  }\n\n  .#{$prefix}--copy-btn {\n    @include reset;\n\n    display: flex;\n    overflow: visible;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    background-color: $layer;\n    cursor: pointer;\n    outline: none;\n\n    &:focus {\n      @include focus-outline('outline');\n\n      outline-color: $focus;\n    }\n  }\n\n  // TODO: remove copy button styles above\n  .#{$prefix}--snippet .#{$prefix}--popover-container {\n    @include font-family('sans');\n\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-end: 0;\n  }\n\n  // Overrides for codesnippet copy btn\n  // TLDR: Copy/CopyButton now uses IconButton, which uses Carbon buttons under the hood\n  // v10 Copy just used native html button so it didn't have extra carbon styles that needed overriding\n  .#{$prefix}--snippet--inline.#{$prefix}--btn {\n    block-size: 1.25rem;\n    inline-size: initial;\n    max-inline-size: unset;\n    min-block-size: 1.25rem;\n    padding-inline: 0;\n  }\n\n  .#{$prefix}--snippet--inline.#{$prefix}--btn.#{$prefix}--btn--primary:hover {\n    color: $text-primary;\n  }\n\n  // override multi copy btn styles\n  .#{$prefix}--snippet.#{$prefix}--snippet--multi\n    .#{$prefix}--popover-container {\n    inset-block-start: 0.5rem;\n    inset-inline-end: 0.5rem;\n  }\n\n  .#{$prefix}--snippet--multi .#{$prefix}--copy-btn {\n    z-index: 10;\n  }\n\n  // Show more / less button\n  .#{$prefix}--snippet-btn--expand {\n    @include type-style('body-compact-01');\n    @include font-family('sans');\n\n    position: absolute;\n    z-index: 10;\n    display: inline-flex;\n    align-items: center;\n\n    padding: $spacing-03 $spacing-05;\n    border: 0;\n    background-color: $layer;\n    block-size: convert.to-rem(32px);\n    color: $text-primary;\n    inset-block-end: 0;\n    inset-inline-end: 0;\n  }\n\n  .#{$prefix}--snippet-btn--expand .#{$prefix}--snippet-btn--text {\n    position: relative;\n    inset-block-start: convert.to-rem(-1px);\n  }\n\n  .#{$prefix}--snippet-btn--expand--hide.#{$prefix}--snippet-btn--expand {\n    display: none;\n  }\n\n  .#{$prefix}--snippet-btn--expand .#{$prefix}--icon-chevron--down {\n    fill: $icon-primary;\n    margin-inline-start: $spacing-03;\n    transform: rotate(0deg);\n    transition: $duration-moderate-01 motion(standard, productive);\n  }\n\n  .#{$prefix}--snippet-btn--expand:hover {\n    background: $layer-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--snippet-btn--expand:active {\n    background-color: $layer-active;\n  }\n\n  .#{$prefix}--snippet-btn--expand:focus {\n    @include focus-outline('outline');\n\n    border-color: transparent;\n  }\n\n  .#{$prefix}--snippet--expand\n    .#{$prefix}--snippet-btn--expand\n    .#{$prefix}--icon-chevron--down {\n    transform: rotate(180deg);\n    transition: transform $transition-expansion;\n  }\n\n  // Light version\n  .#{$prefix}--snippet--light,\n  .#{$prefix}--snippet--light .#{$prefix}--snippet-button,\n  .#{$prefix}--snippet--light .#{$prefix}--btn.#{$prefix}--snippet-btn--expand,\n  .#{$prefix}--snippet--light .#{$prefix}--copy-btn {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--snippet--light.#{$prefix}--snippet--inline:hover,\n  .#{$prefix}--snippet--light .#{$prefix}--snippet-button:hover,\n  .#{$prefix}--snippet--light\n    .#{$prefix}--btn.#{$prefix}--snippet-btn--expand:hover,\n  .#{$prefix}--snippet--light .#{$prefix}--copy-btn:hover {\n    background-color: $layer-hover;\n  }\n\n  .#{$prefix}--snippet--light.#{$prefix}--snippet--inline:active,\n  .#{$prefix}--snippet--light .#{$prefix}--snippet-button:active,\n  .#{$prefix}--snippet--light\n    .#{$prefix}--btn.#{$prefix}--snippet-btn--expand:active,\n  .#{$prefix}--snippet--light .#{$prefix}--copy-btn:active {\n    background-color: $layer-active;\n  }\n\n  // Skeleton State\n  .#{$prefix}--snippet.#{$prefix}--skeleton .#{$prefix}--snippet-container {\n    block-size: 100%;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--snippet-button .#{$prefix}--btn--copy__feedback {\n    // (The height of button) + (The height of the tooltip's triangle) + 4px\n    inset-block-start: convert.to-rem(50.8px);\n    inset-inline: 50% auto;\n\n    &::before {\n      inset-block-start: 0;\n    }\n\n    &::after {\n      inset-block-start: convert.to-rem(-4px);\n    }\n  }\n\n  .#{$prefix}--snippet--multi\n    .#{$prefix}--snippet-button\n    .#{$prefix}--btn--copy__feedback {\n    // (The height of button) + (The height of the tooltip's triangle) + 4px\n    inset-block-start: convert.to-rem(42.8px);\n  }\n\n  .#{$prefix}--snippet--inline .#{$prefix}--btn--copy__feedback {\n    // TODO: use updated global tooltip mixins under the hood\n    // since all of the positioning values for the copy button tooltip are arbitrary hard coded rem values, we need this arbitrary 4px offset to keep the proper tooltip spacing according to the spec\n    inset-block-start: calc(100% - #{convert.to-rem(4px)});\n    inset-inline: 50% auto;\n  }\n\n  // Using mask-image for single line snippet\n  .#{$prefix}--snippet--single .#{$prefix}--snippet-container {\n    mask-image: linear-gradient(\n      to right,\n      #000000 calc(100% - #{$spacing-07}),\n      transparent 100%\n    );\n    pointer-events: auto;\n  }\n\n  .#{$prefix}--snippet--multi {\n    position: relative;\n  }\n\n  .#{$prefix}--snippet--multi .#{$prefix}--snippet-container {\n    inline-size: 100%;\n    mask-composite: intersect;\n    mask-image: linear-gradient(\n        to right,\n        #000000 calc(100% - #{$spacing-07}),\n        transparent 100%\n      ),\n      linear-gradient(\n        to bottom,\n        #000000 calc(100% - #{$spacing-05}),\n        transparent 100%\n      );\n    pointer-events: auto;\n  }\n\n  [dir='rtl'] .#{$prefix}--snippet--single .#{$prefix}--snippet-container {\n    mask-image: linear-gradient(\n      to left,\n      #000000 calc(100% - #{$spacing-07}),\n      transparent 100%\n    );\n  }\n\n  [dir='rtl'] .#{$prefix}--snippet--multi .#{$prefix}--snippet-container {\n    mask-image: linear-gradient(\n        to left,\n        #000000 calc(100% - #{$spacing-07}),\n        transparent 100%\n      ),\n      linear-gradient(\n        to bottom,\n        #000000 calc(100% - #{$spacing-05}),\n        transparent 100%\n      );\n  }\n\n  .#{$prefix}--snippet--single:focus-within .#{$prefix}--snippet-container,\n  .#{$prefix}--snippet--multi:focus-within .#{$prefix}--snippet-container {\n    mask-image: none;\n  }\n\n  .#{$prefix}--snippet--multi.#{$prefix}--skeleton {\n    block-size: convert.to-rem(98px);\n  }\n\n  .#{$prefix}--snippet--single.#{$prefix}--skeleton {\n    block-size: convert.to-rem(56px);\n  }\n\n  .#{$prefix}--snippet.#{$prefix}--skeleton span {\n    @include skeleton;\n\n    display: block;\n    block-size: 1rem;\n    inline-size: 100%;\n    margin-block-start: 0.5rem;\n\n    &:first-child {\n      margin: 0;\n    }\n\n    &:nth-child(2) {\n      inline-size: 85%;\n    }\n\n    &:nth-child(3) {\n      inline-size: 95%;\n    }\n  }\n\n  .#{$prefix}--snippet--single.#{$prefix}--skeleton\n    .#{$prefix}--snippet-container {\n    padding-block-end: 0;\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--snippet--inline:focus {\n    @include high-contrast-mode('focus');\n  }\n\n  .#{$prefix}--snippet--single,\n  .#{$prefix}--snippet--multi {\n    @include high-contrast-mode('outline');\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/convert';\n\n/// Code snippet base styles\n/// @access private\n/// @group code-snippet\n@mixin bx--snippet {\n  @include type-style('code-01');\n\n  position: relative;\n  background-color: $layer;\n  inline-size: 100%;\n  max-inline-size: convert.to-rem(768px);\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/layout';\n@use './tokens' as *;\n@use '../button/tokens' as *;\n\n@mixin content-switcher {\n  .#{$prefix}--content-switcher {\n    @include layout.use('size', $default: 'md', $min: 'sm', $max: 'lg');\n    @include layout.use('density', $default: 'normal');\n\n    display: flex;\n    justify-content: space-evenly;\n    border-radius: convert.to-rem(4px);\n    block-size: layout.size('height');\n    inline-size: 100%;\n    outline: convert.to-rem(1px) solid $border-inverse;\n    outline-offset: convert.to-rem(-1px);\n  }\n\n  .#{$prefix}--content-switcher:has(\n      .#{$prefix}--content-switcher-btn:disabled\n    ) {\n    outline-color: $border-disabled;\n  }\n\n  .#{$prefix}--content-switcher-btn {\n    @include reset;\n    @include font-family('sans');\n    @include focus-outline('reset');\n    @include type-style('body-compact-01');\n\n    position: relative;\n    display: inline-flex;\n    overflow: hidden;\n    border: none;\n    margin: 0;\n    background-color: transparent;\n    border-block-end: convert.to-rem(1px) solid $border-inverse;\n    border-block-start: convert.to-rem(1px) solid $border-inverse;\n    color: $text-secondary;\n    text-align: start;\n    text-decoration: none;\n    white-space: nowrap;\n\n    &::after {\n      position: absolute;\n      display: block;\n      border-radius: convert.to-rem(4px);\n      background-color: $layer-selected-inverse;\n      block-size: 100%;\n      content: '';\n      inline-size: 100%;\n      inset-block-start: 0;\n      inset-inline-start: 0;\n      transform: scaleY(0);\n      transform-origin: bottom;\n    }\n\n    &:disabled::after {\n      display: none;\n    }\n\n    &:focus {\n      border: 0;\n    }\n\n    &:focus::after {\n      border-radius: convert.to-rem(4px);\n      box-shadow:\n        inset 0 0 0 2px $focus,\n        inset 0 0 0 3px $focus-inset;\n    }\n\n    &:hover {\n      color: $text-primary;\n      cursor: pointer;\n    }\n\n    &:hover,\n    &:active {\n      z-index: 3;\n      background-color: $layer-hover;\n      color: $text-primary;\n    }\n\n    &:disabled {\n      border-color: $border-disabled;\n      background-color: transparent;\n      color: $text-disabled;\n\n      &:hover {\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher--selected\n    ) {\n    &:focus::before {\n      display: block;\n      border-radius: convert.to-rem(4px);\n      block-size: 100%;\n      box-shadow: inset 0 0 0 convert.to-rem(2px) $focus;\n      content: '';\n      inline-size: 100%;\n    }\n\n    &:focus::after {\n      background-color: $focus-inset;\n      transform: scaleY(1);\n    }\n\n    &:focus:hover::after {\n      border-radius: 0;\n      background-color: $layer-hover;\n      border-block-end: convert.to-rem(1px) solid $border-inverse;\n      border-block-start: convert.to-rem(1px) solid $border-inverse;\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher:not(.#{$prefix}--content-switcher--icon-only)\n    .#{$prefix}--content-switcher-btn {\n    align-items: center;\n    padding: $spacing-03 layout.density('padding-inline');\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--content-switcher:not(.#{$prefix}--content-switcher--icon-only)\n    .#{$prefix}--content-switcher-btn:first-child {\n    border-end-start-radius: convert.to-rem(4px);\n    border-start-start-radius: convert.to-rem(4px);\n    box-shadow: inset convert.to-rem(1px) 0 0 0 $border-inverse;\n\n    &:disabled {\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher:not(.#{$prefix}--content-switcher--icon-only)\n    .#{$prefix}--content-switcher-btn:last-child {\n    border-end-end-radius: convert.to-rem(4px);\n    border-start-end-radius: convert.to-rem(4px);\n    box-shadow: inset convert.to-rem(-1px) 0 0 0 $border-inverse;\n\n    &:disabled {\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected,\n  .#{$prefix}--content-switcher\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:first-child,\n  .#{$prefix}--content-switcher\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:last-child {\n    border: 0;\n\n    &:disabled::before {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher-btn::before {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    background-color: $border-subtle;\n    block-size: convert.to-rem(16px);\n    content: '';\n    inline-size: convert.to-rem(1px);\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--content-switcher:not(.#{$prefix}--content-switcher--icon-only)\n    .#{$prefix}--content-switcher-btn:first-of-type::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher-btn:focus::before,\n  .#{$prefix}--content-switcher-btn:focus\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher-btn:hover::before,\n  .#{$prefix}--content-switcher-btn:hover\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--selected::before,\n  .#{$prefix}--content-switcher--selected\n    + .#{$prefix}--content-switcher-btn::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher-btn:disabled::before,\n  .#{$prefix}--content-switcher-btn:disabled:hover\n    + .#{$prefix}--content-switcher-btn:disabled::before {\n    background-color: $border-disabled;\n  }\n\n  .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:disabled\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:disabled:hover\n    + .#{$prefix}--content-switcher-btn::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher__icon {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--content-switcher__icon + span {\n    margin-inline-start: $spacing-03;\n  }\n\n  .#{$prefix}--content-switcher__label {\n    z-index: 1;\n    overflow: hidden;\n    max-inline-size: 100%;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--content-switcher-btn:hover .#{$prefix}--content-switcher__icon,\n  .#{$prefix}--content-switcher-btn:focus .#{$prefix}--content-switcher__icon {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--content-switcher-btn:focus:has(\n      + .#{$prefix}--content-switcher-btn:not(\n          .#{$prefix}--content-switcher--selected\n        ):hover\n    ),\n  .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher--selected\n    ):hover\n    + .#{$prefix}--content-switcher-btn:focus,\n  .#{$prefix}--content-switcher-btn:hover\n    + .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected,\n  .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:has(\n      + .#{$prefix}--content-switcher-btn:hover\n    ) {\n    &::before {\n      z-index: 0;\n      border-radius: 0;\n      block-size: 100%;\n      border-block-end: convert.to-rem(1px) solid $border-inverse;\n      border-block-start: convert.to-rem(1px) solid $border-inverse;\n      box-shadow: inset 0 0 0 convert.to-rem(1px) $layer-hover;\n      content: '';\n      inline-size: 100%;\n    }\n\n    &:not(.#{$prefix}--content-switcher--selected)::after {\n      background-color: $focus-inset;\n      transform: scaleY(1);\n    }\n  }\n\n  .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected {\n    z-index: 3;\n    color: $text-inverse;\n\n    &:hover {\n      background-color: transparent;\n    }\n\n    &:disabled {\n      border-radius: convert.to-rem(4px);\n      background-color: $button-disabled;\n      color: $text-disabled;\n    }\n\n    &::after {\n      transform: scaleY(1);\n    }\n  }\n\n  .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected\n    .#{$prefix}--content-switcher__icon {\n    fill: $icon-inverse;\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--content-switcher-btn:focus {\n    @include high-contrast-mode('focus');\n  }\n\n  // Icon Only overrides\n  .#{$prefix}--content-switcher--icon-only {\n    justify-content: flex-start;\n    inline-size: fit-content;\n  }\n\n  .#{$prefix}--content-switcher--icon-only .#{$prefix}--content-switcher-btn {\n    align-items: center;\n    padding: 0;\n    transition: none;\n\n    &:focus {\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:first-child\n    .#{$prefix}--content-switcher-btn:first-of-type::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:first-child\n    .#{$prefix}--content-switcher-btn {\n    border-end-start-radius: convert.to-rem(4px);\n    border-start-start-radius: convert.to-rem(4px);\n    box-shadow: inset convert.to-rem(1px) 0 0 0 $border-inverse;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:last-child\n    .#{$prefix}--content-switcher-btn {\n    border-end-end-radius: convert.to-rem(4px);\n    border-start-end-radius: convert.to-rem(4px);\n    box-shadow: inset convert.to-rem(-1px) 0 0 0 $border-inverse;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:first-child\n    .#{$prefix}--content-switcher-btn[disabled],\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:last-child\n    .#{$prefix}--content-switcher-btn[disabled] {\n    box-shadow: none;\n  }\n\n  .#{$prefix}--content-switcher--lg .#{$prefix}--content-switcher-btn {\n    // accounts for the larger icon sizes to keep the switcher at 48px\n    padding-inline: convert.to-rem(14px) convert.to-rem(14px);\n  }\n\n  .#{$prefix}--content-switcher--lg .#{$prefix}--content-switcher-btn svg {\n    block-size: 20px;\n    inline-size: 20px;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn\n    svg {\n    z-index: 1;\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected\n    svg {\n    z-index: 1;\n    fill: $icon-inverse;\n  }\n\n  .#{$prefix}--content-switcher--icon-only.#{$prefix}--content-switcher--sm\n    .#{$prefix}--btn--sm {\n    block-size: 2rem;\n  }\n\n  // Subtle border overrides\n\n  .#{$prefix}--content-switcher-btn:focus::before,\n  .#{$prefix}--content-switcher-popover__wrapper:focus-within\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher-popover__wrapper:not(\n      .#{$prefix}--content-switcher-popover--disabled\n    ):hover\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher--selected\n    ):not(:focus)::before,\n  .#{$prefix}--content-switcher--selected::before,\n  .#{$prefix}--content-switcher-popover--selected\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn[disabled]\n    svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn[disabled]:not(\n      .#{$prefix}--content-switcher--selected\n    ):hover,\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover--selected\n    + .#{$prefix}--content-switcher-popover--disabled\n    .#{$prefix}--content-switcher-btn[disabled]:hover::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn[disabled]:hover::before {\n    background-color: $border-subtle;\n  }\n\n  .#{$prefix}--content-switcher-popover__wrapper:has(\n      + .#{$prefix}--content-switcher-popover__wrapper\n        .#{$prefix}--content-switcher-btn:not(\n          .#{$prefix}--content-switcher--selected\n        ):hover\n    )\n    .#{$prefix}--content-switcher-btn:focus,\n  .#{$prefix}--content-switcher-popover__wrapper:not(\n      .#{$prefix}--content-switcher-popover--selected\n    ):hover\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn:focus,\n  .#{$prefix}--content-switcher-popover__wrapper:hover\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher--selected,\n  .#{$prefix}--content-switcher-popover--selected:has(\n      + .#{$prefix}--content-switcher-popover__wrapper\n        .#{$prefix}--content-switcher-btn:hover\n    )\n    .#{$prefix}--content-switcher-btn {\n    &::before {\n      z-index: 0;\n      border-radius: 0;\n      block-size: 100%;\n      border-block-end: convert.to-rem(1px) solid $border-inverse;\n      border-block-start: convert.to-rem(1px) solid $border-inverse;\n      box-shadow: inset 0 0 0 convert.to-rem(1px) $layer-hover;\n      content: '';\n      inline-size: 100%;\n    }\n\n    &:not(.#{$prefix}--content-switcher--selected)::after {\n      background-color: $focus-inset;\n      transform: scaleY(1);\n    }\n  }\n\n  // Low contrast selected state styling\n  .#{$prefix}--content-switcher--low-contrast {\n    background-color: $content-switcher-background;\n    outline-color: $border-strong;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn {\n    border-color: $border-strong;\n\n    &:hover,\n    &:active {\n      background-color: $content-switcher-background-hover;\n    }\n\n    &::before {\n      background-color: $border-strong;\n    }\n\n    &::after {\n      background-color: $content-switcher-selected;\n    }\n\n    &:disabled {\n      border-color: $border-disabled;\n      background-color: transparent;\n      color: $text-disabled;\n\n      &:hover {\n        cursor: not-allowed;\n      }\n    }\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher--selected\n    ) {\n    &:focus::before {\n      background: transparent;\n    }\n\n    &:focus::after {\n      background-color: $content-switcher-background;\n      box-shadow: inset 0 0 0 convert.to-rem(2px) $focus;\n    }\n\n    &:focus:hover::after {\n      border-color: $border-strong;\n      background-color: $content-switcher-background-hover;\n      box-shadow: none;\n    }\n  }\n\n  .#{$prefix}--content-switcher--low-contrast:not(\n      .#{$prefix}--content-switcher--icon-only\n    )\n    .#{$prefix}--content-switcher-btn:first-child {\n    box-shadow: inset convert.to-rem(1px) 0 0 0 $border-strong;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast:not(\n      .#{$prefix}--content-switcher--icon-only\n    )\n    .#{$prefix}--content-switcher-btn:last-child {\n    box-shadow: inset convert.to-rem(-1px) 0 0 0 $border-strong;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast {\n    .#{$prefix}--content-switcher-btn:focus:has(\n        + .#{$prefix}--content-switcher-btn:not(\n            .#{$prefix}--content-switcher--selected\n          ):hover\n      ),\n    .#{$prefix}--content-switcher-btn:not(\n        .#{$prefix}--content-switcher--selected\n      ):hover\n      + .#{$prefix}--content-switcher-btn:focus,\n    .#{$prefix}--content-switcher-btn:hover\n      + .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected,\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:has(\n        + .#{$prefix}--content-switcher-btn:hover\n      ) {\n      &::before {\n        border-color: $border-strong;\n        box-shadow: inset 0 0 0 convert.to-rem(1px)\n          $content-switcher-background-hover;\n      }\n\n      &:not(.#{$prefix}--content-switcher--selected)::after {\n        background-color: $content-switcher-background;\n      }\n    }\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected {\n    @include type-style('heading-compact-01');\n\n    color: $text-primary;\n\n    &:hover {\n      background-color: transparent;\n    }\n\n    &::after {\n      border-radius: convert.to-rem(4px);\n      background-color: $content-switcher-selected;\n      box-shadow: inset 0 0 0 convert.to-rem(1px) $border-inverse;\n    }\n\n    &:focus::after {\n      box-shadow: inset 0 0 0 convert.to-rem(2px) $focus;\n    }\n\n    &:disabled {\n      border: convert.to-rem(1px) solid $border-disabled;\n      border-radius: convert.to-rem(4px);\n      background-color: $content-switcher-selected;\n      color: $text-disabled;\n    }\n\n    &:disabled::before {\n      background-color: transparent;\n    }\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:focus::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:focus\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:hover::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:hover\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher--selected::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher--selected\n    + .#{$prefix}--content-switcher-btn::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:disabled::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:disabled:hover\n    + .#{$prefix}--content-switcher-btn:disabled::before {\n    background-color: $border-disabled;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:disabled\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:disabled:hover\n    + .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:disabled:hover\n    + .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected::before {\n    background-color: transparent;\n  }\n\n  // low contrast icons\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:first-child\n    .#{$prefix}--content-switcher-btn:not([disabled]) {\n    box-shadow: inset convert.to-rem(1px) 0 0 0 $border-strong;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-popover__wrapper:last-child\n    .#{$prefix}--content-switcher-btn:not([disabled]) {\n    box-shadow: inset convert.to-rem(-1px) 0 0 0 $border-strong;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn\n    svg {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn:hover\n    svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn[disabled]\n    svg {\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected\n    svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected[disabled]\n    svg {\n    fill: $icon-disabled;\n  }\n  .#{$prefix}--content-switcher--low-contrast.#{$prefix}--content-switcher--icon-only\n    .#{$prefix}--content-switcher-btn.#{$prefix}--content-switcher--selected:disabled {\n    border-color: $border-disabled;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher__selected-hovered\n    ):focus::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-popover__wrapper:focus-within\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-popover__wrapper:not(\n      .#{$prefix}--content-switcher-popover--disabled\n    ):hover\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn:not(\n      .#{$prefix}--content-switcher__selected-hovered\n    )::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher--selected:not(\n      .#{$prefix}--content-switcher__selected-hovered\n    )::before,\n  .#{$prefix}--content-switcher--low-contrast\n    .#{$prefix}--content-switcher-popover--selected\n    + .#{$prefix}--content-switcher-popover__wrapper\n    .#{$prefix}--content-switcher-btn::before {\n    background-color: transparent;\n  }\n\n  .#{$prefix}--content-switcher--low-contrast {\n    .#{$prefix}--content-switcher-popover__wrapper:has(\n        + .#{$prefix}--content-switcher-popover__wrapper\n          .#{$prefix}--content-switcher-btn:not(\n            .#{$prefix}--content-switcher--selected\n          ):hover\n      )\n      .#{$prefix}--content-switcher-btn:focus,\n    .#{$prefix}--content-switcher-popover__wrapper:not(\n        .#{$prefix}--content-switcher-popover--selected\n      ):hover\n      + .#{$prefix}--content-switcher-popover__wrapper\n      .#{$prefix}--content-switcher-btn:focus,\n    .#{$prefix}--content-switcher-popover__wrapper:hover\n      + .#{$prefix}--content-switcher-popover__wrapper\n      .#{$prefix}--content-switcher--selected,\n    .#{$prefix}--content-switcher-popover--selected:has(\n        + .#{$prefix}--content-switcher-popover__wrapper\n          .#{$prefix}--content-switcher-btn:hover\n      )\n      .#{$prefix}--content-switcher-btn {\n      &::before {\n        border-color: $border-strong;\n        box-shadow: inset 0 0 0 convert.to-rem(1px)\n          $content-switcher-background-hover;\n      }\n\n      &:not(.#{$prefix}--content-switcher--selected)::after {\n        background-color: $content-switcher-background;\n      }\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:color';\n@use 'sass:map';\n@use '../../config';\n@use '../../colors';\n@use '../../themes';\n@use '../../theme' as *;\n@use '../../utilities/component-tokens';\n@use '@carbon/themes/scss/component-tokens' as content-switcher;\n\n// content-switcher-background\n$content-switcher-background: (\n  fallback: map.get(content-switcher.$content-switcher-background, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(content-switcher.$content-switcher-background, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(content-switcher.$content-switcher-background, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(content-switcher.$content-switcher-background, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(content-switcher.$content-switcher-background, g-100),\n    ),\n  ),\n) !default;\n\n// content-switcher-background-hover\n$content-switcher-background-hover: (\n  fallback:\n    map.get(content-switcher.$content-switcher-background-hover, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value:\n        map.get(\n          content-switcher.$content-switcher-background-hover,\n          white-theme\n        ),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(content-switcher.$content-switcher-background-hover, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(content-switcher.$content-switcher-background-hover, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(content-switcher.$content-switcher-background-hover, g-100),\n    ),\n  ),\n) !default;\n\n// content-switcher-selected\n$content-switcher-selected: (\n  fallback: map.get(content-switcher.$content-switcher-selected, white-theme),\n  values: (\n    (\n      theme: themes.$white,\n      value: map.get(content-switcher.$content-switcher-selected, white-theme),\n    ),\n    (\n      theme: themes.$g10,\n      value: map.get(content-switcher.$content-switcher-selected, g-10),\n    ),\n    (\n      theme: themes.$g90,\n      value: map.get(content-switcher.$content-switcher-selected, g-90),\n    ),\n    (\n      theme: themes.$g100,\n      value: map.get(content-switcher.$content-switcher-selected, g-100),\n    ),\n  ),\n) !default;\n\n// Add to $content-switcher-tokens map\n$content-switcher-tokens: (\n  content-switcher-background: $content-switcher-background,\n  content-switcher-background-hover: $content-switcher-background-hover,\n  content-switcher-selected: $content-switcher-selected,\n);\n\n// Generate CSS custom properties for each token\n$content-switcher-background: component-tokens.get-var(\n  $content-switcher-background,\n  'content-switcher-background'\n);\n$content-switcher-background-hover: component-tokens.get-var(\n  $content-switcher-background-hover,\n  'content-switcher-background-hover'\n);\n$content-switcher-selected: component-tokens.get-var(\n  $content-switcher-selected,\n  'content-switcher-selected'\n);\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../tooltip';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/convert';\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/component-reset';\n@use '../../utilities/tooltip' as *;\n\n/// @type Value\n/// @access public\n/// @group progress-indicator\n$progress-indicator-bar-width: 1px inset transparent !default;\n\n/// Progress indicator styles\n/// @access public\n/// @group progress-indicator\n@mixin progress-indicator {\n  .#{$prefix}--progress {\n    @include component-reset.reset;\n\n    display: flex;\n    list-style: none;\n  }\n\n  .#{$prefix}--progress-step {\n    position: relative;\n    display: inline-flex;\n    overflow: visible;\n    flex-direction: row;\n    inline-size: convert.to-rem(128px);\n    min-inline-size: 7rem;\n\n    .#{$prefix}--tooltip__label {\n      display: block;\n    }\n  }\n\n  .#{$prefix}--progress--space-equal .#{$prefix}--progress-step {\n    flex-grow: 1;\n    min-inline-size: 8rem;\n  }\n\n  .#{$prefix}--progress-line {\n    position: absolute;\n    border: $progress-indicator-bar-width;\n    block-size: 2px;\n    inline-size: convert.to-rem(128px);\n    inset-inline-start: 0;\n  }\n\n  .#{$prefix}--progress--space-equal .#{$prefix}--progress-line {\n    inline-size: 100%;\n    min-inline-size: convert.to-rem(128px);\n  }\n\n  .#{$prefix}--progress-step svg {\n    position: relative;\n    z-index: 1;\n    flex-shrink: 0;\n    border-radius: 50%;\n    block-size: $spacing-05;\n    fill: $interactive;\n    inline-size: $spacing-05;\n    margin-block-start: convert.to-rem(10px);\n    margin-inline-end: $spacing-03;\n  }\n\n  .#{$prefix}--progress--space-equal .#{$prefix}--progress-text {\n    overflow: hidden;\n    padding: $spacing-01;\n    margin: -$spacing-01;\n  }\n\n  .#{$prefix}--progress-label {\n    @include type-style('body-compact-01');\n\n    display: block;\n    overflow: hidden;\n    margin: $spacing-03 0 0 0;\n    color: $text-primary;\n    line-height: 1.45;\n    max-inline-size: convert.to-rem(88px);\n    text-overflow: ellipsis;\n    transition:\n      box-shadow $duration-fast-02 motion(standard, productive),\n      color $duration-fast-02 motion(standard, productive);\n    white-space: nowrap;\n\n    &::before {\n      display: block;\n      content: '';\n    }\n  }\n\n  .#{$prefix}--progress-label:hover {\n    box-shadow: 0 convert.to-rem(1px) $link-primary-hover;\n    color: $link-primary-hover;\n    cursor: pointer;\n  }\n\n  .#{$prefix}--progress--space-equal .#{$prefix}--progress-label {\n    margin-inline-end: 0.75rem;\n    max-inline-size: 100%;\n  }\n\n  .#{$prefix}--progress-step-button {\n    &:focus {\n      outline: none;\n    }\n    &:focus-visible .#{$prefix}--progress-label {\n      color: $focus;\n      outline: convert.to-rem(1px) solid $focus;\n    }\n  }\n\n  .#{$prefix}--progress-step-button:not(\n      .#{$prefix}--progress-step-button--unclickable\n    )\n    .#{$prefix}--progress-label:active {\n    box-shadow: 0 convert.to-rem(1px) 0 0 $text-primary;\n    color: $text-primary;\n  }\n\n  //OVERFLOW STYLING\n  .#{$prefix}--progress-label-overflow:hover ~ .#{$prefix}--tooltip,\n  .#{$prefix}--progress-label-overflow:focus ~ .#{$prefix}--tooltip {\n    visibility: inherit;\n  }\n\n  .#{$prefix}--progress-step .#{$prefix}--tooltip .#{$prefix}--tooltip__caret {\n    margin-inline-start: convert.to-rem(10px);\n  }\n\n  .#{$prefix}--tooltip__text {\n    padding: 0;\n    margin: 0;\n    font-weight: normal;\n  }\n\n  //single line tooltip\n  .#{$prefix}--progress-step .#{$prefix}--tooltip {\n    @include type-style('body-01');\n\n    display: block;\n    padding: $spacing-03 $spacing-05;\n    color: $text-inverse;\n    inline-size: convert.to-rem(125px);\n    margin-block-start: convert.to-rem(40px);\n    margin-inline-start: convert.to-rem(22px);\n    min-block-size: $spacing-06;\n\n    min-inline-size: convert.to-rem(115px);\n    visibility: hidden;\n  }\n\n  //multiline tooltip\n  .#{$prefix}--progress-step .#{$prefix}--tooltip_multi {\n    @include type-style('body-01');\n\n    block-size: auto;\n    color: $text-inverse;\n\n    inline-size: convert.to-rem(150px);\n  }\n\n  //OPTIONAL HELPER TEXT STYLING\n  .#{$prefix}--progress-optional {\n    @include type-style('label-01');\n\n    position: absolute;\n    display: block;\n    color: $text-secondary;\n    inset-inline-start: 0;\n    margin-block-start: convert.to-rem(28px);\n    margin-inline-start: $spacing-06;\n    text-align: start;\n  }\n\n  //CURRENT STYLING\n  .#{$prefix}--progress-step--current {\n    .#{$prefix}--progress-line {\n      background-color: $interactive;\n    }\n  }\n\n  //INCOMPLETE STYLING\n  .#{$prefix}--progress-step--incomplete {\n    svg {\n      fill: $icon-primary;\n    }\n\n    .#{$prefix}--progress-line {\n      background-color: $border-subtle;\n    }\n  }\n\n  //COMPLETED STYLING\n  .#{$prefix}--progress-step--complete {\n    .#{$prefix}--progress-line {\n      background-color: $interactive;\n    }\n  }\n\n  //interactive button\n  .#{$prefix}--progress-step-button {\n    @include button-reset.reset;\n\n    display: flex;\n    text-align: start;\n  }\n\n  //unclickable button\n  .#{$prefix}--progress-step-button--unclickable {\n    cursor: default;\n    outline: none;\n  }\n\n  .#{$prefix}--progress-step-button--unclickable\n    .#{$prefix}--progress-label:hover {\n    box-shadow: none;\n    color: $text-primary;\n    cursor: default;\n  }\n\n  .#{$prefix}--progress-step-button--unclickable\n    .#{$prefix}--tooltip__label:hover {\n    box-shadow: 0 convert.to-rem(1px) $link-primary;\n    color: $link-primary;\n    cursor: pointer;\n  }\n\n  //DISABLED STYLING\n  .#{$prefix}--progress-step--disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n\n    svg {\n      cursor: not-allowed;\n      fill: $icon-disabled;\n    }\n\n    .#{$prefix}--progress-label,\n    .#{$prefix}--progress-label:hover {\n      box-shadow: none;\n      color: $text-disabled;\n      cursor: not-allowed;\n    }\n\n    .#{$prefix}--progress-line {\n      cursor: not-allowed;\n    }\n\n    .#{$prefix}--progress-label-overflow:hover\n      ~ .#{$prefix}--tooltip--definition\n      .#{$prefix}--tooltip--definition__bottom {\n      display: none;\n    }\n  }\n\n  // ERROR STYLING\n  .#{$prefix}--progress__warning > * {\n    fill: $support-error;\n  }\n\n  // Skeleton State\n  .#{$prefix}--progress.#{$prefix}--skeleton .#{$prefix}--progress-label {\n    @include skeleton;\n\n    block-size: convert.to-rem(14px);\n\n    inline-size: convert.to-rem(40px);\n\n    margin-block-start: 0.625rem;\n  }\n\n  .#{$prefix}--progress.#{$prefix}--progress--vertical.#{$prefix}--skeleton\n    .#{$prefix}--progress-label {\n    margin-block-start: 0.0625rem;\n  }\n\n  // Vertical Variant\n\n  .#{$prefix}--progress--vertical {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .#{$prefix}--progress--vertical,\n  .#{$prefix}--progress-text {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-step,\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-step-button {\n    align-content: flex-start;\n    inline-size: initial;\n    min-block-size: 3.625rem;\n    min-inline-size: initial;\n  }\n\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-step svg,\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-step-button svg {\n    display: inline-block;\n    // 1px top margin based on visual review\n    margin: convert.to-rem(1px) $spacing-03 0;\n  }\n\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-label {\n    display: inline-block;\n    margin: 0;\n    inline-size: initial;\n    max-inline-size: convert.to-rem(160px);\n    vertical-align: top;\n    white-space: initial;\n  }\n\n  .#{$prefix}--progress--vertical\n    .#{$prefix}--progress-step\n    .#{$prefix}--tooltip {\n    margin-block-start: 0.5rem;\n  }\n\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-optional {\n    position: static;\n    margin: 0 0 auto;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--progress--vertical .#{$prefix}--progress-line {\n    position: absolute;\n    block-size: 100%;\n    inline-size: 1px;\n    inset-block-start: 0;\n    inset-inline-start: 0;\n  }\n}\n","//\n// Copyright IBM Corp. 2020\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button/tokens' as button-tokens;\n@use '../../config' as *;\n@use '../../layer' as *;\n@use '../../motion' as *;\n@use '../../spacing' as *;\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/z-index' as *;\n@use '../../utilities/convert';\n@use '../../utilities/component-reset';\n\n/// Menu styles\n/// @access public\n/// @group menu\n@mixin menu {\n  // Menu\n\n  .#{$prefix}--menu {\n    @include component-reset.reset;\n    @include box-shadow;\n\n    position: fixed;\n    z-index: z('modal');\n    padding: $spacing-02 0;\n    background-color: $layer;\n    max-inline-size: 18rem;\n    min-inline-size: 10rem;\n    opacity: 0;\n    overflow-y: auto;\n    visibility: hidden;\n  }\n\n  .#{$prefix}--menu--border {\n    outline: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--menu--background-token__background {\n    background-color: $background;\n  }\n\n  .#{$prefix}--menu--with-icons {\n    min-inline-size: 12rem;\n  }\n\n  .#{$prefix}--menu--open {\n    visibility: visible;\n\n    &:focus {\n      @include focus-outline('border');\n    }\n  }\n\n  .#{$prefix}--menu:not(.#{$prefix}--menu--open) .#{$prefix}--menu--open {\n    visibility: hidden;\n  }\n\n  .#{$prefix}--menu--shown {\n    overflow: visible;\n    opacity: 1;\n  }\n\n  // MenuItem\n\n  .#{$prefix}--menu-item {\n    @include type-style('body-short-01');\n\n    display: grid;\n    align-items: center;\n    block-size: 2rem;\n    color: $text-secondary;\n    column-gap: $spacing-03;\n    cursor: pointer;\n    grid-template-columns: 1fr max-content;\n    padding-inline: $spacing-05;\n    transition: background-color $duration-fast-01 motion(standard, productive);\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  .#{$prefix}--menu-item:hover {\n    background-color: $layer-hover;\n    color: $text-primary;\n  }\n\n  $supported-sizes: (\n    'xs': 1.5rem,\n    'sm': 2rem,\n    'md': 2.5rem,\n    'lg': 3rem,\n  );\n\n  @each $size, $value in $supported-sizes {\n    .#{$prefix}--menu--#{$size} .#{$prefix}--menu-item {\n      block-size: $value;\n    }\n  }\n\n  .#{$prefix}--menu-item__label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--menu-item__shortcut {\n    display: flex;\n  }\n\n  .#{$prefix}--menu-item-group > ul,\n  .#{$prefix}--menu-item-radio-group > ul {\n    @include component-reset.reset;\n  }\n\n  .#{$prefix}--menu-item__icon,\n  .#{$prefix}--menu-item__selection-icon {\n    display: none;\n  }\n\n  .#{$prefix}--menu--with-icons > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-icons\n    > .#{$prefix}--menu-item-group\n    > ul\n    > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-icons\n    > .#{$prefix}--menu-item-radio-group\n    > ul\n    > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-selectable-items > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-group\n    > ul\n    > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-radio-group\n    > ul\n    > .#{$prefix}--menu-item {\n    grid-template-columns: 1rem 1fr max-content;\n  }\n\n  .#{$prefix}--menu--with-icons\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__icon,\n  .#{$prefix}--menu--with-icons\n    > .#{$prefix}--menu-item-group\n    > ul\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__icon,\n  .#{$prefix}--menu--with-icons\n    > .#{$prefix}--menu-item-radio-group\n    > ul\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__icon,\n  .#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__selection-icon,\n  .#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-group\n    > ul\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__selection-icon,\n  .#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-radio-group\n    > ul\n    > .#{$prefix}--menu-item\n    > .#{$prefix}--menu-item__selection-icon {\n    display: flex;\n  }\n\n  .#{$prefix}--menu--with-icons.#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-icons.#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-group\n    > ul\n    > .#{$prefix}--menu-item,\n  .#{$prefix}--menu--with-icons.#{$prefix}--menu--with-selectable-items\n    > .#{$prefix}--menu-item-radio-group\n    > ul\n    > .#{$prefix}--menu-item {\n    grid-template-columns: 1rem 1rem 1fr max-content;\n  }\n\n  .#{$prefix}--menu-item--disabled {\n    color: $text-disabled;\n    cursor: not-allowed;\n  }\n\n  .#{$prefix}--menu-item--disabled:hover,\n  .#{$prefix}--menu-item--disabled.#{$prefix}--menu-item--danger:hover {\n    background-color: $layer;\n    color: $text-disabled;\n  }\n\n  .#{$prefix}--menu-item--danger:focus,\n  .#{$prefix}--menu-item--danger:hover {\n    background-color: button-tokens.$button-danger-primary;\n    color: $text-on-color;\n  }\n\n  // MenuItemDivider\n\n  .#{$prefix}--menu-item-divider {\n    display: block;\n    background-color: $border-subtle;\n    block-size: convert.to-rem(1px);\n    inline-size: 100%;\n    margin-block: $spacing-02;\n  }\n}\n","//\n// Copyright IBM Corp. 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../menu';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../utilities/convert';\n@use '../../utilities/custom-property';\n\n/// Combo Button styles\n/// @access public\n/// @group combo-button\n@mixin combo-button {\n  .#{$prefix}--combo-button__container {\n    display: inline-flex;\n    column-gap: convert.to-rem(1px);\n  }\n\n  $triggerSizes: (\n    'sm': convert.to-rem(32px),\n    'md': convert.to-rem(40px),\n    'lg': convert.to-rem(48px),\n  );\n\n  @each $size, $trigger in $triggerSizes {\n    .#{$prefix}--combo-button__container--#{$size}\n      .#{$prefix}--combo-button__primary-action {\n      min-inline-size: 10rem - convert.to-rem(1px) - $trigger;\n    }\n  }\n\n  .#{$prefix}--combo-button__primary-action .#{$prefix}--btn {\n    inline-size: 100%;\n    max-inline-size: convert.to-rem(239px);\n    min-inline-size: convert.to-rem(111px);\n  }\n\n  .#{$prefix}--combo-button__primary-action button {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--combo-button__trigger svg {\n    transition: transform $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--combo-button__container--open\n    .#{$prefix}--combo-button__trigger\n    svg {\n    transform: rotate(180deg);\n  }\n\n  // Menu alignment classes\n  $popover-offset: custom-property.get-var('popover-offset', 3rem);\n\n  .#{$prefix}--combo-button__top {\n    transform: translate(0, calc(-100% - $popover-offset));\n  }\n\n  .#{$prefix}--combo-button__top-start {\n    transform: translate(0, calc(-100% - $popover-offset));\n  }\n\n  .#{$prefix}--combo-button__top-end {\n    transform: translate(0, calc(-100% - $popover-offset));\n  }\n}\n","//\n// Copyright IBM Corp. 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../button';\n@use '../menu';\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../utilities/custom-property';\n\n/// Menu Button styles\n/// @access public\n/// @group menu-button\n@mixin menu-button {\n  .#{$prefix}--menu-button__container {\n    display: contents;\n  }\n\n  .#{$prefix}--menu-button__trigger:not(.#{$prefix}--btn--ghost) {\n    min-inline-size: 12rem;\n  }\n\n  .#{$prefix}--menu-button__trigger svg {\n    transition: transform $duration-fast-02 motion(standard, productive);\n  }\n\n  .#{$prefix}--menu-button__trigger--open svg {\n    transform: rotate(180deg);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../functions' as *;\n@use '../../../config' as *;\n@use '../../../theme' as *;\n\n/// UI shell content\n/// @access private\n/// @group ui-shell\n@mixin content {\n  .#{$prefix}--content {\n    padding: 2rem;\n    color: $text-primary;\n    will-change: margin-left;\n  }\n\n  .#{$prefix}--header ~ .#{$prefix}--content,\n  div:has(.#{$prefix}--header) ~ .#{$prefix}--content {\n    margin-block-start: mini-units(6);\n  }\n\n  .#{$prefix}--side-nav ~ .#{$prefix}--content {\n    margin-inline-start: mini-units(6);\n  }\n\n  .#{$prefix}--side-nav.#{$prefix}--side-nav--expanded ~ .#{$prefix}--content {\n    margin-inline-start: mini-units(32);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2025\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../button';\n@use '../mixins' as *;\n@use '../functions' as *;\n@use '../../../breakpoint' as *;\n@use '../../../config' as *;\n@use '../../../layer' as *;\n@use '../../../motion' as *;\n@use '../../../spacing' as *;\n@use '../../../theme' as *;\n@use '../../../type' as *;\n@use '../../../utilities/button-reset';\n@use '../../../utilities/component-reset';\n@use '../../../utilities/convert';\n@use '../../../utilities/z-index' as *;\n\n/// UI shell header\n/// @access private\n/// @group ui-shell\n@mixin header {\n  .#{$prefix}--header {\n    @include component-reset.reset;\n\n    position: fixed;\n    z-index: z('header');\n    display: flex;\n    align-items: center;\n    background-color: $background;\n    block-size: mini-units(6);\n    border-block-end: 1px solid $border-subtle;\n    inset-block-start: 0;\n    inset-inline: 0;\n  }\n\n  .#{$prefix}--header__action {\n    @include button-reset.reset();\n\n    display: inline-flex;\n    border: convert.to-rem(1px) solid transparent;\n    block-size: mini-units(6);\n    inline-size: mini-units(6);\n    transition:\n      background-color $duration-fast-02,\n      border-color $duration-fast-02;\n    @include breakpoint-down('md') {\n      min-inline-size: $spacing-09;\n    }\n  }\n\n  .#{$prefix}--header__global .#{$prefix}--popover {\n    z-index: z('header') + 1;\n  }\n\n  .#{$prefix}--header__action > :first-child {\n    margin-block-start: 0;\n  }\n\n  .#{$prefix}--header__action\n    > svg.#{$prefix}--navigation-menu-panel-collapse-icon,\n  .#{$prefix}--header__action--active\n    > svg.#{$prefix}--navigation-menu-panel-expand-icon {\n    display: none;\n  }\n\n  .#{$prefix}--header__action--active\n    > svg.#{$prefix}--navigation-menu-panel-collapse-icon {\n    display: inline;\n  }\n\n  .#{$prefix}--header__action:hover {\n    background-color: $background-hover;\n  }\n\n  .#{$prefix}--header__action--active {\n    background: $layer;\n    border-block-end: 1px solid transparent;\n    border-inline-end: 1px solid $border-subtle;\n    border-inline-start: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--header__action--active > svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--header__action:focus {\n    border-color: $focus;\n    outline: none;\n  }\n\n  .#{$prefix}--header__action:active {\n    background-color: $background-active;\n  }\n\n  .#{$prefix}--header__action.#{$prefix}--btn--icon-only {\n    align-items: center;\n    justify-content: center;\n  }\n\n  .#{$prefix}--btn.#{$prefix}--btn--icon-only.#{$prefix}--header__action svg {\n    fill: $icon-secondary;\n  }\n\n  .#{$prefix}--btn.#{$prefix}--btn--icon-only.#{$prefix}--header__action:hover\n    svg,\n  .#{$prefix}--btn.#{$prefix}--btn--icon-only.#{$prefix}--header__action:active\n    svg,\n  .#{$prefix}--btn.#{$prefix}--btn--icon-only.#{$prefix}--header__action--active\n    svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--header__menu-trigger > svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--header__menu-trigger:hover > svg {\n    fill: $icon-primary;\n    // TODO: ask design if this color changes on hover, missing spec for it\n  }\n\n  .#{$prefix}--header__menu-toggle {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .#{$prefix}--header__menu-toggle__hidden {\n    @include breakpoint('lg') {\n      display: none;\n    }\n  }\n\n  //--------------------------------------------------------------------------\n  // Header - Name\n  //--------------------------------------------------------------------------\n  a.#{$prefix}--header__name {\n    @include type-style('body-compact-01');\n\n    display: flex;\n    align-items: center;\n    padding: 0 mini-units(4) 0 mini-units(2);\n    border: convert.to-rem(2px) solid transparent;\n    block-size: 100%;\n    font-weight: 600;\n    letter-spacing: 0.1px;\n    line-height: 1.25rem;\n    outline: none;\n    text-decoration: none;\n    transition: border-color $duration-fast-02;\n    user-select: none;\n    @include breakpoint-down('md') {\n      padding: 0 $spacing-05;\n    }\n  }\n\n  a.#{$prefix}--header__name:focus {\n    border-color: $focus;\n    // TODO: follow up with design to see if this is correct, missing focus spec for it\n  }\n\n  .#{$prefix}--header__name--prefix {\n    font-weight: 400;\n  }\n\n  a.#{$prefix}--header__name,\n  a.#{$prefix}--header__name:hover {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--header__menu-toggle:not(.#{$prefix}--header__menu-toggle__hidden)\n    ~ .#{$prefix}--header__name {\n    padding-inline-start: convert.to-rem(8px);\n  }\n\n  //--------------------------------------------------------------------------\n  // Header - Navigation\n  //--------------------------------------------------------------------------\n  .#{$prefix}--header__nav {\n    position: relative;\n    display: none;\n    block-size: 100%;\n    padding-inline-start: mini-units(2);\n\n    @include breakpoint('lg') {\n      display: block;\n    }\n\n    // header nav divider\n    &::before {\n      position: absolute;\n      display: block;\n      background-color: $border-subtle;\n      block-size: convert.to-rem(24px);\n      content: '';\n      inline-size: convert.to-rem(1px);\n      inset-block-start: 50%;\n      inset-inline-start: 0;\n      transform: translateY(-50%);\n    }\n  }\n\n  .#{$prefix}--header__menu-bar {\n    @include component-reset.reset;\n\n    display: flex;\n    padding: 0;\n    margin: 0;\n    block-size: 100%;\n    list-style: none;\n  }\n\n  a.#{$prefix}--header__menu-item {\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 mini-units(2);\n    // Used for focus styles\n    border: 2px solid transparent;\n    background-color: $background;\n    // Used for links that are directly in the menubar to span the full height\n    block-size: 100%;\n    color: $text-secondary;\n    // Text styles\n    font-size: convert.to-rem(14px);\n    font-weight: 400;\n    letter-spacing: 0;\n    line-height: 1.125rem;\n    // Reset link styles and make sure the text isn't selectable\n    text-decoration: none;\n    transition:\n      background-color $duration-fast-02,\n      border-color $duration-fast-02,\n      color $duration-fast-02;\n    user-select: none;\n  }\n\n  a.#{$prefix}--header__menu-item:hover {\n    background-color: $background-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--header__action:active,\n  a.#{$prefix}--header__menu-item:active {\n    background-color: $background-active;\n    color: $text-primary;\n  }\n\n  a.#{$prefix}--header__menu-item:focus {\n    border-color: $focus;\n    outline: none;\n  }\n\n  a.#{$prefix}--header__menu-item:hover > svg,\n  a.#{$prefix}--header__menu-item:active > svg {\n    fill: $icon-primary;\n  }\n\n  // Styles for selected state\n\n  a.#{$prefix}--header__menu-item[aria-current='page'],\n  .#{$prefix}--header__menu-item--current {\n    color: $text-primary;\n  }\n\n  a.#{$prefix}--header__menu-item[aria-current='page']::after,\n  .#{$prefix}--header__menu-item--current::after {\n    position: absolute;\n    background-color: $border-interactive;\n    block-size: 3px;\n    content: '';\n    inline-size: calc(100% + 4px);\n    inset-block-end: -2px;\n    inset-inline-start: -2px;\n  }\n\n  a.#{$prefix}--header__menu-item[aria-current='page']:focus::after,\n  .#{$prefix}--header__menu-item--current:focus::after {\n    border: 0;\n  }\n\n  .#{$prefix}--header__submenu .#{$prefix}--header__menu {\n    a.#{$prefix}--header__menu-item[aria-current='page']::after,\n    .#{$prefix}--header__menu-item--current::after {\n      background-color: $border-interactive;\n      block-size: calc(100% + 4px);\n      inline-size: 3px;\n      inset-block-start: -2px;\n      inset-inline-start: -2px;\n    }\n\n    a.#{$prefix}--header__menu-item[aria-current='page']:focus::after,\n    .#{$prefix}--header__menu-item--current:focus::after {\n      background-color: $border-interactive;\n      block-size: calc(100% + 4px);\n      // extra, hidden width prevents flickering on focus change\n      inline-size: 5px;\n      inset-block-start: -2px;\n      inset-inline-start: -2px;\n    }\n  }\n\n  a.#{$prefix}--header__menu-item[aria-current='page']:focus,\n  a.#{$prefix}--header__menu-item.#{$prefix}--header__menu-item--current:focus {\n    border: 2px solid $focus;\n  }\n\n  .#{$prefix}--header__submenu {\n    position: relative;\n  }\n\n  .#{$prefix}--header__menu-title[aria-haspopup='true'] {\n    position: relative;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true'] {\n    // Note: needs to be higher than menu. Adding 1 here instead of moving to\n    // the next level.\n    z-index: #{z('header') + 2};\n    background-color: $layer;\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    > .#{$prefix}--header__menu-arrow {\n    transform: rotate(180deg);\n  }\n\n  .#{$prefix}--header__menu {\n    display: none;\n    padding: 0;\n    margin: 0;\n    list-style: none;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu {\n    position: absolute;\n    z-index: #{z('header') + 1};\n    display: flex;\n    flex-direction: column;\n    background-color: $layer;\n    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 50%);\n    inline-size: mini-units(25);\n    inset-block-end: 0;\n    inset-inline-start: 0;\n    transform: translateY(100%);\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu\n    .#{$prefix}--header__menu-item {\n    background-color: $layer;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu\n    .#{$prefix}--header__menu-item:hover {\n    background-color: $layer-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu\n    .#{$prefix}--header__menu-item:active {\n    background-color: $layer-active;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu\n    .#{$prefix}--header__menu-item.#{$prefix}--header__menu-item--current {\n    // used for both desktop and mobile\n    background-color: $layer-selected;\n\n    &:hover {\n      background-color: $layer-selected-hover;\n    }\n  }\n\n  .#{$prefix}--header__menu .#{$prefix}--header__menu-item {\n    block-size: mini-units(6);\n  }\n\n  .#{$prefix}--header__menu-arrow {\n    fill: $icon-secondary;\n    margin-inline-start: mini-units(1);\n    transition:\n      transform $duration-fast-02,\n      fill $duration-fast-02;\n  }\n\n  //--------------------------------------------------------------------------\n  // Header - Global\n  //--------------------------------------------------------------------------\n  .#{$prefix}--header__global {\n    display: flex;\n    flex: 1 1 0%;\n    justify-content: flex-end;\n    block-size: 100%;\n  }\n\n  //--------------------------------------------------------------------------\n  // Header - Skip to content\n  //--------------------------------------------------------------------------\n  .#{$prefix}--skip-to-content {\n    position: absolute;\n    overflow: hidden;\n    padding: 0;\n    border: 0;\n    margin: -1px;\n    block-size: 1px;\n    clip: rect(0, 0, 0, 0);\n    inline-size: 1px;\n    visibility: inherit;\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--skip-to-content:focus {\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    padding: 0 1rem;\n    border: 4px solid $focus;\n    background-color: $background;\n    block-size: 3rem;\n    clip: auto;\n    color: $text-secondary;\n    inline-size: auto;\n    inset-block-start: 0;\n    inset-inline-start: 0;\n    // TODO: double check with design that these tokens are correct, missing spec for it\n    outline: none;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../functions' as *;\n@use '../../../config' as *;\n@use '../../../layer' as *;\n@use '../../../motion' as *;\n@use '../../../theme' as *;\n@use '../../../utilities/z-index' as *;\n\n/// UI shell side nav\n/// @access private\n/// @group ui-shell\n@mixin header-panel {\n  //----------------------------------------------------------------------------\n  // Header Panel\n  //----------------------------------------------------------------------------\n  .#{$prefix}--header-panel {\n    position: fixed;\n    z-index: z('header');\n    overflow: hidden;\n    border: none;\n    background-color: $layer;\n    color: $text-secondary;\n    inline-size: 0;\n    inset-block: mini-units(6) 0;\n    inset-inline-end: 0;\n    transition: width $duration-fast-02 motion(exit, productive);\n    will-change: width;\n  }\n\n  .#{$prefix}--header-panel--expanded {\n    border-inline-end: 1px solid $border-subtle;\n    border-inline-start: 1px solid $border-subtle;\n    inline-size: mini-units(32);\n    overflow-y: auto;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../mixins' as *;\n@use '../functions' as *;\n@use '../../../breakpoint' as *;\n@use '../../../config' as *;\n@use '../../../layer' as *;\n@use '../../../motion' as *;\n@use '../../../spacing' as *;\n@use '../../../theme' as *;\n@use '../../../type' as *;\n@use '../../../utilities/button-reset';\n@use '../../../utilities/component-reset';\n@use '../../../utilities/convert';\n@use '../../../utilities/focus-outline' as *;\n@use '../../../utilities/z-index' as *;\n\n/// UI shell side nav\n/// @access private\n/// @group ui-shell\n@mixin side-nav {\n  //----------------------------------------------------------------------------\n  // Side-nav > Panel\n  //----------------------------------------------------------------------------.\n  .#{$prefix}--side-nav {\n    position: fixed;\n    z-index: z('header');\n    // Useful to toggle this property to see what's going on when not expanded\n    overflow: hidden;\n    background-color: $background;\n    color: $text-secondary;\n    inline-size: mini-units(6);\n    inset-block: 0;\n    inset-inline-start: 0;\n    max-inline-size: mini-units(32);\n    // TODO: sync with motion work\n    transition:\n      inline-size 0.11s cubic-bezier(0.2, 0, 1, 0.9),\n      transform 0.11s cubic-bezier(0.2, 0, 1, 0.9);\n    will-change: inline-size;\n  }\n\n  .#{$prefix}--side-nav--ux {\n    inline-size: mini-units(32);\n    inset-block-start: $spacing-09;\n\n    @include breakpoint-down('lg') {\n      inline-size: 0;\n    }\n  }\n\n  //----------------------------------------------------------------------------\n  // Rail\n  //---------------------------------------------------------------------------\n  // Used for rendering the actual side rail. There are two states that we have\n  // to style for, namely for when the rail is collapsed and expanded. When\n  // collapsed, the rail is intended to expand on mouse over. When expanded, it\n  // should have the same dimensions as when expanded on mouse over\n\n  .#{$prefix}--side-nav--rail {\n    inline-size: mini-units(6);\n  }\n\n  .#{$prefix}--side-nav--hidden {\n    inline-size: 0;\n  }\n\n  .#{$prefix}--side-nav--expanded {\n    inline-size: mini-units(32);\n  }\n\n  .#{$prefix}--side-nav__overlay {\n    position: fixed;\n    background-color: transparent;\n    block-size: 0;\n    inline-size: 0;\n    inset-block-start: convert.to-rem(48px);\n    inset-inline-start: 0;\n    opacity: 0;\n    transition:\n      opacity $transition-expansion $standard-easing,\n      background-color $transition-expansion $standard-easing;\n  }\n\n  .#{$prefix}--side-nav__overlay-active {\n    @include breakpoint-down('lg') {\n      z-index: z('overlay');\n      background-color: $overlay;\n      block-size: 100vh;\n      inline-size: 100vw;\n      opacity: 1;\n      transition:\n        opacity $transition-expansion $standard-easing,\n        background-color $transition-expansion $standard-easing;\n    }\n  }\n\n  // When used alongside the header, we update the `top` positioning so that we\n  // can fit both widgets on the same page without overlapping.\n  .#{$prefix}--header ~ .#{$prefix}--side-nav {\n    block-size: calc(100% - 48px);\n    inset-block-start: mini-units(6);\n  }\n\n  .#{$prefix}--side-nav--fixed {\n    inline-size: mini-units(32);\n  }\n\n  .#{$prefix}--side-nav--collapsed {\n    inline-size: mini-units(32);\n    transform: translateX(mini-units(-32));\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Navigation\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav__navigation {\n    display: flex;\n    flex-direction: column;\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Navigation > Item(s)\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav__items {\n    @include component-reset.reset;\n\n    overflow: hidden;\n    flex: 1 1 0%;\n    padding: 1rem 0 0;\n\n    @include expanded() {\n      overflow-y: auto;\n    }\n  }\n\n  .#{$prefix}--side-nav--ux .#{$prefix}--side-nav__items {\n    overflow-y: auto;\n  }\n\n  .#{$prefix}--side-nav__item {\n    overflow: hidden;\n    block-size: auto;\n    inline-size: auto;\n  }\n\n  .#{$prefix}--side-nav--ux .#{$prefix}--side-nav__item {\n    block-size: auto;\n    inline-size: auto;\n  }\n\n  .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--active):hover\n    .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--active)\n    > .#{$prefix}--side-nav__submenu:hover,\n  .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--active)\n    > .#{$prefix}--side-nav__link:hover,\n  .#{$prefix}--side-nav__menu\n    a.#{$prefix}--side-nav__link:not(.#{$prefix}--side-nav__link--current):not(\n      [aria-current='page']\n    ):hover,\n  .#{$prefix}--side-nav a.#{$prefix}--header__menu-item:hover,\n  .#{$prefix}--side-nav\n    .#{$prefix}--header__menu-title[aria-expanded='true']:hover {\n    // TODO: sync color\n    background-color: $background-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--active)\n    > .#{$prefix}--side-nav__link:hover\n    > span,\n  .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--active)\n    .#{$prefix}--side-nav__menu-item\n    > .#{$prefix}--side-nav__link:hover\n    > span {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--side-nav__item--large {\n    block-size: auto;\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Navigation > Divider\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav__divider {\n    margin: $spacing-03 $spacing-05;\n    background-color: $border-subtle;\n    block-size: 1px;\n    list-style-type: none;\n  }\n\n  .#{$prefix}--side-nav__divider hr {\n    border: none;\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Navigation > {Menu,Submenu}\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav__submenu {\n    @include button-reset.reset($width: true);\n    @include type-style('heading-compact-01');\n    @include focus-outline('reset');\n\n    display: flex;\n    align-items: center;\n\n    padding: 0 mini-units(2);\n    block-size: mini-units(4);\n    color: $text-secondary;\n    transition:\n      color $duration-fast-02,\n      background-color $duration-fast-02,\n      outline $duration-fast-02;\n    user-select: none;\n  }\n\n  .#{$prefix}--side-nav__submenu:hover {\n    background-color: $background-hover;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--side-nav__submenu:focus {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--side-nav__submenu-title {\n    @include text-overflow();\n\n    text-align: start;\n  }\n\n  .#{$prefix}--side-nav__icon.#{$prefix}--side-nav__submenu-chevron {\n    display: flex;\n    flex: 1;\n    justify-content: flex-end;\n  }\n\n  .#{$prefix}--side-nav__submenu-chevron > svg {\n    block-size: convert.to-rem(16px);\n    inline-size: convert.to-rem(16px);\n    transition: transform $duration-fast-02;\n  }\n\n  .#{$prefix}--side-nav__submenu[aria-expanded='true']\n    .#{$prefix}--side-nav__submenu-chevron\n    > svg {\n    transform: rotate(180deg);\n  }\n\n  .#{$prefix}--side-nav__item--large .#{$prefix}--side-nav__submenu {\n    block-size: mini-units(6);\n  }\n\n  .#{$prefix}--side-nav__item--active .#{$prefix}--side-nav__submenu:hover {\n    //the active className is used for selected styles, hence using the selected tokens\n    background-color: $background-selected;\n    color: $text-primary;\n  }\n\n  .#{$prefix}--side-nav__item--active\n    .#{$prefix}--side-nav__submenu[aria-expanded='false'] {\n    position: relative;\n    background-color: $background-selected;\n    color: $text-primary;\n\n    &::before {\n      position: absolute;\n      background-color: $border-interactive;\n      content: '';\n      inline-size: 3px;\n      inset-block: 0;\n      inset-inline-start: 0;\n    }\n  }\n\n  .#{$prefix}--side-nav__item--active .#{$prefix}--side-nav__submenu-title {\n    color: $text-primary;\n    font-weight: 600;\n  }\n\n  .#{$prefix}--side-nav__item--active .#{$prefix}--side-nav__icon > svg {\n    fill: $icon-primary;\n  }\n\n  .#{$prefix}--side-nav__menu {\n    @include component-reset.reset;\n\n    display: block;\n    max-block-size: 0;\n    visibility: hidden;\n  }\n\n  .#{$prefix}--side-nav__submenu[aria-expanded='true']\n    + .#{$prefix}--side-nav__menu {\n    max-block-size: convert.to-rem(1500px);\n    visibility: inherit;\n  }\n\n  .#{$prefix}--side-nav__menu a.#{$prefix}--side-nav__link {\n    block-size: mini-units(4);\n    font-weight: 400;\n    min-block-size: mini-units(4);\n    padding-inline-start: mini-units(4);\n  }\n\n  .#{$prefix}--side-nav__item.#{$prefix}--side-nav__item--icon\n    a.#{$prefix}--side-nav__link {\n    padding-inline-start: mini-units(9);\n  }\n  .#{$prefix}--side-nav__menu a.#{$prefix}--side-nav__link--current,\n  .#{$prefix}--side-nav__menu a.#{$prefix}--side-nav__link[aria-current='page'],\n  a.#{$prefix}--side-nav__link--current {\n    background-color: $background-selected;\n\n    > span {\n      color: $text-primary;\n      font-weight: 600;\n    }\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Link\n  //----------------------------------------------------------------------------\n  a.#{$prefix}--side-nav__link,\n  .#{$prefix}--side-nav a.#{$prefix}--header__menu-item,\n  .#{$prefix}--side-nav\n    .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu {\n    @include focus-outline('reset');\n    @include type-style('heading-compact-01');\n\n    position: relative;\n    display: flex;\n    align-items: center;\n    padding: 0 mini-units(2);\n    min-block-size: mini-units(4);\n    text-decoration: none;\n    transition:\n      color $duration-fast-02,\n      background-color $duration-fast-02,\n      outline $duration-fast-02;\n  }\n\n  .#{$prefix}--side-nav__item--large a.#{$prefix}--side-nav__link {\n    block-size: mini-units(6);\n  }\n\n  a.#{$prefix}--side-nav__link > .#{$prefix}--side-nav__link-text,\n  .#{$prefix}--side-nav\n    a.#{$prefix}--header__menu-item\n    .#{$prefix}--text-truncate-end {\n    @include text-overflow();\n\n    color: $text-secondary;\n    font-size: convert.to-rem(14px);\n    letter-spacing: 0.1px;\n    line-height: 1.25rem;\n    user-select: none;\n  }\n\n  a.#{$prefix}--side-nav__link:focus,\n  .#{$prefix}--side-nav a.#{$prefix}--header__menu-item:focus {\n    @include focus-outline('outline');\n  }\n\n  a.#{$prefix}--side-nav__link[aria-current='page'],\n  a.#{$prefix}--side-nav__link--current {\n    background-color: $background-selected;\n    font-weight: 600;\n  }\n\n  a.#{$prefix}--side-nav__link[aria-current='page']\n    .#{$prefix}--side-nav__link-text,\n  a.#{$prefix}--side-nav__link--current .#{$prefix}--side-nav__link-text {\n    color: $text-primary;\n  }\n\n  a.#{$prefix}--side-nav__link[aria-current='page']::before,\n  a.#{$prefix}--side-nav__link--current::before {\n    position: absolute;\n    background-color: $border-interactive;\n    content: '';\n    inline-size: 3px;\n    inset-block: 0;\n    inset-inline-start: 0;\n  }\n\n  //----------------------------------------------------------------------------\n  // Side-nav > Icons\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav__icon {\n    display: flex;\n    // Helpful in flex containers so the icon does not have less than the\n    // expected width\n    flex: 0 0 mini-units(2);\n    align-items: center;\n    justify-content: center;\n  }\n\n  .#{$prefix}--side-nav__icon:not(.#{$prefix}--side-nav__submenu-chevron) {\n    margin-inline-end: mini-units(3);\n  }\n\n  .#{$prefix}--side-nav__icon > svg {\n    block-size: mini-units(2);\n    fill: $icon-secondary;\n    inline-size: mini-units(2);\n  }\n\n  .#{$prefix}--side-nav__icon > svg.#{$prefix}--side-nav-collapse-icon {\n    display: none;\n  }\n\n  .#{$prefix}--side-nav--expanded\n    .#{$prefix}--side-nav__icon\n    > svg.#{$prefix}--side-nav-expand-icon {\n    display: none;\n  }\n\n  .#{$prefix}--side-nav--expanded\n    .#{$prefix}--side-nav__icon\n    > svg.#{$prefix}--side-nav-collapse-icon {\n    display: block;\n  }\n\n  //----------------------------------------------------------------------------\n  // Variants - Fixed\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav--fixed a.#{$prefix}--side-nav__link,\n  .#{$prefix}--side-nav--fixed .#{$prefix}--side-nav__submenu {\n    padding-inline-start: mini-units(2);\n  }\n\n  .#{$prefix}--side-nav--fixed\n    .#{$prefix}--side-nav__item:not(.#{$prefix}--side-nav__item--icon)\n    .#{$prefix}--side-nav__menu\n    a.#{$prefix}--side-nav__link {\n    padding-inline-start: mini-units(4);\n  }\n\n  //----------------------------------------------------------------------------\n  // Variants - Header Nav Links in Side Nav\n  //----------------------------------------------------------------------------\n  .#{$prefix}--side-nav .#{$prefix}--header__nav {\n    @include breakpoint-down('lg') {\n      display: block;\n    }\n  }\n\n  .#{$prefix}--side-nav__header-navigation {\n    @include component-reset.reset;\n\n    display: none;\n\n    @include breakpoint-down('lg') {\n      position: relative;\n      display: block;\n      margin-block-end: convert.to-rem(32px);\n    }\n  }\n\n  .#{$prefix}--side-nav__header-divider::after {\n    position: absolute;\n    background: $border-subtle;\n    block-size: convert.to-rem(1px);\n    content: '';\n    inline-size: calc(100% - 32px);\n    inset-block-end: convert.to-rem(-16px);\n    inset-inline-start: convert.to-rem(16px);\n  }\n\n  //header menu items overrides\n  .#{$prefix}--side-nav a.#{$prefix}--header__menu-item {\n    justify-content: space-between;\n    color: $text-secondary;\n    white-space: nowrap;\n\n    &[aria-expanded='true'] {\n      background-color: transparent;\n    }\n  }\n\n  .#{$prefix}--side-nav\n    .#{$prefix}--header__menu-title[aria-expanded='true']\n    + .#{$prefix}--header__menu {\n    padding: 0;\n    background-color: transparent;\n    box-shadow: none;\n    inline-size: 100%;\n    inset-block-end: inherit;\n    transform: none;\n\n    li {\n      inline-size: 100%;\n    }\n\n    a.#{$prefix}--header__menu-item {\n      font-weight: 400;\n      padding-inline-start: 4.25rem;\n    }\n\n    a.#{$prefix}--header__menu-item:hover {\n      background-color: $background-hover;\n      color: $text-primary;\n    }\n\n    // non-hover, selected state inherited from `_header.scss`\n    a.#{$prefix}--header__menu-item--current:hover {\n      background-color: $layer-selected-hover;\n    }\n  }\n\n  .#{$prefix}--side-nav\n    .#{$prefix}--side-nav__header-navigation\n    a.#{$prefix}--header__menu-item[aria-current='page']::after,\n  .#{$prefix}--side-nav\n    .#{$prefix}--side-nav__header-navigation\n    .#{$prefix}--header__menu-item--current::after {\n    block-size: calc(100% + 4px);\n    inline-size: 3px;\n  }\n\n  .#{$prefix}--side-nav\n    .#{$prefix}--header__menu\n    a.#{$prefix}--header__menu-item {\n    block-size: inherit;\n  }\n\n  .#{$prefix}--side-nav\n    a.#{$prefix}--header__menu-item:hover\n    .#{$prefix}--header__menu-arrow,\n  .#{$prefix}--side-nav\n    a.#{$prefix}--header__menu-item:focus\n    .#{$prefix}--header__menu-arrow,\n  .#{$prefix}--side-nav .#{$prefix}--header__menu-arrow {\n    fill: $icon-secondary;\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../config' as *;\n\n/// Helper to add in text overflow styles to a particular node. Useful if we\n/// don't want to have display-inline: block from the text helper classes\n/// @access private\n/// @group ui-shell\n/// @example\n///   .my-custom-selector {\n///     @include text-overflow();\n///   }\n@mixin text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/// Helper for handling selectors for the expansion state of the side-nav.\n/// This helper makes it easier to write code for children that need to respond\n/// to whether the side-nav is open, or closed. For convenience, we also\n/// optionally set properties for opacity and visibility to help with the\n/// transition animation.\n/// @access private\n/// @group ui-shell\n/// @param {Bool} $opacity [false]\n/// @param {Bool} $visibility [false]\n/// @content\n@mixin expanded($opacity: false, $visibility: false) {\n  @if $opacity == true {\n    opacity: 0;\n  }\n\n  @if $visibility == true {\n    visibility: hidden;\n  }\n\n  .#{$prefix}--side-nav:hover &,\n  // Include the fixed variant here so components can render in both expandable\n  // and fixed side navs\n  .#{$prefix}--side-nav--fixed &,\n  .#{$prefix}--side-nav--expanded & {\n    @if $visibility == true {\n      visibility: inherit;\n    }\n    @if $opacity == true {\n      opacity: 1;\n    }\n    @content;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../../config' as *;\n@use '../../../spacing' as *;\n@use '../../../theme' as *;\n@use '../../../type' as *;\n@use '../../../utilities/component-reset';\n@use '../../../utilities/convert';\n\n/// UI shell side nav\n/// @access private\n/// @group ui-shell\n@mixin switcher {\n  //----------------------------------------------------------------------------\n  // Header Switcher\n  //----------------------------------------------------------------------------\n  .#{$prefix}--switcher {\n    @include component-reset.reset;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: $text-secondary;\n  }\n\n  .#{$prefix}--switcher__item {\n    block-size: $spacing-07;\n    inline-size: 100%;\n  }\n\n  .#{$prefix}--switcher__item:nth-child(1) {\n    margin-block-start: $spacing-05;\n  }\n\n  .#{$prefix}--switcher__item--divider {\n    display: block;\n    border: none;\n    margin: $spacing-03 $spacing-05;\n    background: $border-subtle;\n    block-size: 1px;\n    inline-size: convert.to-rem(224px);\n  }\n\n  .#{$prefix}--switcher__item-link {\n    @include type-style('heading-compact-01');\n\n    display: block;\n    padding: convert.to-rem(6px) $spacing-05;\n    block-size: $spacing-07;\n    color: $text-secondary;\n    text-decoration: none;\n\n    &:hover:not(.#{$prefix}--switcher__item-link--selected) {\n      background: $layer-hover;\n      color: $text-primary;\n      cursor: pointer;\n    }\n\n    &:focus {\n      outline: 2px solid $focus;\n      outline-offset: -2px;\n    }\n\n    &:active {\n      background: $layer-active;\n      color: $text-primary;\n    }\n  }\n\n  .#{$prefix}--switcher__item-link--selected {\n    // TODO: should we add a 3px left border-interactive here too? Doesn't currently have it, but specs have it\n    background: $layer-selected;\n    color: $text-primary;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../motion' as *;\n@use '../../theme' as *;\n@use '../../spacing' as *;\n@use '../../type' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/high-contrast-mode' as *;\n\n@use '../button/tokens' as *;\n\n@keyframes fp-fade-in-down {\n  from {\n    opacity: 0;\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fp-slide-left {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes fp-slide-left-new {\n  from {\n    transform: translate3d(100%, 0, 0);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fp-slide-right {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n\n  to {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes fp-slide-right-new {\n  from {\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fp-fade-out {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fp-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@mixin flatpickr {\n  .flatpickr-calendar {\n    position: absolute;\n    overflow: hidden;\n    box-sizing: border-box;\n    padding: 0;\n    border: 0;\n    border-radius: 0;\n    animation: none;\n    direction: ltr;\n    inline-size: convert.to-rem(315px);\n    max-block-size: 0;\n    opacity: 0;\n    text-align: center;\n    touch-action: manipulation;\n    visibility: hidden;\n    @include high-contrast-mode('outline');\n  }\n\n  .flatpickr-calendar.open,\n  .flatpickr-calendar.inline {\n    overflow: visible;\n    max-block-size: convert.to-rem(640px);\n    opacity: 1;\n    visibility: inherit;\n  }\n\n  .flatpickr-calendar.open {\n    @include box-shadow;\n\n    z-index: 99999;\n    display: flex;\n    overflow: hidden;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: $spacing-02 $spacing-02 $spacing-03 $spacing-02;\n    border: none;\n    background-color: $layer-01;\n    block-size: convert.to-rem(336px);\n    inline-size: convert.to-rem(288px);\n    margin-block-start: convert.to-rem(-2px);\n\n    &:focus {\n      @include focus-outline('border');\n    }\n  }\n\n  .flatpickr-calendar.animate.open {\n    animation: fp-fade-in-down $duration-fast-02 motion(entrance, productive);\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      animation: none;\n    }\n  }\n\n  .flatpickr-calendar.inline {\n    position: absolute;\n    display: block;\n    inset-block-start: auto;\n  }\n\n  .flatpickr-calendar.static {\n    position: absolute;\n    inset-block-start: calc(100% + 2px);\n  }\n\n  .flatpickr-calendar.static.open {\n    z-index: 999;\n    display: block;\n  }\n\n  .flatpickr-calendar.hasWeeks {\n    inline-size: auto;\n  }\n\n  .dayContainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    padding: 0;\n    block-size: convert.to-rem(246px);\n    outline: 0;\n  }\n\n  .flatpickr-calendar .hasWeeks .dayContainer,\n  .flatpickr-calendar .hasTime .dayContainer {\n    border-block-end: 0;\n    border-end-end-radius: 0;\n    border-end-start-radius: 0;\n  }\n\n  .flatpickr-calendar .hasWeeks .dayContainer {\n    border-inline-start: 0;\n  }\n\n  .flatpickr-calendar.showTimeInput.hasTime .flatpickr-time {\n    block-size: convert.to-rem(40px);\n    border-block-start: 1px solid #e6e6e6;\n  }\n\n  .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n    block-size: auto;\n  }\n\n  .flatpickr-calendar:focus {\n    outline: 0;\n  }\n\n  .flatpickr-months {\n    display: flex;\n    justify-content: space-between;\n    inline-size: 100%;\n  }\n\n  .flatpickr-month {\n    @include type-style('heading-compact-01');\n\n    display: flex;\n    align-items: center;\n    background-color: transparent;\n    block-size: convert.to-rem(40px);\n    color: $text-primary;\n    line-height: 1;\n    text-align: center;\n  }\n\n  .flatpickr-prev-month,\n  .flatpickr-next-month {\n    z-index: 3;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    block-size: convert.to-rem(40px);\n    cursor: pointer;\n    fill: $icon-primary;\n    inline-size: convert.to-rem(40px);\n    line-height: 16px;\n    text-decoration: none;\n    transform: scale(1, 1) #{'/*rtl: scale(-1,1)*/'};\n    transition: background-color $duration-fast-01 motion(standard, productive);\n    user-select: none;\n\n    @media screen and (prefers-reduced-motion: reduce) {\n      transition: none;\n    }\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n  }\n\n  .flatpickr-next-month.disabled svg,\n  .flatpickr-prev-month.disabled svg {\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .flatpickr-next-month.disabled:hover svg,\n  .flatpickr-prev-month.disabled:hover svg {\n    fill: $icon-disabled;\n  }\n\n  .flatpickr-current-month {\n    @include type-style('heading-compact-01');\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: convert.to-rem(28px);\n    text-align: center;\n  }\n\n  .flatpickr-current-month .cur-month {\n    margin-inline: $spacing-02 $spacing-02;\n\n    &:hover {\n      background-color: $layer-hover;\n    }\n  }\n\n  .numInputWrapper {\n    position: relative;\n    inline-size: convert.to-rem(60px);\n\n    &:hover {\n      background-color: $background-hover;\n    }\n  }\n\n  .numInputWrapper .numInput {\n    display: inline-block;\n    padding: $spacing-02;\n    border: none;\n    margin: 0;\n    // Added in when upgraded to Flatpickr 4.5.5 (#1977)\n    -moz-appearance: textfield; /* Firefox */\n    background-color: $field-01;\n    color: $text-primary;\n    cursor: default;\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: 600;\n    inline-size: 100%;\n\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n      // Added in when upgraded to Flatpickr 4.5.5 (#1977)\n      -webkit-appearance: none;\n    }\n\n    &:focus {\n      @include focus-outline('border');\n    }\n\n    &[disabled],\n    &[disabled]:hover {\n      background-color: $layer-01;\n      color: $text-disabled;\n      pointer-events: none;\n    }\n  }\n\n  .numInputWrapper .arrowUp {\n    border-block-end: 0;\n    inset-block-start: convert.to-rem(4px);\n\n    &::after {\n      border-block-end: convert.to-rem(4px) solid $icon-primary;\n    }\n  }\n\n  .numInputWrapper .arrowDown {\n    inset-block-start: convert.to-rem(11px);\n\n    &::after {\n      border-block-start: convert.to-rem(4px) solid $icon-primary;\n    }\n  }\n\n  .numInputWrapper .arrowUp,\n  .numInputWrapper .arrowDown {\n    position: absolute;\n    padding: 0 convert.to-rem(4px) 0 convert.to-rem(2px);\n    border: none;\n    block-size: 50%;\n    cursor: pointer;\n    inline-size: convert.to-rem(12px);\n    inset-inline-start: 2.6rem;\n    line-height: 50%;\n    opacity: 0;\n\n    &::after {\n      position: absolute;\n      display: block;\n      border-inline-end: convert.to-rem(4px) solid transparent;\n      border-inline-start: convert.to-rem(4px) solid transparent;\n      content: '';\n      inset-block-start: 33%;\n    }\n\n    &:hover::after {\n      border-block-end-color: $button-primary;\n      border-block-start-color: $button-primary;\n    }\n\n    &:active::after {\n      border-block-end-color: $border-interactive;\n      border-block-start-color: $border-interactive;\n    }\n  }\n\n  .numInput[disabled] ~ .arrowUp::after {\n    border-block-end-color: $text-disabled;\n  }\n\n  .numInput[disabled] ~ .arrowDown::after {\n    border-block-start-color: $text-disabled;\n  }\n\n  .numInputWrapper:hover .arrowUp,\n  .numInputWrapper:hover .arrowDown {\n    opacity: 1;\n  }\n\n  .numInputWrapper:hover .numInput[disabled] ~ .arrowUp,\n  .numInputWrapper:hover .numInput[disabled] ~ .arrowDown {\n    opacity: 0;\n  }\n\n  .flatpickr-weekdays {\n    display: flex;\n    align-items: center;\n    block-size: convert.to-rem(40px);\n  }\n\n  .flatpickr-weekdaycontainer {\n    display: flex;\n    inline-size: 100%;\n  }\n\n  .flatpickr-weekday {\n    @include type-style('body-compact-01');\n\n    flex: 1;\n    color: $text-primary;\n    cursor: default;\n  }\n\n  .flatpickr-days:focus {\n    outline: 0;\n  }\n\n  .flatpickr-calendar.animate .dayContainer.slideLeft {\n    animation:\n      fp-fade-out 400ms cubic-bezier(0.23, 1, 0.32, 1),\n      fp-slide-left 400ms cubic-bezier(0.23, 1, 0.32, 1);\n  }\n\n  .flatpickr-calendar.animate .dayContainer.slideLeft,\n  .flatpickr-calendar.animate .dayContainer.slideLeftNew {\n    transform: translate3d(-100%, 0, 0);\n  }\n\n  .flatpickr-calendar.animate .dayContainer.slideLeftNew {\n    animation:\n      fp-fade-in 400ms cubic-bezier(0.23, 1, 0.32, 1),\n      fp-slide-left 400ms cubic-bezier(0.23, 1, 0.32, 1);\n  }\n\n  .flatpickr-calendar.animate .dayContainer.slideRight {\n    animation:\n      fp-fade-out 400ms cubic-bezier(0.23, 1, 0.32, 1),\n      fp-slide-right 400ms cubic-bezier(0.23, 1, 0.32, 1);\n    transform: translate3d(100%, 0, 0);\n  }\n\n  .flatpickr-calendar.animate .dayContainer.slideRightNew {\n    animation:\n      fp-fade-in 400ms cubic-bezier(0.23, 1, 0.32, 1),\n      fp-slide-right-new 400ms cubic-bezier(0.23, 1, 0.32, 1);\n  }\n\n  .flatpickr-day {\n    @include type-style('body-compact-01');\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    block-size: convert.to-rem(40px);\n    color: $text-primary;\n    cursor: pointer;\n    inline-size: convert.to-rem(40px);\n    transition: all $duration-fast-01 motion(standard, productive);\n\n    &:hover {\n      background: $layer-hover;\n    }\n\n    &:focus {\n      @include focus-outline('outline');\n\n      outline-color: $button-primary;\n    }\n  }\n\n  .nextMonthDay,\n  .prevMonthDay {\n    color: $text-helper;\n  }\n\n  .flatpickr-day.today {\n    position: relative;\n    color: $link-primary;\n    font-weight: 600;\n\n    &::after {\n      position: absolute;\n      display: block;\n      background-color: $link-primary;\n      block-size: convert.to-rem(4px);\n      content: '';\n      inline-size: convert.to-rem(4px);\n      inset-block-end: convert.to-rem(7px);\n      inset-inline-start: 50%;\n      transform: translateX(-50%);\n    }\n  }\n\n  .flatpickr-day.today.no-border {\n    border: none;\n  }\n\n  .flatpickr-day.today.selected {\n    @include focus-outline('outline');\n\n    &::after {\n      display: none;\n    }\n  }\n\n  .flatpickr-day.inRange {\n    background-color: $highlight;\n    color: $text-primary;\n  }\n\n  .flatpickr-day.selected {\n    background-color: $button-primary;\n    color: $text-on-color;\n    @include high-contrast-mode('focus') {\n      outline-style: dotted;\n    }\n\n    &:focus {\n      outline: convert.to-rem(1px) solid $layer-02;\n      outline-offset: convert.to-rem(-3px);\n    }\n  }\n\n  .flatpickr-day.startRange.selected {\n    z-index: 2;\n    box-shadow: none;\n  }\n\n  .flatpickr-day.startRange.inRange:not(.selected),\n  .flatpickr-day.endRange.inRange {\n    @include focus-outline('outline');\n\n    z-index: 3;\n    background: $layer-01;\n  }\n\n  .flatpickr-day.endRange:hover {\n    @include focus-outline('outline');\n\n    background: $layer-01;\n    color: $text-primary;\n  }\n\n  .flatpickr-day.endRange.inRange.selected {\n    background: $button-primary;\n    color: $text-on-color;\n  }\n\n  .flatpickr-day.flatpickr-disabled {\n    color: $text-disabled;\n    cursor: not-allowed;\n\n    &:hover {\n      background-color: transparent;\n    }\n  }\n\n  .flatpickr-input[readonly] {\n    cursor: pointer;\n  }\n\n  .flatpickr-day.today,\n  .flatpickr-day.inRange {\n    @include high-contrast-mode {\n      color: Highlight;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'flatpickr' as *;\n@use '../form';\n@use '../../colors' as *;\n@use '../../config' as *;\n@use '../../motion' as *;\n@use '../../theme' as *;\n@use '../../spacing' as *;\n@use '../../type' as *;\n@use '../../utilities/ai-gradient' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/convert';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/placeholder-colors' as *;\n@use '../../utilities/skeleton' as *;\n\n/// Date picker styles\n/// @access public\n/// @group date-picker\n@mixin date-picker {\n  @include flatpickr;\n\n  .#{$prefix}--date-picker {\n    display: flex;\n  }\n\n  // V11: Possibly deprecate\n  .#{$prefix}--date-picker--light .#{$prefix}--date-picker__input {\n    background: $field-02;\n  }\n\n  .#{$prefix}--date-picker ~ .#{$prefix}--label {\n    order: 1;\n  }\n\n  .#{$prefix}--date-picker-container {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n  }\n\n  .#{$prefix}--date-picker-container .#{$prefix}--label {\n    display: flex;\n  }\n\n  .#{$prefix}--date-picker-input__wrapper {\n    display: flex;\n    align-items: center;\n  }\n\n  .#{$prefix}--date-picker-input__wrapper > span {\n    position: relative;\n  }\n\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--simple\n    .#{$prefix}--date-picker__input,\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--simple .#{$prefix}--label {\n    inline-size: convert.to-rem(120px);\n  }\n\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--simple\n    .#{$prefix}--date-picker-input__wrapper--invalid,\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--simple\n    .#{$prefix}--date-picker-input__wrapper--warn {\n    .#{$prefix}--date-picker__input,\n    ~ .#{$prefix}--form-requirement {\n      inline-size: convert.to-rem(152px);\n    }\n  }\n\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--simple.#{$prefix}--date-picker--short {\n    .#{$prefix}--date-picker__input {\n      inline-size: 5.7rem;\n    }\n  }\n\n  .#{$prefix}--date-picker.#{$prefix}--date-picker--single\n    .#{$prefix}--date-picker__input {\n    inline-size: convert.to-rem(288px);\n  }\n\n  .#{$prefix}--date-picker\n    .#{$prefix}--date-picker-input__wrapper--warn\n    ~ .#{$prefix}--form-requirement {\n    color: $text-primary;\n  }\n  .#{$prefix}--date-picker__input {\n    @include component-reset.reset;\n    @include type-style('code-02');\n    @include focus-outline('reset');\n\n    position: relative;\n    display: block;\n    padding: 0 $spacing-05;\n    border: none;\n    background-color: $field;\n    block-size: convert.to-rem(40px);\n    border-block-end: 1px solid $border-strong;\n    color: $text-primary;\n    transition: $duration-fast-01 motion(standard, productive) all;\n\n    &:focus,\n    &.#{$prefix}--focused {\n      @include focus-outline('outline');\n    }\n\n    &:disabled {\n      background-color: $field;\n      border-block-end: 1px solid transparent;\n      color: $text-disabled;\n      cursor: not-allowed;\n    }\n\n    &:disabled::placeholder {\n      color: $text-disabled;\n    }\n\n    &:disabled:hover {\n      border-block-end: 1px solid transparent;\n    }\n\n    &::placeholder {\n      @include placeholder-colors;\n    }\n  }\n\n  // Size variant styles\n  .#{$prefix}--date-picker__input--lg {\n    block-size: convert.to-rem(48px);\n  }\n\n  .#{$prefix}--date-picker__input--sm {\n    block-size: convert.to-rem(32px);\n  }\n\n  .#{$prefix}--date-picker__icon {\n    position: absolute;\n    z-index: 1;\n    fill: $icon-primary;\n    // vertically center icon within parent container on IE11\n    inset-block-start: 50%;\n    inset-inline-end: 1rem;\n    pointer-events: none;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--date-picker__icon--invalid,\n  .#{$prefix}--date-picker__icon--warn {\n    cursor: auto;\n  }\n\n  .#{$prefix}--date-picker__icon--warn {\n    fill: $support-warning;\n  }\n\n  // V11: Do we have an always black token?\n  .#{$prefix}--date-picker__icon--warn path:first-of-type {\n    fill: $black-100;\n    opacity: 1;\n  }\n\n  .#{$prefix}--date-picker__icon--invalid {\n    fill: $support-error;\n  }\n\n  .#{$prefix}--date-picker__icon ~ .#{$prefix}--date-picker__input {\n    padding-inline-end: $spacing-09;\n  }\n\n  .#{$prefix}--date-picker__input:disabled ~ .#{$prefix}--date-picker__icon {\n    cursor: not-allowed;\n    fill: $icon-disabled;\n  }\n\n  .#{$prefix}--date-picker--range\n    > .#{$prefix}--date-picker-container:first-child {\n    margin-inline-end: convert.to-rem(1px);\n  }\n\n  .#{$prefix}--date-picker--range .#{$prefix}--date-picker-container,\n  .#{$prefix}--date-picker--range .#{$prefix}--date-picker__input {\n    inline-size: convert.to-rem(143.5px);\n  }\n\n  // Styles for `AILabel` rendered inside `DatePickerInput`\n  .#{$prefix}--date-picker-input__wrapper--decorator\n    .#{$prefix}--date-picker-input-inner-wrapper--decorator\n    > *,\n  .#{$prefix}--date-picker-input__wrapper--slug .#{$prefix}--ai-label,\n  .#{$prefix}--date-picker-input__wrapper--slug .#{$prefix}--slug {\n    position: absolute;\n    inset-block-start: 50%;\n    inset-inline-end: $spacing-08;\n    transform: translateY(-50%);\n  }\n\n  .#{$prefix}--date-picker-input__wrapper--decorator\n    .#{$prefix}--date-picker-input-inner-wrapper--decorator:not(\n      :has(.#{$prefix}--ai-label)\n    )\n    > * {\n    block-size: 1rem;\n  }\n\n  .#{$prefix}--date-picker-input__wrapper--decorator\n    .#{$prefix}--date-picker__input:has(\n      ~ .#{$prefix}--date-picker-input-inner-wrapper--decorator\n        .#{$prefix}--ai-label\n    ):not(\n      :has(\n          ~ .#{$prefix}--date-picker-input-inner-wrapper--decorator\n            .#{$prefix}--ai-label--revert\n        )\n    ),\n  .#{$prefix}--date-picker-input__wrapper--slug\n    .#{$prefix}--date-picker__input:has(~ .#{$prefix}--ai-label):not(\n      :has(~ .#{$prefix}--ai-label--revert)\n    ),\n  .#{$prefix}--date-picker-input__wrapper--slug\n    .#{$prefix}--date-picker__input:has(~ .#{$prefix}--slug):not(\n      :has(~ .#{$prefix}--slug--revert)\n    ) {\n    @include ai-gradient;\n\n    padding-inline-end: $spacing-10;\n  }\n\n  // Read-only State\n  .#{$prefix}--date-picker__input[readonly] {\n    background: transparent;\n    border-block-end-color: $border-subtle;\n    cursor: text;\n  }\n\n  .#{$prefix}--date-picker__input[readonly] + .#{$prefix}--date-picker__icon {\n    fill: $icon-disabled;\n  }\n\n  // Skeleton State\n  .#{$prefix}--date-picker.#{$prefix}--skeleton input,\n  .#{$prefix}--date-picker__input.#{$prefix}--skeleton {\n    @include skeleton;\n\n    inline-size: 100%;\n\n    &::placeholder {\n      color: transparent;\n    }\n  }\n\n  .#{$prefix}--date-picker.#{$prefix}--skeleton .#{$prefix}--label {\n    @include skeleton;\n\n    block-size: convert.to-rem(14px);\n    inline-size: convert.to-rem(75px);\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n//-----------------------------\n// Tabs\n//-----------------------------\n\n@use 'vars' as *;\n@use '../button/tokens' as button;\n@use '../tooltip';\n@use '../../config' as *;\n@use '../../theme' as *;\n@use '../../colors' as *;\n@use '../../type' as *;\n@use '../../breakpoint' as *;\n@use '../../spacing' as *;\n@use '../../motion' as *;\n@use '../../layer' as *;\n@use '../../layer/layer-tokens';\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/rotate' as *;\n@use '../../utilities/box-shadow' as *;\n@use '../../utilities/component-reset';\n@use '../../utilities/component-tokens' as *;\n@use '../../utilities/custom-property';\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/visually-hidden' as *;\n@use '../../utilities/button-reset';\n@use '../../utilities/high-contrast-mode' as *;\n@use '../../utilities/convert';\n@use '../../utilities/layout';\n@use '../../utilities/update_fields_on_layer' as *;\n\n/// Tabs styles\n/// @access public\n/// @group tabs\n@mixin tabs {\n  .#{$prefix}--tabs,\n  .#{$prefix}--tab-content {\n    @include layout.use('density', $default: 'normal');\n  }\n\n  .#{$prefix}--tabs.#{$prefix}--tabs--tall,\n  .#{$prefix}--tabs.#{$prefix}--tabs--contained.#{$prefix}--tabs--tall {\n    @include layout.use('size', $min: 'lg', $max: 'xl', $default: 'xl');\n  }\n\n  .#{$prefix}--tabs {\n    @include reset;\n    @include type-style('body-compact-01');\n    @include layout.use('size', $min: 'sm', $max: 'lg', $default: 'md');\n\n    position: relative;\n    display: flex;\n    block-size: auto;\n    color: $text-primary;\n    inline-size: 100%;\n    max-block-size: custom-property.get-var('layout-size-height-xl');\n    min-block-size: layout.size('height');\n    overflow-x: hidden;\n\n    &.#{$prefix}--tabs--contained {\n      @include layout.use('size', $min: 'sm', $max: 'xl', $default: 'lg');\n    }\n\n    .#{$prefix}--tab--list {\n      display: flex;\n      inline-size: auto;\n      overflow-x: auto;\n      scroll-behavior: smooth;\n      scrollbar-width: none;\n      will-change: scroll-position;\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    }\n\n    &.#{$prefix}--tabs--vertical {\n      background: $layer;\n      box-shadow: inset -1px 0 $border-subtle;\n      grid-column: span 2;\n      max-block-size: none;\n\n      @include breakpoint(lg) {\n        grid-column: span 4;\n      }\n\n      .#{$prefix}--tab--list {\n        overflow: visible auto;\n        flex-direction: column;\n        inline-size: 100%;\n      }\n\n      .#{$prefix}--tab--list-gradient_bottom {\n        position: absolute;\n        background: linear-gradient(to bottom, transparent, $layer);\n        block-size: $spacing-10;\n        inset-block-end: 0;\n        inset-inline: 0;\n        pointer-events: none;\n      }\n\n      .#{$prefix}--tab--list-gradient_top {\n        position: absolute;\n        background: linear-gradient(to top, transparent, $layer);\n        block-size: $spacing-10;\n        inset-block-start: 0;\n        inset-inline: 0;\n        pointer-events: none;\n      }\n    }\n\n    .#{$prefix}--tabs__nav {\n      @include component-reset.reset;\n\n      display: flex;\n    }\n\n    //-----------------------------\n    // Overflow Nav Buttons\n    //-----------------------------\n    .#{$prefix}--tab--overflow-nav-button {\n      @include button-reset.reset;\n\n      display: flex;\n      flex-shrink: 0;\n      align-items: center;\n      justify-content: center;\n      background-color: $background;\n      inline-size: $spacing-08;\n\n      &:focus {\n        @include focus-outline('outline');\n      }\n\n      &:hover {\n        background-color: $background-hover;\n      }\n\n      &:active {\n        background-color: $background-active;\n      }\n    }\n\n    .#{$prefix}--tab--overflow-nav-button--hidden {\n      display: none;\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tab--overflow-nav-button {\n      margin: 0;\n      background-color: $layer-accent;\n      inline-size: $spacing-09;\n\n      &:hover {\n        background-color: $layer-accent-hover;\n      }\n\n      &:active {\n        background-color: $layer-accent-active;\n      }\n    }\n\n    .#{$prefix}--tab--overflow-nav-button svg {\n      z-index: 2;\n      fill: $icon-primary;\n\n      &:active,\n      &:hover {\n        fill: $icon-primary;\n      }\n    }\n\n    .#{$prefix}--tab--overflow-nav-button--next {\n      position: relative;\n      inset-block: 0;\n      inset-inline-end: 0;\n    }\n\n    .#{$prefix}--tab--overflow-nav-button--next::before {\n      position: absolute;\n      z-index: 1;\n      block-size: 100%;\n      content: '';\n      inline-size: $spacing-03;\n      inset-inline-start: -$spacing-03;\n    }\n\n    &:not(.#{$prefix}--tabs--contained) {\n      .#{$prefix}--tab--overflow-nav-button--next::before {\n        background: linear-gradient(\n          to right,\n          rgba(255, 255, 255, 0),\n          $background\n        );\n      }\n      .#{$prefix}--tab--overflow-nav-button--previous::before {\n        background: linear-gradient(\n          to left,\n          rgba(255, 255, 255, 0),\n          $background\n        );\n      }\n    }\n\n    .#{$prefix}--tab--overflow-nav-button--previous {\n      position: relative;\n      z-index: 1;\n      inset-block: 0;\n      inset-inline-start: 0;\n    }\n\n    .#{$prefix}--tab--overflow-nav-button--previous::before {\n      position: absolute;\n      z-index: 1;\n      block-size: 100%;\n      content: '';\n      inline-size: $spacing-03;\n      inset-inline-end: -$spacing-03;\n    }\n\n    .#{$prefix}--tabs--light .#{$prefix}--tabs__overflow-indicator--left {\n      background-image: linear-gradient(\n        to left,\n        rgba(255, 255, 255, 0),\n        $layer\n      );\n    }\n\n    .#{$prefix}--tabs--light .#{$prefix}--tabs__overflow-indicator--right {\n      background-image: linear-gradient(\n        to right,\n        rgba(255, 255, 255, 0),\n        $layer\n      );\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__overflow-indicator--left {\n      background-image: linear-gradient(\n        to left,\n        rgba(255, 255, 255, 0),\n        $layer-accent\n      );\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__overflow-indicator--right {\n      background-image: linear-gradient(\n        to right,\n        rgba(255, 255, 255, 0),\n        $layer-accent\n      );\n    }\n\n    // Safari-only media query\n    // won't appear correctly with CSS custom properties\n    // see: code snippet and modal overflow indicators\n    @supports (hanging-punctuation: first) and (font: -apple-system-body) and\n      (-webkit-appearance: none) {\n      .#{$prefix}--tabs__overflow-indicator--left {\n        background-image: linear-gradient(\n          to left,\n          rgba($background, 0),\n          $background\n        );\n      }\n\n      .#{$prefix}--tabs__overflow-indicator--right {\n        background-image: linear-gradient(\n          to right,\n          rgba($background, 0),\n          $background\n        );\n      }\n\n      &.#{$prefix}--tabs--contained\n        .#{$prefix}--tabs__overflow-indicator--left {\n        background-image: linear-gradient(\n          to left,\n          rgba($layer-accent, 0),\n          $layer-accent\n        );\n      }\n\n      &.#{$prefix}--tabs--contained\n        .#{$prefix}--tabs__overflow-indicator--right {\n        background-image: linear-gradient(\n          to right,\n          rgba($layer-accent, 0),\n          $layer-accent\n        );\n      }\n    }\n\n    //-----------------------------\n    // Wrapper\n    //-----------------------------\n    .#{$prefix}--tabs__nav-item-label-wrapper {\n      display: flex;\n    }\n\n    &:not(.#{$prefix}--tabs--contained)\n      .#{$prefix}--tabs__nav-item-label-wrapper {\n      position: relative;\n      inset-block-start: convert.to-rem(1px);\n    }\n\n    //-----------------------------\n    // Item\n    //-----------------------------\n    .#{$prefix}--tabs__nav-item {\n      @include reset;\n\n      position: relative;\n      display: flex;\n      flex: 1 0 auto;\n      padding: 0;\n      cursor: pointer;\n      transition: background-color $duration-fast-01\n        motion(standard, productive);\n    }\n\n    .#{$prefix}--tabs__nav-item + .#{$prefix}--tabs__nav-item {\n      margin-inline-start: convert.to-rem(1px);\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item {\n      background-color: $layer-accent;\n      // Draws the border without affecting the inner-content\n      box-shadow: convert.to-rem(-1px) 0 0 0 $border-strong;\n      margin-inline-start: 0;\n    }\n\n    &.#{$prefix}--tabs--vertical .#{$prefix}--tabs__nav-item {\n      flex: none;\n      background-color: $layer-01;\n      block-size: $spacing-10;\n      border-block-end: 1px solid $border-subtle;\n      border-inline-end: 1px solid $border-subtle;\n      box-shadow: inset 3px 0 0 0 $border-subtle;\n      inline-size: 100%;\n      margin-inline-start: 0;\n    }\n\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--vertical)\n      .#{$prefix}--tabs__nav-item--selected\n      + div\n      + .#{$prefix}--tabs__nav-item {\n      box-shadow: convert.to-rem(-1px) 0 0 0 transparent;\n    }\n\n    .#{$prefix}--tabs__nav-item .#{$prefix}--tabs__nav-link {\n      transition:\n        color $duration-fast-01 motion(standard, productive),\n        border-bottom-color $duration-fast-01 motion(standard, productive),\n        outline $duration-fast-01 motion(standard, productive);\n    }\n\n    &.#{$prefix}--tabs--dismissable .#{$prefix}--tabs__nav-link {\n      padding-inline-end: $spacing-08;\n    }\n\n    &.#{$prefix}--tabs--dismissable.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-link {\n      padding-inline-end: calc($spacing-09 - 1px);\n    }\n\n    //-----------------------------\n    // Icon\n    //-----------------------------\n\n    .#{$prefix}--tabs__nav-item--close {\n      position: relative;\n      display: flex;\n      align-items: center;\n      inset-inline-start: calc(-#{$spacing-04} - 1px);\n      margin-inline-start: calc(-#{$spacing-06} + 1px);\n    }\n\n    &:not(.#{$prefix}--tabs--contained)\n      .#{$prefix}--tabs__nav-item--close--hidden {\n      @include visually-hidden;\n\n      position: static;\n      inline-size: convert.to-rem(3px);\n    }\n\n    &.#{$prefix}--tabs--contained.#{$prefix}--tabs--full-width\n      .#{$prefix}--tabs__nav-item--close--hidden {\n      display: none;\n    }\n\n    .#{$prefix}--tabs__nav-item--close-icon {\n      @include button-reset.reset();\n\n      block-size: convert.to-rem(24px);\n      inline-size: convert.to-rem(24px);\n      padding-block: $spacing-02;\n      padding-inline: $spacing-02;\n      pointer-events: auto;\n\n      svg {\n        block-size: convert.to-rem(16px);\n        fill: $text-secondary;\n        inline-size: convert.to-rem(16px);\n      }\n\n      svg:hover {\n        fill: $icon-primary;\n      }\n\n      &:hover {\n        background-color: $layer-hover;\n      }\n\n      &:focus,\n      &:active {\n        @include focus-outline('outline');\n      }\n    }\n\n    .#{$prefix}--tabs__nav-item:hover\n      + .#{$prefix}--tabs__nav-item--close\n      .#{$prefix}--tabs__nav-item--close-icon\n      svg {\n      fill: $icon-primary;\n    }\n\n    .#{$prefix}--tabs__nav-item--close-icon--selected {\n      svg {\n        fill: $icon-primary;\n      }\n    }\n\n    .#{$prefix}--tabs__nav-item:hover\n      + .#{$prefix}--tabs__nav-item--close\n      .#{$prefix}--tabs__nav-item--close-icon--disabled,\n    .#{$prefix}--tabs__nav-item--close-icon--disabled,\n    .#{$prefix}--tabs__nav-item--close-icon--disabled:hover {\n      background-color: inherit;\n      cursor: not-allowed;\n\n      svg {\n        // Note: $icon-disabled maps to the same color as $tab-text-disabled, but in high contrast mode, $icon-disabled\n        // maps to the system-defined \"GrayText\" color, which is better for high contrast mode support.\n        fill: $icon-disabled;\n      }\n\n      &:focus,\n      &:active {\n        @include focus-outline('reset');\n      }\n    }\n\n    .#{$prefix}--tabs__nav-item--icon {\n      display: flex;\n      align-items: center;\n      padding-inline-start: $spacing-03;\n    }\n\n    .#{$prefix}--tabs__nav-item--icon-left {\n      display: flex;\n      align-items: center;\n      margin-block-start: -2px;\n      padding-inline-end: $spacing-03;\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item--icon {\n      padding-inline-start: layout.density('padding-inline');\n    }\n\n    //-----------------------------\n    // Link\n    //-----------------------------\n    .#{$prefix}--tabs__nav-link {\n      @include button-reset.reset($width: false);\n      @include focus-outline('reset');\n      @include type-style('body-compact-01');\n\n      overflow: hidden;\n      border-block-end: $tab-underline-color;\n      color: $text-secondary;\n      padding-inline: layout.density('padding-inline');\n      text-align: start;\n      text-decoration: none;\n      text-overflow: ellipsis;\n      transition:\n        border $duration-fast-01 motion(standard, productive),\n        outline $duration-fast-01 motion(standard, productive);\n      white-space: nowrap;\n\n      &:focus,\n      &:active {\n        @include focus-outline('outline');\n      }\n    }\n\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--vertical)\n      .#{$prefix}--tabs__nav-link {\n      border-block-end: 0;\n    }\n\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--tall)\n      .#{$prefix}--tabs__nav-item-label {\n      // height - vertical padding\n      line-height: calc(#{convert.to-rem(48px)} - (#{$spacing-03} * 2));\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item-secondary-label {\n      @include type-style('label-01');\n\n      min-block-size: convert.to-rem(16px);\n    }\n\n    &.#{$prefix}--tabs--vertical:not(.#{$prefix}--tabs--tall)\n      .#{$prefix}--tabs__nav-item-label {\n      line-height: var(--cds-body-compact-01-line-height);\n    }\n\n    //-----------------------------\n    // Icon Item\n    //-----------------------------\n    &.#{$prefix}--tabs__icon--default,\n    &.#{$prefix}--tabs__icon--lg,\n    &.#{$prefix}--tabs__icon--default .#{$prefix}--tab--list,\n    &.#{$prefix}--tabs__icon--lg .#{$prefix}--tab--list {\n      overflow-x: visible;\n    }\n\n    .#{$prefix}--tabs__nav-item--icon-only {\n      margin-inline-end: convert.to-rem(1px);\n    }\n\n    .#{$prefix}--tabs__nav-item--icon-only,\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item--icon-only {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      padding: 0;\n      block-size: layout.size('height');\n      inline-size: layout.size('height');\n\n      .#{$prefix}--tabs__nav-item-label {\n        line-height: 0;\n      }\n    }\n\n    .#{$prefix}--tabs__nav-item--icon-only:not(\n        .#{$prefix}--tabs__nav-item--icon-only__20\n      )\n      .#{$prefix}--badge-indicator {\n      margin-block-start: $spacing-02;\n      margin-inline-end: $spacing-02;\n    }\n\n    //-----------------------------\n    // Item Hover\n    //-----------------------------\n    &:not(.#{$prefix}--tabs--contained)\n      .#{$prefix}--tabs__nav-item:not(\n        .#{$prefix}--tabs__nav-item--selected\n      ):not(.#{$prefix}--tabs__nav-item--disabled):hover {\n      border-block-end: $tab-underline-color-hover;\n      color: $text-primary;\n    }\n\n    &.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item:not(\n        .#{$prefix}--tabs__nav-item--selected\n      ):not(.#{$prefix}--tabs__nav-item--disabled):not(\n        .#{$prefix}--tabs__nav-item--hover-off\n      ):hover {\n      background-color: $layer-accent-hover;\n      color: $text-primary;\n    }\n\n    &.#{$prefix}--tabs--vertical\n      .#{$prefix}--tabs__nav-item:not(\n        .#{$prefix}--tabs__nav-item--selected\n      ):not(.#{$prefix}--tabs__nav-item--disabled):not(\n        .#{$prefix}--tabs__nav-item--hover-off\n      ):hover {\n      background-color: $layer-hover;\n      box-shadow: inset 3px 0 0 0 $border-strong;\n    }\n\n    //-----------------------------\n    // Item Selected\n    //-----------------------------\n    .#{$prefix}--tabs__nav-item--selected {\n      border-block-end: 2px solid $border-interactive;\n      transition: color $duration-fast-01 motion(standard, productive);\n    }\n\n    &.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item--selected\n      + .#{$prefix}--tabs__nav-item {\n      box-shadow: none;\n    }\n\n    &.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--selected {\n      // Draws the border without affecting the inner-content\n      box-shadow: inset 0 2px 0 0 $border-interactive;\n    }\n\n    &.#{$prefix}--tabs--vertical\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--selected {\n      border-inline: none;\n      // Draws the border without affecting the inner-content\n      box-shadow: inset 3px 0 0 0 $border-interactive;\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item--selected,\n    .#{$prefix}--tabs__nav-item--selected,\n    .#{$prefix}--tabs__nav-item--selected:focus\n      .#{$prefix}--tabs__nav-link:focus,\n    .#{$prefix}--tabs__nav-item--selected:active\n      .#{$prefix}--tabs__nav-link:active {\n      @include type-style('heading-compact-01');\n\n      color: $text-primary;\n    }\n\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--tall)\n      .#{$prefix}--tabs__nav-item--selected,\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--tall)\n      .#{$prefix}--tabs__nav-item--selected:hover {\n      // height - vertical padding\n      line-height: calc(#{convert.to-rem(48px)} - (#{$spacing-03} * 2));\n    }\n\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item--selected,\n    &.#{$prefix}--tabs--contained .#{$prefix}--tabs__nav-item--selected:hover {\n      background-color: $layer;\n\n      .#{$prefix}--tabs__nav-link:focus,\n      .#{$prefix}--tabs__nav-link:active {\n        box-shadow: none;\n      }\n    }\n\n    &.#{$prefix}--tabs--light.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item--selected,\n    &.#{$prefix}--tabs--light.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item--selected:hover {\n      background-color: $background;\n    }\n\n    //-----------------------------\n    //  Item Disabled\n    //-----------------------------\n\n    .#{$prefix}--tabs__nav-item--disabled {\n      background-color: transparent;\n      border-block-end: 2px solid $border-subtle;\n      color: $tab-text-disabled;\n      outline: none;\n    }\n\n    .#{$prefix}--tabs__nav-item--disabled:hover {\n      border-block-end: 2px solid $border-subtle;\n      color: $tab-text-disabled;\n      cursor: not-allowed;\n    }\n\n    &.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--disabled,\n    &.#{$prefix}--tabs--contained\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--disabled:hover {\n      background-color: button.$button-disabled;\n    }\n\n    &.#{$prefix}--tabs--vertical\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--disabled,\n    &.#{$prefix}--tabs--vertical\n      .#{$prefix}--tabs__nav-item.#{$prefix}--tabs__nav-item--disabled:hover {\n      background-color: $layer;\n      border-block-end: 1px solid $border-subtle;\n    }\n\n    .#{$prefix}--tabs__nav-item--disabled:focus,\n    .#{$prefix}--tabs__nav-item--disabled:active {\n      border-block-end: 2px solid $border-subtle;\n      outline: none;\n      pointer-events: none;\n    }\n\n    .#{$prefix}--tabs--light\n      .#{$prefix}--tabs__nav-item--disabled\n      .#{$prefix}--tabs__nav-link {\n      border-block-end-color: $border-subtle;\n    }\n\n    .#{$prefix}--tabs--light\n      .#{$prefix}--tabs__nav-item--disabled:hover\n      .#{$prefix}--tabs__nav-link {\n      border-block-end-color: $border-subtle;\n    }\n\n    .#{$prefix}--tabs--light\n      .#{$prefix}--tabs__nav-item--disabled\n      .#{$prefix}--tabs__nav-link:focus,\n    .#{$prefix}--tabs--light\n      .#{$prefix}--tabs__nav-item--disabled\n      .#{$prefix}--tabs__nav-link:active {\n      border-block-end-color: $border-subtle;\n    }\n\n    &.#{$prefix}--tabs--contained:not(.#{$prefix}--tabs--vertical)\n      .#{$prefix}--tabs__nav-item--disabled {\n      border-block-end: none;\n      color: $text-on-color-disabled;\n    }\n  }\n  //-----------------------------\n  //  Tab Content Container\n  //-----------------------------\n  .#{$prefix}--tab-content {\n    padding: layout.density('padding-inline');\n\n    &:focus {\n      @include focus-outline('outline');\n    }\n  }\n\n  .#{$prefix}--tabs--contained ~ .#{$prefix}--tab-content {\n    background: $layer;\n  }\n\n  .#{$prefix}--tabs--vertical ~ .#{$prefix}--tab-content {\n    @include update_fields_on_layer;\n\n    grid-column: 3/-1;\n    overflow-y: auto;\n\n    @include breakpoint(lg) {\n      grid-column: 5/-1;\n    }\n  }\n\n  //-----------------------------\n  // Skeleton state\n  //-----------------------------\n  .#{$prefix}--tabs.#{$prefix}--skeleton {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  .#{$prefix}--skeleton.#{$prefix}--tabs:not(.#{$prefix}--tabs--contained)\n    .#{$prefix}--tabs__nav-link {\n    border-block-end: 2px solid $skeleton-element;\n  }\n\n  .#{$prefix}--tabs.#{$prefix}--skeleton .#{$prefix}--tabs__nav-link {\n    display: flex;\n    align-items: center;\n    padding: 0 layout.density('padding-inline');\n    block-size: 100%;\n    inline-size: 10rem;\n  }\n\n  .#{$prefix}--tabs.#{$prefix}--skeleton .#{$prefix}--tabs__nav-link span {\n    @include skeleton;\n\n    display: block;\n    block-size: convert.to-rem(14px);\n    inline-size: 100%;\n  }\n\n  // Windows HCM fix\n  .#{$prefix}--tabs__nav-item--selected .#{$prefix}--tabs__nav-link,\n  .#{$prefix}--tabs__nav-item--selected.#{$prefix}--tabs__nav-link,\n  .#{$prefix}--tabs.#{$prefix}--tabs--contained\n    .#{$prefix}--tabs__nav-item--selected,\n  .#{$prefix}--tabs.#{$prefix}--tabs--contained\n    .#{$prefix}--tabs__nav-item--selected.#{$prefix}--tabs__nav-link {\n    @include high-contrast-mode {\n      background-color: SelectedItem;\n    }\n  }\n\n  .#{$prefix}--tabs\n    .#{$prefix}--tabs__nav-item--disabled\n    .#{$prefix}--tabs__nav-link {\n    @include high-contrast-mode('disabled');\n  }\n}\n\n//-----------------------------\n// Grid contained tabs\n//-----------------------------\n\n.#{$prefix}--tabs.#{$prefix}--tabs--contained.#{$prefix}--tabs--full-width\n  .#{$prefix}--tab--list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));\n  inline-size: 100%;\n\n  .#{$prefix}--tabs__nav-link {\n    .#{$prefix}--tabs__nav-item-label,\n    .#{$prefix}--tabs__nav-item-secondary-label {\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n    .#{$prefix}--tabs__nav-item--icon {\n      margin-inline-start: auto;\n    }\n  }\n}\n\n.#{$prefix}--tabs.#{$prefix}--tabs--vertical {\n  .#{$prefix}--tabs__nav-link {\n    .#{$prefix}--tabs__nav-item-label {\n      display: -webkit-box;\n      overflow: hidden;\n      -webkit-box-orient: vertical;\n      -webkit-line-clamp: 2;\n      text-overflow: ellipsis;\n      white-space: normal;\n    }\n  }\n}\n","//\n// Copyright IBM Corp. 2021\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n// Tabs\n\n@use '../../theme' as *;\n\n/// @type Value\n/// @access public\n/// @group tabs\n$tab-underline-color: 2px solid $border-subtle !default;\n\n/// @type Value\n/// @access public\n/// @group tabs\n$tab-underline-color-hover: 2px solid $border-strong !default;\n\n/// @type Color\n/// @access public\n/// @group tabs\n$tab-text-disabled: $text-disabled !default;\n\n/// @type Value\n/// @access public\n/// @group tabs\n$tab-underline-disabled: 2px solid $border-disabled !default;\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'mixins' as *;\n@use '../../config' as *;\n@use '../../feature-flags' as *;\n@use '../../layer' as *;\n@use '../../motion';\n@use '../../theme' as *;\n@use '../../type' as *;\n@use '../../spacing' as *;\n@use '../../utilities/focus-outline' as *;\n@use '../../utilities/skeleton' as *;\n@use '../../utilities/convert';\n@use '../../utilities/component-reset';\n\n@mixin structured-list($enable-v12-structured-list-visible-icons: false) {\n  .#{$prefix}--structured-list--selection .#{$prefix}--structured-list-td,\n  .#{$prefix}--structured-list--selection .#{$prefix}--structured-list-th {\n    @include padding--data-structured-list;\n  }\n  .#{$prefix}--structured-list-row--focused-within {\n    @include focus-outline('outline');\n  }\n\n  .#{$prefix}--structured-list {\n    @include component-reset.reset;\n\n    display: table;\n\n    background-color: $layer transparent;\n    border-collapse: collapse;\n    border-spacing: 0;\n    inline-size: 100%;\n    overflow-x: auto;\n\n    // Condensed list\n    &.#{$prefix}--structured-list--condensed .#{$prefix}--structured-list-td,\n    &.#{$prefix}--structured-list--condensed .#{$prefix}--structured-list-th {\n      @include padding-td--condensed;\n      //8px padding all over\n    }\n\n    .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-td:first-of-type,\n    .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-th:first-of-type {\n      padding-inline-start: 1rem;\n      // specs require 16px spacing between columns\n      // 8px side padding between col creates 16 px, with exception of 1st col, which needs an override to be 16px\n    }\n\n    // Flush list\n    &.#{$prefix}--structured-list--flush\n      .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-td,\n    &.#{$prefix}--structured-list--flush\n      .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-th,\n    &.#{$prefix}--structured-list--flush\n      .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-td:first-of-type,\n    &.#{$prefix}--structured-list--flush\n      .#{$prefix}--structured-list-row\n      .#{$prefix}--structured-list-th:first-of-type {\n      padding-inline: 0 1rem;\n    }\n  }\n\n  .#{$prefix}--structured-list-row {\n    display: table-row;\n    border-block-start: 1px solid $border-subtle;\n    transition: background-color motion.$duration-fast-02\n      motion.motion(standard, productive);\n  }\n\n  .#{$prefix}--structured-list-tbody\n    .#{$prefix}--structured-list-row:last-child {\n    border-block-end: 1px solid $border-subtle;\n  }\n\n  .#{$prefix}--structured-list-row--header-row {\n    border: none;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row:hover:not(\n      .#{$prefix}--structured-list-row--header-row\n    ):not(.#{$prefix}--structured-list-row--selected) {\n    border-color: $layer-hover;\n    background-color: $layer-hover;\n    cursor: pointer;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row:hover:not(\n      .#{$prefix}--structured-list-row--header-row\n    ):not(.#{$prefix}--structured-list-row--selected)\n    + .#{$prefix}--structured-list-row {\n    border-color: $layer-hover;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row.#{$prefix}--structured-list-row--selected {\n    border-color: $layer-selected;\n    background-color: $layer-selected;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row--selected\n    + .#{$prefix}--structured-list-row {\n    border-color: $layer-selected;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row.#{$prefix}--structured-list-row--selected\n    .#{$prefix}--structured-list-td {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--structured-list-row.#{$prefix}--structured-list-row--header-row {\n    cursor: inherit;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row:hover:not(\n      .#{$prefix}--structured-list-row--header-row\n    )\n    > .#{$prefix}--structured-list-td,\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-row.#{$prefix}--structured-list-row--selected\n    > .#{$prefix}--structured-list-td {\n    color: $text-primary;\n  }\n\n  .#{$prefix}--structured-list-thead {\n    display: table-header-group;\n    vertical-align: middle;\n  }\n\n  .#{$prefix}--structured-list-th {\n    @include component-reset.reset;\n    @include padding-th;\n    @include type-style('heading-compact-01');\n\n    display: table-cell;\n    block-size: convert.to-rem(40px);\n    color: $text-primary;\n    font-weight: 600;\n    text-align: start;\n    text-transform: $structured-list-text-transform;\n    vertical-align: top;\n  }\n\n  .#{$prefix}--structured-list-tbody {\n    display: table-row-group;\n    vertical-align: middle;\n  }\n\n  .#{$prefix}--structured-list-td {\n    @include component-reset.reset;\n    @include type-style('body-01');\n    @include padding-td;\n\n    position: relative;\n    display: table-cell;\n    color: $text-secondary;\n    max-inline-size: 36rem;\n\n    transition: color motion.$duration-fast-02\n      motion.motion(standard, productive);\n  }\n\n  .#{$prefix}--structured-list-content--nowrap {\n    white-space: nowrap;\n  }\n\n  .#{$prefix}--structured-list-input + .#{$prefix}--structured-list-td {\n    text-align: end;\n  }\n\n  .#{$prefix}--structured-list-svg {\n    display: inline-block;\n    margin-block-start: $spacing-01;\n    transition: all motion.$duration-fast-02 motion.motion(standard, productive);\n    vertical-align: top;\n  }\n\n  .#{$prefix}--structured-list-input:checked\n    + .#{$prefix}--structured-list-row\n    .#{$prefix}--structured-list-svg,\n  .#{$prefix}--structured-list-input:checked\n    + .#{$prefix}--structured-list-td\n    .#{$prefix}--structured-list-svg {\n    fill: $icon-primary;\n  }\n\n  @if not(\n    enabled('enable-v12-structured-list-visible-icons') and\n      $enable-v12-structured-list-visible-icons\n  )\n  {\n    .#{$prefix}--structured-list-svg {\n      fill: transparent;\n    }\n    .#{$prefix}--structured-list--selection\n      .#{$prefix}--structured-list-td:last-child {\n      inline-size: $spacing-07;\n      padding-inline-start: 0;\n    }\n  }\n  @if (\n    enabled('enable-v12-structured-list-visible-icons') or\n      $enable-v12-structured-list-visible-icons\n  ) {\n    .#{$prefix}--structured-list-input:checked\n      ~ .#{$prefix}--structured-list-td\n      .#{$prefix}--structured-list-svg {\n      fill: $icon-primary;\n    }\n  }\n\n  // Skeleton State\n  .#{$prefix}--structured-list.#{$prefix}--skeleton {\n    .#{$prefix}--structured-list-th {\n      &:first-child {\n        inline-size: 8%;\n      }\n\n      &:nth-child(3n + 2) {\n        inline-size: 30%;\n      }\n\n      &:nth-child(3n + 3) {\n        inline-size: 15%;\n      }\n    }\n\n    span {\n      @include skeleton;\n\n      display: block;\n      block-size: 1rem;\n\n      inline-size: 75%;\n    }\n  }\n\n  .#{$prefix}--structured-list.#{$prefix}--structured-list--selection.#{$prefix}--skeleton\n    .#{$prefix}--structured-list-th:first-child {\n    inline-size: 5%;\n\n    span {\n      display: none;\n    }\n  }\n\n  .#{$prefix}--structured-list__icon {\n    margin-block-start: $spacing-01;\n    vertical-align: top;\n  }\n\n  .#{$prefix}--structured-list--selection\n    .#{$prefix}--structured-list-td:first-child:has(\n      .#{$prefix}--structured-list__icon\n    ) {\n    inline-size: $spacing-07;\n    padding-inline-end: 0;\n  }\n}\n","//\n// Copyright IBM Corp. 2016, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use '../../spacing' as *;\n\n// Structured List\n\n/// @type Number\n/// @access public\n/// @group structured-list\n$structured-list-padding: 2rem !default;\n\n/// @type Value\n/// @access public\n/// @group structured-list\n$structured-list-text-transform: none !default;\n\n/// Used only for `.#{prefix}--structured-list--condensed`\n/// @access private\n/// @group structured-list\n/// @param {Number} $padding [$structured-list-padding]\n@mixin padding-td--condensed($padding: $structured-list-padding) {\n  padding: $padding * 0.25;\n}\n\n/// Used only for [data-structured-list]\n/// @access private\n/// @group structured-list\n/// @param {Number} $padding [$structured-list-padding]\n@mixin padding--data-structured-list($padding: $structured-list-padding) {\n  padding-inline: $padding * 0.5 $padding * 0.5;\n\n  // Controls gutter sizes for check\n  &:first-child {\n    padding-inline: $padding * 0.5 $padding * 0.5;\n  }\n}\n\n/// Used only for normal structured-list\n/// @access private\n/// @group structured-list\n/// @param {Number} $padding [$structured-list-padding]\n@mixin padding-th($padding: $structured-list-padding) {\n  padding: $spacing-05 $spacing-03 $spacing-03 $spacing-03;\n}\n\n/// Used only for normal structured-list\n/// @access private\n/// @group structured-list\n/// @param {Number} $padding [$structured-list-padding]\n@mixin padding-td($padding: $structured-list-padding) {\n  padding: $spacing-05 $spacing-03 $spacing-06 $spacing-03;\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@use 'sass:map';\n@use 'sass:meta';\n@use 'config';\n@use 'themes';\n\n/// Specify the fallback theme, used as a catch-all for tokens that you may not\n/// have defined in your custom theme\n$fallback: themes.$white !default;\n\n/// Specify the current theme. This can override existing tokens, or add new\n/// tokens. If you are adding new tokens, it's recommended that you set the\n/// fallback for your current theme\n$theme: () !default;\n$theme: map.merge($fallback, $theme);\n\n/// Local component tokens that can be updated with `@mixin add-component-tokens`.\n$-component-tokens: ();\n\n/// Include the CSS Custom Properties for the active theme or a given theme on\n/// a selector\n@mixin theme($active-theme: $theme, $component-tokens...) {\n  @each $token, $value in $active-theme {\n    @include -custom-property($token, $value);\n  }\n\n  @each $group in $component-tokens {\n    @each $token, $value in $group {\n      @include -custom-property($token, $value);\n    }\n  }\n\n  @each $token, $value in $-component-tokens {\n    @include -custom-property(\n      $token,\n      -resolve-token-value($active-theme, $value)\n    );\n  }\n}\n\n/// Retrieve the value for the given $token from the current $theme\n/// @param {String} $token\n@function get($token) {\n  @if map.has-key($theme, $token) {\n    @return map.get($theme, $token);\n  }\n  @error \"Unable to find token: #{$token} in current $theme\";\n}\n\n/// Compare two themes to see if the second theme is a superset of the first\n/// theme. In other words, this function will return true if every token in the\n/// first theme is available in the second theme and has the same value. The\n/// second theme is allowed to have additional values and it will still match.\n/// @param {Map} $a\n/// @param {Map} $b\n/// @returns {Boolean}\n@function matches($a, $b) {\n  @each $key, $value in $a {\n    @if map.has-key($b, $key) == false {\n      @return false;\n    }\n\n    @if map.get($b, $key) != $value {\n      @return false;\n    }\n  }\n\n  @return true;\n}\n\n/// Add component tokens which will be included any time the theme mixin is\n/// called\n@mixin add-component-tokens($token-map) {\n  $-component-tokens: map.merge($-component-tokens, $token-map) !global;\n}\n\n/// Determine the value from a component token that matches the given theme.\n/// This is helpful when a component token may change depending on what theme the\n/// component is being rendered in.\n@function -resolve-token-value($active-theme: $theme, $token-value) {\n  @if meta.type-of($token-value) == map and map.has-key($token-value, values) {\n    $fallback: map.get($token-value, fallback);\n    $theme-values: map.get($token-value, values);\n\n    @each $theme-value in $theme-values {\n      $theme-to-match: map.get($theme-value, theme);\n      $value: map.get($theme-value, value);\n\n      @if matches($theme-to-match, $active-theme) {\n        @return $value;\n      }\n    }\n\n    @return $fallback;\n  }\n\n  @return $token-value;\n}\n\n/// @access private\n/// @group @carbon/themes\n@mixin -custom-property($name, $value) {\n  @if meta.type-of($value) == map {\n    @each $property, $property-value in $value {\n      // Only support one-level of depth for values that are maps. This is to\n      // avoid bringing properties like `breakpoints` on type tokens\n      @if meta.type-of($property-value) != map {\n        @include -custom-property('#{$name}-#{$property}', $property-value);\n      }\n    }\n  } @else {\n    --#{config.$prefix}-#{$name}: #{$value};\n  }\n}\n","//\n// Copyright IBM Corp. 2018, 2023\n//\n// This source code is licensed under the Apache-2.0 license found in the\n// LICENSE file in the root directory of this source tree.\n//\n\n@forward './theme/theme' hide theme;\n@use './theme/theme';\n@use './layer/layer-tokens';\n@use './utilities/custom-property';\n\n/// Include the CSS Custom Properties for the active theme or a given theme on\n/// a selector\n@mixin theme($args...) {\n  @include theme.theme($args...);\n\n  color-scheme: custom-property.get-var('color-scheme', light);\n\n  // If the system is in high-contrast mode, use the system defined colors.  This mostly happens automatically, but\n  // we need to do it manually for icons and selected backgrounds.  Importantly, the custom properties we set here\n  // need to override the CSS custom properties set above.  See:\n  // - https://github.com/carbon-design-system/carbon/issues/19015\n  // - https://developer.mozilla.org/en-US/docs/Web/CSS/system-color.\n  // - https://carbondesignsystem.com/elements/color/tokens/#icon\n  @media screen and (-ms-high-contrast: active), (forced-colors: active) {\n    // Icon colors specified by \"fill\".\n    @include custom-property.declaration('icon-primary', ButtonText);\n    @include custom-property.declaration('icon-secondary', ButtonText);\n    @include custom-property.declaration('icon-interactive', ButtonText);\n    @include custom-property.declaration('icon-disabled', GrayText);\n    @include custom-property.declaration('icon-on-color-disabled', GrayText);\n\n    // Since icon-inverse and icon-on-color are generally used to indicated selected icons, use SelectedItemText.\n    @include custom-property.declaration('icon-inverse', SelectedItemText);\n    @include custom-property.declaration('icon-on-color', SelectedItemText);\n\n    // Some components currently set these values for fill, although unclear if that's valid.\n    @include custom-property.declaration('button-disabled', GrayText);\n    @include custom-property.declaration('interactive', ButtonText);\n    @include custom-property.declaration('link-primary', LinkText);\n    @include custom-property.declaration('link-primary-hover', LinkText);\n    @include custom-property.declaration('link-secondary', LinkText);\n    @include custom-property.declaration('link-inverse', SelectedItemText);\n    @include custom-property.declaration(\n      'link-inverse-hover',\n      SelectedItemText\n    );\n    @include custom-property.declaration(\n      'link-inverse-visited',\n      SelectedItemText\n    );\n    @include custom-property.declaration('link-visited', VisitedText);\n\n    // Force a background-color for selected buttons etc., otherwise the user won't know they are selected.\n    @include custom-property.declaration('background-selected', SelectedItem);\n    @include custom-property.declaration(\n      'background-selected-hover',\n      SelectedItem\n    );\n    @include custom-property.declaration('background-inverse', SelectedItem);\n    @include custom-property.declaration(\n      'layer-selected-inverse',\n      SelectedItem\n    );\n  }\n\n  // Note: we need to re-emit the contextual layer tokens as part of the theme\n  // mixin. Otherwise, the layer tokens are defined at the :root level and will\n  // not pick up the theme-specific, or zone-specific, value from the first\n  // layer.\n  //\n  // For example, in this situation:\n  //\n  // ```\n  // :root {\n  //   --layer-one: #000000;\n  //   --layer: var(--layer-one);\n  // }\n  // ```\n  //\n  // This will always evaluate to the value of `--layer-one` at the `:root`\n  // selector, even if `--layer-one` is redefined layer on in the cascade.\n  //\n  // ```\n  // .zone {\n  //   --layer-one: #ffffff;\n  // }\n  // ```\n  //\n  // Even though you would expect `--layer` to be redefined, it will keep the\n  // value defined at the `:root` level.\n  //\n  // @see https://github.com/carbon-design-system/carbon/issues/11138\n  @include layer-tokens.emit-layer-tokens(1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
